/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://d3as7bv2o8grkq.cloudfront.net/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 475);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(39);
var hide = __webpack_require__(41);
var redefine = __webpack_require__(40);
var ctx = __webpack_require__(53);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(103);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__callbacks__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuity__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__refs_refs__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__indexes_indexes__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_load_contract__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutex_mutex__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ops_ops__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__log_log__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_phone__ = __webpack_require__(1104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/lp_app.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*//** @type {LpApp} */var lpApp=void 0;/**
 * This class is the main application of LegalPlace
 */var LpApp=function(){function LpApp(){_classCallCheck(this,LpApp);this.init();}/**
     * The global initialization
     */_createClass(LpApp,[{key:'init',value:function init(){var _this=this;window.onresize=function(){_this.initializeEnvironment();};this.initializeLogs();this.initializeOperations();this.initializeMutex();this.initializeEnvironment();this.intializeCallbacks();this.initializeActionTracking();this.initializeReferences();this.initializeIndexes();this.initializeHrefParams();}/**
     * This is for some general contract information
     */},{key:'setContractUniqid',value:function setContractUniqid(cUniqid){this.contractUniqid=cUniqid;window.contract_id=cUniqid;}},{key:'setNewCustomer',value:function setNewCustomer(newCustomer){this.newCustomer=newCustomer;window.newCustomer=newCustomer;}},{key:'setContractTitle',value:function setContractTitle(cTitle){this.contractTitle=cTitle;window.contractName=cTitle;}},{key:'setContractMetaId',value:function setContractMetaId(id){var _this2=this;return new Promise(function(resolve){_this2.contractMetaId=parseInt(id,10);window.contract_meta_id=id;resolve(id);});}},{key:'setType',value:function setType(type,contractMetaId){this.type=type;this.contractMetaId=contractMetaId;window.type=type;var noPhoneContractList=[302,181,680];// Display Phone on Header when only its a demarche type
if(type==='demarche'&&noPhoneContractList.indexOf(contractMetaId)===-1&&!document.getElementById('phone-number')){Object(__WEBPACK_IMPORTED_MODULE_10__constants_phone__["b" /* displayHeaderPhone */])();Object(__WEBPACK_IMPORTED_MODULE_10__constants_phone__["a" /* displayHeaderMobilePhone */])();}}},{key:'setSupportPhone',value:function setSupportPhone(str){this.supportPhone=str;window.support_phone=str;}},{key:'setIsPrerender',value:function setIsPrerender(isPrerender){this.isPrerender=!!isPrerender;}},{key:'setPrerenderDoc',value:function setPrerenderDoc(prerenderDoc){this.prerenderDoc=parseInt(prerenderDoc,10);}},{key:'setDisableIntro',value:function setDisableIntro(disable_intro){this.disable_intro=disable_intro;}},{key:'setSubscription',value:function setSubscription(){var subscribe=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;// For now on Crea all subscription are on false
// There is a value force_subscription on the docs API to use if necessary
this.subscription=subscribe;window.contract_subscription=subscribe;}},{key:'setIsPaidSession',value:function setIsPaidSession(isPaidSession){this.paidSession=isPaidSession;}},{key:'setFullWidth',value:function setFullWidth(fullWidth){this.fullWidth=fullWidth;}},{key:'setPayed',value:function setPayed(isPayed){this.isPayed=isPayed;}/**
     * This part is for reading the params from the href
     */},{key:'initializeHrefParams',value:function initializeHrefParams(){this.continuity=new __WEBPACK_IMPORTED_MODULE_1__continuity__["a" /* default */]();}/**
     * Initialize the environment informations (for bypassing the cross-browsing problem)
     * like : width and height, orientation, agent ,....
     */},{key:'initializeEnvironment',value:function initializeEnvironment(){this.env=new __WEBPACK_IMPORTED_MODULE_2__env__["a" /* default */]();window.lfoug=!!window.MSInputMethodContext&&!!document.documentMode?70:30;}/**
    * Refernces manipulation,
    * A reference is the data we take from the json we read,
    */},{key:'initializeReferences',value:function initializeReferences(){this.references=new __WEBPACK_IMPORTED_MODULE_3__refs_refs__["a" /* default */]();}/**
     * Index manipulations
     * Using the data like it's got from the json may cause performence fallout,
     * So I oriented the strategy to be building indexes in order to use it in an
     * associative way.
     */},{key:'initializeIndexes',value:function initializeIndexes(){this.indexes=new __WEBPACK_IMPORTED_MODULE_4__indexes_indexes__["a" /* default */]();}/**
     * Actions tracking,
     * The flux is a great pattern, but using it with a huge data structures can cause
     * performance fallout, so we track our actions in order to minimize the update of
     * real DOM.
     */},{key:'initializeActionTracking',value:function initializeActionTracking(){this.action_tracker=new __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */]();}/**
   * Initialize the store
   * Whe I used the redux's store in the first time, I couldn't have access all the time
   * to my context, so I had to iexport it as global variable, but it made me make sure
   * every time I use it.
   * So The best thing to do,
   * is to link the redux thing in the App directly, to centralize everything.
   */},{key:'initializeStore',value:function initializeStore(store){this.store=store;this.dispatch=function(){return console.log('no dispatcher found');};this.getState=function(){return'no state ;)';};this.redux_subscribe=function(){return'No store';};if(store){this.dispatch=store.dispatch;this.getState=store.getState;this.redux_subscribe=store.subscribe;}}/**
   * DOM callbacks
   * The user experience imposes some rules to follow,
   * but the manipulation of such things in a random way
   * makes things more complex that it happen to be,
   * so here I centralized the thing so we can change the callbacks whenever
   * we want, and still having the initial callback saved.
   */},{key:'intializeCallbacks',value:function intializeCallbacks(){this.callbacks=new __WEBPACK_IMPORTED_MODULE_0__callbacks__["a" /* default */]();}/**
     * the mutex thing.
     */},{key:'initializeMutex',value:function initializeMutex(){this.mutex=new __WEBPACK_IMPORTED_MODULE_7__mutex_mutex__["a" /* default */]();this.mutex.setMutex('history',true);this.mutex.setMutex('preview',true);this.mutex.setMutex('links',true);}},{key:'initializeOperations',value:function initializeOperations(){this.ops=new __WEBPACK_IMPORTED_MODULE_8__ops_ops__["a" /* default */]();}},{key:'initializeLogs',value:function initializeLogs(){this.logs=new __WEBPACK_IMPORTED_MODULE_9__log_log__["a" /* default */]();}/**
     * The entry point (c'est simple non?)
     */},{key:'main',value:function main(contractName){var uniqId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';this.setContractUniqid(uniqId);if(this.store){this.intializeCallbacks();this.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_load_contract__["c" /* getAndInitContract */])(contractName,uniqId));}this.setContractTitle(contractName);this.setSubscription();}},{key:'mainCheckout',value:function mainCheckout(contractName,uniqid){this.setContractUniqid(uniqid);if(this.store){this.intializeCallbacks();this.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_load_contract__["b" /* getAndInitCheckout */])(contractName,uniqid));}this.setContractTitle(contractName);this.setSubscription();}},{key:'mainPrerender',value:function mainPrerender(uniqid){var doc=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'main';this.setIsPrerender(true);this.setPrerenderDoc(doc);if(this.store){this.intializeCallbacks();this.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_load_contract__["d" /* getAndInitPrerender */])(uniqid));}}/**
     * This is the singleton function, any auther instance of LpApp is not authorized.
     */}],[{key:'getInstance',value:function getInstance(){if(typeof lpApp==='undefined'){lpApp=new LpApp();}return lpApp;}}]);return LpApp;}();lpApp=LpApp.getInstance();/* harmony default export */ __webpack_exports__["a"] = (lpApp);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(806);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(27)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDocumentEdited;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middlewares_middlewares__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_reducers_root__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_lp_app__ = __webpack_require__(2);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*
* Project: LegalPlace assistant
* File: src/globals.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// add listener to reindex the things.
// initialization of the basic context, with reducers and middleware
/**
 * @description creation of the store,
 */var store=void 0;var environment="production";if(environment=='development')store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined,_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__middlewares_middlewares__["a" /* default */])))(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__redux_reducers_root__["a" /* default */],window.__REDUX_DEVTOOLS_EXTENSION__&&window.__REDUX_DEVTOOLS_EXTENSION__());else{store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined,_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__middlewares_middlewares__["a" /* default */])))(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__redux_reducers_root__["a" /* default */]);}/**
 * @description create the callback of the indexes
 * Options, variables, multiples, parents, variables parents, conditions
 */function reorderThings(){// let state = store.getState();
var la=__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].action_tracker.last_action;if(la==='EDIT_VARIABLE_VALUE_'||la==='CREATE_FLAT_UI_')return;Object(__WEBPACK_IMPORTED_MODULE_3__logic_re_index__["c" /* initializeIndexes */])();Object(__WEBPACK_IMPORTED_MODULE_3__logic_re_index__["n" /* updateConditions */])();__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.updateConditions();Object(__WEBPACK_IMPORTED_MODULE_3__logic_re_index__["o" /* updateWindow */])();}store.subscribe(reorderThings);function isDocumentEdited(){return store.getState().account_settings.edited_doc;}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(61);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseLink__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_hardcoded_checkout__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_lp_app__ = __webpack_require__(2);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};window.dataLayer=window.dataLayer||[];window.exectuteOnceCheckoutActe=1;/**
 * @description compilation time event
 */function EventTracking(){this.queue=[];this.queueTimer=null;this.data_uri=__WEBPACK_IMPORTED_MODULE_0__baseLink__["a" /* default */]+'/data';this.packName=undefined;// Save packName here as we need it after payment confirmation
this.register({'React Build':typeof window.build_date==='string'?window.build_date:'Unkown','Powered By':'ReactJs'});//  this.triggerHj('react_wizard');
this.url=null;}/*
 * Queue execute
 */EventTracking.prototype.executeQueue=function executeQueue(){for(var i=0;i<this.queue.length;i+=1){var c=this.queue[i];var args=[];if(c.length>1){for(var x=0;x<c[1].length;x+=1){args.push(c[1][x]);}args.push(true);var r=this[c[0]].apply(this,args);if(r===true){this.queue.splice(i,1);}}}};EventTracking.prototype.queueTimeout=function queueTimeout(){if(this.queueTimer!==null)clearTimeout(this.queueTimer);var that=this;this.queueTimer=setTimeout(function(){that.executeQueue();},500);};/*
 * Event tracking
 */EventTracking.prototype.track=function track(eventName,eventProps){// // Mixpanel
// this.trackMix(eventName, eventProps);
// // Facebook Pixel
// this.trackFB(eventName, eventProps);
// // Google Analytics
// this.trackGA(eventName, eventProps);
// SendinBlue
this.trackSIB(eventName,eventProps);// console.log('Tracking '+eventName);
// console.log(eventProps);
};/**
 * Here the word checkout only means that we have started a paid funnel
 * Doesn't not mean we are on the chckout step
 */EventTracking.prototype.trackGTMCheckoutStep=function trackGTMCheckoutStep(checkoutStepNumber,checkoutStepName,contract){var checkoutOperation=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var metaId=arguments[4];var packNames=arguments.length>5&&arguments[5]!==undefined?arguments[5]:[];var price=void 0;this.packName=packNames.length>0?packNames[checkoutOperation.pack]:undefined;price=checkoutOperation&&checkoutOperation.prices?checkoutOperation.prices[Object.keys(checkoutOperation.prices)[checkoutOperation.pack]]:undefined;var type=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].type&&(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].type==='demarche'?'Démarche':'Contrat');var productPrice=checkoutOperation&&price?price:undefined;if(!productPrice&&checkoutOperation&&checkoutOperation.prices&&checkoutOperation.prices.first_price){productPrice=checkoutOperation.prices.first_price;}var products=[{productId:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractMetaId||undefined,productName:contract?contract.name:undefined,productCategory:type,productBrand:'Legalplace',productVariant:checkoutOperation?this.packName:undefined,productPrice:productPrice,productQuantity:1,productFormVersion:contract?''+contract.version:undefined}];if(__WEBPACK_IMPORTED_MODULE_2__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(metaId)>-1&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().account_settings.is_crea_assiste_sub){products.push({productId:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractMetaId||undefined,productName:'Assistance LegalPlace',productBrand:'LegalPlace',productCategory:type,productVariant:undefined,productPrice:'0.00',productQuantity:1,productFormVersion:contract?''+contract.version:undefined});}dataLayer.push(Object(__WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__["gtmCheckoutEvent"])({currencyCode:'EUR',checkoutStepNumber:checkoutStepNumber,checkoutStepName:checkoutStepName,products:products}));};EventTracking.prototype.trackErrorPaymentCheckout=function trackErrorPaymentCheckout(errorMessage){// eslint-disable-next-line no-undef
dataLayer.push(Object(__WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__["getContractGAEvent"])({eventCategory:'Payment error',eventAction:'Clic sur Payer',eventLabel:errorMessage}));};EventTracking.prototype.trackGTMFunnel=function trackGTMFunnel(pathname){var paid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;//console.log(pathname, lpApp.getState().contract.name, lpApp.getState().contract.section.label)
if(this.url!==pathname){this.url=pathname;var step=pathname.split('/').length>1?pathname.split('/')[pathname.split('/').length-1]:undefined;var totalSections=Object.keys(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.sections).length+1;var metaId=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractMetaId;var constStep=step;var pageAction=void 0;var sectionTitle=void 0;if(step==='checkout'&&!paid){pageAction=__WEBPACK_IMPORTED_MODULE_2__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(metaId)>-1?'Confirmation avant paiement 2 | 2':'Confirmation avant paiement 1 | 1';sectionTitle='Recapitulatif de votre commande';}else if(step==='paiement'){pageAction='Confirmation avant paiement 1 | 2';sectionTitle='Choississez votre pack';}else if(step==='checkout'&&paid){pageAction='Paiement confirmation';sectionTitle='Paiement confirmation';}else if(parseInt(step,10)===totalSections){pageAction='Questionnaire : '+step+' | '+totalSections;sectionTitle="Votre adresse email";}else{step=step&&step.length<10?step:1;pageAction='Questionnaire : '+step+' | '+totalSections;sectionTitle=step&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.sections[step-1]?__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.sections[step-1].label:undefined;}// don't do this event for expert-comptable
if(constStep!=='expert-comptable'){dataLayer.push(Object(__WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__["getContractFunnelGAEvent"])({contractName:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.name,sectionTitle:sectionTitle,pageAction:pageAction}));}}};EventTracking.prototype.trackPopUpCheckout=function trackPopUpCheckout(){dataLayer.push(Object(__WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__["getContractFunnelGAEvent"])({contractName:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.name,sectionTitle:"Pop-in paiement",pageAction:"Pop-in paiement"}));};EventTracking.prototype.trackClickPayment=function trackClickPayment(){dataLayer.push(Object(__WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__["getContractFunnelGAEvent"])({contractName:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.name,sectionTitle:"Clic sur Payer",pageAction:"Clic sur Payer"}));};EventTracking.prototype.trackGTMGAEvent=function trackGTMGAEvent(eventCategory,eventAction,eventLabel){dataLayer.push(Object(__WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__["getContractGAEvent"])({eventCategory:eventCategory,eventAction:eventAction,eventLabel:eventLabel}));};EventTracking.prototype.trackGTMOrder=function trackGTMOrder(orderId,orderShipping,orderTax,orderPaymentMethod,packPriceWithReduction){var acteProduct=arguments.length>5&&arguments[5]!==undefined?arguments[5]:true;var checkoutOperation=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().checkout_operations;var price=checkoutOperation&&checkoutOperation.prices?checkoutOperation.prices[Object.keys(checkoutOperation.prices)[checkoutOperation.pack]]:undefined;var contract=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract;var type=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].type&&(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].type==='demarche'?'Démarche':'Contrat');var paymentMethod=void 0;switch(orderPaymentMethod){case'paypal':paymentMethod='Paypal';break;case'alma':paymentMethod='Carte bancaire en 3 fois';break;default:paymentMethod='Carte bancaire';break;}var priceActeHT=acteProduct&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].ops.checkout.getHTPrice()&&parseFloat(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].ops.checkout.getHTPrice()).toFixed(2);var priceActeTVA=acteProduct&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].ops.checkout.getHTPrice()&&(parseFloat(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice())-parseFloat(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].ops.checkout.getHTPrice())).toFixed(2);var products=[{productId:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractMetaId||undefined,productName:contract?contract.name:undefined,productCategory:type,productBrand:'Legalplace',productVariant:checkoutOperation?this.packName:undefined,productPrice:priceActeHT||(checkoutOperation&&price?price:packPriceWithReduction||undefined),productQuantity:1,productFormVersion:contract?''+contract.version:undefined}];if(__WEBPACK_IMPORTED_MODULE_2__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractMetaId)>-1&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().account_settings.is_crea_assiste_sub){products.push({productId:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractMetaId||undefined,productName:'Assistance LegalPlace',productBrand:'LegalPlace',productCategory:type,productVariant:undefined,productPrice:'0.00',productQuantity:1,productFormVersion:contract?''+contract.version:undefined});}dataLayer.push(Object(__WEBPACK_IMPORTED_MODULE_1__legalplace_lp_events__["gtmAchatEvent"])({products:products,currencyCode:'EUR',orderId:orderId,orderRevenue:priceActeHT||packPriceWithReduction||0,orderShipping:orderShipping,orderTax:priceActeTVA||orderTax,orderPack:this.packName,orderNewCustomer:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].newCustomer?'Oui':'Non',orderTunnelType:__WEBPACK_IMPORTED_MODULE_2__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractMetaId)>-1?'Créations':price>0?'Actes payants':'Actes gratuits',orderPaymentMethod:paymentMethod,orderCoupon:checkoutOperation&&checkoutOperation.promo_code?checkoutOperation.promo_code+' - '+checkoutOperation.promo_percentage*100+'%':undefined,orderFormVersion:contract?''+contract.version:undefined,orderOption:__WEBPACK_IMPORTED_MODULE_2__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractMetaId)>-1&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().account_settings.is_crea_assiste_sub?'Oui':'Non'}));};/*
 * Event tracking in Mixpanel
 */EventTracking.prototype.trackMix=function trackMix(eventName,eventProps,doNotPushToQueue){if(typeof window.mixpanel!=='undefined'){if(this.queue.length>0&&!doNotPushToQueue)this.executeQueue();window.mixpanel.track(eventName,eventProps);return true;}if(typeof doNotPushToQueue==='undefined')this.queue.push(['trackMix',arguments]);this.queueTimeout();return false;};/*
 * Event tracking in Mixpanel
 */EventTracking.prototype.trackAbTasty=function trackAbTasty(eventName,eventProps,doNotPushToQueue){if(typeof window.abtasty!=='undefined'){if(this.queue.length>0&&!doNotPushToQueue)this.executeQueue();window.abtasty.send('transaction',{tid:eventProps.uniqid,ta:eventName,tr:eventProps.revenue,tt:eventProps.itemPrice/6,tc:'EUR',tcc:eventProps.couponCode,pm:eventProps.paymentMethod,icn:1});window.abtasty.send('item',{tid:eventProps.uniqid,in:eventProps.itemName,ip:eventProps.itemPrice,iq:1});return true;}if(typeof doNotPushToQueue==='undefined')this.queue.push(['trackAbTasty',arguments]);this.queueTimeout();return false;};/*
 * Event tracking in SendinBlue
 */EventTracking.prototype.trackSIB=function trackSIB(eventName,eventProps,doNotPushToQueue){if(typeof window.sendinblue!=='undefined'){if(this.queue.length>0&&!doNotPushToQueue)this.executeQueue();window.sendinblue.track(eventName,eventProps);return true;}if(typeof doNotPushToQueue==='undefined')this.queue.push(['trackSIB',arguments]);this.queueTimeout();return false;};/*
 * Event tracking in Facebook Pixel
 */EventTracking.prototype.trackFB=function trackFB(eventName,eventProps,doNotPushToQueue){if(typeof window.fbq!=='undefined'){if(this.queue.length>0&&!doNotPushToQueue)this.executeQueue();window.fbq('trackCustom',eventName,eventProps);return true;}for(var _len=arguments.length,args=Array(_len>3?_len-3:0),_key=3;_key<_len;_key++){args[_key-3]=arguments[_key];}if(typeof doNotPushToQueue==='undefined')this.queue.push(['trackFB'].concat(args));this.queueTimeout();return false;};/*
 * Event tracking in Google Analytucs
 */EventTracking.prototype.trackGA=function trackGA(eventName,eventProps,doNotPushToQueue){if(typeof window.ga!=='undefined'){if(this.queue.length>0&&!doNotPushToQueue)this.executeQueue();window.ga('send','event','lpTracking','track',eventName,1,eventProps);return true;}for(var _len2=arguments.length,args=Array(_len2>3?_len2-3:0),_key2=3;_key2<_len2;_key2++){args[_key2-3]=arguments[_key2];}if(typeof doNotPushToQueue==='undefined')this.queue.push(['trackGA'].concat(args));this.queueTimeout();return false;};/*
 * Props register
 */EventTracking.prototype.register=function register(props){// Mixpanel
this.registerMix(props);// Facebook Pixel
this.registerFB(props);};/*
 * Props register Mixpanel
 */EventTracking.prototype.registerMix=function registerMix(props,doNotPushToQueue){if(typeof window.mixpanel!=='undefined'){if(this.queue.length>0&&!doNotPushToQueue)this.executeQueue();window.mixpanel.register(props);return true;}for(var _len3=arguments.length,args=Array(_len3>2?_len3-2:0),_key3=2;_key3<_len3;_key3++){args[_key3-2]=arguments[_key3];}if(typeof doNotPushToQueue==='undefined')this.queue.push(['registerMix'].concat(args));this.queueTimeout();return false;};/*
 * Props register Facebook Pixel
 */EventTracking.prototype.registerFB=function registerFB(props,doNotPushToQueue){if(typeof window.fbq!=='undefined'){if(this.queue.length>0&&!doNotPushToQueue)this.executeQueue();window.fbq('trackCustom','GeneralProps',props);return true;}for(var _len4=arguments.length,args=Array(_len4>2?_len4-2:0),_key4=2;_key4<_len4;_key4++){args[_key4-2]=arguments[_key4];}if(typeof doNotPushToQueue==='undefined')this.queue.push(['registerFB'].concat(args));this.queueTimeout();return false;};/*
 * Props trigger
 */EventTracking.prototype.trigger=function trigger(name){// Hotjar
this.triggerHj(name);};/*
 * Hotjar trigger helper
 */EventTracking.prototype.triggerHj=function triggerHj(name,doNotPushToQueue){// Making sure HJ tracking lib is loaded
if(typeof window.hj!=='undefined'){// If queue isn't empty & function hasn't been called by executeQueue
if(this.queue.length>0&&!doNotPushToQueue)this.executeQueue();// Trigger
window.hj('trigger',name);return true;}// Adding to queue
for(var _len5=arguments.length,args=Array(_len5>2?_len5-2:0),_key5=2;_key5<_len5;_key5++){args[_key5-2]=arguments[_key5];}if(typeof doNotPushToQueue==='undefined')this.queue.push(['triggerHj'].concat(args));this.queueTimeout();return false;};/**
 * Adwords conversion tracking
 * @param {object} props Conversion tracking props
 * @param {boolean} doNotPushToQueue Avoid queueing event if the provider's script isn't loaded (used esentially bu eventTracking.executeQueue)
 */EventTracking.prototype.adwordsConversion=function adwordsConversion(props,doNotPushToQueue){// Making sure Google Adwords conversion script is loaded
if(typeof window.google_trackConversion==='undefined'){for(var _len6=arguments.length,args=Array(_len6>2?_len6-2:0),_key6=2;_key6<_len6;_key6++){args[_key6-2]=arguments[_key6];}if(typeof doNotPushToQueue==='undefined')this.queue.push(['adwordsConversion'].concat(args));return false;}/** Do NOT track conversions for free products */if(props.google_conversion_value===0)return;// Default tracking props
var defaultProps={google_conversion_id:958034329,google_conversion_language:'en',google_conversion_format:'3',google_conversion_color:'ffffff',google_conversion_label:'ZcUkCN3ntIoBEJnj6cgD',google_conversion_value:0,google_remarketing_only:false};// Overriding default props by props
if((typeof props==='undefined'?'undefined':_typeof(props))==='object'){var propsKeys=Object.keys(props);for(var i=0;i<propsKeys.length;i+=1){var currentKey=propsKeys[i];// Making sure key exists in default props
if(Object.prototype.hasOwnProperty.call(defaultProps,currentKey)){defaultProps[currentKey]=props[currentKey];}}}// Tracking conversion
window.google_trackConversion(defaultProps);return true;};/**
 * Bing conversion tracking
 * @param {object} props Conversion tracking props
 * @param {boolean} doNotPushToQueue Avoid queueing event if the provider's script isn't loaded (used esentially bu eventTracking.executeQueue)
 */EventTracking.prototype.bingConversion=function bingConversion(props,doNotPushToQueue){// Making sure Bing Ad conversion script is loaded
if(typeof window.uetq=='undefined'){if(typeof doNotPushToQueue=='undefined')this.queue.push(['bingConversion',arguments]);return false;}/** Do NOT track conversions for free products */if(props.gv===0)return;// Default tracking props
var default_props={ea:'Purchase',gv:0,gc:'EUR'};// Overriding default props by props
if((typeof props==='undefined'?'undefined':_typeof(props))=='object'){var props_keys=Object.keys(props);for(var i=0;i<props_keys.length;i++){var current_key=props_keys[i];// Making sure key exists in default props
if(!default_props.hasOwnProperty(current_key))continue;default_props[current_key]=props[current_key];}}// Tracking convertion
window.uetq=window.uetq||[];window.uetq.push(default_props);return true;};/**
 * Facebook conversion tracking
 * @param {object} props Conversion tracking props
 * @param {boolean} doNotPushToQueue Avoid queueing event if the provider's script isn't loaded (used esentially bu eventTracking.executeQueue)
 */EventTracking.prototype.facebookConversion=function facebookConversion(props,doNotPushToQueue){// Making sure Facebook Ad conversion script is loaded
if(typeof window.fbq=='undefined'){if(typeof doNotPushToQueue=='undefined')this.queue.push(['facebookConversion',arguments]);return false;}/** Do NOT track conversions for free products */if(props.value===0)return;// Default tracking props
var default_props={content_type:'product',content_ids:[0],value:0,currency:'EUR'};// Overriding default props by props
if((typeof props==='undefined'?'undefined':_typeof(props))=='object'){var props_keys=Object.keys(props);for(var i=0;i<props_keys.length;i++){var current_key=props_keys[i];// Making sure key exists in default props
if(!default_props.hasOwnProperty(current_key))continue;default_props[current_key]=props[current_key];}}// Tracking convertion
window.fbq('track','Purchase',default_props);return true;};/**
 * Google Analytics conversion tracking
 * @param {object} props Conversion tracking props
 * @param {boolean} doNotPushToQueue Avoid queueing event if the provider's script isn't loaded (used esentially bu eventTracking.executeQueue)
 */EventTracking.prototype.gAnalyticsConversion=function gAnalyticsConversion(props,doNotPushToQueue){// Making sure Facebook Ad conversion script is loaded
if(typeof window.ga=='undefined'){if(typeof doNotPushToQueue=='undefined')this.queue.push(['gAnalyticsConversion',arguments]);return false;}/** Do NOT track conversions for free products */if(props.price===0)return;// Default tracking props
var default_props={id:new Date().getTime(),affiliation:'LegalPlace',revenue:0,price:0,shipping:0,tax:0,name:'',currency:'EUR',quantity:'1'};// Overriding default props by props
if((typeof props==='undefined'?'undefined':_typeof(props))=='object'){var props_keys=Object.keys(props);for(var i=0;i<props_keys.length;i++){var current_key=props_keys[i];// Making sure key exists in default props
if(!default_props.hasOwnProperty(current_key))continue;default_props[current_key]=props[current_key];}}// Tracking convertion
window.ga('send','event','Payment','Download',default_props.price);window.ga('require','ecommerce');window.ga('ecommerce:addTransaction',default_props);window.ga('ecommerce:addItem',default_props);window.ga('ecommerce:send');return true;};EventTracking.prototype.trackDatalayerMixpanel=function trackDatalayerMixpanel(eventCategory,eventLabel){var eventAction=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'Clic';dataLayer.push({event:"eventMXP",eventCategory:eventCategory,eventLabel:eventLabel,eventAction:eventAction});};EventTracking.prototype.trackDatalayerSendinBlue=function trackDatalayerSendinBlue(SBInfos){dataLayer.push({event:"avocatyExtraction",SBInfos:SBInfos});};var lpevents=new EventTracking();window.lpevents=new EventTracking();/* harmony default export */ __webpack_exports__["a"] = (lpevents);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lpw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _lp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_fr_json__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__language_fr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_de_json__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__language_de_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src\logic\wording.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var lpWording=function(){function lpWording(){_classCallCheck(this,lpWording);this.language='fr';this.dicts={fr:__WEBPACK_IMPORTED_MODULE_0__language_fr_json__,de:__WEBPACK_IMPORTED_MODULE_1__language_de_json__};this.detectLanguage();// console.log(this)
// this.initIndex();
}_createClass(lpWording,[{key:'detectLanguage',value:function detectLanguage(){if(navigator.language in['fr','de'])this.language=navigator.language;else this.language='fr';// this.language = "de"
this.dict=this.dicts[this.language];}},{key:'get',value:function get(something){if(this.dict.values[something]){return this.dict.values[something];}return something;}},{key:'initIndex',value:function initIndex(){var nodes=document.getElementById('contact-').childNodes;nodes[0].nodeValue=this.get('want help?');nodes[1].childNodes[0].innerText=this.get('contact us');nodes[1].childNodes[1].nodeValue=this.get('or');nodes[2].innerText=this.get('call us');}}]);return lpWording;}();var lpw=new lpWording();var _lp=function _lp(str){return str;};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = objectLength;
/* harmony export (immutable) */ __webpack_exports__["c"] = guid;
/* harmony export (immutable) */ __webpack_exports__["b"] = generateId1;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return localFormat; });
/* unused harmony export animationScroll */
/* harmony export (immutable) */ __webpack_exports__["f"] = scrollAndGoUp;
/* harmony export (immutable) */ __webpack_exports__["g"] = scrollTo;
/* harmony export (immutable) */ __webpack_exports__["a"] = filterComponents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_lp_app__ = __webpack_require__(2);
/*
 * Project: LegalPlace assistant
 * File: src\components\utils\misc.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 *//* eslint-disable */function objectLength(ob){var i=0;for(var j in ob){i=j;}return i;}function guid(){function s4(){return Math.floor((1+Math.random())*0x10000).toString(16).substring(1);}return s4()+s4()+'-'+s4()+'-'+s4()+'-'+s4()+'-'+s4()+s4()+s4();}var lut=[];for(var i=0;i<256;i+=1){lut[i]=(i<16?'0':'')+i.toString(16);}function generateId1(){var d0=Math.random()*0xffffffff|0;var d1=Math.random()*0xffffffff|0;var d2=Math.random()*0xffffffff|0;var d3=Math.random()*0xffffffff|0;return lut[d0&0xff]+lut[d0>>8&0xff]+lut[d0>>16&0xff]+lut[d0>>24&0xff]+'-'+lut[d1&0xff]+lut[d1>>8&0xff]+'-'+lut[d1>>16&0x0f|0x40]+lut[d1>>24&0xff]+'-'+lut[d2&0x3f|0x80]+lut[d2>>8&0xff]+'-'+lut[d2>>16&0xff]+lut[d2>>24&0xff]+lut[d3&0xff]+lut[d3>>8&0xff]+lut[d3>>16&0xff]+lut[d3>>24&0xff];}var localFormat=function localFormat(t){var res=t;if(t<10){res='0'+t;}return res;};function animationScroll(){var dest0=arguments.length>0&&arguments[0]!==undefined?arguments[0]:-1;var destY=void 0;if(dest0===-1)destY=125;else destY=dest0;// debugger;
var delta=30;var scrollEvent=setInterval(function(){if(Math.abs(window.scrollY-destY)<=10||window.innerHeight+window.scrollY>=document.body.offsetHeight){console.log('animated');clearInterval(scrollEvent);}else{// console.log(window.scrollY)
if(destY<window.scrollY){window.scrollTo(window.scrollX,window.scrollY-window.scrollY/delta);}else{window.scrollTo(window.scrollX,window.scrollY+(window.scrollY<350?350:window.scrollY)/delta);}}},10);}function scrollAndGoUp(){window.scrollTo(window.pageYOffset,0);return true;}function scrollTo(element,to,duration){var start=element.scrollTop;var change=to-start;var currentTime=0;var increment=20;var timer=void 0;var killed=void 0;Math.easeInOutQuad=function(t,b,c,d){t/=d/2;if(t<1)return c/2*t*t+b;t-=1;return-c/2*(t*(t-2)-1)+b;};var animateScroll=function animateScroll(){if(killed)return;currentTime+=increment;var val=Math.easeInOutQuad(currentTime,start,change,duration);element.scrollTop=val;if(currentTime<duration){timer=setTimeout(animateScroll,increment);}};animateScroll();return{stop:function stop(){killed=true;clearTimeout(timer);}};}/* eslint-enable */// ----------------- GLOBALE TRACKING SCROLLE CHIT
window.toctoc=null;window.scrollingTracker=true;window.addEventListener('scroll',function(){window.scrollingTracker=false;if(window.toctoc!==null){clearTimeout(window.toctoc);}window.toctoc=setTimeout(function(){window.scrollingTracker=true;},150);});// gist.
/**
 * @description This funciton creates an array which radio children are put togather.
 * @param {number} id
 * @returns {array}
 */function filterComponents(id){var now=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.getOption(id);if(typeof now==='undefined')return now;var children=[];var radios=[];var actualChildren=now.children;var childrenLength=actualChildren.length;// debugger;
actualChildren.forEach(function(idx,i){var _=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.getOption(idx);if(_.meta.type!=='radio'){if(radios.length===0)children.push(idx);else{children.push(radios);radios=[];children.push(idx);}}else{radios.push(idx);if(radios.length>0){if(i===childrenLength-1){children.push(radios);}}}});return children;}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(117)('wks');
var uid = __webpack_require__(83);
var Symbol = __webpack_require__(9).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(52);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initializeIndexes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initializeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return reorderOption; });
/* unused harmony export reorederFlat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return reorderVariable; });
/* unused harmony export reorderMultiples */
/* unused harmony export reorderParent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reorderViews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return lpUpdateMultiple; });
/* unused harmony export lpGetMultipleList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return initializeVariables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lpGetOptionById; });
/* unused harmony export lpGetFlatById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return lpGetVariableById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return lpGetIsMultiple; });
/* unused harmony export lpGetViewByVariable */
/* unused harmony export lpGetParentById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return lpSetVariableById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateConditions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return delReindexVariable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return delReindexOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preview_render_angular_reader__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_reducers_load_ovc__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__condition_evo__ = __webpack_require__(29);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/*
* Project: LegalPlace assistant
* File: src/logic/re_index.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var optionsIndex={};var flatIndex={};var varsIndex={};var multiplesIndex={};var varViewIndex={};var multipleList={};// optimization issue
var conditionList={};var parentingIndex={};var parentingIndexOpts={};function initializeOptions(){optionsIndex={};}function initializeVariables(){varsIndex={};}function initializeIndexes(){flatIndex={};parentingIndex={};}function lpUpdateMultiple(opt,m){multipleList[opt]=m;window.lp_mList=multipleList;}function lpGetMultipleList(opt){return multipleList[opt];}function updateConditions(){var keys=void 0;if(!__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.options)return;var la=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].action_tracker.last_action;var laArg=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].action_tracker.la_arg1;if(la==='EDIT_OPTION_RADIO_'||la==='SET_SECTION_ID'||la==='EDIT_OPTION_VALUE_'||la==='ADD_MULTIPLE'||la==='REMOVE_FIRST'||la==='REMOVE_FIRST_VARIABLE'||la==='REM_OPTION_DUP'||la==='REM_VARIABLE_DUP'||la==='EDIT_VARIABLE'){if(la==='EDIT_VARIABLE')keys=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.dependencies.getVariableDependecies(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(laArg));else keys=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.dependencies.getDependecies(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(laArg));if(keys){keys.forEach(function(idx){var now=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(idx).meta;if(now.conditional&&now.compiledConditions.length>0){// let c = new ConditionRuntime(now.compiledConditions);
// c.compileDirect()
// conditionList[idx] = c.execute(true);
conditionList[idx]=__WEBPACK_IMPORTED_MODULE_4__condition_evo__["a" /* default */].getCondition(idx);}});}// debugger;
__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.conditions.buildConditions(conditionList);}return conditionList;}window.updateConditions=updateConditions;function reorderViews(views){Object.keys(views).forEach(function(idx){var id=parseInt(idx.split('.')[0],10);var meView=new __WEBPACK_IMPORTED_MODULE_0__preview_render_angular_reader__["a" /* default */](id,views[idx]);meView.compile();// FIXME:
meView.variables.forEach(function(jdx){if(varViewIndex[jdx])varViewIndex[jdx].push(idx);else varViewIndex[jdx]=[idx];});});// window.ous = varViewIndex;
__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.updateV2V(varViewIndex);}function reorderMultiples(opt){var cId=opt.id;if(typeof opt.id==='string'){var _opt$id$split=opt.id.split('_');var _opt$id$split2=_slicedToArray(_opt$id$split,1);cId=_opt$id$split2[0];{var ids=Object(__WEBPACK_IMPORTED_MODULE_2__redux_reducers_load_ovc__["a" /* getOFirstMultipleParent */])(cId);// console.log(ids)
multiplesIndex[ids]=true;}}else multiplesIndex[cId]=false;}function reorderOption(opt){var i=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(opt){optionsIndex[opt.id]={value:opt.value,key:opt.key,index:i};__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.updateOption(opt,i);}}function reorederFlat(flat){if(flat){flatIndex[flat.uiid]={id:flat.id,parent:flat.parentId,ovc:flat.genre,parentUi:flat.parentUi,active:flat.active};}}function reorderVariable(var_){var i=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(var_){varsIndex[var_.id]={value:var_.value,key:var_.key,index:i};__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.updateVariable(var_,i);window.vars=varsIndex;}}function reorderParent(flat){if(flat){if(flat.genre==='oc'||flat.genre==='vc')return;if(flat.genre==='o'){parentingIndexOpts[flat.id]={ovc:flat.genre,parent:flat.parentId,section:flat.sectionId};}else{parentingIndex[flat.id]={ovc:flat.genre,parent:flat.parentId,section:flat.sectionId};}}}function updateWindow(){window.lp_ops=optionsIndex;window.lp_vars=varsIndex;window.lp_parenting=parentingIndex;window.lp_parenting_opts=parentingIndexOpts;window.lp_flat=flatIndex;// window.lp_mult = {};//multiplesIndex;
// window.lp_co = conditionList;
}// get information:
function lpGetOptionById(id){return optionsIndex[id];}function lpGetFlatById(uiid){return flatIndex[uiid];}function lpGetVariableById(id){return varsIndex[id];}function lpSetVariableById(id,value){varsIndex[id].value=value;}function lpGetIsMultiple(id){// console.log(id)
if(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(id))return __WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(id);return undefined;}function lpGetViewByVariable(id){var result=[];// console.group(id);
//     console.log(varViewIndex[id]);
// console.groupEnd(id);
if(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.content.content){__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.content.content.forEach(function(idx){if(varViewIndex){varViewIndex[id].forEach(function(jdx){if(jdx===idx[0])result=[jdx];});}});}return result;}function lpGetParentById(id){return parentingIndex[id];}/*
 * Delete functions
 */function delReindexVariable(id){if(Object.prototype.hasOwnProperty.call(varsIndex,id))delete varsIndex[id];}function delReindexOption(id){if(Object.prototype.hasOwnProperty.call(varsIndex,id))delete optionsIndex[id];}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["_4"] = isClientPro;
/* harmony export (immutable) */ __webpack_exports__["F"] = buildQuery;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUILD_CHECKOUT; });
/* unused harmony export SEND_INFORMATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_CSRF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return buildCheckout; });
/* unused harmony export sendInformation */
/* unused harmony export updateCSRF */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CK_UPDATE_PROMOTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CK_SET_PACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CK_TOGGLE_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CK_TOGGLE_LETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CK_UPDATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CK_UPDATE_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CK_UPDATE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CK_UPDATE_ZIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CK_UPDATE_LETTER_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CK_UPDATE_PAYMENT_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CK_UPDATE_C_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CK_UPDATE_C_EXPIRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CK_UPDATE_C_CCV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CK_UPDATE_DIRECT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CK_UPDATE_IBAN; });
/* unused harmony export CK_M_CREDIT_CARD */
/* unused harmony export CK_M_PAYPAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CK_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CK_UPDATE_REDUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CK_LOADING_REDUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CE_TOGGLE_PACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return PACK_ENTREPRENEUR_HEADER_BTN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PACK_ENTREPRENEUR_CHOOSE_PACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PACK_ENTREPRENEUR_ADD_UPSELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return IU_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return IU_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return IU_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return IU_ZIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return IU_TVA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return IU_VIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return invoiceUpdateName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return invoiceUpdateAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return invoiceUpdateCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return invoiceUpdateZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return invoiceUpdateTVA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return invoiceUpdateVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return ckUpdatePromoCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return ckUpdatePack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return ckSetCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ckSetSending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return ckUpdateLettersNbr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return ckUpdateName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return ckUpdateCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return ckUpdateAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return ckUpdateZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return ckPaymentSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ckCUpdateCardNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ckCUpdateCardExpiration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ckCUpdateCCV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return ckCUpdateDirectName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return ckCUpdateIban; });
/* unused harmony export buildDataForPayment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ckCheckCondition; });
/* unused harmony export ckReduction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ckSendPromoCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ceTogglePack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return packEntrepreneur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return packEntrepreneurChoosePack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return packEntrepreneurAddUpsell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logic_action_counter__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_ovc_converter__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__document_state__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_history__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_condition_tree__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__baseLink__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lperrors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_ops_sendinblue_notification__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__manager_apiManager__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_hardcoded_checkout__ = __webpack_require__(63);
/*
* Project: LegalPlace assistant
* File: src/redux/actions/checkout_operations.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// TODO: must have a second check here.
var BUILD_CHECKOUT='BUILD_CHECKOUT_';var SEND_INFORMATION='SEND_INFORMATION_';var UPDATE_CSRF='UPDATE_CSRF_';// checkout stage
// promo code
var CK_UPDATE_PROMOTION='CK_UPDATE_PROMOTION';// Packs selections
var CK_SET_PACK='CK_SET_PACK';// Option selection
var CK_TOGGLE_CALL='CK_TOGGLE_CALL';var CK_TOGGLE_LETTER='CK_TOGGLE_LETTER';var CK_UPDATE_NAME='CK_UPDATE_NAME';var CK_UPDATE_ADDRESS='CK_UPDATE_ADDRESS';var CK_UPDATE_CITY='CK_UPDATE_CITY';var CK_UPDATE_ZIP='CK_UPDATE_ZIP';var CK_UPDATE_LETTER_NUMBER='CK_UPDATE_LETTER_NUMBER';// payment
var CK_UPDATE_PAYMENT_METHOD='CK_UPDATE_PAYMENT_METHOD';var CK_UPDATE_C_NUMBER='CK_UPDATE_C_NUMBER';var CK_UPDATE_C_EXPIRATION='CK_UPDATE_C_EXPIRATION';var CK_UPDATE_C_CCV='CK_UPDATE_C_CCV';var CK_UPDATE_DIRECT_NAME='CK_UPDATE_DIRECT_NAME';var CK_UPDATE_IBAN='CK_UPDATE_IBAN';// Payment options
var CK_M_CREDIT_CARD=0;var CK_M_PAYPAL=1;// checkbox of terms and conditions
var CK_CHECK='CK_CHECK';var CK_UPDATE_REDUCTION='CK_UPDATE_REDUCTION';var CK_LOADING_REDUCTION='CK_LOADING_REDUCTION';var CE_TOGGLE_PACK='CE_TOGGLE_PACK';var PACK_ENTREPRENEUR_HEADER_BTN='PACK_ENTREPRENEUR_HEADER_BTN';var PACK_ENTREPRENEUR_CHOOSE_PACK='PACK_ENTREPRENEUR_CHOOSE_PACK';var PACK_ENTREPRENEUR_ADD_UPSELL='PACK_ENTREPRENEUR_ADD_UPSELL';var IU_NAME='IU_NAME';var IU_ADDRESS='IU_ADDRESS';var IU_CITY='IU_CITY';var IU_ZIP='IU_ZIP';var IU_TVA='IU_TVA';var IU_VIS='IU_VIS';/**
 * @description add the checkout type conditions.
 * @param {Object} val
 */function ceTogglePack(val,id){var goToExpertComptableStep=window.location.href.indexOf('paiement')>-1&&__WEBPACK_IMPORTED_MODULE_17__constants_hardcoded_checkout__["c" /* HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractMetaId)>-1&&id===3;var backToExpertComptableStep=window.location.href.indexOf('checkout')>-1&&__WEBPACK_IMPORTED_MODULE_17__constants_hardcoded_checkout__["c" /* HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractMetaId)>-1&&id===3;if(val===true){// intermediate page and specific case
// if step 1 && included metaId go to expert-comptable
if(goToExpertComptableStep){val=false;Object(__WEBPACK_IMPORTED_MODULE_4__logic_history__["a" /* default */])('expert-comptable',false,false,__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractUniqid);}else{Object(__WEBPACK_IMPORTED_MODULE_4__logic_history__["a" /* default */])('checkout',false,false,__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractUniqid);}}else{if(backToExpertComptableStep){Object(__WEBPACK_IMPORTED_MODULE_4__logic_history__["a" /* default */])('expert-comptable',false,false,__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractUniqid);}else{Object(__WEBPACK_IMPORTED_MODULE_4__logic_history__["a" /* default */])('payment',false,false,__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractUniqid);}}return{type:CE_TOGGLE_PACK,val:val};}function packEntrepreneur(val){return{type:PACK_ENTREPRENEUR_HEADER_BTN,val:val};}function packEntrepreneurChoosePack(val){return{type:PACK_ENTREPRENEUR_CHOOSE_PACK,val:val};}function packEntrepreneurAddUpsell(val){return{type:PACK_ENTREPRENEUR_ADD_UPSELL,val:val};}function ckCheckCondition(val){return{type:CK_CHECK,val:val};}// update things here
/**
 * @description update the promo code in the store.
 * @param {String} val
 */function ckUpdatePromoCode(val){return{type:CK_UPDATE_PROMOTION,val:val};}/**
 * @description select the pack in the store.
 * @param {number} val
 */function ckUpdatePack(val){return{type:CK_SET_PACK,val:val};}/**
 * @description add the call to the store
 * @param {boolean} val
 */function ckSetCall(val){return{type:CK_TOGGLE_CALL,val:val};}/**
 * @description set true if the user selected the send-me-letters
 * @param {boolean} val
 */function ckSetSending(val){return{type:CK_TOGGLE_LETTER,val:val};}/**
 * @description update the number of letters must be sent
 * @param {number} incr
 */function ckUpdateLettersNbr(incr){return{type:CK_UPDATE_LETTER_NUMBER,incr:incr};}function ckUpdateName(val){return{type:CK_UPDATE_NAME,val:val};}/**
 * @description update the city name int he store
 * @param {string} val
 */function ckUpdateCity(val){return{type:CK_UPDATE_CITY,val:val};}/**
 * @description update the address of the user
 * @param {string} val
 */function ckUpdateAddress(val){return{type:CK_UPDATE_ADDRESS,val:val};}/**
 * @description update zip code
 * @param {number} val
 */function ckUpdateZip(val){return{type:CK_UPDATE_ZIP,val:val};}// here we build queries and all
/**
 * @description select the payment type (credit card/ paypal)
 * @param {number} method
 */function ckPaymentSelect(method){return{type:CK_UPDATE_PAYMENT_METHOD,method:method};}/**
 * @description update the card number in store
 * @param {number} val
 */function ckCUpdateCardNumber(val){return{type:CK_UPDATE_C_NUMBER,val:val};}/**
 * @description update the expiration date.
 * @param {Date} val
 */function ckCUpdateCardExpiration(val){return{type:CK_UPDATE_C_EXPIRATION,val:val};}/**
 * @description update ccv
 * @param {number} val
 */function ckCUpdateCCV(val){return{type:CK_UPDATE_C_CCV,val:val};}/**
 * @description update direct name
 * @param {string} val
 */function ckCUpdateDirectName(val){return{type:CK_UPDATE_DIRECT_NAME,val:val};}/**
* @description update direct iban
* @param {string} val
*/function ckCUpdateIban(val){return{type:CK_UPDATE_IBAN,val:val};}/**
 * @description uodates the name in invoice section
 * @param {string} val
 */function invoiceUpdateName(val){return{type:IU_NAME,val:val};}/**
 * @description updates the address in the invoice
 * @param {string} val
 */function invoiceUpdateAddress(val){return{type:IU_ADDRESS,val:val};}/**
 * @description updates the city in invoice section
 * @param {string} val
 */function invoiceUpdateCity(val){return{type:IU_CITY,val:val};}/**
 * @description updates ZIP code in invoice section
 * @param {number} val
 */function invoiceUpdateZip(val){return{type:IU_ZIP,val:val};}/**
 * @description updates the TVA number
 * @param {string} val
 */function invoiceUpdateTVA(val){return{type:IU_TVA,val:val};}/**
 * @description updates the state of visibility of invoice
 * @param {boolean} val
 */function invoiceUpdateVisibility(val){return{type:IU_VIS,val:val};}/**
 * @description update the csrf token like received
 * @param {Object} csrf
 */function updateCSRF(csrf){return{type:UPDATE_CSRF,csrf:csrf};}/**
 *
 * @param {string} mail
 * @param {number} totalV total number of variables
 * @param {number} totalO total number of the options selected
 * @param {number} cVersion contract version
 * @param {string} ind individual/commercial buy
 * @param {string} uniqid individual/commercial buy
 * @param {boolean} forceSb individual/commercial buy
 */function buildPhaseOne(){var mail=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var totalV=arguments[1];var totalO=arguments[2];var cVersion=arguments[3];var ind=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'ind';var uniqid=arguments.length>5&&arguments[5]!==undefined?arguments[5]:'';var forceSb=arguments.length>6&&arguments[6]!==undefined?arguments[6]:false;if(uniqid===''){return{email:mail,do_not_email:1,nb_total_options:totalO,nb_total_vars:totalV,nb_chosen_options:__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.utils.getEditedOptions(),nb_filled_vars:__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.utils.getEditedVariables(),contract_version:cVersion,force_subscription:forceSb,client_type:ind,app_type:'react',mode:'expert'};}return{email:mail,do_not_email:1,nb_total_options:totalO,nb_total_vars:totalV,nb_chosen_options:Object(__WEBPACK_IMPORTED_MODULE_0__logic_action_counter__["a" /* getEditedOptions */])(),nb_filled_vars:Object(__WEBPACK_IMPORTED_MODULE_0__logic_action_counter__["b" /* getEditedVariables */])(),contract_version:cVersion,force_subscription:forceSb,client_type:ind,app_type:'react',mode:'expert',uniqid:uniqid};}function buildPhaseOneSaveFirst(mail,section,json){return{email:mail,json:JSON.stringify(json),mode:'expert',section:section};}/**
 * @description update if the document is saved
 * @param {number} contractId
 * @param {number} section section number
 * @param {Object} json OVC to save
 */function buildPhaseOneSave(contractId,section,json){return{contract_id:contractId,do_not_email:1,json:JSON.stringify(json),mode:'expert',section:section};}/**
 * @description decide wether the user is individual or a professional
 */function isClientPro(){var state=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState();var pro=true;var proTest=state.contract.client_type;switch(proTest){case'COND':if(state.contract.pro_condition.length===0)pro=false;else{var proCond=new __WEBPACK_IMPORTED_MODULE_5__logic_condition_tree__["a" /* ConditionRuntime */](state.contract.pro_condition);proCond.compileDirect();pro=proCond.execute(true);}break;case'PRO':default:pro=true;break;}return pro;}/**
 * @description send the basic information.
 */function sendInformation(isCheckout){var contractId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch,getState){// build the query
var state=getState();var ovcc=Object(__WEBPACK_IMPORTED_MODULE_1__logic_ovc_converter__["a" /* getAllOptions */])();var body={json:JSON.stringify(ovcc),contract_id:!contractId?state.checkout_operations.contract_id:contractId,user_email:__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().account_settings.mail,contract_version:__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.version,justSave:true,is_two_steps:__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.is_two_steps,ovc:ovcc};body[state.checkout_operations.csrf_key]=state.checkout_operations.csrf_value;Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["g" /* saveInstance */])(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractTitle,body).then(function(resp){var parsedObj=resp.data;__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].trackGTMGAEvent('Inscription email','Clic','Funnel Contrat standard');dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_8__errors_error__["a" /* LpError */](0,0,'')));dispatch({type:__WEBPACK_IMPORTED_MODULE_3__document_state__["d" /* SET_DOCUMENT_ID */],doc:parsedObj.uniqid});if(isCheckout){var event={};event['First proposed price']=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().checkout_operations.prices.first_price;event['Second proposed price']=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().checkout_operations.prices.second_price;event['NB° Chosen options']=Object(__WEBPACK_IMPORTED_MODULE_0__logic_action_counter__["a" /* getEditedOptions */])();event['NB° Total options']=Object.keys(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.options).length;event['NB° Total variables']=Object.keys(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.variables).length;event['NB° Filled variables']=Object(__WEBPACK_IMPORTED_MODULE_0__logic_action_counter__["b" /* getEditedVariables */])();event['email_id']=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().account_settings.mail;event.Document=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.name;event['Document Version']=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.version;event['Nouveau document']=typeof window.contract_id!=='undefined'&&window.contract_id===''?'Oui':'Non';event['checkoutVersion']='legacy';__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].register({Contract:__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.name,Email:__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().account_settings.mail,checkoutVersion:'legacy'});__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].track('Reached Checkout',event);/*
          * Adwords Conversion tracking
          */if(event['Nouveau document']==='Oui'){__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].adwordsConversion({google_conversion_value:0.01});}}// On exécute le callback
if(typeof callback==='function')callback();}).catch(function(err){'';console.error(err);__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].logs.log(err.name,err.message);dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_8__errors_error__["a" /* LpError */](0,1,Object(__WEBPACK_IMPORTED_MODULE_13__logic_wording__["a" /* _lp */])('Problèmes de connexion, veuillez recharger la page.'))));// On exécute le callback
if(typeof callback==='function')callback();});};}/**
 * @description build the checkout information to the store
 * @param {number} userId
 * @param {number} contractId
 * @param {number} prices
 * @param {number} adminFees
 * @param {string} pricingType
 * @param {Object} csrf
 * @param {Object} cCodes
 * @param {string} desabonnement
 * @param {string} mlLink
 *
 */function buildCheckout(userId,contractId,contractMetaId,prices,adminFees,pricingType,detailsCheckout,csrf,cCodes,desabonnement,mlLink){return{type:BUILD_CHECKOUT,user_id:userId,contract_id:contractId,contract_meta_id:contractMetaId,prices:prices,admin_fees:adminFees,pricing_type:pricingType,detailsCheckout:detailsCheckout,csrf:csrf,c_codes:cCodes,desabonnement:desabonnement,ml_link:mlLink};}/**
 * @description send async document data to the server.
 * @param {boolean} justSave
 * @param {boolean} autosave
 */function buildQuery(){var justSave=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var autosave=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return function(dispatch,getState){// If it's autosave && document hasn't been edited we stop right here
if(autosave&&!getState().account_settings.edited_doc){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["l" /* setChecking */])(false));return;}var state=getState();dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["j" /* loadingPricing */])());// TODO: can be more sophisticated
var totalV=Object.keys(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.variables).length;var totleO=Object.keys(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.options).filter(function(idx){return __WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.getOption(idx).meta.type==='radio'||__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.getOption(idx).meta.type==='checkbox';}).length;// the test of ind
var pro=isClientPro();// console.log("%cType: " + pro, "color: red");
// ConditionRuntime(getState().contract.)
var qb=void 0;if(justSave){// if(getState)
if(getState().document_state.unique===''){qb=buildPhaseOneSaveFirst(getState().account_settings.mail,getState().contract.currentSection+1,Object(__WEBPACK_IMPORTED_MODULE_1__logic_ovc_converter__["a" /* getAllOptions */])());}else{qb=buildPhaseOneSave(getState().document_state.unique,getState().contract.currentSection+1,Object(__WEBPACK_IMPORTED_MODULE_1__logic_ovc_converter__["a" /* getAllOptions */])());}}else{qb=buildPhaseOne(getState().account_settings.mail,totalV,totleO,getState().contract.version,pro?'pro':'ind',state.document_state.unique,!!window.contract_subscription);qb.autosave=1;}qb.contract_version=getState().contract.version;qb.ovc=Object(__WEBPACK_IMPORTED_MODULE_1__logic_ovc_converter__["a" /* getAllOptions */])();qb.justSave=justSave;qb.is_two_steps=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.is_two_steps;if(justSave){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["l" /* setChecking */])(true));if(getState().document_state.unique===''){Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["g" /* saveInstance */])(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractTitle,qb).then(function(res){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["m" /* unloadingPricing */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["l" /* setChecking */])(false));var parsedObj=res.data;window.obj=parsedObj;__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].setContractUniqid(parsedObj.uniqid);dispatch({type:__WEBPACK_IMPORTED_MODULE_3__document_state__["d" /* SET_DOCUMENT_ID */],doc:parsedObj.uniqid});// sending notifs for extarcted variables
var sdbNotif=new __WEBPACK_IMPORTED_MODULE_15__app_ops_sendinblue_notification__["a" /* default */]();sdbNotif.sendInBlueNotification(parsedObj,false,function(){__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.slack.generateMixpanel();__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.slack.generateSendinBlue('Variable Extraction');});dispatch({type:'UPDATE_C_CODES',c_codes:parsedObj.c_codes});dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_8__errors_error__["a" /* LpError */](0,0,'')));__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].register({Email:getState().account_settings.mail});if(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].isPayed)__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].track('Saved Paid document');else __WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].track('Saved document');dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__account_settings__["o" /* editedDocument */])(false));Object(__WEBPACK_IMPORTED_MODULE_8__errors_error__["c" /* unraiseError */])('save-mail');}).catch(function(err){console.error(err);// set non connection issue.
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["l" /* setChecking */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["m" /* unloadingPricing */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_8__errors_error__["a" /* LpError */](0,1,Object(__WEBPACK_IMPORTED_MODULE_13__logic_wording__["a" /* _lp */])('Votre connexion semble lente, veuillez vérifier votre connextion et recharger la page svp.'))));});}else{Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["h" /* updateInstance */])(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractTitle,__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractUniqid,qb).then(function(response){var parseObj=response.data;window.obj=parseObj;dispatch({type:__WEBPACK_IMPORTED_MODULE_3__document_state__["d" /* SET_DOCUMENT_ID */],doc:parseObj.uniqid});__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].setContractUniqid(parseObj.uniqid);var sdbNotif=new __WEBPACK_IMPORTED_MODULE_15__app_ops_sendinblue_notification__["a" /* default */]();sdbNotif.sendInBlueNotification(parseObj,false,function(){__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.slack.generateMixpanel();__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.slack.generateSendinBlue('Variable Extraction');});__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].register({Email:getState().account_settings.mail});if(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].isPayed)__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].track('Saved Paid document');dispatch({type:'UPDATE_C_CODES',c_codes:parseObj.c_codes});dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_8__errors_error__["a" /* LpError */](0,0,'')));dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__account_settings__["o" /* editedDocument */])(false));Object(__WEBPACK_IMPORTED_MODULE_8__errors_error__["c" /* unraiseError */])('save-mail');dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["l" /* setChecking */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["m" /* unloadingPricing */])());}).catch(function(err){console.error(err);// set non connection issue.
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["l" /* setChecking */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["m" /* unloadingPricing */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_8__errors_error__["a" /* LpError */](0,1,Object(__WEBPACK_IMPORTED_MODULE_13__logic_wording__["a" /* _lp */])('Votre connexion semble lente, veuillez vérifier votre connextion et recharger la page svp.'))));});}}else{var apiCall=getState().document_state.unique===''?Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["g" /* saveInstance */])(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractTitle,qb):Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["h" /* updateInstance */])(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].contractTitle,getState().document_state.unique,qb);apiCall.then(function(response){window.resp=response;var parsedObj=response.data;dispatch({type:__WEBPACK_IMPORTED_MODULE_3__document_state__["d" /* SET_DOCUMENT_ID */],doc:parsedObj.uniqid});__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].setContractUniqid(parsedObj.uniqid);window.obj=parsedObj;var sdbNotif=new __WEBPACK_IMPORTED_MODULE_15__app_ops_sendinblue_notification__["a" /* default */]();sdbNotif.sendInBlueNotification(parsedObj,false,function(){__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.slack.generateMixpanel();__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.slack.generateSendinBlue('Variable Extraction');});if(getState().document_state.state==='continue'&&getState().appstate!==1){Object(__WEBPACK_IMPORTED_MODULE_4__logic_history__["a" /* default */])('payment',true,getState().contract.current_section,getState().document_state.unique);}else Object(__WEBPACK_IMPORTED_MODULE_4__logic_history__["a" /* default */])('payment',false,getState().contract.current_section,getState().document_state.unique);dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_8__errors_error__["a" /* LpError */](0,0,'')));dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__app_state__["g" /* setAppState */])(2,true));var event={};event['First proposed price']=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().checkout_operations.prices.first_price;event['Second proposed price']=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().checkout_operations.prices.second_price;event['NB° Chosen options']=Object(__WEBPACK_IMPORTED_MODULE_0__logic_action_counter__["a" /* getEditedOptions */])();event['NB° Total options']=Object.keys(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.options).length;event['NB° Total variables']=Object.keys(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.variables).length;event['NB° Filled variables']=Object(__WEBPACK_IMPORTED_MODULE_0__logic_action_counter__["b" /* getEditedVariables */])();event['email_id']=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().account_settings.mail;event.Document=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.name;event['Document Version']=__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.version;event['checkoutVersion']='legacy';event['Nouveau document']=typeof window.contract_id!=='undefined'&&window.contract_id===''?'Oui':'Non';__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].register({Contract:__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().contract.name,Email:__WEBPACK_IMPORTED_MODULE_6__globals__["b" /* store */].getState().account_settings.mail,checkoutVersion:'legacy'});if(!window.executeEventOnetime){__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].track('Reached Checkout',event);window.executeEventOnetime=1;}/*
          * Adwords Conversion tracking
          */if(event['Nouveau document']==='Oui'){__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].adwordsConversion({google_conversion_value:0.01});}if(parsedObj.redirect_to){// console.log(_obj);
window.onbeforeunload=null;setTimeout(function(){window.location.href=parsedObj.redirect_to;},100);return;}}).catch(function(err){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__loading__["m" /* unloadingPricing */])());console.log(err);__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].logs.log(err.name,err.message);dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_8__errors_error__["a" /* LpError */](0,1,Object(__WEBPACK_IMPORTED_MODULE_13__logic_wording__["a" /* _lp */])('Problèmes de connexion, veuillez recharger la page'))));});}};}// build the thing
/**
 * @description create the payment object
 * @param {Object} state
 */function buildDataForPayment(state){var result={};var checkout=state.checkout_operations;result.pack=checkout.pack;result.contract_id=checkout.contract_id;result.payment_method=checkout.payment_method===0?'stripe':'paypal';result.card={card_number:checkout.credit_card.number,expiration_date:checkout.credit_card.expiration,ccv:checkout.credit_card.ccv};return result;}/**
 * @description update the reduction percentage
 * @param {float} val
 */function ckReduction(val){return{type:CK_UPDATE_REDUCTION,reduction:val};}function ckSendPromoCode(promo,contractId){return function(dispatch){dispatch({type:CK_LOADING_REDUCTION,val:true});Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["i" /* validateCoupon */])(contractId,promo).then(function(response){var obj=response.data;if(obj.STATUS==='SUCCESS'){if(typeof obj.redirect_to==='string'){window.onbeforeunload=null;window.location.href=obj.redirect_to;}dispatch(ckReduction(obj.reduction));var globalEvents={};globalEvents['Coupon code']=promo;__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].register(globalEvents);__WEBPACK_IMPORTED_MODULE_10__tracking_lpevents__["a" /* default */].track('Used coupon code',{});}else{dispatch(ckReduction(obj.MESSAGES[0]));}dispatch({type:CK_LOADING_REDUCTION,val:false});}).catch(function(){dispatch(ckReduction('Une erreur inconnue empêche la vérification de votre code'));dispatch({type:CK_LOADING_REDUCTION,val:false});});};}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATE_FIREBASE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_MAIL_FROM_FB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_MAIL_FROM_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_EXISTANT_IN_FIREBASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_FLAT_UI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDITED_DOCUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SHOW_CONTACT_US; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CARD_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_X3_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_PAYPAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_DIRECT_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_CREAT_ASSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SHOW_LOGIN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SHOW_SINGUP_MODAL; });
/* unused harmony export getFirebaseToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return updateMailFromInput; });
/* unused harmony export isDBExistant */
/* unused harmony export loadFlatUI */
/* unused harmony export loadOptions */
/* unused harmony export loadMail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return editedDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return showContactUs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setCardPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setX3Payment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setPaypalPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setDirectPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setCreatAssist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return showLoginModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return showSingupModal; });
/*
 * Project: LegalPlace assistant
 * File: src/redux/actions/account_settings.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var CREATE_FIREBASE_ID='LOAD_FIREBASE_ID_';var LOAD_MAIL_FROM_FB='LMFFB';var UPDATE_MAIL_FROM_INPUT='UMFI';var SET_EXISTANT_IN_FIREBASE='SEIF';var LOAD_FLAT_UI='LFUI';var LOAD_OPTIONS='LOFB';var EDITED_DOCUMENT='EDITED_DOCUMENT';var SHOW_CONTACT_US='SHOW_CONTACT_US';var SET_CARD_PAYMENT='SET_CARD_PAYMENT';var SET_X3_PAYMENT='SET_X3_PAYMENT';var SET_PAYPAL_PAYMENT='SET_PAYPAL_PAYMENT';var SET_DIRECT_PAYMENT='SET_DIRECT_PAYMENT';var SET_CREAT_ASSIST='SET_CREAT_ASSIST';var SHOW_LOGIN_MODAL='SHOW_LOGIN_MODAL';var SHOW_SINGUP_MODAL='SHOW_SINGUP_MODAL';function showContactUs(val){return{type:SHOW_CONTACT_US,val:val};}function editedDocument(val){return{type:EDITED_DOCUMENT,edited:val};}function getFirebaseToken(){return{type:CREATE_FIREBASE_ID};}function updateMailFromInput(val){return{type:UPDATE_MAIL_FROM_INPUT,value:val};}function isDBExistant(val){return{type:SET_EXISTANT_IN_FIREBASE,val:val};}function loadFlatUI(val){return{type:LOAD_FLAT_UI,val:val};}function loadOptions(val){return{type:LOAD_OPTIONS,val:val};}function loadMail(val){return{type:LOAD_MAIL_FROM_FB,val:val};}function setCardPayment(val){return{type:SET_CARD_PAYMENT,val:val};}function setX3Payment(val){return{type:SET_X3_PAYMENT,val:val};}function setPaypalPayment(val){return{type:SET_PAYPAL_PAYMENT,val:val};}function setDirectPayment(val){return{type:SET_DIRECT_PAYMENT,val:val};}function setCreatAssist(val){return{type:SET_CREAT_ASSIST,val:val};}function showLoginModal(val){return{type:SHOW_LOGIN_MODAL,val:val};}function showSingupModal(val){return{type:SHOW_SINGUP_MODAL,val:val};}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(276);
var toPrimitive = __webpack_require__(57);
var dP = Object.defineProperty;

exports.f = __webpack_require__(24) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var DOMProperty = __webpack_require__(105);
var ReactDOMComponentFlags = __webpack_require__(320);

var invariant = __webpack_require__(8);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(916)
var ieee754 = __webpack_require__(917)
var isArray = __webpack_require__(390)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(58);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsonlogic_parser__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsonlogic_applier__ = __webpack_require__(852);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Conditions EVO
 * Author: Moncef
 * ------
 * Todo:
 * - Lire toutes les conditions à l'initialization et assigné des id's a chacune
 * - Rajouter les hooks
 */var _ConditionsEvo=function(){function _ConditionsEvo(){_classCallCheck(this,_ConditionsEvo);this.compiledConditionsList={};this.parsedCompiledConditionsList={};this.hooks={options:{},variables:{}};this.multiples={};this.repeated_dependecies={};this.initiated=false;this.conditions={};this.repeated_options=[];this.parents_tree={options:{},variables:{}};}_createClass(_ConditionsEvo,[{key:'init',value:function init(){// Initializing conditions
this.initializeCompiledConditions();this.initializeHooks();this.initializeMultiples();this.initializeParentTree();this.parseCompiledConditions();this.initiated=true;}},{key:'execAllConditions',value:function execAllConditions(){var _this2=this;// Getting list of ids from the complied conditions object
var conditionsIds=Object.keys(this.compiledConditionsList);// Adding the list of ids from the conditions object (in order to add multiples)
Object.keys(this.conditions).forEach(function(id){if(!conditionsIds.includes(id))conditionsIds.push(id);});// Executing all conditions
conditionsIds.forEach(function(id){_this2.execCondition(id);},this);}/**
   *  INITIALIZERS BEGIN
   */// Initializes the compiledConditions object
},{key:'initializeCompiledConditions',value:function initializeCompiledConditions(){var _this3=this;Object.keys(__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.options).map(function(id){var option=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.getOption(id);if(option.meta.conditional){var compiledConditions=option.meta.compiledConditions;if((typeof compiledConditions==='undefined'?'undefined':_typeof(compiledConditions))=='object'&&compiledConditions.length>0)_this3.compiledConditionsList[id]=[].concat(_toConsumableArray(compiledConditions));}if(option.meta.multiple)_this3.multiples[id]=false;if(option.meta.multiple||option.meta.parentMultiple)_this3.repeated_options.push(parseInt(id));if(option.meta.type=='repeated'){var repeat_id=option.meta.repeatOption;if(!_this3.repeated_dependecies[repeat_id])_this3.repeated_dependecies[repeat_id]=[];var children=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].ops.utils.getAllChildren(id);_this3.repeated_options=[].concat(_toConsumableArray(_this3.repeated_options),[parseInt(id)],_toConsumableArray(children));_this3.repeated_dependecies[repeat_id]=[].concat(_toConsumableArray(_this3.repeated_dependecies[repeat_id]),[parseInt(id)],_toConsumableArray(children));}return option;},this);}// Parses all compiled conditions to JsonLogic
},{key:'parseCompiledConditions',value:function parseCompiledConditions(){var _this4=this;Object.keys(this.compiledConditionsList).map(function(id){try{_this4.parsedCompiledConditionsList[id]=new __WEBPACK_IMPORTED_MODULE_1__jsonlogic_parser__["a" /* default */](_this4.compiledConditionsList[id]);}catch(e){console.error(e);}},this);}// Intializes the hooks
},{key:'initializeHooks',value:function initializeHooks(){var _this5=this;var pushHook=function pushHook(idx,id){if('c'in idx){if(!idx.v){if(!_this5.hooks.options[idx.o])_this5.hooks.options[idx.o]=[];_this5.hooks.options[idx.o].push(id);}else{if(!_this5.hooks.variables[idx.v])_this5.hooks.variables[idx.v]=[];_this5.hooks.variables[idx.v].push(id);}}else if('condition_array'in idx){idx.condition_array.map(function(idx){pushHook(idx,id);});}};Object.keys(this.compiledConditionsList).map(function(id){var _c=_this5.compiledConditionsList[id];_c.map(function(idx){pushHook(idx,id);});},this);/*
     * Reverse dependencies
     */Object.keys(this.hooks.options).map(function(id){var parents_tree=[];var parent=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.grandpa.getFather(id);if(parent)parents_tree.push(parent);while(typeof parent!='undefined'){parent=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.grandpa.getFather(parent);if(parent)parents_tree.push(parent);}parents_tree.map(function(parent_id){if(_this5.compiledConditionsList[parent_id]){if(!_this5.hooks.options[parent_id])_this5.hooks.options[parent_id]=[];_this5.hooks.options[parent_id]=[].concat(_toConsumableArray(_this5.hooks.options[parent_id]),_toConsumableArray(_this5.hooks.options[id]));}});});}// Intializes the multiples
},{key:'initializeMultiples',value:function initializeMultiples(){var _this6=this;Object.keys(this.multiples).map(function(id){// Getting all children
var options=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].ops.utils.getAllChildren(id);var variables=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].ops.utils.getAllVariableChildren([id].concat(_toConsumableArray(options)));var compiledConditionsList=[];var hooks={options:[],variables:[]};options.map(function(cid){if(Object.keys(_this6.compiledConditionsList).includes(cid.toString()))compiledConditionsList.push(cid);if(Object.keys(_this6.hooks.options).includes(cid.toString()))hooks.options.push(parseInt(cid));},_this6);variables.map(function(vid){if(Object.keys(_this6.hooks.variables).includes(vid.toString()))hooks.variables.push(parseInt(vid));},_this6);if(_this6.hooks.options.hasOwnProperty(id.toString()))hooks.options=[].concat(_toConsumableArray(hooks.options),_toConsumableArray(_this6.hooks.options[id].map(function(v){return parseInt(v);})));if(_this6.hooks.variables.hasOwnProperty(id.toString()))hooks.variables=[].concat(_toConsumableArray(hooks.variables),_toConsumableArray(_this6.hooks.variables[id].map(function(v){return parseInt(v);})));if(compiledConditionsList.length==0&&hooks.options.length==0&&hooks.variables.length==0)return;// Repeat dependencies
if(_this6.repeated_dependecies[id])options=[].concat(_toConsumableArray(options),_toConsumableArray(_this6.repeated_dependecies[id]));_this6.multiples[id]={descendants:{options:options,variables:variables},copies:[],compiledConditionsList:compiledConditionsList,hooks:hooks};},this);for(var id in this.multiples){if(_typeof(this.multiples[id])!='object'){delete this.multiples[id];}}}// Initializes parent trees for all our options
},{key:'initializeParentTree',value:function initializeParentTree(){var _this7=this;Object.keys(this.hooks.options).map(function(id){var parents_tree=[];var parent=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.grandpa.getFather(id);if(parent)parents_tree.push(parent);while(typeof parent!='undefined'){parent=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.grandpa.getFather(parent);if(parent)parents_tree.push(parent);}_this7.parents_tree.options[id]=parents_tree;});Object.keys(this.hooks.variables).map(function(id){var parents_tree=[];var parent=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.grandpa_vars.getVGrandpa(id);if(parent)parents_tree.push(parent);while(typeof parent!='undefined'){parent=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.grandpa.getFather(parent);if(parent)parents_tree.push(parent);}_this7.parents_tree.variables[id]=parents_tree;});}/**
   * INITIALIZERS END
   *//**
   * MULTIPLES MANAGEMENT BEGIN
   */},{key:'setupMultipleWatchers',value:function setupMultipleWatchers(a,id){var _this8=this;// Waiting for initiation
if(!this.initiated)setTimeout(function(){_this8.setupMultipleWatchers.apply(_this8,[a,id]);},300);if(!this.multiples[id])return;var _this=this;// Must use this here since we can't override Array's this
a.push=function(){Array.prototype.push.apply(this,arguments);_this.multipleChangeReduce(id,[].concat(_toConsumableArray(this)));return this;};a.splice=function(){Array.prototype.splice.apply(this,arguments);_this.multipleChangeReduce(id,[].concat(_toConsumableArray(this)));return this;};a.split=function(){Array.prototype.split.apply(this,arguments);_this.multipleChangeReduce(id,[].concat(_toConsumableArray(this)));return this;};}},{key:'multipleChangeReduce',value:function multipleChangeReduce(id,_new){var _this9=this;if(!this.multiples[id])return;var toAdd=[];var toDelete=[];// Old copies
var _old=[].concat(_toConsumableArray(this.multiples[id].copies));if((typeof _new==='undefined'?'undefined':_typeof(_new))!='object'&&(typeof _old==='undefined'?'undefined':_typeof(_old))=='object'){toDelete=_old;}else{_new.map(function(copy){if(!_old.includes(copy))toAdd.push(copy);});_old.map(function(copy){if(!_new.includes(copy))toDelete.push(copy);});}toAdd.map(function(copy){return _this9.addMultiple(id,copy);},this);toDelete.map(function(copy){return _this9.delMultiple(id,copy);},this);}},{key:'addMultiple',value:function addMultiple(id,copy){var _this10=this;if(!this.multiples[id])return;// Adding parent himself
if(Object.keys(this.hooks.options).includes(id.toString())){this.hooks.options[id+'_'+copy]=this.hooks.options[id].map(function(hook_id){if(_this10.multiples[id].descendants.options.includes(parseInt(hook_id))){_this10.execCondition(hook_id,copy);hook_id+='_'+copy;}return hook_id;},this);}// Adding children
this.multiples[id].hooks.options.map(function(child_id){if(typeof _this10.hooks.options[child_id]==='undefined')return;_this10.hooks.options[child_id+'_'+copy]=_this10.hooks.options[child_id].map(function(hook_id){if(_this10.multiples[id].descendants.options.includes(parseInt(hook_id))){_this10.execCondition(hook_id,copy);hook_id+='_'+copy;}return hook_id;},_this10);});// Adding variables
this.multiples[id].hooks.variables.map(function(variable_id){if(typeof _this10.hooks.variables[variable_id]==='undefined')return;_this10.hooks.variables[variable_id+'_'+copy]=_this10.hooks.variables[variable_id].map(function(hook_id){if(_this10.multiples[id].descendants.options.includes(parseInt(hook_id))){_this10.execCondition(hook_id,copy);hook_id+='_'+copy;}return hook_id;},_this10);});// Adding copy
this.multiples[id].copies.push(copy);// Checking if is conditional
if(Object.keys(this.compiledConditionsList).includes(id.toString())){this.execCondition(id,copy);// Adding hooks
Object.keys(this.hooks.options).map(function(ho_id){if(_this10.hooks.options[ho_id].includes(id.toString()))_this10.hooks.options[ho_id].push(id+'_'+copy);});Object.keys(this.hooks.variables).map(function(ho_id){if(_this10.hooks.variables[ho_id].includes(id.toString()))_this10.hooks.variables[ho_id].push(id+'_'+copy);});}// Executing related conditions
this.multiples[id].compiledConditionsList.map(function(id){_this10.execCondition(id,copy);});// Triggering related conditions
this.execOptionHook(id);}},{key:'delMultiple',value:function delMultiple(id,copy){var _this11=this;if(!this.multiples[id])return;// Adding parent himself
if(Object.keys(this.hooks.options).includes(id.toString())){delete this.hooks.options[id+'_'+copy];}// Adding children
this.multiples[id].hooks.options.map(function(child_id){delete _this11.hooks.options[child_id+'_'+copy];});// Adding variables
this.multiples[id].hooks.variables.map(function(variable_id){delete _this11.hooks.variables[variable_id+'_'+copy];});// Deleting copy
var copy_index=this.multiples[id].copies.indexOf(copy);if(copy_index>-1)this.multiples[id].copies.splice(copy_index,1);// Deleting hooks
Object.keys(this.hooks.options).map(function(ho_id){if(_this11.hooks.options[ho_id].includes(id+'_'+copy))_this11.hooks.options[ho_id].splice(_this11.hooks.options[ho_id].indexOf(id+'_'+copy),1);});Object.keys(this.hooks.variables).map(function(ho_id){if(_this11.hooks.variables[ho_id].includes(id+'_'+copy))_this11.hooks.variables[ho_id].splice(_this11.hooks.variables[ho_id].indexOf(id+'_'+copy),1);});// Triggering related conditions
this.execOptionHook(id);}/**
   * MULTIPLES MANAGEMENT END
   *//**
   * CONDITIONS TREATEMENT
   */},{key:'execCondition',value:function execCondition(id){var copy=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;// Separating id and copy if we recieve it attached "id_copy"
if(typeof id==='string'){var parts=id.split('_');if(parts.length>1){id=parseInt(parts[0]);copy=parts[1];}}// Making sur option is conditionned before going any futher
if(!(id in this.parsedCompiledConditionsList))return true;// Getting copy
var _copy=copy===false?this.repeated_options.includes(parseInt(id))?copy:false:copy;// Initiating Applier
var jl_condition=new __WEBPACK_IMPORTED_MODULE_2__jsonlogic_applier__["a" /* default */](this.parsedCompiledConditionsList[id],_copy,id);// Executing condition
var result=jl_condition.apply();// Ref
var ref=copy!==false?id+'_'+copy:id;// Updating condition
this.updateCondition(ref,result);return result;}},{key:'updateCondition',value:function updateCondition(id,result){if(this.conditions[id]==result)return;this.conditions[id]=result;}},{key:'getCondition',value:function getCondition(id){return typeof this.conditions[id]!='undefined'?this.conditions[id]:this.execCondition(id);}},{key:'rawCondition',value:function rawCondition(condition){var copy=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;try{var parsed_condition=new __WEBPACK_IMPORTED_MODULE_1__jsonlogic_parser__["a" /* default */](condition);// Initiating Applier
var jl_condition=new __WEBPACK_IMPORTED_MODULE_2__jsonlogic_applier__["a" /* default */](parsed_condition,copy,id);return jl_condition.apply();}catch(e){console.error(e);}}/**
   * HOOKS EXECUTION
   */},{key:'execOptionHook',value:function execOptionHook(id){var _this12=this;if(!this.hooks.options[id])return;this.hooks.options[id].map(function(id){var rest=_this12.execCondition(id);_this12.execOptionHook(id);},this);}},{key:'execVariableHook',value:function execVariableHook(id){var _this13=this;if(!this.hooks.variables[id])return;this.hooks.variables[id].map(function(id){_this13.execCondition(id);},this);}}]);return _ConditionsEvo;}();var ConditionsEvo=new _ConditionsEvo();/* harmony default export */ __webpack_exports__["a"] = (ConditionsEvo);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(955).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(361)(module)))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOptionPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getVariablePass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lpIdGetPure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return lpIdGetCopy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_lp_app__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/*
* Project: LegalPlace assistant
* File: src/logic/global_getter.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// get the option
var optionDefaults={};function getOptionDefaults(){if(__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */]&&__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.options){Object.keys(__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.options).map(function(idx){var now=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.options[idx];optionDefaults[now.meta.default]=true;});}window.default_opts=optionDefaults;}// logger with color
function getOptionPass(id){if(Object.keys(optionDefaults).length===0)getOptionDefaults();var cId=id;if(typeof id==='string'){var _=id.split('_');var _ref=_slicedToArray(_,1);cId=_ref[0];}// if(typeof id == 'string')debugger;
if(typeof __WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.getOption(cId)==='undefined')return false;var optType=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.getOption(cId).meta.type;var theOptions=false;// the default phase
if(optType==='radio'){// default pass
if(optionDefaults[id]){theOptions=optionDefaults[id];}// ovc pass
if(__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.oF&&__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.oF[id]){theOptions=__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.oF[id];// check the string, or number
}else theOptions=false;}else if(optType==='checkbox'){if(__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.cF&&__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.cF[id]){theOptions=__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.cF[id];// check the string, or number
}else theOptions=false;}else if(optType==='static'||optType==='brut-text'){// console.log("detected text")
theOptions='NONE';}else if(optType==='hidden'){theOptions='NONE';}// if(typeof lpGetOptionById(id) != 'undefined'){
//     theOptions = lpGetOptionById(id).value;
//     // console.log("%c" + id + " : " + theOptions, "color: pink");
// }
return theOptions;}function getVariablePass(id){var theVariable='';var cId=id;if(typeof id==='string'){var _id$split=id.split('_');var _id$split2=_slicedToArray(_id$split,1);cId=_id$split2[0];}if(!__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.getVariable(cId))return'';if(__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.vF&&__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.vF[id]){theVariable=__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.vF[id];}return theVariable;}function lpIdGetPure(idx){if(typeof idx==='string')return parseInt(idx.split('_')[0],10);return idx;}function lpIdGetCopy(idx){if(typeof idx==='string'){var _=idx.split('_');if(_.length>1)return _[1];return-2;}return-2;}window.update_it=getOptionDefaults;getOptionDefaults();

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return lpPattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return P_CLOSE_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return P_SELECT_PACK_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return P_SELECT_PACK_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return P_SELECT_PACK_3; });
/* unused harmony export P_SELECT_PACK_4 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return P_ADD_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return P_REMOVE_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return P_ADD_LETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return P_REMOVE_LETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return P_CHANGE_LETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return P_UPDATE_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return P_CHECK_PREVIEW; });
/* unused harmony export P_TRYING_PROMO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return P_CHECK_PROMO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return P_CLOSE_PAIMENT; });
/* unused harmony export P_REQUEST_MODAL */
/* unused harmony export P_SUBSCRIBE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return P_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return P_BACK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logic_utils_encoding__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src\tracking\pattern_detector.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var PatternTracker=function(){function PatternTracker(){_classCallCheck(this,PatternTracker);var state=__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState();this.events=[];this.last_action='none';this.user_agent=navigator.userAgent;this.window_size={height:window.innerHeight,width:window.innerWidth};this.language=navigator.language;this.languages=navigator.languages;this.last_action_time=0;this.price_one=state.checkout_operations.prices.first_price;this.price_two=state.checkout_operations.prices.second_price;this.selected_price=state.checkout_operations.pack;this.base_time=new Date().getTime();}_createClass(PatternTracker,[{key:'init',value:function init(){var state=__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState();this.events=[];this.last_action='none';this.user_agent=navigator.userAgent;this.window_size={height:window.innerHeight,width:window.innerWidth};this.language=navigator.language;this.languages=navigator.languages;this.last_action_time=0;this.price_one=state.checkout_operations.prices.first_price;this.price_two=state.checkout_operations.prices.second_price;this.selected_price=state.checkout_operations.pack;this.base_time=new Date().getTime();}/**
     *
     * @param {string} id
     */},{key:'trackInPayment',value:function trackInPayment(id){var params={};// getting the last one
var keys=Object.keys(this.events);var t=void 0;if(keys.length==0)t=new Date().getTime()-this.base_time;else t=new Date().getTime()-this.base_time-keys[keys.length-1];t=Math.floor(t/100);params[t]=id;this.events.push(params);}},{key:'trackLastAction',value:function trackLastAction(id){var state=__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState();this.last_action=id;this.last_action_time=new Date().getTime();this.selected_price=state.checkout_operations.pack;}},{key:'encode',value:function encode(){var result='';this.events.map(function(idx){var key=Object.keys(idx)[0];result+=key+' '+idx[key]+',';});return Object(__WEBPACK_IMPORTED_MODULE_0__logic_utils_encoding__["b" /* b64EncodeUnicode */])(JSON.stringify(result));}/**
     *
     * @param {string} events
     */},{key:'decode',value:function decode(events){return JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_0__logic_utils_encoding__["a" /* b64DecodeUnicode */])(events));}},{key:'sendAndResetTracker',value:function sendAndResetTracker(){var params={};params.pattern={};var that=this;Object.keys(this).map(function(idx){if(idx=='events')params[idx]=that.encode();else{params[idx]=that[idx];}});__WEBPACK_IMPORTED_MODULE_1__lpevents__["a" /* default */].track('Checkout Pattern',params);this.init();}}]);return PatternTracker;}();var lpPattern=new PatternTracker();window.lpPattern=lpPattern;var P_CLOSE_PAYMENT=0;var P_SELECT_PACK_1=1;var P_SELECT_PACK_2=2;var P_SELECT_PACK_3=3;var P_SELECT_PACK_4=4;var P_ADD_CALL=3;var P_REMOVE_CALL=4;var P_ADD_LETTER=5;var P_REMOVE_LETTER=6;var P_CHANGE_LETTER=7;var P_UPDATE_ADDRESS=8;var P_CHECK_PREVIEW=9;var P_TRYING_PROMO=10;var P_CHECK_PROMO=11;var P_CLOSE_PAIMENT=12;var P_REQUEST_MODAL=13;var P_SUBSCRIBE=14;// last actions
var P_PAY=20;var P_BACK=19;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(779)();
}


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INIT_OUTPUT_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REM_OPTION_DUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REM_VARIABLE_DUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INIT_OUTPUT_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_OPTION_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EDIT_VARIABLE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EDIT_OPTION_RADIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REMOVE_FIRST_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REMOVE_FIRST_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return initOutputOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return initOutputVariable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return editOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return editVariable; });
/* unused harmony export checkRadio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return checkRadio1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return removeDuplicateFromOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return removeDuplicateFromVariables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return removeFirstOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return removeFirstVariable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_utils_tree_operations__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\output.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var INIT_OUTPUT_VARIABLE='INIT_OUTPUT_VARIABLE_';var INIT_OUTPUT_OPTION='INIT_OUTPUT_OPTION_';var EDIT_VARIABLE_VALUE='EDIT_VARIABLE_VALUE_';var EDIT_OPTION_VALUE='EDIT_OPTION_VALUE_';var EDIT_OPTION_RADIO='EDIT_OPTION_RADIO_';// rem_first
var REMOVE_FIRST_OPTION='REMOVE_FIRST';var REMOVE_FIRST_VARIABLE='REMOVE_FIRST_VARIABLE';// build actions
function initOutputVariable(id,key){var value=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return{type:INIT_OUTPUT_VARIABLE,id:id,key:key,value:value};}function initOutputOption(id,key){var val=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return{type:INIT_OUTPUT_OPTION,id:id,key:key,value:val};}function editVariable(id,value){return{type:EDIT_VARIABLE_VALUE,id:id,value:value};}function editOption(id,value){return{type:EDIT_OPTION_VALUE,id:id,value:value};}function checkRadio(key,value){return{type:EDIT_OPTION_RADIO,key:key,value:value};}function checkRadio1(id,parent){return function(dispatch){var copy=Object(__WEBPACK_IMPORTED_MODULE_0__logic_global_getter__["c" /* lpIdGetCopy */])(id);var parentCId=Object(__WEBPACK_IMPORTED_MODULE_0__logic_global_getter__["d" /* lpIdGetPure */])(parent);// get siblings
// debugger;
var _lpApp$references$get=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(parentCId),children=_lpApp$references$get.children;children=Object(__WEBPACK_IMPORTED_MODULE_1__logic_utils_tree_operations__["c" /* filterRadios */])(children);if(copy!==-2){children=children.map(function(idx){return idx+'_'+copy;});}// put them to all to false, except for the
children.forEach(function(idx){if(idx==id){dispatch(editOption(idx,true));}else{dispatch(editOption(idx,false));}});};}var REM_OPTION_DUP='REM_OPTION_DUP';var REM_VARIABLE_DUP='REM_VARIABLE_DUP';function removeDuplicateFromOption(id){return{type:REM_OPTION_DUP,id:id};}function removeDuplicateFromVariables(id){return{type:REM_VARIABLE_DUP,id:id};}// removing the first option
function removeFirstOption(firstCopy,id){return{type:REMOVE_FIRST_OPTION,firstCopy:firstCopy,id:id};}function removeFirstVariable(firstCopy,id){return{type:REMOVE_FIRST_VARIABLE,firstCopy:firstCopy,id:id};}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(41);
var has = __webpack_require__(44);
var SRC = __webpack_require__(83)('src');
var $toString = __webpack_require__(481);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(39).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var createDesc = __webpack_require__(84);
module.exports = __webpack_require__(24) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(10);
var defined = __webpack_require__(58);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Metadata; });
/* unused harmony export validateMetadata */
/* harmony export (immutable) */ __webpack_exports__["c"] = getExtPrefix;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCountryCallingCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSupportedCountry;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_semver_compare__ = __webpack_require__(880);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

 // Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".

var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata =
/*#__PURE__*/
function () {
  function Metadata(metadata) {
    _classCallCheck(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      this.selectNumberingPlan(null, callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();



var NumberingPlan =
/*#__PURE__*/
function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format =
/*#__PURE__*/
function () {
  function Format(format, metadata) {
    _classCallCheck(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()); // Previously, `FIRST_GROUP_ONLY_PREFIX_PATTERN` check was instead done via:
      // // Check that national prefix formatting rule is not a "dummy" one.
      // this.nationalPrefixFormattingRule() !== '$1' &&
      // // Check that national prefix formatting rule actually has national prefix digit(s).
      // // Filters out cases like "($1)".
      // // Is used in place of `libphonenumber`'s `FIRST_GROUP_ONLY_PREFIX_PATTERN_` regexp.
      // /\d/.test(this.nationalPrefixFormattingRule().replace('$1', ''))
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type =
/*#__PURE__*/
function () {
  function Type(type, metadata) {
    _classCallCheck(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return _typeof(_);
};
/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */


function getExtPrefix(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).ext();
  }

  return DEFAULT_EXT_PREFIX;
}
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  this.v1 = !metadata.version;
  this.v2 = metadata.version !== undefined && Object(__WEBPACK_IMPORTED_MODULE_0__tools_semver_compare__["a" /* default */])(metadata.version, V3) === -1;
  this.v3 = metadata.version !== undefined && Object(__WEBPACK_IMPORTED_MODULE_0__tools_semver_compare__["a" /* default */])(metadata.version, V4) === -1;
  this.v4 = metadata.version !== undefined; // && compare(metadata.version, V5) === -1
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }
//# sourceMappingURL=metadata.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(118);
var defined = __webpack_require__(58);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(44);
var toObject = __webpack_require__(28);
var IE_PROTO = __webpack_require__(183)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(119);
var createDesc = __webpack_require__(84);
var toIObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(57);
var has = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(276);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(24) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(383);
var isBuffer = __webpack_require__(898);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(30);
var minAssert = __webpack_require__(49);
var minUtils = __webpack_require__(416);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 51 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(37);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(10);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LP_STATE_WIZARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LP_STATE_CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LP_STATE_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LP_STATE_SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LP_STATE_PRE_WIZARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_STATE; });
/* unused harmony export BACK_STATE */
/* unused harmony export NEXT_STATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setAppState; });
/*
* Project: LegalPlace assistant
* File: src/redux/actions/app_state.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var LP_STATE_WIZARD=0;var LP_STATE_CHECKOUT=1;var LP_STATE_PAYMENT=2;var LP_STATE_SAVE=3;var LP_STATE_PRE_WIZARD=4;var SET_STATE='SET_STATE';var BACK_STATE='BACK_STATE';var NEXT_STATE='NEXT_STATE';function setAppState(appState){var ignoreHistory=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return{type:SET_STATE,state:appState,ignoreHistory:ignoreHistory};}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(39);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(53);
var IObject = __webpack_require__(118);
var toObject = __webpack_require__(28);
var toLength = __webpack_require__(20);
var asc = __webpack_require__(202);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(17);

var CallbackQueue = __webpack_require__(324);
var PooledClass = __webpack_require__(94);
var ReactFeatureFlags = __webpack_require__(325);
var ReactReconciler = __webpack_require__(106);
var Transaction = __webpack_require__(151);

var invariant = __webpack_require__(8);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HARCODED_CHECKOUT_META_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOM_CGV_LINK_PER_META_IDS; });
/* unused harmony export HARDCODED_FEES_PER_META_IDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HARDCODED_CONVERSION_VALUE_META_IDS; });
/* unused harmony export HARCODED_NEW_CALCUL_PRICE_CHECKOUT_META_IDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS; });
/*
* Hardcoded checkouts list:
* 197 -> SARL
* 124 -> SCI
* 162 -> Association
* 175 -> SAS
* 176 -> SASU
* 181 -> Auto-Entrepreneur
* 198 -> EURL
* 229 -> CSE moins de 20 employés
*/var HARCODED_CHECKOUT_META_IDS=[197,124,162,175,176,181,198,184,219,227,229,230,231,287,296,301,616,680];var CUSTOM_CGV_LINK_PER_META_IDS={229:'https://www.legalplace.fr/guides/wp-content/uploads/2019/09/CGV-LP-CSE.pdf'// This fees should be deduced from the tracking
};var HARDCODED_FEES_PER_META_IDS={136:54.42// used for bing, facebook, google Adwords
};var HARDCODED_CONVERSION_VALUE_META_IDS={2:16.58,// Bail commercial
80:16.58,// Bail précaire
75:16.58,// Bail professionnel
1:16.58,// Contrat de location vide
3:16.58,// Contrat de location meublée
11:16.58// Contrat de location saisonière
};var HARCODED_NEW_CALCUL_PRICE_CHECKOUT_META_IDS=[227,287,296,616];var HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS=[175,176,197,198];

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = raiseError;
/* harmony export (immutable) */ __webpack_exports__["c"] = unraiseError;
/* unused harmony export lpErrorType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LpError; });
/* unused harmony export lpSpecialError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_actions_lperrors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: errors/error.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var lpErrorType={GLOBAL:0,LOCAL:1,REPEATED:2};var error_logs={};var LpError=function(_Error){_inherits(LpError,_Error);function LpError(type,code,message){_classCallCheck(this,LpError);var _this=_possibleConstructorReturn(this,(LpError.__proto__||Object.getPrototypeOf(LpError)).call(this));_this.error_log_type=0;// global
_this.code=code;_this.message=message;_this.type=type;return _this;}return LpError;}(Error);var lpSpecialError=function(_LpError){_inherits(lpSpecialError,_LpError);function lpSpecialError(type,code,message,component){var id=arguments.length>4&&arguments[4]!==undefined?arguments[4]:-1;_classCallCheck(this,lpSpecialError);var _this2=_possibleConstructorReturn(this,(lpSpecialError.__proto__||Object.getPrototypeOf(lpSpecialError)).call(this,type,code,message));_this2.error_log_type=1;// local
_this2.component_type=component;_this2.component_id=id;return _this2;}return lpSpecialError;}(LpError);/**
 *
 * @param {LpError} error
 */function pushErrorLog(error){error_logs[Date.now()]=error;}function getErrors(){return error_logs;}window.errors_list=getErrors;function raiseError(component,code,message){__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].logs.log(component,message);if(component==='global')__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_lperrors__["c" /* lpSetError */])(new LpError(0,code,message)));else __WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_lperrors__["c" /* lpSetError */])(new lpSpecialError(0,code,message,component)));}function unraiseError(component){__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_actions_lperrors__["d" /* lpUnsetError */])(component));}window.raiseError=raiseError;window.unraiseError=unraiseError;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(49);
var inherits = __webpack_require__(7);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*
* Project: LegalPlace assistant
* File: src/components/misc/helper.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var LpHelper=function LpHelper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"wz-helper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{dangerouslySetInnerHTML:{__html:props.text}}));};/* harmony default export */ __webpack_exports__["a"] = (LpHelper);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(24)) {
  var LIBRARY = __webpack_require__(74);
  var global = __webpack_require__(9);
  var fails = __webpack_require__(10);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(146);
  var $buffer = __webpack_require__(209);
  var ctx = __webpack_require__(53);
  var anInstance = __webpack_require__(89);
  var propertyDesc = __webpack_require__(84);
  var hide = __webpack_require__(41);
  var redefineAll = __webpack_require__(88);
  var toInteger = __webpack_require__(52);
  var toLength = __webpack_require__(20);
  var toIndex = __webpack_require__(304);
  var toAbsoluteIndex = __webpack_require__(87);
  var toPrimitive = __webpack_require__(57);
  var has = __webpack_require__(44);
  var classof = __webpack_require__(99);
  var isObject = __webpack_require__(12);
  var toObject = __webpack_require__(28);
  var isArrayIter = __webpack_require__(189);
  var create = __webpack_require__(85);
  var getPrototypeOf = __webpack_require__(46);
  var gOPN = __webpack_require__(93).f;
  var getIterFn = __webpack_require__(190);
  var uid = __webpack_require__(83);
  var wks = __webpack_require__(19);
  var createArrayMethod = __webpack_require__(60);
  var createArrayIncludes = __webpack_require__(137);
  var speciesConstructor = __webpack_require__(121);
  var ArrayIterators = __webpack_require__(187);
  var Iterators = __webpack_require__(100);
  var $iterDetect = __webpack_require__(139);
  var setSpecies = __webpack_require__(91);
  var arrayFill = __webpack_require__(203);
  var arrayCopyWithin = __webpack_require__(297);
  var $DP = __webpack_require__(25);
  var $GOPD = __webpack_require__(47);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(188);
var $export = __webpack_require__(0);
var shared = __webpack_require__(117)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(302))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var PooledClass = __webpack_require__(94);

var emptyFunction = __webpack_require__(61);
var warning = __webpack_require__(14);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(778);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(784);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(345);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(785);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(787);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(789);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(793);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(797);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(798);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IC_SET_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IC_SET_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return icSetOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return icSetVariable; });
/*
* Project: LegalPlace assistant
* File: src/redux/actions/input_context.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var IC_SET_OPTION='IC_SET_OPTION';var IC_SET_VARIABLE='IC_SET_VARIABLE';function icSetOption(id){return{type:IC_SET_OPTION,optionid:id};}function icSetVariable(id){return{type:IC_SET_VARIABLE,varid:id};}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_re_index__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/misc/warning.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var _LpWarning=function(_Component){_inherits(_LpWarning,_Component);function _LpWarning(props){_classCallCheck(this,_LpWarning);var _this=_possibleConstructorReturn(this,(_LpWarning.__proto__||Object.getPrototypeOf(_LpWarning)).call(this,props));_this.is_hidden=true;return _this;}_createClass(_LpWarning,[{key:'componentDidMount',value:function componentDidMount(){var me=void 0;if(this.props.type==='v')me=Object(__WEBPACK_IMPORTED_MODULE_2__logic_re_index__["h" /* lpGetVariableById */])(this.props.id);else me=Object(__WEBPACK_IMPORTED_MODULE_2__logic_re_index__["g" /* lpGetOptionById */])(this.props.id);// debugger;
if(me){this.is_hidden=!me.value;if(this.props.type==='v')this.is_hidden=false;// if(this.props.id == 243)debugger;
this.forceUpdate();}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){var me=void 0;if(this.props.type==='v')me=Object(__WEBPACK_IMPORTED_MODULE_2__logic_re_index__["h" /* lpGetVariableById */])(this.props.id);else me=Object(__WEBPACK_IMPORTED_MODULE_2__logic_re_index__["g" /* lpGetOptionById */])(nextProps.id);if(me){this.is_hidden=!me.value;if(this.props.type==='v')this.is_hidden=false;}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infobox','data-type':'warning',style:{display:this.is_hidden?'none':'block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:this.props.text}}));}}]);return _LpWarning;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(){return{};};var mapDispatchToProps=function mapDispatchToProps(){return{};};var LpWarning=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_LpWarning);/* harmony default export */ __webpack_exports__["a"] = (LpWarning);

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(19)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(41)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(83)('meta');
var isObject = __webpack_require__(12);
var has = __webpack_require__(44);
var setDesc = __webpack_require__(25).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(10)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOT_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WIZARD_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WIZARD_UNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRICE_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRICE_UNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_CHECKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_CHECKING_PAYMENT; });
/* harmony export (immutable) */ __webpack_exports__["l"] = setChecking;
/* harmony export (immutable) */ __webpack_exports__["k"] = loadingWizard;
/* harmony export (immutable) */ __webpack_exports__["n"] = unloadingWizard;
/* harmony export (immutable) */ __webpack_exports__["j"] = loadingPricing;
/* harmony export (immutable) */ __webpack_exports__["m"] = unloadingPricing;
/* harmony export (immutable) */ __webpack_exports__["i"] = checkingPayment;
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\loading.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var IS_LOADING='IS_LOADING';var NOT_LOADING='NOT_LOADING';var WIZARD_LOAD='WIZARD_LOADING';var WIZARD_UNLOAD='WIZARD_UNLOADING';var PRICE_LOAD='PRICE_LOADING';var PRICE_UNLOAD='PRICE_UNLOADING';var IS_CHECKING='IS_CHECKING';var IS_CHECKING_PAYMENT='IS_CHECKING_PAYMENT';function setChecking(val){return{type:IS_CHECKING,is_checking:val};}function setLoadingState(is_loading){if(!is_loading){return{type:NOT_LOADING};}return{type:IS_LOADING};}function loadingWizard(){return{type:WIZARD_LOAD};}function unloadingWizard(){return{type:WIZARD_UNLOAD};}function loadingPricing(){return{type:PRICE_LOAD};}function unloadingPricing(){return{type:PRICE_UNLOAD};}function checkingPayment(is_checking){return{type:IS_CHECKING_PAYMENT,is_checking:is_checking};}/* unused harmony default export */ var _unused_webpack_default_export = (setLoadingState);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_history__ = __webpack_require__(234);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
* Project: LegalPlace assistant
* File: src/logic/history.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// manipulating history
// assert that every step we save the actuial the state.
// The titles are predefined * - LegalPlace
// douments: Statut SASU - Modèle de status SASU rédigé par des avocats - LegalPlace ->
// definition of the links and titles
var LinkState=function(){function LinkState(title,link){_classCallCheck(this,LinkState);this.title=title;this.link=link;}_createClass(LinkState,[{key:'getTitle',value:function getTitle(){return this.title;}},{key:'getLink',value:function getLink(){return this.link;}}]);return LinkState;}();var LinkContract=function(_LinkState){_inherits(LinkContract,_LinkState);function LinkContract(section){_classCallCheck(this,LinkContract);var _this=_possibleConstructorReturn(this,(LinkContract.__proto__||Object.getPrototypeOf(LinkContract)).call(this,'Création de votre document - LegalPlace','/contrats/'+window.contractName+'/creer/'+(section+1)));console.log("section ===>",section);return _this;}return LinkContract;}(LinkState);var LinkContractContinue=function(_LinkState2){_inherits(LinkContractContinue,_LinkState2);function LinkContractContinue(id,section){_classCallCheck(this,LinkContractContinue);return _possibleConstructorReturn(this,(LinkContractContinue.__proto__||Object.getPrototypeOf(LinkContractContinue)).call(this,'Création de votre document - LegalPlace','/contrats/'+window.contractName+'/continuer/'+id+'/'+(section+1)));}return LinkContractContinue;}(LinkState);var LinkContractPayment=function(_LinkState3){_inherits(LinkContractPayment,_LinkState3);function LinkContractPayment(id){_classCallCheck(this,LinkContractPayment);return _possibleConstructorReturn(this,(LinkContractPayment.__proto__||Object.getPrototypeOf(LinkContractPayment)).call(this,'Création de votre document - LegalPlace','/contrats/'+window.contractName+'/'+id+'/paiement'));}return LinkContractPayment;}(LinkState);var LinkContractExpertComptable=function(_LinkState4){_inherits(LinkContractExpertComptable,_LinkState4);function LinkContractExpertComptable(id){_classCallCheck(this,LinkContractExpertComptable);return _possibleConstructorReturn(this,(LinkContractExpertComptable.__proto__||Object.getPrototypeOf(LinkContractExpertComptable)).call(this,'Création de votre document - LegalPlace','/contrats/'+window.contractName+'/'+id+'/expert-comptable'));}return LinkContractExpertComptable;}(LinkState);var LinkContractContinuePayment=function(_LinkState5){_inherits(LinkContractContinuePayment,_LinkState5);function LinkContractContinuePayment(id){_classCallCheck(this,LinkContractContinuePayment);return _possibleConstructorReturn(this,(LinkContractContinuePayment.__proto__||Object.getPrototypeOf(LinkContractContinuePayment)).call(this,'Création de votre document - LegalPlace','/contrats/'+window.contractName+'/'+id+'/paiement'));}return LinkContractContinuePayment;}(LinkState);var LinkContractPaymentCheckout=function(_LinkState6){_inherits(LinkContractPaymentCheckout,_LinkState6);function LinkContractPaymentCheckout(id){_classCallCheck(this,LinkContractPaymentCheckout);return _possibleConstructorReturn(this,(LinkContractPaymentCheckout.__proto__||Object.getPrototypeOf(LinkContractPaymentCheckout)).call(this,'Création de votre document - LegalPlace','/contrats/'+window.contractName+'/'+id+'/checkout'));}return LinkContractPaymentCheckout;}(LinkState);// The model of our state is: type: (new|continue), docid: (if continue), section: nbr
function getStateByHref(href){var data=href.split('/');// let contrcats = data[1];
// let name = data[2];
var type=data[1];var arg1=data[2];//
var result={continue:false,doc_id:'',section:-1};if(type==='continuer'){var arg2=data[3];result.continue=true;result.doc_id=arg1;result.section=arg2;}else{result.continue=false;result.section=arg1;}return result;}// changes are in section-id
function writeHistory(state,cont,section){var id=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var link=void 0;if(cont){if(state==='payment'){link=new LinkContractContinuePayment(id);}else if(state==='checkout'){link=new LinkContractPaymentCheckout(id);}else{link=new LinkContractContinue(id,section);}}else if(state==='payment'){link=new LinkContractPayment(id);}else if(state==='expert-comptable'){link=new LinkContractExpertComptable(id);}else if(state==='checkout'){link=new LinkContractPaymentCheckout(id);}else{link=new LinkContract(section);}// cons ole.log(link)
// setup the push
if(window.lpApp&&window.lpApp.isPrerender)return;__WEBPACK_IMPORTED_MODULE_2__utils_history__["a" /* default */].history.push(link.getLink());// window.history.pushState({ store: { section, app_state: state === 'payment' ? 1 : 0 }, s_id: store.getState().contract.currentSection }, link.getTitle(), link.getLink());
document.title=link.getTitle();// cons ole.log(link)
// setup the push
if(window.lpApp&&window.lpApp.is_prerender)return;if(!__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].mutex.checkMutex('links'))return;// window.history.pushState({store: {section: section, app_state: state == 'payment' ? 1 : 0 }, s_id: store.getState().contract.current_section}, link.getTitle(), link.getLink());
document.title=link.getTitle();}window.writeHistory=writeHistory;window.detectHistory=getStateByHref;// TODO: Every single action must write history
// setup the thing
/* harmony default export */ __webpack_exports__["a"] = (writeHistory);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MIN_LENGTH_FOR_NSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_LENGTH_FOR_NSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_LENGTH_COUNTRY_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VALID_DIGITS; });
/* unused harmony export WHITESPACE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALID_PUNCTUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PLUS_CHARS; });
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
//# sourceMappingURL=constants.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(5).Buffer
var Transform = __webpack_require__(111).Transform
var StringDecoder = __webpack_require__(251).StringDecoder
var inherits = __webpack_require__(7)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 83 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(6);
var dPs = __webpack_require__(277);
var enumBugKeys = __webpack_require__(184);
var IE_PROTO = __webpack_require__(183)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(179)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(185).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(278);
var enumBugKeys = __webpack_require__(184);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(52);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(40);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(53);
var call = __webpack_require__(281);
var isArrayIter = __webpack_require__(189);
var anObject = __webpack_require__(6);
var toLength = __webpack_require__(20);
var getIterFn = __webpack_require__(190);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var dP = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(24);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(278);
var hiddenKeys = __webpack_require__(184).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(783);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INIT_CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SECTION_ID; });
/* unused harmony export SET_FULL_WIDTH */
/* unused harmony export REPRISE_WIZARD */
/* unused harmony export REPRISE_LINK */
/* unused harmony export SET_IS_FINISHED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REDIRECT_TO_SECTION; });
/* harmony export (immutable) */ __webpack_exports__["j"] = setSection;
/* harmony export (immutable) */ __webpack_exports__["e"] = redirectToSection;
/* harmony export (immutable) */ __webpack_exports__["f"] = setFullWidth;
/* harmony export (immutable) */ __webpack_exports__["h"] = setRepriseLink;
/* harmony export (immutable) */ __webpack_exports__["i"] = setRepriseWizard;
/* harmony export (immutable) */ __webpack_exports__["g"] = setIsFinished;
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\contract.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var CREATE_CONTRACT='CREATE_CONTRACT';var INIT_CONTRACT='INIT_CONTRACT';// load section 0
var SET_SECTION_ID='SET_SECTION_ID';var SET_FULL_WIDTH='SET_FULL_WIDTH';var REPRISE_WIZARD='REPRISE_WIZARD';var REPRISE_LINK='REPRISE_LINK';var SET_IS_FINISHED="SET_IS_FINISHED";var REDIRECT_TO_SECTION="REDIRECT_TO_SECTION";function setSection(id,isaNav){return{type:SET_SECTION_ID,id:id>0?id:0,isaNav:isaNav};}function redirectToSection(s_id){return{type:REDIRECT_TO_SECTION,s_id:s_id};}function setFullWidth(val){return{type:SET_FULL_WIDTH,val:val};}function setRepriseLink(val){return{type:REPRISE_LINK,val:val};}function setRepriseWizard(val){return{type:REPRISE_WIZARD,val:val};}function setIsFinished(val){return{type:SET_IS_FINISHED,val:val};}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cookies__ = __webpack_require__(875);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Cookies__["a" /* default */]);


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(167);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(130));
util.inherits = __webpack_require__(7);
/*</replacement>*/

var Readable = __webpack_require__(392);
var Writable = __webpack_require__(250);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(51);
var TAG = __webpack_require__(19)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(25).f;
var has = __webpack_require__(44);
var TAG = __webpack_require__(19)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(58);
var fails = __webpack_require__(10);
var spaces = __webpack_require__(195);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var ReactBaseClasses = __webpack_require__(313);
var ReactChildren = __webpack_require__(682);
var ReactDOMFactories = __webpack_require__(687);
var ReactElement = __webpack_require__(104);
var ReactPropTypes = __webpack_require__(688);
var ReactVersion = __webpack_require__(692);

var createReactClass = __webpack_require__(693);
var onlyChild = __webpack_require__(695);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var ReactCurrentOwner = __webpack_require__(69);

var warning = __webpack_require__(14);
var canDefineProperty = __webpack_require__(315);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(316);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(704);
var ReactInstrumentation = __webpack_require__(55);

var warning = __webpack_require__(14);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(218);
var setInnerHTML = __webpack_require__(153);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(219);
var setTextContent = __webpack_require__(329);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseLink=void 0;var environment="production";if(environment==='development'){// Used by the CI for now do not commit changes
baseLink="https://test.legalplace.eu";}else{baseLink="";}// }
/* harmony default export */ __webpack_exports__["a"] = (baseLink);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARCHITECTURE; });
/* unused harmony export CONTRACT_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OPTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MULTIPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VARIABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return META; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RENDERER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HELPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ISCONDITIONAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FSIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MULTIPLE_PARENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return VARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHILDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return OptionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SOptionType; });
/* harmony export (immutable) */ __webpack_exports__["s"] = detectType;
/*
 * Project: LegalPlace assistant
 * File: src\logic\lp_map_utils.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var ARCHITECTURE='contract_architecture';var CONTRACT_NAME='contract_name';var SECTIONS='sections';// ---------------IN SINGLE SECTION------------------------
var LABEL='label';var OPTS='options';var MULTIPLE='multiple';// -------------------------------------------------------
var VARIABLES='variables_wrapper';var OPTIONS='options_wrapper';// ------------------ OPTIONS IN OPTIONWRAPPERS -----------
var META='meta';var TYPE='type';// LABEL extits
var RENDERER='outputRender';var HELPER='helper';var ISCONDITIONAL='conditional';// ---- FOR THE Varibale wrapper
var FSIZE='phsize';var MULTIPLE_PARENTS='parentMultiple';var VARS='variables';var CHILDS='children';// ------------------ INPUTS TYPES ------------------------
var OptionType={NONE:69,HIDDEN:0,TEXT:1,RADIO:2,CHECKBOX:3,STATIC:4,DATE:5,LIST:6,TEXTAREA:7,PURE:8,REPEATED:9,EVAL:10,NUMBER:11,BASICMASK:12,ADVANCEDMASK:13,HOUR:14,EMAIL:15};var SOptionType=OptionType;function detectType(t_text){switch(t_text){case'text':return SOptionType.TEXT;case'radio':return SOptionType.RADIO;case'hidden':return SOptionType.HIDDEN;case'checkbox':return SOptionType.CHECKBOX;case'static':return SOptionType.STATIC;case'date':return SOptionType.DATE;case'list':return SOptionType.LIST;case'textarea':return SOptionType.TEXTAREA;case'brut-text':return SOptionType.PURE;case'repeated':return SOptionType.REPEATED;case'eval':return SOptionType.EVAL;case'number':return SOptionType.NUMBER;case'mask':return SOptionType.BASICMASK;case'mask':return SOptionType.BASICMASK;case'advancedmask':return SOptionType.ADVANCEDMASK;case'hour':return SOptionType.HOUR;case'email':return SOptionType.EMAIL;default:return SOptionType.NONE;}}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(872);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(873);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(248).EventEmitter;
var inherits = __webpack_require__(7);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(249);
Stream.Writable = __webpack_require__(926);
Stream.Duplex = __webpack_require__(927);
Stream.Transform = __webpack_require__(928);
Stream.PassThrough = __webpack_require__(929);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(5).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(31)))

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(5).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_PREVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_POPOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_POPOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return togglePreview; });
/* unused harmony export showPopover */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hidePopover; });
/*
* Project: LegalPlace assistant
* File: src/redux/actions/toggle_preview.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var TOGGLE_PREVIEW='LP_TOGGLE_PREVIEW';var SHOW_POPOVER='SHOW_POPOVER';var HIDE_POPOVER='HIDE_POPOVER';function togglePreview(){return{type:TOGGLE_PREVIEW};}function showPopover(){return{type:SHOW_POPOVER};}function hidePopover(){return{type:HIDE_POPOVER};}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview_row__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/popup_preview.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// idout, template
var PopupPreview=function(_Component){_inherits(PopupPreview,_Component);function PopupPreview(props){_classCallCheck(this,PopupPreview);// console.log("Pcreated preview");
var _this=_possibleConstructorReturn(this,(PopupPreview.__proto__||Object.getPrototypeOf(PopupPreview)).call(this,props));_this.state={};return _this;}_createClass(PopupPreview,[{key:'componentDidMount',value:function componentDidMount(){var varM=document.querySelectorAll('.popupViewer [data-var-id=\''+this.props.variable+'\']');var popM=document.querySelectorAll('.popupViewer .page');// console.log(popM)
if(varM&&this.refs.popup&&this.refs.changeThings&&varM.length>0){// var_.
// if(var_.getBoundingClientRect().y)
var keysVarM=Object.keys(varM);keysVarM.forEach(function(keyVar){/** @type {Element} */var variable=varM[keyVar];if(variable.offsetTop>(window.oo?window.oo:120)){// console.log(this.refs.changeThings)
popM[keyVar].setAttribute('style','margin-top: -'+(variable.offsetTop-40)+'px');}if(variable.offsetTop<10){// console.log(this.refs.changeThings)
// console.log("oups")
popM[keyVar].setAttribute('style','margin-top: '+(variable.offsetTop+40)+'px');}},this);// console.log(this.refs.popup.getBoundingClientRect())
}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].action_tracker.last_action==='EDIT_VARIABLE_VALUE_'&&nextProps.state_must_not_update){if(nextProps.var_val!==nextProps.variable)return false;var value='';if(Object(__WEBPACK_IMPORTED_MODULE_3__logic_re_index__["h" /* lpGetVariableById */])(nextProps.variable))value='<span class=\'doc-highlight\'>'+Object(__WEBPACK_IMPORTED_MODULE_3__logic_re_index__["h" /* lpGetVariableById */])(nextProps.variable).value.replace(/<br>/g,'\n').replace(/</g,'&lt;').replace(/\n/g,'<br>')+'</span>';if(document.querySelector('.popupContent [data-var-id=\''+nextProps.variable+'\']')){var _edits=document.querySelectorAll('.popupContent [data-var-id=\''+nextProps.variable+'\']');// .forEach(idx => idx.innerHTML = value)
var _editsLen=_edits.length;for(var i=0;i<_editsLen;i+=1){_edits[i].innerHTML=value;}}// document.querySelectorAll(".lp-doc [data-var-id='" + nextProps.variable + "']");
var edits=document.querySelectorAll('.lp-doc [data-var-id=\''+nextProps.variable+'\']');var editsLen=edits.length;for(var _i=0;_i<editsLen;_i+=1){edits[_i].innerHTML=value;}return false;}return true;}},{key:'componentDidUpdate',value:function componentDidUpdate(){// hgere we do the thing.
// console.log(this.props.variable)
// .map(idx => idx.attributes["data-var-id"])
if(!this.refs.popup)return;// let vars = document.getElementsByClassName("popupViewer");
// console.log(this.props.list)
var list=[];var thisPopup=this.refs.popup.getBoundingClientRect().y||this.refs.popup.getBoundingClientRect().top;var spanNodes=this.refs.popup.querySelectorAll('.page > div > span');for(var i=0;i<spanNodes.length;i+=1){var BoundingClientRect=spanNodes[i].getBoundingClientRect();list.push(BoundingClientRect.y||BoundingClientRect.top);}var distanceCropped=Math.min.apply(Math,_toConsumableArray(list.map(function(idx){return idx-thisPopup;})));if(this.refs.changeThings){if(this.refs.changeThings.querySelector('[data-var-id=\''+this.props.variable+'\']')){/** @type {Element} */var variable=this.refs.changeThings.querySelector('[data-var-id=\''+this.props.variable+'\']');var page=this.refs.changeThings;//
if(page){if(variable.offsetTop>120){page.setAttribute('style','margin-top: -'+(distanceCropped+variable.offsetTop-window.lfoug)+'px');}else if(variable.offsetTop<0){page.setAttribute('style','margin-top: '+(distanceCropped+variable.offsetTop+window.lfoug)+'px');}}}else{// console.log("l")
}}var nbrSys={};// this one must change
var numbers=document.querySelectorAll('.popupPreviewContainer [num-auto], .popupPreviewContainer [num-auto-pre]');// get the numbering system
// console.log(numbers);
for(var _i2=0;_i2<numbers.length;_i2+=1){var v=numbers[_i2];if(v&&v.attributes&&v.attributes.getNamedItem('num-auto')){nbrSys[v.attributes.getNamedItem('num-auto').value]=0;}else{nbrSys[v.attributes.getNamedItem('num-auto-pre').value]=0;}}Object.keys(numbers).forEach(function(idx){var element=numbers[idx];if(element&&element.attributes&&element.attributes.getNamedItem('num-auto')){var counter=element.attributes.getNamedItem('num-auto').value;nbrSys[counter]+=1;element.innerHTML=nbrSys[counter];// test if it's an article
if(counter==='articles'){// init all them
Object.keys(nbrSys).forEach(function(index){if(index!=='articles')nbrSys[index]=0;});}}else if(element&&element.attributes){var _counter=element.attributes.getNamedItem('num-auto-pre').value;element.innerHTML=nbrSys[_counter];}});}},{key:'render',value:function render(){return!this.props.fullWidth&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'none'},className:'popupPreviewContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popupPreview',ref:'poop'},// (this.props.isShown) &&
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popupViewer',ref:'popup',key:Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["b" /* generateId1 */])(4)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popupContent'},(this.props.var_val&&this.props.var_val===this.props.variable||typeof this.props.var_val==='undefined')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'changeThings',className:'page'},!__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].env.is_mobile&&this.props.isShown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.list.map(function(idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__preview_row__["a" /* default */],{key:Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["b" /* generateId1 */])(4),idOut:idx[1],out:idx[0],am_popup:true});})))))));}}]);return PopupPreview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){var viewId='';var isShown=false;var hide=state.contract.fullWidth;if(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].action_tracker.last_action==='EDIT_VARIABLE_VALUE_'||state.input_context.variable!==ownProps.var_val){return{state_must_not_update:true,idOption:state.input_context.option,variable:state.input_context.variable,value:Object(__WEBPACK_IMPORTED_MODULE_3__logic_re_index__["h" /* lpGetVariableById */])(state.input_context.variable)};}var lst=[];if(state.input_context.variable!==''){var vid=state.input_context.variable;if(state.input_context.variable===ownProps.var_val){lst=__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].ops.content.getOutputFroPreview(vid);}if(lst.length>0)isShown=true;}// this line i for debugging
// console.log([the_before, the_output, the_next])
// console.log([the_before, the_output, the_next])
return{template:viewId,idOption:state.input_context.option,isShown:isShown,variable:state.input_context.variable,list:lst,fullWidth:hide};};var LpPopupPreview=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(PopupPreview);/* unused harmony default export */ var _unused_webpack_default_export = (LpPopupPreview);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(39);
var global = __webpack_require__(9);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(74) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(51);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(6);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(37);
var SPECIES = __webpack_require__(19)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(124);
var EventPluginUtils = __webpack_require__(212);

var accumulateInto = __webpack_require__(321);
var forEachAccumulated = __webpack_require__(322);
var warning = __webpack_require__(14);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var EventPluginRegistry = __webpack_require__(211);
var EventPluginUtils = __webpack_require__(212);
var ReactErrorUtils = __webpack_require__(213);

var accumulateInto = __webpack_require__(321);
var forEachAccumulated = __webpack_require__(322);
var invariant = __webpack_require__(8);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(70);

var getEventTarget = __webpack_require__(214);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LP_ERROR_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LP_ERROR_UNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return lpSetError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lpUnsetError; });
/* unused harmony export unsetAfterXSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__(11);
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\lperrors.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LP_ERROR_SET='LP_ERROR_SET';var LP_ERROR_UNSET='LP_ERROR_UNSET';/**
 * @description raise the error.
 * @param {LpError} error
 */function lpSetError(error){return{type:LP_ERROR_SET,error:error};}/**
 * @description remove the error
 */function lpUnsetError(component){return{type:LP_ERROR_UNSET,component:component};}function unsetAfterXSeconds(secs){var dispatch=__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].dispatch;setTimeout(function(){dispatch(lpUnsetError());},secs*1000);}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchesEntirely;
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeArrays;
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */

function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b)
  // {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getNumberType;
/* unused harmony export is_of_type */
/* harmony export (immutable) */ __webpack_exports__["a"] = checkNumberLengthForType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(128);


var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (is_of_type(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // v1 metadata.
    // Legacy.
    // Deprecated.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (is_of_type(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
    var _type = _NON_FIXED_LINE_PHONE[_i];

    if (is_of_type(nationalNumber, _type, metadata)) {
      return _type;
    }
  }
}
function is_of_type(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(nationalNumber, type.pattern());
} // Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* mergeArrays */])(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths)
      // {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // }
      // else
      // {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
      return 'INVALID_LENGTH';
    }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=getNumberType_.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(7)
var MD5 = __webpack_require__(252)
var RIPEMD160 = __webpack_require__(253)
var sha = __webpack_require__(254)
var Base = __webpack_require__(82)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var assert = __webpack_require__(49);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(30);

asn1.define = __webpack_require__(980).define;
asn1.base = __webpack_require__(135);
asn1.constants = __webpack_require__(422);
asn1.decoders = __webpack_require__(985);
asn1.encoders = __webpack_require__(987);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(982).Reporter;
base.DecoderBuffer = __webpack_require__(421).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(421).EncoderBuffer;
base.Node = __webpack_require__(983);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(52);
var defined = __webpack_require__(58);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(45);
var toLength = __webpack_require__(20);
var toAbsoluteIndex = __webpack_require__(87);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(40);
var redefineAll = __webpack_require__(88);
var meta = __webpack_require__(76);
var forOf = __webpack_require__(90);
var anInstance = __webpack_require__(89);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(10);
var $iterDetect = __webpack_require__(139);
var setToStringTag = __webpack_require__(101);
var inheritIfRequired = __webpack_require__(191);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(19)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(51);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(12);
var cof = __webpack_require__(51);
var MATCH = __webpack_require__(19)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(99);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(298);
var redefine = __webpack_require__(40);
var hide = __webpack_require__(41);
var fails = __webpack_require__(10);
var defined = __webpack_require__(58);
var wks = __webpack_require__(19);
var regexpExec = __webpack_require__(204);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(41);
var uid = __webpack_require__(83);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(74) || !__webpack_require__(10)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(9)[K];
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(37);
var ctx = __webpack_require__(53);
var forOf = __webpack_require__(90);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(125);
var ViewportMetrics = __webpack_require__(328);

var getEventModifierState = __webpack_require__(216);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(38);
var DOMNamespaces = __webpack_require__(218);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(219);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var EventPluginRegistry = __webpack_require__(211);
var ReactEventEmitterMixin = __webpack_require__(725);
var ViewportMetrics = __webpack_require__(328);

var getVendorPrefixedEventName = __webpack_require__(726);
var isEventSupported = __webpack_require__(215);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_preview_render_angular_reader__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_lp_app__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/preview_row.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var _PreviewRow=function(_Component){_inherits(_PreviewRow,_Component);function _PreviewRow(props){_classCallCheck(this,_PreviewRow);// Getting all variable childs
// Getting father
var _this=_possibleConstructorReturn(this,(_PreviewRow.__proto__||Object.getPrototypeOf(_PreviewRow)).call(this,props));_this.updateNumbers=function(){if(_this.props.lastView===true)_this.props.updateNumbers();};var parentId=__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].indexes.grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_5__logic_global_getter__["d" /* lpIdGetPure */])(props.idOut));if(parentId&&__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(parentId).meta.type==='repeated'){var repeatOptionId=__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(parentId).meta.repeatOption;var children=__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].ops.utils.getAllChildren(repeatOptionId);var variables=__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].ops.utils.getAllVariableChildren(children);_this.view=new __WEBPACK_IMPORTED_MODULE_2__logic_preview_render_angular_reader__["a" /* default */](props.idOut,props.template,-1,variables);}else{_this.view=new __WEBPACK_IMPORTED_MODULE_2__logic_preview_render_angular_reader__["a" /* default */](props.idOut,props.template);}_this.data=[];// console.log(props.template);
// console.log(this.view.id)
_this.view.compile();// this.rData = [];
// console.log(this.view.variables);
return _this;}_createClass(_PreviewRow,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;this.my_key=Object(__WEBPACK_IMPORTED_MODULE_3__utils_misc__["b" /* generateId1 */])(4);this.rData=this.view.variables.map(function(idx){return _this2.props.getValue(idx);});this.strings={__html:this.view.draw(this.rData)};if(this.props.am_popup){this.view=new __WEBPACK_IMPORTED_MODULE_2__logic_preview_render_angular_reader__["a" /* default */](this.props.idOut,this.props.template,this.props.var_to_hover);this.view.compile();}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){var _this3=this;var newString=JSON.stringify(this.view.variables.map(function(idx){return _this3.props.getValue(idx);}));if(newString===this.oldString){this.updateNumbers();return false;}else{this.oldString=newString;return true;}}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.updateNumbers();}},{key:'render',value:function render(){var _this4=this;// console.time("render")
this.rData=this.view.variables.map(function(idx){return _this4.props.getValue(idx);});// console.log(this.props.idOut, this.view.raw.search(/justify/g))
this.view.compiled=this.view.compiled.replace(/text-align:justify/g,'');var strs={__html:this.view.draw(this.rData)};var result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{ref:'doc_row'},/* this.props.condition && */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-id':this.props.idOut,className:'preview-row',dangerouslySetInnerHTML:strs}));// console.timeEnd("render")
return result;}}]);return _PreviewRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){var pText=state.views[ownProps.out];var conditionShow=true;var cId=ownProps.idOut;if(typeof cId==='string'){var _cId$split=cId.split('_');var _cId$split2=_slicedToArray(_cId$split,1);cId=_cId$split2[0];}var a=Object(__WEBPACK_IMPORTED_MODULE_4__logic_re_index__["g" /* lpGetOptionById */])(ownProps.idOut);if(typeof a==='undefined'){// test
if(state.document_state.state==='continue'){if(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId)&&__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='checkbox'){a={value:state.loadedOvc&&state.loadedOvc.cF&&state.loadedOvc.cF[ownProps.idOut]?state.loadedOvc.cF[ownProps.idOut]:!(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='radio'||__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='checkbox')};}else{a={value:state.loadedOvc&&state.loadedOvc.oF&&state.loadedOvc.oF[ownProps.idOut]?state.loadedOvc.oF[ownProps.idOut]:!(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='radio'||__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='checkbox')};}}}if(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId)&&(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='radio'||__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='checkbox')){if(typeof a==='undefined')a=false;else a=a.value;}else{a=true;}// a = true;
return{condition:conditionShow&&a,template:pText,var_to_hover:state.input_context.variable,v:state.input_context.variable,getValue:function getValue(id){var result='';if(typeof Object(__WEBPACK_IMPORTED_MODULE_4__logic_re_index__["h" /* lpGetVariableById */])(id)!=='undefined'){var _lpGetVariableById=Object(__WEBPACK_IMPORTED_MODULE_4__logic_re_index__["h" /* lpGetVariableById */])(id),value=_lpGetVariableById.value;// let value = toString(lpGetVariableById(id).value);
result=value.replace(/<br>/g,'\n').replace(/</g,'&lt;').replace(/\n/g,'<br>');}else{// TODO: test the continue foirst
result=state.loadedOvc&&state.loadedOvc.vF?state.loadedOvc.vF[id]:'';}return result;}};};var PreviewRow=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(_PreviewRow);/* harmony default export */ __webpack_exports__["a"] = (PreviewRow);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initializeCounters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return raiseOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return raiseVariable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEditedVariables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEditedOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_lp_app__ = __webpack_require__(2);
/*
* Project: LegalPlace assistant
* File: src/logic/action_counter.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*//** @type {Object} */var VariableActions={};/** @type {Object} */var OptionActions={};function initializeCounters(){VariableActions={};OptionActions={};}/**
 * Fired when we edit an option, so we can log the option as selected
 * @param {string|number} id
 */function raiseOption(id){if(typeof OptionActions[id]==='undefined'){if((Object.keys(OptionActions).length+1)%4===0){var event={};event['Options mod four']=(Object.keys(OptionActions).length+1)/4;event['Contract name']=window.contractName;__WEBPACK_IMPORTED_MODULE_0__tracking_lpevents__["a" /* default */].track('Edited Options',event);}}OptionActions[id]=true;window._os=OptionActions;}/**
 * Fired when a variable is edited, so we can log it as EDITED
 * @param {string|number} id
 */function raiseVariable(id){if(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].mutex.checkMutex('preview')){if(typeof VariableActions[id]==='undefined'){if((Object.keys(VariableActions).length+1)%4===0){var event={};event['Variables mod four']=(Object.keys(VariableActions).length+1)/4;event['Contract name']=window.contractName;__WEBPACK_IMPORTED_MODULE_0__tracking_lpevents__["a" /* default */].track('Edited variables',event);}}}VariableActions[id]=true;window._vs=VariableActions;}/**
 * Get the number of edited variables on the document, including the ones loaded from the OVC.
 */function getEditedVariables(){// updating if there is a variable or an option in there
var vF=__WEBPACK_IMPORTED_MODULE_1__globals__["b" /* store */].getState().loadedOvc.vF;var vFKeys=typeof vF==='undefined'?[]:Object.keys(vF);vFKeys.map(function(idx){if(vF[idx]!=='')VariableActions[idx]=true;});if(typeof VariableActions==='undefined')return 0;return Object.keys(VariableActions).length;}/**
 * Get the number of edited options, radios or checkbox, including the options loaded from OVC
 */function getEditedOptions(){var oF=__WEBPACK_IMPORTED_MODULE_1__globals__["b" /* store */].getState().loadedOvc.oF;var cF=__WEBPACK_IMPORTED_MODULE_1__globals__["b" /* store */].getState().loadedOvc.cF;var oFKeys=typeof oF==='undefined'?[]:Object.keys(oF);var cFKeys=typeof cF==='undefined'?[]:Object.keys(cF);oFKeys.map(function(idx){if(oF[idx]&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_2__global_getter__["d" /* lpIdGetPure */])(idx))&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_2__global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='radio')OptionActions[idx]=true;});cFKeys.map(function(idx){if(cF[idx]&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_2__global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='checkbox')OptionActions[idx]=true;});if(typeof OptionActions==='undefined')return 0;return Object.keys(OptionActions).length;}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_FULL_WIDTH */
/* harmony export (immutable) */ __webpack_exports__["a"] = caluclateConditionDependecies;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMaa;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAndInitPrerender;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAndInitContract;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAndInitCheckout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__document_state__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loading__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__load_ovc__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lperrors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__contract__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_whatwg_fetch__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logic_autosave__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_subscription_constant__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__manager_apiManager__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__logic_condition_evo__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__reducers_contract__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_universal_cookie__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jsonwebtoken__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_jsonwebtoken__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/*
 * Project: LegalPlace assistant
 * File: src/redux/actions/load_contract.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// loading axios library
// import { axios } from 'axios';
// get the load contract actuion logic
// this is used if we could'nt use any URL
// import { preview_1 } from '../../logic/test/previewData';
// import { contract_json } from '../../logic/test/sas';
// import { contract } from '../../logic/test/contrat_de_travail';
var cookies=new __WEBPACK_IMPORTED_MODULE_20_universal_cookie__["a" /* default */]();var SET_FULL_WIDTH='SET_FULL_WIDTH';// load usig axios
// Copied from web
function isJson(str){try{JSON.parse(str);}catch(e){return false;}return true;}var lpAllTree={};var lpAllIndexVar={};function lpExplore(id,babies){if(babies){babies.forEach(function(idx){lpAllTree[idx]=id;// get children
var me=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(idx);if(me.children&&me.children.length>0){lpExplore(idx,me.children);}});}}function lpExploreSections(){if(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.options&&Object.keys(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.options).length>0){Object.keys(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.options).forEach(function(idx){var now=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(idx);lpExplore(parseInt(idx,10),now.children);// explore variables
if(now.variables){now.variables.forEach(function(jdx){lpAllIndexVar[jdx]=parseInt(idx,10);});}});}// Object.keys(sections).map((idx) => {
//     lpExplore(-1 * parseInt(idx) ,sections[idx].options)
// });
}function fetchAndInitContractWithOVC(contractPermalink,uniqid,dispatch,getState){var _this=this;var callback=arguments.length>4&&arguments[4]!==undefined?arguments[4]:function(){};var isCheckout=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;dispatch({type:'IS_LOADING'});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["k" /* loadingWizard */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["j" /* loadingPricing */])());Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["e" /* getContractAndOVC */])(contractPermalink,uniqid).then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var contract,abCookie,order,isLoggedIn,decodedToken,role,isNotAuthorised,hasQuizzStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:contract=response.data;// To redirect to wizardx if instance
if(contract.appType==="wizardx"&&!isCheckout){abCookie=cookies.get('X-Source');if(abCookie&&abCookie.split('/').length>1&&abCookie.split('/')[1]==='wizard'){cookies.set('X-Source',abCookie.split('/')[0]+'/wizardxs/wizard-lp',{path:'/',encode:function encode(value){return value;}});window.onbeforeunload=function(){};document.location.reload(true);}}__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].mutex.setMutex('links',false);// tell everyone that the document is not empty
dispatch({type:'NO_EMPTY'});// extract the preview indexes
dispatch({type:'PREVIEW_INDEX_',val:contract.views_wrapper});__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addViewsRefernce(contract.views_wrapper);if(contract.contract_architecture.params&&contract.contract_architecture.params.varsExtraction){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addSlackNotification(contract.contract_architecture.params.varsExtraction);}__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addCustomizationsReference(contract.model_params);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setSubscription(contract.model_params.enable_subscription);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setIsPaidSession(contract.is_paid_session);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setType(contract.type,contract.contract_meta_id);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setPayed(contract.is_paid);if(!__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].isPayed){_context.next=22;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["f" /* getContractOrder */])(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].contractUniqid).then(function(response){return response.data?response.data.order:response.data;});case 15:order=_context.sent;isLoggedIn=!!cookies.get('token');decodedToken=__WEBPACK_IMPORTED_MODULE_21_jsonwebtoken___default.a.decode(cookies.get('token'))||{};role=decodedToken.role;isNotAuthorised=!isLoggedIn||role==='GUEST';hasQuizzStatus=['analyzing','valid'].includes(order.quizz_status);if(isNotAuthorised&&hasQuizzStatus){window.onbeforeunload=null;window.onunload=null;window.location.href="https://formalites.legalplace.eu"+'/download/'+__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].contractUniqid;}case 22:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setContractMetaId(contract.contract_meta_id).then(function(){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setContractUniqid(uniqid);dispatch({type:__WEBPACK_IMPORTED_MODULE_2__document_state__["d" /* SET_DOCUMENT_ID */],doc:uniqid});__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setDisableIntro(contract.data_intro?contract.data_intro==='disabled':false);if(contract.support_phone){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setSupportPhone(contract.support_phone.txt);}// ======================================================
// FIXME: construct a better one here
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.docs_wrappers=contract.docs_wrapper;if(!isCheckout){dispatch({type:'CREATE_CONTRACT',contract:contract});for(var i=0;i<getState().contract.total_sections;i+=1){window.lp[i]=false;}// finish the loading phase
lpExploreSections();// window.lp_grandpa = lpAllTree;
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.updateGrandpa(lpAllTree);// window.lp_var_gran = lpAllIndexVar;
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.grandpa_vars.buildGrandpaVariables(lpAllIndexVar);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addMandatpryOptions(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.options);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addMandatoryVariables(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.variables);// Initiating ConditionsEvo right after loading model
__WEBPACK_IMPORTED_MODULE_18__logic_condition_evo__["a" /* default */].init();// Updating sections conditions after initiating ConditionsEvo
Object(__WEBPACK_IMPORTED_MODULE_19__reducers_contract__["b" /* updateSectionsIfConditions */])();// do initializatio  of static texts into the preview component
// dispatch(initOutPut())
if(contract.contract_architecture&&contract.contract_architecture.params&&contract.contract_architecture.params.fullWidth){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__contract__["f" /* setFullWidth */])(contract.contract_architecture.params.fullWidth));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setFullWidth(contract.contract_architecture.params.fullWidth);}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__contract__["f" /* setFullWidth */])(false));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setFullWidth(false);}if(contract.contract_architecture.is_two_steps){// dispatch(setFullWidth(true))
// lpApp.setFullWidth(true);
}else if(contract.contract_architecture&&contract.contract_architecture.params&&contract.contract_architecture.params.fullWidth){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__contract__["f" /* setFullWidth */])(contract.contract_architecture.params.fullWidth));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setFullWidth(contract.contract_architecture.params.fullWidth);}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__contract__["f" /* setFullWidth */])(false));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setFullWidth(false);}// I don't know why I put this here wallah
// dispatch({type: 'NO_EMPTY'});
caluclateConditionDependecies();__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.updateDependencies();Object(__WEBPACK_IMPORTED_MODULE_13__logic_re_index__["m" /* reorderViews */])(getState().views);// initialize the whole thing
window.lp={};window.addEventListener('beforeunload',__WEBPACK_IMPORTED_MODULE_12__logic_autosave__["a" /* autosave */]);// let url = new URL(window.location.href);
var autosaveParam=function(){// $_GET JS
var $_GET_PARTS=window.location.search.substr(1).split('&');var $_GET={};for(var _i=0;_i<$_GET_PARTS.length;_i+=1){var temp=$_GET_PARTS[_i].split('=');$_GET[decodeURIComponent(temp[0])]=decodeURIComponent(temp[1]);}if($_GET.autosaved)return true;return null;}();// Checking autosave
var autosaveOVC=Object(__WEBPACK_IMPORTED_MODULE_12__logic_autosave__["b" /* checkAutosave */])();if(window.contract_id!==''||__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].continuity&&__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].continuity.continue){if(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].isPrerender){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__load_ovc__["c" /* loadOVC */])(contract.ovc));}else if(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].continuity.continue)dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__load_ovc__["c" /* loadOVC */])(contract.ovc));else dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__load_ovc__["c" /* loadOVC */])(contract.ovc));dispatch({type:'SET_SECTION_ID',id:0});var currentEvent={};currentEvent['Document version:']=getState().contract.version;__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].register({Contract:getState().contract.name});__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].track('Continue contract',currentEvent);}else if(!Object(__WEBPACK_IMPORTED_MODULE_1_util__["isNull"])(autosaveParam)&&autosaveOVC!==false){window.autosave=!!autosaveOVC;// autosave check
dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__load_ovc__["b" /* autosaveLoadOVC */])(autosaveOVC.data));var sectionId=autosaveOVC.info.section-1;dispatch({type:'SET_SECTION_ID',id:sectionId});__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].mutex.setMutex('links',true);}else{var _currentEvent={'LpApp':'React'};_currentEvent['Document version:']=getState().contract.version;__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].register({Contract:getState().contract.name});__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].track('Create new contract',_currentEvent);dispatch({type:'NOT_LOADING'});dispatch({type:'SET_SECTION_ID',id:0});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["n" /* unloadingWizard */])());__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].mutex.setMutex('links',true);}// Executing All Conditions right after all data is set
__WEBPACK_IMPORTED_MODULE_18__logic_condition_evo__["a" /* default */].execAllConditions();}dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["m" /* unloadingPricing */])());__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].trackGTMFunnel(window.location.pathname);callback();});case 23:case'end':return _context.stop();}}},_callee,_this);}));return function(_x3){return _ref.apply(this,arguments);};}()).catch(function(error){console.error('Error while loading contract',error);});}function fetchAndInitContract(contractPermalink,dispatch,getState){// starting the loading phase
dispatch({type:'IS_LOADING'});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["k" /* loadingWizard */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["j" /* loadingPricing */])());Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["d" /* getContract */])(contractPermalink)// Success of the request
.then(function(response){var contract=response.data;__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].mutex.setMutex('links',false);// tell everyone that the document is not empty
dispatch({type:'NO_EMPTY'});// extract the preview indexes
dispatch({type:'PREVIEW_INDEX_',val:contract.views_wrapper});__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addViewsRefernce(contract.views_wrapper);if(contract.contract_architecture.params&&contract.contract_architecture.params.varsExtraction){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addSlackNotification(contract.contract_architecture.params.varsExtraction);}__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addCustomizationsReference(contract.model_params);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setSubscription(contract.model_params.enable_subscription);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setIsPaidSession(contract.is_paid_session);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setType(contract.type,contract.contract_meta_id);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setContractMetaId(contract.contract_meta_id).then(function(){if(contract.contract_uniqid){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setContractUniqid(contract.contract_uniqid);}__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setDisableIntro(contract.data_intro?contract.data_intro==='disabled':false);if(contract.support_phone){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setSupportPhone(contract.support_phone.txt);}// ======================================================
// FIXME: construct a better one here
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.docs_wrappers=contract.docs_wrapper;// create the contract object
dispatch({type:'CREATE_CONTRACT',contract:contract});// Initiating ConditionsEvo right after loading model
__WEBPACK_IMPORTED_MODULE_18__logic_condition_evo__["a" /* default */].init();// Updating sections conditions after initiating ConditionsEvo
Object(__WEBPACK_IMPORTED_MODULE_19__reducers_contract__["b" /* updateSectionsIfConditions */])();// do initializatio  of static texts into the preview component
// dispatch(initOutPut())
if(contract.contract_architecture&&contract.contract_architecture.params&&contract.contract_architecture.params.fullWidth){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__contract__["f" /* setFullWidth */])(contract.contract_architecture.params.fullWidth));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setFullWidth(contract.contract_architecture.params.fullWidth);}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__contract__["f" /* setFullWidth */])(false));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setFullWidth(false);}if(contract.contract_architecture.is_two_steps){// dispatch(setFullWidth(true))
// lpApp.setFullWidth(true);
}else if(contract.contract_architecture&&contract.contract_architecture.params&&contract.contract_architecture.params.fullWidth){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__contract__["f" /* setFullWidth */])(contract.contract_architecture.params.fullWidth));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setFullWidth(contract.contract_architecture.params.fullWidth);}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__contract__["f" /* setFullWidth */])(false));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setFullWidth(false);}// I don't know why I put this here wallah
// dispatch({type: 'NO_EMPTY'});
caluclateConditionDependecies();__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.updateDependencies();Object(__WEBPACK_IMPORTED_MODULE_13__logic_re_index__["m" /* reorderViews */])(getState().views);// initialize the whole thing
window.lp={};for(var i=0;i<getState().contract.total_sections;i+=1){window.lp[i]=false;}// finish the loading phase
lpExploreSections();// window.lp_grandpa = lpAllTree;
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.updateGrandpa(lpAllTree);// window.lp_var_gran = lpAllIndexVar;
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.grandpa_vars.buildGrandpaVariables(lpAllIndexVar);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addMandatpryOptions(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.options);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addMandatoryVariables(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.variables);window.addEventListener('beforeunload',__WEBPACK_IMPORTED_MODULE_12__logic_autosave__["a" /* autosave */]);// let url = new URL(window.location.href);
var autosaveParam=function(){// $_GET JS
var $_GET_PARTS=window.location.search.substr(1).split('&');var $_GET={};for(var _i2=0;_i2<$_GET_PARTS.length;_i2+=1){var temp=$_GET_PARTS[_i2].split('=');$_GET[decodeURIComponent(temp[0])]=decodeURIComponent(temp[1]);}if($_GET.autosaved)return true;return null;}();// Checking autosave
var autosaveOVC=Object(__WEBPACK_IMPORTED_MODULE_12__logic_autosave__["b" /* checkAutosave */])();if(window.contract_id!==''||__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].continuity&&__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].continuity.continue){dispatch({type:'SET_SECTION_ID',id:0});var currentEvent={};currentEvent['Document version:']=getState().contract.version;__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].register({Contract:getState().contract.name});__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].track('Continue contract',currentEvent);}else if(!Object(__WEBPACK_IMPORTED_MODULE_1_util__["isNull"])(autosaveParam)&&autosaveOVC!==false){window.autosave=!!autosaveOVC;// autosave check
dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__load_ovc__["b" /* autosaveLoadOVC */])(autosaveOVC.data));var sectionId=autosaveOVC.info.section-1;dispatch({type:'SET_SECTION_ID',id:sectionId});__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].mutex.setMutex('links',true);}else{var _currentEvent2={'LpApp':'React'};_currentEvent2['Document version:']=getState().contract.version;__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].register({Contract:getState().contract.name});__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].track('Create new contract',_currentEvent2);dispatch({type:'NOT_LOADING'});dispatch({type:'SET_SECTION_ID',id:0});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["n" /* unloadingWizard */])());__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].mutex.setMutex('links',true);}// Executing All Conditions right after all data is set
__WEBPACK_IMPORTED_MODULE_18__logic_condition_evo__["a" /* default */].execAllConditions();dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["m" /* unloadingPricing */])());__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].trackGTMCheckoutStep(1,'Questionnaire',getState().contract);// Load first funnel event
__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].trackGTMFunnel(window.location.pathname);// set the current section to 0
});}).catch(function(error){console.error(error);// the same thing, but with telling everyone what is the error
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].logs.log(error.name,error.message);dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_5__errors_error__["a" /* LpError */](0,1,Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('Problèmes de connexion, veuillez recharger la page'))));});lpExploreSections();// window.lp_grandpa = lpAllTree;
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.updateGrandpa(lpAllTree);};var getPricesAndFees=function getPricesAndFees(checkoutInformations,prices,fees){Object.keys(checkoutInformations).map(function(pack){prices[pack]=checkoutInformations[pack];fees[pack]=0;if(_typeof(checkoutInformations[pack])==='object'&&typeof checkoutInformations[pack].price!=='undefined'){prices[pack]=checkoutInformations[pack].price;if(checkoutInformations[pack].fees&&checkoutInformations[pack].fees.length){checkoutInformations[pack].fees.forEach(function(feesElement){fees[pack]+=feesElement.price||0;});}}});};function fetchAndInitCheckout(contractPermalink,uniqid,dispatch,getState){fetchAndInitContractWithOVC(contractPermalink,uniqid,dispatch,getState,function(){// starting the loading phase
dispatch({type:'IS_LOADING'});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["k" /* loadingWizard */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["j" /* loadingPricing */])());Object(__WEBPACK_IMPORTED_MODULE_16__manager_apiManager__["c" /* getCheckout */])(contractPermalink,uniqid)// Success of the request
.then(function(response){var contract=response.data;if(contract.is_paid){if(contract.redirectTo)window.location.href=contract.redirectTo;else window.location.href='/contrats/'+contractPermalink+'/continuer/'+uniqid+'/1';}if(contract.model_params)__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setSubscription(contract.model_params.enable_subscription);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setIsPaidSession(contract.is_paid_session);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setType(contract.type,contract.contract_meta_id);if(contract.model_params)__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addCustomizationsReference(contract.model_params);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setNewCustomer(contract.newCustomer);// create the contract object
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setContractMetaId(contract.contract_meta_id).then(function(){if(contract.contract_uniqid){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setContractUniqid(uniqid);}if(contract&&contract.checkoutInformations){var showSubscribeOffer=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].subscription||!__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].paidSession&&__WEBPACK_IMPORTED_MODULE_15__constants_subscription_constant__["a" /* AVAILABLE_SUBSCRIPTION_CONTRACT_META_ID */].indexOf(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].contractMetaId)>-1;if(contract.contract_architecture)dispatch({type:'CREATE_CONTRACT',contract:contract});// prices
var prices={};var fees={};getPricesAndFees(contract.checkoutInformations,prices,fees);if(showSubscribeOffer){prices.second_price=0.0;}//fees
dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__actions_checkout_operations__["E" /* buildCheckout */])(contract.user_id,uniqid,contract.contract_meta_id,prices,fees,'Conditional',contract.checkoutInformations));__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setPayed(contract.is_paid);}__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setDisableIntro(contract.data_intro?contract.data_intro==='disabled':false);if(contract.support_phone){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setSupportPhone(contract.support_phone.txt);}// ======================================================
// FIXME: construct a better one here
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.docs_wrappers=contract.docs_wrapper;__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.addCustomizationsReference(contract.model_params);dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__account_settings__["x" /* updateMailFromInput */])(contract.user_email));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__loading__["m" /* unloadingPricing */])());__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.slack.generateSendinBlue('Variable Extraction');// set the current section to 0
__WEBPACK_IMPORTED_MODULE_7__tracking_lpevents__["a" /* default */].trackGTMFunnel(window.location.pathname);});}).catch(function(error){console.error(error);// the same thing, but with telling everyone what is the error
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].logs.log(error.name,error.message);dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_5__errors_error__["a" /* LpError */](0,1,Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('Problèmes de connexion, veuillez recharger la page'))));});lpExploreSections();// window.lp_grandpa = lpAllTree;
__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.updateGrandpa(lpAllTree);},true);};// load condition dependecies
var dependeciesTable={};function caluclateConditionDependecies(){if(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.options){var allKeys=Object.keys(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.options);allKeys.forEach(function(idx){var now=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(idx);// debugger;
if(now.meta.conditional){now.meta.conditions.forEach(function(jdx){if(idx.o){if(typeof dependeciesTable[jdx.o]==='undefined'){dependeciesTable[jdx.o]=[now.meta.id];}else{dependeciesTable[jdx.o].push(now.meta.id);}}});}});}}function getMaa(v){return lpAllTree[v];}function getAndInitPrerender(uniqid){return function(dispatch,getState){var docIndex='';if(typeof __WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].prerenderDoc==='number'&&!Number.isNaN(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].prerenderDoc))docIndex='&doc='+__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].prerenderDoc;var lnk='/private_jsons/prerender/?'+(typeof uniqid==='string'&&uniqid!==''?'for='+uniqid:'')+docIndex;fetchAndInitContract(lnk,dispatch,getState);};}function getAndInitContract(contractName){var uniqid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;localStorage.setItem('URL_ENTREE',window.document.referrer);if(uniqid){__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setContractUniqid(uniqid);return function(dispatch,getState){fetchAndInitContractWithOVC(contractName,uniqid,dispatch,getState);};}return function(dispatch,getState){fetchAndInitContract(contractName,dispatch,getState);};}function getAndInitCheckout(contractName,uniqid){return function(dispatch,getState){fetchAndInitCheckout(contractName,uniqid,dispatch,getState);};}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NEW_DOCUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTINUE_DOCUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_CONTRACT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_DOCUMENT_ID; });
/* unused harmony export newDocument */
/* unused harmony export continueDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setContractName; });
/* unused harmony export setUserId */
/* unused harmony export setDocumentId */
/*
* Project: LegalPlace assistant
* File: src/redux/actions/document_state.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// document_state (new | continue)
// contract id
// user-id
// continue-id uniqid
var NEW_DOCUMENT='NEW_DOCUMENT';var CONTINUE_DOCUMENT='CONTINUE_DOCUMENT';var SET_CONTRACT_NAME='SET_CONTRACT_NAME';var SET_USER_ID='SET_USER_ID';var SET_DOCUMENT_ID='SET_DOCUMENT_ID';function newDocument(){return{type:NEW_DOCUMENT};}function continueDocument(docid){return{type:CONTINUE_DOCUMENT,id:docid};}function setContractName(name){return{type:SET_CONTRACT_NAME,name:name};}function setUserId(uid){return{type:SET_USER_ID,id:uid};}function setDocumentId(uid){return{type:SET_DOCUMENT_ID,doc:uid};}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConditionRuntime; });
/* unused harmony export loadNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_reducers_load_ovc__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__condition_evo__ = __webpack_require__(29);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
* Project: LegalPlace assistant
* File: src/logic/condition_tree.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// This is a condition runtime environment,
// AST tree technique
// a basic token is [variable, option] who is compiled/not , got from the OVC array
/**
 * Token class, can save a terminal, (variable, option) and his values [hasMany, selected]
 */var LpToken=function(){function LpToken(id,type){var parent=arguments.length>2&&arguments[2]!==undefined?arguments[2]:-1;_classCallCheck(this,LpToken);this.id=id;this.type=type;this.parent=parent;this.value=null;this.hasMany=false;this.compiled=false;}// the token is multiple
_createClass(LpToken,[{key:'setMany',value:function setMany(val){this.hasMany=val;this.compiled=true;}// the token is true or false
},{key:'setValue',value:function setValue(val){this.value=val;this.compiled=true;}},{key:'clone',value:function clone(){var result=new LpToken(this.id,this.type,this.parent);// we do this by hands
result.value=this.value;result.hasMany=this.hasMany;result.compiled=this.compiled;return result;}}]);return LpToken;}();// the condition tree's node
/**
 * The AST tree is a positioning of every single node in compiled condition
 * The Node may contain a single token, or many, and children
 *
 *          o:2
 *          / \
 *         /   \
 *       o:4  o:5
 *        |     |\ \
 *        |     | \  \
 *        v:1  v2  v3  o8
 *                      | \
 *                      v9 v1
 *
 * So we compile conditions to put em in such tree
 */var AstNode=function(){function AstNode(leaf){_classCallCheck(this,AstNode);this.children=[];this.is_leaf=leaf;this.id=-1;this.parent=-1;this.type='none';// an operation is the state, has-many/has-one/selected/not-selected
this.operation='none';// this provides the relationship between this node and the siblings
this.rel='none';}// initialize token as leaf (end of tree)
_createClass(AstNode,[{key:'initLeaf',value:function initLeaf(id,parent,type,operation){var rel=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'none';var additionalValue=arguments.length>5&&arguments[5]!==undefined?arguments[5]:'';this.is_leaf=true;this.id=id;this.parent=parent;this.type=type;this.operation=operation;this.rel=rel;this.additionalValue=additionalValue;}// add children to this node
},{key:'addChild',value:function addChild(child){this.children.push(child);}},{key:'forceIsShown',value:function forceIsShown(optId){var isVar=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var skipSelf=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var _this=this;var debug=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var isAtleast=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;// console.time("isShown")
if(optId===-1)return true;if(isAtleast){var copies=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.ovc.multipleFirst(optId));if(copies){var siblings=copies.map(function(idx){return Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(optId)+'_'+idx;});siblings.push(optId);return siblings.map(function(idx){return _this.forceIsShown(idx,isVar,skipSelf,debug,false);},this).reduce(function(a,b){return a||b;});}}var opt=isVar?__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getVariable(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(optId)):__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(optId));if(!opt){// debugger;
return false;}if(isVar){var parent=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa_vars.getVGrandpa(opt.id);if(!parent)return true;return this.forceIsShown(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(optId)===-2?parent:parent+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(optId));}// Checking if option is selected
if(['radio','checkbox'].includes(opt.meta.type)&&!skipSelf){var value=Object(__WEBPACK_IMPORTED_MODULE_0__re_index__["g" /* lpGetOptionById */])(optId);if(typeof value==='undefined'){value=Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["a" /* getOptionPass */])(optId);}else{var _value=value;value=_value.value;}if(!value)return false;}// Checking option's conditions
var parentRef=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(optId));if(parentRef&&parentRef.meta.compiledConditions&&parentRef.meta.compiledConditions.length>0){var cond=__WEBPACK_IMPORTED_MODULE_4__condition_evo__["a" /* default */].getCondition(optId);// console.log('is shown is checking ', optId, cond);
__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.conditions.setCondition(optId,cond);if(debug)console.log('[isShown]On va checker les condition ',optId);if(cond===false)return false;}// Getting the parent
var par=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(optId));// this.getOptionParent(optId);
// If it's a root we check conditions
if(typeof par==='undefined'){return true;}return this.forceIsShown(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(optId)===-2?par:par+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(optId),false,false,debug);// console.timeEnd("isShown")
}// Is Shown
},{key:'isShown',value:function isShown(optId){// console.time("isShown")
if(optId===-1)return true;var opt=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(optId);if(!opt){// debugger;
return false;}// Checking if option is selected
if(['radio','checkbox'].includes(opt.meta.type)){var value=Object(__WEBPACK_IMPORTED_MODULE_0__re_index__["g" /* lpGetOptionById */])(optId);if(typeof value==='undefined'){value=Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["a" /* getOptionPass */])(optId);}else{var _value2=value;value=_value2.value;}if(!value)return false;}// Checking option's conditions
if(optId in __WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.conditions.conditions){return __WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.conditions.getCondition(optId);}if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(optId)&&__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(optId).meta.compiledConditions&&__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(optId).meta.compiledConditions.length>0){// var cond = new ConditionRuntime(lpApp.references.getOption(optId).meta.compiledConditions);
// cond.compileDirect();
// lpApp.indexes.conditions.setCondition(optId, cond.execute())
__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.conditions.setCondition(optId,__WEBPACK_IMPORTED_MODULE_4__condition_evo__["a" /* default */].getCondition(optId));if(!__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.conditions.getCondition(optId))return false;}// Getting the parent
var par=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa.getFather(optId);// this.getOptionParent(optId);
// If it's a root we check conditions
if(par===false){return true;}return this.isShown(par);// console.timeEnd("isShown")
}},{key:'forceInterprete',value:function forceInterprete(){var convTable=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _this2=this;var edit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var debug=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var state=null;var hasMany=null;var frs=this.forceIsShown(edit[this.id]?edit[this.id]:this.id,this.type==='variable',true,debug,this.is_leaf&&this.operation==='at-least-one');if(!frs)return false;// this is a leaf, so we interprete operations
if(this.is_leaf){convTable.map(function(idx){if((idx.id===_this2.id||idx.id===edit[_this2.id])&&idx.type===_this2.type){// if(edit[idx.id])
state=idx.value;hasMany=idx.hasMany;}},this);if(state===null)return true;if((typeof state==='undefined'?'undefined':_typeof(state))==='object')state=state.value;// The thing is multiple, and
if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.options[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(this.id)]){var opt=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.options[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(this.id)].meta;if(opt.parentMultiple&&opt.parentMultiple===true){// this is a multiple so we create an array in order to get its multiples' values.
var m=Object(__WEBPACK_IMPORTED_MODULE_3__redux_reducers_load_ovc__["a" /* getOFirstMultipleParent */])(this.id);// Get the array
var x=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(m)?__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(m).map(function(idx){return __WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.options.getOption(_this2.id+'_'+idx)?__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.options.getOption(_this2.id+'_'+idx).value:false;}):[];if(x.length&&!window.repeated){if(x.length===1)state&=x[0];if(x.length>1)state&=x.reduce(function(a,b){return a&&b;});}}}if(this.operation==='selected'&&state||this.operation==='not-selected'&&!state){// if(this.id == 97) debugger;
return true;}if(this.operation==='selected'&&!state||this.operation==='not-selected'&&state)return false;if(this.operation==='contains'){var variable=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.variables.variables[edit[this.id]?edit[this.id]:this.id];var realValue=variable?variable.value:'';if(this.additionalValue===realValue)return true;return false;}// console.log(this.operation + " => " + hasMany)
if(this.operation==='has-many'&&hasMany)return true;if(this.operation==='has-many'&&!hasMany)return false;if(this.operation==='has-one'&&!hasMany)return true;if(this.operation==='has-one'&&hasMany)return false;if(this.operation==='at-least-one'){// console.log(this.id, this.operation)
var multiples=Object.keys(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.options.options).filter(function(idx){return idx.split('_')[0]===_this2.id||idx===_this2.id;}).map(function(idx){return __WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.options.getOption(idx).value;}).filter(function(jdx){return jdx===true;});if(multiples.length>0)return true;return false;}return false;// can be false.
}// else
// this is not leaf so we add everytime the rel interpretation.
var child=this.children.length===0?true:null;this.children.forEach(function(idx){// interprete everi chlid wa7dou
var cNode=idx.forceInterprete(convTable,edit,debug);// and then interprete the relationships between nodes
switch(idx.rel){case'none':default:child=cNode;break;case'and':if(child===null)child=cNode;else child=child&&cNode;break;case'or':if(child===null)child=cNode;else child=child||cNode;break;}if(debug)console.log(idx.id,idx.rel,cNode,child);});if(debug)console.log('some here ',child);return child;}// execute the AST result, with a special context [token values]
},{key:'interprete',value:function interprete(){var _this3=this;var conv_table=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var edit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var state=null;var hasMany=null;if(!this.isShown(this.id))return false;// if(this.id)
// this is a leaf, so we interprete operations
if(this.is_leaf){conv_table.forEach(function(idx){if((idx.id===_this3.id||idx.id===edit[_this3.id])&&idx.type===_this3.type){// if(edit[idx.id])
state=idx.value;hasMany=idx.hasMany;}},this);if((typeof state==='undefined'?'undefined':_typeof(state))==='object'&&state)state=state.value;if(this.operation==='selected'&&state||this.operation==='not-selected'&&!state)return true;if(this.operation==='contains'){var copy='';if(Object.keys(edit).length>0){var _edit$Object$keys$0$s=edit[Object.keys(edit)[0]].split('_');var _edit$Object$keys$0$s2=_slicedToArray(_edit$Object$keys$0$s,2);copy=_edit$Object$keys$0$s2[1];}var realValue=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.variables.variables[copy!==''?this.id+'_'+copy:this.id].value;if(this.additionalValue===realValue)return true;return false;}if(this.operation==='selected'&&!state||this.operation==='not-selected'&&state)return false;// console.log(this.operation + " => " + hasMany)
if(this.operation==='has-many'&&hasMany)return true;if(this.operation==='has-many'&&!hasMany)return false;if(this.operation==='has-one'&&!hasMany)return true;if(this.operation==='has-one'&&hasMany)return false;return false;// can be false.
}// else
// this is not leaf so we add everytime the rel interpretation.
var child=true;this.children.forEach(function(idx){// interprete everi chlid wa7dou
var cNode=idx.interprete(conv_table,edit);// and then interprete the relationships between nodes
switch(idx.rel){case'none':default:child=cNode;break;case'and':child=child&&cNode;break;case'or':child=child||cNode;break;}});return child;}}]);return AstNode;}();// the runtime environment is meant to be a container,
// who contains a context and an AST tree condition,
var ConditionRuntime=function(){function ConditionRuntime(){var obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];_classCallCheck(this,ConditionRuntime);// this contains tokens single tokens (options and variables)
/** @type {LpToken[]} */this.conv_table=[];/** @type {AstNode} */this.root=null;if(obj.length>0)this.build(obj);this.edited_options={};this.copy=undefined;}// build an object to tree
_createClass(ConditionRuntime,[{key:'build',value:function build(obj){this.root=loadNode(obj,this.conv_table);}// interprete the AST tree, with the local conv_table
},{key:'execute',value:function execute(){var forced=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var debug=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;// update conditions
// if(Object.keys(this.edited_options).length > 0)
// debugger;
if(!this.root)return true;if(debug)console.log(this.conv_table);return!forced?this.root.interprete(this.conv_table,this.edited_options,debug):this.root.forceInterprete(this.conv_table,this.edited_options,debug);}// update the options
},{key:'modifyForMultiples',value:function modifyForMultiples(id){var _this4=this;var cCopy=Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(id);if(cCopy===-2)return;this.conv_table.forEach(function(idx){if(idx.type==='option'){if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.options[idx.id].meta.multiple||__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.options[idx.id].meta.parentMultiple)_this4.editOption(idx.id,idx.id+'_'+cCopy);}else if(idx.type==='variable'){_this4.editOption(idx.id,idx.id+'_'+cCopy);}},this);}},{key:'compileDirect',value:function compileDirect(){var _this5=this;this.conv_table=this.conv_table.map(function(idx){if(_this5.edited_options[idx.id]){idx.id=_this5.edited_options[idx.id];return idx;}return idx;},this);this.conv_table=this.conv_table.map(function(idx){var editedWork=_this5.edited_options[idx.id];var opt=void 0;if(idx.type==='variable')opt=Object(__WEBPACK_IMPORTED_MODULE_0__re_index__["h" /* lpGetVariableById */])(editedWork||(typeof _this5.copy==='undefined'||_this5.copy===-2?idx.id:idx.id+'_'+_this5.copy));else opt=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.options.getOption(editedWork||(typeof _this5.copy==='undefined'||_this5.copy===-2?idx.id:idx.id+'_'+_this5.copy));// TODO: before this we have to luncgh it in continue mode
if(typeof opt==='undefined'){opt=Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["a" /* getOptionPass */])(editedWork||idx.id);}else{opt=opt.value;}// let opt = getOptionPass(editedWork ? editedWork : idx.id);
var multiple=void 0;if(typeof idx.id==='string')multiple=Object(__WEBPACK_IMPORTED_MODULE_0__re_index__["f" /* lpGetIsMultiple */])(idx.id.split('_')[0]);else multiple=Object(__WEBPACK_IMPORTED_MODULE_0__re_index__["f" /* lpGetIsMultiple */])(idx.id);var _=idx.clone();if(typeof opt==='undefined'){_.setValue(false);}else{_.setValue(opt);}if(typeof multiple==='undefined'||multiple.length===0){_.setMany(false);}else{_.setMany(multiple);}return _;},this);}// we pass this ebery time an update is made in the options
// this one update conv_table values
},{key:'passOptions',value:function passOptions(opt){this.conv_table=this.conv_table.map(function(idx){// console.log(idx);
if(idx.id===opt.id){var _=idx.clone();_.setValue(opt.value);return _;}return idx;});}},{key:'editOption',value:function editOption(optId,newOptId){this.edited_options[optId]=newOptId;// console.log(this)
}}]);return ConditionRuntime;}();// load node from a JSON obj
function loadNode(obj){var ct=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];// test if obj is atomic
// TODO: add possibility of having a rel in condition_array
// check if the obj contains a condition
if('c'in obj){// this is a leaf
var node=new AstNode(true);// extract information from the obj
var condition=obj.c;var id=-1;var parent=-1;var type='none';var rel='none';var additionalValue='';// the condition is on an option
if('o'in obj&&obj.o!==false){id=obj.o;type='option';}// the condition is on a variable
if('v'in obj&&obj.v!==false){id=obj.v;type='variable';additionalValue=obj.value;}/* if(('m' in obj) && (obj.m != false)){
            id = obj.m;
            type = 'multiple';
        } */// set the parent
if('p'in obj)parent=obj.p;// set the relationship
if('t'in obj){rel=obj.t;}// test existance in the token list
var isInconv=false;// test the existance of the token in the conv_table
ct.forEach(function(idx){if(idx.id===id&&type===idx.type)isInconv=true;});// add a token if it doesn't exist
if(!isInconv){ct.push(new LpToken(id,type,parent));}// init the leaf, return it
node.initLeaf(id,parent,type,condition,rel,additionalValue);return node;}// TODO: TEST the case if the rel in condition_array and arrays
// test if it's a condition array node
if('condition_array'in obj){var children=obj.condition_array;if('t'in obj){var _node=new AstNode(false);_node.rel=obj.t;_node.addChild(loadNode(children,ct));return _node;}return loadNode(children,ct);// FIXME: An array of condition arrays
}// if it's an array of conditions
if(typeof obj.length!=='undefined'){// create the node.
var _node2=new AstNode(false);// push every single node here
// console.log(obj.length);
obj.forEach(function(idx){_node2.addChild(loadNode(idx,ct));});return _node2;}}window.basterd=ConditionRuntime;

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeArguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber___ = __webpack_require__(373);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function parsePhoneNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber___["a" /* default */])(text, options, metadata);
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
      if (arg_3) {
        options = arg_2;
        metadata = arg_3;
      } else {
        metadata = arg_2;
      }
    } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
} // Otherwise istanbul would show this as "branch not covered".

/* istanbul ignore next */

var isObject = function isObject(_) {
  return _typeof(_) === 'object';
};
//# sourceMappingURL=parsePhoneNumber.js.map

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIGITS */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseDigit;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseDigits;
// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=parseDigits.js.map

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPossibleNumber___ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validate___ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isValidNumberForRegion___ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getNumberType___ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__format___ = __webpack_require__(377);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }







var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var PhoneNumber =
/*#__PURE__*/
function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    _classCallCheck(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    var _metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    } else {
      /* istanbul ignore if */
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (_metadata.isNonGeographicCallingCode(countryCallingCode)) {
          this.country = '001';
        }
      }
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  _createClass(PhoneNumber, [{
    key: "isPossible",
    value: function isPossible() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__isPossibleNumber___["a" /* default */])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__validate___["a" /* default */])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__getNumberType___["b" /* default */])(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__format___["c" /* default */])(this, _format, options ? _objectSpread({}, options, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();



var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};
//# sourceMappingURL=PhoneNumber.js.map

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = limit;
/* harmony export (immutable) */ __webpack_exports__["d"] = trimAfterFirstMatch;
/* harmony export (immutable) */ __webpack_exports__["c"] = startsWith;
/* harmony export (immutable) */ __webpack_exports__["a"] = endsWith;
/** Returns a regular expression quantifier with an upper and lower limit. */
function limit(lower, upper) {
  if (lower < 0 || upper <= 0 || upper < lower) {
    throw new TypeError();
  }

  return "{".concat(lower, ",").concat(upper, "}");
}
/**
 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
 * returning the trimmed version.
 */

function trimAfterFirstMatch(regexp, string) {
  var index = string.search(regexp);

  if (index >= 0) {
    return string.slice(0, index);
  }

  return string;
}
function startsWith(string, substring) {
  return string.indexOf(substring) === 0;
}
function endsWith(string, substring) {
  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getContractAndOVC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return saveInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return validateCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getContractOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkGeneratedFiles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var axiosOptions={withCredentials:true};var api=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:"https://api.legalplace.eu"+'/api/v1'});var getContract=function getContract(contractPermalink){return api.get('/wizard/contract/'+contractPermalink,axiosOptions);};var getContractAndOVC=function getContractAndOVC(contractPermalink,uniqid){return api.get('/wizard/contract/'+contractPermalink+'/'+uniqid,axiosOptions);};var getCheckout=function getCheckout(contractPermalink,uniqid){return api.get('/wizard/checkout/'+contractPermalink+'/'+uniqid,axiosOptions);};var saveInstance=function saveInstance(contractPermalink,instanceData){var isAutosaved=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return api.post('/wizard/instance/'+contractPermalink+(isAutosaved?'?autosaved':''),instanceData,axiosOptions);};var updateInstance=function updateInstance(contractPermalink,uniqd,instanceData){return api.put('/wizard/instance/'+contractPermalink+'/'+uniqd,instanceData,axiosOptions);};var createOrder=function createOrder(uniqid,orderData){return api.post('/wizard/order/'+uniqid,orderData,axiosOptions);};var validateCoupon=function validateCoupon(uniqid,couponCode){return api.post('/wizard/order/coupon/validate',{uniqid:uniqid,couponCode:couponCode},axiosOptions);};var getContractOrder=function getContractOrder(uniqid){return api.get('/form/orders/'+uniqid,axiosOptions);};var checkGeneratedFiles=function checkGeneratedFiles(uniqid){return api.get('/wizard/generation/check/'+uniqid,axiosOptions);};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(5).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(5).Buffer
var MD5 = __webpack_require__(252)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(30);
var utils = __webpack_require__(50);
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(979)
var aesid = __webpack_require__(990)
var fixProc = __webpack_require__(991)
var ciphers = __webpack_require__(256)
var compat = __webpack_require__(403)
var Buffer = __webpack_require__(5).Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),
/* 172 */
/***/ (function(module, exports) {

var JsonWebTokenError = function (message, error) {
  Error.call(this, message);
  if(Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  }
  this.name = 'JsonWebTokenError';
  this.message = message;
  if (error) this.inner = error;
};

JsonWebTokenError.prototype = Object.create(Error.prototype);
JsonWebTokenError.prototype.constructor = JsonWebTokenError;

module.exports = JsonWebTokenError;


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = filterRadios;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkIfAllFalse;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkUnInitializedSiblings;
/* unused harmony export areAllMyChildrenHidden */
/* harmony export (immutable) */ __webpack_exports__["d"] = hasEmptyChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_load_contract__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_lp_app__ = __webpack_require__(2);
/*
* Project: LegalPlace assistant
* File: src/logic/utils/tree_operations.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// In this library we'll have some operations like get siblinges, check siblings all are false ....
function getSiblings(v){var parent=Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_load_contract__["e" /* getMaa */])(v);if(typeof parent==='undefined')return[];if(parent<=0)return[];if(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.options&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(parent)){return __WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(parent).children;}return[];}function filterRadios(){var siblings=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return siblings.filter(function(idx){return __WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(idx).meta.type==='radio';});}function checkIfAllFalse(){var v=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var copy=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';// preparing the ground for multiples
var nV=void 0;if(copy&&copy.length>0)nV=v.map(function(idx){return idx+'_'+copy;});else nV=v;var result=true;nV.forEach(function(idx){var s=Object(__WEBPACK_IMPORTED_MODULE_0__re_index__["g" /* lpGetOptionById */])(idx);if(typeof s==='undefined'){s=Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["a" /* getOptionPass */])(idx);}else{s=s.value;}if(s)result=false;});// console.log(v, result);
return result;}function checkUnInitializedSiblings(v,copy){return checkIfAllFalse(filterRadios(getSiblings(v)),copy);}/**
 *
 * @param {array} cd
 */function areAllMyChildrenHidden(cd){if(typeof cd==='undefined')return false;var cdChildren=cd.children;var result=true;cdChildren.forEach(function(idx){if(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(idx).meta.type!=='hidden')result=false;});return result;}/**
 *
 * @param {number} id
 */function hasEmptyChildren(id){return id in __WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.options&&(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(id).children.length===0||areAllMyChildrenHidden(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(id)))&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(id).variables.length===0&&(!('warning'in window.lpApp.references.getOption(id).meta)||__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.getOption(id).meta.warning==='');}window.hasEmptyChildren=hasEmptyChildren;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var alpha = exports.alpha = {
  'en-US': /^[A-Z]+$/i,
  'bg-BG': /^[А-Я]+$/i,
  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[A-ZÆØÅ]+$/i,
  'de-DE': /^[A-ZÄÖÜß]+$/i,
  'el-GR': /^[Α-ω]+$/i,
  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'nb-NO': /^[A-ZÆØÅ]+$/i,
  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[A-ZÆØÅ]+$/i,
  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
  'ru-RU': /^[А-ЯЁ]+$/i,
  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[A-ZÅÄÖ]+$/i,
  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};

var alphanumeric = exports.alphanumeric = {
  'en-US': /^[0-9A-Z]+$/i,
  'bg-BG': /^[0-9А-Я]+$/i,
  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
  'el-GR': /^[0-9Α-ω]+$/i,
  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
  'ru-RU': /^[0-9А-ЯЁ]+$/i,
  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};

var decimal = exports.decimal = {
  'en-US': '.',
  ar: '٫'
};

var englishLocales = exports.englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];

for (var locale, i = 0; i < englishLocales.length; i++) {
  locale = 'en-' + englishLocales[i];
  alpha[locale] = alpha['en-US'];
  alphanumeric[locale] = alphanumeric['en-US'];
  decimal[locale] = decimal['en-US'];
}

// Source: http://www.localeplanet.com/java/
var arabicLocales = exports.arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];

for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
  _locale = 'ar-' + arabicLocales[_i];
  alpha[_locale] = alpha.ar;
  alphanumeric[_locale] = alphanumeric.ar;
  decimal[_locale] = decimal.ar;
}

// Source: https://en.wikipedia.org/wiki/Decimal_mark
var dotDecimal = exports.dotDecimal = [];
var commaDecimal = exports.commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'es-ES', 'fr-FR', 'it-IT', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-Pl', 'pt-PT', 'ru-RU', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'];

for (var _i2 = 0; _i2 < dotDecimal.length; _i2++) {
  decimal[dotDecimal[_i2]] = decimal['en-US'];
}

for (var _i3 = 0; _i3 < commaDecimal.length; _i3++) {
  decimal[commaDecimal[_i3]] = ',';
}

alpha['pt-BR'] = alpha['pt-PT'];
alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
decimal['pt-BR'] = decimal['pt-PT'];

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_input_mask__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_input_mask__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/misc/masked_input.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var KEYCODE_Z=90;var KEYCODE_Y=89;function isUndo(e){return(e.ctrlKey||e.metaKey)&&e.keyCode===(e.shiftKey?KEYCODE_Y:KEYCODE_Z);}function isRedo(e){return(e.ctrlKey||e.metaKey)&&e.keyCode===(e.shiftKey?KEYCODE_Z:KEYCODE_Y);}function getSelection(el){var start=void 0;var end=void 0;var rangeEl=void 0;var clone=void 0;if(el.selectionStart!==undefined){start=el.selectionStart;end=el.selectionEnd;}else{try{el.focus();rangeEl=el.createTextRange();clone=rangeEl.duplicate();rangeEl.moveToBookmark(document.selection.createRange().getBookmark());clone.setEndPoint('EndToStart',rangeEl);start=clone.text.length;end=start+rangeEl.text.length;}catch(e){/* not focused or not visible */}}return{start:start,end:end};}function setSelection(el,selection){var rangeEl=void 0;try{if(el.selectionStart!==undefined){el.focus();el.setSelectionRange(selection.start,selection.end);}else{el.focus();rangeEl=el.createTextRange();rangeEl.collapse(true);rangeEl.moveStart('character',selection.start);rangeEl.moveEnd('character',selection.end-selection.start);rangeEl.select();}}catch(e){/* not focused or not visible */}}var MaskedInput=function(_React$Component){_inherits(MaskedInput,_React$Component);_createClass(MaskedInput,null,[{key:'keyPressPropName',value:function keyPressPropName(){if(typeof navigator!=='undefined'){return navigator.userAgent.match(/Android/i)?'onBeforeInput':'onKeyPress';}return'onKeyPress';}}]);function MaskedInput(props){_classCallCheck(this,MaskedInput);var _this=_possibleConstructorReturn(this,(MaskedInput.__proto__||Object.getPrototypeOf(MaskedInput)).call(this,props));_this.onChange=_this.onChange.bind(_this);_this.onKeyDown=_this.onKeyDown.bind(_this);_this.onPaste=_this.onPaste.bind(_this);_this.onKeyPress=_this.onKeyPress.bind(_this);_this.updateInputSelection=_this.updateInputSelection.bind(_this);return _this;}_createClass(MaskedInput,[{key:'componentWillMount',value:function componentWillMount(){var options={pattern:this.props.mask,value:this.props.value,formatCharacters:this.props.formatCharacters};if(this.props.placeholderChar){options.placeholderChar=this.props.placeholderChar;}this.mask=new __WEBPACK_IMPORTED_MODULE_2__utils_input_mask___default.a(options);}},{key:'componentDidMount',value:function componentDidMount(){if(document.getElementById('numcard1')&&document.getElementById('numcard2')){document.getElementById('numcard1').setAttribute('autoFocus',true);document.getElementById('numcard2').setAttribute('autoFocus',true);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.mask!==nextProps.mask&&this.props.value!==nextProps.mask){// if we get a new value and a new mask at the same time
// check if the mask.value is still the initial value
// - if so use the nextProps value
// - otherwise the `this.mask` has a value for us (most likely from paste action)
if(this.mask.getValue()===this.mask.emptyValue){this.mask.setPattern(nextProps.mask,{value:nextProps.value});}else{this.mask.setPattern(nextProps.mask,{value:this.mask.getRawValue()});}}else if(this.props.mask!==nextProps.mask){this.mask.setPattern(nextProps.mask,{value:this.mask.getRawValue()});}else if(this.props.value!==nextProps.value){this.mask.setValue(nextProps.value);}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(nextProps.mask!==this.props.mask){this.updatePattern(nextProps);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.mask!==this.props.mask&&this.mask.selection.start){this.updateInputSelection();}if(document.getElementById('numcard1')&&document.getElementById('numcard2')){document.getElementById('numcard1').setAttribute('autoFocus',true);document.getElementById('numcard2').setAttribute('autoFocus',true);}}},{key:'onChange',value:function onChange(e){// console.log('onChange', JSON.stringify(getSelection(this.input)), e.target.value)
var maskValue=this.mask.getValue();var incomingValue=e.target.value;if(incomingValue!==maskValue){// only modify mask if form contents actually changed
this.updateMaskSelection();this.mask.setValue(incomingValue);// write the whole updated value into the mask
e.target.value=this.getDisplayValue();// update the form with pattern applied to the value
this.updateInputSelection();}if(this.props.onChange){this.props.onChange(e);}}},{key:'onKeyDown',value:function onKeyDown(e){// console.log('onKeyDown', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
if(isUndo(e)){e.preventDefault();if(this.mask.undo()){e.target.value=this.getDisplayValue();this.updateInputSelection();if(this.props.onChange){this.props.onChange(e);}}return;}if(isRedo(e)){e.preventDefault();if(this.mask.redo()){e.target.value=this.getDisplayValue();this.updateInputSelection();if(this.props.onChange){this.props.onChange(e);}}return;}if(e.key==='Backspace'){e.preventDefault();this.updateMaskSelection();if(this.mask.backspace()){var value=this.getDisplayValue();e.target.value=value;if(value){this.updateInputSelection();}if(this.props.onChange){this.props.onChange(e);}}}}},{key:'onKeyPress',value:function onKeyPress(e){// console.log('onKeyPress', JSON.stringify(getSelection(this.input)), e.key, e.target.value)
// Ignore modified key presses
// Ignore enter key to allow form submission
if(e.metaKey||e.altKey||e.ctrlKey||e.key==='Enter'){return;}e.preventDefault();this.updateMaskSelection();if(this.mask.input(e.key||e.data)){e.target.value=this.mask.getValue();this.updateInputSelection();if(this.props.onChange){this.props.onChange(e);}}}},{key:'onPaste',value:function onPaste(e){e.preventDefault();this.updateMaskSelection();// getData value needed for IE also works in FF & Chrome
if(this.mask.paste(e.clipboardData.getData('Text'))){e.target.value=this.mask.getValue();// Timeout needed for IE
setTimeout(this.updateInputSelection.bind(this),0);if(this.props.onChange){this.props.onChange(e);}}}},{key:'getEventHandlers',value:function getEventHandlers(){return _defineProperty({onChange:this.onChange,onKeyDown:this.onKeyDown,onPaste:this.onPaste},MaskedInput.keyPressPropName(),this.onKeyPress);}},{key:'getDisplayValue',value:function getDisplayValue(){var value=this.mask.getValue();return value===this.mask.emptyValue?'':value;}},{key:'updatePattern',value:function updatePattern(props){this.mask.setPattern(props.mask,{value:this.mask.getRawValue(),selection:getSelection(this.input)});}},{key:'updateMaskSelection',value:function updateMaskSelection(){this.mask.selection=getSelection(this.input);}},{key:'updateInputSelection',value:function updateInputSelection(){setSelection(this.input,this.mask.selection);}},{key:'focus',value:function focus(){this.input.focus();}},{key:'blur',value:function blur(){this.input.blur();}},{key:'render',value:function render(){var _this2=this;var ref=function ref(r){_this2.input=r;};var maxLength=this.mask.pattern.length;var placeholder=this.getDisplayValue();var eventHandlers=this.getEventHandlers();var _props$size=this.props.size,size=_props$size===undefined?maxLength:_props$size;var cleanedProps=_objectWithoutProperties(this.props,[]);if(this.props.placeholder!==''){;placeholder=this.props.placeholder;}var inputProps=Object.assign({},cleanedProps,eventHandlers,{ref:ref,maxLength:maxLength,size:size,placeholder:placeholder});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',inputProps);}}]);return MaskedInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MaskedInput.propTypes={mask:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,formatCharacters:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,placeholderChar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};MaskedInput.defaultProps={value:'',formatCharacters:{},placeholderChar:''};/* harmony default export */ __webpack_exports__["a"] = (MaskedInput);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TitleShimmer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ParagraphShimmer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PackShimmer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*
* Project: LegalPlace assistant
* File: src/components/misc/shimmer.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var TitleShimmer=function TitleShimmer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shimmer ch-titles"});};var ParagraphShimmer=function ParagraphShimmer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shimmer ch-content"});};var PackShimmer=function PackShimmer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pack-shimmer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shimmer ch-pack"}));};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_masked_input__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_credit_card_detect__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/card_modal.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// intiialization of errors payment errors
function initErrors(){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('credit-error');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('credit.number');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('card.exp');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('card.cvc');// unraiseError('')
}var _LpCreditCardModal=function(_Component){_inherits(_LpCreditCardModal,_Component);function _LpCreditCardModal(props){_classCallCheck(this,_LpCreditCardModal);var _this=_possibleConstructorReturn(this,(_LpCreditCardModal.__proto__||Object.getPrototypeOf(_LpCreditCardModal)).call(this,props));_this.updateCardNumber=_this.updateCardNumber.bind(_this);_this.updateCardExpiration=_this.updateCardExpiration.bind(_this);_this.updateCardCCV=_this.updateCardCCV.bind(_this);_this.initiatePayment=_this.initiatePayment.bind(_this);_this.updateCheckBox=_this.updateCheckBox.bind(_this);// do the changes in the card type
_this.state={card_class:'none'};return _this;}_createClass(_LpCreditCardModal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var that=this;var a=document.getElementById('checkout-modal1');document.getElementById('checkout-modal1').addEventListener('click',function(e){if(e.target===a||e.target===that.close_btn){_this2.props.closeEvent();__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.resetCreditCardInformation();}__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["g" /* P_CLOSE_PAIMENT */]);});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(!prevProps.show&&this.props.show){if(this.refs.credit_card_modal){if(document.getElementById('checkout-modal1').firstChild)document.getElementById('checkout-modal1').removeChild(document.getElementById('checkout-modal1').firstChild);document.getElementById('checkout-modal1').appendChild(this.refs.credit_card_modal);document.getElementById('checkout-modal1').classList.add('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='blur(5px)';document.body.style.overflow='hidden';__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.utils.addModalClassToBody();}}if(prevProps.show&&!this.props.show){document.getElementById('checkout-modal1').classList.remove('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.utils.removeModalClassToBody();}var that=this;var a=document.getElementById('checkout-modal1');document.getElementById('checkout-modal1').addEventListener('click',function(e){if(e.target===a||e.target===that.refs.close_btn){_this3.props.closeEvent();__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.resetCreditCardInformation();}__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["g" /* P_CLOSE_PAIMENT */]);});var paypal=window.paypal;if(paypal&&!document.querySelector('.paypal-buttons')&&document.querySelector('#paypal-container')){paypal.Buttons({style:{color:'silver',fundingicons:'false',layout:'horizontal',tagline:'false'},onClick:function onClick(data,actions){_this3.props.updatePaymentMethod(1);if(!_this3.props.confirmation){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',20,Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."));return actions.reject();}},createOrder:function createOrder(data,actions){return actions.order.create({purchase_units:[{amount:{currency_code:'EUR',value:contract_meta_id===302?_this3.props.totalTTC:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice()}}]});},onApprove:function onApprove(data,actions){return actions.order.capture().then(function(response){_this3.initiatePayment(data.orderID,response.payer.email_address);});}}).render('#paypal-container');}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(document.getElementById('checkout-modal1').firstChild)document.getElementById('checkout-modal1').removeChild(document.getElementById('checkout-modal1').firstChild);document.getElementById('checkout-modal1').classList.remove('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.utils.removeModalClassToBody();}// TODO: better things.
},{key:'updateCardNumber',value:function updateCardNumber(evt){this.props.updateCardNumber(evt.target.value);this.setState({card_class:Object(__WEBPACK_IMPORTED_MODULE_8__utils_credit_card_detect__["a" /* getCardClass */])(evt.target.value)});}},{key:'updateCardExpiration',value:function updateCardExpiration(evt){this.props.updateCardExpiration(evt.target.value);}},{key:'updateCardCCV',value:function updateCardCCV(evt){this.props.updateCardCCV(evt.target.value);}},{key:'updateCheckBox',value:function updateCheckBox(evt){this.props.updateConfirmation(evt.target.checked);}},{key:'totalRevenue',value:function totalRevenue(){return this.props.contract_meta_id===302?this.props.coursier_pack_price:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getHTPrice();// const  htPrice = lpApp.ops.checkout.getHTPrice()
// const deducedFees = Object.keys(HARDCODED_FEES_PER_META_IDS).indexOf(`${lpApp.contractMetaId}`) > -1
// ? HARDCODED_FEES_PER_META_IDS[`${lpApp.contractMetaId}`]
// : 0
// return htPrice - deducedFees
}},{key:'initiatePayment',value:function initiatePayment(){var _this4=this;var orderId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var paypalAddress=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';// if(this.props.confirmation){
this.props.loading();initErrors();// pattern.
__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["p" /* lpPattern */].trackLastAction(__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["i" /* P_PAY */]);__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["p" /* lpPattern */].sendAndResetTracker();var selectedPack=void 0;switch(this.props.selected_pack){case 0:selectedPack='first_price';break;case 1:selectedPack='second_price';break;default:selectedPack='third_price';break;}var totalTTC=this.props.contract_meta_id===302?this.props.totalTTC:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice();var datalayerData={};// devenir-coursier only
if([302].indexOf(this.props.contract_meta_id)>-1){var priceTva=(totalTTC*(1/6)).toFixed(2);var priceHT=(totalTTC-priceTva).toFixed(2);datalayerData={orderShipping:0,packPriceWithReduction:priceHT,orderTax:priceTva,acteProduct:false};}if(this.props.payment_method===0){// credit card
window.lp_payment.handleTransaction(Object.assign({type:'card',card:{number:this.props.card_number,cvc:!this.props.card_ccv.includes(' ')?this.props.card_ccv:this.props.card_ccv.slice(0,3),exp:this.props.card_expiration},contract_id:this.props.contract_id,pack:this.props.contract_meta_id===302?'first_price':selectedPack,options:[],pack_price:this.props.pack_price,upsell:this.props.upsell,invoice:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.isInvoiceActivated()?__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getInvoice():{},coupon:this.props.promo_code,client_email:this.props.mail,document_name:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].contractTitle,cgv:this.props.confirmation,price:totalTTC,paymentMethod:'stripe',revenue:this.totalRevenue()},datalayerData)).then(function(response){if(response.STATUS==='SUCCESS'){window.localStorage.setItem('purchaseScore',response.purchaseScore);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setPayed(true);window.onbeforeunload=null;if(typeof window.ga!=='undefined'){window.ga('send','event','Payment','Download',parseFloat(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice()));window.ga('require','ecommerce');window.ga('ecommerce:addTransaction',{id:_this4.props.contract_id,affiliation:'LegalPlace - Wizard',revenue:parseFloat(totalTTC),shipping:'0',tax:0,currency:'EUR'});window.ga('ecommerce:addItem',{id:_this4.props.contract_id,// Transaction ID. Required.
name:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].contractTitle,// Product name. Required.
price:parseFloat(totalTTC),// Unit price.
quantity:'1'// Quantity.
});window.ga('ecommerce:send');}window.location.href=response.redirect+'?react';}_this4.props.unloading();}).catch(function(err_){var errorMessage=err_&&err_.length&&err_[0].message;__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackErrorPaymentCheckout(errorMessage);var err=void 0;if(err_.gcv){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,err_.gcv);err=err_.ae;}else err=err_;if(err.length&&err.length>0){err.forEach(function(idx){if(idx.hook==='global')Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',10,idx.message);else Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])(idx.hook,10,idx.message);});}// test if the thing is Error type
if(err instanceof Error){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,err.message);}_this4.props.unloading();});}else{if(!this.props.confirmation){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',20,Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."));this.props.unloading();return;}var _pack=void 0;switch(this.props.selected_pack){case 0:_pack='first_price';break;case 1:_pack='second_price';break;default:_pack='third_price';break;}window.lp_payment.handleTransaction(Object.assign({type:'paypal',contract_id:this.props.contract_id,pack:this.props.contract_meta_id===302?'first_price':_pack,options:[],invoice:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.isInvoiceActivated()?__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getInvoice():{},coupon:this.props.promo_code,price:totalTTC,upsell:this.props.upsell,locale:'fr_FR',pack_price:this.props.pack_price,client_email:this.props.mail,document_name:window.contractName,cgv:this.props.confirmation,paymentMethod:'paypal',orderId:orderId||'',paypalAddress:paypalAddress,revenue:this.totalRevenue()},datalayerData)).then(function(response){if(response.STATUS==='SUCCESS'){window.localStorage.setItem('purchaseScore',response.purchaseScore);__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].setPayed(true);window.onbeforeunload=null;window.location.href=response.redirect+'?react';}_this4.props.unloading();}).catch(function(err_){var errorMessage=err_&&err_.length&&err_[0].message;__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackErrorPaymentCheckout(errorMessage);var err=void 0;if(err_.gcv){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,err_.gcv);err=err_.ae;}else err=err_;if(err.length&&err.length>0){err.forEach(function(idx){if(idx.hook==='global')Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',10,idx.message);else Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])(idx.hook,10,idx.message);});}// test if the thing is Error type
if(err instanceof Error){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,err.message);}_this4.props.unloading();});}var pack=void 0;switch(this.props.selected_pack){case 0:pack='first_price';break;case 1:pack='second_price';break;default:pack='third_price';break;}var eventParams={};eventParams['Chosen price']=this.props.price[pack];eventParams['Total price']=totalTTC;eventParams['Chosen pack']=pack;eventParams['Payment method']=this.props.payment_method===0?'Stripe':'Paypal';__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].track('Asked Payment',eventParams);__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackClickPayment();}},{key:'render',value:function render(){var _this5=this;var totalTTC=this.props.contract_meta_id===302?this.props.totalTTC:parseFloat(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice());return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'credit_card_modal'},this.props.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'close_btn',className:'lpm-close icn-x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-lock'}),Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])('Paiement sécurisé')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'content_modal',className:'lpm-content'},this.props.credit_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.credit_error.message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chekout-tabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-tab active',id:'ct-cards'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ct-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'form-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group form-payement__card-number '+this.state.card_class+(this.props.error_card?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Num\xE9ro de carte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!!! !!!! !!!! !!!!',className:'form-control',name:'cardnumber',autoComplete:'cc-number',value:this.props.card_number,onChange:this.updateCardNumber}),' ',this.props.error_card&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.error_card.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6 form-payement__exp-date'+(this.props.error_exp?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date d\'expiration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{placeholder:Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])('MM/AA'),mask:'!!/!!',maxLength:'5',className:'form-control',name:'cardexp',autoComplete:'cc-exp',value:this.props.card_expiration,onChange:this.updateCardExpiration}),this.props.error_exp&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.error_exp.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6 form-payement__cvc'+(this.props.error_cvc?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Crypto (CVC)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!!!',className:'form-control',autoComplete:'cc-csc',value:this.props.card_ccv,onChange:this.updateCardCCV}),this.props.error_cvc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.error_cvc.message)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-payment cp-flexy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group checkout-conditions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'check_stripe',value:this.props.confirmation,onClick:this.updateCheckBox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'check_stripe'},'En cochant cette case, j\'accepte les',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/conditions-generales',target:'_blank'},' ','conditions g\xE9n\xE9rales'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-block btn-primary cta-payement'+(this.props.loading_payment?' checking':''),onClick:this.props.loading_payment?function(){}:function(){return _this5.initiatePayment();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'loading-spin'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn-text'},'Acheter',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',totalTTC.toFixed(2),' ','\u20AC'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ct-spacer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Ou acheter par')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-tab'+(this.props.payment_method===1?' active':''),id:'ct-paypal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'paypal-container-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'paypal-container'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lmc-footer lpm-footer'},'Besoin d\'aide? Appelez-nous au',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].supportPhone),' ')));}}]);return _LpCreditCardModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{payment_method:state.checkout_operations.payment_method,card_number:state.checkout_operations.credit_card.number,card_expiration:state.checkout_operations.credit_card.expiration,card_ccv:state.checkout_operations.credit_card.ccv,contract_id:state.checkout_operations.contract_id,contract_meta_id:state.checkout_operations.contract_meta_id,selected_pack:state.checkout_operations.pack,price:state.checkout_operations.prices,call_chosen:state.checkout_operations.has_call,letter_chosen:state.checkout_operations.has_letter,// now with the letter informayion
letter_number:state.checkout_operations.letter.number,letter_zip:state.checkout_operations.letter.zip,letter_city:state.checkout_operations.letter.city,letter_address:state.checkout_operations.letter.address,letter_name:state.checkout_operations.letter.name,// coupone code
promo_code:state.checkout_operations.promo_code,confirmation:state.checkout_operations.confirm,promo_percentage:state.checkout_operations.promo_percentage,pack_price:state.checkout_operations.pack===0?state.checkout_operations.prices.first_price:state.checkout_operations.prices.second_price,coursier_pack_price:state.checkout_operations.prices.first_price,// the errors are here
credit_error:state.errors.components['credit-error'],error_card:state.errors.components['card.number'],error_exp:state.errors.components['card.exp'],error_cvc:state.errors.components['card.cvc'],// payment loading
loading_payment:state.loading_details.checking_payment,// For payment add
mail:state.account_settings.mail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){var l=__WEBPACK_IMPORTED_MODULE_4__globals__["b" /* store */].getState().document_state.state;if(l==='new'){// dispatch({type: SET_DOCUMENT_ID, doc: d})
}return{updatePaymentMethod:function updatePaymentMethod(meth){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["N" /* ckPaymentSelect */])(meth));},updateCardNumber:function updateCardNumber(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["J" /* ckCUpdateCardNumber */])(val));},updateCardExpiration:function updateCardExpiration(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["I" /* ckCUpdateCardExpiration */])(val));},updateCardCCV:function updateCardCCV(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["H" /* ckCUpdateCCV */])(val));},updateConfirmation:function updateConfirmation(val){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["c" /* CK_CHECK */],val:val});},loading:function loading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__["i" /* checkingPayment */])(true));},unloading:function unloading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__["i" /* checkingPayment */])(false));}};};var LpCreditCardModal=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_LpCreditCardModal);/* harmony default export */ __webpack_exports__["a"] = (LpCreditCardModal);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(99);
var test = {};
test[__webpack_require__(19)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(40)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(136)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(181)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(74);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(40);
var hide = __webpack_require__(41);
var Iterators = __webpack_require__(100);
var $iterCreate = __webpack_require__(182);
var setToStringTag = __webpack_require__(101);
var getPrototypeOf = __webpack_require__(46);
var ITERATOR = __webpack_require__(19)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(85);
var descriptor = __webpack_require__(84);
var setToStringTag = __webpack_require__(101);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(41)(IteratorPrototype, __webpack_require__(19)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(117)('keys');
var uid = __webpack_require__(83);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(9).document;
module.exports = document && document.documentElement;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(187);
var getKeys = __webpack_require__(86);
var redefine = __webpack_require__(40);
var global = __webpack_require__(9);
var hide = __webpack_require__(41);
var Iterators = __webpack_require__(100);
var wks = __webpack_require__(19);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(75);
var step = __webpack_require__(279);
var Iterators = __webpack_require__(100);
var toIObject = __webpack_require__(45);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(181)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(280);
var validate = __webpack_require__(92);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(138)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(100);
var ITERATOR = __webpack_require__(19)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(99);
var ITERATOR = __webpack_require__(19)('iterator');
var Iterators = __webpack_require__(100);
module.exports = __webpack_require__(39).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var setPrototypeOf = __webpack_require__(192).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(6);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(53)(Function.call, __webpack_require__(47).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(280);
var validate = __webpack_require__(92);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(138)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(39);
var LIBRARY = __webpack_require__(74);
var wksExt = __webpack_require__(284);
var defineProperty = __webpack_require__(25).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(52);
var defined = __webpack_require__(58);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 198 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(142);
var defined = __webpack_require__(58);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(19)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(25);
var createDesc = __webpack_require__(84);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(570);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(28);
var toAbsoluteIndex = __webpack_require__(87);
var toLength = __webpack_require__(20);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(120);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(136)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(53);
var invoke = __webpack_require__(289);
var html = __webpack_require__(185);
var cel = __webpack_require__(179);
var global = __webpack_require__(9);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(51)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var macrotask = __webpack_require__(206).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(51)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(37);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(24);
var LIBRARY = __webpack_require__(74);
var $typed = __webpack_require__(146);
var hide = __webpack_require__(41);
var redefineAll = __webpack_require__(88);
var fails = __webpack_require__(10);
var anInstance = __webpack_require__(89);
var toInteger = __webpack_require__(52);
var toLength = __webpack_require__(20);
var toIndex = __webpack_require__(304);
var gOPN = __webpack_require__(93).f;
var dP = __webpack_require__(25).f;
var arrayFill = __webpack_require__(203);
var setToStringTag = __webpack_require__(101);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(690);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactErrorUtils = __webpack_require__(213);

var invariant = __webpack_require__(8);
var warning = __webpack_require__(14);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(38);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(107);
var Danger = __webpack_require__(710);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactInstrumentation = __webpack_require__(55);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(219);
var setInnerHTML = __webpack_require__(153);
var setTextContent = __webpack_require__(329);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactPropTypesSecret = __webpack_require__(728);
var propTypesFactory = __webpack_require__(317);

var React = __webpack_require__(103);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(8);
var warning = __webpack_require__(14);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactCurrentOwner = __webpack_require__(69);
var ReactInstanceMap = __webpack_require__(126);
var ReactInstrumentation = __webpack_require__(55);
var ReactUpdates = __webpack_require__(62);

var invariant = __webpack_require__(8);
var warning = __webpack_require__(14);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var emptyFunction = __webpack_require__(61);
var warning = __webpack_require__(14);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(229);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(95);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var History=function History(){_classCallCheck(this,History);};History.history=Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])();/* harmony default export */ __webpack_exports__["a"] = (History);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(870);


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_OVC; });
/* unused harmony export updateOVC */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOVC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return autosaveLoadOVC; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__document_state__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lperrors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logic_condition_evo__ = __webpack_require__(29);
/*
* Project: LegalPlace assistant
* File: src/redux/actions/load_ovc.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var UPDATE_OVC='LOAD_OVC';function updateOVC(ovc){return{type:UPDATE_OVC,ovc:ovc};}function loadOVC(ovc){return function(dispatch){window.OVC=ovc;// console.log(data)
dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__document_state__["f" /* setContractName */])(window.contractName));dispatch({type:UPDATE_OVC,ovc:ovc});// Setting client email
// set the current section to 0
if(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].continuity){__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].mutex.setMutex('links',true);var sectionNb=Number.isNaN(parseInt(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].continuity.section,10))?0:parseInt(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].continuity.section,10);if(sectionNb>Object.keys(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].indexes.real_sections).length)dispatch({type:'SET_SECTION_ID',id:0});else{dispatch({type:'SET_SECTION_ID',id:0});}}else dispatch({type:'SET_SECTION_ID',id:0});dispatch({type:'NOT_LOADING'});__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].mutex.setMutex('links',true);__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].indexes.options.loadFromO();__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].indexes.variables.loadFromO();// Executing all conditions after ovc if fully loaded
__WEBPACK_IMPORTED_MODULE_6__logic_condition_evo__["a" /* default */].execAllConditions();dispatch({type:'UPDATE_SECTIONS_C'});dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__loading__["n" /* unloadingWizard */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__lperrors__["c" /* lpSetError */])(new __WEBPACK_IMPORTED_MODULE_2__errors_error__["a" /* LpError */](0,0,'')));window.prerenderReady=true;window.lpMax=255;};}function autosaveLoadOVC(data){// prepare the link
return function(dispatch){// test validity
if(data){window.OVC=data;dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__document_state__["f" /* setContractName */])(window.contractName));dispatch({type:UPDATE_OVC,ovc:data});dispatch({type:'NOT_LOADING'});__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].indexes.options.loadFromO();__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].indexes.variables.loadFromO();dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__loading__["n" /* unloadingWizard */])());// sinon
}};}window.loadOVC=loadOVC;

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initParentingOpts */
/* unused harmony export getFirstMultipleParent */
/* harmony export (immutable) */ __webpack_exports__["a"] = getOFirstMultipleParent;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateOVCReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_load_ovc__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*
* Project: LegalPlace assistant
* File: src/redux/reducers/load_ovc.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/function initParentingVars(){var vars_parents={};// extract the variable to option thing =
Object.keys(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.options).map(function(idx){__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(idx).variables.map(function(jdx){vars_parents[jdx]=idx;});});return vars_parents;}function initParentingOpts(){var opts_parents={};// debugger;
// extract the variable to option thing =
Object.keys(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.options).map(function(idx){__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(idx).children.map(function(jdx){opts_parents[jdx]=idx;});});return opts_parents;}var ops_par={};var var_par={};function getFirstMultipleParent(var_idx){// get the last variable who is a multiple or false if there is not
var opt_idx=var_par[var_idx];var _result=false;// debugger;
while(opt_idx>=0){if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(opt_idx).meta.multiple){_result=opt_idx;}if(ops_par[opt_idx]){opt_idx=ops_par[opt_idx];}else{break;}}return _result;}function getOFirstMultipleParent(var_idx){// get the last variable who is a multiple or false if there is not
var opt_idx=var_idx;var _result=false;var r=[];while(opt_idx){r.push(opt_idx);opt_idx=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa.getFather(opt_idx);}r=r.filter(function(idx){return __WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.options[idx].meta.multiple===true;});if(r.length>0)return r[0];else return false;}function updateOVCReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{o:{},v:{},c:{}};var action=arguments[1];if(action.type==__WEBPACK_IMPORTED_MODULE_0__actions_load_ovc__["a" /* UPDATE_OVC */]){var a=JSON.stringify(action.ovc);var result=JSON.parse(a);// console.log(result);
var on_opts={};ops_par=initParentingOpts();var_par=initParentingVars();var options_flat={};var opts=result.o;if(typeof opts=='undefined'||opts.length)opts={};var opts_keys=Object.keys(opts);var _i=0;if(opts_keys.length===0)return result;for(;_i<opts_keys.length;_i+=1){var idx=opts_keys[_i];var now_=opts[idx];if((typeof now_==='undefined'?'undefined':_typeof(now_))=='object'&&now_.length>1){var keys_list=[];// Setting multiples
if(getOFirstMultipleParent(idx)==idx){for(var _i2=0;_i2<now_.length-1;_i2+=1){keys_list.push(Object(__WEBPACK_IMPORTED_MODULE_1__components_utils_misc__["b" /* generateId1 */])(4));}__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.addMultiple(idx,keys_list);}else{keys_list=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(getOFirstMultipleParent(idx));}for(var j=0;j<now_.length;j+=1){var jdx=now_[j];if(jdx==""){// console.log("faragh")
}else{if(j==0){// the first option
options_flat[jdx]=true;// options_flat[idx] = true;
}else{var k=keys_list[j-1];if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(getOFirstMultipleParent(idx))){var m_=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(getOFirstMultipleParent(idx));if(_i-1>m_.length){options_flat[idx+'_'+k]=true;options_flat[jdx+'_'+k]=true;}else{options_flat[idx+'_'+k]=true;options_flat[jdx+'_'+k]=true;}}else{// lpApp.indexes.multiples.addMultiple(idx, [k]);
options_flat[idx+'_'+k]=true;options_flat[jdx+'_'+k]=true;}// window.lp_mult[idx] = true;
}}}}else{if(now_=="");// console.log("faragh");
else options_flat[now_]=true;}}// checkbox flat
var checkbox_flat={};var chk=result.c;if(typeof chk=='undefined'||chk.length)chk={};var chk_keys=Object.keys(chk);_i=0;for(_i=0;_i<chk_keys.length;_i+=1){var _idx=chk_keys[_i];var _now_=chk[_idx].c?chk[_idx].c:chk[_idx];var now_opts=chk[_idx].v;if(_now_!=null&&_now_&&(typeof _now_==='undefined'?'undefined':_typeof(_now_))=='object'&&_now_.length>1){for(var _j=0;_j<_now_.length;_j+=1){var _jdx=_now_[_j];if(_j==0){checkbox_flat[_idx]=_jdx;}else{var mk=getOFirstMultipleParent(_idx);if(mk){if(typeof __WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(mk)!='undefined')checkbox_flat[_idx+'_'+__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(mk)[_j-1]]=_jdx;// debugger;
}}}}else{checkbox_flat[_idx]=(typeof _now_==='undefined'?'undefined':_typeof(_now_))=='object'?_now_[0]:_now_;}if((typeof now_opts==='undefined'?'undefined':_typeof(now_opts))=='object'&&typeof now_opts.length=='undefined'){var c_opts=now_opts;now_opts=[];for(var _i in c_opts){now_opts.push(c_opts[_i]);}}if((typeof now_opts==='undefined'?'undefined':_typeof(now_opts))=='object'&&now_opts.length>1){for(var _j2=0;_j2<now_opts.length;_j2+=1){var _jdx2=now_opts[_j2];// console.log(idx+ ' : '+jdx);
if(_jdx2==""){// console.log("faragh")
}else{if(_j2==0){// the first option
options_flat[_jdx2]=true;}else{var _k=Object(__WEBPACK_IMPORTED_MODULE_1__components_utils_misc__["b" /* generateId1 */])(4);if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(_idx)){var tmp=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(_idx);tmp.push(_k);__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.addMultiple(_idx,tmp);}else __WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.addMultiple(_idx,[_k]);options_flat[_jdx2+'_'+_k]=true;}}}}else{if(now_opts=="");// console.log("faragh");
else options_flat[now_opts]=true;}}// console.log("hello")
// extract informaion from V
// don't waste variables xD hahahahha
var vars_flat={};_i=0;var v_keys=Object.keys(result.v);var v_=result.v;for(_i=0;_i<v_keys.length;_i+=1){var _idx2=v_keys[_i];var _now_2=v_[_idx2];if((typeof _now_2==='undefined'?'undefined':_typeof(_now_2))=='object'&&_now_2.length>1){for(var _j3=0;_j3<_now_2.length;_j3+=1){var _jdx3=_now_2[_j3];if(_j3==0){vars_flat[_idx2]=_jdx3;}else{var _mk=getFirstMultipleParent(_idx2);if(typeof _mk!="undefined"){// debugger;
if(typeof __WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(_mk)!='undefined')vars_flat[_idx2+'_'+__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(_mk)[_j3-1]]=_jdx3;}}}}else{vars_flat[_idx2]=(typeof _now_2==='undefined'?'undefined':_typeof(_now_2))=='object'?_now_2[0]:_now_2;}}// console.log(options_flat)
result.oF=options_flat;result.vF=vars_flat;result.cF=checkbox_flat;// result.o_ = on_opts;
return result;}return state;}

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_utils_phoneNumber__ = __webpack_require__(877);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/SendInBlue.js
 * Author: Amine Azizi
 * Version: 1.0
*/var LpSendInBluekOps=function(){function LpSendInBluekOps(){_classCallCheck(this,LpSendInBluekOps);this.sendinblueVars={};}_createClass(LpSendInBluekOps,[{key:'sendInBlueNotification',value:function sendInBlueNotification(){var _obj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _this=this;var isAssist=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var callback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};// console log senindblue
console.log("SB isAssist",isAssist);try{if(!isAssist){var _userEmail=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().account_settings.mail;// Test if execute script here
console.log("mail",__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().account_settings.mail);var chosenPack=void 0;var price=void 0;if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].store.getState().appstate===2||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].store.getState().appstate===1||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].store.getState().appstate===3){var chosen=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].store.getState().checkout_operations.pack;if(chosen===0)chosenPack='Third Pack';else if(chosen===1)chosenPack='Second Pack';else chosenPack='Firs Pack';this.sendinblueVars={"email_id":_userEmail.toLowerCase(),"Client_type":__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().contract.client_type?'pro':'ind',"Document":__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().contract.name,"UNIQID":__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractUniqid,"Reprise":"www.legalplace.fr/contrats/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractTitle+"/continuer/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractUniqid+"?ref=relmail","CHOSEN_PACK":chosenPack,"PRICE":price,"AB":Math.floor(Math.random()*2),'C_CODE_10':_obj.c_codes&&_obj.c_codes[0]?_obj.c_codes[0]:'','C_CODE_20':_obj.c_codes&&_obj.c_codes[1]?_obj.c_codes[1]:'','C_CODE_30':_obj.c_codes&&_obj.c_codes[2]?_obj.c_codes[2]:'','CODE_PARRAINAGE':_obj.refferal_code,'TELECHARGEMENT':"www.legalplace.fr/rt/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractUniqid,'CODE_PARRAINAGE_USAGE':_obj.refferal_code_usage,'CHECKOUT':"www.legalplace.fr/contrats/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractTitle+"/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractUniqid+"/paiement?ref=relmail",'DOCUMENT':__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().contract.name,'CHECKOUTS_COUNT':_obj.counts?_obj.counts.checkouts_count:'',//'CHECKOUTS_MOD_4': _obj.counts ? _obj.counts.checkouts_mod_4 : '',
'DESABONNEMENT':_obj.desabonnement,'URL_ENTREE':localStorage.getItem('URL_ENTREE')//'ML_LINK': _obj.ml_link
};// Sendinblue password var
if(_obj.pwd!==false){this.sendinblueVars['PWD']=_obj.pwd;}}if(_obj.counts){var CMODF=_obj.counts.checkouts_mod_4;this.sendinblueVars["DOCUMENT_"+CMODF]=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().contract.name;this.sendinblueVars["REPRISE_"+CMODF]="www.legalplace.fr/contrats/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractTitle+"/continuer/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractUniqid+"?ref=relmail";this.sendinblueVars["CHECKOUT_"+CMODF]="www.legalplace.fr/contrats/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractTitle+"/"+__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractUniqid+"/paiement?ref=relmail";this.sendinblueVars["CHECKOUT"]=this.sendinblueVars["CHECKOUT_"+CMODF];this.sendinblueVars["DOCUMENT"]=this.sendinblueVars["DOCUMENT_"+CMODF];}}// Test if execute script here
var userEmail=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().account_settings.mail||_obj.user.email;var sib=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.slack_notification.sendinblue;try{sib.forEach(function(idx){if(idx.name==="TEL"){_this.sendinblueVars[idx.name]=idx.type==='option'?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(idx.id)?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(idx.id).value:'No value':__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(idx.id)?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(idx.id).value:'No value';var smsNumber=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(idx.id)?Object(__WEBPACK_IMPORTED_MODULE_1__logic_utils_phoneNumber__["a" /* formatMobilePhone */])(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(idx.id).value):'';if(smsNumber)_this.sendinblueVars["SMS"]=smsNumber;}});}catch(error){console.error('variable extraxction failed',error);}console.log("Info SendinBlue",this.sendinblueVars);console.log("email-user:",userEmail);if(typeof window.sendinblue!=='undefined'){window.sendinblue.identify(userEmail.toLowerCase(),this.sendinblueVars);setTimeout(function(){callback();},500);}// Track Datalayer
__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].ops.slack.sendExtractionAttributesSBToDatalayer(this.sendinblueVars);}catch(err){console.log('SB error '+err);}}}]);return LpSendInBluekOps;}();/* harmony default export */ __webpack_exports__["a"] = (LpSendInBluekOps);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParseError; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://stackoverflow.com/a/46971044/970769
var ParseError = function ParseError(code) {
  _classCallCheck(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};


ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;
//# sourceMappingURL=ParseError.js.map

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* unused harmony export extractFormattedPhoneNumber */
/* harmony export (immutable) */ __webpack_exports__["e"] = stripNationalPrefixAndCarrierCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = findCountryCode;
/* harmony export (immutable) */ __webpack_exports__["f"] = stripNationalPrefixAndCarrierCodeFromCompleteNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = extractCountryCallingCode;
/* harmony export (immutable) */ __webpack_exports__["c"] = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ParseError__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isViablePhoneNumber__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extension__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parseIncompletePhoneNumber__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getCountryCallingCode__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getNumberType___ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isPossibleNumber___ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IDD__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RFC3966__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PhoneNumber__ = __webpack_require__(164);
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js












 // We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PLUS_CHARS */] + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']'); // Regular expression of trailing characters that we want to remove.

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']+$');
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // `options`:
//  {
//    country:
//    {
//      restrict - (a two-letter country code)
//                 the phone number must be in this country
//
//      default - (a two-letter country code)
//                default country to use for phone number parsing and validation
//                (if no country code could be derived from the phone number)
//    }
//  }
//
// Returns `{ country, number }`
//
// Example use cases:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* default */](metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_2__ParseError__["a" /* default */]('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_2__ParseError__["a" /* default */]('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_2__ParseError__["a" /* default */]('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MIN_LENGTH_FOR_NSN */]) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_2__ParseError__["a" /* default */]('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* MAX_LENGTH_FOR_NSN */]) {
    if (options.v2) {
      throw new __WEBPACK_IMPORTED_MODULE_2__ParseError__["a" /* default */]('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new __WEBPACK_IMPORTED_MODULE_12__PhoneNumber__["a" /* default */](countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && Object(__WEBPACK_IMPORTED_MODULE_9__isPossibleNumber___["b" /* isPossibleNumber */])(nationalNumber, countryCallingCode !== undefined, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} throwOnError — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function extractFormattedPhoneNumber(text, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new __WEBPACK_IMPORTED_MODULE_2__ParseError__["a" /* default */]('TOO_LONG');
    }

    return;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function stripNationalPrefixAndCarrierCode(number, metadata) {
  if (number && metadata.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // If a "capturing group" didn't match
      // then its element in `prefixMatch[]` array will be `undefined`.

      var capturedGroupsCount = prefixMatch.length - 1;

      if (metadata.nationalPrefixTransformRule() && capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount]) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // Carrier code is the last captured group,
        // but only when there's more than one captured group.

        if (capturedGroupsCount > 1 && prefixMatch[capturedGroupsCount]) {
          carrierCode = prefixMatch[1];
        }
      } // If it's a simple-enough case then just
      // strip the national prefix from the number.
      else {
          // National prefix is the whole substring matched by
          // the `national_prefix_for_parsing` regexp.
          var nationalPrefix = prefixMatch[0];
          nationalNumber = number.slice(nationalPrefix.length); // Carrier code is the last captured group.

          if (capturedGroupsCount > 0) {
            carrierCode = prefixMatch[1];
          }
        } // We require that the national (significant) number remaining after
      // stripping the national prefix and carrier code be long enough
      // to be a possible length for the region. Otherwise, we don't do
      // the stripping, since the original number could be a valid number.
      // For example, in some countries (Russia, Belarus) the same digit
      // could be both a national prefix and a leading digit of a valid
      // national phone number, like `8` is the national prefix for Russia
      // and `800 555 35 35` is a valid national (significant) number.


      if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(number, metadata.nationalNumberPattern()) && !Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(nationalNumber, metadata.nationalNumberPattern())) {// Don't strip national prefix or carrier code.
      } else {
        return {
          nationalNumber: nationalNumber,
          carrierCode: carrierCode
        };
      }
    }
  }

  return {
    nationalNumber: number
  };
}
function findCountryCode(callingCode, nationalPhoneNumber, metadata) {
  /* istanbul ignore if */
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  } // Is always non-empty, because `callingCode` is always valid


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return _findCountryCode(possibleCountries, nationalPhoneNumber, metadata.metadata);
} // Changes `metadata` `country`.

function _findCountryCode(possibleCountries, nationalPhoneNumber, metadata) {
  metadata = new __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* default */](metadata);

  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var country = _ref;
    metadata.country(country); // Leading digits check would be the simplest one

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (Object(__WEBPACK_IMPORTED_MODULE_8__getNumberType___["b" /* default */])({
        phone: nationalPhoneNumber,
        country: country
      }, undefined, metadata.metadata)) {
        return country;
      }
  }
}
/**
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_11__RFC3966__["b" /* parseRFC3966 */])(text);
  }

  var number = extractFormattedPhoneNumber(text, v2); // If the phone number is not viable, then abort.

  if (!number || !Object(__WEBPACK_IMPORTED_MODULE_4__isViablePhoneNumber__["a" /* default */])(number)) {
    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = Object(__WEBPACK_IMPORTED_MODULE_5__extension__["c" /* extractExtension */])(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(Object(__WEBPACK_IMPORTED_MODULE_6__parseIncompletePhoneNumber__["a" /* default */])(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.chooseCountryByCountryCallingCode(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
      metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

      if (defaultCountry) {
        country = defaultCountry;
      } else {
        /* istanbul ignore if */
        if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
          if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
            country = '001';
          }
        }
      }

      countryCallingCode = defaultCallingCode || Object(__WEBPACK_IMPORTED_MODULE_7__getCountryCallingCode__["a" /* default */])(defaultCountry, metadata.metadata);
    } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _stripNationalPrefixA = stripNationalPrefixAndCarrierCodeFromCompleteNumber(Object(__WEBPACK_IMPORTED_MODULE_6__parseIncompletePhoneNumber__["a" /* default */])(number), metadata),
      nationalNumber = _stripNationalPrefixA.nationalNumber,
      carrierCode = _stripNationalPrefixA.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = findCountryCode(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */


function stripNationalPrefixAndCarrierCodeFromCompleteNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _stripNationalPrefixA2 = stripNationalPrefixAndCarrierCode(Object(__WEBPACK_IMPORTED_MODULE_6__parseIncompletePhoneNumber__["a" /* default */])(number), metadata),
      nationalNumber = _stripNationalPrefixA2.nationalNumber,
      carrierCode = _stripNationalPrefixA2.carrierCode; // If a national prefix has been extracted, check to see
  // if the resultant number isn't too short.


  if (nationalNumber.length !== number.length + (carrierCode ? carrierCode.length : 0)) {
    // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    if (metadata.possibleLengths()) {
      // "We require that the NSN remaining after stripping the national prefix and
      // carrier code be long enough to be a possible length for the region.
      // Otherwise, we don't do the stripping, since the original number could be
      // a valid short number."
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      switch (Object(__WEBPACK_IMPORTED_MODULE_8__getNumberType___["a" /* checkNumberLengthForType */])(nationalNumber, undefined, metadata)) {
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
          // case 'IS_POSSIBLE_LOCAL_ONLY':
          // Don't strip the national prefix.
          return {
            nationalNumber: number
          };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = Object(__WEBPACK_IMPORTED_MODULE_10__IDD__["b" /* stripIDDPrefix */])(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin2.countryCallingCode,
            shorterNumber = _extractCountryCallin2.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* default */](metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* MAX_LENGTH_COUNTRY_CODE */] && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(undefined, _countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}
/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? Object(__WEBPACK_IMPORTED_MODULE_7__getCountryCallingCode__["a" /* default */])(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* default */](metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _stripNationalPrefixA3 = stripNationalPrefixAndCarrierCode(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _stripNationalPrefixA3.nationalNumber;

    var _stripNationalPrefixA4 = stripNationalPrefixAndCarrierCode(number, metadata),
        nationalNumber = _stripNationalPrefixA4.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(nationalNumber, metadata.nationalNumberPattern()) && Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || Object(__WEBPACK_IMPORTED_MODULE_8__getNumberType___["a" /* checkNumberLengthForType */])(nationalNumber, undefined, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
//# sourceMappingURL=parse_.js.map

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXTN_PATTERNS_FOR_PARSING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXTN_PATTERNS_FOR_MATCHING; });
/* harmony export (immutable) */ __webpack_exports__["c"] = extractExtension;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
 // The RFC 3966 format for extensions.

var RFC3966_EXTN_PREFIX = ';ext='; // Pattern to capture digits used in an extension.
// Places a maximum length of '7' for an extension.

var CAPTURING_EXTN_DIGITS = '([' + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']{1,7})';
/**
 * Regexp of all possible ways to write extensions, for use when parsing. This
 * will be run as a case-insensitive regexp match. Wide character versions are
 * also provided after each ASCII version. There are three regular expressions
 * here. The first covers RFC 3966 format, where the extension is added using
 * ';ext='. The second more generic one starts with optional white space and
 * ends with an optional full stop (.), followed by zero or more spaces/tabs
 * /commas and then the numbers themselves. The other one covers the special
 * case of American numbers where the extension is written with a hash at the
 * end, such as '- 503#'. Note that the only capturing groups should be around
 * the digits that you want to capture as part of the extension, or else parsing
 * will fail! We allow two options for representing the accented o - the
 * character itself, and one in the unicode decomposed form with the combining
 * acute accent.
 */

function create_extension_pattern(purpose) {
  // One-character symbols that can be used to indicate an extension.
  var single_extension_characters = "x\uFF58#\uFF03~\uFF5E";

  switch (purpose) {
    // For parsing, we are slightly more lenient in our interpretation than for matching. Here we
    // allow "comma" and "semicolon" as possible extension indicators. When matching, these are
    case 'parsing':
      single_extension_characters = ',;' + single_extension_characters;
  }

  return RFC3966_EXTN_PREFIX + CAPTURING_EXTN_DIGITS + '|' + "[ \xA0\\t,]*" + "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|" + // "доб."
  "\u0434\u043E\u0431|" + '[' + single_extension_characters + "]|int|anexo|\uFF49\uFF4E\uFF54)" + "[:\\.\uFF0E]?[ \xA0\\t,-]*" + CAPTURING_EXTN_DIGITS + '#?|' + '[- ]+([' + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']{1,5})#';
}
/**
 * Regexp of all possible ways to write extensions, for use when parsing. This
 * will be run as a case-insensitive regexp match. Wide character versions are
 * also provided after each ASCII version. There are three regular expressions
 * here. The first covers RFC 3966 format, where the extension is added using
 * ';ext='. The second more generic one starts with optional white space and
 * ends with an optional full stop (.), followed by zero or more spaces/tabs
 * /commas and then the numbers themselves. The other one covers the special
 * case of American numbers where the extension is written with a hash at the
 * end, such as '- 503#'. Note that the only capturing groups should be around
 * the digits that you want to capture as part of the extension, or else parsing
 * will fail! We allow two options for representing the accented o - the
 * character itself, and one in the unicode decomposed form with the combining
 * acute accent.
 */


var EXTN_PATTERNS_FOR_PARSING = create_extension_pattern('parsing');
var EXTN_PATTERNS_FOR_MATCHING = create_extension_pattern('matching'); // Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + EXTN_PATTERNS_FOR_PARSING + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var number_without_extension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i] != null && matches[i].length > 0) {
      return {
        number: number_without_extension,
        ext: matches[i]
      };
    }

    i++;
  }
}
//# sourceMappingURL=extension.js.map

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIDDPrefix;
/* harmony export (immutable) */ __webpack_exports__["b"] = stripIDDPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(81);


var CAPTURING_DIGIT_PATTERN = new RegExp('([' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* VALID_DIGITS */] + '])');
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIDDPrefix(country, callingCode, metadata) {
  var countryMetadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (SINGLE_IDD_PREFIX.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }

  return countryMetadata.defaultIDDPrefix();
}
function stripIDDPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // Some kind of a weird edge case.
  // No explanation from Google given.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  /* istanbul ignore next */

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
//# sourceMappingURL=IDD.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRFC3966;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRFC3966;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isViablePhoneNumber__ = __webpack_require__(374);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var part = _ref;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isViablePhoneNumber__["a" /* default */])(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref2) {
  var number = _ref2.number,
      ext = _ref2.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNumberType___ = __webpack_require__(129);



/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__getNumberType___["b" /* default */])(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(national_number, metadata.nationalNumberPattern());
}
//# sourceMappingURL=validate_.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumberMatcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extension__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__findNumbers_RegExpCache__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__findNumbers_util__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findNumbers_Leniency__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__findNumbers_parsePreCandidate__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__findNumbers_isValidPreCandidate__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__findNumbers_isValidCandidate__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__parse___ = __webpack_require__(240);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A port of Google's `PhoneNumberMatcher.java`.
 * https://github.com/googlei18n/libphonenumber/blob/master/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberMatcher.java
 * Date: 08.03.2018.
 */












/**
 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
 * ordered according to specificity. For example, white-space is last since that is frequently
 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
 * want to break up the phone-number-like text on more than one different kind of symbol at one
 * time, although symbols of the same type (e.g. space) can be safely grouped together.
 *
 * Note that if there is a match, we will always check any text found up to the first match as
 * well.
 */

var INNER_MATCHES = [// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
'\\/+(.*)/', // Note that the bracket here is inside the capturing group, since we consider it part of the
// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
// We require a space on either side of the hyphen for it to be considered a separator.
"(?:".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "-|-").concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], ")").concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
// possible that it's supposed to be used to break two numbers without spaces, and we haven't
// seen many instances of it used within a number.
"[\u2012-\u2015\uFF0D]".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
"\\.+".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
"".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["g" /* pZ */], "+(").concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["a" /* PZ */], "+)")]; // Limit on the number of leading (plus) characters.

var leadLimit = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["b" /* limit */])(0, 2); // Limit on the number of consecutive punctuation characters.

var punctuationLimit = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["b" /* limit */])(0, 4);
/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
 * single block, set high enough to accommodate the entire national number and the international
 * country code. */

var digitBlockLimit = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* MAX_LENGTH_FOR_NSN */] + __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* MAX_LENGTH_COUNTRY_CODE */]; // Limit on the number of blocks separated by punctuation.
// Uses digitBlockLimit since some formats use spaces to separate each digit.

var blockLimit = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["b" /* limit */])(0, digitBlockLimit);
/* A punctuation sequence allowing white space. */

var punctuation = "[".concat(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* VALID_PUNCTUATION */], "]") + punctuationLimit; // A digits block without punctuation.

var digitSequence = __WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["f" /* pNd */] + Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["b" /* limit */])(1, digitBlockLimit);
/**
 * Phone number pattern allowing optional punctuation.
 * The phone number pattern used by `find()`, similar to
 * VALID_PHONE_NUMBER, but with the following differences:
 * <ul>
 *   <li>All captures are limited in order to place an upper bound to the text matched by the
 *       pattern.
 * <ul>
 *   <li>Leading punctuation / plus signs are limited.
 *   <li>Consecutive occurrences of punctuation are limited.
 *   <li>Number of digits is limited.
 * </ul>
 *   <li>No whitespace is allowed at the start or end.
 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
 * </ul>
 */

var PATTERN = '(?:' + __WEBPACK_IMPORTED_MODULE_9__findNumbers_isValidCandidate__["a" /* LEAD_CLASS */] + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + __WEBPACK_IMPORTED_MODULE_2__extension__["a" /* EXTN_PATTERNS_FOR_MATCHING */] + ')?'; // Regular expression of trailing characters that we want to remove.
// We remove all characters that are not alpha or numerical characters.
// The hash character is retained here, as it may signify
// the previous block was an extension.
//
// // Don't know what does '&&' mean here.
// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
//

var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["c" /* _pN */]).concat(__WEBPACK_IMPORTED_MODULE_5__findNumbers_utf_8__["b" /* _pL */], "#]+$"));
var NON_DIGITS_PATTERN = /(\D+)/;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
 * {@link PhoneNumberUtil}.
 *
 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
 * not found.
 *
 * <p>This class is not thread-safe.
 */

var PhoneNumberMatcher =
/*#__PURE__*/
function () {
  /** The iteration tristate. */

  /** The next index to start searching at. Undefined in {@link State#DONE}. */
  // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
  // countries being used for the same doc with ~10 patterns for each country. Some pages will have
  // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
  // that use-case won't have a lot of benefit.

  /**
   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
   * new instance.
   *
   * @param util  the phone number util to use
   * @param text  the character sequence that we will search, null for no text
   * @param country  the country to assume for phone numbers not written in international format
   *     (with a leading plus, or with the international dialing prefix of the specified region).
   *     May be null or "ZZ" if only numbers with a leading plus should be
   *     considered.
   * @param leniency  the leniency to use when evaluating candidate phone numbers
   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
   *     be {@code >= 0}.
   */
  function PhoneNumberMatcher() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metadata = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, PhoneNumberMatcher);

    _defineProperty(this, "state", 'NOT_READY');

    _defineProperty(this, "searchIndex", 0);

    _defineProperty(this, "regExpCache", new __WEBPACK_IMPORTED_MODULE_3__findNumbers_RegExpCache__["a" /* default */](32));

    options = _objectSpread({}, options, {
      defaultCallingCode: options.defaultCallingCode,
      defaultCountry: options.defaultCountry && Object(__WEBPACK_IMPORTED_MODULE_10__metadata__["d" /* isSupportedCountry */])(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
      maxTries: options.maxTries || MAX_SAFE_INTEGER
    });

    if (!options.leniency) {
      throw new TypeError('`Leniency` not supplied');
    }

    if (options.maxTries < 0) {
      throw new TypeError('`maxTries` not supplied');
    }

    this.text = text;
    this.options = options;
    this.metadata = metadata;
    /** The degree of validation requested. */

    this.leniency = __WEBPACK_IMPORTED_MODULE_6__findNumbers_Leniency__["a" /* default */][options.leniency];

    if (!this.leniency) {
      throw new TypeError("Unknown leniency: ".concat(options.leniency, "."));
    }
    /** The maximum number of retries after matching an invalid number. */


    this.maxTries = options.maxTries;
    this.PATTERN = new RegExp(PATTERN, 'ig');
  }
  /**
   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
   * that represents a phone number. Returns the next match, null if none was found.
   *
   * @param index  the search index to start searching at
   * @return  the phone number match found, null if none can be found
   */


  _createClass(PhoneNumberMatcher, [{
    key: "find",
    value: function find() // (index)
    {
      // // Reset the regular expression.
      // this.PATTERN.lastIndex = index
      var matches;

      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
        var candidate = matches[0];
        var offset = matches.index;
        candidate = Object(__WEBPACK_IMPORTED_MODULE_7__findNumbers_parsePreCandidate__["a" /* default */])(candidate);

        if (Object(__WEBPACK_IMPORTED_MODULE_8__findNumbers_isValidPreCandidate__["a" /* default */])(candidate, offset, this.text)) {
          var match = // Try to come up with a valid match given the entire candidate.
          this.parseAndVerify(candidate, offset, this.text) // If that failed, try to find an "inner match" -
          // there might be a phone number within this candidate.
          || this.extractInnerMatch(candidate, offset, this.text);

          if (match) {
            if (this.options.v2) {
              var phoneNumber = new __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__["a" /* default */](match.country || match.countryCallingCode, match.phone, this.metadata);

              if (match.ext) {
                phoneNumber.ext = match.ext;
              }

              return {
                startsAt: match.startsAt,
                endsAt: match.endsAt,
                number: phoneNumber
              };
            }

            return match;
          }
        }

        this.maxTries--;
      }
    }
    /**
     * Attempts to extract a match from `candidate`
     * if the whole candidate does not qualify as a match.
     */

  }, {
    key: "extractInnerMatch",
    value: function extractInnerMatch(candidate, offset, text) {
      for (var _i = 0, _INNER_MATCHES = INNER_MATCHES; _i < _INNER_MATCHES.length; _i++) {
        var innerMatchPattern = _INNER_MATCHES[_i];
        var isFirstMatch = true;
        var matches = void 0;
        var possibleInnerMatch = new RegExp(innerMatchPattern, 'g');

        while ((matches = possibleInnerMatch.exec(candidate)) !== null && this.maxTries > 0) {
          if (isFirstMatch) {
            // We should handle any group before this one too.
            var _group = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["d" /* trimAfterFirstMatch */])(UNWANTED_END_CHAR_PATTERN, candidate.slice(0, matches.index));

            var _match = this.parseAndVerify(_group, offset, text);

            if (_match) {
              return _match;
            }

            this.maxTries--;
            isFirstMatch = false;
          }

          var group = Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_util__["d" /* trimAfterFirstMatch */])(UNWANTED_END_CHAR_PATTERN, matches[1]); // Java code does `groupMatcher.start(1)` here,
          // but there's no way in javascript to get a group match start index,
          // therefore using the overall match start index `matches.index`.

          var match = this.parseAndVerify(group, offset + matches.index, text);

          if (match) {
            return match;
          }

          this.maxTries--;
        }
      }
    }
    /**
     * Parses a phone number from the `candidate` using `parseNumber` and
     * verifies it matches the requested `leniency`. If parsing and verification succeed,
     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
     *
     * @param candidate  the candidate match
     * @param offset  the offset of {@code candidate} within {@link #text}
     * @return  the parsed and validated phone number match, or null
     */

  }, {
    key: "parseAndVerify",
    value: function parseAndVerify(candidate, offset, text) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__findNumbers_isValidCandidate__["b" /* default */])(candidate, offset, text, this.options.leniency)) {
        return;
      }

      var number = Object(__WEBPACK_IMPORTED_MODULE_11__parse___["a" /* default */])(candidate, {
        extended: true,
        defaultCountry: this.options.defaultCountry,
        defaultCallingCode: this.options.defaultCallingCode
      }, this.metadata);

      if (!number.possible) {
        return;
      }

      if (this.leniency(number, candidate, this.metadata, this.regExpCache)) {
        // // We used parseAndKeepRawInput to create this number,
        // // but for now we don't return the extra values parsed.
        // // TODO: stop clearing all values here and switch all users over
        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
        // number.clearCountryCodeSource()
        // number.clearRawInput()
        // number.clearPreferredDomesticCarrierCode()
        var result = {
          startsAt: offset,
          endsAt: offset + candidate.length,
          phone: number.phone
        };

        if (number.country && number.country !== '001') {
          result.country = number.country;
        } else {
          result.countryCallingCode = number.countryCallingCode;
        }

        if (number.ext) {
          result.ext = number.ext;
        }

        return result;
      }
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.lastMatch = this.find(); // (this.searchIndex)

        if (this.lastMatch) {
          // this.searchIndex = this.lastMatch.endsAt
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      } // Don't retain that memory any longer than necessary.


      var result = this.lastMatch;
      this.lastMatch = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberMatcher;
}();


//# sourceMappingURL=PhoneNumberMatcher.js.map

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(48);
var normalizeHeaderName = __webpack_require__(900);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(384);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(384);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/*global exports*/
var SignStream = __webpack_require__(915);
var VerifyStream = __webpack_require__(1000);

var ALGORITHMS = [
  'HS256', 'HS384', 'HS512',
  'RS256', 'RS384', 'RS512',
  'PS256', 'PS384', 'PS512',
  'ES256', 'ES384', 'ES512'
];

exports.ALGORITHMS = ALGORITHMS;
exports.sign = SignStream.sign;
exports.verify = VerifyStream.verify;
exports.decode = VerifyStream.decode;
exports.isValid = VerifyStream.isValid;
exports.createSign = function createSign(opts) {
  return new SignStream(opts);
};
exports.createVerify = function createVerify(opts) {
  return new VerifyStream(opts);
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(392);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(250);
exports.Duplex = __webpack_require__(98);
exports.Transform = __webpack_require__(395);
exports.PassThrough = __webpack_require__(925);


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(167);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(130));
util.inherits = __webpack_require__(7);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(923)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(393);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(5).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(394);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(98);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(98);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(921).setImmediate, __webpack_require__(32)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(924).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(7)
var HashBase = __webpack_require__(397)
var Buffer = __webpack_require__(5).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(27).Buffer
var inherits = __webpack_require__(7)
var HashBase = __webpack_require__(397)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(932)
exports.sha1 = __webpack_require__(933)
exports.sha224 = __webpack_require__(934)
exports.sha256 = __webpack_require__(398)
exports.sha384 = __webpack_require__(935)
exports.sha512 = __webpack_require__(399)


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(49);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(944)
var deciphers = __webpack_require__(952)
var modes = __webpack_require__(411)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(945),
  CBC: __webpack_require__(946),
  CFB: __webpack_require__(947),
  CFB8: __webpack_require__(948),
  CFB1: __webpack_require__(949),
  OFB: __webpack_require__(950),
  CTR: __webpack_require__(409),
  GCM: __webpack_require__(409)
}

var modes = __webpack_require__(411)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(956);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(30);
var randomBytes = __webpack_require__(112);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(961).version;
elliptic.utils = __webpack_require__(50);
elliptic.rand = __webpack_require__(258);
elliptic.curve = __webpack_require__(417);
elliptic.curves = __webpack_require__(261);

// Protocols
elliptic.ec = __webpack_require__(972);
elliptic.eddsa = __webpack_require__(976);


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(262);
var curve = __webpack_require__(417);
var utils = __webpack_require__(50);

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(971);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(65);
hash.common = __webpack_require__(133);
hash.sha = __webpack_require__(965);
hash.ripemd = __webpack_require__(969);
hash.hmac = __webpack_require__(970);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toDate;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toDate(date) {
  (0, _assertString2.default)(date);
  date = Date.parse(date);
  return !isNaN(date) ? new Date(date) : null;
}
module.exports = exports['default'];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = toString;
function toString(input) {
  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && input !== null) {
    if (typeof input.toString === 'function') {
      input = input.toString();
    } else {
      input = '[object Object]';
    }
  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
    input = '';
  }
  return String(input);
}
module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(114);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_siblings__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_radio_show__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_action_counter__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logic_condition_evo__ = __webpack_require__(29);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\misc\radio.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// what.
// additional components
var inlineStyle={width:'80%'};// we have key, label, parent, id
var SingleRadio=function(_Component){_inherits(SingleRadio,_Component);function SingleRadio(props){_classCallCheck(this,SingleRadio);// the elasticity
var _this=_possibleConstructorReturn(this,(SingleRadio.__proto__||Object.getPrototypeOf(SingleRadio)).call(this,props));_this.params=Object.assign({},props);// TODO: ommit this one test
if('key'in props)_this.key=props.key;else _this.key=props.lpKey;// Creates the this thing.
_this.clickCallback=_this.clickCallback.bind(_this);//
return _this;}_createClass(SingleRadio,[{key:'componentWillMount',value:function componentWillMount(){var id=this.props.copy===-2?this.props.id:this.props.id+'_'+this.props.copy;var _lpApp$indexes$option=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.options.getOption(id),value=_lpApp$indexes$option.value;if(!this.props.exists){this.props.initOutputSystem(this.props.id,this.props.lpKey,this.props.ovc,value,this.props.isDuplicate,this.props.copy);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(!nextProps.i_update||__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].action_tracker.last_action==='EDIT_VARIABLE_VALUE_'||__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].action_tracker.last_action==='IC_SET_VARIABLE_'||__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].action_tracker.last_action==='IC_SET_OPTION_'){return false;}return true;}},{key:'clickCallback',value:function clickCallback(){this.props.changeValue(this.props.id,this.props.group,this.props.isDuplicate,this.props.copy);Object(__WEBPACK_IMPORTED_MODULE_4__utils_siblings__["a" /* endEditionMode */])(this.lpKey,false);Object(__WEBPACK_IMPORTED_MODULE_6__utils_radio_show__["b" /* rsRegisterAction */])(this.props.id,this.props.parent,this.props.isDuplicate,this.props.copy);var cId=this.props.id;if(this.props.isDuplicate){cId=cId+'_'+this.props.copy;}Object(__WEBPACK_IMPORTED_MODULE_7__logic_action_counter__["c" /* raiseOption */])(cId);}},{key:'render',value:function render(){var _this2=this;// If option's condition isn't respected, let's stop right here
if(this.props.condition===false)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'radio','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy,className:'form-group wzog-option'+(!__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.two_steps.isDiscovered(this.props.id,'option')?' highlight-second':''),key:'rad_'+Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["c" /* guid */])()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',onClick:function onClick(evt){return _this2.clickCallback(evt);},onChange:function onChange(){},key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),name:this.props.isDuplicate?this.props.group+'_'+this.props.copy:this.props.group,id:this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id// value={ this.props.label }
,style:inlineStyle,checked:this.props.is_checked}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id},'just_me'in this.props&&this.props.just_me?this.props.id?__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.label:'None':this.props.label,' ','helper'in __WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta&&__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.helper})));}}]);return SingleRadio;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){// the thing
var checked=false;var exists=false;var existsKey='';var existsParent='';var condition=true;if(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].action_tracker.last_action==='EDIT_VARIABLE_VALUE_'){return{i_update:false,exists:true};}// get if i'ts checked
var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){var lpOption=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(cId);if(typeof lpOption!=='undefined'){exists=true;checked=lpOption.value;existsKey=lpOption.key;}}if(ownProps.ovc==='v'){var _lpOption=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(cId);if(typeof _lpOption!=='undefined'){exists=true;checked=_lpOption.value;existsKey=_lpOption.key;}}var option_ref=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(ownProps.id);if((typeof option_ref==='undefined'?'undefined':_typeof(option_ref))==='object'&&option_ref.meta.conditional){condition=__WEBPACK_IMPORTED_MODULE_12__logic_condition_evo__["a" /* default */].getCondition(cId);}return{// exists: checkUIExists(state.flat, ownProps.id, ownProps.genre),
sectionId:state.contract.currentSection,checked:checked,exists:exists,condition:condition,existant_key:existsKey,existant_parent:existsParent};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{initOutputSystem:function initOutputSystem(id,parent,genre,value,isDuplicate,copy){//
// check duplication
var cId=!isDuplicate?id:id+'_'+copy;var cPid=!isDuplicate?parent:parent+'_'+copy;if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(cId,cPid,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(cId,cPid,value));},changeValue:function changeValue(id,parent,isDuplicate,copy){var cId=!isDuplicate?id:id+'_'+copy;var cPid=!isDuplicate?parent:parent+'_'+copy;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["j" /* checkRadio1 */])(cId,cPid));dispatch({type:'UPDATE_SECTIONS_C'});if(!Object(__WEBPACK_IMPORTED_MODULE_10__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["o" /* editedDocument */])(true));}};};var LpSingleRadio=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SingleRadio);/* harmony default export */ __webpack_exports__["a"] = (LpSingleRadio);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rsRegisterAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rsDoICome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rsRemove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_condition_evo__ = __webpack_require__(29);
/*
* Project: LegalPlace assistant
* File: src/components/utils/radio_show.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// Solving the problem to which parent are able to show their radio children or not.
var radioParents={};function rsRegisterAction(id,parent,isDuplicate,copy){var actualComponent=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.getOption(id);if(actualComponent.meta.type!=='radio')return false;var pId=isDuplicate?parent+'_'+copy:parent;if(actualComponent.children.length===0&&actualComponent.variables.length===0){// build key
radioParents[pId]=true;}else if(actualComponent.variables.length>0){radioParents[pId]=false;}else{var children=actualComponent.children;// let variables = actualComponent.variables;
var hAwlad=true;children.map(function(idx){if(__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.getOption(idx).meta.type!=='hidden'){// test the conditional thing
var wOption=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.getOption(idx);if(wOption.meta.conditional&&wOption.meta.compiledConditions.length>0){// let c = new ConditionRuntime(wOption.meta.compiledConditions);
// c.compileDirect();
// if(c.execute())
//     hAwlad = false;
// let c = new ConditionRuntime(wOption.meta.compiledConditions);
// c.compileDirect();
if(__WEBPACK_IMPORTED_MODULE_1__logic_condition_evo__["a" /* default */].getCondition(idx))hAwlad=false;}else hAwlad=false;}});radioParents[pId]=hAwlad?true:undefined;}window.aaaa=radioParents;return true;}function rsRemove(id){var newRadios={};Object.keys(radioParents).map(function(idx){if(idx!==id)newRadios[idx]=radioParents[idx];});radioParents=newRadios;}function rsDoICome(id,parent,isDuplicate,copy){if(typeof id==='undefined')return null;if(id.length)return null;var actualComponent=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.getOption(id);if(actualComponent.meta.type!=='radio'){return null;}var pId=isDuplicate?parent+'_'+copy:parent;return radioParents[pId];}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseLink__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__manager_apiManager__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_experimentsDataHelpers__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_trackingData__ = __webpack_require__(1129);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*
 * LegalPlace payments lib
 */var Stripe=null;var braintree=null;function LpPayment(){this.libReady=false;// Static count variable
if(typeof LpPayment.countCallAdwords=='undefined'){LpPayment.countCallAdwords=0;}// Requests base url
this.base_url=__WEBPACK_IMPORTED_MODULE_3__baseLink__["a" /* default */];this.config={data_uri:this.base_url+'/data',stripe:{publishableKey:"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL"},paypal:{tokenDataUrl:this.base_url+'/json/paypalToken',submitElem:document.getElementById('paypalSubmit')},fetchHeaders:new Headers({Origin:'legalplace.dev'})};// initing things
this.Stripe=null;this.braintree=null;try{this.init();}catch(err){console.log(err);}}/*
 * Payment init
 */LpPayment.prototype.init=function init(){var _this=this;// Initializing checkout libraries
this.initCheckoutLibs().then(function(){// State
var state={stripe:false,paypal:false};// Initializing Stripe
_this.initStripe().then(function(){state.stripe=true;if(state.stripe&&state.paypal){_this.libReady=true;console.log('Ready g');}}).catch(function(err){Object(__WEBPACK_IMPORTED_MODULE_0__errors_error__["b" /* raiseError */])('credit-error',21,err.message);});}).catch(function(){Object(__WEBPACK_IMPORTED_MODULE_0__errors_error__["b" /* raiseError */])('credit-error',10,Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Le paiement a \xE9chou\xE9 en raison d\xB4une erreur inconnue, merci de contacter notre support au '+__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].supportPhone));});};/*
 * Initializing Checkout libraries :
 * - Stripe V2
 * - Gateway V3.6.0 for PayPal
 */LpPayment.prototype.initCheckoutLibs=function initCheckoutLibs(){var _this2=this;return new Promise(function(resolve,reject){var loaded=0;var scriptsList=['https://checkout.stripe.com/checkout.js','https://www.paypal.com/sdk/js?client-id='+"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy"+'&currency=EUR','https://js.stripe.com/v2/'];scriptsList.forEach(function(url){_this2.loadScript(url).then(function(){loaded+=1;if(loaded===scriptsList.length){var _global=global;Stripe=_global.Stripe;braintree=_global.braintree;resolve();}}).catch(function(e){reject(e);});});});};/*
 * Initialize Stripe
 */LpPayment.prototype.initStripe=function(){var _this3=this;return new Promise(function(resolve,reject){if(typeof Stripe==='undefined'){reject(new Error(Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Erreur de chargement, veuillez recharger la page')));}else{Stripe.setPublishableKey(_this3.config.stripe.publishableKey);resolve();}});};/*
 * Handle transaction
 *
 * Expected Data object:
 * {
 *  'pack': (string) chosen pack,
 *  'price': (float) total ttc price,
 *  'locale': (string) current locale (fr_FR|de_DE|etc...)
 *  'option': (object) Option's object,
 *  'invoice': (object) Invoice object,
 *  'contractId': (string) document's id,
 *  'coupon_code': (string) Coupon code,
 *  'type': (srting) payment method[card|paypal],
 *  'card': {
 *    'number': (string) Card number,
 *    'cvc': (string) CVC number,
 *    'exp': (string) Expiration date MM/YY
 *  }
 * }
 */LpPayment.prototype.handleTransaction=function handleTransaction(data){var _this4=this;return new Promise(function(_resolve,reject){// Making sure that the library is ready
if(_this4.libReady!==true&&false){reject(new Error(Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])("Erreur de chargement, veuillez recharger la page")));return;}/**
         * Resolve wrapper function
         *
         * Used to track events & conversions right after
         * a successful payment
         *
         * @param {object} response
         */var resolve=function resolve(response){if(typeof LpPayment.countCallAdwords==='undefined')LpPayment.countCallAdwords=0;LpPayment.countCallAdwords++;window.countCall=LpPayment.countCallAdwords;try{if(LpPayment.countCallAdwords===1){/**
                 * Tracking Paid event with CHOSEN_PACK & Price
                 */__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].track('Paid',{"Chosen Pack":data.pack,"Paid Price":data.price});// Tracking DataLayer
__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].trackGTMFunnel('/checkout',true);if(data.price){__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].trackAbTasty('Paid',{revenue:data.revenue,transactionId:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].contractUniqid,transactionTax:data.price*1/6,transactionCoupon:data.coupon_code,paymentMethod:data.paymentMethod,upsell:data.upsell,itemName:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].getState().contract.name,couponCode:data.coupon_code||data.coupon,itemPrice:data.price,uniqid:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].contractUniqid});}console.log('track paid event');__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].trackGTMOrder(response.orderId,data.orderShipping&&parseFloat(data.orderShipping),data.orderTax&&parseFloat(data.orderTax),data.paymentMethod,typeof data.packPriceWithReduction!=='undefined'&&parseFloat(data.packPriceWithReduction),typeof data.acteProduct==='boolean'&&!data.acteProduct?false:true);var revenue=data.revenue;if(Object.keys(__WEBPACK_IMPORTED_MODULE_7__constants_trackingData__["a" /* ENHANCED_CONVERSION_VALUE_BY_PERMALINK */]).includes(__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].contractTitle))revenue=__WEBPACK_IMPORTED_MODULE_7__constants_trackingData__["a" /* ENHANCED_CONVERSION_VALUE_BY_PERMALINK */][__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].contractTitle];/**
                 * Tracking Adwords conversion
                 */__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].adwordsConversion({google_conversion_id:958034329,google_conversion_label:"t7F-CNm6hIoBEJnj6cgD",google_conversion_value:revenue,google_conversion_currency:"EUR"});/**
                 * Tracking Bing conversion
                 */__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].bingConversion({gv:parseFloat(data.revenue)});/**
                 * Tracking Facebook conversion
                 */__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].facebookConversion({value:parseFloat(data.revenue)});/**
                 * Tracking Google Analytics conversion
                 */__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].gAnalyticsConversion({revenue:parseFloat(data.price)/1.2,price:parseFloat(data.price)/1.2,name:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].getState().contract.name});}}catch(error){console.error(error);}setTimeout(function(){_resolve(response);},2000);};// Checking data
try{switch(data.type){case'abonnement':_this4.handleStripeSubscription(data).then(function(response){resolve(response);}).catch(function(e){reject(e);});break;case'card':_this4.handleStripePayment(data).then(function(response){resolve(response);}).catch(function(e){reject(e);});break;case'sepa_debit':_this4.handleSepaDebit(data).then(function(response){resolve(response);}).catch(function(e){reject(e);});break;case'paypal':_this4.handlePaypalPayment(data).then(function(response){resolve(response);}).catch(function(e){// Notify payment error
reject(e);});break;default:reject(new Error(Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Une erreur inconnue est survenue')));break;}}catch(e){reject(new Error(Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Une erreur inconnue est survenue')));}});};/*
* Handling Stripe subscription
*/LpPayment.prototype.handleStripeSubscription=function handleStripeSubscription(data){var _this5=this;return new Promise(function(resolve,reject){console.log(data);// TODO: VALIDATE DATA
var err=_this5.stripeDataIsValid(data.card);if((typeof err==='undefined'?'undefined':_typeof(err))==='object'){reject(err);return;}// Initializing form data
var formElem=document.createElement('form');// Card
var cardElem=document.createElement('input');cardElem.setAttribute('data-stripe','number');cardElem.value=data.card.number;formElem.appendChild(cardElem);// CVC
var cvcElem=document.createElement('input');cvcElem.setAttribute('data-stripe','cvc');cvcElem.value=data.card.cvc;formElem.appendChild(cvcElem);// Expiration
var expMonth=data.card.exp.split('/')[0].trim();var expYear=data.card.exp.split('/')[1].trim();// Month
var expMonthElem=document.createElement('input');expMonthElem.setAttribute('data-stripe','expMonth');expMonthElem.value=expMonth;formElem.appendChild(expMonthElem);// Year
var expYearElem=document.createElement('input');expYearElem.setAttribute('data-stripe','expYear');expYearElem.value=expYear;formElem.appendChild(expYearElem);// Response Handler
var responseData=data;var handleResponse=function handleResponse(code,response){var errors=[];if(code===200){// Submiting token
var request={stripeToken:response.id,stripeEmail:responseData.client_email,paymentMethod:responseData.type,coupon:responseData.coupon_code||responseData.coupon,is_two_steps:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].getState().contract.is_two_steps,experiments_data:Object(__WEBPACK_IMPORTED_MODULE_6__utils_experimentsDataHelpers__["a" /* getExperimentsData */])()};Object(__WEBPACK_IMPORTED_MODULE_5__manager_apiManager__["b" /* createOrder */])(responseData.contract_id,request).then(function(res){var response=res.data;if(response.STATUS&&response.STATUS==='FAIL'){errors=[].concat(_toConsumableArray(_this5.handleResponseErrors(response.ERROR)));reject(errors);}else{resolve(response);return;}}).catch(function(error){reject(errors);});return;}if([400,401,402,404,409,429].indexOf(code)>-1){// Reading errors
errors=[].concat(_toConsumableArray(_this5.handleResponseErrors(response.error)));}else{errors.push({hook:'global',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Une erreur inconnue s\'est produite pendant la tentative de d\xE9bit de votre carte. Veuillez contacter notre support au '+__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].supportPhone+' ou par email')});}reject(errors);};handleResponse=handleResponse.bind(_this5);// Creating Token
Stripe.card.createToken(formElem,handleResponse);});};/*
 * Handling Stripe payment
 */LpPayment.prototype.handleStripePayment=function handleStripePayment(data){var _this6=this;return new Promise(function(resolve,reject){// Validating Data
var err=_this6.stripeDataIsValid(data.card);// Checking CGV
if(!data.cgv){if((typeof err==='undefined'?'undefined':_typeof(err))!=='object')err=[];err.push({hook:'global',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])("Vous devez lire et accepter nos conditions générales de vente et d'utilisation.")});}if((typeof err==='undefined'?'undefined':_typeof(err))==='object'){reject(err);return;}// Initializing form data
var formElem=document.createElement('form');// Card
var cardElem=document.createElement('input');cardElem.setAttribute('data-stripe','number');cardElem.value=data.card.number;formElem.appendChild(cardElem);// CVC
var cvcElem=document.createElement('input');cvcElem.setAttribute('data-stripe','cvc');cvcElem.value=data.card.cvc;formElem.appendChild(cvcElem);// Expiration
var expMonth=data.card.exp.split('/')[0].trim();var expYear=data.card.exp.split('/')[1].trim();// Month
var expMonthElem=document.createElement('input');expMonthElem.setAttribute('data-stripe','expMonth');expMonthElem.value=expMonth;formElem.appendChild(expMonthElem);// Month
var expYearElem=document.createElement('input');expYearElem.setAttribute('data-stripe','expYear');expYearElem.value=expYear;formElem.appendChild(expYearElem);// Response Handler
var responseData=data;var handleResponse=function handleResponse(code,response){var errors=[];if(code===200){// Submiting token
var request={contract_id:responseData.contract_id,pack:responseData.pack,options:responseData.options,invoice:responseData.invoice,upsell:data.upsell,coupon:responseData.coupon_code||responseData.coupon,stripeToken:response.id,paymentMethod:responseData.paymentMethod,is_two_steps:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].getState().contract.is_two_steps,experiments_data:Object(__WEBPACK_IMPORTED_MODULE_6__utils_experimentsDataHelpers__["a" /* getExperimentsData */])()};if(data.is_installment&&data.is_installment===true)request.is_installment=true;if(data.is_crea_assist_sub&&data.is_crea_assist_sub===true)request.is_crea_assist_sub=true;Object(__WEBPACK_IMPORTED_MODULE_5__manager_apiManager__["b" /* createOrder */])(responseData.contract_id,request).then(function(res){var response=res.data;if(response.STATUS&&response.STATUS==='FAIL'){errors=[].concat(_toConsumableArray(_this6.handleResponseErrors(response.ERROR)));reject(errors);}else{resolve(response);return;}}).catch(function(error){console.error(error);reject(errors);});return;}if([400,401,402,404,409,429].indexOf(code)>-1){// Reading errors
errors=[].concat(_toConsumableArray(_this6.handleResponseErrors(response.error)));}else if([500,502,503,504].indexOf(code)>-1){// stripe server errors
errors.push({hook:'global',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Une erreur inconnue s\'est produite pendant la tentative de d\xE9bit de votre carte. Veuillez contacter notre support au '+__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].supportPhone+' ou par email')});}else{errors.push({hook:'global',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Une erreur inconnue s\'est produite pendant la tentative de d\xE9bit de votre carte. Veuillez contacter notre support au '+__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].supportPhone+' ou par email')});}reject(errors);};handleResponse=handleResponse.bind(_this6);// Creating Token
if(data.cgv){Stripe.card.createToken(formElem,handleResponse);}});};LpPayment.prototype.handleSepaDebit=function handleSepaDebit(data){var _this7=this;return new Promise(function(resolve,reject){// Response Handler
var responseData=data;var errors=[];// Submiting token
var request={pack:responseData.pack,options:responseData.options,invoice:responseData.invoice,coupon:responseData.coupon_code||responseData.coupon,stripeSource:responseData.iban_source.id,paymentMethod:responseData.paymentMethod,upsell:data.upsell,is_two_steps:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].getState().contract.is_two_steps,experiments_data:Object(__WEBPACK_IMPORTED_MODULE_6__utils_experimentsDataHelpers__["a" /* getExperimentsData */])()};Object(__WEBPACK_IMPORTED_MODULE_5__manager_apiManager__["b" /* createOrder */])(responseData.contract_id,request).then(function(res){var response=res.data;if(response.STATUS&&response.STATUS==='FAIL'){errors=[].concat(_toConsumableArray(_this7.handleResponseErrors(response.ERROR)));reject(errors);}else{resolve(response);return;}}).catch(function(error){console.error(error);reject(errors);});return;});};/*
 * Handling Paypal payment
 */LpPayment.prototype.handlePaypalPayment=function handlePaypalPayment(data){return new Promise(function(resolve,reject){// Checking CGV
if(!data.cgv){reject(new Error([{hook:'global',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])("Vous devez lire et accepter nos conditions générales de vente et d'utilisation.")}]));}// This object will be sent to the server
var request={contract_id:data.contract_id,pack:data.pack,options:data.options,invoice:data.invoice,coupon:data.coupon_code||data.coupon,orderId:data.orderId,upsell:data.upsell,paypalAddress:data.paypalAddress,paymentMethod:data.paymentMethod,is_two_steps:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].getState().contract.is_two_steps,experiments_data:Object(__WEBPACK_IMPORTED_MODULE_6__utils_experimentsDataHelpers__["a" /* getExperimentsData */])()};Object(__WEBPACK_IMPORTED_MODULE_5__manager_apiManager__["b" /* createOrder */])(data.contract_id,request).then(function(response){return resolve(response.data);}).catch(function(){reject(new Error([{hook:'global',message:'Veuillez réessayer'},{hook:'internal',message:err.message}]));});});};/*
 * Helpers
 */// Load script
LpPayment.prototype.loadScript=function loadScript(url){return new Promise(function(resolve,reject){var elem=document.createElement('script');elem.setAttribute('src',url);document.head.appendChild(elem);// Timeout after 15 seconds
var timeout=setTimeout(function(){elem.removeEventListener('load',resolve,false);reject(new Error(Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Error loading checkout script at: ')+url));},30000);// Listening to load
elem.addEventListener('load',function(){clearTimeout(timeout);resolve();},false);});};// Stripe data validator
LpPayment.prototype.stripeDataIsValid=function stripeDataIsValid(card){var errors=[];// Credit card
if(card.number.replace(/\s+/g,'').length===0){errors.push({hook:'card.number',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Veuillez saisir les coordonnées de votre carte de crédit')});}else if(!Stripe.card.validateCardNumber(card.number)){errors.push({hook:'card.number',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Le numéro de carte semble incorrect')});}// Exp date
var date=card.exp.split('/');if(date){if(date.length!==2||date[0].trim().length!==2||date[1].trim().length!==2){errors.push({hook:'card.exp',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Date invalide')});}}// CVC
if(card.cvc.trim().length===0){errors.push({hook:'card.cvc',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Veuillez saisir votre cryptogramme')});}else if(!Stripe.card.validateCVC(card.cvc)){errors.push({hook:'card.cvc',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Le cryptogramme est incorrect')});}if(errors.length===0)return true;return errors;};/*
 * Helper: Converts object to bullet points
 */LpPayment.prototype.errorsToBullets=function errorsToBullets(obj){var result='';for(var i in obj){result+='- '+obj[i].message+'\n';}return result;};/*
 * Handling stripe response errors
 */LpPayment.prototype.handleResponseErrors=function(error){var errors=[];switch(error.code){case'expired_card':errors.push({hook:'card.exp',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Il semble que votre carte soit expirée')});break;// in case of card error
case'invalid_number':case'incorrect_number':errors.push({hook:'card.number',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Le numéro de carte semble incorrect')});break;// In case of an error with exp date
case'invalid_expiry_month':case'invalid_expiry_year':errors.push({hook:'card.exp',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])("La date d'expiration de votre carte semble incorrecte")});break;// Fonds insuffisants
case'invalid_amount':case'withdrawal_count_limit_exceeded':errors.push({hook:'global',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Il semble que votre carte ait été refusée pour fonds insuffisants')});break;// CVC invalide
case'invalid_cvc':errors.push({hook:'card.cvc',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Le cryptogramme est incorrect')});break;case'incorrect_cvc':case'cvc_check_fails':errors.push({hook:'card.cvc',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Le code CVC de votre carte semble incorrect')});break;case'card_declined':switch(error.decline_code){case'do_not_honor':case'transaction_not_allowed':errors.push({'hook':'global','message':Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])("Votre banque a refusé la transaction pour une erreur inconnue. Vous pouvez contacter notre support au 01 76 35 02 40 ou par email à support@legalplace.fr")});break;case'insufficient_funds':errors.push({'hook':'global','message':Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])("Votre carte ne dispose pas des fonds suffisant pour votre achat.")});break;case'fraudulent':case'generic_decline':errors.push({'hook':'global','message':Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])("Votre paiement a été bloqué car considéré comme trop risqué. Merci d’essayer un autre moyen de paiement ou de nous contacter.")});break;default:errors.push({'hook':'global','message':Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])("Une erreur inconnue s\'est produite pendant la tentative de débit de votre carte. Veuillez contacter notre support au 01 76 35 02 40 ou par email")});break;}break;default:errors.push({hook:'global',message:Object(__WEBPACK_IMPORTED_MODULE_2__wording__["a" /* _lp */])('Une erreur inconnue s\'est produite pendant la tentative de d\xE9bit de votre carte. Veuillez contacter notre support au '+__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].supportPhone+' ou par email')});break;}return errors;};/* harmony default export */ __webpack_exports__["a"] = (LpPayment);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_masked_input__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_credit_card_detect__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_hardcoded_checkout__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/card_modal.js
* Author: Amine Azizi
* Version: 1.0
*/// intiialization of errors payment errors
function initErrors(){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('credit-error');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('credit.number');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('card.exp');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('card.cvc');// unraiseError('')
}var _PaymentModal=function(_Component){_inherits(_PaymentModal,_Component);function _PaymentModal(props){_classCallCheck(this,_PaymentModal);var _this=_possibleConstructorReturn(this,(_PaymentModal.__proto__||Object.getPrototypeOf(_PaymentModal)).call(this,props));_this.totalRevenue=function(){// Hardcoded Revenue depend of contract meta ID
if(Object.keys(__WEBPACK_IMPORTED_MODULE_12__constants_hardcoded_checkout__["d" /* HARDCODED_CONVERSION_VALUE_META_IDS */]).indexOf(''+__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].contractMetaId)>-1)return __WEBPACK_IMPORTED_MODULE_12__constants_hardcoded_checkout__["d" /* HARDCODED_CONVERSION_VALUE_META_IDS */][''+__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].contractMetaId];return 0;};_this.closeModal=function(){_this.props.closeEvent();__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["h" /* P_CLOSE_PAYMENT */]);};_this.updateCardNumber=_this.updateCardNumber.bind(_this);_this.updateCardExpiration=_this.updateCardExpiration.bind(_this);_this.updateCardCCV=_this.updateCardCCV.bind(_this);_this.stripeSubscription=_this.stripeSubscription.bind(_this);_this.updateCheckBox=_this.updateCheckBox.bind(_this);// do the changes in the card type
_this.state={card_class:'none'};return _this;}_createClass(_PaymentModal,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var that=this;var a=document.getElementById('checkout-modal1');document.getElementById('checkout-modal1').addEventListener('click',function(e){if(e.target===a||e.target===that.close_btn)_this2.props.closeEvent();__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["h" /* P_CLOSE_PAYMENT */]);});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!prevProps.show&&this.props.show){if(this.refs.credit_card_modal){if(document.getElementById('checkout-modal1').firstChild===null||document.getElementById('checkout-modal1').firstChild.children.length===0)document.getElementById('checkout-modal1').appendChild(this.refs.credit_card_modal);document.getElementById('checkout-modal1').classList.add('lp-modal');document.getElementById('checkout-modal1').classList.add('tryout-modal');document.getElementsByClassName('page-wrap')[0].style.filter='blur(5px)';document.body.style.overflow='hidden';__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.utils.addModalClassToBody();}}if(prevProps.show&&!this.props.show){document.getElementById('checkout-modal1').classList.remove('lp-modal');document.getElementById('checkout-modal1').classList.remove('tryout-modal');document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.utils.removeModalClassToBody();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(document.getElementById('checkout-modal1').firstChild)document.getElementById('checkout-modal1').removeChild(document.getElementById('checkout-modal1').firstChild);document.getElementById('checkout-modal1').classList.remove('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.utils.removeModalClassToBody();}// TODO: better things.
},{key:'updateCardNumber',value:function updateCardNumber(evt){this.props.updateCardNumber(evt.target.value);this.setState({card_class:Object(__WEBPACK_IMPORTED_MODULE_8__utils_credit_card_detect__["a" /* getCardClass */])(evt.target.value)});}},{key:'updateCardExpiration',value:function updateCardExpiration(evt){this.props.updateCardExpiration(evt.target.value);}},{key:'updateCardCCV',value:function updateCardCCV(evt){this.props.updateCardCCV(evt.target.value);}},{key:'updateCheckBox',value:function updateCheckBox(evt){console.log('Hello');this.props.updateConfirmation(evt.target.checked);}},{key:'stripeSubscription',value:function stripeSubscription(){var _this3=this;initErrors();this.props.loading();// tracking.
__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["p" /* lpPattern */].trackLastAction(__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["i" /* P_PAY */]);__WEBPACK_IMPORTED_MODULE_9__tracking_pattern_detector__["p" /* lpPattern */].sendAndResetTracker();window.lp_payment.handleTransaction({type:'abonnement',card:{number:this.props.card_number,cvc:!this.props.card_ccv.includes(' ')?this.props.card_ccv:this.props.card_ccv.slice(0,3),exp:this.props.card_expiration},contract_id:this.props.contract_id,pack:'abonnement',// price issue  I guess
options:[],invoice:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.isInvoiceActivated()?__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getInvoice():[],coupon:this.props.promo_code,client_email:this.props.mail,revenue:this.totalRevenue(),pack_price:this.props.pack_price,document_name:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].contractTitle,cgv:true}).then(function(response){if(response.STATUS==='SUCCESS'){window.localStorage.setItem('purchaseScore',response.purchaseScore);window.onbeforeunload=null;window.location.href=response.redirect;}_this3.props.unloading();}).catch(function(err){var errorMessage=err&&err.length&&err[0].message;__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackErrorPaymentCheckout(errorMessage);// raiseError("global", 10, err.message)
// test if the the ting is an array
if(err.length&&err.length>0){err.forEach(function(idx){if(idx.hook==='global')Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',10,idx.message);else Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])(idx.hook,10,idx.message);});}// test if the thing is Error type
if(err instanceof Error){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,err.message);}_this3.props.unloading();});var pack='abonnement';var eventParams={};eventParams['Chosen price']=this.props.price[pack];eventParams['Total price']=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice();eventParams['Chosen pack']=pack;eventParams['Payment method']='Stripe';__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].track('Asked Payment',eventParams);__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackClickPayment();// console.log(this.prepareData())
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'credit_card_modal'},this.props.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'close_btn',className:'lpm-close icn-x',onClick:this.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-lock'}),'Paiement s\xE9curis\xE9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chekout-tabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-tab active',id:'ct-cards'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ct-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cp-cards-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cp-cards'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ct-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'form-payement'},this.props.credit_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.credit_error.message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group form-payement__card-number visa'+this.state.card_class+(this.props.error_card?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])('Numéro de carte')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!!! !!!! !!!! !!!!',type:'text',className:'form-control',autoComplete:'cc-number',value:this.props.card_number,onChange:this.updateCardNumber}),this.props.error_card&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.error_card.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6 form-payement__exp-date '+(this.props.error_exp?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])("Date d'expiration")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{placeholder:Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])('MM / AA'),mask:'!! / !!',type:'text',className:'form-control',autoComplete:'cc-exp',value:this.props.card_expiration,onChange:this.updateCardExpiration}),this.props.error_exp&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.error_exp.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6 form-payement__cvc '+(this.props.error_cvc?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])('Crypto (CVC)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!!!',type:'text',className:'form-control',autoComplete:'cc-csc',value:this.props.card_ccv,onChange:this.updateCardCCV}),this.props.error_cvc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.error_cvc.message)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-payment cp-flexy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cp-help-block'},Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])("Après l'essai gratui de 7 jours, vous serez automatiquement débités de 19,90 € chaque mois du fait de la souscription à l'offre LegalPlace Premium. Vous pouvez annuler votre souscription en ligne ou en écrivant à support@legalplace.fr. Aucun prélèvement n'interviendra si vous annulez avant la fin de la période d'essai gratuit.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-block btn-primary mobile-right-cta cta-payement'+(this.props.loading_payment?' checking':''),onClick:this.props.loading_payment?function(){}:this.stripeSubscription},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'loading-spin'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn-text'},Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])('Tester 7 jours gratuitement'))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-footer'},Object(__WEBPACK_IMPORTED_MODULE_10__logic_wording__["a" /* _lp */])("Besoin d'aide? Appelez-nous au "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].supportPhone),' ')));}}]);return _PaymentModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{payment_method:state.checkout_operations.payment_method,card_number:state.checkout_operations.credit_card.number,card_expiration:state.checkout_operations.credit_card.expiration,card_ccv:state.checkout_operations.credit_card.ccv,contract_id:state.checkout_operations.contract_id,selected_pack:state.checkout_operations.pack,price:state.checkout_operations.prices,call_chosen:state.checkout_operations.has_call,letter_chosen:state.checkout_operations.has_letter,// now with the letter informayion
letter_number:state.checkout_operations.letter.number,letter_zip:state.checkout_operations.letter.zip,letter_city:state.checkout_operations.letter.city,letter_address:state.checkout_operations.letter.address,letter_name:state.checkout_operations.letter.name,// coupone code
promo_code:state.checkout_operations.promo_code,confirmation:state.checkout_operations.confirm,promo_percentage:state.checkout_operations.promo_percentage,pack_price:state.checkout_operations.pack===0?state.checkout_operations.prices.first_price:state.checkout_operations.prices.second_price,// the errors are here
credit_error:state.errors.components['credit-error'],error_card:state.errors.components['card.number'],error_exp:state.errors.components['card.exp'],error_cvc:state.errors.components['card.cvc'],// payment loading
loading_payment:state.loading_details.checking_payment,// For payment add
mail:state.account_settings.mail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){var l=__WEBPACK_IMPORTED_MODULE_4__globals__["b" /* store */].getState().document_state.state;if(l==='new'){// dispatch({type: SET_DOCUMENT_ID, doc: d})
}return{updatePaymentMethod:function updatePaymentMethod(meth){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["N" /* ckPaymentSelect */])(meth));},updateCardNumber:function updateCardNumber(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["J" /* ckCUpdateCardNumber */])(val));},updateCardExpiration:function updateCardExpiration(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["I" /* ckCUpdateCardExpiration */])(val));},updateCardCCV:function updateCardCCV(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["H" /* ckCUpdateCCV */])(val));},updateConfirmation:function updateConfirmation(val){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["c" /* CK_CHECK */],val:val});},loading:function loading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__["i" /* checkingPayment */])(true));},unloading:function unloading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__["i" /* checkingPayment */])(false));}};};var PaymentModal=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_PaymentModal);/* harmony default export */ __webpack_exports__["a"] = (PaymentModal);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_faq__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_faq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__constants_faq__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _faq=function(_Component){_inherits(_faq,_Component);function _faq(props){_classCallCheck(this,_faq);var _this=_possibleConstructorReturn(this,(_faq.__proto__||Object.getPrototypeOf(_faq)).call(this,props));_this.state={faqInfo:_this.getFaq()};return _this;}_createClass(_faq,[{key:'getFaq',value:function getFaq(){switch(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].contractMetaId){// 198 -> EURL
case 198:return[{question:'Pourquoi choisir LegalPlace ?',answer:'LegalPlace vous permet de créer votre société facilement, rapidement, et sans aucun risque de rejet par le greffe. Vos statuts sont parfaitement fiables juridiquement et adaptés à votre société. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et créent votre société en un temps record grâce à leur expérience et leur relations avec les greffes et autres administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre société, nous vous proposons de payer les frais de services et les frais administratifs en 3 fois sur 3 mois, sans aucun frais supplémentaire.'},{question:'En combien de temps aurai-je mon K-bis?',answer:'Une fois votre dossier complet, nos experts lancent sous 24h* (formule express uniquement) toutes les démarches auprès du greffe et du journal d’annonce légale pour immatriculer votre société au plus vite. Vous recevrez alors votre Kbis en moyenne une semaine après (variable selon les départements).'},{question:'Que se passe-t-il après le paiement ?',answer:'Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires sur votre EURL. Une fois le questionnaire complété, vos statuts seront générés automatiquement et nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement). Vous recevrez alors vos statuts nécessaires à l’ouverture de votre compte bancaire. Une fois votre compte bancaire ouvert, nos experts s’occupent de tout jusqu’à l’obtention de votre Kbis.'},{question:'Comment récupérer la TVA ?',answer:'Les frais de création sont avancés par un ou plusieurs associés pour le compte de la société en formation. Les associés qui ont avancé les coûts de création de EURL se remboursent une fois les fonds du compte bancaire de la société débloqués – et à condition que la EURL dispose de la trésorerie suffisante. La TVA afférente aux frais de création est déductible dans le cadre des activités de la société.'}];// 123 -> SARL
case 197:return[{question:'Pourquoi choisir LegalPlace ?',answer:'LegalPlace vous permet de créer votre société facilement, rapidement, et sans aucun risque de rejet par le greffe. Vos statuts sont parfaitement fiables juridiquement et adaptés à votre société. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et créent votre société en un temps record grâce à leur expérience et leur relations avec les greffes et autres administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre société, nous vous proposons de payer les frais de services et les frais administratifs en 3 fois sur 3 mois, sans aucun frais supplémentaire.'},{question:'En combien de temps aurai-je mon K-bis?',answer:'Une fois votre dossier complet, nos experts lancent sous 24h* (formule express uniquement) toutes les démarches auprès du greffe et du journal d’annonce légale pour immatriculer votre société au plus vite. Vous recevrez alors votre Kbis en moyenne une semaine après (variable selon les départements).'},{question:'Que se passe-t-il après le paiement ?',answer:'Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires sur votre SARL. Une fois le questionnaire complété, vos statuts seront générés automatiquement et nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement). Vous recevrez alors vos statuts nécessaires à l’ouverture de votre compte bancaire. Une fois votre compte bancaire ouvert, nos experts s’occupent de tout jusqu’à l’obtention de votre Kbis.'},{question:'Comment récupérer la TVA ?',answer:'Les frais de création sont avancés par un ou plusieurs associés pour le compte de la société en formation. Les associés qui ont avancé les coûts de création de SARL se remboursent une fois les fonds du compte bancaire de la société débloqués – et à condition que la SARL dispose de la trésorerie suffisante. La TVA afférente aux frais de création est déductible dans le cadre des activités de la société.'}];// 175 -> SAS
case 175:return[{question:'Pourquoi choisir LegalPlace ?',answer:'LegalPlace vous permet de créer votre société facilement, rapidement, et sans aucun risque de rejet par le greffe. Vos statuts sont parfaitement fiables juridiquement et adaptés à votre société. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et créent votre société en un temps record grâce à leur expérience et leur relations avec les greffes et autres administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre société, nous vous proposons de payer les frais de services et les frais administratifs en 3 fois sur 3 mois, sans aucun frais supplémentaire.'},{question:'En combien de temps aurai-je mon K-bis?',answer:'Une fois votre dossier complet, nos experts lancent sous 24h* (formule express uniquement) toutes les démarches auprès du greffe et du journal d’annonce légale pour immatriculer votre société au plus vite. Vous recevrez alors votre Kbis en moyenne une semaine après (variable selon les départements).'},{question:'Que se passe-t-il après le paiement ?',answer:'Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires sur votre SAS. Une fois le questionnaire complété, vos statuts seront générés automatiquement et nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement). Vous recevrez alors vos statuts nécessaires à l’ouverture de votre compte bancaire. Une fois votre compte bancaire ouvert, nos experts s’occupent de tout jusqu’à l’obtention de votre Kbis.'},{question:'Comment récupérer la TVA ?',answer:'Les frais de création sont avancés par un ou plusieurs associés pour le compte de la société en formation. Les associés qui ont avancé les coûts de création de SAS se remboursent une fois les fonds du compte bancaire de la société débloqués – et à condition que la SAS dispose de la trésorerie suffisante. La TVA afférente aux frais de création est déductible dans le cadre des activités de la société.'}];// 176 -> SASU
case 176:return[{question:'Pourquoi choisir LegalPlace ?',answer:'LegalPlace vous permet de créer votre société facilement, rapidement, et sans aucun risque de rejet par le greffe. Vos statuts sont parfaitement fiables juridiquement et adaptés à votre société. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et créent votre société en un temps record grâce à leur expérience et leur relations avec les greffes et autres administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre société, nous vous proposons de payer les frais de services et les frais administratifs en 3 fois sur 3 mois, sans aucun frais supplémentaire.'},{question:'En combien de temps aurai-je mon K-bis?',answer:'Une fois votre dossier complet, nos experts lancent sous 24h* (formule express uniquement) toutes les démarches auprès du greffe et du journal d’annonce légale pour immatriculer votre société au plus vite. Vous recevrez alors votre Kbis en moyenne une semaine après (variable selon les départements).'},{question:'Que se passe-t-il après le paiement ?',answer:'Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires sur votre SASU. Une fois le questionnaire complété, vos statuts seront générés automatiquement et nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement). Vous recevrez alors vos statuts nécessaires à l’ouverture de votre compte bancaire. Une fois votre compte bancaire ouvert, nos experts s’occupent de tout jusqu’à l’obtention de votre Kbis.'},{question:'Comment récupérer la TVA ?',answer:'Les frais de création sont avancés par un ou plusieurs associés pour le compte de la société en formation. Les associés qui ont avancé les coûts de création de SASU se remboursent une fois les fonds du compte bancaire de la société débloqués – et à condition que la SASU dispose de la trésorerie suffisante. La TVA afférente aux frais de création est déductible dans le cadre des activités de la société.'}];// 124 -> SCI
case 124:return[{question:'Pourquoi choisir LegalPlace ?',answer:'LegalPlace vous permet de créer votre société facilement, rapidement, et sans aucun risque de rejet par le greffe. Vos statuts sont parfaitement fiables juridiquement et adaptés à votre société. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et créent votre société en un temps record grâce à leur expérience et leur relations avec les greffes et autres administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre société, nous vous proposons de payer les frais de services et les frais administratifs en 3 fois sur 3 mois, sans aucun frais supplémentaire.'},{question:'En combien de temps aurai-je mon K-bis?',answer:'Une fois votre dossier complet, nos experts lancent sous 24h* (formule express uniquement) toutes les démarches auprès du greffe et du journal d’annonce légale pour immatriculer votre société au plus vite. Vous recevrez alors votre Kbis en moyenne une semaine après (variable selon les départements).'},{question:'Que se passe-t-il après le paiement ?',answer:'Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires sur votre SCI. Une fois le questionnaire complété, vos statuts seront générés automatiquement et nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement). Vous recevrez alors vos statuts nécessaires à l’ouverture de votre compte bancaire. Une fois votre compte bancaire ouvert, nos experts s’occupent de tout jusqu’à l’obtention de votre Kbis.'},{question:'Comment récupérer la TVA ?',answer:'Les frais de création sont avancés par un ou plusieurs associés pour le compte de la société en formation. Les associés qui ont avancé les coûts de création de SCI se remboursent une fois les fonds du compte bancaire de la société débloqués – et à condition que la SCI dispose de la trésorerie suffisante. La TVA afférente aux frais de création est déductible dans le cadre des activités de la société.'}];// 162 -> Association
case 162:return __WEBPACK_IMPORTED_MODULE_3__constants_faq__["faqAsso"];// CSE
case 229:case 230:case 231:return[{question:'Pourquoi choisir LegalPlace ?',answer:'LegalPlace vous permet de mettre en place l\'élection de votre CSE (ou, faute de candidat, d\'accomplir toutes vos obligations légales afférentes au CSE) rapidement, conformément aux délais légaux, sans risque d\'invalidation de votre élection.\n\nNos documents sont à jour des dernières évolutions législatives, parfaitement fiables juridiquement et adaptés à votre entreprise : ils sont générés sur mesure. Un expert dédié vous guide et vous accompagne tout au long du processus par téléphone ou e-mail. Le vote électronique (proposé par notre partenaire) est simple et certifié.'},{question:'Quels avantages pour mon entreprise ?',answer:'Grâce à la technologie combinée au savoir-faire de ses équipes d\'experts, LegalPlace peut proposer des prix bien moins élevés que les autres offres existantes pour une qualité juridique optimale. Vous économisez de l\'argent tout en optant pour la qualité, la sécurité et la sérénité.'},{question:'Que se passe-t-il après le paiement ?',answer:'Une fois le paiement effectué, vous sous serez automatiquement redirigé vers un questionnaire afin de compléter les informations nécessaires à l\'organisation de l\'élection, puis un expert dédié vous contactera pour la mise en place et le commencement de votre procédure. Vous n\'aurez plus qu\'à vous laisser guider.'},{question:'Quels gains pour mon entreprise ?',answer:'Gérer l\'élection du CSE seul, c\'est une perte de temps considérable si vous n\'êtes pas expert et c\'est également s\'exposer à des risques (en ne respectant pas la procédure ou en utilisant des documents non adaptés). En choisissant LegalPlace, vous optez pour le respect de vos obligations légales en toute sérénité : nos experts se chargent de vous accompagner. Si vous optez pour le vote électronique, vous évitez les désagréments liés à la tenue d\'une élection physique. Le scrutin, de son ouverture à sa clôture, en passant par le vote, se fait de manière intuitive, simple et 100% digitalisé. Les résultats sont certifiés et il n\'y a pas de risques de contestation.'}];// 181 -> Auto-Entrepreneur
case 181:default:return[{question:'Pourquoi choisir LegalPlace ?',answer:'LegalPlace vous permet de créer votre micro-entreprise en toute simplicité. Une fois vos réponses à notre questionnaire complétées, nos experts s’occupent de toutes les démarches administratives jusqu’à l’obtention de votre numéro SIREN. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre auto-entreprise, nous vous proposons de nous régler en 3 fois sur 3 mois, sans aucun frais supplémentaire.'},{question:'En combien de temps mon auto-entreprise sera créée ?',answer:'Une fois votre dossier complet, nos experts lancent sous 24h (formule Express uniquement) toutes les démarches pour immatriculer votre auto-entreprise au plus vite. Vous obtiendrez alors votre numéro SIREN sous 10 à 30 jours en moyenne (variable selon les départements).'},{question:'Que se passe-t-il après le paiement ?',answer:'Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires. Une fois le questionnaire complété, nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement) et vous contacterons en cas de besoin.'},{question:'Qu’est-ce que la demande d’ACCRE ?',answer:"L’ACCRE correspond à « Aide aux demandeurs d'emploi créant ou reprenant une entreprise ». Le dispositif consiste en une exonération de charges sociales pendant un an à partir du moment de l'immatriculation de la société ou au début de son activité. Si vous choisissez la formule Express, nos experts réalisent la demande d’Accre pour vous."}];}}},{key:'render',value:function render(){var _this2=this;var getFaqContent=function getFaqContent(faqIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,_this2.state.faqInfo[faqIndex].question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,_this2.state.faqInfo[faqIndex].answer));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{id:'faq'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'sc-title'},'FAQ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},getFaqContent(0),getFaqContent(1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},getFaqContent(2),getFaqContent(3))));}}]);return _faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{title:state.contract.name};};var Faq=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(_faq);/* harmony default export */ __webpack_exports__["a"] = (Faq);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return packEntrepreneurData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_img_newPackEntrepreneur_assitance_svg__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_img_newPackEntrepreneur_assitance_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_img_newPackEntrepreneur_assitance_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_newPackEntrepreneur_contrats_svg__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_newPackEntrepreneur_contrats_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_newPackEntrepreneur_contrats_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_newPackEntrepreneur_template_svg__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_newPackEntrepreneur_template_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_img_newPackEntrepreneur_template_svg__);
var packEntrepreneurData={181:{header:{packTitle:"Pack entrepreneur",packsubTitle:"Ce pack contient l'ensemble des éléments utiles aux entrepreneurs afin qu'ils puissent correctement exercer leur activité."},content:[{picture:__WEBPACK_IMPORTED_MODULE_0__styles_img_newPackEntrepreneur_assitance_svg___default.a,optionTitle:"Assistance Entrepreneur",optionText:"Bénéficiez d'un accès privilégié à notre expertise pour répondre à toutes vos inquiétudes"},{picture:__WEBPACK_IMPORTED_MODULE_1__styles_img_newPackEntrepreneur_contrats_svg___default.a,optionTitle:"Contrats personnalisés",optionText:"Pendant 2 mois, vous avez un accès illimité à notre générateur de contrats personnalisés."},{picture:__WEBPACK_IMPORTED_MODULE_2__styles_img_newPackEntrepreneur_template_svg___default.a,optionTitle:"Modèles de devis et factures",optionText:"Nous vous fournissons des templates de devis et de factures pré-remplis et aux normes."}],footer:{oldPrice:49,newPrice:32,btnText:"Ajouter",skipBtnText:"Ignorer et passer au paiement",footerText:"Vous pouvez prendre ce pack plus tard mais le tarif réduit de 32€ ne sera plus applicable. Le Pack Entrepreneur est valable 2 mois à partir de la date d'achat."}}};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PackBtn__ = __webpack_require__(1170);
var Card=function Card(_ref){var packDetails=_ref.packDetails,_goToNextStep=_ref.goToNextStep,isBottom=_ref.isBottom,hasThreePack=_ref.hasThreePack;var title=packDetails.title,subTitle=packDetails.subTitle,price=packDetails.price,info=packDetails.info,id=packDetails.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card '+(hasThreePack?"three-packs":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cardText-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'cardText-title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'cardText-subtitle'},subTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cardText-price'},price==='Offerte'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,price):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,price,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'HT'))),info&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cardText-info'},info)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PackBtn__["a" /* default */],{goToNextStep:function goToNextStep(){return _goToNextStep(id,title);},isBottom:isBottom})));};/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(478);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 274 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178);
__webpack_require__(180);
__webpack_require__(186);
__webpack_require__(188);
module.exports = __webpack_require__(39).Map;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(24) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(179)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var anObject = __webpack_require__(6);
var getKeys = __webpack_require__(86);

module.exports = __webpack_require__(24) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(44);
var toIObject = __webpack_require__(45);
var arrayIndexOf = __webpack_require__(137)(false);
var IE_PROTO = __webpack_require__(183)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(25).f;
var create = __webpack_require__(85);
var redefineAll = __webpack_require__(88);
var ctx = __webpack_require__(53);
var anInstance = __webpack_require__(89);
var forOf = __webpack_require__(90);
var $iterDefine = __webpack_require__(181);
var step = __webpack_require__(279);
var setSpecies = __webpack_require__(91);
var DESCRIPTORS = __webpack_require__(24);
var fastKey = __webpack_require__(76).fastKey;
var validate = __webpack_require__(92);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(6);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178);
__webpack_require__(180);
__webpack_require__(186);
__webpack_require__(193);
module.exports = __webpack_require__(39).Set;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(482);

__webpack_require__(675);

__webpack_require__(676);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(19);


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(45);
var gOPN = __webpack_require__(93).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(24);
var getKeys = __webpack_require__(86);
var gOPS = __webpack_require__(140);
var pIE = __webpack_require__(119);
var toObject = __webpack_require__(28);
var IObject = __webpack_require__(118);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(37);
var isObject = __webpack_require__(12);
var invoke = __webpack_require__(289);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(9).parseInt;
var $trim = __webpack_require__(102).trim;
var ws = __webpack_require__(195);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(9).parseFloat;
var $trim = __webpack_require__(102).trim;

module.exports = 1 / $parseFloat(__webpack_require__(195) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(51);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(12);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(197);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(37);
var toObject = __webpack_require__(28);
var IObject = __webpack_require__(118);
var toLength = __webpack_require__(20);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(28);
var toAbsoluteIndex = __webpack_require__(87);
var toLength = __webpack_require__(20);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(204);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(24) && /./g.flags != 'g') __webpack_require__(25).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(120)
});


/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var isObject = __webpack_require__(12);
var newPromiseCapability = __webpack_require__(208);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var each = __webpack_require__(60)(0);
var redefine = __webpack_require__(40);
var meta = __webpack_require__(76);
var assign = __webpack_require__(286);
var weak = __webpack_require__(303);
var isObject = __webpack_require__(12);
var validate = __webpack_require__(92);
var NATIVE_WEAK_MAP = __webpack_require__(92);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(138)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(88);
var getWeak = __webpack_require__(76).getWeak;
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(12);
var anInstance = __webpack_require__(89);
var forOf = __webpack_require__(90);
var createArrayMethod = __webpack_require__(60);
var $has = __webpack_require__(44);
var validate = __webpack_require__(92);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(52);
var toLength = __webpack_require__(20);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(93);
var gOPS = __webpack_require__(140);
var anObject = __webpack_require__(6);
var Reflect = __webpack_require__(9).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(141);
var isObject = __webpack_require__(12);
var toLength = __webpack_require__(20);
var ctx = __webpack_require__(53);
var IS_CONCAT_SPREADABLE = __webpack_require__(19)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(20);
var repeat = __webpack_require__(196);
var defined = __webpack_require__(58);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(24);
var getKeys = __webpack_require__(86);
var toIObject = __webpack_require__(45);
var isEnum = __webpack_require__(119).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(99);
var from = __webpack_require__(310);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(90);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(679).polyfill()


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(122),
    _assign = __webpack_require__(17);

var ReactNoopUpdateQueue = __webpack_require__(314);

var canDefineProperty = __webpack_require__(315);
var emptyObject = __webpack_require__(150);
var invariant = __webpack_require__(8);
var lowPriorityWarning = __webpack_require__(681);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(14);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(689);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(696);


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(38);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(94);

var invariant = __webpack_require__(8);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(26);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(38);
var escapeTextContentForBrowser = __webpack_require__(154);
var setInnerHTML = __webpack_require__(153);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(105);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactInstrumentation = __webpack_require__(55);

var quoteAttributeValueForBrowser = __webpack_require__(724);
var warning = __webpack_require__(14);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var LinkedValueUtils = __webpack_require__(220);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactUpdates = __webpack_require__(62);

var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(17);

var ReactCompositeComponent = __webpack_require__(733);
var ReactEmptyComponent = __webpack_require__(336);
var ReactHostComponent = __webpack_require__(337);

var getNextDebugID = __webpack_require__(734);
var invariant = __webpack_require__(8);
var warning = __webpack_require__(14);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var React = __webpack_require__(103);

var invariant = __webpack_require__(8);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactCurrentOwner = __webpack_require__(69);
var REACT_ELEMENT_TYPE = __webpack_require__(735);

var getIteratorFn = __webpack_require__(736);
var invariant = __webpack_require__(8);
var KeyEscapeUtils = __webpack_require__(224);
var warning = __webpack_require__(14);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(122);

var ReactCurrentOwner = __webpack_require__(69);

var invariant = __webpack_require__(8);
var warning = __webpack_require__(14);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(61);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(748);

var containsNode = __webpack_require__(750);
var focusNode = __webpack_require__(330);
var getActiveElement = __webpack_require__(342);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var DOMLazyTree = __webpack_require__(107);
var DOMProperty = __webpack_require__(105);
var React = __webpack_require__(103);
var ReactBrowserEventEmitter = __webpack_require__(155);
var ReactCurrentOwner = __webpack_require__(69);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactDOMContainerInfo = __webpack_require__(765);
var ReactDOMFeatureFlags = __webpack_require__(766);
var ReactFeatureFlags = __webpack_require__(325);
var ReactInstanceMap = __webpack_require__(126);
var ReactInstrumentation = __webpack_require__(55);
var ReactMarkupChecksum = __webpack_require__(767);
var ReactReconciler = __webpack_require__(106);
var ReactUpdateQueue = __webpack_require__(225);
var ReactUpdates = __webpack_require__(62);

var emptyObject = __webpack_require__(150);
var instantiateReactComponent = __webpack_require__(334);
var invariant = __webpack_require__(8);
var setInnerHTML = __webpack_require__(153);
var shouldUpdateReactComponent = __webpack_require__(223);
var warning = __webpack_require__(14);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(335);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(95);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(347);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(230);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(788)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(351);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(817);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(816);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(810);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(359);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(231);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chalk__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chalk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chalk__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/logic/preview_render/angular_reader.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// import lpApp from '../../app/lp_app';
var LpOutput=function(){function LpOutput(id,text){var varId=arguments.length>2&&arguments[2]!==undefined?arguments[2]:-1;var variablesIndex=arguments[3];_classCallCheck(this,LpOutput);this.id=id;this.raw=text;this.variables=[];this.variablesIndex=variablesIndex;this.compiled='';this.actual_variable=varId;// console.log(this.id);
// console.log(text);
}_createClass(LpOutput,[{key:'compile',value:function compile(){var _this=this;// FIXME: we can optimize this
// TODO: Add all the compiled outputs to the windowDOM
// const reg_test = /<(p|span)\s(\s|\w|=|\\|"|-|:|\[|\]|\$|\.|\'|\/)+>/img;
var initThing=/<span ng-init=\"(\w|\[|\]|\s|=|\.)+\"\sng-include=\"\'preview\/var\.html\'\"><\/span>/gm;// eslint-disable-line
var replacedThings=this.raw.match(initThing);var res=this.raw;var varExtractor=/contractCtrl.variables.wrapper\[(\d+)\]/gm;if(replacedThings===null||replacedThings.length===0){this.compiled=this.raw;return this;}replacedThings.forEach(function(idx){var m=void 0;var varId=void 0;while(m=varExtractor.exec(idx)){var _m=m;// add the copy name
var _m2=_slicedToArray(_m,2);varId=_m2[1];if(typeof _this.id==='string'){// Checking if variable is a child
// let children = lpApp.utils.getAllChildren(this.id.split('_')[0]);
// console.log(children)
if(_typeof(_this.variablesIndex)==='object'){if(_this.variablesIndex.includes(parseInt(varId,10))){varId=varId+'_'+_this.id.split('_')[1];}}else{varId=varId+'_'+_this.id.split('_')[1];}}_this.variables.push(varId);}res=res.replace(idx,'<span class="am_a_var" data-var-id="'+varId+'">{{'+varId+'}}</span>');},this);// this.compiled = res;
this.compiled=res;return this;}},{key:'draw',value:function draw(){var _this2=this;var vas=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];if(vas.length!==this.variables.length)return'';var result=this.compiled.slice(0);// filterNumbers(this.compiled).slice(0); // clone
var i=0;// if(vas[0] != "" && this.id == 285)debugger;
this.variables.forEach(function(idx){var cIdx=idx;// Converting to string if it's a number
if(typeof vas[i]==='number')vas[i]=vas[i].toString();if(idx===_this2.actual_variable){if(vas[i]===''||typeof vas[i]==='undefined')result=result.replace('{{'+cIdx+'}}','<span class="doc-highlight">_______________________</span>');else{var res=vas[i].replace(/<br>/g,'\n').replace(/</g,'&lt;').replace(/\n/g,'<br>');result=result.replace('{{'+cIdx+'}}','<span class="doc-highlight">'+res+'</span>');}}else if(vas[i]===''||typeof vas[i]==='undefined')result=result.replace('{{'+cIdx+'}}','_______________________');else{var _res=vas[i].replace(/<br>/g,'\n').replace(/</g,'&lt;').replace(/\n/g,'<br>');result=result.replace('{{'+cIdx+'}}',_res);}i+=1;},this);return result;}}]);return LpOutput;}();/* harmony default export */ __webpack_exports__["a"] = (LpOutput);

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function () {
	return /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]/g;
};


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var _References=function(){function _References(){_classCallCheck(this,_References);this.initiated=false;}/**
     * Initiates references
     */_createClass(_References,[{key:"init",value:function init(){if(this.initiated===true)return;this.options=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.options;this.variables=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.variables;this.sections=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.sections;// Initiating parents tree
this.initParentsTree();this.initConditionnedOptions();this.initMultiplesDependencies();this.initiated=true;}/**
     * Reads Options and Variables wrapper and sets
     * and object with the parents tree of each option
     * and variable
     */},{key:"initParentsTree",value:function initParentsTree(){var _this=this;var parentsTree={options:{},variables:{}};// Options
Object.keys(this.options).forEach(function(id){parentsTree.options[id]=[];var parent_id=_this.getOptionParent(parseInt(id,10));while(parent_id!==false){parentsTree.options[id].push(parent_id);parent_id=_this.getOptionParent(parent_id);}});// Variables
Object.keys(this.variables).forEach(function(id){parentsTree.variables[id]=[];var parent_id=_this.getVariableParent(parseInt(id));while(parent_id!==false){parentsTree.variables[id].push(parent_id);parent_id=_this.getOptionParent(parent_id);}});this.parentsTree=parentsTree;}/**
     * Reads Options wrapper and sets the list of
     * conditionned options
     */},{key:"initConditionnedOptions",value:function initConditionnedOptions(){var _this2=this;var conditionnedOptions=[];// Options
Object.keys(this.options).forEach(function(id){var option=_this2.options[id];if(option.meta.conditional===true&&Array.isArray(option.meta.compiledConditions)&&option.meta.compiledConditions.length>0){conditionnedOptions.push(parseInt(id,10));}});this.conditionnedOptions=conditionnedOptions;}/**
     * Reads Options wrapper in order to set the deps
     * of multiples
     */},{key:"initMultiplesDependencies",value:function initMultiplesDependencies(){var _this3=this;this.multiplesDependencies={};// Options
Object.keys(this.options).forEach(function(id){var option=_this3.options[id];var repeatOption=void 0;var multiplesDependencies=[];// If it's a repeated option, all it's children must
// depend on a multiple
if(option.meta.type==="repeated"){repeatOption=option.meta.repeatOption;multiplesDependencies=_this3.getChildrenIds(id);}// If it's a multiple all it's children depends on it
else if(option.meta.multiple){repeatOption=id;multiplesDependencies=_this3.getChildrenIds(id);}// If the array isn't empty we add it to the global object
if(multiplesDependencies.length>0){if(_this3.multiplesDependencies.hasOwnProperty(repeatOption)){_this3.multiplesDependencies[repeatOption]=[].concat(_toConsumableArray(_this3.multiplesDependencies[repeatOption]),_toConsumableArray(multiplesDependencies));}else{_this3.multiplesDependencies[repeatOption]=multiplesDependencies;}}});}/**
     * Returns the full children list of an option
     * @param {integer} id
     */},{key:"getChildrenIds",value:function getChildrenIds(id){var _this4=this;var option=this.options[id];var children=[];if(Array.isArray(option.children)){option.children.forEach(function(child_id){children.push(parseInt(child_id,10));children=[].concat(_toConsumableArray(children),_toConsumableArray(_this4.getChildrenIds(child_id)));});}return children;}/**
     * @param {number} id Returns the parent's id of the given option's id
     */},{key:"getOptionParent",value:function getOptionParent(id){var _this5=this;var parent=false;Object.keys(this.options).forEach(function(_id){var option=_this5.options[_id];if(option.children.includes(id)){parent=parseInt(_id,10);}});return parent;}/**
     * @param {number} id Returns the parent's id of the given variable's id
     */},{key:"getVariableParent",value:function getVariableParent(id){var _this6=this;var parent=false;Object.keys(this.options).forEach(function(_id){var option=_this6.options[_id];if(option.variables.includes(id)){parent=parseInt(_id);}});return parent;}/**
     * Returns parents tree
     */},{key:"getParentsTree",value:function getParentsTree(){// Initiating refs if they weren't initiated
if(References.initiated===false)References.init();return this.parentsTree;}/**
     * Returns conditionned options list
     */},{key:"getConditionnedOptions",value:function getConditionnedOptions(){// Initiating refs if they weren't initiated
if(References.initiated===false)References.init();return this.conditionnedOptions;}/**
     * Returns multiples deps list
     */},{key:"getMultiplesDependencies",value:function getMultiplesDependencies(){// Initiating refs if they weren't initiated
if(References.initiated===false)References.init();return this.multiplesDependencies;}}]);return _References;}();var References=new _References();/* harmony default export */ __webpack_exports__["a"] = (References);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = updateSectionsIfConditions;
/* harmony export (immutable) */ __webpack_exports__["a"] = ccontract;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_contract__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__section__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_section__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_json_to_contract__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_condition_evo__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_load_contract__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic_history__ = __webpack_require__(80);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\contract.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// Test phase
// import contract from '../../logic/jsonTestModel';
// import { contract_json } from '../../logic/jsonTestModel1';
// import { contract0 } from '../../logic/jsonTestModel2';
// lets do it
function updateSectionsIfConditions(){var index=0;var indexO=0;// console.log("Wow")
var lpRealSections={};var lpOutputSections={};Object.keys(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.sections).map(function(jdx){var idx=__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.getSection(jdx);// if the it's conditional, and if the thing is new
if(typeof idx.compiledConditions==='undefined'){lpOutputSections[indexO]=idx;indexO+=1;if(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.two_steps.checkSection(jdx))return;lpRealSections[index]=idx;index+=1;}else if(idx.compiledConditions&&idx.compiledConditions.length===0){lpOutputSections[indexO]=idx;indexO+=1;if(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.two_steps.checkSection(jdx))return;lpRealSections[index]=idx;index+=1;}else if(idx.compiledConditions.length>0&&__WEBPACK_IMPORTED_MODULE_5__logic_condition_evo__["a" /* default */].initiated===true){if(__WEBPACK_IMPORTED_MODULE_5__logic_condition_evo__["a" /* default */].rawCondition(idx.compiledConditions)){// debugger;
lpOutputSections[indexO]=idx;indexO+=1;if(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.two_steps.checkSection(jdx))return;lpRealSections[index]=idx;index+=1;}window.nbr_forced+=1;}});__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].indexes.updateRealSections(lpRealSections);__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].indexes.real_sections.updateOutputSections(lpOutputSections);}function ccontract(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{name:'',version:0,this_section:0,currentSection:0,section:{},total_sections:0,sections:[],client_type:'',pro_condition:[],fullWidth:false,reprise_wizard:false,reprise_link:'#',comeFrom:''};var action=arguments[1];switch(action.type){// LegalTon: here we can add any additionnal feature in the contract.
case __WEBPACK_IMPORTED_MODULE_0__actions_contract__["a" /* CREATE_CONTRACT */]:{var cont=new __WEBPACK_IMPORTED_MODULE_4__logic_json_to_contract__["a" /* default */](action.contract);// after will be sent by action
// directly
// window.lpVarRefs = c.variables;
__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.addVariablesRefernce(cont.variables);// window.lpOptRefs = c.options;
__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.addOptionsReference(cont.options);__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.addSectionsReference(action.contract.contract_architecture.sections);Object(__WEBPACK_IMPORTED_MODULE_6__actions_load_contract__["a" /* caluclateConditionDependecies */])();// Updating sections conditions after initiating ConditionsEvo
updateSectionsIfConditions();__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].indexes.updateRoots(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.sections);return Object.assign({},state,{name:cont.name,version:cont.contract_version,is_two_steps:action.contract.contract_architecture.is_two_steps,total_sections:cont.total_sections,currentSection:0,sections:__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].indexes.real_sections.sections,client_type:action.contract.contract_architecture.params?action.contract.contract_architecture.params.proIdnType:'pro',pro_condition:action.contract.contract_architecture.pro,disable_auto_default:action.contract.contract_architecture.params?action.contract.contract_architecture.params.disableAutoDefault:false});}case __WEBPACK_IMPORTED_MODULE_0__actions_contract__["b" /* INIT_CONTRACT */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actions_contract__["d" /* SET_SECTION_ID */]:{updateSectionsIfConditions();var sId=action.id;var isaNav=action.isaNav;if(action.id>Object.keys(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].indexes.real_sections))sId=1;// get into the section, and try to feed it with options
return Object.assign({},state,{currentSection:sId>0?sId:0,section:Object(__WEBPACK_IMPORTED_MODULE_1__section__["a" /* default */])({},{type:__WEBPACK_IMPORTED_MODULE_3__actions_section__["a" /* ADD_SECTION */],section:__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].indexes.real_sections.getSection(sId<0?0:sId),sId:sId,isaNav:isaNav}),sections:__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].indexes.real_sections.sections});}case __WEBPACK_IMPORTED_MODULE_0__actions_contract__["c" /* REDIRECT_TO_SECTION */]:{var section=action.section;var s_id=action.s_id;var history_mutex=__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].mutex.checkMutex("history");var pathname=window.location.pathname;var result=Object.assign({},state,{comeFrom:pathname.split('/')[3]});if(__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().document_state.state==='continue'){if(history_mutex){Object(__WEBPACK_IMPORTED_MODULE_8__logic_history__["a" /* default */])('normal',true,s_id,__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().document_state.unique);// set route id as article number
// writeHistory('normal', true, section.id - 1, store.getState().document_state.unique);
}else{__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].mutex.setMutex("history",true);}}else{if(history_mutex){Object(__WEBPACK_IMPORTED_MODULE_8__logic_history__["a" /* default */])('normal',false,s_id,"");}else __WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].mutex.setMutex("history",true);}return result;}case'UPDATE_SECTIONS_C':updateSectionsIfConditions();return Object.assign({},state,{sections:__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].indexes.real_sections.sections});case'SET_FULL_WIDTH':return Object.assign({},state,{fullWidth:action.val});case'REPRISE_WIZARD':return Object.assign({},state,{reprise_wizard:action.val});case'REPRISE_LINK':return Object.assign({},state,{reprise_link:action.val});default:return state;}}window.uncover_=updateSectionsIfConditions;

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_SECTION; });
/* unused harmony export REMOVE_SECTION */
/* unused harmony export REDIRECT_TO_SECTION */
/* unused harmony export setSection */
/* unused harmony export removeSection */
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\section.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var ADD_SECTION='ADD_SECTION';var REMOVE_SECTION='REMOVE_SECTION';var REDIRECT_TO_SECTION='REDIRECT_TO_SECTION';function setSection(section){// TODO: test if the the
return{type:ADD_SECTION,section:section,s_id:s_id,isaNav:isaNav};}// we have only one section
function removeSection(){return{type:REMOVE_SECTION};}

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_OPTION; });
/* harmony export (immutable) */ __webpack_exports__["c"] = addOption;
/* unused harmony export removeOption */
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\option.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var ADD_OPTION='ADD_OPTION_';var REMOVE_OPTION='REMOVE_OPTION_';function addOption(id){return{type:ADD_OPTION,id:id};}function removeOption(id){return{type:REMOVE_OPTION,id:id};}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_VARIABLE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = createVariable;
/* unused harmony export removeVariable */
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\variable.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var ADD_VARIABLE='ADD_VARIABLE_';var REMOVE_VARIABLE='REMOVE_VARIABLE_';function createVariable(id){return{type:ADD_VARIABLE,id:id};}function removeVariable(id){return{type:REMOVE_VARIABLE,id:id};}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VariableWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_map_utils__ = __webpack_require__(109);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src\logic\variable_wrapper.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// the variable wrapper
var VariableWrapper=function VariableWrapper(obj){_classCallCheck(this,VariableWrapper);this.id=-1;this.label="";this.helper="";this.type=__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["l" /* OptionType */].NONE;this.phSize=16;this.has_multipleParents=false;this.is_conditional=false;this.id=obj['id'];this.label=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["f" /* LABEL */]];this.type=Object(__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["s" /* detectType */])(obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["p" /* TYPE */]]);this.phSize=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["c" /* FSIZE */]];this.has_multipleParents=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["i" /* MULTIPLE_PARENTS */]];this.is_conditional=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["e" /* ISCONDITIONAL */]];this.helper=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["d" /* HELPER */]];}//nice joke XD (has multiple parents lol)
;

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptionWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_map_utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variable_wrapper__ = __webpack_require__(368);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src\logic\option_wrapper.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var OptionWrapper=function(){// Variables
function OptionWrapper(obj){_classCallCheck(this,OptionWrapper);this.id=0;this.type=__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["l" /* OptionType */].NONE;this.label="";this.renderer="";this.dValue=0;this.helper="";this.is_conditional=false;this.parentId=-1;this.variables=[];this.children=[];this.variables_extracted={};this.children_extracted={};this.multiple={};this.is_multiple=false;this.multiple_max_number=0;this.multiple_text="";this.multiple_more_text="";this.warning="";//
if(!obj)return;this.id=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]]['id'];// this.type = this.detectType(obj[META][TYPE]);
this.loadMetaData(obj);this.loadVariables(obj);this.loadChildren(obj);this.loadMultiple(obj);}// loading meta data
_createClass(OptionWrapper,[{key:'loadMetaData',value:function loadMetaData(obj){this.type=Object(__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["s" /* detectType */])(obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]][__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["p" /* TYPE */]]);this.label=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]][__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["f" /* LABEL */]];this.renderer=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]][__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["m" /* RENDERER */]];this.dValue=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]]['default'];// TODO: check the defautl
this.helper=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]][__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["d" /* HELPER */]];this.is_conditional=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]][__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["e" /* ISCONDITIONAL */]];this.parentId=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]]['parent_section'];// To modify "parent_section"
// NEXT
if('multiple'in obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]])this.is_multiple=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]]['multiple'];if('warning'in obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]])this.warning=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]]['warning'];if('multipletext'in obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]])this.multiple_text=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]]['multipletext'];if('multipleIncrtText'in obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]])this.multiple_more_text=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]]['multipleIncrtText'];if('multipleIncrt'in obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]])this.multiple_max_number=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["g" /* META */]]['multipleIncrt'];}// TODO: next section will be a little bit changed, it will contain the NOT LAZY LOAD
},{key:'loadVariables',value:function loadVariables(obj){this.variables=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["r" /* VARS */]];}},{key:'loadChildren',value:function loadChildren(obj){this.children=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["b" /* CHILDS */]];}},{key:'loadMultiple',value:function loadMultiple(obj){if(__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["h" /* MULTIPLE */] in obj)this.multiple=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["h" /* MULTIPLE */]];}},{key:'loadFenyanVariables',value:function loadFenyanVariables(vars_ref){var _this=this;this.variables.forEach(function(variable,index){_this.variables_extracted[index]=new __WEBPACK_IMPORTED_MODULE_1__variable_wrapper__["a" /* VariableWrapper */](vars_ref[variable]);});}}]);return OptionWrapper;}();

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertToO */
/* unused harmony export reindexOByFlat */
/* unused harmony export reindexOById */
/* unused harmony export getOVC */
/* unused harmony export getOptionsOVC */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*
* Project: LegalPlace assistant
* File: src/logic/ovc_converter.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// this file converts the OVC model in the local context to a Guy's format
function reindexOById(o){var _={};o.forEach(function(idx){_[idx.id]={flat:idx.key,value:idx.value};});return _;}function reindexOByFlat(o){var _={};o.forEach(function(idx){_[idx.key]={id:idx.id,value:idx.value};});return _;}function reindexFlatToKey(){var flat=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _={};flat.forEach(function(idx){_[idx.uiid]={parent:idx.parentId,type:idx.genre,id:idx.id};});return _;}function multipleFirst(id){var now=id;// parseInt(id);
while(typeof now!=='undefined'){if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(now).meta.multiple)return now;now=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa.getFather(now);}return false;}function getMultiplePosition(id){var pureId=Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(id);var copy=Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(id);var multiples=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(multipleFirst(pureId));if(typeof multiples==='undefined')return false;var idx=1;var i=0;while(multiples[i]!==copy){idx+=1;}return idx;}// check multiples, the first multiple parent
/* eslint-disable */// ████████╗███████╗███████╗████████╗    ████████╗██╗  ██╗███████╗    ██╗███╗   ██╗██╗████████╗██╗ █████╗ ██╗     ██╗███████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗
// ╚══██╔══╝██╔════╝██╔════╝╚══██╔══╝    ╚══██╔══╝██║  ██║██╔════╝    ██║████╗  ██║██║╚══██╔══╝██║██╔══██╗██║     ██║╚══███╔╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║
//    ██║   █████╗  ███████╗   ██║          ██║   ███████║█████╗      ██║██╔██╗ ██║██║   ██║   ██║███████║██║     ██║  ███╔╝ ███████║   ██║   ██║██║   ██║██╔██╗ ██║
//    ██║   ██╔══╝  ╚════██║   ██║          ██║   ██╔══██║██╔══╝      ██║██║╚██╗██║██║   ██║   ██║██╔══██║██║     ██║ ███╔╝  ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║
//    ██║   ███████╗███████║   ██║          ██║   ██║  ██║███████╗    ██║██║ ╚████║██║   ██║   ██║██║  ██║███████╗██║███████╗██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║
//    ╚═╝   ╚══════╝╚══════╝   ╚═╝          ╚═╝   ╚═╝  ╚═╝╚══════╝    ╚═╝╚═╝  ╚═══╝╚═╝   ╚═╝   ╚═╝╚═╝  ╚═╝╚══════╝╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝
/* eslint-enable */function getAllOptions(){var options=__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().output.o;var variables=__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().output.v;var optionsPre=__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.oF;var variablesPre=__WEBPACK_IMPORTED_MODULE_0__globals__["b" /* store */].getState().loadedOvc.vF;var o={};var c={};var v={};Array.prototype.fillAtIndex=function(value,index){for(var i=0;i<index;i+=1){if(typeof this[i]==='undefined')this.push('');}this.splice(index,1,value);return this;};// TODO: get the nearest grandpa multiple
// initialization of options
if(optionsPre){Object.keys(optionsPre).forEach(function(idx){var grandpa=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa;if(idx&&grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx))){// debugger//
var par=grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx));if(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx)!==-2){// multiple thing
if(_typeof(o[par])==='object'){var index=0;var parentMultiple=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(par);if((typeof parentMultiple==='undefined'?'undefined':_typeof(parentMultiple))==='object')index=parentMultiple.indexOf(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx));index=index>-1?index+1:0;o[par].fillAtIndex(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx),index);}else if(['string','integer'].indexOf(_typeof(o[par]))>-1){o[par]=[o[par],idx];}else if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx))).meta.multiple){o[grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx))]=[idx];}else o[grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx))]=idx;}else if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx))).meta.multiple){o[grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx))]=[idx];}else o[grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx))]=idx;}});}options.forEach(function(idx){if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)).meta.type==='radio'&&idx.value&&__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id))){// debugger
if(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx.id)!==-2){// multiple thing
var par=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id));if(_typeof(o[par])!=='object')o[par]=[];o[par].fillAtIndex(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id),__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.ovc.getIndexOfMultiple(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx.id)));}else if(multipleFirst(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id))){var _par=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id));if(_typeof(o[_par])!=='object')o[_par]=[];o[_par].fillAtIndex(idx.id,__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.ovc.getIndexOfMultiple(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx.id)));}else o[__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa.getFather(idx.id)]=idx.id;}if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)).meta.type==='checkbox'){// debugger
if(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx.id)!==-2){// multiple thing
if(_typeof(c[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)])!=='object'){c[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)]=[];var max=getMultiplePosition(idx.id);for(var i=0;i<max;i+=1){c[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)].push('');}}c[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)].push(idx.value);// console.log(idx.id)
// console.log(c[lpIdGetPure(idx.id)])
}else if(multipleFirst(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id))){if(_typeof(c[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)])==='object')c[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)][0]=idx.value;else c[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)]=[idx.value];}else c[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)]=idx.value;}});if(variablesPre){Object.keys(variablesPre).forEach(function(idx){if(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx)!==-2){// multiple thing
v[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx)].push(variablesPre[idx]);}else if(multipleFirst(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa_vars.getVGrandpa(idx)))){v[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx)]=[variablesPre[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx)]];}else v[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx)]=variablesPre[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx)];});}variables.forEach(function(idx){// console.log(idx);
if(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx.id)!==-2){// multiple thing
if(!v[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)])v[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)]=[];v[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)].fillAtIndex(idx.value,__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.ovc.getIndexOfMultiple(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["c" /* lpIdGetCopy */])(idx.id)));}else if(multipleFirst(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.grandpa_vars.getVGrandpa(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id))))){v[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)]=[idx.value];}else v[Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx.id)]=idx.value;});var cleanMultipleArray=function cleanMultipleArray(a,id,len){var def_val=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';if(typeof a[id]==='undefined')a[id]=[];else if(_typeof(a[id])!=='object')a[id]=[a[id]];if(a[id].length<len)for(var i=a[id].length;i<len;i+=1){a[id].push(def_val);}};// Cleaning multiples
Object.keys(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.multiples).forEach(function(idx){var multiple=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.multiples.multiples[idx];var length=((typeof multiple==='undefined'?'undefined':_typeof(multiple))==='object'?multiple.length:0)+1;var children=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.utils.getAllChildren(idx);var childrenVariables=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.utils.getAllVariableChildren([idx].concat(_toConsumableArray(children)));// Checking length
if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='checkbox')cleanMultipleArray(c,idx,length,false);else cleanMultipleArray(o,idx,length);// Checking options
children.forEach(function(cId){if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__global_getter__["d" /* lpIdGetPure */])(cId)).meta.type==='checkbox')cleanMultipleArray(c,cId,length,false);else cleanMultipleArray(o,cId,length);});// Cleaning childrenVariables
childrenVariables.forEach(function(cId){cleanMultipleArray(v,cId,length);});});return{o:o,v:v,c:c};}window.getAllOptions=getAllOptions;function convertToO(){var o=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var flat=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var _={};var c={};var f=reindexFlatToKey(flat);o.forEach(function(idx){if(idx.value){var cId=idx.id;if(typeof idx.id==='string'){var _idx$id$split=idx.id.split('_');var _idx$id$split2=_slicedToArray(_idx$id$split,1);cId=_idx$id$split2[0];}if(idx.key in f&&'parent'in f[idx.key]&&(f[idx.key].parent>0||typeof f[idx.key].parent==='string')&&f[idx.key].type==='o'){var cPid=f[idx.key].parent;var isCheckbox=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='checkbox';if(typeof cPid==='string'){cPid=parseInt(cPid.split('_')[0],10);}if(isCheckbox){if(cPid in c){if(!c[cPid].length){c[cPid]=[c[cPid],parseInt(cId,10)];}else c[cPid].push(parseInt(cId,10));}else if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(cId).meta.multiple)c[cPid]=[parseInt(cId,10)];else c[cPid]=parseInt(cId,10);}else if(cPid in _){if(!_[cPid].length){_[cPid]=[_[cPid],parseInt(cId,10)];}else _[cPid].push(parseInt(cId,10));}else if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(cId).meta.multiple)_[cPid]=[parseInt(cId,10)];else _[cPid]=parseInt(cId,10);}}});// console.log(_)
// console.log(c)
return[_,c];}function convertToV(){var v=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _={};// let f = reindexFlatToKey(flat);
v.forEach(function(idx){if(idx.value&&idx.value!==''){_[idx.id]=idx.value;}});return _;}// check if the parents are multiples or not
function traverseParents(id){var amMultiple=false;var idx=id;while(idx>=0){if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getOption(typeof idx==='string'?idx.split('_')[0]:idx).meta.multiple)amMultiple=true;idx=idx in window.lp_parenting_opts?window.lp_parenting_opts[idx].parent:-10;}return amMultiple;}// convert the object to O array usable in the payment and document generation
function getOptionsOVC(){var input=window.lp_ops;var passOne={};Object.keys(input).map(function(idx){return input[idx].value==='NONE'?null:passOne[idx]=input[idx].value;});var passTwo={};// debugger;
Object.keys(passOne).forEach(function(idx){if(idx.split('_').length>1){var idDiv=idx.split('_');// idDiv[0] = parseInt(idDiv[0]);
// debugger
if(passTwo[idDiv[0]]&&passTwo[idDiv[0]].length){passTwo[idDiv[0]].push(passOne[idx]);}}else if(window.lp_mult[idx]||traverseParents(idx))passTwo[idx]=[passOne[idx]];else{passTwo[idx]=passOne[idx];}});return passTwo;}function getOVC(o,v,flat){var convertedO=convertToO(o,flat);var convertedV=convertToV(v);// return {o: convertedO, v: convertedV, c: _c};
return[convertedO[0],convertedV,convertedO[1]];}window.getOVC=getAllOptions;

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es6_ParseError__ = __webpack_require__(239);
/* unused harmony reexport ParseError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_parsePhoneNumber__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__es6_parsePhoneNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es6_parsePhoneNumberFromString__ = __webpack_require__(883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__es6_parsePhoneNumberFromString__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__es6_findNumbers__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__es6_findNumbers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es6_searchNumbers__ = __webpack_require__(380);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_4__es6_searchNumbers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es6_findPhoneNumbersInText__ = __webpack_require__(381);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__es6_findPhoneNumbersInText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es6_searchPhoneNumbersInText__ = __webpack_require__(892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__es6_searchPhoneNumbersInText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__es6_PhoneNumberMatcher__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__es6_PhoneNumberMatcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__es6_AsYouType__ = __webpack_require__(382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__es6_AsYouType__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__es6_getCountries__ = __webpack_require__(893);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__es6_getCountries__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__es6_metadata__ = __webpack_require__(43);
/* unused harmony reexport Metadata */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__es6_metadata__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__es6_metadata__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__es6_metadata__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__es6_getExampleNumber__ = __webpack_require__(894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__es6_getExampleNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__es6_formatIncompletePhoneNumber__ = __webpack_require__(895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_12__es6_formatIncompletePhoneNumber__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__es6_parseIncompletePhoneNumber__ = __webpack_require__(375);
/* unused harmony reexport parseIncompletePhoneNumber */
/* unused harmony reexport parsePhoneNumberCharacter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__es6_parseDigits__ = __webpack_require__(163);
/* unused harmony reexport parseDigits */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__es6_RFC3966__ = __webpack_require__(243);
/* unused harmony reexport parseRFC3966 */
/* unused harmony reexport formatRFC3966 */























/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse___ = __webpack_require__(240);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function parsePhoneNumber(text, options, metadata) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__parse___["a" /* default */])(text, _objectSpread({}, options, {
    v2: true
  }), metadata);
}
//# sourceMappingURL=parsePhoneNumber_.js.map

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isViablePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extension__ = __webpack_require__(241);

 //  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']{' + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MIN_LENGTH_FOR_NSN */] + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PLUS_CHARS */] + ']{0,1}' + '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* VALID_PUNCTUATION */] + ']*' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']' + '){3,}' + '[' + __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* VALID_DIGITS */] + ']*'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + __WEBPACK_IMPORTED_MODULE_1__extension__["b" /* EXTN_PATTERNS_FOR_PARSING */] + ')?' + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MIN_LENGTH_FOR_NSN */] && VALID_PHONE_NUMBER_PATTERN.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseIncompletePhoneNumber;
/* unused harmony export parsePhoneNumberCharacter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parseDigits__ = __webpack_require__(163);

/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * `input-format` `parse()` function.
 * https://gitlab.com/catamphetamine/input-format
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string} value - The value parsed so far.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, value) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (value) {
      return;
    }

    return '+';
  } // Allow digits.


  return Object(__WEBPACK_IMPORTED_MODULE_0__parseDigits__["b" /* parseDigit */])(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPossiblePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = isPossibleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNumberType___ = __webpack_require__(129);


function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
    }
  }

  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, undefined, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, isInternational, metadata) {
  switch (Object(__WEBPACK_IMPORTED_MODULE_1__getNumberType___["a" /* checkNumberLengthForType */])(nationalNumber, undefined, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
//# sourceMappingURL=isPossibleNumber_.js.map

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = formatNumber;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIRST_GROUP_PATTERN; });
/* harmony export (immutable) */ __webpack_exports__["d"] = formatNationalNumberUsingFormat;
/* harmony export (immutable) */ __webpack_exports__["b"] = applyInternationalSeparatorStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IDD__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RFC3966__ = __webpack_require__(243);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js





var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  } // Formats a phone number
  //
  // Example use cases:
  //
  // ```js
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
  // formatNumber('+78005553535', 'NATIONAL')
  // formatNumber('+78005553535', 'NATIONAL', metadata)
  // ```
  //

};
function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata__["a" /* default */](metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return Object(__WEBPACK_IMPORTED_MODULE_4__RFC3966__["a" /* formatRFC3966 */])({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var IDDPrefix = Object(__WEBPACK_IMPORTED_MODULE_3__IDD__["a" /* getIDDPrefix */])(options.fromCountry, undefined, metadata.metadata);

      if (!IDDPrefix) {
        return;
      }

      if (options.humanReadable) {
        var formattedForSameCountryCallingCode = countryCallingCode && formatIDDSameCountryCallingCodeNumber(nationalNumber, metadata.countryCallingCode(), options.fromCountry, metadata, options);

        if (formattedForSameCountryCallingCode) {
          number = formattedForSameCountryCallingCode;
        } else {
          number = "".concat(IDDPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, 'INTERNATIONAL', metadata, options));
        }

        return addExtension(number, input.ext, metadata, options.formatExtension);
      }

      return "".concat(IDDPrefix).concat(countryCallingCode).concat(nationalNumber);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
} // This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly.  Therefore, we use \d, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, useInternationalSeparator, useNationalPrefixFormattingRule, metadata) {
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalSeparator ? format.internationalFormat() : useNationalPrefixFormattingRule && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalSeparator) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}

function formatNationalNumber(number, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, formatAs === 'INTERNATIONAL', format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options.nationalPrefix === false ? false : true, metadata);
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var format = _ref;

    // Validate leading digits
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* matchesEntirely */])(nationalNnumber, format.pattern())) {
      return format;
    }
  }
} // Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//


function applyInternationalSeparatorStyle(local) {
  return local.replace(new RegExp("[".concat(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* VALID_PUNCTUATION */], "]+"), 'g'), ' ').trim();
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDDSameCountryCallingCodeNumber(number, toCountryCallingCode, fromCountry, toCountryMetadata, options) {
  var fromCountryMetadata = new __WEBPACK_IMPORTED_MODULE_2__metadata__["a" /* default */](toCountryMetadata.metadata);
  fromCountryMetadata.country(fromCountry); // If calling within the same country calling code.

  if (toCountryCallingCode === fromCountryMetadata.countryCallingCode()) {
    // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.
    if (toCountryCallingCode === '1') {
      return toCountryCallingCode + ' ' + formatNationalNumber(number, 'NATIONAL', toCountryMetadata, options);
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formatNationalNumber(number, 'NATIONAL', toCountryMetadata, options);
  }
}
//# sourceMappingURL=format_.js.map

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findNumbers___ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber__ = __webpack_require__(162);


function findNumbers() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_1__parsePhoneNumber__["b" /* normalizeArguments */])(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return Object(__WEBPACK_IMPORTED_MODULE_0__findNumbers___["a" /* default */])(text, options, metadata);
}
//# sourceMappingURL=findNumbers.js.map

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _pN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pNd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _pL; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isLatinLetter;
/* harmony export (immutable) */ __webpack_exports__["d"] = isInvalidPunctuationSymbol;
// Javascript doesn't support UTF-8 regular expressions.
// So mimicking them here.
// Copy-pasted from `PhoneNumberMatcher.js`.

/**
 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
 * http://www.regular-expressions.info/unicode.html
 * "\P{Z}" is the reverse of "\p{Z}".
 * "\p{N}" is any kind of numeric character in any script ("Number").
 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
 * "\p{L}" is any kind of letter from any language ("Letter").
 * "\p{Mn}" is "non-spacing mark".
 *
 * Javascript doesn't support Unicode Regular Expressions
 * so substituting it with this explicit set of characters.
 *
 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
 */
var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
var pZ = "[".concat(_pZ, "]");
var PZ = "[^".concat(_pZ, "]");
var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19"; // const pN = `[${_pN}]`

var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
var pNd = "[".concat(_pNd, "]");
var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var pL = "[".concat(_pL, "]");
var pL_regexp = new RegExp(pL);
var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
var pSc = "[".concat(_pSc, "]");
var pSc_regexp = new RegExp(pSc);
var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
var pMn = "[".concat(_pMn, "]");
var pMn_regexp = new RegExp(pMn);
var _InBasic_Latin = "\0-\x7F";
var _InLatin_1_Supplement = "\x80-\xFF";
var _InLatin_Extended_A = "\u0100-\u017F";
var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
var _InLatin_Extended_B = "\u0180-\u024F";
var _InCombining_Diacritical_Marks = "\u0300-\u036F";
var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
/**
 * Helper method to determine if a character is a Latin-script letter or not.
 * For our purposes, combining marks should also return true since we assume
 * they have been added to a preceding Latin character.
 */

function isLatinLetter(letter) {
  // Combining marks are a subset of non-spacing-mark.
  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
    return false;
  }

  return latinLetterRegexp.test(letter);
}
function isInvalidPunctuationSymbol(character) {
  return character === '%' || pSc_regexp.test(character);
}
//# sourceMappingURL=utf-8.js.map

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher__ = __webpack_require__(245);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 * @return ES6 `for ... of` iterator.
 */

function searchNumbers() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber__["b" /* normalizeArguments */])(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  var matcher = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher__["a" /* default */](text, options, metadata);
  return _defineProperty({}, Symbol.iterator, function () {
    return {
      next: function next() {
        if (matcher.hasNext()) {
          return {
            done: false,
            value: matcher.next()
          };
        }

        return {
          done: true
        };
      }
    };
  });
}
//# sourceMappingURL=searchNumbers.js.map

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findPhoneNumbersInText;
/* harmony export (immutable) */ __webpack_exports__["b"] = getArguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findNumbers__ = __webpack_require__(378);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


function findPhoneNumbersInText(text, defaultCountry, options, metadata) {
  var args = getArguments(defaultCountry, options, metadata);
  return Object(__WEBPACK_IMPORTED_MODULE_0__findNumbers__["a" /* default */])(text, args.options, args.metadata);
}
function getArguments(defaultCountry, options, metadata) {
  if (metadata) {
    if (defaultCountry) {
      options = _objectSpread({}, options, {
        defaultCountry: defaultCountry
      });
    }
  } else {
    if (options) {
      metadata = options;

      if (defaultCountry) {
        if (is_object(defaultCountry)) {
          options = defaultCountry;
        } else {
          options = {
            defaultCountry: defaultCountry
          };
        }
      } else {
        options = undefined;
      }
    } else {
      metadata = defaultCountry;
      options = undefined;
    }
  }

  return {
    options: _objectSpread({}, options, {
      v2: true
    }),
    metadata: metadata
  };
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof(_) === 'object';
};
//# sourceMappingURL=findPhoneNumbersInText.js.map

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIGIT_PLACEHOLDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsYouType; });
/* unused harmony export stripNonPairedParens */
/* unused harmony export cutAndStripNonPairedParens */
/* unused harmony export closeNonPairedParens */
/* unused harmony export countOccurences */
/* unused harmony export repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumber__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse___ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__format___ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IDD__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getNumberType___ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parseDigits__ = __webpack_require__(163);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This is an enhanced port of Google Android `libphonenumber`'s
// `asyoutypeformatter.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/blob/8d21a365061de2ba0675c878a710a7b24f74d2ae/javascript/i18n/phonenumbers/asyoutypeformatter.js
//
// Simplified: does not differentiate between "local-only" numbers
// and "internationally dialable" numbers.
// For example, doesn't include changes like this:
// https://github.com/googlei18n/libphonenumber/commit/865da605da12b01053c4f053310bac7c5fbb7935








 // Used in phone number format template creation.
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // The digits that have not been entered yet will be represented by a \u2008,
// the punctuation space.

var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.

var SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
  return /\d(?=[^,}][^,}])/g;
}; // A pattern that is used to determine if a `format` is eligible
// to be used by the "as you type formatter".
// It is eligible when the `format` contains groups of the dollar sign
// followed by a single digit, separated by valid phone number punctuation.
// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
// getting into the output of the "as you type formatter".


var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* VALID_PUNCTUATION */] + ']*' + '(\\$\\d[' + __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* VALID_PUNCTUATION */] + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;
var VALID_FORMATTED_PHONE_NUMBER_PART = '[' + __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* VALID_DIGITS */] + ']+';
var VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_PART + '$', 'i');
var VALID_PHONE_NUMBER = '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PLUS_CHARS */] + ']' + '[' + __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* VALID_DIGITS */] + ']*' + '|' + '[' + __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* VALID_DIGITS */] + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* VALID_DIGITS */] + ']+' + '.*' + '$');
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var AsYouType =
/*#__PURE__*/
function () {
  // Not setting `options` to a constructor argument
  // not to break backwards compatibility
  // for older versions of the library.

  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck(this, AsYouType);

    _defineProperty(this, "options", {});

    this.metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata); // Set `defaultCountry` and `defaultCallingCode` options.

    var defaultCountry;
    var defaultCallingCode; // Turns out `null` also has type "object". Weird.

    if (optionsOrDefaultCountry) {
      if (_typeof(optionsOrDefaultCountry) === 'object') {
        defaultCountry = optionsOrDefaultCountry.defaultCountry;
        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
      } else {
        defaultCountry = optionsOrDefaultCountry;
      }
    }

    if (defaultCountry && this.metadata.hasCountry(defaultCountry)) {
      this.defaultCountry = defaultCountry;
    }

    if (defaultCallingCode) {
      /* istanbul ignore if */
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          this.defaultCountry = '001';
        }
      }

      this.defaultCallingCode = defaultCallingCode;
    } // Reset.


    this.reset();
  }

  _createClass(AsYouType, [{
    key: "reset",
    value: function reset() {
      this.formattedOutput = '';
      this.international = false;
      this.internationalPrefix = undefined;
      this.countryCallingCode = undefined;
      this.digits = '';
      this.nationalNumberDigits = '';
      this.nationalPrefix = '';
      this.carrierCode = '';
      this.setCountry(this.defaultCountry, this.defaultCallingCode);
      return this;
    }
  }, {
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.international;
    }
    /**
     * Returns the "country calling code" part of the phone number.
     * Returns `undefined` if the number is not being input in international format.
     * Returns "country calling code" for "non-geographic" phone numbering plans too.
     * @return {string} [countryCallingCode]
     */

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.countryCallingCode;
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      // If no digits have been input yet,
      // then `this.country` is the `defaultCountry`.
      // Won't return the `defaultCountry` in such case.
      if (!this.digits) {
        return;
      }

      var countryCode = this.country;
      /* istanbul ignore if */

      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (this.country === '001') {
          countryCode = undefined;
        }
      }

      return countryCode;
    }
  }, {
    key: "setCountry",
    value: function setCountry(country, callingCode) {
      this.country = country;
      this.metadata.selectNumberingPlan(country, callingCode);

      if (this.metadata.hasSelectedNumberingPlan()) {
        this.initializePhoneNumberFormatsForCountry();
      } else {
        this.matchingFormats = [];
      }

      this.resetFormat();
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var formattedDigits = this.extractFormattedDigits(text); // If the extracted phone number part
      // can possibly be a part of some valid phone number
      // then parse phone number characters from a formatted phone number.

      if (VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN.test(formattedDigits)) {
        this.formattedOutput = this.getFullNumber(this.inputDigits(Object(__WEBPACK_IMPORTED_MODULE_8__parseDigits__["a" /* default */])(formattedDigits)) || this.getNonFormattedNationalNumber());
      }

      return this.formattedOutput;
    }
    /**
     * Extracts formatted phone number digits from text (if there're any).
     * @param  {string} text
     * @return {string}
     */

  }, {
    key: "extractFormattedDigits",
    value: function extractFormattedDigits(text) {
      // Extract a formatted phone number part from text.
      var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

      if (extractedNumber[0] === '+') {
        // Trim the `+`.
        extractedNumber = extractedNumber.slice('+'.length);

        if (this.digits) {// If an out of position `+` is detected
          // (or a second `+`) then just ignore it.
        } else {
          this.formattedOutput = '+';
          this.startInternationalNumber();
        }
      }

      return extractedNumber;
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber() {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.setCountry();
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits) {
      // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.
      if (!this.digits) {
        var numberWithoutIDD = Object(__WEBPACK_IMPORTED_MODULE_6__IDD__["b" /* stripIDDPrefix */])(nextDigits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

        if (numberWithoutIDD && numberWithoutIDD !== nextDigits) {
          // If an IDD prefix was stripped then
          // convert the number to international one
          // for subsequent parsing.
          this.internationalPrefix = nextDigits.slice(0, nextDigits.length - numberWithoutIDD.length);
          nextDigits = numberWithoutIDD;
          this.startInternationalNumber();
        }
      } // Append phone number digits.


      this.digits += nextDigits; // Try to format the parsed input

      if (this.isInternational()) {
        if (this.countryCallingCode) {
          this.nationalNumberDigits += nextDigits; // `this.country` could be `undefined`, for example, when there is
          // ambiguity in a form of several different countries,
          // each corresponding to the same country phone code
          // (e.g. NANPA: USA, Canada, etc), and there's not enough digits
          // to reliably determine the country the phone number belongs to.
          // Therefore, in cases of such ambiguity, each time something is input,
          // try to determine the country (if it hasn't been determined yet).

          if (!this.country || this.isCountryCallingCodeAmbiguous()) {
            this.determineTheCountry();
          }
        } else {
          // Extract country calling code from the digits entered so far.
          // There must be some digits in order to extract anything from them.
          //
          // If one looks at country phone codes
          // then they can notice that no one country phone code
          // is ever a (leftmost) substring of another country phone code.
          // So if a valid country code is extracted so far
          // then it means that this is the country code.
          //
          // If no country phone code could be extracted so far,
          // then don't format the phone number.
          //
          if (!this.extractCountryCallingCode()) {
            // Don't format the phone number.
            return;
          } // Possibly extract a national prefix.
          // Some people incorrectly input national prefix
          // in an international phone number.
          // For example, some people write British phone numbers as `+44(0)...`.
          // Also, mobile phone numbers in Mexico are supposed to be dialled
          // internationally using a `15` national prefix.
          //
          // https://www.mexperience.com/dialing-cell-phones-in-mexico/
          //
          // "Dialing a Mexican cell phone from abroad
          // When you are calling a cell phone number in Mexico from outside Mexico,
          // it’s necessary to dial an additional “1” after Mexico’s country code
          // (which is “52”) and before the area code.
          // You also ignore the 045, and simply dial the area code and the
          // cell phone’s number.
          //
          // If you don’t add the “1”, you’ll receive a recorded announcement
          // asking you to redial using it.
          //
          // For example, if you are calling from the USA to a cell phone
          // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
          // (Note that this is different to calling a land line in Mexico City
          // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
          //


          this.nationalNumberDigits = this.digits.slice(this.countryCallingCode.length); // this.extractNationalPrefix()
          //
          // Determine the country from country calling code and national number.

          this.determineTheCountry();
        }
      } else {
        this.nationalNumberDigits += nextDigits; // If `defaultCallingCode` is set,
        // see if the `country` could be derived.

        if (!this.country) {
          this.determineTheCountry();
        } // Some national prefixes are substrings of other national prefixes
        // (for the same country), therefore try to extract national prefix each time
        // because a longer national prefix might be available at some point in time.


        var previousNationalPrefix = this.nationalPrefix;
        this.nationalNumberDigits = this.nationalPrefix + this.nationalNumberDigits; // Re-extract national prefix.

        this.extractNationalPrefix(); // If another national prefix has been extracted.

        if (this.nationalPrefix !== previousNationalPrefix) {
          // National number has changed
          // (due to another national prefix been extracted)
          // therefore national number has changed
          // therefore reset all previous formatting data.
          // (and leading digits matching state)
          this.initializePhoneNumberFormatsForCountry();
          this.resetFormat();
        }
      }

      if (this.nationalNumberDigits) {
        // Match the available formats by the currently available leading digits.
        this.matchFormats(this.nationalNumberDigits);
      } // Format the phone number (given the next digits)


      return this.formatNationalNumberWithNextDigits(nextDigits);
    }
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits) {
      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNextNationalNumberDigits()`,
      // which formats based on the chosen formatting pattern.
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`.
      var formattedNumber = this.attemptToFormatCompletePhoneNumber(); // Just because a phone number doesn't have a suitable format
      // that doesn't mean that the phone number is invalid,
      // because phone number formats only format phone numbers,
      // they don't validate them and some (rare) phone numbers
      // are meant to stay non-formatted.

      if (formattedNumber) {
        return formattedNumber;
      } // Format the next phone number digits
      // using the previously chosen phone number format.
      //
      // This is done here because if `attemptToFormatCompletePhoneNumber`
      // was placed before this call then the `template`
      // wouldn't reflect the situation correctly (and would therefore be inconsistent)
      //


      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat();

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If could format the next (current) digit
          // using the previously chosen phone number format
          // then return the formatted number so far.
          //
          // If no new phone number format could be chosen,
          // and couldn't format the supplied national number
          // using the previously chosen phone number pattern,
          // then return `undefined`.
          //
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then format the national phone number (so far)
          // using the newly selected format.
          //
          // Will return `undefined` if it couldn't format
          // the supplied national number
          // using the selected phone number pattern.
          //
          return this.reformatNationalNumber();
        }
      }
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat() {
      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var format = _ref;

        // If this format is currently being used
        // and is still possible, then stick to it.
        if (this.chosenFormat === format) {
          break;
        }

        if (!this.createFormattingTemplate(format)) {
          continue;
        }

        this.chosenFormat = format; // With a new formatting template, the matched position
        // using the old template needs to be reset.

        this.populatedNationalNumberTemplatePosition = -1;
        break;
      }

      if (!this.chosenFormat) {
        // No format matches the national phone number entered.
        this.resetFormat();
      }

      return this.chosenFormat;
    } // Formats each digit of the national phone number (so far)
    // using the selected format.

  }, {
    key: "reformatNationalNumber",
    value: function reformatNationalNumber() {
      return this.formatNextNationalNumberDigits(this.nationalPrefix + this.nationalNumberDigits);
    }
  }, {
    key: "initializePhoneNumberFormatsForCountry",
    value: function initializePhoneNumberFormatsForCountry() {
      // Get all "eligible" phone number formats for this country
      this.matchingFormats = this.metadata.formats().filter(function (format) {
        // Compared to `libphonenumber`'s code, the two "Discard a few formats
        // that we know are not relevant based on the presence of the national prefix"
        // checks have changed: the first one has been moved to `.matchFormats()`,
        // and the second one doesn't apply to this library because it doesn't deal with
        // "incomplete" phone numbers (for example, phone numbers, entered without "area code").
        return ELIGIBLE_FORMAT_PATTERN.test(format.internationalFormat());
      });
    }
  }, {
    key: "matchFormats",
    value: function matchFormats(leadingDigits) {
      var _this = this;

      // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.
      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        // If national prefix is mandatory for this phone number format
        // and the user didn't input the national prefix
        // then this phone number format isn't suitable.
        if (!_this.isInternational() && !_this.nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
          return false;
        }

        var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
        // leading digits pattern then it fits.

        if (leadingDigitsPatternsCount === 0) {
          return true;
        } // Start excluding any non-matching formats only when the
        // national number entered so far is at least 3 digits long,
        // otherwise format matching would give false negatives.
        // For example, when the digits entered so far are `2`
        // and the leading digits pattern is `21` –
        // it's quite obvious in this case that the format could be the one
        // but due to the absence of further digits it would give false negative.


        if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
          return true;
        } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
        // then format matching starts narrowing down the list of possible formats
        // (only previously matched formats are considered for next digits).


        leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
        var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
        // all or-ed (`|`) parts, not just the first one.

        return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function getSeparatorAfterNationalPrefix(format) {
      if (this.metadata.countryCallingCode() === '1') {
        return ' ';
      }

      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      }

      return '';
    } // This is in accordance to how Google's `libphonenumber` does it.
    // "Check to see if there is an exact pattern match for these digits.
    // If so, we should use this instead of any other formatting template
    // whose `leadingDigitsPattern` also matches the input."

  }, {
    key: "attemptToFormatCompletePhoneNumber",
    value: function attemptToFormatCompletePhoneNumber() {
      for (var _iterator2 = this.matchingFormats, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var format = _ref2;
        var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

        if (!matcher.test(this.nationalNumberDigits)) {
          continue;
        } // Here, national number is formatted without "national prefix
        // formatting rule", because otherwise there'd be a bug
        // when "area code" is "duplicated" during input:
        // https://github.com/catamphetamine/libphonenumber-js/issues/318


        var formattedNationalNumber = Object(__WEBPACK_IMPORTED_MODULE_5__format___["d" /* formatNationalNumberUsingFormat */])(this.nationalNumberDigits, format, this.isInternational(), false, // Don't prepend national prefix (it will be prepended manually).
        this.metadata); // Check if this `format` preserves all digits.
        // This is how it's done in Google's `libphonenumber`.
        // Also, it fixes the bug when "area code" is "duplicated" during input:
        // https://github.com/catamphetamine/libphonenumber-js/issues/318
        //
        // "Check that we didn't remove nor add any extra digits when we matched
        // this formatting pattern. This usually happens after we entered the last
        // digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
        // formatted but AYTF should retain all the number entered and not change
        // in order to match a format (of same leading digits and length) display
        // in that way."
        // "If it's the same (i.e entered number and format is same), then it's
        // safe to return this in formatted number as nothing is lost / added."
        // Otherwise, don't use this format.
        // https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
        // https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
        //

        if (Object(__WEBPACK_IMPORTED_MODULE_8__parseDigits__["a" /* default */])(formattedNationalNumber) !== this.nationalNumberDigits) {
          continue;
        } // Prepend national prefix (if any).


        if (this.nationalPrefix) {
          // Here, national number is formatted with "national prefix
          // formatting rule". The reason is that "national prefix
          // formatting rule" often adds parentheses, and while Google's
          // `libphonenumber` dismisses those preferring simply prepending
          // national prefix followed by a " " character, this library
          // looks if the national prefix could be formatted better.
          var formattedNationalNumberWithNationalPrefix = Object(__WEBPACK_IMPORTED_MODULE_5__format___["d" /* formatNationalNumberUsingFormat */])(this.nationalNumberDigits, format, this.isInternational(), true, // Prepend national prefix.
          this.metadata);

          if (Object(__WEBPACK_IMPORTED_MODULE_8__parseDigits__["a" /* default */])(formattedNationalNumberWithNationalPrefix) === this.nationalPrefix + this.nationalNumberDigits) {
            formattedNationalNumber = formattedNationalNumberWithNationalPrefix;
          } else {
            formattedNationalNumber = this.nationalPrefix + this.getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
          }
        } // formats national number (probably) without national prefix.
        // Formatting a national number with national prefix could result in
        // bugs when "area code" is "duplicated" during input:
        // https://github.com/catamphetamine/libphonenumber-js/issues/318
        // The "are all digits preserved" check fixes that type of bug.
        // To leave the formatter in a consistent state


        this.resetFormat();
        this.chosenFormat = format; // Set `this.template` and `this.populatedNationalNumberTemplate`.

        /* istanbul ignore else */

        if (this.createFormattingTemplate(format)) {
          // Populate `this.populatedNationalNumberTemplate` with phone number digits.
          this.reformatNationalNumber();
        } else {
          // If the formatting template couldn't be created for a format,
          // create it manually from the formatted phone number.
          // This case doesn't ever happen with the current metadata.
          this.template = this.getFullNumber(formattedNationalNumber).replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
          this.populatedNationalNumberTemplate = formattedNationalNumber;
          this.populatedNationalNumberTemplatePosition = this.populatedNationalNumberTemplate.length - 1;
        }

        return formattedNationalNumber;
      }
    }
  }, {
    key: "getInternationalPrefix",
    value: function getInternationalPrefix(options) {
      return this.internationalPrefix ? options && options.spacing === false ? this.internationalPrefix : this.internationalPrefix + ' ' : '+';
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      if (this.isInternational()) {
        var prefix = this.getInternationalPrefix();

        if (!this.countryCallingCode) {
          return "".concat(prefix).concat(this.digits);
        }

        if (!formattedNationalNumber) {
          return "".concat(prefix).concat(this.countryCallingCode);
        }

        return "".concat(prefix).concat(this.countryCallingCode, " ").concat(formattedNationalNumber);
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumber",
    value: function getNonFormattedNationalNumber() {
      return this.nationalPrefix + (this.nationalPrefix && this.nationalNumberDigits && this.getSeparatorAfterNationalPrefix()) + this.nationalNumberDigits;
    } // Extracts the country calling code from the beginning
    // of the entered `national_number` (so far),
    // and places the remaining input into the `national_number`.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode() {
      var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_4__parse___["b" /* extractCountryCallingCode */])('+' + this.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (!countryCallingCode) {
        return;
      }

      this.nationalNumberDigits = number;
      this.countryCallingCode = countryCallingCode;
      this.metadata.chooseCountryByCountryCallingCode(countryCallingCode);
      this.initializePhoneNumberFormatsForCountry();
      this.resetFormat();
      return this.metadata.hasSelectedNumberingPlan();
    }
  }, {
    key: "extractNationalPrefix",
    value: function extractNationalPrefix() {
      this.nationalPrefix = '';

      if (!this.metadata.hasSelectedNumberingPlan()) {
        return;
      } // Only strip national prefixes for non-international phone numbers
      // because national prefixes can't be present in international phone numbers.
      // While `parseNumber()` is forgiving is such cases, `AsYouType` is not.


      var _stripNationalPrefixA = Object(__WEBPACK_IMPORTED_MODULE_4__parse___["e" /* stripNationalPrefixAndCarrierCode */])(this.nationalNumberDigits, this.metadata),
          nationalNumber = _stripNationalPrefixA.nationalNumber,
          carrierCode = _stripNationalPrefixA.carrierCode; // Sometimes `stripNationalPrefixAndCarrierCode()` won't actually
      // strip national prefix and will instead prepend some digits to the `number`:
      // for example, when number `2345678` is passed with `VI` country selected,
      // it will return `{ number: "3402345678" }`, because `340` area code is prepended.
      // So check if the `nationalNumber` is actually at the end of `this.nationalNumberDigits`.


      if (nationalNumber) {
        var index = this.nationalNumberDigits.indexOf(nationalNumber);

        if (index < 0 || index !== this.nationalNumberDigits.length - nationalNumber.length) {
          return;
        }
      }

      if (carrierCode) {
        this.carrierCode = carrierCode;
      }

      this.nationalPrefix = this.nationalNumberDigits.slice(0, this.nationalNumberDigits.length - nationalNumber.length);
      this.nationalNumberDigits = nationalNumber;
      return this.nationalPrefix;
    } // isPossibleNumber(number) {
    // 	switch (checkNumberLengthForType(number, undefined, this.metadata)) {
    // 		case 'IS_POSSIBLE':
    // 			return true
    // 		// case 'IS_POSSIBLE_LOCAL_ONLY':
    // 		// 	return !this.isInternational()
    // 		default:
    // 			return false
    // 	}
    // }

  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var countryCodes = this.metadata.getCountryCodesForCallingCode(this.countryCallingCode);
      return countryCodes && countryCodes.length > 1;
    }
  }, {
    key: "createFormattingTemplate",
    value: function createFormattingTemplate(format) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForNumberFormatPattern(format, this.nationalPrefix); // If the national number entered is too long
      // for any phone number format, then abort.

      if (!template) {
        return;
      }

      this.template = template;
      this.populatedNationalNumberTemplate = template; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (this.isInternational()) {
        this.template = this.getInternationalPrefix().replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, this.countryCallingCode.length) + ' ' + template;
      }

      return this.template;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForNumberFormatPattern",
    value: function getTemplateForNumberFormatPattern(format, nationalPrefix) {
      var pattern = format.pattern();
      /* istanbul ignore else */

      if (SUPPORT_LEGACY_FORMATTING_PATTERNS) {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (this.nationalNumberDigits.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalNumberDigits : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalNumberDigits` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalNumberDigits`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = this.nationalNumberDigits.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalNumberDigits` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format);
      var includesNationalPrefix;

      if (nationalPrefix) {
        if (format.nationalPrefixFormattingRule()) {
          var numberFormatWithNationalPrefix = numberFormat.replace(__WEBPACK_IMPORTED_MODULE_5__format___["a" /* FIRST_GROUP_PATTERN */], format.nationalPrefixFormattingRule());

          if (Object(__WEBPACK_IMPORTED_MODULE_8__parseDigits__["a" /* default */])(numberFormatWithNationalPrefix) === nationalPrefix + Object(__WEBPACK_IMPORTED_MODULE_8__parseDigits__["a" /* default */])(numberFormat)) {
            numberFormat = numberFormatWithNationalPrefix;
            includesNationalPrefix = true;
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER);

      if (nationalPrefix) {
        if (!includesNationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      // Using `.split('')` to iterate through a string here
      // to avoid requiring `Symbol.iterator` polyfill.
      // `.split('')` is generally not safe for Unicode,
      // but in this particular case for `digits` it is safe.
      // for (const digit of digits)
      for (var _iterator3 = digits.split(''), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var digit = _ref3;

        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (this.populatedNationalNumberTemplate.slice(this.populatedNationalNumberTemplatePosition + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
          // Reset the format.
          this.resetFormat();
          return;
        }

        this.populatedNationalNumberTemplatePosition = this.populatedNationalNumberTemplate.search(DIGIT_PLACEHOLDER_MATCHER);
        this.populatedNationalNumberTemplate = this.populatedNationalNumberTemplate.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
      } // Return the formatted phone number so far.


      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format) {
      if (this.isInternational()) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__format___["b" /* applyInternationalSeparatorStyle */])(format.internationalFormat());
      }

      return format.format();
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.country = Object(__WEBPACK_IMPORTED_MODULE_4__parse___["d" /* findCountryCode */])(this.isInternational() ? this.countryCallingCode : this.defaultCallingCode, this.nationalNumberDigits, this.metadata);
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      if (this.isInternational()) {
        if (!this.countryCallingCode) {
          return;
        }
      } else {
        if (!this.country && !this.defaultCallingCode) {
          return;
        }
      }

      if (!this.nationalNumberDigits) {
        return undefined;
      }

      var countryCode = this.getCountry();
      var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
      var nationalNumber = this.nationalNumberDigits;
      var carrierCode = this.carrierCode; // When an international number without a leading `+` has been autocorrected,
      // extract country calling code, because normally it's only extracted
      // for international numbers with a leading `+`.
      // Could also just use `parsePhoneNumberFromString()` here
      // instead of hacking around this single case.

      if (!this.isInternational() && this.nationalNumberDigits === this.digits) {
        var _extractCountryCallin2 = Object(__WEBPACK_IMPORTED_MODULE_4__parse___["c" /* extractCountryCallingCodeFromInternationalNumberWithoutPlusSign */])(this.digits, countryCode, callingCode, this.metadata.metadata),
            countryCallingCode = _extractCountryCallin2.countryCallingCode,
            number = _extractCountryCallin2.number;

        if (countryCallingCode) {
          var _stripNationalPrefixA2 = Object(__WEBPACK_IMPORTED_MODULE_4__parse___["f" /* stripNationalPrefixAndCarrierCodeFromCompleteNumber */])(number, this.metadata),
              shorterNationalNumber = _stripNationalPrefixA2.nationalNumber,
              newCarrierCode = _stripNationalPrefixA2.carrierCode;

          nationalNumber = shorterNationalNumber;
          carrierCode = newCarrierCode;
        }
      }

      var phoneNumber = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumber__["a" /* default */](countryCode || callingCode, nationalNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.nationalNumberDigits;
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      return this.getFullNumber(this.getNonFormattedNationalNumber()).replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
    }
    /**
     * Returns formatted phone number template.
     * @return {string} [template]
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      if (!this.template) {
        return this.getNonFormattedTemplate();
      }

      var index = -1;
      var i = 0;

      while (i < (this.isInternational() ? this.getInternationalPrefix({
        spacing: false
      }).length : 0) + this.digits.length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }]);

  return AsYouType;
}();


function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i4 = 0, _dangling_braces = dangling_braces; _i4 < _dangling_braces.length; _i4++) {
    var index = _dangling_braces[_i4];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function closeNonPairedParens(template, cut_before) {
  var retained_template = template.slice(0, cut_before);
  var opening_braces = countOccurences('(', retained_template);
  var closing_braces = countOccurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return template.slice(0, cut_before);
} // Counts all occurences of a symbol in a string.
// Unicode-unsafe (because using `.split()`).

function countOccurences(symbol, string) {
  var count = 0; // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for counting brackets it is safe.
  // for (const character of string)

  for (var _iterator4 = string.split(''), _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray4) {
      if (_i5 >= _iterator4.length) break;
      _ref4 = _iterator4[_i5++];
    } else {
      _i5 = _iterator4.next();
      if (_i5.done) break;
      _ref4 = _i5.value;
    }

    var character = _ref4;

    if (character === symbol) {
      count++;
    }
  }

  return count;
} // Repeats a string (or a symbol) N times.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
/**
 * Extracts formatted phone number from text (if there's any).
 * @param  {string} text
 * @return {string} [formattedPhoneNumber]
 */

function extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_PHONE_NUMBER);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
//# sourceMappingURL=AsYouType.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);
var settle = __webpack_require__(901);
var buildURL = __webpack_require__(903);
var parseHeaders = __webpack_require__(904);
var isURLSameOrigin = __webpack_require__(905);
var createError = __webpack_require__(385);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(906);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(902);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_SUBSCRIPTION_CONTRACT_META_ID; });
var AVAILABLE_SUBSCRIPTION_CONTRACT_META_ID=[1,2,3,75];

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var jws = __webpack_require__(247);

module.exports = function (jwt, options) {
  options = options || {};
  var decoded = jws.decode(jwt, options);
  if (!decoded) { return null; }
  var payload = decoded.payload;

  //try parse the payload
  if(typeof payload === 'string') {
    try {
      var obj = JSON.parse(payload);
      if(obj !== null && typeof obj === 'object') {
        payload = obj;
      }
    } catch (e) { }
  }

  //return header if `complete` option is enabled.  header includes claims
  //such as `kid` and `alg` used to select the key within a JWKS needed to
  //verify the signature
  if (options.complete === true) {
    return {
      header: decoded.header,
      payload: payload,
      signature: decoded.signature
    };
  }
  return payload;
};


/***/ }),
/* 390 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*global module, process*/
var Buffer = __webpack_require__(5).Buffer;
var Stream = __webpack_require__(111);
var util = __webpack_require__(110);

function DataStream(data) {
  this.buffer = null;
  this.writable = true;
  this.readable = true;

  // No input
  if (!data) {
    this.buffer = Buffer.alloc(0);
    return this;
  }

  // Stream
  if (typeof data.pipe === 'function') {
    this.buffer = Buffer.alloc(0);
    data.pipe(this);
    return this;
  }

  // Buffer or String
  // or Object (assumedly a passworded key)
  if (data.length || typeof data === 'object') {
    this.buffer = data;
    this.writable = false;
    process.nextTick(function () {
      this.emit('end', data);
      this.readable = false;
      this.emit('close');
    }.bind(this));
    return this;
  }

  throw new TypeError('Unexpected data type ('+ typeof data + ')');
}
util.inherits(DataStream, Stream);

DataStream.prototype.write = function write(data) {
  this.buffer = Buffer.concat([this.buffer, Buffer.from(data)]);
  this.emit('data', data);
};

DataStream.prototype.end = function end(data) {
  if (data)
    this.write(data);
  this.emit('end', data);
  this.emit('close');
  this.writable = false;
  this.readable = false;
};

module.exports = DataStream;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(167);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(390);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(248).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(393);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(5).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(130));
util.inherits = __webpack_require__(7);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(918);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(919);
var destroyImpl = __webpack_require__(394);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(98);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(251).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(98);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(251).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(31)))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(248).EventEmitter;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(167);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(98);

/*<replacement>*/
var util = Object.create(__webpack_require__(130));
util.inherits = __webpack_require__(7);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var bufferEqual = __webpack_require__(930);
var Buffer = __webpack_require__(5).Buffer;
var crypto = __webpack_require__(931);
var formatEcdsa = __webpack_require__(998);
var util = __webpack_require__(110);

var MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".'
var MSG_INVALID_SECRET = 'secret must be a string or buffer';
var MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';

var supportsKeyObjects = typeof crypto.createPublicKey === 'function';
if (supportsKeyObjects) {
  MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
  MSG_INVALID_SECRET += 'or a KeyObject';
}

function checkIsPublicKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return;
  }

  if (!supportsKeyObjects) {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key !== 'object') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.type !== 'string') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.asymmetricKeyType !== 'string') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.export !== 'function') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }
};

function checkIsPrivateKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return;
  }

  if (typeof key === 'object') {
    return;
  }

  throw typeError(MSG_INVALID_SIGNER_KEY);
};

function checkIsSecretKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return key;
  }

  if (!supportsKeyObjects) {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (typeof key !== 'object') {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (key.type !== 'secret') {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (typeof key.export !== 'function') {
    throw typeError(MSG_INVALID_SECRET);
  }
}

function fromBase64(base64) {
  return base64
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

function toBase64(base64url) {
  base64url = base64url.toString();

  var padding = 4 - base64url.length % 4;
  if (padding !== 4) {
    for (var i = 0; i < padding; ++i) {
      base64url += '=';
    }
  }

  return base64url
    .replace(/\-/g, '+')
    .replace(/_/g, '/');
}

function typeError(template) {
  var args = [].slice.call(arguments, 1);
  var errMsg = util.format.bind(util, template).apply(null, args);
  return new TypeError(errMsg);
}

function bufferOrString(obj) {
  return Buffer.isBuffer(obj) || typeof obj === 'string';
}

function normalizeInput(thing) {
  if (!bufferOrString(thing))
    thing = JSON.stringify(thing);
  return thing;
}

function createHmacSigner(bits) {
  return function sign(thing, secret) {
    checkIsSecretKey(secret);
    thing = normalizeInput(thing);
    var hmac = crypto.createHmac('sha' + bits, secret);
    var sig = (hmac.update(thing), hmac.digest('base64'))
    return fromBase64(sig);
  }
}

function createHmacVerifier(bits) {
  return function verify(thing, signature, secret) {
    var computedSig = createHmacSigner(bits)(thing, secret);
    return bufferEqual(Buffer.from(signature), Buffer.from(computedSig));
  }
}

function createKeySigner(bits) {
 return function sign(thing, privateKey) {
    checkIsPrivateKey(privateKey);
    thing = normalizeInput(thing);
    // Even though we are specifying "RSA" here, this works with ECDSA
    // keys as well.
    var signer = crypto.createSign('RSA-SHA' + bits);
    var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
    return fromBase64(sig);
  }
}

function createKeyVerifier(bits) {
  return function verify(thing, signature, publicKey) {
    checkIsPublicKey(publicKey);
    thing = normalizeInput(thing);
    signature = toBase64(signature);
    var verifier = crypto.createVerify('RSA-SHA' + bits);
    verifier.update(thing);
    return verifier.verify(publicKey, signature, 'base64');
  }
}

function createPSSKeySigner(bits) {
  return function sign(thing, privateKey) {
    checkIsPrivateKey(privateKey);
    thing = normalizeInput(thing);
    var signer = crypto.createSign('RSA-SHA' + bits);
    var sig = (signer.update(thing), signer.sign({
      key: privateKey,
      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
    }, 'base64'));
    return fromBase64(sig);
  }
}

function createPSSKeyVerifier(bits) {
  return function verify(thing, signature, publicKey) {
    checkIsPublicKey(publicKey);
    thing = normalizeInput(thing);
    signature = toBase64(signature);
    var verifier = crypto.createVerify('RSA-SHA' + bits);
    verifier.update(thing);
    return verifier.verify({
      key: publicKey,
      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
    }, signature, 'base64');
  }
}

function createECDSASigner(bits) {
  var inner = createKeySigner(bits);
  return function sign() {
    var signature = inner.apply(null, arguments);
    signature = formatEcdsa.derToJose(signature, 'ES' + bits);
    return signature;
  };
}

function createECDSAVerifer(bits) {
  var inner = createKeyVerifier(bits);
  return function verify(thing, signature, publicKey) {
    signature = formatEcdsa.joseToDer(signature, 'ES' + bits).toString('base64');
    var result = inner(thing, signature, publicKey);
    return result;
  };
}

function createNoneSigner() {
  return function sign() {
    return '';
  }
}

function createNoneVerifier() {
  return function verify(thing, signature) {
    return signature === '';
  }
}

module.exports = function jwa(algorithm) {
  var signerFactories = {
    hs: createHmacSigner,
    rs: createKeySigner,
    ps: createPSSKeySigner,
    es: createECDSASigner,
    none: createNoneSigner,
  }
  var verifierFactories = {
    hs: createHmacVerifier,
    rs: createKeyVerifier,
    ps: createPSSKeyVerifier,
    es: createECDSAVerifer,
    none: createNoneVerifier,
  }
  var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
  if (!match)
    throw typeError(MSG_INVALID_ALGORITHM, algorithm);
  var algo = (match[1] || match[3]).toLowerCase();
  var bits = match[2];

  return {
    sign: signerFactories[algo](bits),
    verify: verifierFactories[algo](bits),
  }
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(5).Buffer
var Transform = __webpack_require__(111).Transform
var inherits = __webpack_require__(7)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(113)
var Buffer = __webpack_require__(5).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(113)
var Buffer = __webpack_require__(5).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(7)
var Legacy = __webpack_require__(936)
var Base = __webpack_require__(82)
var Buffer = __webpack_require__(5).Buffer
var md5 = __webpack_require__(401)
var RIPEMD160 = __webpack_require__(253)

var sha = __webpack_require__(254)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(252)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(938)
exports.pbkdf2Sync = __webpack_require__(406)


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(401)
var RIPEMD160 = __webpack_require__(253)
var sha = __webpack_require__(254)

var checkParameters = __webpack_require__(404)
var defaultEncoding = __webpack_require__(405)
var Buffer = __webpack_require__(5).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(49);
var inherits = __webpack_require__(7);

var utils = __webpack_require__(407);
var Cipher = __webpack_require__(255);

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(132)
var Buffer = __webpack_require__(5).Buffer
var incr32 = __webpack_require__(410)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 410 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(168)
var Buffer = __webpack_require__(5).Buffer
var Transform = __webpack_require__(82)
var inherits = __webpack_require__(7)
var GHASH = __webpack_require__(951)
var xor = __webpack_require__(132)
var incr32 = __webpack_require__(410)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(168)
var Buffer = __webpack_require__(5).Buffer
var Transform = __webpack_require__(82)
var inherits = __webpack_require__(7)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(112);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(30);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(415);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(30);
var brorand = __webpack_require__(258);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(170);
curve.short = __webpack_require__(962);
curve.mont = __webpack_require__(963);
curve.edwards = __webpack_require__(964);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var common = __webpack_require__(133);
var shaCommon = __webpack_require__(418);
var assert = __webpack_require__(49);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var common = __webpack_require__(133);
var assert = __webpack_require__(49);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);
var Reporter = __webpack_require__(135).Reporter;
var Buffer = __webpack_require__(27).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(984);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);

var asn1 = __webpack_require__(134);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);
var Buffer = __webpack_require__(27).Buffer;

var asn1 = __webpack_require__(134);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(131)
var Buffer = __webpack_require__(5).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(30)
var Buffer = __webpack_require__(5).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

/*global module*/
var Buffer = __webpack_require__(27).Buffer;

module.exports = function toString(obj) {
  if (typeof obj === 'string')
    return obj;
  if (typeof obj === 'number' || Buffer.isBuffer(obj))
    return obj.toString();
  return JSON.stringify(obj);
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var JsonWebTokenError = __webpack_require__(172);

var NotBeforeError = function (message, date) {
  JsonWebTokenError.call(this, message);
  this.name = 'NotBeforeError';
  this.date = date;
};

NotBeforeError.prototype = Object.create(JsonWebTokenError.prototype);

NotBeforeError.prototype.constructor = NotBeforeError;

module.exports = NotBeforeError;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var JsonWebTokenError = __webpack_require__(172);

var TokenExpiredError = function (message, expiredAt) {
  JsonWebTokenError.call(this, message);
  this.name = 'TokenExpiredError';
  this.expiredAt = expiredAt;
};

TokenExpiredError.prototype = Object.create(JsonWebTokenError.prototype);

TokenExpiredError.prototype.constructor = TokenExpiredError;

module.exports = TokenExpiredError;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var ms = __webpack_require__(1002);

module.exports = function (time, iat) {
  var timestamp = iat || Math.floor(Date.now() / 1000);

  if (typeof time === 'string') {
    var milliseconds = ms(time);
    if (typeof milliseconds === 'undefined') {
      return;
    }
    return Math.floor(timestamp + milliseconds / 1000);
  } else if (typeof time === 'number') {
    return timestamp + time;
  } else {
    return;
  }

};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var semver = __webpack_require__(1003);

module.exports = semver.satisfies(process.version, '^6.12.0 || >=8.0.0');

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ADD_ERROR */
/* unused harmony export REMOVE_ERROR */
/* unused harmony export CLEAR_ALL_ERRORS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAIL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAIL_ERROR_NOT; });
/* unused harmony export raiseError */
/* unused harmony export removeError */
/* unused harmony export clearAllErrors */
/* harmony export (immutable) */ __webpack_exports__["c"] = raiseMailError;
/* harmony export (immutable) */ __webpack_exports__["d"] = unraiseMailErrors;
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\error.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var ADD_ERROR='ADD_ERROR_';var REMOVE_ERROR='REMOVE_ERROR_';var CLEAR_ALL_ERRORS='CLEAR_ALL_ERRORS_';var MAIL_ERROR='MAIL_ERROR';var MAIL_ERROR_NOT='MAIL_ERROR_NOT';function raiseError(uiid,code){var args=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];return{type:ADD_ERROR,ui:uiid,code:code,args:args};}function removeError(uiid,code){return{type:REMOVE_ERROR,ui:uiid,code:code};}function clearAllErrors(){return{type:CLEAR_ALL_ERRORS};}function raiseMailError(){return{type:MAIL_ERROR};}function unraiseMailErrors(){return{type:MAIL_ERROR_NOT};}

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return F_UI_CREATE; });
/* unused harmony export F_UI_CHECK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return F_UI_SET_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return F_UI_IS_MULTIPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return F_UI_COPY_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return F_UI_RADIO_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REMOVE_DUPLICATE; });
/* unused harmony export createFUI */
/* unused harmony export checkUI */
/* unused harmony export setActive */
/* unused harmony export setMultiple */
/* unused harmony export setCopy */
/* unused harmony export checkUIExists */
/* unused harmony export checkUIExistsThunk */
/* unused harmony export checkRadio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeFlatDuplicate; });
/*
 * Project: LegalPlace assistant
 * File: src/redux/actions/flat_ui.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// the UI contains { uiid, id, section_id, parant_id, active, multiple, copy_nbr }
var F_UI_CREATE='CREATE_FLAT_UI_';// creates new index in the flat UI table
var F_UI_CHECK='CHECK_F_UI_';// check the existance of UI in the flat table
var F_UI_SET_ACTIVE='SET_ACTIVE_F_UI_';// set the entry as active
var F_UI_IS_MULTIPLE='IS_MULTIPLE_F_UI_';// check if theentry is multiple
var F_UI_COPY_NUMBER='COPY_NUMBER_F_UI_';// get if it's a copy number or not
// ================================================================================
var F_UI_RADIO_ACTIVE='RADIO_ACTIVE_F_UI_';// ===============================================================================
var REMOVE_DUPLICATE='REMOVE_DUPLICATE';function createFUI(uiid,id,genre,sectionId,parentId){var ui_parent=arguments.length>5&&arguments[5]!==undefined?arguments[5]:'';return{type:F_UI_CREATE,uiid:uiid,ui_parent:ui_parent,id:id,genre:genre,sectionId:sectionId,parentId:parentId};}function checkUI(uiid,id){return{type:F_UI_CHECK,uiid:uiid,id:id};}function checkRadio(uiid,check){return{type:F_UI_RADIO_ACTIVE,uiid:uiid,check:check};}function setActive(id,active){return{type:F_UI_SET_ACTIVE,id:id,active:active};}function setMultiple(id,genre,multiple){return{type:F_UI_IS_MULTIPLE,id:id,genre:genre,multiple:multiple};}function setCopy(id,genre,copy){return{F_UI_COPY_NUMBER:F_UI_COPY_NUMBER,id:id,genre:genre,copy:copy};}function checkUIExists(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var id=arguments[1];var genre=arguments[2];var uiInfo=[];state.forEach(function(idx){if(idx.id===id&&idx.genre===genre)uiInfo.push(idx);});return uiInfo;}function checkUIExistsThunk(id,genre){return function(dispatch,getState){var uiInfo=[];getState().flat.forEach(function(idx){if(idx.id===id&&idx.genre===genre)uiInfo.push(idx);});return uiInfo;};}function removeFlatDuplicate(dupIdx){return{type:REMOVE_DUPLICATE,id:dupIdx};}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toDate = __webpack_require__(263);

var _toDate2 = _interopRequireDefault(_toDate);

var _toFloat = __webpack_require__(437);

var _toFloat2 = _interopRequireDefault(_toFloat);

var _toInt = __webpack_require__(1021);

var _toInt2 = _interopRequireDefault(_toInt);

var _toBoolean = __webpack_require__(1022);

var _toBoolean2 = _interopRequireDefault(_toBoolean);

var _equals = __webpack_require__(1023);

var _equals2 = _interopRequireDefault(_equals);

var _contains = __webpack_require__(1024);

var _contains2 = _interopRequireDefault(_contains);

var _matches = __webpack_require__(1025);

var _matches2 = _interopRequireDefault(_matches);

var _isEmail = __webpack_require__(1026);

var _isEmail2 = _interopRequireDefault(_isEmail);

var _isURL = __webpack_require__(1027);

var _isURL2 = _interopRequireDefault(_isURL);

var _isMACAddress = __webpack_require__(1028);

var _isMACAddress2 = _interopRequireDefault(_isMACAddress);

var _isIP = __webpack_require__(439);

var _isIP2 = _interopRequireDefault(_isIP);

var _isFQDN = __webpack_require__(265);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

var _isBoolean = __webpack_require__(1029);

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isAlpha = __webpack_require__(1030);

var _isAlpha2 = _interopRequireDefault(_isAlpha);

var _isAlphanumeric = __webpack_require__(1031);

var _isAlphanumeric2 = _interopRequireDefault(_isAlphanumeric);

var _isNumeric = __webpack_require__(1032);

var _isNumeric2 = _interopRequireDefault(_isNumeric);

var _isPort = __webpack_require__(1033);

var _isPort2 = _interopRequireDefault(_isPort);

var _isLowercase = __webpack_require__(1034);

var _isLowercase2 = _interopRequireDefault(_isLowercase);

var _isUppercase = __webpack_require__(1035);

var _isUppercase2 = _interopRequireDefault(_isUppercase);

var _isAscii = __webpack_require__(1036);

var _isAscii2 = _interopRequireDefault(_isAscii);

var _isFullWidth = __webpack_require__(441);

var _isFullWidth2 = _interopRequireDefault(_isFullWidth);

var _isHalfWidth = __webpack_require__(442);

var _isHalfWidth2 = _interopRequireDefault(_isHalfWidth);

var _isVariableWidth = __webpack_require__(1037);

var _isVariableWidth2 = _interopRequireDefault(_isVariableWidth);

var _isMultibyte = __webpack_require__(1038);

var _isMultibyte2 = _interopRequireDefault(_isMultibyte);

var _isSurrogatePair = __webpack_require__(1039);

var _isSurrogatePair2 = _interopRequireDefault(_isSurrogatePair);

var _isInt = __webpack_require__(440);

var _isInt2 = _interopRequireDefault(_isInt);

var _isFloat = __webpack_require__(1040);

var _isFloat2 = _interopRequireDefault(_isFloat);

var _isDecimal = __webpack_require__(1041);

var _isDecimal2 = _interopRequireDefault(_isDecimal);

var _isHexadecimal = __webpack_require__(443);

var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);

var _isDivisibleBy = __webpack_require__(1042);

var _isDivisibleBy2 = _interopRequireDefault(_isDivisibleBy);

var _isHexColor = __webpack_require__(1043);

var _isHexColor2 = _interopRequireDefault(_isHexColor);

var _isISRC = __webpack_require__(1044);

var _isISRC2 = _interopRequireDefault(_isISRC);

var _isMD = __webpack_require__(1045);

var _isMD2 = _interopRequireDefault(_isMD);

var _isHash = __webpack_require__(1046);

var _isHash2 = _interopRequireDefault(_isHash);

var _isJSON = __webpack_require__(1047);

var _isJSON2 = _interopRequireDefault(_isJSON);

var _isEmpty = __webpack_require__(1048);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isLength = __webpack_require__(1049);

var _isLength2 = _interopRequireDefault(_isLength);

var _isByteLength = __webpack_require__(438);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isUUID = __webpack_require__(1050);

var _isUUID2 = _interopRequireDefault(_isUUID);

var _isMongoId = __webpack_require__(1051);

var _isMongoId2 = _interopRequireDefault(_isMongoId);

var _isAfter = __webpack_require__(1052);

var _isAfter2 = _interopRequireDefault(_isAfter);

var _isBefore = __webpack_require__(1053);

var _isBefore2 = _interopRequireDefault(_isBefore);

var _isIn = __webpack_require__(1054);

var _isIn2 = _interopRequireDefault(_isIn);

var _isCreditCard = __webpack_require__(1055);

var _isCreditCard2 = _interopRequireDefault(_isCreditCard);

var _isISIN = __webpack_require__(1056);

var _isISIN2 = _interopRequireDefault(_isISIN);

var _isISBN = __webpack_require__(1057);

var _isISBN2 = _interopRequireDefault(_isISBN);

var _isISSN = __webpack_require__(1058);

var _isISSN2 = _interopRequireDefault(_isISSN);

var _isMobilePhone = __webpack_require__(1059);

var _isMobilePhone2 = _interopRequireDefault(_isMobilePhone);

var _isCurrency = __webpack_require__(1060);

var _isCurrency2 = _interopRequireDefault(_isCurrency);

var _isISO = __webpack_require__(1061);

var _isISO2 = _interopRequireDefault(_isISO);

var _isISO31661Alpha = __webpack_require__(1062);

var _isISO31661Alpha2 = _interopRequireDefault(_isISO31661Alpha);

var _isBase = __webpack_require__(1063);

var _isBase2 = _interopRequireDefault(_isBase);

var _isDataURI = __webpack_require__(1064);

var _isDataURI2 = _interopRequireDefault(_isDataURI);

var _isMimeType = __webpack_require__(1065);

var _isMimeType2 = _interopRequireDefault(_isMimeType);

var _isLatLong = __webpack_require__(1066);

var _isLatLong2 = _interopRequireDefault(_isLatLong);

var _isPostalCode = __webpack_require__(1067);

var _isPostalCode2 = _interopRequireDefault(_isPostalCode);

var _ltrim = __webpack_require__(444);

var _ltrim2 = _interopRequireDefault(_ltrim);

var _rtrim = __webpack_require__(445);

var _rtrim2 = _interopRequireDefault(_rtrim);

var _trim = __webpack_require__(1068);

var _trim2 = _interopRequireDefault(_trim);

var _escape = __webpack_require__(1069);

var _escape2 = _interopRequireDefault(_escape);

var _unescape = __webpack_require__(1070);

var _unescape2 = _interopRequireDefault(_unescape);

var _stripLow = __webpack_require__(1071);

var _stripLow2 = _interopRequireDefault(_stripLow);

var _whitelist = __webpack_require__(1072);

var _whitelist2 = _interopRequireDefault(_whitelist);

var _blacklist = __webpack_require__(446);

var _blacklist2 = _interopRequireDefault(_blacklist);

var _isWhitelisted = __webpack_require__(1073);

var _isWhitelisted2 = _interopRequireDefault(_isWhitelisted);

var _normalizeEmail = __webpack_require__(1074);

var _normalizeEmail2 = _interopRequireDefault(_normalizeEmail);

var _toString = __webpack_require__(264);

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = '9.4.1';

var validator = {
  version: version,
  toDate: _toDate2.default,
  toFloat: _toFloat2.default,
  toInt: _toInt2.default,
  toBoolean: _toBoolean2.default,
  equals: _equals2.default,
  contains: _contains2.default,
  matches: _matches2.default,
  isEmail: _isEmail2.default,
  isURL: _isURL2.default,
  isMACAddress: _isMACAddress2.default,
  isIP: _isIP2.default,
  isFQDN: _isFQDN2.default,
  isBoolean: _isBoolean2.default,
  isAlpha: _isAlpha2.default,
  isAlphanumeric: _isAlphanumeric2.default,
  isNumeric: _isNumeric2.default,
  isPort: _isPort2.default,
  isLowercase: _isLowercase2.default,
  isUppercase: _isUppercase2.default,
  isAscii: _isAscii2.default,
  isFullWidth: _isFullWidth2.default,
  isHalfWidth: _isHalfWidth2.default,
  isVariableWidth: _isVariableWidth2.default,
  isMultibyte: _isMultibyte2.default,
  isSurrogatePair: _isSurrogatePair2.default,
  isInt: _isInt2.default,
  isFloat: _isFloat2.default,
  isDecimal: _isDecimal2.default,
  isHexadecimal: _isHexadecimal2.default,
  isDivisibleBy: _isDivisibleBy2.default,
  isHexColor: _isHexColor2.default,
  isISRC: _isISRC2.default,
  isMD5: _isMD2.default,
  isHash: _isHash2.default,
  isJSON: _isJSON2.default,
  isEmpty: _isEmpty2.default,
  isLength: _isLength2.default,
  isByteLength: _isByteLength2.default,
  isUUID: _isUUID2.default,
  isMongoId: _isMongoId2.default,
  isAfter: _isAfter2.default,
  isBefore: _isBefore2.default,
  isIn: _isIn2.default,
  isCreditCard: _isCreditCard2.default,
  isISIN: _isISIN2.default,
  isISBN: _isISBN2.default,
  isISSN: _isISSN2.default,
  isMobilePhone: _isMobilePhone2.default,
  isPostalCode: _isPostalCode2.default,
  isCurrency: _isCurrency2.default,
  isISO8601: _isISO2.default,
  isISO31661Alpha2: _isISO31661Alpha2.default,
  isBase64: _isBase2.default,
  isDataURI: _isDataURI2.default,
  isMimeType: _isMimeType2.default,
  isLatLong: _isLatLong2.default,
  ltrim: _ltrim2.default,
  rtrim: _rtrim2.default,
  trim: _trim2.default,
  escape: _escape2.default,
  unescape: _unescape2.default,
  stripLow: _stripLow2.default,
  whitelist: _whitelist2.default,
  blacklist: _blacklist2.default,
  isWhitelisted: _isWhitelisted2.default,
  normalizeEmail: _normalizeEmail2.default,
  toString: _toString2.default
};

exports.default = validator;
module.exports = exports['default'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toFloat;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toFloat(str) {
  (0, _assertString2.default)(str);
  return parseFloat(str);
}
module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  (0, _assertString2.default)(str);
  version = String(version);
  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }
    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::

    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.
    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    }
    // initial or final ::
    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }
        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
        // it has been checked before that the last
        // block is a valid IPv4 address
      } else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }
    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }
    return blocks.length === expectedNumberOfBlocks;
  }
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isInt;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var intLeadingZeroes = /^[-+]?[0-9]+$/;

function isInt(str, options) {
  (0, _assertString2.default)(str);
  options = options || {};

  // Get the regex to use for testing, based on whether
  // leading zeroes are allowed or not.
  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes;

  // Check min/max/lt/gt
  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;

  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}
module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fullWidth = undefined;
exports.default = isFullWidth;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fullWidth = exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;

function isFullWidth(str) {
  (0, _assertString2.default)(str);
  return fullWidth.test(str);
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.halfWidth = undefined;
exports.default = isHalfWidth;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var halfWidth = exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;

function isHalfWidth(str) {
  (0, _assertString2.default)(str);
  return halfWidth.test(str);
}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHexadecimal;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexadecimal = /^[0-9A-F]+$/i;

function isHexadecimal(str) {
  (0, _assertString2.default)(str);
  return hexadecimal.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ltrim;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ltrim(str, chars) {
  (0, _assertString2.default)(str);
  var pattern = chars ? new RegExp('^[' + chars + ']+', 'g') : /^\s+/g;
  return str.replace(pattern, '');
}
module.exports = exports['default'];

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rtrim;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rtrim(str, chars) {
  (0, _assertString2.default)(str);
  var pattern = chars ? new RegExp('[' + chars + ']') : /\s/;

  var idx = str.length - 1;
  while (idx >= 0 && pattern.test(str[idx])) {
    idx--;
  }

  return idx < str.length ? str.substr(0, idx + 1) : str;
}
module.exports = exports['default'];

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blacklist;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function blacklist(str, chars) {
  (0, _assertString2.default)(str);
  return str.replace(new RegExp('[' + chars + ']+', 'g'), '');
}
module.exports = exports['default'];

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__condition_evo__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_account_settings__ = __webpack_require__(23);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * LegalPlace's default values setter
 */var _DefaultValues=function(){function _DefaultValues(){_classCallCheck(this,_DefaultValues);}_createClass(_DefaultValues,[{key:'setDefaults',value:function setDefaults(){var _this=this;var excludeCurrent=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;// Getting sections to be treated
var currentSection=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].store.getState().contract.currentSection;if(excludeCurrent)currentSection-=1;// Reading through sections
for(var i=0;i<=currentSection;i+=1){var sectionId=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].store.getState().contract.sections[i].id;var section=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.getSection(sectionId-1);// Setting section's defaults
section.options.map(function(id){return _this.setOptionDefault(id);});}}},{key:'setOptionDefault',value:function setOptionDefault(id){var _this2=this;var copy=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var ref=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.getOption(id);var eligibleId=copy===false?id:id+'_'+copy;// Making sure reference is a valid option with a valid meta
if((typeof ref==='undefined'?'undefined':_typeof(ref))!=='object'||_typeof(ref.meta)!=='object')return;// If type isn't a static/radio/checkbox we stop here
if(!['static','radio','checkbox'].includes(ref.meta.type))return;// Making sure option is true if it's conditional
if(ref.meta.conditional&&__WEBPACK_IMPORTED_MODULE_2__condition_evo__["a" /* default */].getCondition(eligibleId)!==true)return;// Getting radio children
var eligibleChildren=[];ref.children.map(function(id){var childRef=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.getOption(id);// Making sure reference is a valid option with a valid meta
if((typeof childRef==='undefined'?'undefined':_typeof(childRef))!=='object'||_typeof(childRef.meta)!=='object')return id;// If type isn't a radio we stop here
if(childRef.meta.type!=='radio')return id;var eligibleId=copy===false?id:id+'_'+copy;eligibleChildren.push(eligibleId);return id;});// Getting option's default & current value
var defaultValue=parseInt(ref.meta.default,10)?ref.meta.default:0;var currentValue=null;eligibleChildren.map(function(id){if(__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].indexes.options.getOption(id).value===true)currentValue=id;return id;});// If default value isn't set we asume the first option is the default
// value in case the auto default is enabled
if((defaultValue==="0"||defaultValue===0)&&!__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].store.getState().contract.disable_auto_default&&eligibleChildren.length>0){defaultValue=eligibleChildren[0];}// Setting default value if it's superior to 0 and current value is null
if(Object(__WEBPACK_IMPORTED_MODULE_0_util__["isNull"])(currentValue)&&defaultValue>0){eligibleChildren.map(function(id){__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].indexes.updateOption({id:id,value:Object(__WEBPACK_IMPORTED_MODULE_4__global_getter__["d" /* lpIdGetPure */])(id)===defaultValue});return id;});__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["j" /* checkRadio1 */])(defaultValue+(copy?'_'+copy:''),eligibleId));__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_account_settings__["o" /* editedDocument */])(true));currentValue=copy?defaultValue+'_'+copy:defaultValue;}// Checking children
ref.children.map(function(cId){var cRef=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].references.getOption(cId);var contractId=copy===false?cId:cId+'_'+copy;// If type isn't a static/radio/checkbox we stop here
if(!['static','radio','checkbox'].includes(cRef.meta.type))return cId;// If it's a radio and it's not checked we stop here
if(cRef.meta.type==='radio'&&contractId!==currentValue)return cId;// If it's a checkbox and it's not checked we stop here
if(cRef.meta.type==='checkbox'&&__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].indexes.options.getOption(contractId).value!==true)return cId;// Making sure option is true if it's conditional
if(cRef.meta.conditional&&__WEBPACK_IMPORTED_MODULE_2__condition_evo__["a" /* default */].getCondition(contractId)!==true)return cId;// Checking for defaults
_this2.setOptionDefault(cId,copy);return cId;});// If option is multiple & has other indexes, we fire them
if(ref.meta.multiple===true&&__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(id)&&copy===false){__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(id).map(function(multiple){_this2.setOptionDefault(id,multiple);return multiple;});}}}]);return _DefaultValues;}();var DefaultValues=new _DefaultValues();/* harmony default export */ __webpack_exports__["a"] = (DefaultValues);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__option_container__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variable_container__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc_static__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__misc_radio__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__misc_hidden__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__misc_text__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__misc_checkbox__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__misc_list__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__misc_textarea__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__misc_warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__misc_date__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__misc_pure__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_siblings__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__redux_actions_flat_ui__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_radio_show__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__logic_preview_render_condition_manager__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__logic_utils_tree_operations__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__misc_radio_group__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__logic_condition_evo__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src\components\option.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// The bigass component
// init the react env
// to detect the type
// import components (global components like containers, variables)
// import utils to generate keys
// import atomic  omponents
// TODO: can be removed
// import { List } from 'immutable';
// used when we want to get the radio group (in modification case)
// the condition phase
// importing the condition runtime
// push Elist
// this let us detect disabled conditions already
// detecting the first child
function doesMyFatherARadio(id_){if(typeof id_==='undefined'){return false;}var id=void 0;if(id_&&id_.length){;var _id_=_slicedToArray(id_,1);id=_id_[0];}else id=id_;if(__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(id).meta.type==='checkbox'&&typeof __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.grandpa.getFather(id)==='undefined')return false;var idx=__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.grandpa.getFather(id);while(typeof idx!=='undefined'){if(__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(idx).meta.type==='radio'||__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(idx).meta.type==='checkbox'){return true;}idx=__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.grandpa.getFather(idx);}return false;}// styles of show/hide
var showStyle={display:'block'};var hideStyle={display:'none'};// enters the type, the label, (the name if it's a radio), the id,
var _Option=function(_Component){_inherits(_Option,_Component);// this is the
function _Option(props){_classCallCheck(this,_Option);var _this=_possibleConstructorReturn(this,(_Option.__proto__||Object.getPrototypeOf(_Option)).call(this,props));_this.multiples=[];// Setting up ConditionsEvo's multiple watchers
__WEBPACK_IMPORTED_MODULE_28__logic_condition_evo__["a" /* default */].setupMultipleWatchers(_this.multiples,props.id);// console.log(props.id)
_this.params=Object.assign({parent:-1,type:__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].NONE,label:'',id:'',// we generate here an ID to affect it to the output <------
awlad:[],variables:[],is_checked:false,parentId:-1,// <------
is_multiple:false,isDuplicate:false,copy:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(2)},_this.props);// case if we are duplicate
// initialize the ID and KEY for the duplicate option
if(_this.props.isDuplicate){_this.params.id=_this.params.id+'_'+_this.props.copy;_this.params.lpKey=Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(4);}// test existance using id, parent
_this.state={edit:false,show_edit:false};// add to multiple global
if(props.is_multiple&&__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.multiples){// get all the children
// name of the memeory thing
if(__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.exists(props.id)&&__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(props.id).length){_this.multiples=__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(props.id);__WEBPACK_IMPORTED_MODULE_28__logic_condition_evo__["a" /* default */].setupMultipleWatchers(_this.multiples,props.id);}}// setup this for callbacks
_this.modificationButtonCallback=_this.modificationButtonCallback.bind(_this);_this.addMultiple=_this.addMultiple.bind(_this);_this.updateShowingState=_this.updateShowingState.bind(_this);_this.removeMultiple=_this.removeMultiple.bind(_this);_this.multiples_len=0;return _this;}_createClass(_Option,[{key:'componentWillMount',value:function componentWillMount(){// update the key, if it exists
if(this.props.exists){this.params.lpKey=this.props.existant_key;}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){var a=Object(__WEBPACK_IMPORTED_MODULE_18__utils_siblings__["b" /* getSiblingsFamily */])(nextProps.lpKey);if(a!==null)nextState.edit=a.edit_mode;// eslint-disable-line
}// add multiple clicked
},{key:'addMultiple',value:function addMultiple(){console.log(this.multiples);// add a copy:
// generate a copy code
this.multiples.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(3));// update number length of duplicates of this option
this.multiples_len+=1;// add it to the real global context
__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.addMultiple(this.props.id,this.multiples);// force update the compoentn
Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["j" /* lpUpdateMultiple */])(this.props.id,this.multiples);__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].action_tracker.trackAction('ADD_MULTIPLE',this.props.id);Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["n" /* updateConditions */])();this.forceUpdate();}},{key:'removeMultiple',value:function removeMultiple(id){// test if it exists
var cIdx=void 0;var cIdxPos=void 0;// existance of the removed option
this.multiples.forEach(function(idx,i){if(idx===id){cIdx=id;cIdxPos=i;// we can delete the ID from the array
}});if(!cIdx)return;// The multiple exists
// remove all flats of the duplicate
this.props.removeFlatUI(id);// remove all options and variables of the duplicate
this.props.removeOptions(id);this.props.removeVariables(id);// remove the thing from this array
this.multiples.splice(cIdxPos,1);// decrease the len
this.multiples_len-=1;Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["j" /* lpUpdateMultiple */])(this.props.id,this.multiples);__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.options.delOption(this.props.id+'_'+id);if(this.multiples_len===0)__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.addMultiple(this.props.id,undefined);else __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.addMultiple(this.props.id,this.multiples);Object(__WEBPACK_IMPORTED_MODULE_21__utils_radio_show__["c" /* rsRemove */])(this.props.id);__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].action_tracker.trackAction('ADD_MULTIPLE',this.props.id);Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["n" /* updateConditions */])();this.forceUpdate();}},{key:'removeFirst',value:function removeFirst(){// update multiples
this.props.removeFirst(this.multiples[0]);var oldMultiples=[].concat(_toConsumableArray(this.multiples));this.multiples=this.multiples.slice(1,this.multiples.length);this.multiples_len=this.multiples.length;for(var i=0;i<oldMultiples.length;i+=1){if(this.multiples.indexOf(oldMultiples[i])===-1)__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.options.delOption(this.props.id+'_'+oldMultiples[i]);}Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["j" /* lpUpdateMultiple */])(this.props.id,this.multiples);if(this.multiples_len===0)__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.addMultiple(this.props.id,undefined);else __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.addMultiple(this.props.id,this.multiples);Object(__WEBPACK_IMPORTED_MODULE_21__utils_radio_show__["c" /* rsRemove */])(this.props.id);Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["n" /* updateConditions */])();this.forceUpdate();}},{key:'modificationButtonCallback',value:function modificationButtonCallback(){this.setState({edit:true});// this line may be deleted
// the check here if it's a radio or any shit
if(this.props.is_multiple){// can be deleted
}this.setState({show_edit:!this.show_edit});// if(this.props.isDuplicate){
Object(__WEBPACK_IMPORTED_MODULE_18__utils_siblings__["a" /* endEditionMode */])(this.props.exists?this.props.existant_key:this.props.lpKey,true);// }
// endEditionMode(this.props.exists? this.props.existant_key : this.props.lpKey, true);
// return;
}},{key:'updateShowingState',value:function updateShowingState(){var h_s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;this.setState({show_edit:h_s});}},{key:'render',value:function render(){var _this2=this;var result=void 0;var falseSiblings=true;if(this.props.isDuplicate){falseSiblings=Object(__WEBPACK_IMPORTED_MODULE_25__logic_utils_tree_operations__["b" /* checkUnInitializedSiblings */])(this.props.id,this.props.copy);}else falseSiblings=Object(__WEBPACK_IMPORTED_MODULE_25__logic_utils_tree_operations__["b" /* checkUnInitializedSiblings */])(this.props.id);// render atomic component
// test of possibility
switch(this.params.type){case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].HIDDEN:case'hidden':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__misc_hidden__["a" /* default */],{id:this.props.id,parent:this.props.parent,value:this.props.label,ovc:'o',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(2),sectionId:this.props.sectionId});break;case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].STATIC:case'static':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.checked&&'wzog-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__misc_static__["a" /* default */],{parent:this.props.parent,id:this.props.id,label:this.props.label,ovc:'o',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(2),cond_:this.props.is_conditional?this.end:true}));break;case'RADIOS':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__misc_radio_group__["a" /* default */],{parent:this.props.parent,id:this.props.id,isDuplicate:this.props.isDuplicate,copy:this.props.copy}));// this is a special case
break;case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].RADIO:case'radio':// IMPORTANT: midfication button create a new copy name, and pass it
// edit this
result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!this.state.show_edit/** render single radio, as title */&&(this.props.checked||this.props.show_m||falseSiblings)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},'/** the component is checked and ready to put the modification button */',this.props.checked&&!this.props.show_m&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wzog-edit-btn-1 icn-pen',onClick:this.modificationButtonCallback,style:{display:'block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Modifier')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.props.checked&&!this.props.show_m&&this.modificationButtonCallback},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__misc_radio__["a" /* default */],{id:this.props.id,parent:this.props.parent,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(1),group:this.props.parent,label:this.props.label,ovc:'o',is_checked:this.props.checked,isDuplicate:this.props.isDuplicate,is_multiple:this.props.is_multiple,copy:this.props.copy}))));// this is a special case
break;// TODO: The same thing as RADIO buttons
case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].CHECKBOX:case'checkbox':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.checked&&(!__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.helper||__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.helper.length===0)&&'wzog-options',key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(2)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__misc_checkbox__["a" /* default */],{lpKey:this.props.lpKey,lpParent:this.props.lpParent,id:this.props.id,parent:this.props.parent,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(1),label:this.props.label,is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,ovc:'o'}));break;case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].TEXT:case'text':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__misc_text__["a" /* default */],{id:this.props.id,parent:this.props.parent,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(1),label:this.props.label,ovc:'o',isDuplicate:this.props.isDuplicate,is_multiple:this.props.is_multiple,copy:this.props.copy});break;case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].LIST:case'list':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__misc_list__["a" /* default */],{key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(4),id:this.props.id,label:this.props.label,ovc:'o',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy});break;case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].TEXTAREA:case'texarea':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__misc_textarea__["a" /* default */],{key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(4),id:this.props.id,label:this.props.label,ovc:'o',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy});break;case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].DATE:case'date':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__misc_date__["a" /* default */],{parent:this.props.parent,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(4),id:this.props.id,label:this.props.label,ovc:'o',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy});break;case __WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].PURE:case'brut-text':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__misc_pure__["a" /* default */],{id:this.props.id,content:__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.content,isDuplicate:this.props.isDuplicate,copy:this.props.copy});break;default:result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.my_key});break;}// Setting the Multiple labels in case of a multiple
var currentMultipleLabel='';var multipleAddLabel='';var multipleIncrtStep=1;if(this.props.is_multiple){var multipleOptionMeta=__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta;// Adding CTA Label
multipleAddLabel=multipleOptionMeta.multipletext.toLowerCase().indexOf('ajouter')===-1&&multipleOptionMeta.multipletext.toLowerCase().indexOf('hinzufügen')===-1?Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Ajouter un '):'';multipleAddLabel+=multipleOptionMeta.multipletext;// Current Multiple label
currentMultipleLabel=multipleOptionMeta.multipletext;if(multipleOptionMeta.multipleIncrtText&&typeof multipleOptionMeta.multipleIncrtText==='string'&&multipleOptionMeta.multipleIncrtText.trim().length>0){currentMultipleLabel=multipleOptionMeta.multipleIncrtText;}// Incrementation step
if(multipleOptionMeta.multipleIncrt&&!Number.isNaN(parseInt(multipleOptionMeta.multipleIncrt,10))){multipleIncrtStep=parseInt(multipleOptionMeta.multipleIncrt,10);}}var divStyle=Object.assign({},this.params.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].REPEATED||this.props.is_conditional&&!this.props.cond_end?hideStyle:showStyle);divStyle=Object.assign(divStyle,this.props.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].STATIC?{marginBottom:'50px'}:{});var radioButWeCanShowIt=this.props.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].RADIO&&this.props.show_m&&!this.props.checked;var act=this.props.selectedOption!==-1// this is when the thing is radio
&&!Object(__WEBPACK_IMPORTED_MODULE_25__logic_utils_tree_operations__["d" /* hasEmptyChildren */])(Object(__WEBPACK_IMPORTED_MODULE_24__logic_global_getter__["d" /* lpIdGetPure */])(this.props.selectedOption))||// &&
(this.props.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].CHECKBOX||this.props.type==='checkbox')&&this.props.checked&&!Object(__WEBPACK_IMPORTED_MODULE_25__logic_utils_tree_operations__["d" /* hasEmptyChildren */])(Object(__WEBPACK_IMPORTED_MODULE_24__logic_global_getter__["d" /* lpIdGetPure */])(this.props.id));var optionStyle=__WEBPACK_IMPORTED_MODULE_2_classnames__({'wzog-wrapper':true,'wzog-editable':this.props.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].RADIO,first:!doesMyFatherARadio(Object(__WEBPACK_IMPORTED_MODULE_24__logic_global_getter__["d" /* lpIdGetPure */])(this.props.id)),active:act,'ml-15':this.props.push_left,'highlight-second':!__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].ops.two_steps.isDiscovered(this.props.id,'option')});var optionResult=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);// Here we test the options
var mL=0;if(__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(this.props.id)){mL=__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.multiples.getMultiple(this.props.id).length;}if(!__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].ops.two_steps.checkOption(this.props.id.length?-1:this.props.id)){optionResult=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:optionStyle,'data-type':'option','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy,style:divStyle,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(4)},this.props.copy===-2&&mL>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){return _this2.removeFirst();},className:'oh-delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Supprimer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'oh-text'},this.props.id&&'multipletext'in __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta&&currentMultipleLabel+' '+multipleIncrtStep)),(radioButWeCanShowIt||this.props.cond_show||falseSiblings||this.props.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].RADIO&&this.props.checked)&&!this.props.dont_show_me&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wzog-options'},result,' '),// Here is the shit
this.props.selectedOption!==-1&&__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption)&&'warning'in __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption).meta/** there is warning in the component */&&__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption).meta.warning.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__misc_warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption).meta.warning,id:this.props.selectedOption===-1?this.props.id:this.props.selectedOption}),__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption)&&__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption).variables.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__variable_container__["a" /* VariableContainer */],{copy:this.props.copy,isDuplicate:this.props.isDuplicate,is_multiple:this.props.is_multiple,id:this.props.selectedOption,parent:this.props.selectedOption,show:true,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(1),variables:__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption).variables.map(function(idx){return __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getVariable(idx);})}),this.props.selectedOption!==-1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__option_container__["a" /* OptionContainer */],{copy:this.props.copy,isDuplicate:this.props.isDuplicate,is_multiple:this.props.is_multiple,parent:this.props.selectedOption,id:this.props.selectedOption,key:'opt_'+this.props.key,variables:__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption).variables.map(function(idx){return __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getVariable(idx);}),children:__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.selectedOption).children.map(function(idx){return __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(idx).meta;}),aroba:true}),this.props.type!==__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].HIDDEN&&(this.props.checked||this.props.type!==__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].RADIO&&this.props.type!==__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].CHECKBOX)&&/** the option is checkked, so we show every single child */__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id)&&'warning'in __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta/** there is warning in the component */&&__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.warning.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__misc_warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.warning,id:this.props.id}),__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id)&&__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(this.props.id).variables.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__variable_container__["a" /* VariableContainer */],{copy:this.props.copy,isDuplicate:this.props.isDuplicate,is_multiple:this.props.is_multiple,id:this.props.id,parent:this.props.id,show:this.props.checked,key:Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(1),variables:this.props.variables}),this.props.checked/** we have the component checked, so every single child */&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__option_container__["a" /* OptionContainer */],{copy:this.props.copy,isDuplicate:this.props.isDuplicate,is_multiple:this.props.is_multiple,parent:this.props.id,id:this.props.id,key:'opt_'+Object(__WEBPACK_IMPORTED_MODULE_7__utils_misc__["b" /* generateId1 */])(4),variables:this.props.variables,children:this.props.awlad}),'is_multiple'in this.params&&this.props.is_multiple&&!this.props.isDuplicate/** here we add the duplicates */&&this.multiples.map(function(idx,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'opt_'+_this2.props.id+'_'+idx},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'option-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){return _this2.removeMultiple(idx);},className:'oh-delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Supprimer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'oh-text'},_this2.props.id&&'multipletext'in __WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(_this2.props.id).meta&&currentMultipleLabel+' '+(multipleIncrtStep+i+1))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option,{key:idx,copy:idx,isDuplicate:true,is_multiple:false,original_id:_this2.props.id,id:_this2.props.id,parent:_this2.props.parent,type:_this2.props.type,label:_this2.props.label,variables:_this2.props.variables,awlad:_this2.props.awlad,dont_show_me:true,checked:true}));},this),this.props.checked&&'is_multiple'in this.params&&this.params.is_multiple&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.addMultiple,className:'main-link',style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-add-outline'}),multipleAddLabel));}return optionResult;}}]);return _Option;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function filterSelected(opts,vals){var result=-1;opts.forEach(function(idx,i){if(vals[i])result=idx;});return result;}// get all the siblings
var mapStateToProps=function mapStateToProps(state,ownProps){var radioState=true;if(ownProps.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].RADIO)radioState=false;var exists=false;var existsKey='';//
var showMe=true;// condition related variables
var isConditional=false;// test if the option has condition, and start new conditionn Runtime
var meIdx=-1;// treat the duplicates as special ones
if(ownProps.isDuplicate){var cId=ownProps.id+'_'+ownProps.copy;if(typeof Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["g" /* lpGetOptionById */])(cId)!=='undefined'){var opt=Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["g" /* lpGetOptionById */])(cId);radioState=opt.value;exists=true;existsKey=opt.key;meIdx=opt.index;}}else if(typeof Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["g" /* lpGetOptionById */])(ownProps.id)!=='undefined'){var _opt=Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["g" /* lpGetOptionById */])(ownProps.id);radioState=_opt.value;exists=true;existsKey=_opt.key;meIdx=_opt.index;}var showCondition=true;var optionRef=__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].references.getOption(ownProps.id);if(optionRef){if(optionRef.meta.conditional){isConditional=true;if(optionRef.meta.compiledConditions.length>0){showCondition=__WEBPACK_IMPORTED_MODULE_28__logic_condition_evo__["a" /* default */].getCondition(ownProps.copy===-2?Object(__WEBPACK_IMPORTED_MODULE_24__logic_global_getter__["d" /* lpIdGetPure */])(ownProps.id):ownProps.id+'_'+ownProps.copy);window.nbr_forced+=1;__WEBPACK_IMPORTED_MODULE_27__app_lp_app__["a" /* default */].indexes.conditions.setCondition(ownProps.copy===-2?Object(__WEBPACK_IMPORTED_MODULE_24__logic_global_getter__["d" /* lpIdGetPure */])(ownProps.id):ownProps.id+'_'+ownProps.copy,showCondition);}else{showCondition=true;}}}if(meIdx>-1){if(ownProps.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].STATIC||ownProps.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].HIDDEN){// FIXME: antipattern
// state.output.o[meIdx].value = showCondition;
}}if(isConditional&&!showCondition){Object(__WEBPACK_IMPORTED_MODULE_22__logic_preview_render_condition_manager__["b" /* pushEList */])(ownProps.id);}if(ownProps.type===__WEBPACK_IMPORTED_MODULE_3__logic_lp_map_utils__["o" /* SOptionType */].STATIC||ownProps.type==='static')radioState=true;// The RADIO case
var selectedOption=-1;if(ownProps.type==='RADIOS'){var _cId=ownProps.id;if(ownProps.isDuplicate)_cId=_cId.map(function(idx){return idx+'_'+ownProps.copy;});var vals=_cId.map(function(idx){return Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["g" /* lpGetOptionById */])(idx)?Object(__WEBPACK_IMPORTED_MODULE_23__logic_re_index__["g" /* lpGetOptionById */])(idx).value:false;});selectedOption=filterSelected(ownProps.id,vals);// console.log(selectedOption)
}return{already_exists:exists,// must be deleted
exists:exists,existant_key:existsKey,checked:radioState,// condtional showing
cond_show:showMe,// condition
is_conditional:isConditional,cond_end:showCondition,// for debug
show_m:Object(__WEBPACK_IMPORTED_MODULE_21__utils_radio_show__["a" /* rsDoICome */])(ownProps.id,ownProps.parent,ownProps.isDuplicate,ownProps.copy),sectionId:state.contract.currentSection,selectedOption:selectedOption,push_left:!Object(__WEBPACK_IMPORTED_MODULE_25__logic_utils_tree_operations__["a" /* checkIfAllFalse */])(ownProps.id.length?ownProps.id:[])};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{removeFlatUI:function removeFlatUI(idx){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__redux_actions_flat_ui__["g" /* removeFlatDuplicate */])(idx));},removeOptions:function removeOptions(idx){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__redux_actions_output__["o" /* removeDuplicateFromOption */])(idx));},removeVariables:function removeVariables(idx){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__redux_actions_output__["p" /* removeDuplicateFromVariables */])(idx));},removeFirst:function removeFirst(fC){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__redux_actions_output__["q" /* removeFirstOption */])(fC,ownProps.id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__redux_actions_output__["r" /* removeFirstVariable */])(fC,ownProps.id));}};};var Option=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_Option);// here we map a thing to the store
/* harmony default export */ __webpack_exports__["a"] = (Option);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_static__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__misc_radio__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc_hidden__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__misc_text__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__misc_list__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc_checkbox__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__misc_textarea__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__misc_eval__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__misc_number__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__misc_date__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__misc_pure__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__misc_basic_mask__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__misc_advanced_mask__ = __webpack_require__(1125);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\variable.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// variable renderer
// importing basic componentns
var flen={width:'100%'};var Variable=function(_Component){_inherits(Variable,_Component);function Variable(props){_classCallCheck(this,Variable);// get type
var _this=_possibleConstructorReturn(this,(Variable.__proto__||Object.getPrototypeOf(Variable)).call(this,props));var defaults={id:-1,parent:-1,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(3),lpKey:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),// lpParent
label:'',type:__WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].NONE,font_size:16,helper:'',is_multiple:false,isDuplicate:false,copy:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(2)};_this.params=Object.assign(defaults,props);return _this;}_createClass(Variable,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var result=void 0;// console.log(this.props)
switch(this.props.type){case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].HIDDEN:case'hidden':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__misc_hidden__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),id:this.props.id,ovc:'v',value:'',isDuplicate:this.props.isDuplicate,is_multiple:this.props.is_multiple,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].STATIC:case'static':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__misc_static__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].RADIO:case'radio':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__misc_radio__["a" /* default */],{lpKey:this.props.lpkey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),group:this.props.parent,id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].CHECKBOX:case'checkbox':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__misc_checkbox__["a" /* default */],{lpKey:this.props.lpKey?this.props.lpKey:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].TEXT:case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].HOUR:case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].EMAIL:case'text':case'hour':case'email':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__misc_text__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,autocomplete:this.props.autocomplete,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].EVAL:case'eval':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__misc_eval__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].NUMBER:case'number':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__misc_number__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].LIST:case'list':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__misc_list__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].TEXTAREA:case'textarea':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__misc_textarea__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].DATE:case'date':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__misc_date__["a" /* default */],{lpParent:this.props.lpParent,parent:this.props.parent,lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,copy:this.props.copy});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].PURE:case'brut-text':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__misc_pure__["a" /* default */],{id:this.props.id,content:__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.content,isDuplicate:this.props.isDuplicate,copy:this.props.copy});console.log('Pure');break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].BASICMASK:case'mask':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__misc_basic_mask__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,autocomplete:this.props.autocomplete,copy:this.props.copy,parent:this.props.parent});break;case __WEBPACK_IMPORTED_MODULE_1__logic_lp_map_utils__["o" /* SOptionType */].ADVANCEDMASK:case'advancedmask':result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__misc_advanced_mask__["a" /* default */],{lpKey:this.props.lpKey,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),id:this.props.id,label:this.props.label,ovc:'v',is_multiple:this.props.is_multiple,isDuplicate:this.props.isDuplicate,autocomplete:this.props.autocomplete,copy:this.props.copy,parent:this.props.parent});break;default:result=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);break;}// console.log(this.props.label + " => " + this.props.awlad);
if(__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.two_steps.checkVariable(this.props.id))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-field'+(!__WEBPACK_IMPORTED_MODULE_14__app_lp_app__["a" /* default */].ops.two_steps.isDiscovered(this.props.id,'variable')?' highlight-second':''),style:flen,'data-type':'variable-single','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy},result);}}]);return Variable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Variable);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\misc\static.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var SingleText=function(_Component){_inherits(SingleText,_Component);function SingleText(){_classCallCheck(this,SingleText);return _possibleConstructorReturn(this,(SingleText.__proto__||Object.getPrototypeOf(SingleText)).apply(this,arguments));}_createClass(SingleText,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.exists){if(this.props.isDuplicate){this.props.initializeFlat(this.props.id+'_'+this.props.copy);this.props.initializeOutput(this.props.id+'_'+this.props.copy,this.props.parentId,this.props.ovc,this.props.label);}else{this.props.initializeFlat(this.props.id);this.props.initializeOutput(this.props.id,this.props.parentId,this.props.ovc,this.props.label);}}}},{key:'render',value:function render(){// TODO: add the unique key to a big table
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["c" /* guid */])(),'data-type':'variable-container','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy},this.props.label,' ','helper'in __WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta&&__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.helper})));}}]);return SingleText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{initializeFlat:function initializeFlat(id){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(id,ownProps.lpKey,true));if(ownProps.ovc==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(id,ownProps.lpKey,true));return null;},initializeOutput:function initializeOutput(id,parent,genre){var value=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';// console.log("Init statics " + id)
if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(id,parent,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(id,parent,value));},editOption:function editOption(id,val){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["k" /* editOption */])(id,val));}};};var mapStateToProps=function mapStateToProps(state,ownProps){var exists=false;var realId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_4__logic_re_index__["g" /* lpGetOptionById */])(realId)!=='undefined'){exists=true;}}if(ownProps.ovc==='v'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_4__logic_re_index__["h" /* lpGetVariableById */])(realId)!=='undefined'){exists=true;}}return{sectionId:state.contract.currentSection,exists:exists};};var LpSingleText=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SingleText);/* harmony default export */ __webpack_exports__["a"] = (LpSingleText);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSiblingsFamily; });
/* unused harmony export siblingsObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return endEditionMode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_lp_app__ = __webpack_require__(2);
function siblingsObject(key,obj){if(!('lpSiblings'in window)){window.lpSiblings={};}if(!(key in window.lpSiblings)){window.lpSiblings[key]={edit_mode:false};}window.lpSiblings[key][obj.uiid]=Object.assign({},obj);}function getSiblingsFamily(key){if(!('lpSiblings'in window))return false;if(key in window.lpSiblings)return window.lpSiblings[key];var bs=null;Object.values(window.lpSiblings).forEach(function(idx){Object.values(idx).forEach(function(jdx){if(jdx.uiid===key){// TODO: add
var cId=typeof jdx.id==='string'?jdx.id.split('_')[0]:jdx.id;if(__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].references.getOption(cId).meta.type==='radio')bs=idx;}});});return bs;}function endEditionMode(key,val){if(!('lpSiblings'in window))return false;if(key in window.lpSiblings)return window.lpSiblings[key];Object.keys(window.lpSiblings).forEach(function(idx){var tmp=window.lpSiblings[idx];Object.values(tmp).forEach(function(jdx){if(jdx.uiid===key)window.lpSiblings[idx].edit_mode=val;});});return true;}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic_re_index__ = __webpack_require__(21);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\misc\hidden.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var SingleHidden=function(_Component){_inherits(SingleHidden,_Component);function SingleHidden(){_classCallCheck(this,SingleHidden);return _possibleConstructorReturn(this,(SingleHidden.__proto__||Object.getPrototypeOf(SingleHidden)).apply(this,arguments));}_createClass(SingleHidden,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.exists){if(this.props.isDuplicate){this.props.initializeOutput(this.props.id+'_'+this.props.copy,this.props.parentId,this.props.ovc,this.props.label);}else{this.props.initializeOutput(this.props.id,this.props.parentId,this.props.ovc,this.props.label);}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',value:this.props.label});}}]);return SingleHidden;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){var exists=false;var realId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_3__logic_re_index__["g" /* lpGetOptionById */])(realId)!=='undefined'){exists=true;}}if(ownProps.ovc==='v'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_3__logic_re_index__["h" /* lpGetVariableById */])(realId)!=='undefined'){exists=true;}}return{exists:exists};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{initializeFlat:function initializeFlat(id){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["m" /* initOutputOption */])(id,ownProps.lpKey,'NONE'));if(ownProps.ovc==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["n" /* initOutputVariable */])(id,ownProps.lpKey,'NONE'));return null;},initializeOutput:function initializeOutput(id,parent,genre){var value=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';// console.log("Init statics " + id)
if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["m" /* initOutputOption */])(id,parent,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["n" /* initOutputVariable */])(id,parent,value));}};};var LpSingleHidden=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SingleHidden);/* harmony default export */ __webpack_exports__["a"] = (LpSingleHidden);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__popup_preview__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\misc\text.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// init the react environment
// generate keys functions
// update the redux system
// onfocus and onblur
// inputs: placeholder, id, label, helper (if it exists)
var SingleTextField=function(_Component){_inherits(SingleTextField,_Component);function SingleTextField(props){_classCallCheck(this,SingleTextField);// register the variable/option
// bind the events here
var _this=_possibleConstructorReturn(this,(SingleTextField.__proto__||Object.getPrototypeOf(SingleTextField)).call(this,props));_this.params=Object.assign({},props);_this.lpKey=Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4);_this.onValueChanged=_this.onValueChanged.bind(_this);_this.onFocus=_this.onFocus.bind(_this);_this.onBlur=_this.onBlur.bind(_this);if(props.isDuplicate){_this.params.id=_this.params.id+'_'+props.copy;}return _this;}// TODO: work on dispathcing things upside down, multiple, duplicate ....
// before putting the shit into the dom
_createClass(SingleTextField,[{key:'componentWillMount',value:function componentWillMount(){// console.time("text_" + this.props.id);
// TODO: check the duplication in the fucking existant UI component
if(!this.props.exists){this.props.initializeOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.lpKey,this.props.ovc,__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.variables.getVariable(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id).value);}else{this.params.label=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(this.props.id);}// console.timeEnd("text_" + this.props.id);
}},{key:'componentDidMount',value:function componentDidMount(){// In case props value is not equal to state value
// we update it in state (must be a prefilled value)
if(this.props.value.length>0&&this.props.value!==Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id).value){this.props.editOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.value);}}},{key:'onValueChanged',value:function onValueChanged(val){this.props.editOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.params.id,val);}},{key:'onFocus',value:function onFocus(){//this.props.updateContext();
}},{key:'onBlur',value:function onBlur(){this.props.unUpdateContext;}},{key:'render',value:function render(){var _this2=this;var variable_ref=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id);// Placeholder
var placeholder=variable_ref&&variable_ref.placeholder?variable_ref.placeholder:"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group','data-type':'text-input','data-id':this.props.id,'data-is-duplicate':this.props.is_duplicate,'data-copy':this.props.copy},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'text_'+this.props.lpKey},this.props.label,' ','helper'in __WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id)&&__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper})),this.props.id in __WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.variables&&__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning,id:this.props.id,type:'v'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),placeholder:placeholder,id:'text_'+this.props.lpKey,value:this.props.value,autoComplete:this.props.autocomplete,onChange:function onChange(evt){return _this2.onValueChanged(evt.target.value);},onBlur:this.onBlur,onFocus:this.onFocus,className:'form-control'})));}}]);return SingleTextField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){// test if exists
var exists=false;var existantKey='';var existantParent='';var value='';var realId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["g" /* lpGetOptionById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["g" /* lpGetOptionById */])(realId).key;var _lpGetOptionById=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["g" /* lpGetOptionById */])(realId);value=_lpGetOptionById.value;}}if(ownProps.ovc==='v'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(realId).key;var _lpGetVariableById=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(realId);value=_lpGetVariableById.value;}}/**
   * Prefilling
   */if(__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.variables[ownProps.id].prefillings!==undefined){var prefillings=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.variables[ownProps.id].prefillings;var executePrefill=value.length===0;prefillings.forEach(function(idx){if(value===idx.text.slice())executePrefill=true;});if(prefillings.length!==0&&executePrefill){for(var _i=0;_i<prefillings.length;_i++){var idx=prefillings[_i];var text=idx.text.slice();var fillForm=false;if(idx.compiledConditions.length>0)fillForm=ConditionsEvo.rawCondition(idx.compiledConditions,ownProps.copy!=-2?ownProps.copy:false);else fillForm=true;if(fillForm){text=text.replace(/\[var:([0-9]+)\]/gi,function(a,id){var variable=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.variables.getVariable(id);var varValue=variable?variable.value.toString():'';return varValue.trim().length>0?varValue:'________________';});// Looking for old value in prefills
var foundValueInPrefills=false;for(var _i=0;_i<prefillings.length;_i++){if(value==prefillings[_i].text){foundValueInPrefills=true;}}// Making sure we do not override user input value
if(foundValueInPrefills===true||value.trim().length===0){value=text;break;}}}}}// have the parent
// if(exists){
//     if(typeof lpGetFlatById(existant_key) != 'undefined'){
//         existant_parent = lpGetFlatById(existant_key).parentUi
//     }
// }
var isShown=false;if(state.input_context.variable!==''&&state.input_context.variable===ownProps.id){isShown=true;}var hw=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.var_to_view.getViewByVar(ownProps.id);return{had_output:hw?hw.length>0:false,sectionId:state.contract.currentSection,exists:exists,existant_key:existantKey,existant_parent:existantParent,value:value,show_popup:isShown};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// this case, parent = key
initializeOutput:function initializeOutput(id,parent,genre){var value=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(id,parent,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(id,parent,value));},editOutput:function editOutput(id,val){if(ownProps.ovc==='o'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["k" /* editOption */])(id,val));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["l" /* editVariable */])(id,val));}if(!Object(__WEBPACK_IMPORTED_MODULE_9__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_account_settings__["o" /* editedDocument */])(true));},updateContext:function updateContext(){var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;var pId=ownProps.isDuplicate?ownProps.parent+'_'+ownProps.copy:ownProps.parent;if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(cId));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["d" /* icSetVariable */])(cId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(pId));}},unUpdateContext:function unUpdateContext(){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(''));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["d" /* icSetVariable */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(''));}}};};var LpText=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SingleTextField);/* harmony default export */ __webpack_exports__["a"] = (LpText);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_logging__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__popup_preview__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_input_context__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src\components\misc\list.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// importing more componentns
var ListComponent=function(_Component){_inherits(ListComponent,_Component);function ListComponent(props){_classCallCheck(this,ListComponent);var _this=_possibleConstructorReturn(this,(ListComponent.__proto__||Object.getPrototypeOf(ListComponent)).call(this,props));_this.params=Object.assign({},props);_this.lpKey=Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4);_this.selectCallback=_this.selectCallback.bind(_this);if(props.isDuplicate){_this.params.id=_this.params.id+'_'+props.copy;}return _this;}_createClass(ListComponent,[{key:'componentWillMount',value:function componentWillMount(){// console.log("cpas");
if(!this.props.exists){var id=this.props.copy===-2?this.props.id:this.props.id+'_'+this.props.copy;var _lpApp$indexes$variab=__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].indexes.variables.getVariable(id),value=_lpApp$indexes$variab.value;this.props.initializeFlat(this.props.lpKey,this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.ovc,this.props.sectionId,this.props.group);this.props.initOutputSystem(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.lpKey,this.props.ovc,value);}else{this.params.label=__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id);}// load list components, and label
if('list'in __WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id))this.listValue=__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).list;}},{key:'selectCallback',value:function selectCallback(evt){// console.log("Selected " + evt.target.value)
this.props.changeValue(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,evt.target.value);__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].action_tracker.trackAction('EDIT_VARIABLE',this.props.id);Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["n" /* updateConditions */])();this.forceUpdate();this.props.unUpdateContext();}// TODO: Add the possibility to add one single flat_key
},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group','data-type':'list','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'list_'+this.props.lpKey},this.props.label,' ','helper'in __WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id)&&__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper})),this.props.id in __WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.variables&&__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning,id:this.props.id,type:'v'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{id:'list_'+this.props.lpKey,onChange:this.selectCallback,onFocus:this.props.updateContext,onBlur:this.props.unUpdateContext,className:'form-control',value:this.props.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),this.listValue.map(function(idx){if(idx===_this2.props.value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(2),value:idx},' ',idx,' ');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(2),value:idx},idx);})));}}]);return ListComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){// the thing
var checked=false;var exists=false;var existsKey='';var existsParent='';var cId=ownProps.id;if(ownProps.isDuplicate)cId=ownProps.id+'_'+ownProps.copy;if(ownProps.ovc==='o'){var opt=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["g" /* lpGetOptionById */])(cId);if(opt){existsKey=opt.key;exists=true;checked=opt.value;}}else if(ownProps.ovc==='v'){var vars=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(cId);if(vars){existsKey=vars.key;exists=true;checked=vars.value;}}state.flat.forEach(function(idx){if(exists)if(idx.uiid===existsKey)existsParent=idx.parentUi;});Object(__WEBPACK_IMPORTED_MODULE_4__middlewares_logging__["a" /* firedFlat */])();return{// exists: checkUIExists(state.flat, ownProps.id, ownProps.genre),
sectionId:state.contract.currentSection,value:checked,exists:exists,existant_key:existsKey,existant_parent:existsParent};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{initializeFlat:function initializeFlat(uiid,id,genre,sectionId,parentId,parentUi,isDuplicate,copy){var cId=!isDuplicate?id:id+'_'+copy;if(!ownProps.exists){if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(cId,uiid,''));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(cId,uiid,''));}},initOutputSystem:function initOutputSystem(id,parent,genre,value,isDuplicate,copy){// console.log(genre);
// check duplication
var cId=!isDuplicate?id:id+'_'+copy;var cPid=!isDuplicate?parent:parent+'_'+copy;if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(cId,cPid,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(cId,cPid,value));},changeValue:function changeValue(id,value){// let cId = !isDuplicate ? id : id + '_' + copy;
// let cPid = !isDuplicate ? parent : parent + '_' + copy;
dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["l" /* editVariable */])(id,value));if(!Object(__WEBPACK_IMPORTED_MODULE_10__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["o" /* editedDocument */])(true));},updateContext:function updateContext(){var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;var pId=ownProps.isDuplicate?ownProps.parent+'_'+ownProps.copy:ownProps.parent;if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_input_context__["c" /* icSetOption */])(cId));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_input_context__["d" /* icSetVariable */])(cId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_input_context__["c" /* icSetOption */])(pId));}},unUpdateContext:function unUpdateContext(){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_input_context__["c" /* icSetOption */])(''));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_input_context__["d" /* icSetVariable */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_input_context__["c" /* icSetOption */])(''));}}};};var LpList=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ListComponent);/* harmony default export */ __webpack_exports__["a"] = (LpList);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_action_counter__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_radio_show__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\misc\checkbox.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// the communication to low level
// some componentns
// inputs are id, label, ischecked(after)
// FIXME: when we check and get back to it, we lose the value
var CheckBox=function(_Component){_inherits(CheckBox,_Component);function CheckBox(props){_classCallCheck(this,CheckBox);var _this=_possibleConstructorReturn(this,(CheckBox.__proto__||Object.getPrototypeOf(CheckBox)).call(this,props));_this.updateCheckbox=_this.updateCheckbox.bind(_this);return _this;}_createClass(CheckBox,[{key:'componentWillMount',value:function componentWillMount(){// console.log(this.props.exists);
var id=this.props.copy===-2?this.props.id:this.props.id+'_'+this.props.copy;var _lpApp$indexes$option=__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].indexes.options.getOption(id),value=_lpApp$indexes$option.value;if(!this.props.exists){this.props.initializeOutput(this.props.id,this.props.lpKey,this.props.ovc,value,this.props.isDuplicate,this.props.copy);}// this.forceUpdate();
}},{key:'updateCheckbox',value:function updateCheckbox(){if(this.props.checked)this.props.editOutput(false);else this.props.editOutput(true);var cId=this.props.id;if(this.props.isDuplicate){cId=cId+'_'+this.props.copy;}Object(__WEBPACK_IMPORTED_MODULE_5__logic_action_counter__["c" /* raiseOption */])(cId);Object(__WEBPACK_IMPORTED_MODULE_6__utils_radio_show__["b" /* rsRegisterAction */])(this.props.id,this.props.parent,this.props.isDuplicate,this.props.copy);// this.forceUpdate();
}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-type':'checkbox','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy,className:'form-group wzog-option',key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:this.props.lpKey,onClick:function onClick(){return _this2.updateCheckbox();},checked:this.props.checked,className:'',onChange:function onChange(){}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.props.lpKey},this.props.label,'helper'in __WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta&&__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.helper})));}}]);return CheckBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){var checked=false;var exists=false;var uiid='';// preparing the ids
var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){var opt=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["g" /* lpGetOptionById */])(cId);if(typeof opt!=='undefined'){checked=opt.value;exists=true;uiid=opt.key;}}else{var _opt=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(cId);if(typeof _opt!=='undefined'){checked=_opt.value;exists=true;uiid=_opt.key;}}return{// TODO: optimize the call of checkUIExists
exists:exists,checked:checked,// exists ? checked : default_continue_value,
uiid:uiid,sectionId:state.contract.currentSection};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// this case, parent = key
initializeOutput:function initializeOutput(id,parent,genre,value,isDuplicate,copy){var cId=!isDuplicate?id:id+'_'+copy;// let c_pid = !isDuplicate ? parent : parent + '_' + copy;
// console.log(genre)
if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(cId,parent,value));else dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(cId,parent,value));},editOutput:function editOutput(val){var cId=!ownProps.isDuplicate?ownProps.id:ownProps.id+'_'+ownProps.copy;if(ownProps.ovc==='o'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["k" /* editOption */])(cId,val));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["l" /* editVariable */])(cId,val));}if(!Object(__WEBPACK_IMPORTED_MODULE_9__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_account_settings__["o" /* editedDocument */])(true));}};};var LpCheckBox=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CheckBox);/* harmony default export */ __webpack_exports__["a"] = (LpCheckBox);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popup_preview__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logic_condition_evo__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src\components\misc\textarea.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// modif0
var TextArea=function(_Component){_inherits(TextArea,_Component);function TextArea(props){_classCallCheck(this,TextArea);var _this=_possibleConstructorReturn(this,(TextArea.__proto__||Object.getPrototypeOf(TextArea)).call(this,props));_this.changeCallback=_this.changeCallback.bind(_this);_this.changeValue=_this.changeValue.bind(_this);_this.text='';_this.onBlur=_this.onBlur.bind(_this);_this.onFocus=_this.onFocus.bind(_this);return _this;}_createClass(TextArea,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.exists){this.props.initOutputSystem(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.lpKey,this.props.ovc,'');}else{this.text=this.props.value;}}},{key:'componentDidMount',value:function componentDidMount(){// In case props value is not equal to state value
// we update it in state (must be a prefilled value)
if(this.props.value.length>0&&this.props.value!==Object(__WEBPACK_IMPORTED_MODULE_9__logic_re_index__["h" /* lpGetVariableById */])(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id).value){this.props.changeValue(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.value);}}},{key:'componentWillUpdate',value:function componentWillUpdate(props){this.text=props.value;this.changeValue(props.value);}},{key:'onBlur',value:function onBlur(){this.props.unUpdateContext();}},{key:'onFocus',value:function onFocus(){this.props.updateContext();}},{key:'changeCallback',value:function changeCallback(evt){this.props.changeValue(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,evt.target.value);}},{key:'changeValue',value:function changeValue(value){this.props.changeValue(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,value);}},{key:'render',value:function render(){var variableMeta=__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id);/*
         * Height personnalisable
         */var height=60;if(variableMeta.textarea_size){switch(variableMeta.textarea_size){case's':height=60;break;case'm':height=120;break;case'l':height=240;break;case'p':if(variableMeta.textarea_height&&!Number.isNaN(parseInt(variableMeta.textarea_height,10))){height=parseInt(variableMeta.textarea_height,10);}break;default:height=60;}}var style={height:height+'px'};// Variable ref
var variable_ref=__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id);// Placeholder
var placeholder=variable_ref&&variable_ref.placeholder?variable_ref.placeholder:"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.props.lpKey},this.props.label,' ','helper'in __WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id)&&__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper})),this.props.id in __WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.variables&&__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning,id:this.props.id,type:'v'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{id:this.props.lpKey,placeholder:placeholder,className:'form-control',style:style,onChange:this.changeCallback,onFocus:this.onFocus,onBlur:this.onBlur,value:this.text})));}}]);return TextArea;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){var value='';var cId=void 0;var exists=false;if(ownProps.isDuplicate)cId=ownProps.id+'_'+ownProps.copy;else cId=ownProps.id;if(ownProps.ovc==='o'){var opt=Object(__WEBPACK_IMPORTED_MODULE_9__logic_re_index__["g" /* lpGetOptionById */])(cId);if(typeof opt!=='undefined'){value=opt.value;exists=true;}}else{var _opt=Object(__WEBPACK_IMPORTED_MODULE_9__logic_re_index__["h" /* lpGetVariableById */])(cId);if(typeof _opt!=='undefined'){value=_opt.value;exists=true;}}/**
   * Prefilling
   */if(__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.variables[ownProps.id].prefillings!==undefined){var prefillings=__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.variables[ownProps.id].prefillings;var executePrefill=value.length===0;prefillings.forEach(function(idx){if(value===idx.text.slice())executePrefill=true;});if(prefillings.length!==0&&executePrefill){for(var _i=0;_i<prefillings.length;_i++){var idx=prefillings[_i];var text=idx.text.slice();var fillForm=false;if(idx.compiledConditions.length>0){var id=ownProps.id;var parentId=__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].indexes.grandpa_vars.getVGrandpa(id);var copy=ownProps.copy!=-2?ownProps.copy:false;fillForm=__WEBPACK_IMPORTED_MODULE_11__logic_condition_evo__["a" /* default */].rawCondition(idx.compiledConditions,copy,parentId);}else fillForm=true;if(fillForm){text=text.replace(/\[var:([0-9]+)\]/gi,function(a,id){var variable=__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].indexes.variables.getVariable(id);var varValue=variable?variable.value.toString():'';return varValue.trim().length>0?varValue:'________________';});// Looking for old value in prefills
var foundValueInPrefills=false;for(var _i=0;_i<prefillings.length;_i++){if(value==prefillings[_i].text){foundValueInPrefills=true;}}// Making sure we do not override user input value
if(foundValueInPrefills===true||value.trim().length===0){value=text;break;}}}}}return{value:value,exists:exists,sectionId:state.contract.currentSection};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{initOutputSystem:function initOutputSystem(id,parent,genre,value,isDuplicate,copy){// console.log(genre);
// check duplication
var cId=!isDuplicate?id:id+'_'+copy;var cPid=!isDuplicate?parent:parent+'_'+copy;if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["m" /* initOutputOption */])(cId,cPid,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["n" /* initOutputVariable */])(cId,cPid,value));},changeValue:function changeValue(id,value){// let cId = !isDuplicate ? id : id + '_' + copy;
// let cPid = !isDuplicate ? parent : parent + '_' + copy;
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["l" /* editVariable */])(id,value));if(!Object(__WEBPACK_IMPORTED_MODULE_7__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_account_settings__["o" /* editedDocument */])(true));},updateContext:function updateContext(){var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;var pId=ownProps.isDuplicate?ownProps.parent+'_'+ownProps.copy:ownProps.parent;if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(cId));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["d" /* icSetVariable */])(cId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(pId));}},unUpdateContext:function unUpdateContext(){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(''));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["d" /* icSetVariable */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(''));}}};};var LpTextArea=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TextArea);/* harmony default export */ __webpack_exports__["a"] = (LpTextArea);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__masked_input__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup_preview__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_input_context__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src\components\misc\date.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// importing additional componentns
// dateformat
var _DatePicker=function(_Component){_inherits(_DatePicker,_Component);function _DatePicker(props){_classCallCheck(this,_DatePicker);var _this=_possibleConstructorReturn(this,(_DatePicker.__proto__||Object.getPrototypeOf(_DatePicker)).call(this,props));_this.onValueChanged=_this.onValueChanged.bind(_this);_this.onFocus=_this.onFocus.bind(_this);_this.onBlur=_this.onBlur.bind(_this);return _this;}_createClass(_DatePicker,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.exists){this.props.initializeOutput(this.props.id,this.props.ovc,'');}}},{key:'onFocus',value:function onFocus(){this.props.updateContext();}},{key:'onBlur',value:function onBlur(){this.props.unUpdateContext();}},{key:'onValueChanged',value:function onValueChanged(val){// Fri Nov 17 2017 00:00:00 GMT+0100 (CET)
// let formatted_date = new Intl.DateTimeFormat().format(val);
// console.log( val);
this.props.editOutput(this.props.id,val);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'date_'+this.props.lpKey},this.props.label),this.props.id in __WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.variables&&__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning,id:this.props.id,type:'v'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__masked_input__["a" /* default */],{type:'text',className:'form-control form-calendar',value:this.props.value,onChange:function onChange(ev){return _this2.onValueChanged(ev.target.value);},mask:'!!/!!/!!!!',placeholder:'JJ/MM/AAAA',onBlur:this.onBlur,onFocus:this.onFocus})));}}]);return _DatePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){// test if exists
var exists=false;var existantKey='';var value='';var realId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){var opt=Object(__WEBPACK_IMPORTED_MODULE_9__logic_re_index__["g" /* lpGetOptionById */])(realId);if(typeof opt!=='undefined'){exists=true;existantKey=opt.key;value=opt.value;}}if(ownProps.ovc==='v'){var _opt=Object(__WEBPACK_IMPORTED_MODULE_9__logic_re_index__["h" /* lpGetVariableById */])(realId);if(typeof _opt!=='undefined'){exists=true;existantKey=_opt.key;value=_opt.value;}}return{sectionId:state.contract.currentSection,exists:exists,existantKey:existantKey,value:value};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// this case, parent = key
initializeOutput:function initializeOutput(id,genre){var value=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var cId=void 0;if(ownProps.isDuplicate){cId=ownProps.id+'_'+ownProps.copy;}else{cId=ownProps.id;}if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["m" /* initOutputOption */])(cId,ownProps.lpKey,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["n" /* initOutputVariable */])(cId,ownProps.lpKey,value));},editOutput:function editOutput(id,val){var cId=void 0;if(ownProps.isDuplicate){cId=ownProps.id+'_'+ownProps.copy;}else cId=ownProps.id;if(ownProps.ovc==='o'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["k" /* editOption */])(cId,val));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["l" /* editVariable */])(cId,val));}if(!Object(__WEBPACK_IMPORTED_MODULE_7__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_account_settings__["o" /* editedDocument */])(true));},updateContext:function updateContext(){var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;var pId=ownProps.isDuplicate?ownProps.parent+'_'+ownProps.copy:ownProps.parent;if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_input_context__["c" /* icSetOption */])(cId));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_input_context__["d" /* icSetVariable */])(cId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_input_context__["c" /* icSetOption */])(pId));}},unUpdateContext:function unUpdateContext(){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_input_context__["c" /* icSetOption */])(''));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_input_context__["d" /* icSetVariable */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_input_context__["c" /* icSetOption */])(''));}}};};_DatePicker.childContextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object.isRequired};var LpDatePicker=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_DatePicker);/* harmony default export */ __webpack_exports__["a"] = (LpDatePicker);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/misc/pure.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// require id, uiid, parent, paren_ui, isDuplicate, copy, content
var LpPure=function(_Component){_inherits(LpPure,_Component);function LpPure(){_classCallCheck(this,LpPure);return _possibleConstructorReturn(this,(LpPure.__proto__||Object.getPrototypeOf(LpPure)).apply(this,arguments));}_createClass(LpPure,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{"data-id":this.props.id,"data-type":"texte_brute","data-is-duplicate":this.props.isDuplicate,"data-copy":this.props.copy,dangerouslySetInnerHTML:{__html:this.props.content}});}}]);return LpPure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LpPure);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(1124);
} else {
  module.exports = require('./lib/react-input-mask.development.js');
}


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeEList;
/* harmony export (immutable) */ __webpack_exports__["b"] = pushEList;
/*
* Project: LegalPlace assistant
* File: src/logic/preview_render/condition_manager.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var staticExceptionList=[];function initializeEList(){staticExceptionList=[];}function pushEList(id){var _=false;staticExceptionList.forEach(function(idx){if(idx===id)_=true;});if(!_)staticExceptionList.push(id);window.cond_s=staticExceptionList;}

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview_row__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_toggle_preview__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/modal.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// import actions
var numberOfAll=0;// calculation of page numbers
var PAGE_WIDTH=684;function getPageNumber(width){return Math.ceil(width/PAGE_WIDTH);}function getPageToMargin(page){return-(PAGE_WIDTH*page);}// ██████╗ ██████╗ ███████╗██████╗  █████╗ ██████╗ ███████╗    ██████╗  ██████╗ ███╗   ███╗
// ██╔══██╗██╔══██╗██╔════╝██╔══██╗██╔══██╗██╔══██╗██╔════╝    ██╔══██╗██╔═══██╗████╗ ████║
// ██████╔╝██████╔╝█████╗  ██████╔╝███████║██████╔╝█████╗      ██║  ██║██║   ██║██╔████╔██║
// ██╔═══╝ ██╔══██╗██╔══╝  ██╔═══╝ ██╔══██║██╔══██╗██╔══╝      ██║  ██║██║   ██║██║╚██╔╝██║
// ██║     ██║  ██║███████╗██║     ██║  ██║██║  ██║███████╗    ██████╔╝╚██████╔╝██║ ╚═╝ ██║
// ╚═╝     ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝    ╚═════╝  ╚═════╝ ╚═╝     ╚═╝
//
function placeModalInDOM(exitYo){document.getElementById('modal').appendChild(exitYo);document.getElementsByClassName('page-wrap')[0].style.filter='blur(5px)';}function disableScrollToBody(){document.body.style.overflow='hidden';}var _PreviewModal=function(_Component){_inherits(_PreviewModal,_Component);function _PreviewModal(props){_classCallCheck(this,_PreviewModal);var _this=_possibleConstructorReturn(this,(_PreviewModal.__proto__||Object.getPrototypeOf(_PreviewModal)).call(this,props));_this.len=0;_this.state={page_length:0,current_page:1};//
// init contextfor callbacks
_this.closeCallBack=_this.closeCallBack.bind(_this);_this.goNextCallBack=_this.goNextCallBack.bind(_this);_this.goPreviousCallBack=_this.goPreviousCallBack.bind(_this);return _this;}_createClass(_PreviewModal,[{key:'componentWillMount',value:function componentWillMount(){document.body.style.overflow='auto';}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(this.props.preview===false&&nextProps.preview===true)return true;if(nextState.current_page===this.state.current_page){// if(!this.props.preview)return false;
return true;}var pgNbr=getPageNumber(this.refs.modal_doc.scrollWidth);var a=getPageToMargin(nextState.current_page-1);this.refs.modal_doc.style.marginLeft=a===0?0:a+'px';this.refs.current_page.innerText=' '+nextState.current_page+' ';this.refs.total_page.innerText=' '+pgNbr+' ';// now to the better
if(nextState.current_page<pgNbr)this.refs.to_the_right.style.display='block';// show right
else this.refs.to_the_right.style.display='none';if(nextState.current_page>1)this.refs.to_the_left.style.display='block';// show left
else this.refs.to_the_left.style.display='none';//
document.getElementsByClassName('page-wrap')[0].style.filter='blur(5px)';document.body.style.overflow='hidden';document.querySelector('.lp-doc-container.lp-doc-modal').style.overflow='hidden';return false;}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){window.modal=this.refs.modal_doc;window.c_page=this.refs.current_page;window.t_page=this.refs.total_page;if(this.refs.modal_doc){nextState.page_length=getPageNumber(this.refs.modal_doc.scrollWidth);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){// show and hide the page number
if(this.refs.modal_doc){if(this.state.current_page<getPageNumber(this.refs.modal_doc.scrollWidth)-1)this.refs.to_the_right.style.display='block';// show right
else this.refs.to_the_right.style.display='none';if(this.state.current_page>1)this.refs.to_the_left.style.display='block';// show left
else this.refs.to_the_left.style.display='none';}if(this.refs.modal_doc){var pageNumber=getPageNumber(this.refs.modal_doc.scrollWidth);this.state.page_length=pageNumber;if(this.refs.total_page)this.refs.total_page.innerText=' '+pageNumber;}if(this.props.is_modal)disableScrollToBody();//
// displace tge shit
if(this.refs.exit_yo){placeModalInDOM(this.refs.exit_yo);}var nbrSys={};// this one must change
var numbers=document.querySelectorAll('#modal [num-auto], #modal [num-auto-pre]');// get the numbering system
// console.log(numbers);
for(var i=0;i<numbers.length;i+=1){var v=numbers[i];if(v&&v.attributes&&v.attributes.getNamedItem('num-auto')){nbrSys[v.attributes.getNamedItem('num-auto').value]=0;}else{nbrSys[v.attributes.getNamedItem('num-auto-pre').value]=0;}}Object.keys(numbers).forEach(function(idx){var element=numbers[idx];if(element&&element.attributes&&element.attributes.getNamedItem('num-auto')){var counter=element.attributes.getNamedItem('num-auto').value;nbrSys[counter]+=1;element.innerHTML=nbrSys[counter];// test if it's an article
if(counter==='articles'){// init all them
Object.keys(nbrSys).forEach(function(sysIdx){if(sysIdx!=='articles')nbrSys[sysIdx]=0;});}}else if(element&&element.attributes){var _counter=element.attributes.getNamedItem('num-auto-pre').value;element.innerHTML=nbrSys[_counter];}});}},{key:'goToPage',value:function goToPage(id){if(id<=this.state.page_length||id>0){this.setState({current_page:id});}}},{key:'closeCallBack',value:function closeCallBack(target){var cList=target.classList;if(cList.contains('lp-modal')||cList.contains('lpm-close')||cList.contains('lp-modal-content')||cList.contains('lp-doc-modal-container')){this.props.toggle_screen();document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';}}},{key:'goNextCallBack',value:function goNextCallBack(){var pgNbr=getPageNumber(document.getElementById('lp-doc-modal').scrollWidth);if(this.state.current_page<pgNbr)this.goToPage(this.state.current_page+1);}},{key:'goPreviousCallBack',value:function goPreviousCallBack(){if(this.state.current_page>1)this.goToPage(this.state.current_page-1);}},{key:'render',value:function render(){var _this2=this;// console.time('modal')
return this.props.preview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'doc-preview',className:'lp-modal',ref:'exit_yo',onClick:function onClick(evt){_this2.closeCallBack(evt.target);},style:this.props.is_full?{filter:'blur(14px)'}:{},onCopy:function onCopy(e){return e.preventDefault();},onCut:function onCut(e){return e.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-doc-modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lpm-close icn-x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-doc-container lp-doc-modal',ref:'ff_p',style:{overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lp-doc-modal',ref:'modal_doc',className:'lp-doc',style:{marginLeft:getPageToMargin(this.state.current_page-1)}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},this.props.views.map(function(idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__preview_row__["a" /* default */],{key:Object(__WEBPACK_IMPORTED_MODULE_3__utils_misc__["b" /* generateId1 */])(4),idOut:idx[1],out:idx[0]});}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dm-count'},Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Page'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{ref:'current_page'},' ',this.state.current_page,' '),Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('sur'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{ref:'total_page'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{ref:'to_the_right',className:'lpm-next',onClick:this.goNextCallBack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-chev-llr'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{ref:'to_the_left',className:'lpm-prev',onClick:this.goPreviousCallBack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-chev-lll'}))));// console.timeEnd('modal')
}}]);return _PreviewModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){// check the updatable conditions.
numberOfAll=0;var outputs=[];if(state.contract===undefined||state.contract===null){return{views:[]};}if(!state.preview){return{is_modal:state.preview,preview:state.preview,views:[]};}// console.log(keys)
Object.keys(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].indexes.real_sections.output_sections).forEach(function(idx){__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].ops.content.getOutput(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].indexes.real_sections.getOutputSection(idx).options,outputs);});__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].indexes.content.updateContent(outputs,numberOfAll);return{preview:state.preview,views:outputs,is_modal:state.preview};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggle_screen:function toggle_screen(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_toggle_preview__["e" /* togglePreview */])());}};};var PreviewModal=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_PreviewModal);/* harmony default export */ __webpack_exports__["a"] = (PreviewModal);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getExperimentsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__(97);
var getExperimentsData=function getExperimentsData(){var mixpanelKey="mp_ecdbd1b26476e4332bbcd23fd903ddfa_mixpanel";var cookies=new __WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */]();var mixpanelData=cookies.get(mixpanelKey);return mixpanelData;};

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_contract__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_ops_sendinblue_notification__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\wizard_body.js
 * Author: Amine Azizi
 * Version: 1.0
 */var _RepriseWizard=function(_Component){_inherits(_RepriseWizard,_Component);function _RepriseWizard(props){_classCallCheck(this,_RepriseWizard);var _this=_possibleConstructorReturn(this,(_RepriseWizard.__proto__||Object.getPrototypeOf(_RepriseWizard)).call(this,props));_this.poursuivre=_this.poursuivre.bind(_this);return _this;}_createClass(_RepriseWizard,[{key:'componentDidMount',value:function componentDidMount(){document.body.classList.add('wz-page');document.body.classList.add('step2-reprise');if(this.props.is_crea_assist_sub){var sdbNotif=new __WEBPACK_IMPORTED_MODULE_3__app_ops_sendinblue_notification__["a" /* default */]();sdbNotif.sendInBlueNotification({},this.props.is_crea_assist_sub);}document.getElementsByTagName('html')[0].style.fontSize='10px';}},{key:'componentWillUpdate',value:function componentWillUpdate(){}},{key:'componentDidUpdate',value:function componentDidUpdate(){}},{key:'componentWillUnmount',value:function componentWillUnmount(){console.log(this.props.reprise_link);document.body.classList.remove('wz-page');document.body.classList.remove('step2-reprise');window.onbeforeunload=null;window.location.href=this.props.reprise_link;}},{key:'poursuivre',value:function poursuivre(){/*
     * Adwords Conversion tracking
     */if([162,144,197,175,176,124,180].indexOf(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId)>-1){__WEBPACK_IMPORTED_MODULE_4__tracking_lpevents__["a" /* default */].adwordsConversion({google_conversion_value:0.01});}this.props.setRepriseWizard(false);}},{key:'render',value:function render(){var styles={cursor:'pointer'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{className:'wz-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'has-ok-icn'},'Votre paiement a \xE9t\xE9 valid\xE9 !'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Merci de r\xE9pondre aux questions compl\xE9mentaires afin de permettre \xE0 notre logiciel de cr\xE9er les documents juridiques les plus adapt\xE9s \xE0 votre situation.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'is-cta is-rounded has-arrow-right',onClick:this.poursuivre,style:styles},'Poursuivre'));}}]);return _RepriseWizard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{currentSection:state.contract.currentSection,doc_state:state.document_state.state,reprise_wizard:state.contract.reprise_wizard,reprise_link:state.contract.reprise_link,is_crea_assist_sub:state.account_settings.is_crea_assist_sub};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setRepriseWizard:function setRepriseWizard(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_contract__["i" /* setRepriseWizard */])(val));}};};var RepriseWizard=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_RepriseWizard);/* harmony default export */ __webpack_exports__["a"] = (RepriseWizard);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_hardcoded_checkout__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_img_newCheckout_chevron_left_svg__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_img_newCheckout_chevron_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_img_newCheckout_chevron_left_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/header.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var _Header=function(_Component){_inherits(_Header,_Component);function _Header(props){_classCallCheck(this,_Header);var _this=_possibleConstructorReturn(this,(_Header.__proto__||Object.getPrototypeOf(_Header)).call(this,props));_this.goTopack=_this.goTopack.bind(_this);return _this;}_createClass(_Header,[{key:'goTopack',value:function goTopack(){var hardCodedMeta=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;__WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__["a" /* default */].trackGTMGAEvent('Checkout retour','Clic',this.props.title);// intermediate page => reload the page
if(this.props.packEntrepreneur&&this.props.packEntrepreneur.backHeaderBtn){this.props.onPackEntrepreneurHeaderBtn(false);this.props.onPackEntrepreneurChoosePack(undefined);return;}if(this.props.togglePack&&hardCodedMeta){this.props.goPack(false,this.props.selectedPack);}else{window.location.href='/contrats/'+__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractTitle+'/continuer/'+__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractUniqid;}document.getElementsByTagName("html")[0].removeAttribute('style');}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractMetaId)>-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tb-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link-gd',style:{cursor:"pointer"},onClick:this.goTopack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-arrow-left'}),'Retour')))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tb-headings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link-gd',title:Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])("Retourner au Questionnaire"),onClick:this.props.goBack},__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractMetaId===302?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__styles_img_newCheckout_chevron_left_svg___default.a,alt:''}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-arrow-left'}),__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractMetaId===302?'Retour':Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Modifier mes réponses')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'tb-title',style:__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractMetaId===302?{display:'none'}:{}},__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('checkout_title')=='NONE'?Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])("Votre ")+this.props.title+Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])(" est prêt"):__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('checkout_title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'tb-subtitle'},__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.custom&&__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.custom.uniqpack?"":Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])("Choisissez l'offre qui vous correspond"))))));}}]);return _Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{title:state.contract.name,togglePack:state.checkout_operations.togglepack,packEntrepreneur:state.checkout_operations.packEntrepreneur,selectedPack:state.checkout_operations.pack};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{goBack:function goBack(){// #event
__WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__["a" /* default */].track('Modifier mon document',{});__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["p" /* lpPattern */].trackLastAction(__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["c" /* P_BACK */]);__WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__["a" /* default */].trackGTMGAEvent('Checkout retour','Clic',__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].getState().contract.name);__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["p" /* lpPattern */].sendAndResetTracker();ownProps.history.push('/contrats/'+__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractTitle+'/continuer/'+__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractUniqid+'/'+Object.keys(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].indexes.real_sections.sections).length);},goPack:function goPack(val,id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["G" /* ceTogglePack */])(val,id));},onPackEntrepreneurChoosePack:function onPackEntrepreneurChoosePack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_7" /* packEntrepreneurChoosePack */])(val));},onPackEntrepreneurHeaderBtn:function onPackEntrepreneurHeaderBtn(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_5" /* packEntrepreneur */])(val));}};};var LpHeader=Object(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_Header));/* harmony default export */ __webpack_exports__["a"] = (LpHeader);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCardClass;
/*
 * Project: LegalPlace assistant
 * File: src\components\utils\credit_card_detect.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/function checkVisa(){var cn=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return cn.search(/^4[0-9]/g)===0;}function checkMasterCard(){var cn=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return cn.search(/^5[1-5]/g)===0;}function checkAmex(){var cn=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return cn.search(/^3[47]/g)===0;}function getCardClass(){var cn=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';if(checkVisa(cn))return'visa';if(checkMasterCard(cn))return'master';if(checkAmex(cn))return'amex';return'none';}window.card_class=getCardClass;

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export percentagePromo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PackChoice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_shimmer__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_subscription_constant__ = __webpack_require__(388);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/pack_choice.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*//**
 *
 * @param {string} price
 */var percentagePromo=function percentagePromo(price){if(Number.isNaN(parseFloat(price))||typeof price==='string')return 1.0;return 1.0-parseFloat(price);};/**
 * @description The component that selects the packs of prices.
 */var _PackChoice=function(_Component){_inherits(_PackChoice,_Component);function _PackChoice(){_classCallCheck(this,_PackChoice);return _possibleConstructorReturn(this,(_PackChoice.__proto__||Object.getPrototypeOf(_PackChoice)).apply(this,arguments));}_createClass(_PackChoice,[{key:'componentWillMount',value:function componentWillMount(){document.body.classList.add('checkout-base');}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.classList.remove('checkout-base');}},{key:'render',value:function render(){var _this2=this;var showSubscribeOffer=__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].subscription||!__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].paidSession&&__WEBPACK_IMPORTED_MODULE_7__constants_subscription_constant__["a" /* AVAILABLE_SUBSCRIPTION_CONTRACT_META_ID */].indexOf(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractMetaId)>-1;if(showSubscribeOffer)__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].setSubscription(true);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractMetaId===302?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.custom&&__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.custom.uniqpack?'packs one-pack':'packs'},__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.custom&&__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.custom.uniqpack?'':this.props.pricing_loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__misc_shimmer__["a" /* PackShimmer */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(e){e.preventDefault();_this2.props.selectOne();},style:{opacity:showSubscribeOffer&&this.props.chosen_pack===1?0.6:1},className:'pack lp-checkbox pack-basic'+(this.props.chosen_pack===0?' selected':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'p',type:'radio',id:'p1',checked:this.props.chosen_pack===0,onChange:function onChange(){}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'p1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'pack-name'},__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('first_pack_name')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Pack Basique'):__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('first_pack_name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'pack-price'},(parseFloat(this.props.first_price)*percentagePromo(this.props.promo_percentage)).toFixed(2),'\u20AC')),__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('first_pack_content')==='NONE'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Votre document personnalisé')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Version imprimable '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('(PDF)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{textDecoration:'line-through'},className:'pack-feature-off'},Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Version modifiable '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('(Word)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Annexes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'feature-highlight'},Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Modifiable pendant '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ped-hilight'},Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('15 jours')))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('first_pack_content')}}))),this.props.pricing_loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__misc_shimmer__["a" /* PackShimmer */],null):showSubscribeOffer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(e){e.preventDefault();_this2.props.selectSubscription();},className:'pack lp-checkbox pack-complet'+(this.props.chosen_pack===1?' selected':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'p',type:'radio',id:'p2',checked:this.props.chosen_pack===1,onChange:function onChange(){}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'p2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'pack-name'},Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Essai 7 jours')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'pack-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Gratuit')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Votre document personnalisé en '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Word')),Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])(' et '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('PDF')),Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])(' avec annexes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Accès illimité et gratuit à la bibliothèque de documents juridiques LegalPlace')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Support juridique gratuit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Gratuit 7 jours puis '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('19,90€/mois.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Annulable sans aucun frais à tout moment'))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(e){e.preventDefault();_this2.props.selectTwo();},className:'pack lp-checkbox pack-complet'+(this.props.chosen_pack===1?' selected':'')},__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.custom&&__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.custom.uniqpack?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-badge'},Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Le plus populaire')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'p',type:'radio',id:'p2',checked:this.props.chosen_pack===1,onChange:function onChange(){}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'p2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'pack-name'},__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('second_pack_name')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Pack Complet'):__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('second_pack_name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'pack-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,(parseFloat(this.props.second_price)*percentagePromo(this.props.promo_percentage)).toFixed(2),'\u20AC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pack-price-original'},(parseFloat(this.props.second_price)+15).toFixed(2),'\u20AC'))),__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('second_pack_content')==='NONE'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Votre document personnalisé')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Version imprimable '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('(PDF)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Version modifiable '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('(Word)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Annexes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'feature-highlight'},Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Modifiable pendant '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ped-hilight'},Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('45 jours')))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features',dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('second_pack_content')}})))));}}]);return _PackChoice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price,chosen_pack:state.checkout_operations.pack,pricing_loading:state.loading_details.pricing,promo_percentage:state.checkout_operations.promo_percentage};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectSubscription:function selectSubscription(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(1));__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["m" /* P_SELECT_PACK_2 */]);},selectOne:function selectOne(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(0));__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["l" /* P_SELECT_PACK_1 */]);},selectTwo:function selectTwo(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(1));__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["m" /* P_SELECT_PACK_2 */]);}};};var PackChoice=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_PackChoice);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pack_entrepreneurAB_css__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pack_entrepreneurAB_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pack_entrepreneurAB_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pack_entrepreneurAB_header__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pack_entrepreneurAB_content__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pack_entrepreneurAB_footer__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pack_entrepreneurAB_Data__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _PackEntrepreneurAB=function(_Component){_inherits(_PackEntrepreneurAB,_Component);function _PackEntrepreneurAB(){_classCallCheck(this,_PackEntrepreneurAB);return _possibleConstructorReturn(this,(_PackEntrepreneurAB.__proto__||Object.getPrototypeOf(_PackEntrepreneurAB)).apply(this,arguments));}_createClass(_PackEntrepreneurAB,[{key:"componentDidMount",value:function componentDidMount(){this.props.entrepreneurPack(true);}},{key:"render",value:function render(){var _packEntrepreneurData=__WEBPACK_IMPORTED_MODULE_5__pack_entrepreneurAB_Data__["a" /* packEntrepreneurData */][__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].contractMetaId],header=_packEntrepreneurData.header,content=_packEntrepreneurData.content,footer=_packEntrepreneurData.footer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main",{className:"newPack-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"corner-ribbon"},"recommand\xE9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pack_entrepreneurAB_header__["a" /* default */],{header:header}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"details"},content&&content.length&&content.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pack_entrepreneurAB_content__["a" /* default */],option);}).reduce(function(prev,curr){return[prev,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"separator"},"+"),curr];})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__pack_entrepreneurAB_footer__["a" /* default */],{selectPack:this.props.selectPack,index:this.props.index,footer:footer}));}}]);return _PackEntrepreneurAB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{entrepreneurPack:function entrepreneurPack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_checkout_operations__["_5" /* packEntrepreneur */])(val));}};};var PackEntrepreneurAB=Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(null,mapDispatchToProps)(_PackEntrepreneurAB);/* harmony default export */ __webpack_exports__["a"] = (PackEntrepreneurAB);

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjE0NiAzLjE5NjE1TDIwLjM1NCAwLjM5NjE0OUMyMC4xNTkgMC4yMDAxNDkgMTkuODQyIDAuMjAwMTQ5IDE5LjY0NyAwLjM5NTE0OUwxOS42NDYgMC4zOTYxNDlMNy44NTQgMTIuMTk2MUM3LjY1OSAxMi4zOTIxIDcuMzQyIDEyLjM5MjEgNy4xNDcgMTIuMTk3MUw3LjE0NiAxMi4xOTYxTDQuMzU0IDkuMzk2MTVDNC4xNTkgOS4yMDAxNSAzLjg0MiA5LjIwMDE1IDMuNjQ3IDkuMzk1MTVMMy42NDYgOS4zOTYxNUwwLjg1Mzk5OCAxMi4xOTYxQzAuNjU4OTk4IDEyLjM5MTEgMC42NTg5OTggMTIuNzA4MSAwLjg1Mzk5OCAxMi45MDMxTDcuMTQ2IDE5LjE5NjFDNy4zNDEgMTkuMzkyMSA3LjY1OCAxOS4zOTIxIDcuODUzIDE5LjE5NzFMNy44NTQgMTkuMTk2MUwyMy4xNDYgMy44OTYxNUMyMy4zMzcgMy43MDIxNSAyMy4zMzcgMy4zOTAxNSAyMy4xNDYgMy4xOTYxNVoiIGZpbGw9IiMxNENGOTYiLz4KPC9zdmc+Cg=="

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDE2IDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IG9wYWNpdHk9IjAuMiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjQiIGZpbGw9IiM2Qjc1N0YiLz4KPC9zdmc+Cg=="

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AbTest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_universal_cookie__ = __webpack_require__(97);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var localStorageAvailable=true;if(typeof Storage==='undefined')localStorageAvailable=false;try{// try to use localStorage
localStorage.setItem('localStorageAvailable','true');localStorage.getItem('localStorageAvailable');localStorage.removeItem('localStorageAvailable');}catch(e){console.log('You are in Privacy Mode\nPlease deactivate Privacy Mode and then reload the page.');localStorageAvailable=false;}function AbTest(){this.tests={};this.session_prefix='lp_ab_';}/*
 * Registers Test
 */AbTest.prototype.registerTest=function(name){this.tests[name]=[];this.current_test=name;return this;};/*
 * Registers variation
 */AbTest.prototype.registerVar=function(name,percent){if(!this.current_test){return false;}this.tests[this.current_test].push({name:name,percent:percent});return true;};/**
 * Register data from cookie
 */AbTest.prototype.registerFromCookie=function(abTestName){var oldValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'Old';var cookies=decodeURIComponent(document.cookie).split(';');var abTestCookieValue=void 0;cookies.forEach(function(cookie){var _cookie$split=cookie.split('='),_cookie$split2=_slicedToArray(_cookie$split,2),cookieKey=_cookie$split2[0],cookieValue=_cookie$split2[1];if(cookieKey.indexOf(abTestName)>-1){abTestCookieValue=cookieValue;}});var mp={};// Make sur to have Cookies
var cookiesUniversal=new __WEBPACK_IMPORTED_MODULE_1_universal_cookie__["a" /* default */]();if(!abTestCookieValue&&cookiesUniversal.get(abTestName)){abTestCookieValue=cookiesUniversal.get(abTestName);}if(abTestName&&typeof window[abTestName]==='undefined'){window[abTestName]=abTestCookieValue;}if(abTestCookieValue){// Mixpanel tracking
mp["AB: "+abTestName]=abTestCookieValue;}else{mp["AB: "+abTestName]=oldValue;}__WEBPACK_IMPORTED_MODULE_0__lpevents__["a" /* default */].register(mp);};/*
 * Get variation
 */AbTest.prototype.getVar=function(testName){// if( typeof Storage != 'function' ) return false;
var test=this.tests[testName];var variation=null;if(typeof test==='undefined'){return false;}// Checking if test exists in localStorage
if(localStorageAvailable){if(localStorage.getItem((this.session_prefix+testName).toLowerCase().replace(' ','_'))){variation=localStorage.getItem((this.session_prefix+testName).toLowerCase().replace(' ','_'));return variation;}}// Counts
var lastPercent=0;var percent=Math.floor(Math.random()*100+1);// Reading variations list
for(var i=0;i<test.length;i+=1){if(percent>lastPercent&&percent<=test[i].percent+lastPercent){variation=test[i].name;break;}else lastPercent+=test[i].percent;}if(variation===null)variation=test[0].name;// Adding to localStorage
if(localStorageAvailable)localStorage.setItem((this.session_prefix+testName).toLowerCase().replace(' ','_'),variation);// Mixpanel tracking
var mp={};mp['AB: '+testName]=variation;__WEBPACK_IMPORTED_MODULE_0__lpevents__["a" /* default */].register(mp);return variation;};// Initiation ab lib

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_history__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpsellEcCardComponent=function(_Component){_inherits(UpsellEcCardComponent,_Component);function UpsellEcCardComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UpsellEcCardComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UpsellEcCardComponent.__proto__||Object.getPrototypeOf(UpsellEcCardComponent)).call.apply(_ref,[this].concat(args))),_this),_this.goToNextStep=function(){_this.props.togglePack(true);__WEBPACK_IMPORTED_MODULE_4__tracking_lpevents__["a" /* default */].trackDatalayerMixpanel("Je suis intéressé","upsellScreenEC");if(typeof window.sendinblue!=='undefined'){window.sendinblue.identify(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().account_settings.mail,{EXPERT_COMPTABLE:true});}},_this.goBackToPackSelectorPage=function(){__WEBPACK_IMPORTED_MODULE_4__tracking_lpevents__["a" /* default */].trackDatalayerMixpanel("Je m’occupe seul de ma comptabilité","upsellScreenEC");Object(__WEBPACK_IMPORTED_MODULE_5__logic_history__["a" /* default */])('payment',false,false,__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractUniqid);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UpsellEcCardComponent,[{key:"render",value:function render(){var _props$card=this.props.card,monthSubscription=_props$card.monthSubscription,yearSubscription=_props$card.yearSubscription,textBtn=_props$card.textBtn,textLink=_props$card.textLink;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"upsellEc-content-card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"upsellEc-content-card-text"},monthSubscription," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)," ",yearSubscription),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"upsellEc-interested-btn",onClick:this.goToNextStep},textBtn),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"upsellEc-desinterested-btn",onClick:this.goBackToPackSelectorPage},textLink));}}]);return UpsellEcCardComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{togglePack:function togglePack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["G" /* ceTogglePack */])(val));}};};var UpsellEcCard=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null,mapDispatchToProps)(UpsellEcCardComponent);/* harmony default export */ __webpack_exports__["a"] = (UpsellEcCard);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(476);
module.exports = __webpack_require__(480);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {



if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(477).enable();
  window.Promise = __webpack_require__(479);
}

// fetch() polyfill for making API calls.
__webpack_require__(274);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(17);


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(273);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(273);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_polyfill__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_main_css__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(773);
/*
 * Project: LegalPlace assistant
 * File: src\index.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// import 'react-polyfill'
window.lp={};try{__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */],null),document.getElementById('root'));}catch(e){console.log(e);console.log("error");}// registerServiceWorker();

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(117)('native-function-to-string', Function.toString);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(483);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(178);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(180);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(187);
__webpack_require__(584);
__webpack_require__(298);
__webpack_require__(585);
__webpack_require__(299);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(188);
__webpack_require__(193);
__webpack_require__(302);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(186);
module.exports = __webpack_require__(39);


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(9);
var has = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(24);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(40);
var META = __webpack_require__(76).KEY;
var $fails = __webpack_require__(10);
var shared = __webpack_require__(117);
var setToStringTag = __webpack_require__(101);
var uid = __webpack_require__(83);
var wks = __webpack_require__(19);
var wksExt = __webpack_require__(284);
var wksDefine = __webpack_require__(194);
var enumKeys = __webpack_require__(484);
var isArray = __webpack_require__(141);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(12);
var toObject = __webpack_require__(28);
var toIObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(57);
var createDesc = __webpack_require__(84);
var _create = __webpack_require__(85);
var gOPNExt = __webpack_require__(285);
var $GOPD = __webpack_require__(47);
var $GOPS = __webpack_require__(140);
var $DP = __webpack_require__(25);
var $keys = __webpack_require__(86);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(93).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(119).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(74)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(41)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(86);
var gOPS = __webpack_require__(140);
var pIE = __webpack_require__(119);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(85) });


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperty: __webpack_require__(25).f });


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperties: __webpack_require__(277) });


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(45);
var $getOwnPropertyDescriptor = __webpack_require__(47).f;

__webpack_require__(59)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(28);
var $getPrototypeOf = __webpack_require__(46);

__webpack_require__(59)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(28);
var $keys = __webpack_require__(86);

__webpack_require__(59)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(59)('getOwnPropertyNames', function () {
  return __webpack_require__(285).f;
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(76).onFreeze;

__webpack_require__(59)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(76).onFreeze;

__webpack_require__(59)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(76).onFreeze;

__webpack_require__(59)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(12);

__webpack_require__(59)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(12);

__webpack_require__(59)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(12);

__webpack_require__(59)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(286) });


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(287) });


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(192).set });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(288) });


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(24) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(12);
var getPrototypeOf = __webpack_require__(46);
var HAS_INSTANCE = __webpack_require__(19)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(25).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(290);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(291);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var has = __webpack_require__(44);
var cof = __webpack_require__(51);
var inheritIfRequired = __webpack_require__(191);
var toPrimitive = __webpack_require__(57);
var fails = __webpack_require__(10);
var gOPN = __webpack_require__(93).f;
var gOPD = __webpack_require__(47).f;
var dP = __webpack_require__(25).f;
var $trim = __webpack_require__(102).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(85)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(24) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(40)(global, NUMBER, $Number);
}


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(52);
var aNumberValue = __webpack_require__(292);
var repeat = __webpack_require__(196);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(10)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(10);
var aNumberValue = __webpack_require__(292);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(9).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(293) });


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(293);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(291);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(290);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(294);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(197);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(198);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(295) });


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(294) });


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(197) });


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(198);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(198);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(87);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(45);
var toLength = __webpack_require__(20);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(102)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(136)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(20);
var context = __webpack_require__(199);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(200)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(199);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(200)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(196)
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(20);
var context = __webpack_require__(199);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(200)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(42)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(42)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(42)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(42)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(42)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(42)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(42)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(42)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(42)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(42)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(42)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(42)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(42)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(28);
var toPrimitive = __webpack_require__(57);

$export($export.P + $export.F * __webpack_require__(10)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(559);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(10);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(40)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(19)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(41)(proto, TO_PRIMITIVE, __webpack_require__(562));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(57);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(141) });


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(53);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(28);
var call = __webpack_require__(281);
var isArrayIter = __webpack_require__(189);
var toLength = __webpack_require__(20);
var createProperty = __webpack_require__(201);
var getIterFn = __webpack_require__(190);

$export($export.S + $export.F * !__webpack_require__(139)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(201);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(10)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(45);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(118) != Object || !__webpack_require__(54)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(185);
var cof = __webpack_require__(51);
var toAbsoluteIndex = __webpack_require__(87);
var toLength = __webpack_require__(20);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(10)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(37);
var toObject = __webpack_require__(28);
var fails = __webpack_require__(10);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(54)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(60)(0);
var STRICT = __webpack_require__(54)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var isArray = __webpack_require__(141);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(60)(1);

$export($export.P + $export.F * !__webpack_require__(54)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(60)(2);

$export($export.P + $export.F * !__webpack_require__(54)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(60)(3);

$export($export.P + $export.F * !__webpack_require__(54)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(60)(4);

$export($export.P + $export.F * !__webpack_require__(54)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(296);

$export($export.P + $export.F * !__webpack_require__(54)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(296);

$export($export.P + $export.F * !__webpack_require__(54)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(137)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(54)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(45);
var toInteger = __webpack_require__(52);
var toLength = __webpack_require__(20);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(54)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(297) });

__webpack_require__(75)('copyWithin');


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(203) });

__webpack_require__(75)('fill');


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(60)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(75)(KEY);


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(60)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(75)(KEY);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91)('Array');


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var inheritIfRequired = __webpack_require__(191);
var dP = __webpack_require__(25).f;
var gOPN = __webpack_require__(93).f;
var isRegExp = __webpack_require__(142);
var $flags = __webpack_require__(120);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(24) && (!CORRECT_NEW || __webpack_require__(10)(function () {
  re2[__webpack_require__(19)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(40)(global, 'RegExp', $RegExp);
}

__webpack_require__(91)('RegExp');


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(299);
var anObject = __webpack_require__(6);
var $flags = __webpack_require__(120);
var DESCRIPTORS = __webpack_require__(24);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(40)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(10)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(6);
var toLength = __webpack_require__(20);
var advanceStringIndex = __webpack_require__(205);
var regExpExec = __webpack_require__(143);

// @@match logic
__webpack_require__(144)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(6);
var toObject = __webpack_require__(28);
var toLength = __webpack_require__(20);
var toInteger = __webpack_require__(52);
var advanceStringIndex = __webpack_require__(205);
var regExpExec = __webpack_require__(143);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(144)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(6);
var sameValue = __webpack_require__(287);
var regExpExec = __webpack_require__(143);

// @@search logic
__webpack_require__(144)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(142);
var anObject = __webpack_require__(6);
var speciesConstructor = __webpack_require__(121);
var advanceStringIndex = __webpack_require__(205);
var toLength = __webpack_require__(20);
var callRegExpExec = __webpack_require__(143);
var regexpExec = __webpack_require__(204);
var fails = __webpack_require__(10);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(144)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(74);
var global = __webpack_require__(9);
var ctx = __webpack_require__(53);
var classof = __webpack_require__(99);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(12);
var aFunction = __webpack_require__(37);
var anInstance = __webpack_require__(89);
var forOf = __webpack_require__(90);
var speciesConstructor = __webpack_require__(121);
var task = __webpack_require__(206).set;
var microtask = __webpack_require__(207)();
var newPromiseCapabilityModule = __webpack_require__(208);
var perform = __webpack_require__(300);
var userAgent = __webpack_require__(145);
var promiseResolve = __webpack_require__(301);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(19)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(88)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(101)($Promise, PROMISE);
__webpack_require__(91)(PROMISE);
Wrapper = __webpack_require__(39)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(139)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(303);
var validate = __webpack_require__(92);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(138)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(146);
var buffer = __webpack_require__(209);
var anObject = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(87);
var toLength = __webpack_require__(20);
var isObject = __webpack_require__(12);
var ArrayBuffer = __webpack_require__(9).ArrayBuffer;
var speciesConstructor = __webpack_require__(121);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(10)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(91)(ARRAY_BUFFER);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(146).ABV, {
  DataView: __webpack_require__(209).DataView
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(6);
var rApply = (__webpack_require__(9).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(10)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(85);
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(10);
var bind = __webpack_require__(288);
var rConstruct = (__webpack_require__(9).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(25);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(57);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(10)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(47).f;
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(182)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(46);
var has = __webpack_require__(44);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(6);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(47);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(46);
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(305) });


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(25);
var gOPD = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(46);
var has = __webpack_require__(44);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(84);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(12);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(192);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(137)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(75)('includes');


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(306);
var toObject = __webpack_require__(28);
var toLength = __webpack_require__(20);
var aFunction = __webpack_require__(37);
var arraySpeciesCreate = __webpack_require__(202);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(75)('flatMap');


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(306);
var toObject = __webpack_require__(28);
var toLength = __webpack_require__(20);
var toInteger = __webpack_require__(52);
var arraySpeciesCreate = __webpack_require__(202);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(75)('flatten');


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(136)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(307);
var userAgent = __webpack_require__(145);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(307);
var userAgent = __webpack_require__(145);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(102)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(102)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(58);
var toLength = __webpack_require__(20);
var isRegExp = __webpack_require__(142);
var getFlags = __webpack_require__(120);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(182)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(194)('asyncIterator');


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(194)('observable');


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(305);
var toIObject = __webpack_require__(45);
var gOPD = __webpack_require__(47);
var createProperty = __webpack_require__(201);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(308)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(308)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(28);
var aFunction = __webpack_require__(37);
var $defineProperty = __webpack_require__(25);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(24) && $export($export.P + __webpack_require__(147), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(28);
var aFunction = __webpack_require__(37);
var $defineProperty = __webpack_require__(25);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(24) && $export($export.P + __webpack_require__(147), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(28);
var toPrimitive = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(46);
var getOwnPropertyDescriptor = __webpack_require__(47).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(24) && $export($export.P + __webpack_require__(147), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(28);
var toPrimitive = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(46);
var getOwnPropertyDescriptor = __webpack_require__(47).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(24) && $export($export.P + __webpack_require__(147), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(309)('Map') });


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(309)('Set') });


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(148)('Map');


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(148)('Set');


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(148)('WeakMap');


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(148)('WeakSet');


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(149)('Map');


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(149)('Set');


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(149)('WeakMap');


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(149)('WeakSet');


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(9) });


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(9) });


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(51);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(311);
var fround = __webpack_require__(295);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(311) });


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(39);
var global = __webpack_require__(9);
var speciesConstructor = __webpack_require__(121);
var promiseResolve = __webpack_require__(301);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(208);
var perform = __webpack_require__(300);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(46);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(193);
var from = __webpack_require__(310);
var metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(46);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(46);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(68);
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(37);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(207)();
var process = __webpack_require__(9).process;
var isNode = __webpack_require__(51)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(9);
var core = __webpack_require__(39);
var microtask = __webpack_require__(207)();
var OBSERVABLE = __webpack_require__(19)('observable');
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(6);
var anInstance = __webpack_require__(89);
var redefineAll = __webpack_require__(88);
var hide = __webpack_require__(41);
var forOf = __webpack_require__(90);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(91)('Observable');


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(9);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(145);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(206);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(677);
module.exports = __webpack_require__(39).RegExp.escape;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(678)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(680)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(683);
var ReactElement = __webpack_require__(104);

var emptyFunction = __webpack_require__(61);
var traverseAllChildren = __webpack_require__(684);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(122);

var invariant = __webpack_require__(8);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(122);

var ReactCurrentOwner = __webpack_require__(69);
var REACT_ELEMENT_TYPE = __webpack_require__(316);

var getIteratorFn = __webpack_require__(685);
var invariant = __webpack_require__(8);
var KeyEscapeUtils = __webpack_require__(686);
var warning = __webpack_require__(14);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(104);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(104),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(317);

module.exports = factory(isValidElement);

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(210);
var assign = __webpack_require__(17);

var ReactPropTypesSecret = __webpack_require__(318);
var checkPropTypes = __webpack_require__(691);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(313),
    Component = _require.Component;

var _require2 = __webpack_require__(104),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(314);
var factory = __webpack_require__(694);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var emptyObject = __webpack_require__(150);
var _invariant = __webpack_require__(8);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(122);

var ReactElement = __webpack_require__(104);

var invariant = __webpack_require__(8);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(26);
var ReactDefaultInjection = __webpack_require__(697);
var ReactMount = __webpack_require__(343);
var ReactReconciler = __webpack_require__(106);
var ReactUpdates = __webpack_require__(62);
var ReactVersion = __webpack_require__(769);

var findDOMNode = __webpack_require__(770);
var getHostComponentFromComposite = __webpack_require__(344);
var renderSubtreeIntoContainer = __webpack_require__(771);
var warning = __webpack_require__(14);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(698);
var BeforeInputEventPlugin = __webpack_require__(699);
var ChangeEventPlugin = __webpack_require__(703);
var DefaultEventPluginOrder = __webpack_require__(706);
var EnterLeaveEventPlugin = __webpack_require__(707);
var HTMLDOMPropertyConfig = __webpack_require__(708);
var ReactComponentBrowserEnvironment = __webpack_require__(709);
var ReactDOMComponent = __webpack_require__(715);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactDOMEmptyComponent = __webpack_require__(740);
var ReactDOMTreeTraversal = __webpack_require__(741);
var ReactDOMTextComponent = __webpack_require__(742);
var ReactDefaultBatchingStrategy = __webpack_require__(743);
var ReactEventListener = __webpack_require__(744);
var ReactInjection = __webpack_require__(746);
var ReactReconcileTransaction = __webpack_require__(747);
var SVGDOMPropertyConfig = __webpack_require__(753);
var SelectEventPlugin = __webpack_require__(754);
var SimpleEventPlugin = __webpack_require__(755);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(123);
var ExecutionEnvironment = __webpack_require__(38);
var FallbackCompositionState = __webpack_require__(700);
var SyntheticCompositionEvent = __webpack_require__(701);
var SyntheticInputEvent = __webpack_require__(702);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var PooledClass = __webpack_require__(94);

var getTextContentAccessor = __webpack_require__(323);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(70);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(70);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(124);
var EventPropagators = __webpack_require__(123);
var ExecutionEnvironment = __webpack_require__(38);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactUpdates = __webpack_require__(62);
var SyntheticEvent = __webpack_require__(70);

var inputValueTracking = __webpack_require__(326);
var getEventTarget = __webpack_require__(214);
var isEventSupported = __webpack_require__(215);
var isTextInputElement = __webpack_require__(327);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(705);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(123);
var ReactDOMComponentTree = __webpack_require__(26);
var SyntheticMouseEvent = __webpack_require__(152);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(105);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(217);
var ReactDOMIDOperations = __webpack_require__(714);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var DOMLazyTree = __webpack_require__(107);
var ExecutionEnvironment = __webpack_require__(38);

var createNodesFromMarkup = __webpack_require__(711);
var emptyFunction = __webpack_require__(61);
var invariant = __webpack_require__(8);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(38);

var createArrayFromMixed = __webpack_require__(712);
var getMarkupWrap = __webpack_require__(713);
var invariant = __webpack_require__(8);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(8);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(38);

var invariant = __webpack_require__(8);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(217);
var ReactDOMComponentTree = __webpack_require__(26);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(17);

var AutoFocusUtils = __webpack_require__(716);
var CSSPropertyOperations = __webpack_require__(717);
var DOMLazyTree = __webpack_require__(107);
var DOMNamespaces = __webpack_require__(218);
var DOMProperty = __webpack_require__(105);
var DOMPropertyOperations = __webpack_require__(332);
var EventPluginHub = __webpack_require__(124);
var EventPluginRegistry = __webpack_require__(211);
var ReactBrowserEventEmitter = __webpack_require__(155);
var ReactDOMComponentFlags = __webpack_require__(320);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactDOMInput = __webpack_require__(727);
var ReactDOMOption = __webpack_require__(729);
var ReactDOMSelect = __webpack_require__(333);
var ReactDOMTextarea = __webpack_require__(730);
var ReactInstrumentation = __webpack_require__(55);
var ReactMultiChild = __webpack_require__(731);
var ReactServerRenderingTransaction = __webpack_require__(738);

var emptyFunction = __webpack_require__(61);
var escapeTextContentForBrowser = __webpack_require__(154);
var invariant = __webpack_require__(8);
var isEventSupported = __webpack_require__(215);
var shallowEqual = __webpack_require__(222);
var inputValueTracking = __webpack_require__(326);
var validateDOMNesting = __webpack_require__(226);
var warning = __webpack_require__(14);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(26);

var focusNode = __webpack_require__(330);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(331);
var ExecutionEnvironment = __webpack_require__(38);
var ReactInstrumentation = __webpack_require__(55);

var camelizeStyleName = __webpack_require__(718);
var dangerousStyleValue = __webpack_require__(720);
var hyphenateStyleName = __webpack_require__(721);
var memoizeStringOnly = __webpack_require__(723);
var warning = __webpack_require__(14);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(719);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(331);
var warning = __webpack_require__(14);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(722);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(154);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(124);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(38);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(17);

var DOMPropertyOperations = __webpack_require__(332);
var LinkedValueUtils = __webpack_require__(220);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactUpdates = __webpack_require__(62);

var invariant = __webpack_require__(8);
var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var React = __webpack_require__(103);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactDOMSelect = __webpack_require__(333);

var warning = __webpack_require__(14);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(17);

var LinkedValueUtils = __webpack_require__(220);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactUpdates = __webpack_require__(62);

var invariant = __webpack_require__(8);
var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactComponentEnvironment = __webpack_require__(221);
var ReactInstanceMap = __webpack_require__(126);
var ReactInstrumentation = __webpack_require__(55);

var ReactCurrentOwner = __webpack_require__(69);
var ReactReconciler = __webpack_require__(106);
var ReactChildReconciler = __webpack_require__(732);

var emptyFunction = __webpack_require__(61);
var flattenChildren = __webpack_require__(737);
var invariant = __webpack_require__(8);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(106);

var instantiateReactComponent = __webpack_require__(334);
var KeyEscapeUtils = __webpack_require__(224);
var shouldUpdateReactComponent = __webpack_require__(223);
var traverseAllChildren = __webpack_require__(338);
var warning = __webpack_require__(14);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(339);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(17);

var React = __webpack_require__(103);
var ReactComponentEnvironment = __webpack_require__(221);
var ReactCurrentOwner = __webpack_require__(69);
var ReactErrorUtils = __webpack_require__(213);
var ReactInstanceMap = __webpack_require__(126);
var ReactInstrumentation = __webpack_require__(55);
var ReactNodeTypes = __webpack_require__(335);
var ReactReconciler = __webpack_require__(106);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(150);
var invariant = __webpack_require__(8);
var shallowEqual = __webpack_require__(222);
var shouldUpdateReactComponent = __webpack_require__(223);
var warning = __webpack_require__(14);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(224);
var traverseAllChildren = __webpack_require__(338);
var warning = __webpack_require__(14);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(339);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var PooledClass = __webpack_require__(94);
var Transaction = __webpack_require__(151);
var ReactInstrumentation = __webpack_require__(55);
var ReactServerUpdateQueue = __webpack_require__(739);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(225);

var warning = __webpack_require__(14);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var DOMLazyTree = __webpack_require__(107);
var ReactDOMComponentTree = __webpack_require__(26);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(8);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(17);

var DOMChildrenOperations = __webpack_require__(217);
var DOMLazyTree = __webpack_require__(107);
var ReactDOMComponentTree = __webpack_require__(26);

var escapeTextContentForBrowser = __webpack_require__(154);
var invariant = __webpack_require__(8);
var validateDOMNesting = __webpack_require__(226);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var ReactUpdates = __webpack_require__(62);
var Transaction = __webpack_require__(151);

var emptyFunction = __webpack_require__(61);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var EventListener = __webpack_require__(340);
var ExecutionEnvironment = __webpack_require__(38);
var PooledClass = __webpack_require__(94);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactUpdates = __webpack_require__(62);

var getEventTarget = __webpack_require__(214);
var getUnboundedScrollPosition = __webpack_require__(745);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(105);
var EventPluginHub = __webpack_require__(124);
var EventPluginUtils = __webpack_require__(212);
var ReactComponentEnvironment = __webpack_require__(221);
var ReactEmptyComponent = __webpack_require__(336);
var ReactBrowserEventEmitter = __webpack_require__(155);
var ReactHostComponent = __webpack_require__(337);
var ReactUpdates = __webpack_require__(62);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(17);

var CallbackQueue = __webpack_require__(324);
var PooledClass = __webpack_require__(94);
var ReactBrowserEventEmitter = __webpack_require__(155);
var ReactInputSelection = __webpack_require__(341);
var ReactInstrumentation = __webpack_require__(55);
var Transaction = __webpack_require__(151);
var ReactUpdateQueue = __webpack_require__(225);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(38);

var getNodeForCharacterOffset = __webpack_require__(749);
var getTextContentAccessor = __webpack_require__(323);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(751);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(752);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(123);
var ExecutionEnvironment = __webpack_require__(38);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactInputSelection = __webpack_require__(341);
var SyntheticEvent = __webpack_require__(70);

var getActiveElement = __webpack_require__(342);
var isTextInputElement = __webpack_require__(327);
var shallowEqual = __webpack_require__(222);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var EventListener = __webpack_require__(340);
var EventPropagators = __webpack_require__(123);
var ReactDOMComponentTree = __webpack_require__(26);
var SyntheticAnimationEvent = __webpack_require__(756);
var SyntheticClipboardEvent = __webpack_require__(757);
var SyntheticEvent = __webpack_require__(70);
var SyntheticFocusEvent = __webpack_require__(758);
var SyntheticKeyboardEvent = __webpack_require__(759);
var SyntheticMouseEvent = __webpack_require__(152);
var SyntheticDragEvent = __webpack_require__(761);
var SyntheticTouchEvent = __webpack_require__(762);
var SyntheticTransitionEvent = __webpack_require__(763);
var SyntheticUIEvent = __webpack_require__(125);
var SyntheticWheelEvent = __webpack_require__(764);

var emptyFunction = __webpack_require__(61);
var getEventCharCode = __webpack_require__(227);
var invariant = __webpack_require__(8);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(70);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(70);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(125);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(125);

var getEventCharCode = __webpack_require__(227);
var getEventKey = __webpack_require__(760);
var getEventModifierState = __webpack_require__(216);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(227);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(152);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(125);

var getEventModifierState = __webpack_require__(216);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(70);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(152);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(226);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(768);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactCurrentOwner = __webpack_require__(69);
var ReactDOMComponentTree = __webpack_require__(26);
var ReactInstanceMap = __webpack_require__(126);

var getHostComponentFromComposite = __webpack_require__(344);
var invariant = __webpack_require__(8);
var warning = __webpack_require__(14);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(343);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fetch_ie8__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fetch_ie8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fetch_ie8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_es6_map__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_es6_set__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf_polyfill__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raf_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shims_for_IE__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shims_for_IE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__shims_for_IE__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mousetrap__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_preview_modal_wrapper__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_error_bar__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_wizard_container__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__App_css__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_buy_checkout_wrapper__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_buy_packs_wrapper__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_reprise_wizard__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__tracking_abTest__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__logic_utils_history__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__logic_condition_evo__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_contact_us__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_singup_modal__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_login_modal__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_OnboardingModal__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__manager_aliasManager__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_generation_loader_generation_loader__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__constants_ABTestConstants__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_components_buy_Upsell_EC_upsell_Ec__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_utils_abTestInstance__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_universal_cookie__ = __webpack_require__(97);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\App.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// import 'react-polyfill'
// Redux phase
// get the style.
// test
// import { Map } from 'immutable';
var cookies=new __WEBPACK_IMPORTED_MODULE_36_universal_cookie__["a" /* default */]();__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].initializeStore(__WEBPACK_IMPORTED_MODULE_13__globals__["b" /* store */]);window.ConditionsEvo=__WEBPACK_IMPORTED_MODULE_25__logic_condition_evo__["a" /* default */];window.lpApp=__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */];window.nbr_forced=0;window.lpw=__WEBPACK_IMPORTED_MODULE_22__logic_wording__["b" /* lpw */];window.repeated=false;var lpAb=new __WEBPACK_IMPORTED_MODULE_21__tracking_abTest__["a" /* default */]();var wizardxTestName=__WEBPACK_IMPORTED_MODULE_32__constants_ABTestConstants__["a" /* wizardxAbOptions */].testName,wizardxVarOld=__WEBPACK_IMPORTED_MODULE_32__constants_ABTestConstants__["a" /* wizardxAbOptions */].testVarOld,wizardxShareOld=__WEBPACK_IMPORTED_MODULE_32__constants_ABTestConstants__["a" /* wizardxAbOptions */].testShareOld;if(typeof lpAb!=='undefined'){// AB test wizardx
var _cookies=new __WEBPACK_IMPORTED_MODULE_36_universal_cookie__["a" /* default */]();// Making sure we're not overriding AB test variable in case
// user comes from wizardx
if(_cookies.get('X-Source')!=='S3-lp-prod-builds/wizardxs/wizard-lp'){lpAb.registerTest(wizardxTestName);lpAb.registerVar(wizardxVarOld,wizardxShareOld);window.wizardX=lpAb.getVar(wizardxTestName);}// Ab-Test Artisan Pricing with Cookies
Object(__WEBPACK_IMPORTED_MODULE_35__components_utils_abTestInstance__["a" /* setAbTestArtisanPricing */])();// AB Test for Extra Pack display on SAS/SARL/SASU/EURL
}var wizardApiPricing=new __WEBPACK_IMPORTED_MODULE_21__tracking_abTest__["a" /* default */]();if(typeof wizardApiPricing!=='undefined'){wizardApiPricing.registerFromCookie('wizard');}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.setShowOnboardingModal=function(){var isPayed=__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].isPayed;// Don't show onboarding when comming from wizardx
// @TODO remove when implemented on wizardx
var wizardxCookie=cookies.get('X-Source');if(wizardxCookie&&wizardxCookie.split('/').length>1&&wizardxCookie.split('/')[1]==='wizardxs')localStorage.setItem('userHasSeenOnboardingCoursier','true');var hasUserSeenOnboarding=JSON.parse(localStorage.getItem("userHasSeenOnboardingCoursier"));var shouldShowOnboarding=!hasUserSeenOnboarding&&!isPayed;if(shouldShowOnboarding){_this.setState({showOnboardingModal:true});}};_this.closeOnboardingModal=function(){_this.setState({showOnboardingModal:false});localStorage.setItem('userHasSeenOnboardingCoursier','true');localStorage.removeItem("onboardingCoursierStep");};_this.Aw=_this.Aw.bind(_this);Object(__WEBPACK_IMPORTED_MODULE_30__manager_aliasManager__["a" /* setCookieIfAlias */])();window.baseApp=_this;_this.app=0;_this.state={app:0,fullWidth:false,showOnboardingModal:false};__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].redux_subscribe(_this.Aw);return _this;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){// case of sidebar
function getElHeight(el){var positionInfo=el.getBoundingClientRect();return positionInfo.height;}var wizard=document.querySelector('.wizard');if(window.location.href.includes('paiement')||window.location.href.includes('checkout'))__WEBPACK_IMPORTED_MODULE_33__tracking_lpevents__["a" /* default */].register({checkoutVersion:'legacy'});__WEBPACK_IMPORTED_MODULE_24__logic_utils_history__["a" /* default */].history.listen(function(location,action){__WEBPACK_IMPORTED_MODULE_33__tracking_lpevents__["a" /* default */].trackGTMFunnel(location.pathname);});var asideList=document.querySelector('.forcing-summary ul');if(asideList)asideList.style.height=getElHeight(wizard)+'px';// Changing body class from forcing if it's normal
if(__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].isPayed){document.body.classList.add('wz-forcing');}this.setShowOnboardingModal();}},{key:'componentWillUpdate',value:function componentWillUpdate(){if(document.activeElement&&document.activeElement!==document.body&&document.activeElement.tagName&&(document.activeElement.tagName.toLowerCase()==='input'||document.activeElement.tagName.toLowerCase()==='select')){var h=Math.max(document.documentElement.clientHeight,window.innerHeight||0);var _document$activeEleme=document.activeElement.getBoundingClientRect(),top=_document$activeEleme.top;if(h-top<=150){window.scrollBy(0,200);}}}},{key:'Aw',value:function Aw(){if(__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].isPrerender===true)return;var ass=__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].getState().appstate;if(ass!==this.state.app)this.setState({app:ass});this.setState({fullWidth:__WEBPACK_IMPORTED_MODULE_13__globals__["b" /* store */].getState().contract.fullWidth});if(__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].getState().contract.fullWidth){document.body.classList.add('full-wizard');}this.forceUpdate();}},{key:'render',value:function render(){var reprise=__WEBPACK_IMPORTED_MODULE_13__globals__["b" /* store */].getState().contract.reprise_wizard;var showOnboardingModal=this.state.showOnboardingModal;var contractMetaId=__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].contractMetaId;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_13__globals__["b" /* store */]},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,reprise?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_reprise_wizard__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["c" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_24__logic_utils_history__["a" /* default */].history},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/contrats/:name/:id/paiement',component:__WEBPACK_IMPORTED_MODULE_17__components_buy_packs_wrapper__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].isPayed?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* Redirect */],{from:'/contrats/:name/:id/checkout',to:{pathname:"/contrats/:name/continuer/:id/",search:location.search}}):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/contrats/:name/:id/checkout',component:__WEBPACK_IMPORTED_MODULE_16__components_buy_checkout_wrapper__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_23__app_lp_app__["a" /* default */].isPayed?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* Redirect */],{from:'/contrats/:name/:id/expert-comptable',to:{pathname:"/contrats/:name/continuer/:id/",search:location.search}}):__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/contrats/:name/:id/expert-comptable',component:__WEBPACK_IMPORTED_MODULE_34__src_components_buy_Upsell_EC_upsell_Ec__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/contrats/:name/continuer/:id/:sectionId',component:__WEBPACK_IMPORTED_MODULE_14__components_wizard_container__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/contrats/:name/continuer/:id/',component:__WEBPACK_IMPORTED_MODULE_14__components_wizard_container__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/contrats/:name/creer/:sectionId',component:__WEBPACK_IMPORTED_MODULE_14__components_wizard_container__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* Redirect */],{from:'/contrats/:name/creer/',to:{pathname:"/contrats/:name/creer/1",search:location.search}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/contrats/:name/paiement',component:__WEBPACK_IMPORTED_MODULE_16__components_buy_checkout_wrapper__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/prerender_react/contract_output',component:__WEBPACK_IMPORTED_MODULE_11__components_preview_modal_wrapper__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Route */],{path:'/contrats/:name/:id/generation',component:__WEBPACK_IMPORTED_MODULE_31__components_generation_loader_generation_loader__["a" /* default */]}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_error_bar__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_contact_us__["a" /* LpContactUs */],null),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_login_modal__["a" /* LoginModal */],null),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_singup_modal__["a" /* SingupModal */],null),showOnboardingModal&&contractMetaId&&contractMetaId===302&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_OnboardingModal__["a" /* default */],{contractMetaId:contractMetaId,closeOnboardingModal:this.closeOnboardingModal})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);function contactezNous(){__WEBPACK_IMPORTED_MODULE_13__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__redux_actions_account_settings__["u" /* showContactUs */])(true));}// document.getElementById('footer-compact').setAttribute('style', "display: block");
// document.getElementById('partners-logos').setAttribute('style', "display: block");
// document.getElementById("contactez-nous").addEventListener("click", contactezNous);
// document.getElementById("contactez-nous-footer").addEventListener("click", contactezNous);
function login(){__WEBPACK_IMPORTED_MODULE_13__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__redux_actions_account_settings__["v" /* showLoginModal */])(true));}var connexionBtn=document.getElementById("connexion");if(connexionBtn){connexionBtn.addEventListener("click",login);}window.checkout_step='';window.onpopstate=function(event){if(event.state){if(event.state.checkout_step==='checkout'){__WEBPACK_IMPORTED_MODULE_13__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__redux_actions_checkout_operations__["G" /* ceTogglePack */])(false));}else if(event.state.checkout_step==='paiement'){__WEBPACK_IMPORTED_MODULE_13__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__redux_actions_checkout_operations__["G" /* ceTogglePack */])(true));}}};__WEBPACK_IMPORTED_MODULE_10_mousetrap___default.a.bind('g o d l d',function(){// Doing it the dirty way
console.log('here?');var t0=performance.now();while(document.querySelector('.btn.btn-next.on')&&document.querySelector('.btn.btn-next.on').innerText.toLowerCase()==='suivant'){document.querySelector('.btn.btn-next.on').click();}var t1=performance.now();console.log('GODLD TOOK ',t1-t0,' ms');});/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(775).polyfill();


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(32)))

/***/ }),
/* 776 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  // if __disableNativeFetch is set to true, the it will always polyfill fetch
  // with Ajax.
  if (!self.__disableNativeFetch && self.fetch) {
    return
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)

    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var list = this.map[name]
    if (!list) {
      list = []
      this.map[name] = list
    }
    list.push(value)
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    var values = this.map[normalizeName(name)]
    return values ? values[0] : null
  }

  Headers.prototype.getAll = function(name) {
    return this.map[normalizeName(name)] || []
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = [normalizeValue(value)]
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    Object.getOwnPropertyNames(this.map).forEach(function(name) {
      this.map[name].forEach(function(value) {
        callback.call(thisArg, value, name, this)
      }, this)
    }, this)
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    reader.readAsArrayBuffer(blob)
    return fileReaderReady(reader)
  }

  function readBlobAsText(blob, options) {
    var reader = new FileReader()
    var contentType = options.headers.map['content-type'] ? options.headers.map['content-type'].toString() : ''
    var regex = /charset\=[0-9a-zA-Z\-\_]*;?/
    var _charset = blob.type.match(regex) || contentType.match(regex)
    var args = [blob]

    if(_charset) {
      args.push(_charset[0].replace(/^charset\=/, '').replace(/;$/, ''))
    }

    reader.readAsText.apply(reader, args)
    return fileReaderReady(reader)
  }

  var support = {
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob();
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  function Body() {
    this.bodyUsed = false


    this._initBody = function(body, options) {
      this._bodyInit = body
      if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
        this._options = options
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (!body) {
        this._bodyText = ''
      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
        // Only support ArrayBuffers for POST method.
        // Receiving ArrayBuffers happens via Blobs, instead.
      } else {
        throw new Error('unsupported BodyInit type')
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        return this.blob().then(readBlobAsArrayBuffer)
      }

      this.text = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return readBlobAsText(this._bodyBlob, this._options)
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as text')
        } else {
          return Promise.resolve(this._bodyText)
        }
      }
    } else {
      this.text = function() {
        var rejected = consumed(this)
        return rejected ? rejected : Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body
    if (Request.prototype.isPrototypeOf(input)) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = input
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body, options)
  }

  Request.prototype.clone = function() {
    return new Request(this)
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function headers(xhr) {
    var head = new Headers()
    var pairs = xhr.getAllResponseHeaders().trim().split('\n')
    pairs.forEach(function(header) {
      var split = header.trim().split(':')
      var key = split.shift().trim()
      var value = split.join(':').trim()
      head.append(key, value)
    })
    return head
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this._initBody(bodyInit, options)
    this.type = 'default'
    this.status = options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = options.statusText
    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
    this.url = options.url || ''
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request
      if (Request.prototype.isPrototypeOf(input) && !init) {
        request = input
      } else {
        request = new Request(input, init)
      }

      var xhr = new XMLHttpRequest()

      function responseURL() {
        if ('responseURL' in xhr) {
          return xhr.responseURL
        }

        // Avoid security warnings on getResponseHeader when not allowed by CORS
        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
          return xhr.getResponseHeader('X-Request-URL')
        }

        return;
      }

      var __onLoadHandled = false;

      function onload() {
        if (xhr.readyState !== 4) {
          return
        }
        var status = (xhr.status === 1223) ? 204 : xhr.status
        if (status < 100 || status > 599) {
          if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
          reject(new TypeError('Network request failed'))
          return
        }
        var options = {
          status: status,
          statusText: xhr.statusText,
          headers: headers(xhr),
          url: responseURL()
        }
        var body = 'response' in xhr ? xhr.response : xhr.responseText;

        if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
        resolve(new Response(body, options))
      }
      xhr.onreadystatechange = onload;
      xhr.onload = onload;
      xhr.onerror = function() {
        if (__onLoadHandled) { return; } else { __onLoadHandled = true; }
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      // `withCredentials` should be setted after calling `.open` in IE10
      // http://stackoverflow.com/a/19667959/1219343
      try {
        if (request.credentials === 'include') {
          if ('withCredentials' in xhr) {
            xhr.withCredentials = true;
          } else {
            console && console.warn && console.warn('withCredentials is not supported, you can ignore this warning');
          }
        }
      } catch (e) {
        console && console.warn && console.warn('set withCredentials error:' + e);
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true

  // Support CommonJS
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = self.fetch;
  }
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};// function.name (all IE)
/*! @source http://stackoverflow.com/questions/6903762/function-name-not-supported-in-ie*/if(!Object.hasOwnProperty('name')){Object.defineProperty(Function.prototype,'name',{get:function get(){var matches=this.toString().match(/^\s*function\s*((?![0-9])[a-zA-Z0-9_$]*)\s*\(/);var name=matches&&matches.length>1?matches[1]:"";// For better performance only parse once, and then cache the
// result through a new accessor for repeated access.
Object.defineProperty(this,'name',{value:name});return name;}});}var self=window.self;// URL polyfill for SystemJS (all IE)
/*! @source https://github.com/ModuleLoader/es6-module-loader/blob/master/src/url-polyfill.js*/// from https://gist.github.com/Yaffle/1088850
(function(global){function URLPolyfill(url,baseURL){if(typeof url!='string'){throw new TypeError('URL must be a string');}var m=String(url).replace(/^\s+|\s+$/g,"").match(/^([^:\/?#]+:)?(?:\/\/(?:([^:@\/?#]*)(?::([^:@\/?#]*))?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);if(!m){throw new RangeError();}var protocol=m[1]||"";var username=m[2]||"";var password=m[3]||"";var host=m[4]||"";var hostname=m[5]||"";var port=m[6]||"";var pathname=m[7]||"";var search=m[8]||"";var hash=m[9]||"";if(baseURL!==undefined){var base=baseURL instanceof URLPolyfill?baseURL:new URLPolyfill(baseURL);var flag=protocol===""&&host===""&&username==="";if(flag&&pathname===""&&search===""){search=base.search;}if(flag&&pathname.charAt(0)!=="/"){pathname=pathname!==""?((base.host!==""||base.username!=="")&&base.pathname===""?"/":"")+base.pathname.slice(0,base.pathname.lastIndexOf("/")+1)+pathname:base.pathname;}// dot segments removal
var output=[];pathname.replace(/^(\.\.?(\/|$))+/,"").replace(/\/(\.(\/|$))+/g,"/").replace(/\/\.\.$/,"/../").replace(/\/?[^\/]*/g,function(p){if(p==="/.."){output.pop();}else{output.push(p);}});pathname=output.join("").replace(/^\//,pathname.charAt(0)==="/"?"/":"");if(flag){port=base.port;hostname=base.hostname;host=base.host;password=base.password;username=base.username;}if(protocol===""){protocol=base.protocol;}}// convert windows file URLs to use /
if(protocol=='file:')pathname=pathname.replace(/\\/g,'/');this.origin=protocol+(protocol!==""||host!==""?"//":"")+host;this.href=protocol+(protocol!==""||host!==""?"//":"")+(username!==""?username+(password!==""?":"+password:"")+"@":"")+host+pathname+search+hash;this.protocol=protocol;this.username=username;this.password=password;this.host=host;this.hostname=hostname;this.port=port;this.pathname=pathname;this.search=search;this.hash=hash;}global.URLPolyfill=URLPolyfill;})(typeof self!='undefined'?self:global);//classList (IE9)
/*! @license please refer to http://unlicense.org/ *//*! @author Eli Grey *//*! @source https://github.com/eligrey/classList.js */;if("document"in self&&!("classList"in document.createElement("_"))){(function(j){"use strict";if(!("Element"in j)){return;}var a="classList",f="prototype",m=j.Element[f],b=Object,k=String[f].trim||function(){return this.replace(/^\s+|\s+$/g,"");},c=Array[f].indexOf||function(q){var p=0,o=this.length;for(;p<o;p++){if(p in this&&this[p]===q){return p;}}return-1;},n=function n(o,p){this.name=o;this.code=DOMException[o];this.message=p;},g=function g(p,o){if(o===""){throw new n("SYNTAX_ERR","An invalid or illegal string was specified");}if(/\s/.test(o)){throw new n("INVALID_CHARACTER_ERR","String contains an invalid character");}return c.call(p,o);},d=function d(s){var r=k.call(s.getAttribute("class")||""),q=r?r.split(/\s+/):[],p=0,o=q.length;for(;p<o;p++){this.push(q[p]);}this._updateClassName=function(){s.setAttribute("class",this.toString());};},e=d[f]=[],i=function i(){return new d(this);};n[f]=Error[f];e.item=function(o){return this[o]||null;};e.contains=function(o){o+="";return g(this,o)!==-1;};e.add=function(){var s=arguments,r=0,p=s.length,q,o=false;do{q=s[r]+"";if(g(this,q)===-1){this.push(q);o=true;}}while(++r<p);if(o){this._updateClassName();}};e.remove=function(){var t=arguments,s=0,p=t.length,r,o=false;do{r=t[s]+"";var q=g(this,r);if(q!==-1){this.splice(q,1);o=true;}}while(++s<p);if(o){this._updateClassName();}};e.toggle=function(p,q){p+="";var o=this.contains(p),r=o?q!==true&&"remove":q!==false&&"add";if(r){this[r](p);}return!o;};e.toString=function(){return this.join(" ");};if(b.defineProperty){var l={get:i,enumerable:true,configurable:true};try{b.defineProperty(m,a,l);}catch(h){if(h.number===-2146823252){l.enumerable=false;b.defineProperty(m,a,l);}}}else{if(b[f].__defineGetter__){m.__defineGetter__(a,i);}}})(self);};//console mock (IE9)
if(!window.console)window.console={};if(!window.console.log)window.console.log=function(){};if(!window.console.error)window.console.error=function(){};if(!window.console.warn)window.console.warn=function(){};if(!window.console.assert)window.console.assert=function(){};//RequestAnimationFrame (IE9, Android 4.1, 4.2, 4.3)
/*! @author Paul Irish *//*! @source https://gist.github.com/paulirish/1579671 */// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
// MIT license
(function(){var lastTime=0;if(!window.requestAnimationFrame)window.requestAnimationFrame=function(callback,element){var currTime=Date.now();var timeToCall=Math.max(0,16-(currTime-lastTime));var id=window.setTimeout(function(){callback(currTime+timeToCall);},timeToCall);lastTime=currTime+timeToCall;return id;};if(!window.cancelAnimationFrame)window.cancelAnimationFrame=function(id){clearTimeout(id);};})();//Typed Array (IE9)
/*! @source https://github.com/inexorabletash/polyfill/blob/master/typedarray.js *//*
 Copyright (c) 2010, Linden Research, Inc.
 Copyright (c) 2014, Joshua Bell

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 $/LicenseInfo$
 */// Original can be found at:
//   https://bitbucket.org/lindenlab/llsd
// Modifications by Joshua Bell inexorabletash@gmail.com
//   https://github.com/inexorabletash/polyfill
// ES3/ES5 implementation of the Krhonos Typed Array Specification
//   Ref: http://www.khronos.org/registry/typedarray/specs/latest/
//   Date: 2011-02-01
//
// Variations:
//  * Allows typed_array.get/set() as alias for subscripts (typed_array[])
//  * Gradually migrating structure from Khronos spec to ES2015 spec
//
// Caveats:
//  * Beyond 10000 or so entries, polyfilled array accessors (ta[0],
//    etc) become memory-prohibitive, so array creation will fail. Set
//    self.TYPED_ARRAY_POLYFILL_NO_ARRAY_ACCESSORS=true to disable
//    creation of accessors. Your code will need to use the
//    non-standard get()/set() instead, and will need to add those to
//    native arrays for interop.
(function(global){'use strict';var undefined=void 0;// Paranoia
// Beyond this value, index getters/setters (i.e. array[0], array[1]) are so slow to
// create, and consume so much memory, that the browser appears frozen.
var MAX_ARRAY_LENGTH=1e5;// Approximations of internal ECMAScript conversion functions
function Type(v){switch(typeof v==='undefined'?'undefined':_typeof(v)){case'undefined':return'undefined';case'boolean':return'boolean';case'number':return'number';case'string':return'string';default:return v===null?'null':'object';}}// Class returns internal [[Class]] property, used to avoid cross-frame instanceof issues:
function Class(v){return Object.prototype.toString.call(v).replace(/^\[object *|\]$/g,'');}function IsCallable(o){return typeof o==='function';}function ToObject(v){if(v===null||v===undefined)throw TypeError();return Object(v);}function ToInt32(v){return v>>0;}function ToUint32(v){return v>>>0;}// Snapshot intrinsics
var LN2=Math.LN2,abs=Math.abs,floor=Math.floor,log=Math.log,max=Math.max,min=Math.min,pow=Math.pow,round=Math.round;// emulate ES5 getter/setter API using legacy APIs
// http://blogs.msdn.com/b/ie/archive/2010/09/07/transitioning-existing-code-to-the-es5-getter-setter-apis.aspx
// (second clause tests for Object.defineProperty() in IE<9 that only supports extending DOM prototypes, but
// note that IE<9 does not support __defineGetter__ or __defineSetter__ so it just renders the method harmless)
(function(){var orig=Object.defineProperty;var dom_only=!function(){try{return Object.defineProperty({},'x',{});}catch(_){return false;}}();if(!orig||dom_only){Object.defineProperty=function(o,prop,desc){// In IE8 try built-in implementation for defining properties on DOM prototypes.
if(orig)try{return orig(o,prop,desc);}catch(_){}if(o!==Object(o))throw TypeError('Object.defineProperty called on non-object');if(Object.prototype.__defineGetter__&&'get'in desc)Object.prototype.__defineGetter__.call(o,prop,desc.get);if(Object.prototype.__defineSetter__&&'set'in desc)Object.prototype.__defineSetter__.call(o,prop,desc.set);if('value'in desc)o[prop]=desc.value;return o;};}})();// ES5: Make obj[index] an alias for obj._getter(index)/obj._setter(index, value)
// for index in 0 ... obj.length
function makeArrayAccessors(obj){if('TYPED_ARRAY_POLYFILL_NO_ARRAY_ACCESSORS'in global)return;if(obj.length>MAX_ARRAY_LENGTH)throw RangeError('Array too large for polyfill');function makeArrayAccessor(index){Object.defineProperty(obj,index,{'get':function get(){return obj._getter(index);},'set':function set(v){obj._setter(index,v);},enumerable:true,configurable:false});}var i;for(i=0;i<obj.length;i+=1){makeArrayAccessor(i);}}// Internal conversion functions:
//    pack<Type>()   - take a number (interpreted as Type), output a byte array
//    unpack<Type>() - take a byte array, output a Type-like number
function as_signed(value,bits){var s=32-bits;return value<<s>>s;}function as_unsigned(value,bits){var s=32-bits;return value<<s>>>s;}function packI8(n){return[n&0xff];}function unpackI8(bytes){return as_signed(bytes[0],8);}function packU8(n){return[n&0xff];}function unpackU8(bytes){return as_unsigned(bytes[0],8);}function packU8Clamped(n){n=round(Number(n));return[n<0?0:n>0xff?0xff:n&0xff];}function packI16(n){return[n&0xff,n>>8&0xff];}function unpackI16(bytes){return as_signed(bytes[1]<<8|bytes[0],16);}function packU16(n){return[n&0xff,n>>8&0xff];}function unpackU16(bytes){return as_unsigned(bytes[1]<<8|bytes[0],16);}function packI32(n){return[n&0xff,n>>8&0xff,n>>16&0xff,n>>24&0xff];}function unpackI32(bytes){return as_signed(bytes[3]<<24|bytes[2]<<16|bytes[1]<<8|bytes[0],32);}function packU32(n){return[n&0xff,n>>8&0xff,n>>16&0xff,n>>24&0xff];}function unpackU32(bytes){return as_unsigned(bytes[3]<<24|bytes[2]<<16|bytes[1]<<8|bytes[0],32);}function packIEEE754(v,ebits,fbits){var bias=(1<<ebits-1)-1;function roundToEven(n){var w=floor(n),f=n-w;if(f<0.5)return w;if(f>0.5)return w+1;return w%2?w+1:w;}// Compute sign, exponent, fraction
var s,e,f;if(v!==v){// NaN
// http://dev.w3.org/2006/webapi/WebIDL/#es-type-mapping
e=(1<<ebits)-1;f=pow(2,fbits-1);s=0;}else if(v===Infinity||v===-Infinity){e=(1<<ebits)-1;f=0;s=v<0?1:0;}else if(v===0){e=0;f=0;s=1/v===-Infinity?1:0;}else{s=v<0;v=abs(v);if(v>=pow(2,1-bias)){// Normalized
e=min(floor(log(v)/LN2),1023);var significand=v/pow(2,e);if(significand<1){e-=1;significand*=2;}if(significand>=2){e+=1;significand/=2;}var d=pow(2,fbits);f=roundToEven(significand*d)-d;e+=bias;if(f/d>=1){e+=1;f=0;}if(e>2*bias){// Overflow
e=(1<<ebits)-1;f=0;}}else{// Denormalized
e=0;f=roundToEven(v/pow(2,1-bias-fbits));}}// Pack sign, exponent, fraction
var bits=[],i;for(i=fbits;i;i-=1){bits.push(f%2?1:0);f=floor(f/2);}for(i=ebits;i;i-=1){bits.push(e%2?1:0);e=floor(e/2);}bits.push(s?1:0);bits.reverse();var str=bits.join('');// Bits to bytes
var bytes=[];while(str.length){bytes.unshift(parseInt(str.substring(0,8),2));str=str.substring(8);}return bytes;}function unpackIEEE754(bytes,ebits,fbits){// Bytes to bits
var bits=[],i,j,b,str,bias,s,e,f;for(i=0;i<bytes.length;++i){b=bytes[i];for(j=8;j;j-=1){bits.push(b%2?1:0);b=b>>1;}}bits.reverse();str=bits.join('');// Unpack sign, exponent, fraction
bias=(1<<ebits-1)-1;s=parseInt(str.substring(0,1),2)?-1:1;e=parseInt(str.substring(1,1+ebits),2);f=parseInt(str.substring(1+ebits),2);// Produce number
if(e===(1<<ebits)-1){return f!==0?NaN:s*Infinity;}else if(e>0){// Normalized
return s*pow(2,e-bias)*(1+f/pow(2,fbits));}else if(f!==0){// Denormalized
return s*pow(2,-(bias-1))*(f/pow(2,fbits));}else{return s<0?-0:0;}}function unpackF64(b){return unpackIEEE754(b,11,52);}function packF64(v){return packIEEE754(v,11,52);}function unpackF32(b){return unpackIEEE754(b,8,23);}function packF32(v){return packIEEE754(v,8,23);}//
// 3 The ArrayBuffer Type
//
(function(){function ArrayBuffer(length){length=ToInt32(length);if(length<0)throw RangeError('ArrayBuffer size is not a small enough positive integer.');Object.defineProperty(this,'byteLength',{value:length});Object.defineProperty(this,'_bytes',{value:Array(length)});for(var i=0;i<length;i+=1){this._bytes[i]=0;}}global.ArrayBuffer=global.ArrayBuffer||ArrayBuffer;//
// 5 The Typed Array View Types
//
function $TypedArray$(){// %TypedArray% ( length )
if(!arguments.length||_typeof(arguments[0])!=='object'){return function(length){length=ToInt32(length);if(length<0)throw RangeError('length is not a small enough positive integer.');Object.defineProperty(this,'length',{value:length});Object.defineProperty(this,'byteLength',{value:length*this.BYTES_PER_ELEMENT});Object.defineProperty(this,'buffer',{value:new ArrayBuffer(this.byteLength)});Object.defineProperty(this,'byteOffset',{value:0});}.apply(this,arguments);}// %TypedArray% ( typedArray )
if(arguments.length>=1&&Type(arguments[0])==='object'&&arguments[0]instanceof $TypedArray$){return function(typedArray){if(this.constructor!==typedArray.constructor)throw TypeError();var byteLength=typedArray.length*this.BYTES_PER_ELEMENT;Object.defineProperty(this,'buffer',{value:new ArrayBuffer(byteLength)});Object.defineProperty(this,'byteLength',{value:byteLength});Object.defineProperty(this,'byteOffset',{value:0});Object.defineProperty(this,'length',{value:typedArray.length});for(var i=0;i<this.length;i+=1){this._setter(i,typedArray._getter(i));}}.apply(this,arguments);}// %TypedArray% ( array )
if(arguments.length>=1&&Type(arguments[0])==='object'&&!(arguments[0]instanceof $TypedArray$)&&!(arguments[0]instanceof ArrayBuffer||Class(arguments[0])==='ArrayBuffer')){return function(array){var byteLength=array.length*this.BYTES_PER_ELEMENT;Object.defineProperty(this,'buffer',{value:new ArrayBuffer(byteLength)});Object.defineProperty(this,'byteLength',{value:byteLength});Object.defineProperty(this,'byteOffset',{value:0});Object.defineProperty(this,'length',{value:array.length});for(var i=0;i<this.length;i+=1){var s=array[i];this._setter(i,Number(s));}}.apply(this,arguments);}// %TypedArray% ( buffer, byteOffset=0, length=undefined )
if(arguments.length>=1&&Type(arguments[0])==='object'&&(arguments[0]instanceof ArrayBuffer||Class(arguments[0])==='ArrayBuffer')){return function(buffer,byteOffset,length){byteOffset=ToUint32(byteOffset);if(byteOffset>buffer.byteLength)throw RangeError('byteOffset out of range');// The given byteOffset must be a multiple of the element
// size of the specific type, otherwise an exception is raised.
if(byteOffset%this.BYTES_PER_ELEMENT)throw RangeError('buffer length minus the byteOffset is not a multiple of the element size.');if(length===undefined){var byteLength=buffer.byteLength-byteOffset;if(byteLength%this.BYTES_PER_ELEMENT)throw RangeError('length of buffer minus byteOffset not a multiple of the element size');length=byteLength/this.BYTES_PER_ELEMENT;}else{length=ToUint32(length);byteLength=length*this.BYTES_PER_ELEMENT;}if(byteOffset+byteLength>buffer.byteLength)throw RangeError('byteOffset and length reference an area beyond the end of the buffer');Object.defineProperty(this,'buffer',{value:buffer});Object.defineProperty(this,'byteLength',{value:byteLength});Object.defineProperty(this,'byteOffset',{value:byteOffset});Object.defineProperty(this,'length',{value:length});}.apply(this,arguments);}// %TypedArray% ( all other argument combinations )
throw TypeError();}// Properties of the %TypedArray Instrinsic Object
// %TypedArray%.from ( source , mapfn=undefined, thisArg=undefined )
Object.defineProperty($TypedArray$,'from',{value:function value(iterable){return new this(iterable);}});// %TypedArray%.of ( ...items )
Object.defineProperty($TypedArray$,'of',{value:function value()/*...items*/{return new this(arguments);}});// %TypedArray%.prototype
var $TypedArrayPrototype$={};$TypedArray$.prototype=$TypedArrayPrototype$;// WebIDL: getter type (unsigned long index);
Object.defineProperty($TypedArray$.prototype,'_getter',{value:function value(index){if(arguments.length<1)throw SyntaxError('Not enough arguments');index=ToUint32(index);if(index>=this.length)return undefined;var bytes=[],i,o;for(i=0,o=this.byteOffset+index*this.BYTES_PER_ELEMENT;i<this.BYTES_PER_ELEMENT;i+=1,o+=1){bytes.push(this.buffer._bytes[o]);}return this._unpack(bytes);}});// NONSTANDARD: convenience alias for getter: type get(unsigned long index);
Object.defineProperty($TypedArray$.prototype,'get',{value:$TypedArray$.prototype._getter});// WebIDL: setter void (unsigned long index, type value);
Object.defineProperty($TypedArray$.prototype,'_setter',{value:function value(index,_value){if(arguments.length<2)throw SyntaxError('Not enough arguments');index=ToUint32(index);if(index>=this.length)return;var bytes=this._pack(_value),i,o;for(i=0,o=this.byteOffset+index*this.BYTES_PER_ELEMENT;i<this.BYTES_PER_ELEMENT;i+=1,o+=1){this.buffer._bytes[o]=bytes[i];}}});// get %TypedArray%.prototype.buffer
// get %TypedArray%.prototype.byteLength
// get %TypedArray%.prototype.byteOffset
// -- applied directly to the object in the constructor
// %TypedArray%.prototype.constructor
Object.defineProperty($TypedArray$.prototype,'constructor',{value:$TypedArray$});// %TypedArray%.prototype.copyWithin (target, start, end = this.length )
Object.defineProperty($TypedArray$.prototype,'copyWithin',{value:function value(target,start){var end=arguments[2];var o=ToObject(this);var lenVal=o.length;var len=ToUint32(lenVal);len=max(len,0);var relativeTarget=ToInt32(target);var to;if(relativeTarget<0)to=max(len+relativeTarget,0);else to=min(relativeTarget,len);var relativeStart=ToInt32(start);var from;if(relativeStart<0)from=max(len+relativeStart,0);else from=min(relativeStart,len);var relativeEnd;if(end===undefined)relativeEnd=len;else relativeEnd=ToInt32(end);var final;if(relativeEnd<0)final=max(len+relativeEnd,0);else final=min(relativeEnd,len);var count=min(final-from,len-to);var direction;if(from<to&&to<from+count){direction=-1;from=from+count-1;to=to+count-1;}else{direction=1;}while(count>0){o._setter(to,o._getter(from));from=from+direction;to=to+direction;count=count-1;}return o;}});// %TypedArray%.prototype.entries ( )
// -- defined in es6.js to shim browsers w/ native TypedArrays
// %TypedArray%.prototype.every ( callbackfn, thisArg = undefined )
Object.defineProperty($TypedArray$.prototype,'every',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var thisArg=arguments[1];for(var i=0;i<len;i++){if(!callbackfn.call(thisArg,t._getter(i),i,t))return false;}return true;}});// %TypedArray%.prototype.fill (value, start = 0, end = this.length )
Object.defineProperty($TypedArray$.prototype,'fill',{value:function value(_value2){var start=arguments[1],end=arguments[2];var o=ToObject(this);var lenVal=o.length;var len=ToUint32(lenVal);len=max(len,0);var relativeStart=ToInt32(start);var k;if(relativeStart<0)k=max(len+relativeStart,0);else k=min(relativeStart,len);var relativeEnd;if(end===undefined)relativeEnd=len;else relativeEnd=ToInt32(end);var final;if(relativeEnd<0)final=max(len+relativeEnd,0);else final=min(relativeEnd,len);while(k<final){o._setter(k,_value2);k+=1;}return o;}});// %TypedArray%.prototype.filter ( callbackfn, thisArg = undefined )
Object.defineProperty($TypedArray$.prototype,'filter',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var res=[];var thisp=arguments[1];for(var i=0;i<len;i++){var val=t._getter(i);// in case fun mutates this
if(callbackfn.call(thisp,val,i,t))res.push(val);}return new this.constructor(res);}});// %TypedArray%.prototype.find (predicate, thisArg = undefined)
Object.defineProperty($TypedArray$.prototype,'find',{value:function value(predicate){var o=ToObject(this);var lenValue=o.length;var len=ToUint32(lenValue);if(!IsCallable(predicate))throw TypeError();var t=arguments.length>1?arguments[1]:undefined;var k=0;while(k<len){var kValue=o._getter(k);var testResult=predicate.call(t,kValue,k,o);if(Boolean(testResult))return kValue;++k;}return undefined;}});// %TypedArray%.prototype.findIndex ( predicate, thisArg = undefined )
Object.defineProperty($TypedArray$.prototype,'findIndex',{value:function value(predicate){var o=ToObject(this);var lenValue=o.length;var len=ToUint32(lenValue);if(!IsCallable(predicate))throw TypeError();var t=arguments.length>1?arguments[1]:undefined;var k=0;while(k<len){var kValue=o._getter(k);var testResult=predicate.call(t,kValue,k,o);if(Boolean(testResult))return k;++k;}return-1;}});// %TypedArray%.prototype.forEach ( callbackfn, thisArg = undefined )
Object.defineProperty($TypedArray$.prototype,'forEach',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var thisp=arguments[1];for(var i=0;i<len;i++){callbackfn.call(thisp,t._getter(i),i,t);}}});// %TypedArray%.prototype.indexOf (searchElement, fromIndex = 0 )
Object.defineProperty($TypedArray$.prototype,'indexOf',{value:function value(searchElement){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(len===0)return-1;var n=0;if(arguments.length>0){n=Number(arguments[1]);if(n!==n){n=0;}else if(n!==0&&n!==1/0&&n!==-(1/0)){n=(n>0||-1)*floor(abs(n));}}if(n>=len)return-1;var k=n>=0?n:max(len-abs(n),0);for(;k<len;k++){if(t._getter(k)===searchElement){return k;}}return-1;}});// %TypedArray%.prototype.join ( separator )
Object.defineProperty($TypedArray$.prototype,'join',{value:function value(separator){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);var tmp=Array(len);for(var i=0;i<len;++i){tmp[i]=t._getter(i);}return tmp.join(separator===undefined?',':separator);// Hack for IE7
}});// %TypedArray%.prototype.keys ( )
// -- defined in es6.js to shim browsers w/ native TypedArrays
// %TypedArray%.prototype.lastIndexOf ( searchElement, fromIndex = this.length-1 )
Object.defineProperty($TypedArray$.prototype,'lastIndexOf',{value:function value(searchElement){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(len===0)return-1;var n=len;if(arguments.length>1){n=Number(arguments[1]);if(n!==n){n=0;}else if(n!==0&&n!==1/0&&n!==-(1/0)){n=(n>0||-1)*floor(abs(n));}}var k=n>=0?min(n,len-1):len-abs(n);for(;k>=0;k--){if(t._getter(k)===searchElement)return k;}return-1;}});// get %TypedArray%.prototype.length
// -- applied directly to the object in the constructor
// %TypedArray%.prototype.map ( callbackfn, thisArg = undefined )
Object.defineProperty($TypedArray$.prototype,'map',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var res=[];res.length=len;var thisp=arguments[1];for(var i=0;i<len;i++){res[i]=callbackfn.call(thisp,t._getter(i),i,t);}return new this.constructor(res);}});// %TypedArray%.prototype.reduce ( callbackfn [, initialValue] )
Object.defineProperty($TypedArray$.prototype,'reduce',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();// no value to return if no initial value and an empty array
if(len===0&&arguments.length===1)throw TypeError();var k=0;var accumulator;if(arguments.length>=2){accumulator=arguments[1];}else{accumulator=t._getter(k++);}while(k<len){accumulator=callbackfn.call(undefined,accumulator,t._getter(k),k,t);k++;}return accumulator;}});// %TypedArray%.prototype.reduceRight ( callbackfn [, initialValue] )
Object.defineProperty($TypedArray$.prototype,'reduceRight',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();// no value to return if no initial value, empty array
if(len===0&&arguments.length===1)throw TypeError();var k=len-1;var accumulator;if(arguments.length>=2){accumulator=arguments[1];}else{accumulator=t._getter(k--);}while(k>=0){accumulator=callbackfn.call(undefined,accumulator,t._getter(k),k,t);k--;}return accumulator;}});// %TypedArray%.prototype.reverse ( )
Object.defineProperty($TypedArray$.prototype,'reverse',{value:function value(){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);var half=floor(len/2);for(var i=0,j=len-1;i<half;++i,--j){var tmp=t._getter(i);t._setter(i,t._getter(j));t._setter(j,tmp);}return t;}});// %TypedArray%.prototype.set(array, offset = 0 )
// %TypedArray%.prototype.set(typedArray, offset = 0 )
// WebIDL: void set(TypedArray array, optional unsigned long offset);
// WebIDL: void set(sequence<type> array, optional unsigned long offset);
Object.defineProperty($TypedArray$.prototype,'set',{value:function value(index,_value3){if(arguments.length<1)throw SyntaxError('Not enough arguments');var array,sequence,offset,len,i,s,d,byteOffset,byteLength,tmp;if(_typeof(arguments[0])==='object'&&arguments[0].constructor===this.constructor){// void set(TypedArray array, optional unsigned long offset);
array=arguments[0];offset=ToUint32(arguments[1]);if(offset+array.length>this.length){throw RangeError('Offset plus length of array is out of range');}byteOffset=this.byteOffset+offset*this.BYTES_PER_ELEMENT;byteLength=array.length*this.BYTES_PER_ELEMENT;if(array.buffer===this.buffer){tmp=[];for(i=0,s=array.byteOffset;i<byteLength;i+=1,s+=1){tmp[i]=array.buffer._bytes[s];}for(i=0,d=byteOffset;i<byteLength;i+=1,d+=1){this.buffer._bytes[d]=tmp[i];}}else{for(i=0,s=array.byteOffset,d=byteOffset;i<byteLength;i+=1,s+=1,d+=1){this.buffer._bytes[d]=array.buffer._bytes[s];}}}else if(_typeof(arguments[0])==='object'&&typeof arguments[0].length!=='undefined'){// void set(sequence<type> array, optional unsigned long offset);
sequence=arguments[0];len=ToUint32(sequence.length);offset=ToUint32(arguments[1]);if(offset+len>this.length){throw RangeError('Offset plus length of array is out of range');}for(i=0;i<len;i+=1){s=sequence[i];this._setter(offset+i,Number(s));}}else{throw TypeError('Unexpected argument type(s)');}}});// %TypedArray%.prototype.slice ( start, end )
Object.defineProperty($TypedArray$.prototype,'slice',{value:function value(start,end){var o=ToObject(this);var lenVal=o.length;var len=ToUint32(lenVal);var relativeStart=ToInt32(start);var k=relativeStart<0?max(len+relativeStart,0):min(relativeStart,len);var relativeEnd=end===undefined?len:ToInt32(end);var final=relativeEnd<0?max(len+relativeEnd,0):min(relativeEnd,len);var count=final-k;var c=o.constructor;var a=new c(count);var n=0;while(k<final){var kValue=o._getter(k);a._setter(n,kValue);++k;++n;}return a;}});// %TypedArray%.prototype.some ( callbackfn, thisArg = undefined )
Object.defineProperty($TypedArray$.prototype,'some',{value:function value(callbackfn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);if(!IsCallable(callbackfn))throw TypeError();var thisp=arguments[1];for(var i=0;i<len;i++){if(callbackfn.call(thisp,t._getter(i),i,t)){return true;}}return false;}});// %TypedArray%.prototype.sort ( comparefn )
Object.defineProperty($TypedArray$.prototype,'sort',{value:function value(comparefn){if(this===undefined||this===null)throw TypeError();var t=Object(this);var len=ToUint32(t.length);var tmp=Array(len);for(var i=0;i<len;++i){tmp[i]=t._getter(i);}if(comparefn)tmp.sort(comparefn);else tmp.sort();// Hack for IE8/9
for(i=0;i<len;++i){t._setter(i,tmp[i]);}return t;}});// %TypedArray%.prototype.subarray(begin = 0, end = this.length )
// WebIDL: TypedArray subarray(long begin, optional long end);
Object.defineProperty($TypedArray$.prototype,'subarray',{value:function value(start,end){function clamp(v,min,max){return v<min?min:v>max?max:v;}start=ToInt32(start);end=ToInt32(end);if(arguments.length<1){start=0;}if(arguments.length<2){end=this.length;}if(start<0){start=this.length+start;}if(end<0){end=this.length+end;}start=clamp(start,0,this.length);end=clamp(end,0,this.length);var len=end-start;if(len<0){len=0;}return new this.constructor(this.buffer,this.byteOffset+start*this.BYTES_PER_ELEMENT,len);}});// %TypedArray%.prototype.toLocaleString ( )
// %TypedArray%.prototype.toString ( )
// %TypedArray%.prototype.values ( )
// %TypedArray%.prototype [ @@iterator ] ( )
// get %TypedArray%.prototype [ @@toStringTag ]
// -- defined in es6.js to shim browsers w/ native TypedArrays
function makeTypedArray(elementSize,pack,unpack){// Each TypedArray type requires a distinct constructor instance with
// identical logic, which this produces.
var TypedArray=function TypedArray(){Object.defineProperty(this,'constructor',{value:TypedArray});$TypedArray$.apply(this,arguments);makeArrayAccessors(this);};if('__proto__'in TypedArray){TypedArray.__proto__=$TypedArray$;}else{TypedArray.from=$TypedArray$.from;TypedArray.of=$TypedArray$.of;}TypedArray.BYTES_PER_ELEMENT=elementSize;var TypedArrayPrototype=function TypedArrayPrototype(){};TypedArrayPrototype.prototype=$TypedArrayPrototype$;TypedArray.prototype=new TypedArrayPrototype();Object.defineProperty(TypedArray.prototype,'BYTES_PER_ELEMENT',{value:elementSize});Object.defineProperty(TypedArray.prototype,'_pack',{value:pack});Object.defineProperty(TypedArray.prototype,'_unpack',{value:unpack});return TypedArray;}var Int8Array=makeTypedArray(1,packI8,unpackI8);var Uint8Array=makeTypedArray(1,packU8,unpackU8);var Uint8ClampedArray=makeTypedArray(1,packU8Clamped,unpackU8);var Int16Array=makeTypedArray(2,packI16,unpackI16);var Uint16Array=makeTypedArray(2,packU16,unpackU16);var Int32Array=makeTypedArray(4,packI32,unpackI32);var Uint32Array=makeTypedArray(4,packU32,unpackU32);var Float32Array=makeTypedArray(4,packF32,unpackF32);var Float64Array=makeTypedArray(8,packF64,unpackF64);global.Int8Array=global.Int8Array||Int8Array;global.Uint8Array=global.Uint8Array||Uint8Array;global.Uint8ClampedArray=global.Uint8ClampedArray||Uint8ClampedArray;global.Int16Array=global.Int16Array||Int16Array;global.Uint16Array=global.Uint16Array||Uint16Array;global.Int32Array=global.Int32Array||Int32Array;global.Uint32Array=global.Uint32Array||Uint32Array;global.Float32Array=global.Float32Array||Float32Array;global.Float64Array=global.Float64Array||Float64Array;})();//
// 6 The DataView View Type
//
(function(){function r(array,index){return IsCallable(array.get)?array.get(index):array[index];}var IS_BIG_ENDIAN=function(){var u16array=new Uint16Array([0x1234]),u8array=new Uint8Array(u16array.buffer);return r(u8array,0)===0x12;}();// DataView(buffer, byteOffset=0, byteLength=undefined)
// WebIDL: Constructor(ArrayBuffer buffer,
//                     optional unsigned long byteOffset,
//                     optional unsigned long byteLength)
function DataView(buffer,byteOffset,byteLength){if(!(buffer instanceof ArrayBuffer||Class(buffer)==='ArrayBuffer'))throw TypeError();byteOffset=ToUint32(byteOffset);if(byteOffset>buffer.byteLength)throw RangeError('byteOffset out of range');if(byteLength===undefined)byteLength=buffer.byteLength-byteOffset;else byteLength=ToUint32(byteLength);if(byteOffset+byteLength>buffer.byteLength)throw RangeError('byteOffset and length reference an area beyond the end of the buffer');Object.defineProperty(this,'buffer',{value:buffer});Object.defineProperty(this,'byteLength',{value:byteLength});Object.defineProperty(this,'byteOffset',{value:byteOffset});};// get DataView.prototype.buffer
// get DataView.prototype.byteLength
// get DataView.prototype.byteOffset
// -- applied directly to instances by the constructor
function makeGetter(arrayType){return function GetViewValue(byteOffset,littleEndian){byteOffset=ToUint32(byteOffset);if(byteOffset+arrayType.BYTES_PER_ELEMENT>this.byteLength)throw RangeError('Array index out of range');byteOffset+=this.byteOffset;var uint8Array=new Uint8Array(this.buffer,byteOffset,arrayType.BYTES_PER_ELEMENT),bytes=[];for(var i=0;i<arrayType.BYTES_PER_ELEMENT;i+=1){bytes.push(r(uint8Array,i));}if(Boolean(littleEndian)===Boolean(IS_BIG_ENDIAN))bytes.reverse();return r(new arrayType(new Uint8Array(bytes).buffer),0);};}Object.defineProperty(DataView.prototype,'getUint8',{value:makeGetter(Uint8Array)});Object.defineProperty(DataView.prototype,'getInt8',{value:makeGetter(Int8Array)});Object.defineProperty(DataView.prototype,'getUint16',{value:makeGetter(Uint16Array)});Object.defineProperty(DataView.prototype,'getInt16',{value:makeGetter(Int16Array)});Object.defineProperty(DataView.prototype,'getUint32',{value:makeGetter(Uint32Array)});Object.defineProperty(DataView.prototype,'getInt32',{value:makeGetter(Int32Array)});Object.defineProperty(DataView.prototype,'getFloat32',{value:makeGetter(Float32Array)});Object.defineProperty(DataView.prototype,'getFloat64',{value:makeGetter(Float64Array)});function makeSetter(arrayType){return function SetViewValue(byteOffset,value,littleEndian){byteOffset=ToUint32(byteOffset);if(byteOffset+arrayType.BYTES_PER_ELEMENT>this.byteLength)throw RangeError('Array index out of range');// Get bytes
var typeArray=new arrayType([value]),byteArray=new Uint8Array(typeArray.buffer),bytes=[],i,byteView;for(i=0;i<arrayType.BYTES_PER_ELEMENT;i+=1){bytes.push(r(byteArray,i));}// Flip if necessary
if(Boolean(littleEndian)===Boolean(IS_BIG_ENDIAN))bytes.reverse();// Write them
byteView=new Uint8Array(this.buffer,byteOffset,arrayType.BYTES_PER_ELEMENT);byteView.set(bytes);};}Object.defineProperty(DataView.prototype,'setUint8',{value:makeSetter(Uint8Array)});Object.defineProperty(DataView.prototype,'setInt8',{value:makeSetter(Int8Array)});Object.defineProperty(DataView.prototype,'setUint16',{value:makeSetter(Uint16Array)});Object.defineProperty(DataView.prototype,'setInt16',{value:makeSetter(Int16Array)});Object.defineProperty(DataView.prototype,'setUint32',{value:makeSetter(Uint32Array)});Object.defineProperty(DataView.prototype,'setInt32',{value:makeSetter(Int32Array)});Object.defineProperty(DataView.prototype,'setFloat32',{value:makeSetter(Float32Array)});Object.defineProperty(DataView.prototype,'setFloat64',{value:makeSetter(Float64Array)});global.DataView=global.DataView||DataView;})();})(self);//Blob (IE9)
/*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js *//* Blob.js
 * A Blob implementation.
 * 2014-07-24
 *
 * By Eli Grey, http://eligrey.com
 * By Devin Samarin, https://github.com/dsamarin
 * License: MIT
 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
 *//*global self, unescape *//*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
 plusplus: true *//*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */(function(view){"use strict";view.URL=view.URL||view.webkitURL;if(view.Blob&&view.URL){try{new Blob();return;}catch(e){}}// Internally we use a BlobBuilder implementation to base Blob off of
// in order to support older browsers that only have BlobBuilder
var BlobBuilder=view.BlobBuilder||view.WebKitBlobBuilder||view.MozBlobBuilder||function(view){var get_class=function get_class(object){return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];},FakeBlobBuilder=function BlobBuilder(){this.data=[];},FakeBlob=function Blob(data,type,encoding){this.data=data;this.size=data.length;this.type=type;this.encoding=encoding;},FBB_proto=FakeBlobBuilder.prototype,FB_proto=FakeBlob.prototype,FileReaderSync=view.FileReaderSync,FileException=function FileException(type){this.code=this[this.name=type];},file_ex_codes=("NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR "+"NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR").split(" "),file_ex_code=file_ex_codes.length,real_URL=view.URL||view.webkitURL||view,real_create_object_URL=real_URL.createObjectURL,real_revoke_object_URL=real_URL.revokeObjectURL,URL=real_URL,btoa=view.btoa,atob=view.atob,ArrayBuffer=view.ArrayBuffer,Uint8Array=view.Uint8Array,origin=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;FakeBlob.fake=FB_proto.fake=true;while(file_ex_code--){FileException.prototype[file_ex_codes[file_ex_code]]=file_ex_code+1;}// Polyfill URL
if(!real_URL.createObjectURL){URL=view.URL=function(uri){var uri_info=document.createElementNS("http://www.w3.org/1999/xhtml","a"),uri_origin;uri_info.href=uri;if(!("origin"in uri_info)){if(uri_info.protocol.toLowerCase()==="data:"){uri_info.origin=null;}else{uri_origin=uri.match(origin);uri_info.origin=uri_origin&&uri_origin[1];}}return uri_info;};}URL.createObjectURL=function(blob){var type=blob.type,data_URI_header;if(type===null){type="application/octet-stream";}if(blob instanceof FakeBlob){data_URI_header="data:"+type;if(blob.encoding==="base64"){return data_URI_header+";base64,"+blob.data;}else if(blob.encoding==="URI"){return data_URI_header+","+decodeURIComponent(blob.data);}if(btoa){return data_URI_header+";base64,"+btoa(blob.data);}else{return data_URI_header+","+encodeURIComponent(blob.data);}}else if(real_create_object_URL){return real_create_object_URL.call(real_URL,blob);}};URL.revokeObjectURL=function(object_URL){if(object_URL.substring(0,5)!=="data:"&&real_revoke_object_URL){real_revoke_object_URL.call(real_URL,object_URL);}};FBB_proto.append=function(data/*, endings*/){var bb=this.data;// decode data to a binary string
if(Uint8Array&&(data instanceof ArrayBuffer||data instanceof Uint8Array)){var str="",buf=new Uint8Array(data),i=0,buf_len=buf.length;for(;i<buf_len;i++){str+=String.fromCharCode(buf[i]);}bb.push(str);}else if(get_class(data)==="Blob"||get_class(data)==="File"){if(FileReaderSync){var fr=new FileReaderSync();bb.push(fr.readAsBinaryString(data));}else{// async FileReader won't work as BlobBuilder is sync
throw new FileException("NOT_READABLE_ERR");}}else if(data instanceof FakeBlob){if(data.encoding==="base64"&&atob){bb.push(atob(data.data));}else if(data.encoding==="URI"){bb.push(decodeURIComponent(data.data));}else if(data.encoding==="raw"){bb.push(data.data);}}else{if(typeof data!=="string"){data+="";// convert unsupported types to strings
}// decode UTF-16 to binary string
bb.push(unescape(encodeURIComponent(data)));}};FBB_proto.getBlob=function(type){if(!arguments.length){type=null;}return new FakeBlob(this.data.join(""),type,"raw");};FBB_proto.toString=function(){return"[object BlobBuilder]";};FB_proto.slice=function(start,end,type){var args=arguments.length;if(args<3){type=null;}return new FakeBlob(this.data.slice(start,args>1?end:this.data.length),type,this.encoding);};FB_proto.toString=function(){return"[object Blob]";};FB_proto.close=function(){this.size=0;delete this.data;};return FakeBlobBuilder;}(view);view.Blob=function(blobParts,options){var type=options?options.type||"":"";var builder=new BlobBuilder();if(blobParts){for(var i=0,len=blobParts.length;i<len;i++){if(Uint8Array&&blobParts[i]instanceof Uint8Array){builder.append(blobParts[i].buffer);}else{builder.append(blobParts[i]);}}}var blob=builder.getBlob(type);if(!blob.slice&&blob.webkitSlice){blob.slice=blob.webkitSlice;}return blob;};var getPrototypeOf=Object.getPrototypeOf||function(object){return object.__proto__;};view.Blob.prototype=getPrototypeOf(new view.Blob());})(typeof self!=="undefined"&&self||typeof window!=="undefined"&&window||this.content||this);//FormData (IE9)
/*! @source https://github.com/francois2metz/html5-formdata/blob/master/formdata.js *//**
 * Emulate FormData for some browsers
 * MIT License
 * (c) 2010 François de Metz
 */(function(w){if(w.FormData)return;function FormData(){this.fake=true;this.boundary="--------FormData"+Math.random();this._fields=[];}FormData.prototype.append=function(key,value){this._fields.push([key,value]);};FormData.prototype.toString=function(){var boundary=this.boundary;var body="";this._fields.forEach(function(field){body+="--"+boundary+"\r\n";// file upload
if(field[1].name){var file=field[1];body+="Content-Disposition: form-data; name=\""+field[0]+"\"; filename=\""+file.name+"\"\r\n";body+="Content-Type: "+file.type+"\r\n\r\n";body+=file.getAsBinary()+"\r\n";}else{body+="Content-Disposition: form-data; name=\""+field[0]+"\";\r\n\r\n";body+=field[1]+"\r\n";}});body+="--"+boundary+"--";return body;};w.FormData=FormData;})(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(228);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(318);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(228);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(786);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(229);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(345);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(790);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(792);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(349);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(794);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(229);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(796);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(230);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(349);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(230);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(800);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(347);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(231);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(210);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(826);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(358);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(813);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(811);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(355);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(815);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(819);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32), __webpack_require__(818)(module)))

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(356);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(357);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(358);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(359);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(827);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(231);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.3
 * @url craig.is/killing/mice
 */
(function(window, document, undefined) {

    // Check if mousetrap is used inside browser, if not, return
    if (!window) {
        return;
    }

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };

    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */
    var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111 : '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };

    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */
    var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };

    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */
    var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };

    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */
    var _REVERSE_MAP;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {

        // This needs to use a string cause otherwise since 0 is falsey
        // mousetrap will never fire for numpad 0 pressed as part of a keydown
        // event.
        //
        // @see https://github.com/ccampbell/mousetrap/pull/258
        _MAP[i + 96] = i.toString();
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    function _belongsTo(element, ancestor) {
        if (element === null || element === document) {
            return false;
        }

        if (element === ancestor) {
            return true;
        }

        return _belongsTo(element.parentNode, ancestor);
    }

    function Mousetrap(targetElement) {
        var self = this;

        targetElement = targetElement || document;

        if (!(self instanceof Mousetrap)) {
            return new Mousetrap(targetElement);
        }

        /**
         * element to attach key events to
         *
         * @type {Element}
         */
        self.target = targetElement;

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        self._callbacks = {};

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        self._directMap = {};

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        var _sequenceLevels = {};

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        var _resetTimer;

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        var _ignoreNextKeyup = false;

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        var _ignoreNextKeypress = false;

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        var _nextExpectedAction = false;

        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */
        function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};

            var activeSequences = false,
                key;

            for (key in _sequenceLevels) {
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }

            if (!activeSequences) {
                _nextExpectedAction = false;
            }
        }

        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */
        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;

            // if there are no events related to this keycode
            if (!self._callbacks[character]) {
                return [];
            }

            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) {
                modifiers = [character];
            }

            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for (i = 0; i < self._callbacks[character].length; ++i) {
                callback = self._callbacks[character][i];

                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                    continue;
                }

                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) {
                    continue;
                }

                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {

                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) {
                        self._callbacks[character].splice(i, 1);
                    }

                    matches.push(callback);
                }
            }

            return matches;
        }

        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */
        function _fireCallback(callback, e, combo, sequence) {

            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
                return;
            }

            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }

        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */
        self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;

            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for (i = 0; i < callbacks.length; ++i) {
                if (callbacks[i].seq) {
                    maxLevel = Math.max(maxLevel, callbacks[i].level);
                }
            }

            // loop through matching callbacks for this key event
            for (i = 0; i < callbacks.length; ++i) {

                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {

                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) {
                        continue;
                    }

                    processedSequenceCallback = true;

                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }

                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) {
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
                }
            }

            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
                _resetSequences(doNotReset);
            }

            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };

        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */
        function _handleKeyEvent(e) {

            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') {
                e.which = e.keyCode;
            }

            var character = _characterFromEvent(e);

            // no character found then stop
            if (!character) {
                return;
            }

            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }

            self.handleKey(character, _eventModifiers(e), e);
        }

        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */
        function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }

        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */
        function _bindSequence(combo, keys, callback, action) {

            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;

            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */
            function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }

            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */
            function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);

                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') {
                    _ignoreNextKeyup = _characterFromEvent(e);
                }

                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }

            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for (var i = 0; i < keys.length; ++i) {
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }

        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */
        function _bindSingle(combination, callback, action, sequenceName, level) {

            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;

            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');

            var sequence = combination.split(' ');
            var info;

            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }

            info = _getKeyInfo(combination, action);

            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];

            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);

            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }

        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */
        self._bindMultiple = function(combinations, callback, action) {
            for (var i = 0; i < combinations.length; ++i) {
                _bindSingle(combinations[i], callback, action);
            }
        };

        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }

    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */
    Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [keys];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };

    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */
    Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };

    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */
    Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) {
            self._directMap[keys + ':' + action]({}, keys);
        }
        return self;
    };

    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */
    Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };

    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */
    Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;

        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
            return false;
        }

        if (_belongsTo(element, self.target)) {
            return false;
        }

        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) {
                element = initialEventTarget;
            }
        }

        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };

    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */
    Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };

    /**
     * allow custom key mappings
     */
    Mousetrap.addKeycodes = function(object) {
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                _MAP[key] = object[key];
            }
        }
        _REVERSE_MAP = null;
    };

    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */
    Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document);
        for (var method in documentMousetrap) {
            if (method.charAt(0) !== '_') {
                Mousetrap[method] = (function(method) {
                    return function() {
                        return documentMousetrap[method].apply(documentMousetrap, arguments);
                    };
                } (method));
            }
        }
    };

    Mousetrap.init();

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose as a common js module
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = Mousetrap;
    }

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            return Mousetrap;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prerender__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PreviewModalWrapper=function(_Component){_inherits(PreviewModalWrapper,_Component);function PreviewModalWrapper(props){_classCallCheck(this,PreviewModalWrapper);var _this=_possibleConstructorReturn(this,(PreviewModalWrapper.__proto__||Object.getPrototypeOf(PreviewModalWrapper)).call(this,props));var _queryString$parse=__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.parse(_this.props.location.search),uniqid=_queryString$parse.uniqid,doc=_queryString$parse.doc;__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].callbacks.setupInitialCallbacks();__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].mainPrerender(uniqid,doc);return _this;}_createClass(PreviewModalWrapper,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_3__globals__["b" /* store */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__prerender__["a" /* default */],null)));}}]);return PreviewModalWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PreviewModalWrapper);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview_row__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_toggle_preview__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logic_condition_tree__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_condition_evo__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/modal.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// import actions
var numberOfAll=0;// calculation of page numbers
var PAGE_WIDTH=684;function getPageNumber(width){return Math.ceil(width/PAGE_WIDTH);}// ██████╗ ██████╗ ███████╗██████╗  █████╗ ██████╗ ███████╗    ██████╗  ██████╗ ███╗   ███╗
// ██╔══██╗██╔══██╗██╔════╝██╔══██╗██╔══██╗██╔══██╗██╔════╝    ██╔══██╗██╔═══██╗████╗ ████║
// ██████╔╝██████╔╝█████╗  ██████╔╝███████║██████╔╝█████╗      ██║  ██║██║   ██║██╔████╔██║
// ██╔═══╝ ██╔══██╗██╔══╝  ██╔═══╝ ██╔══██║██╔══██╗██╔══╝      ██║  ██║██║   ██║██║╚██╔╝██║
// ██║     ██║  ██║███████╗██║     ██║  ██║██║  ██║███████╗    ██████╔╝╚██████╔╝██║ ╚═╝ ██║
// ╚═╝     ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝    ╚═════╝  ╚═════╝ ╚═╝     ╚═╝
//
var _PreviewModal=function(_Component){_inherits(_PreviewModal,_Component);function _PreviewModal(props){_classCallCheck(this,_PreviewModal);var _this=_possibleConstructorReturn(this,(_PreviewModal.__proto__||Object.getPrototypeOf(_PreviewModal)).call(this,props));_this.len=0;_this.state={page_length:0};return _this;}_createClass(_PreviewModal,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){window.modal=this.refs.modal_doc;window.c_page=this.refs.current_page;window.t_page=this.refs.total_page;if(this.refs.modal_doc){var pageNumber=getPageNumber(this.refs.modal_doc.scrollWidth);nextState.page_length=pageNumber;// eslint-disable-line
}}},{key:'componentDidUpdate',value:function componentDidUpdate(){// show and hide the page number
if(this.refs.modal_doc){var pageNumber=getPageNumber(this.refs.modal_doc.scrollWidth);this.state.page_length=pageNumber;if(this.refs.total_page)this.refs.total_page.innerText=' '+pageNumber;}var nbrSys={};// this one must change
var numbers=document.querySelectorAll('[num-auto], [num-auto-pre]');// get the numbering system
// console.log(numbers);
for(var i=0;i<numbers.length;i+=1){var v=numbers[i];if(v&&v.attributes&&v.attributes.getNamedItem('num-auto')){nbrSys[v.attributes.getNamedItem('num-auto').value]=0;}else{nbrSys[v.attributes.getNamedItem('num-auto-pre').value]=0;}}Object.keys(numbers).forEach(function(idx){var element=numbers[idx];if(element&&element.attributes&&element.attributes.getNamedItem('num-auto')){var counter=element.attributes.getNamedItem('num-auto').value;nbrSys[counter]+=1;element.innerHTML=nbrSys[counter];// test if it's an article
if(counter==='articles'){// init all them
Object.keys(nbrSys).forEach(function(index){if(index!=='articles')nbrSys[index]=0;});}}else if(element&&element.attributes){var _counter=element.attributes.getNamedItem('num-auto-pre').value;element.innerHTML=nbrSys[_counter];}});}},{key:'render',value:function render(){// console.time('modal')
if(this.props.canBeGenerated&&this.props.isFDF){return(// To match worker legacy behaviour not actually angular
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',{id:'FDFJson','ng-if':'contractCtrl.disable_preview','class':'ng-binding ng-scope'},this.props.FDFOutput));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'doc-preview',ref:'exit_yo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'modal_doc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},'PAGE_BEGIN_PRERENDER',this.props.canBeGenerated&&this.props.views.map(function(idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__preview_row__["a" /* default */],{key:Object(__WEBPACK_IMPORTED_MODULE_3__utils_misc__["b" /* generateId1 */])(4),idOut:idx[1],out:idx[0]});}),!this.props.canBeGenerated&&'LP_PRERENDER_DO_NOT_GENERATE','PAGE_END_PRERENDER')));// console.timeEnd('modal')
}}]);return _PreviewModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var isFDF=false;var FDFOutput='';// check the updatable conditions.
numberOfAll=0;var outputs=[];// The algorithm of grabbing the
// get the section content
// prepare options
if(!state.contract){return{views:[]};}// TODO: work on
var keys=__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.sections;// console.log(keys)
if(keys){keys.map(function(idx){if(idx.compiledConditions&&idx.compiledConditions.length>0)if(!__WEBPACK_IMPORTED_MODULE_7__logic_condition_evo__["a" /* default */].rawCondition(idx.compiledConditions))return false;__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].ops.content.getOutput(idx.options,outputs);});}__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].indexes.content.updateContent(outputs,numberOfAll);// console.log("Hello")
// Checking if the document can be generated
var canBeGenerated=true;if(typeof __WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].prerenderDoc==='number'&&!Number.isNaN(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].prerenderDoc)){var docsConditions=__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].ops.document.checkWrappers();if(Object.prototype.hasOwnProperty.call(docsConditions,__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].prerenderDoc)){canBeGenerated=docsConditions[__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].prerenderDoc].cond===true;}else{canBeGenerated=false;}}// Use old prerender behavior
if(typeof __WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].prerenderDoc==='number'){var _document=__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.docs_wrappers[__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].prerenderDoc];isFDF=Object.keys(_document.linked_pdf)>0;if(isFDF){var linkedPdf=_document.linked_pdf;FDFOutput='{"FDFJson":{},"PDFId":"'+linkedPdf.pdfId+'"}';}}return{preview:state.preview,views:outputs,is_modal:state.preview,canBeGenerated:canBeGenerated,isFDF:isFDF,FDFOutput:FDFOutput};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggle_screen:function toggle_screen(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_toggle_preview__["e" /* togglePreview */])());}};};var PreviewModal=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_PreviewModal);/* harmony default export */ __webpack_exports__["a"] = (PreviewModal);

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var escapeStringRegexp = __webpack_require__(832);
var ansiStyles = __webpack_require__(833);
var stripAnsi = __webpack_require__(834);
var hasAnsi = __webpack_require__(835);
var supportsColor = __webpack_require__(836);
var defineProps = Object.defineProperties;
var isSimpleWindowsTerm = process.platform === 'win32' && !/^xterm/i.test(Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}).TERM);

function Chalk(options) {
	// detect mode if not set manually
	this.enabled = !options || options.enabled === undefined ? supportsColor : options.enabled;
}

// use bright blue on Windows as the normal blue color is illegible
if (isSimpleWindowsTerm) {
	ansiStyles.blue.open = '\u001b[94m';
}

var styles = (function () {
	var ret = {};

	Object.keys(ansiStyles).forEach(function (key) {
		ansiStyles[key].closeRe = new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');

		ret[key] = {
			get: function () {
				return build.call(this, this._styles.concat(key));
			}
		};
	});

	return ret;
})();

var proto = defineProps(function chalk() {}, styles);

function build(_styles) {
	var builder = function () {
		return applyStyle.apply(builder, arguments);
	};

	builder._styles = _styles;
	builder.enabled = this.enabled;
	// __proto__ is used because we must return a function, but there is
	// no way to create a function with a different prototype.
	/* eslint-disable no-proto */
	builder.__proto__ = proto;

	return builder;
}

function applyStyle() {
	// support varags, but simply cast to string in case there's only one arg
	var args = arguments;
	var argsLen = args.length;
	var str = argsLen !== 0 && String(arguments[0]);

	if (argsLen > 1) {
		// don't slice `arguments`, it prevents v8 optimizations
		for (var a = 1; a < argsLen; a++) {
			str += ' ' + args[a];
		}
	}

	if (!this.enabled || !str) {
		return str;
	}

	var nestedStyles = this._styles;
	var i = nestedStyles.length;

	// Turns out that on Windows dimmed gray text becomes invisible in cmd.exe,
	// see https://github.com/chalk/chalk/issues/58
	// If we're on Windows and we're dealing with a gray color, temporarily make 'dim' a noop.
	var originalDim = ansiStyles.dim.open;
	if (isSimpleWindowsTerm && (nestedStyles.indexOf('gray') !== -1 || nestedStyles.indexOf('grey') !== -1)) {
		ansiStyles.dim.open = '';
	}

	while (i--) {
		var code = ansiStyles[nestedStyles[i]];

		// Replace any instances already present with a re-opening code
		// otherwise only the part of the string until said closing code
		// will be colored, and the rest will simply be 'plain'.
		str = code.open + str.replace(code.closeRe, code.open) + code.close;
	}

	// Reset the original 'dim' if we changed it to work around the Windows dimmed gray issue.
	ansiStyles.dim.open = originalDim;

	return str;
}

function init() {
	var ret = {};

	Object.keys(styles).forEach(function (name) {
		ret[name] = {
			get: function () {
				return build.call(this, [name]);
			}
		};
	});

	return ret;
}

defineProps(Chalk.prototype, init());

module.exports = new Chalk();
module.exports.styles = ansiStyles;
module.exports.hasColor = hasAnsi;
module.exports.stripColor = stripAnsi;
module.exports.supportsColor = supportsColor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

function assembleStyles () {
	var styles = {
		modifiers: {
			reset: [0, 0],
			bold: [1, 22], // 21 isn't widely supported and 22 does the same thing
			dim: [2, 22],
			italic: [3, 23],
			underline: [4, 24],
			inverse: [7, 27],
			hidden: [8, 28],
			strikethrough: [9, 29]
		},
		colors: {
			black: [30, 39],
			red: [31, 39],
			green: [32, 39],
			yellow: [33, 39],
			blue: [34, 39],
			magenta: [35, 39],
			cyan: [36, 39],
			white: [37, 39],
			gray: [90, 39]
		},
		bgColors: {
			bgBlack: [40, 49],
			bgRed: [41, 49],
			bgGreen: [42, 49],
			bgYellow: [43, 49],
			bgBlue: [44, 49],
			bgMagenta: [45, 49],
			bgCyan: [46, 49],
			bgWhite: [47, 49]
		}
	};

	// fix humans
	styles.colors.grey = styles.colors.gray;

	Object.keys(styles).forEach(function (groupName) {
		var group = styles[groupName];

		Object.keys(group).forEach(function (styleName) {
			var style = group[styleName];

			styles[styleName] = group[styleName] = {
				open: '\u001b[' + style[0] + 'm',
				close: '\u001b[' + style[1] + 'm'
			};
		});

		Object.defineProperty(styles, groupName, {
			value: group,
			enumerable: false
		});
	});

	return styles;
}

Object.defineProperty(module, 'exports', {
	enumerable: true,
	get: assembleStyles
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(361)(module)))

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ansiRegex = __webpack_require__(362)();

module.exports = function (str) {
	return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
};


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ansiRegex = __webpack_require__(362);
var re = new RegExp(ansiRegex().source); // remove the `g` flag
module.exports = re.test.bind(re);


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var argv = process.argv;

var terminator = argv.indexOf('--');
var hasFlag = function (flag) {
	flag = '--' + flag;
	var pos = argv.indexOf(flag);
	return pos !== -1 && (terminator !== -1 ? pos < terminator : true);
};

module.exports = (function () {
	if ('FORCE_COLOR' in Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"})) {
		return true;
	}

	if (hasFlag('no-color') ||
		hasFlag('no-colors') ||
		hasFlag('color=false')) {
		return false;
	}

	if (hasFlag('color') ||
		hasFlag('colors') ||
		hasFlag('color=true') ||
		hasFlag('color=always')) {
		return true;
	}

	if (process.stdout && !process.stdout.isTTY) {
		return false;
	}

	if (process.platform === 'win32') {
		return true;
	}

	if ('COLORTERM' in Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"})) {
		return true;
	}

	if (Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}).TERM === 'dumb') {
		return false;
	}

	if (/^screen|^xterm|^vt100|color|ansi|cygwin|linux/i.test(Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}).TERM)) {
		return true;
	}

	return false;
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__callbacks_basic__ = __webpack_require__(838);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/callbacks.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpCallbacks=function(){function LpCallbacks(){_classCallCheck(this,LpCallbacks);this.onResize=null;this.onClose=null;this.onBeforeClose=null;this.onFocus=null;this.onBlur=null;this.onNextPrevious=null;this.changed_callback='';// load things in the bigenning
}_createClass(LpCallbacks,[{key:'addCallback',value:function addCallback(name,func){if(Object.keys(this).includes(name)){this[name]=func;this.changed_callback=name;this.updateCallbacks();}}},{key:'updateCallbacks',value:function updateCallbacks(){switch(this.changed_callback){case'onResize':window.onresize=this.onResize;break;case'onClose':window.onunload=this.onClose;break;case'onBeforeClose':window.onbeforeunload=this.onBeforeClose;break;case'onFocus':window.onfocus=this.onFocus;break;case'onBlur':window.onblur=this.onBlur;break;case'onNextPrevious':window.onpopstate=this.onNextPrevious;break;default:break;}}},{key:'setupInitialCallbacks',value:function setupInitialCallbacks(){this.addCallback('onBeforeClose',__WEBPACK_IMPORTED_MODULE_0__callbacks_basic__["a" /* UnloadPrompt */]);this.addCallback('onNextPrevious',__WEBPACK_IMPORTED_MODULE_0__callbacks_basic__["b" /* historyDispatcher */]);}}]);return LpCallbacks;}();/* harmony default export */ __webpack_exports__["a"] = (LpCallbacks);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnloadPrompt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return historyDispatcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__ = __webpack_require__(56);
// import { lpPattern } from "../../tracking/pattern_detector";
/*
 * Project: LegalPlace assistant
 * File: src/app/callbacks/basic.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var UnloadPrompt=function UnloadPrompt(e){var state=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState();var event={};if(state.appstate===0){event['Application phase']='Wizard';}else{event['Application phase']=state.appstate===1?'Mail section':'Checkout';}event['Last section']=state.contract&&state.contract.currentSection?parseInt(state.contract.currentSection,10)+1:'None';if(state.appstate>1){__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].track('Closed Checkout',{});// pattern.
if(window.lpPattern){window.lpPattern.trackLastAction('Closed window');window.lpPattern.sendAndResetTracker();}}var clientEvent=e||window.event;var str=Object(__WEBPACK_IMPORTED_MODULE_2__logic_wording__["a" /* _lp */])('Etes-vous sûr de vouloir quitter la page ? Pensez à sauvegarder votre document pour le récupérer plus tard');// For IE and Firefox
if(clientEvent)clientEvent.returnValue=str;// For Safari
return str;};var historyDispatcher=function historyDispatcher(evt){if(evt.state!==null&&'store'in evt.state&&'app_state'in evt.state.store){var appState=evt.state.store.app_state;__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].mutex.setMutex('history',false);__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__["g" /* setAppState */])(appState===0?0:2));}if(evt.state!==null&&'store'in evt.state&&'section'in evt.state.store){var sectionId=evt.state.store.section;// console.log(sectionId);
__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].mutex.setMutex('history',false);__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch({type:'SET_SECTION_ID',id:sectionId});}};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtmAchatEvent = function (gtmAchatInput) { return (__assign({ event: 'eecPurchase' }, gtmAchatInput)); };
var CHECKOUT_NAMES_BY_STEP = {
    1: ['Questionnaire', 'Choississez votre démarche'],
    2: ['Votre adresse email', 'Renseignez vos informations'],
    3: ['Récapitulatif de votre commande', 'Payez en toute sécurité']
};
exports.gtmCheckoutEvent = function (gtmCheckoutInput) {
    if (CHECKOUT_NAMES_BY_STEP[gtmCheckoutInput.checkoutStepNumber].indexOf(gtmCheckoutInput.checkoutStepName) === -1)
        console.warn("Checkout step name " + gtmCheckoutInput.checkoutStepName + " is not available for step n\u00B0 " + gtmCheckoutInput.checkoutStepNumber);
    return __assign({ event: 'eecCheckout' }, gtmCheckoutInput);
};
exports.gtmSivFunnelGAEvent = function (_a) {
    var funnelCategory = _a.funnelCategory, funnelAction = _a.funnelAction, funnelLabel = _a.funnelLabel;
    return {
        event: 'funnelGA',
        eventCommand: 'SIV',
        funnelCategory: funnelCategory,
        funnelAction: funnelAction,
        funnelLabel: funnelLabel
    };
};
exports.getContractFunnelGAEvent = function (gtmFunnelContractInput) { return ({
    event: 'funnelGA',
    eventCommand: 'Contrat standard',
    funnelLabel: gtmFunnelContractInput.sectionTitle,
    funnelAction: gtmFunnelContractInput.pageAction,
    funnelCategory: "Funnel Contract - " + gtmFunnelContractInput.contractName
}); };
exports.getContractGAEvent = function (gtmGAInput) { return (__assign({ event: 'eventGA' }, gtmGAInput)); };
exports.gtmReadyEA = function (gtmGAReadyEA) { return (__assign({ event: 'dataLayerReadyEA' }, gtmGAReadyEA)); };


/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = {"values":{"want help?":"Besoin d'aide ? ","contact us":"Contactez nous ","or":"ou ","call us":"Appelez-nous au ","mail section title":"Adresse e-mail où votre document doit être envoyé ","mail section helper":"Nous ne partagerons vos informations avec personne ","mail section law":"Conformément à la Loi Informatique et Libertés et Règlement général sur la protection des données (RGPD), vous disposez d’un droit d’accès, de modification, de suppression et d’opposition au traitement de vos données à caractère personnel. ","next":"suivant","previous":"précédent","download":"télécharger","pass":"passer","save button save":"Enregistrer et continuer plus tard","save button checking":"","save button saved":"","save section title":"Sauvegarder","save section intro":"Pour enregistrer votre document, veuillez saisir votre adresse email puis la confirmer. Un email contenant un lien de reprise de la sauvegarde vous sera adressé","save section back":"revenir au questionnaire","save":"sauvegarder"}}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = {"values":{"want help?":"7ab n3awnouk ? ","contact us":"contactina ","or":"oula ","call us":"3ayetelna "}}

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/continuity.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*//**
 * This class reads params from the href at the entry point,
 * Here we can exlude some rules, and manage additional query params
 */var LpHrefParams=function(){function LpHrefParams(){_classCallCheck(this,LpHrefParams);this.whatContinuity();}/**
     * Initialize the continuity data from href
     */_createClass(LpHrefParams,[{key:'whatContinuity',value:function whatContinuity(){var section=0;var continueThing='';var isPayment=false;var link=document.location.href;var params=link.split('?');var params0=params[0].split('#');if(params0[0].endsWith('/')){params0[0]=params0[0].slice(0,params0[0].length-1);}var components=params0[0].split('/');var cLength=components.length;// test the l-1
switch(components[cLength-1]){case'checkout':case'paiement':isPayment=true;continueThing=components[cLength-2];break;default:if(components[cLength-1]==='creer'||components[cLength-2]==='creer'){section=1;isPayment=false;continueThing='';}else{// adding the point where the end is a continue thing. 5a7adc56af990
var regOne=/[a-z0-9]{13}/g;if(components[cLength-1].search(regOne)>=0){continueThing=components[cLength-1];section=1;}else{section=components[cLength-1];switch(components[cLength-2]){case'creer':isPayment=false;break;default:continueThing=components[cLength-2];break;}}}break;}// Continue thing
if(continueThing.length===0&&window.contract_id&&window.contract_id.length>0){continueThing=window.contract_id;}// this.isPayment(isPayment);
this.setContinuity(continueThing);this.setSection(section);}/**
     * set if the continuity link is on the payment section
     * @param {boolean} pay
     */},{key:'isPayment',value:function isPayment(pay){}// this.is_payment = pay;
/**
     * Sets the document unique ID to continue
     * whe it's empty the document is new;
     * @param {string} cont
     */},{key:'setContinuity',value:function setContinuity(cont){this.continue=cont;}/**
     * set the continue section number,
     * when it's a new document this param is ignored.
     * @param {number} sec
     */},{key:'setSection',value:function setSection(sec){this.section=sec;}}]);return LpHrefParams;}();/* harmony default export */ __webpack_exports__["a"] = (LpHrefParams);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/env.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*//**
 * This class help to bypass the problimatic of detecting browsers' information in execution time
 * So I initialize the browser's information and execution environment here.
 */var LpEnvironment=function(){function LpEnvironment(){_classCallCheck(this,LpEnvironment);this.detectMobility();this.detectMobileDevice();this.detectOrientation();this.detectSize();}/**
     * detects if the device is mobile or not
     */_createClass(LpEnvironment,[{key:'detectMobility',value:function detectMobility(){if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){this.is_mobile=true;}else{this.is_mobile=false;}}/**
     * Mobile type detection
     */},{key:'detectMobileDevice',value:function detectMobileDevice(){this.mobile_device='NO';if(LpEnvironment.isAndroid())this.mobile_device='Android';if(LpEnvironment.isWebOS())this.mobile_device='WebOS';if(LpEnvironment.isiPhone())this.mobile_device='iPhone';if(LpEnvironment.isiPad())this.mobile_device='iPad';if(LpEnvironment.isiPod())this.mobile_device='iPod';if(LpEnvironment.isBlackBerry())this.mobile_device='BlackBerry';if(LpEnvironment.isIEMobile())this.mobile_device='IEMobile';if(LpEnvironment.isOperaMini())this.mobile_device='OperaMini';}/**
     * ... is it android
     */},{key:'detectOrientation',/**
     * Detetcts the orientation of the device
     * @returns {string} "landscape-*" | "portrait-*"
     */value:function detectOrientation(){this.orientation=window.screen&&window.screen.orientation&&window.screen.orientation.type?window.screen.orientation.type:'none';}/**
     * This is to bypass the mobile device problems
     */},{key:'detectSize',value:function detectSize(){this.client_zone={height:-1,width:-1};if(this.is_mobile){this.client_zone.height=window.screen.availHeight;this.client_zone.width=window.screen.availWidth;}else{this.client_zone.height=window.innerHeight;this.client_zone.width=window.innerWidth;}}}],[{key:'isAndroid',value:function isAndroid(){return /Android/i.test(navigator.userAgent);}/**
     * ... is it WebOS
     */},{key:'isWebOS',value:function isWebOS(){return /webOS/i.test(navigator.userAgent);}/**
     * ... is it an iPhone
     */},{key:'isiPhone',value:function isiPhone(){return /iPhone/i.test(navigator.userAgent);}/**
     * ... is it an iPad
     */},{key:'isiPad',value:function isiPad(){return /iPad/i.test(navigator.userAgent);}/**
     * ... is it an iPod
     */},{key:'isiPod',value:function isiPod(){return /iPod/i.test(navigator.userAgent);}/**
     * ... is it a blackBerry
     */},{key:'isBlackBerry',value:function isBlackBerry(){return /BlackBerry/i.test(navigator.userAgent);}/**
     * ... is it an internet explorer llaaaaah yousterna
     */},{key:'isIEMobile',value:function isIEMobile(){return /IEMobile/i.test(navigator.userAgent);}/**
     * is it an Opera Mini?
     */},{key:'isOperaMini',value:function isOperaMini(){return /Opera Mini/i.test(navigator.userAgent);}}]);return LpEnvironment;}();/* harmony default export */ __webpack_exports__["a"] = (LpEnvironment);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__step2__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customizations__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slack__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/refs/refs.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*//**
 * The references class
 */var LpReferences=function(){function LpReferences(){_classCallCheck(this,LpReferences);this.options={};this.variables={};this.views={};this.parenting={};this.two_steps=new __WEBPACK_IMPORTED_MODULE_0__step2__["a" /* default */]();this.customs=new __WEBPACK_IMPORTED_MODULE_1__customizations__["a" /* default */]();this.slack_notification=new __WEBPACK_IMPORTED_MODULE_2__slack__["a" /* default */]();// Adding mandatory options and variables by sections.
this.mandatory_options={};this.mandatory_variables={};}_createClass(LpReferences,[{key:'addCustomizationsReference',value:function addCustomizationsReference(model){this.customs.buildCustomizations(model);}},{key:'addOptionsReference',value:function addOptionsReference(optRefs){this.options=optRefs;this.two_steps.buildOptions(optRefs);}},{key:'addVariablesRefernce',value:function addVariablesRefernce(varRefs){this.variables=varRefs;this.two_steps.buildVariables(varRefs);}},{key:'addViewsRefernce',value:function addViewsRefernce(vrefs){this.views=vrefs;}},{key:'addSectionsReference',value:function addSectionsReference(secs){this.sections=secs;this.two_steps.buildSections(secs);}},{key:'addSlackNotification',value:function addSlackNotification(slkrefs){this.slack_notification.initSlackRef(slkrefs);}},{key:'addMandatpryOptions',value:function addMandatpryOptions(ops){var _this=this;var keys=Object.keys(ops);keys.forEach(function(keysIdx){var idx=ops[keysIdx];if('mandatory'in idx.meta&&idx.meta.mandatory){if(!(idx.meta.parent_section in _this.mandatory_options)){_this.mandatory_options[idx.meta.parent_section]=[idx.meta.id];}}});}},{key:'addMandatoryVariables',value:function addMandatoryVariables(vars){var _this2=this;var keys=Object.keys(vars);keys.forEach(function(keysIdx){var idx=vars[keysIdx];if('mandatory'in idx&&idx.mandatory){var grandpaIdx=__WEBPACK_IMPORTED_MODULE_3__lp_app__["a" /* default */].references.options[__WEBPACK_IMPORTED_MODULE_3__lp_app__["a" /* default */].indexes.grandpa_vars.getVGrandpa(idx.id)];if(!(grandpaIdx.meta.parent_section in _this2.mandatory_variables)){_this2.mandatory_variables[grandpaIdx.meta.parent_section]=[idx.id];}}},this);}/**
     * Here we have the total control on errors of low level
     */},{key:'getVariable',value:function getVariable(id){return this.variables[id];}},{key:'getOption',value:function getOption(id){return this.options[id];}},{key:'getSection',value:function getSection(id){return this.sections[id];}}]);return LpReferences;}();/* harmony default export */ __webpack_exports__["a"] = (LpReferences);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__step_param__ = __webpack_require__(846);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/refs/step2.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var STEP='step_two_only';var LpStepTwoRef=function(){function LpStepTwoRef(){_classCallCheck(this,LpStepTwoRef);this.ts_options={};this.ts_variables={};this.ts_sections={};}_createClass(LpStepTwoRef,[{key:'buildOptions',value:function buildOptions(opts){var _this=this;var keys=Object.keys(opts);keys.forEach(function(idx){var now=opts[idx];if(now.meta[STEP]){_this.ts_options[idx]=new __WEBPACK_IMPORTED_MODULE_0__step_param__["a" /* default */]();}},this);}},{key:'buildVariables',value:function buildVariables(vars){var _this2=this;var keys=Object.keys(vars);keys.forEach(function(idx){var now=vars[idx];if(now[STEP]){_this2.ts_variables[idx]=new __WEBPACK_IMPORTED_MODULE_0__step_param__["a" /* default */]();}},this);}},{key:'buildSections',value:function buildSections(sections){var _this3=this;var keys=Object.keys(sections);keys.forEach(function(idx){var now=sections[idx];if(now[STEP]){_this3.ts_sections[idx]=new __WEBPACK_IMPORTED_MODULE_0__step_param__["a" /* default */]();}},this);}}]);return LpStepTwoRef;}();/* harmony default export */ __webpack_exports__["a"] = (LpStepTwoRef);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/refs/step_param.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpSecondParam=function(){function LpSecondParam(){_classCallCheck(this,LpSecondParam);this.value=true;// simple value
this.is_discovered=false;// does the user saw it
this.state='NONE';// Payed or not
}_createClass(LpSecondParam,[{key:'isDiscovered',value:function isDiscovered(){return this.is_discovered;}},{key:'setState',value:function setState(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'NONE';this.state=state;}}]);return LpSecondParam;}();/* harmony default export */ __webpack_exports__["a"] = (LpSecondParam);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/refs/customizations.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpCustomizations=function(){function LpCustomizations(){_classCallCheck(this,LpCustomizations);this.custom={};}_createClass(LpCustomizations,[{key:'buildCustomizations',value:function buildCustomizations(modelParam){this.custom=modelParam;}},{key:'get',value:function get(index){if(this.custom&&this.custom[index])return this.custom[index];return'NONE';}}]);return LpCustomizations;}();/* harmony default export */ __webpack_exports__["a"] = (LpCustomizations);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LpSlackRefs=function(){function LpSlackRefs(){_classCallCheck(this,LpSlackRefs);this.saveSlack=[];this.sendinblue=[];this.mixpanel=[];}_createClass(LpSlackRefs,[{key:"initSlackRef",value:function initSlackRef(slkRef){var _this=this;if(slkRef&&slkRef.length>0){// this.saveSlack = slkRef.map((idx) => {
//     if(idx.extractions.slack && idx.extractions.slack.enabled) {
//         return {
//             name: idx.extractions.slack.name,
//             channel: idx.extractions.slack.channel,
//             type: idx.type,
//             id: idx.id
//         }
//     }
// });
// Here starting the extraction
slkRef.forEach(function(idx){var type=idx.type,id=idx.id;// Now with the sending things.
// slack
if(idx.extractions.slack&&idx.extractions.slack.enabled){_this.saveSlack.push({name:idx.extractions.slack.name,channel:idx.extractions.slack.channel,type:type,id:id});}if(idx.extractions.mixpanel&&idx.extractions.mixpanel.enabled){_this.mixpanel.push({name:idx.extractions.mixpanel.name,type:type,id:id});}if(idx.extractions.sendinblue&&idx.extractions.sendinblue.enabled){_this.sendinblue.push({name:idx.extractions.sendinblue.name,type:type,id:id});}},this);}}}]);return LpSlackRefs;}();/* harmony default export */ __webpack_exports__["a"] = (LpSlackRefs);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__options__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conditions_dependencies__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conditions__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__real_sections__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fatherhood__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fatherhood_variables__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__multiples__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_by_variables__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__render__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__root_options__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__by_section__ = __webpack_require__(1088);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// import lpViewHeightIndex from "./view_heights";
/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/indexes.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*//**
 * This class contains all the index data,
 * * variables
 * * options
 * * dependencies (condition)
 * * conditions
 * * view by variables
 * * multiple index
 * * multiple keys index
 * * outputs
 * * real sections
 */var LpIndexContainer=function(){function LpIndexContainer(){_classCallCheck(this,LpIndexContainer);this.options=new __WEBPACK_IMPORTED_MODULE_0__options__["a" /* default */]();this.variables=new __WEBPACK_IMPORTED_MODULE_1__variables__["a" /* default */]();this.dependencies=new __WEBPACK_IMPORTED_MODULE_2__conditions_dependencies__["a" /* default */]();this.conditions=new __WEBPACK_IMPORTED_MODULE_3__conditions__["a" /* default */]();this.real_sections=new __WEBPACK_IMPORTED_MODULE_4__real_sections__["a" /* default */]();this.grandpa=new __WEBPACK_IMPORTED_MODULE_5__fatherhood__["a" /* default */]();this.grandpa_vars=new __WEBPACK_IMPORTED_MODULE_6__fatherhood_variables__["a" /* default */]();this.multiples=new __WEBPACK_IMPORTED_MODULE_7__multiples__["a" /* default */]();this.var_to_view=new __WEBPACK_IMPORTED_MODULE_8__views_by_variables__["a" /* default */]();this.content=new __WEBPACK_IMPORTED_MODULE_9__render__["a" /* default */]();this.roots=new __WEBPACK_IMPORTED_MODULE_10__root_options__["a" /* default */]();this.sections_cache=new __WEBPACK_IMPORTED_MODULE_11__by_section__["a" /* default */]();// this.heights = new lpViewHeightIndex();
}/**
     * Centralizing building
     */_createClass(LpIndexContainer,[{key:'updateOption',value:function updateOption(opt){var i=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;this.options.updateOption(opt,i);}},{key:'updateVariable',value:function updateVariable(var_){var i=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;this.variables.updateVariable(var_,i);}},{key:'updateDependencies',value:function updateDependencies(){this.dependencies.buildDependencies();}},{key:'updateConditions',value:function updateConditions(){this.conditions.updateConditions();}},{key:'updateRealSections',value:function updateRealSections(var_){this.real_sections.updateRealSections(var_);}},{key:'updateGrandpa',value:function updateGrandpa(tree){this.grandpa.buildGrandpa(tree);}},{key:'updateV2V',value:function updateV2V(obj){this.var_to_view.buildVarToView(obj);}},{key:'updateRoots',value:function updateRoots(sections){this.roots.buildRootOptions(sections);}}]);return LpIndexContainer;}();/* harmony default export */ __webpack_exports__["a"] = (LpIndexContainer);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_condition_evo__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/options.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpOptionsIndex=function(){function LpOptionsIndex(){_classCallCheck(this,LpOptionsIndex);this.options={};}_createClass(LpOptionsIndex,[{key:'updateOption',value:function updateOption(opt){var i=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(opt){var changeStatus=false;if(this.options[opt.id]&&this.options[opt.id].value!==opt.value)changeStatus=true;else if(!this.options[opt.id])changeStatus=true;this.options[opt.id]={value:opt.value,index:i};if(changeStatus===true)__WEBPACK_IMPORTED_MODULE_1__logic_condition_evo__["a" /* default */].execOptionHook(opt.id);}}},{key:'loadFromO',value:function loadFromO(){var _this=this;if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().loadedOvc&&Object.keys(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().loadedOvc).length>0){var os=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().loadedOvc.oF;var cs=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().loadedOvc.cF;// Object.keys(os).map(idx => this.options[idx] = {value: os[idx]}, this);
// Object.keys(cs).map(idx => this.options[idx] = {value: cs[idx]}, this);
if(os&&Object.keys(os).length>0)Object.keys(os).map(function(idx){return _this.updateOption({id:idx,value:os[idx]});},this);if(cs&&Object.keys(cs).length>0)Object.keys(cs).map(function(idx){return _this.updateOption({id:idx,value:cs[idx]});},this);}}},{key:'delOption',value:function delOption(id){if(Object.prototype.hasOwnProperty.call(this.options,id)){delete this.options[id];__WEBPACK_IMPORTED_MODULE_1__logic_condition_evo__["a" /* default */].execOptionHook(id);}}},{key:'getOption',value:function getOption(id){if(this.options[id])return this.options[id];// let loaded_option = getOptionPass(id);
// if(loaded_option)
//     return {value: loaded_option};
return{value:false};// return this.options[id] ? this.options[id] : getOptionPass(id);
}},{key:'isLoaded',value:function isLoaded(){return Object.keys(this.options).length>0;}}]);return LpOptionsIndex;}();/* harmony default export */ __webpack_exports__["a"] = (LpOptionsIndex);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__references__ = __webpack_require__(363);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var JsonLogicParser=function(){/**
   * @param {object} conditions v1 conditions object
   */function JsonLogicParser(conditions){_classCallCheck(this,JsonLogicParser);this.data_map={options:[],variables:[],conditions:[]};// Getting parents tree
this.parentsTree=__WEBPACK_IMPORTED_MODULE_0__references__["a" /* default */].getParentsTree();// Getting conditionned Options
this.conditionnedOptions=__WEBPACK_IMPORTED_MODULE_0__references__["a" /* default */].getConditionnedOptions();// Converting conditions to json logic
this.logic=this.convertConditions(conditions);return{logic:this.logic,data_map:this.data_map};}/**
   * Converts v1 conditions object to jsonlogic object
   * @param {object} conditions - LegalPlace's v1 model conditions
   */_createClass(JsonLogicParser,[{key:'convertConditions',value:function convertConditions(conditions){var _this=this;var operator=void 0;// Getting first entry operator if any
if(conditions.length>1){conditions.forEach(function(value,index){if(value.t&&index>0){if(!operator){operator=value.t;}else if(value.t!=operator){throw new Error('Conditions object is not valid, '+operator+' is not equal to '+value.t+' at index '+index+' in '+JSON.stringify(conditions));}}});}// Compiling conditions
var logic_conditions=[];conditions.forEach(function(value,index){var current_condition=void 0;if(_typeof(value.condition_array)==='object'){current_condition=_this.convertConditions(value.condition_array);}else if((typeof value==='undefined'?'undefined':_typeof(value))==='object'){current_condition=_this.convertSingleCondition(value);}else{throw new Error('Invalid condition');}logic_conditions.push(current_condition);});// Putting everything together
var logic={};if(operator){logic[operator]=logic_conditions;}else if(logic_conditions.length==1){logic=logic_conditions[0];}else{throw new Error('Invalid condition '+condition);}return logic;}/**
   * Convert's a single condition object to jsonlogic format
   * @param {object} condition
   */},{key:'convertSingleCondition',value:function convertSingleCondition(condition){var operation=condition.c;var rule={};var parent_id=void 0,dataReference=void 0;if(condition.o!==false){dataReference={"var":'option.'+condition.o};if(this.parentsTree.options[condition.o]){parent_id=this.parentsTree.options[condition.o][0];}else{parent_id=false;}// Adding option to the data map object
this.addOptionToMap(condition.o);if(this.conditionnedOptions.includes(parseInt(condition.o))){rule.and=[{},{"selected":[{"var":'condition.'+condition.o}]}];rule.and[0][operation]=[dataReference];this.addConditionToMap(condition.o);}else{rule[operation]=[dataReference];}}else if(condition.v!==false){dataReference={"var":'variable.'+condition.v};parent_id=this.parentsTree.variables[condition.v][0];// Adding option to the data map object
this.addVariableToMap(condition.v);rule[operation]=[dataReference,condition.value];}else{throw new Error('Invalid condition '+condition);}// Reading parent tree
var parentsConditions=void 0;if(parent_id)parentsConditions=this.getParentConditions(parent_id);else parentsConditions=this.getSectionConditions(condition.o);var conditions=[parentsConditions,rule].filter(function(a){return(typeof a==='undefined'?'undefined':_typeof(a))==="object";});if(conditions.length===0)return false;if(conditions.length>1)return{"and":conditions};return rule;}/**
   * Adds option's id to the data map
   * @param {number} id
   */},{key:'addOptionToMap',value:function addOptionToMap(id){if(!this.data_map.options.includes(id))this.data_map.options.push(id);}/**
   * Adds variables's id to the data map
   * @param {number} id
   */},{key:'addVariableToMap',value:function addVariableToMap(id){if(!this.data_map.variables.includes(id))this.data_map.variables.push(id);}/**
   * Adds conditions's id to the data map
   * @param {number} id
   */},{key:'addConditionToMap',value:function addConditionToMap(id){if(!this.data_map.conditions.includes(id))this.data_map.conditions.push(id);}/**
   * Returns and option's ascendants conditions
   * Spec: This function returns the list of all conditions required in order
   * for the option to be shown since a condition is always false when an option
   * it depends on is hidden
   * @param {number} id
   */},{key:'getParentConditions',value:function getParentConditions(id){var parent_id=this.parentsTree.options[id]?this.parentsTree.options[id][0]:false;var condition=void 0,rule=void 0,parent=void 0;if(parent_id!==false&&this.parentsTree.options[id].length>0){parent=this.getParentConditions(parent_id);}else{parent=this.getSectionConditions(id);}if(this.conditionnedOptions.includes(parseInt(id))){condition={"selected":[{"var":'condition.'+id}]};this.addConditionToMap(id);}// If it's an option or a checkbox
if(__WEBPACK_IMPORTED_MODULE_0__references__["a" /* default */].options[id]&&['radio','checkbox'].includes(__WEBPACK_IMPORTED_MODULE_0__references__["a" /* default */].options[id].meta.type)){rule={"selected":[{"var":'option.'+id}]};this.addOptionToMap(id);}var conditions=[condition,rule,parent].filter(function(a){return(typeof a==='undefined'?'undefined':_typeof(a))==="object";});if(conditions.length===0)return false;if(conditions.length>1)return{"and":conditions};return conditions[0];}/**
   * Returns parent's section's conditions in case it has one
   * Spec: Same as getParentConditions, it's just the last line, the section's
   * condition
   * @param {number} id
   */},{key:'getSectionConditions',value:function getSectionConditions(option_id){var section_index=void 0;// Looking for section
__WEBPACK_IMPORTED_MODULE_0__references__["a" /* default */].sections.map(function(section,index){if(section.options.includes(option_id))section_index=index;});if(typeof section_index!=='number'){return false;}var section=__WEBPACK_IMPORTED_MODULE_0__references__["a" /* default */].sections[section_index];if(Array.isArray(section.convertConditions)&&section.convertConditions.length>0){return this.convertConditions(section.convertConditions);}else{return false;}}}]);return JsonLogicParser;}();/* harmony default export */ __webpack_exports__["a"] = (JsonLogicParser);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__condition_evo__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wrapper__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__references__ = __webpack_require__(363);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var JsonLogicApplier=function(){/**
     * Constuctor
     */function JsonLogicApplier(conditions){var copy=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var id=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;_classCallCheck(this,JsonLogicApplier);// Making sure the conditions object if valid
if(!("data_map"in conditions)||!("logic"in conditions))throw new Error('Conditions object is not a valid LP-JsonLogic');this.logic=conditions.logic;this.data_map=conditions.data_map;// Getting Multiples object from ConditionsEvo
this.multiples=__WEBPACK_IMPORTED_MODULE_1__condition_evo__["a" /* default */].multiples;// The id of the conditions
this.id=parseInt(id);// Parents Tree
this.parentsTree=__WEBPACK_IMPORTED_MODULE_3__references__["a" /* default */].getParentsTree();// Conditionned options list
this.conditionnedOptions=__WEBPACK_IMPORTED_MODULE_3__references__["a" /* default */].getConditionnedOptions();// Multiples dependencies list
this.multiplesDependencies=__WEBPACK_IMPORTED_MODULE_3__references__["a" /* default */].getMultiplesDependencies();// Populating data from data map
this.data=this.populateData(copy);}/**
     * Populates data from lpApp according to the data_map
     * if it recieves the copy, it makes sure only data related
     * to that copy is filled instead of an array with all siblings values
     * @param {string} copy  - Multiple's copy
     */_createClass(JsonLogicApplier,[{key:"populateData",value:function populateData(){var _this=this;var copy=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var data={option:{},variable:{},condition:{}};// Getting options
this.data_map.options.forEach(function(id){var value=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.options.getOption(id).value;// Checking if it's a multiple
var multiple_id=_this.isOptionMultiple(id);if(multiple_id!==false){if(copy===false&&!_this.isOptionEligibleForMultiple(multiple_id)){// Transforming to an array
value=[value];if(_this.multiples[multiple_id]){// Getting all copies
var copies=_this.multiples[multiple_id].copies;if(Array.isArray(copies)){copies.forEach(function(copy){value.push(__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.options.getOption(id+'_'+copy).value);});}}}else{// If the copy isn't false we get the option's copy, otherwise, it's the index 0 of the multiple
var key=copy===false?id:id+'_'+copy;value=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.options.getOption(key).value;}}data.option[id]=value;});// Getting variables
this.data_map.variables.forEach(function(id){var value=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.variables.getVariable(id).value;var parent_id=_this.parentsTree.variables[id][0];// Checking if it's a multiple
var multiple_id=_this.isOptionMultiple(parent_id);if(multiple_id!==false){if(copy===false&&!_this.isOptionEligibleForMultiple(multiple_id)){// Transforming to an array
value=[value];// Getting all copies
var copies=_this.multiples[multiple_id].copies;if(Array.isArray(copies)){copies.forEach(function(copy){value.push(__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.variables.getVariable(id+'_'+copy).value);});}}else{// If the copy isn't false we get the variable's copy, otherwise, it's the index 0 of the multiple
var key=copy===false?id:id+'_'+copy;value=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.variables.getVariable(key).value;}}data.variable[id]=value;});// Getting conditions
this.data_map.conditions.forEach(function(id){var value=__WEBPACK_IMPORTED_MODULE_1__condition_evo__["a" /* default */].getCondition(id);// Checking if it's a multiple
var multiple_id=_this.isOptionMultiple(id);if(multiple_id!==false){if(copy===false&&!_this.isOptionEligibleForMultiple(multiple_id)){// Transforming to an array
value=[value];// Getting all copies
var copies=_this.multiples[multiple_id].copies;if(Array.isArray(copies)){copies.forEach(function(copy){var key=copy?id+'_'+copy:id;value.push(__WEBPACK_IMPORTED_MODULE_1__condition_evo__["a" /* default */].getCondition(key));});}}else{var key=copy?id+'_'+copy:id;value=__WEBPACK_IMPORTED_MODULE_1__condition_evo__["a" /* default */].getCondition(key);}}data.condition[id]=value;});return data;}/**
     * Returns the parent multiple id if the option belongs to
     * a multiple, otherwise it returns false
     * @param {number} id - option's id
     */},{key:"isOptionMultiple",value:function isOptionMultiple(id){var _this2=this;var found=false;if(typeof id==='undefined')throw new Error('Corrupt condition found on id '+this.id);// Checking if the option itself is multiple
if(this.multiples.hasOwnProperty(id.toString())){found=id;}// Checking if it belongs to a multiple
Object.keys(this.multiples).forEach(function(key){if(_this2.multiples[key].descendants.options.includes(parseInt(id,10))){found=key;}});// Checking if option is a child of a repeated option (it's considered as a multiple then)
Object.keys(this.multiplesDependencies).forEach(function(key){if(_this2.multiplesDependencies[key].includes(parseInt(id,10))){found=key;}});return found;}/**
     * Checks if current copy is eligible for a multiple
     * @param {number} id
     */},{key:"isOptionEligibleForMultiple",value:function isOptionEligibleForMultiple(id){// Making sure copy is part of this multiple in case we recieve it
if(this.id!==false&&id!==false){if(!this.multiplesDependencies[id].includes(parseInt(this.id,10)))return false;}return true;}/**
   * Executes condition with jsonLogic
   */},{key:"apply",value:function apply(){return __WEBPACK_IMPORTED_MODULE_2__wrapper__["a" /* default */].apply(this.logic,this.data);}}]);return JsonLogicApplier;}();/* harmony default export */ __webpack_exports__["a"] = (JsonLogicApplier);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_logic_js__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_logic_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_logic_js__);
/**
 * Reduces parents values arrays into a single boolean array
 * @param parents boolean[][]
 * @param length values length
 */var reduceParents=function reduceParents(parents,length){var reducedParents=[];// Getting biggest parents array
parents.sort(function(a,b){return b.length-a.length;});// Getting indexes length
var _loop=function _loop(index){var currentIndexResult=parents.reduce(function(previousValue,currentValue){if(currentValue.length===1)return previousValue&&currentValue[0];if(currentValue[index]===undefined)return false;return previousValue&&currentValue[index];},true);reducedParents[index]=currentIndexResult;};for(var index=0;index<length;index+=1){_loop(index);}return reducedParents;};/**
 * Equals
 */var safeEqual=function safeEqual(value,comparator){if(!isNaN(comparator)){if(!isNaN(value)){return parseFloat(value)===parseFloat(comparator);}return false;}if(!isNaN(value)){return false;}return value===comparator;};/**
 * Reduces values with parents
 * @param values Values array
 * @param parents Parents array
 * @param compareFunction Compare function
 */var reduceValues=function reduceValues(values,parents,compareFunction){// If variable/option has no parents
if(parents===undefined||parents.length===0){return values.map(function(currentValue){return compareFunction(currentValue,true);});}// If variable/option has parents
var reducedParents=reduceParents(parents,values.length);return values.map(function(currentValue,index){return compareFunction(currentValue,reducedParents[index]);});};/**
 * Additionnal operations
 *//**
 * SELECTED
 * --------
 * Make sure values are true, in case of an array, all array's values
 * must be true too
 */__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a.add_operation("selected",function(value){if(!Array.isArray(value)){return value===true;}else{var filter=value.filter(function(_value){return _value===true;});return value.length===filter.length;}});/**
 * NOT-SELECTED
 * ------------
 * Make sure values are false, in case of an array, all array's values
 * must be false too
 */__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a.add_operation("not-selected",function(value){if(!Array.isArray(value)){return value===false;}else{var filter=value.filter(function(_value){return _value===false;});return value.length===filter.length;}});/**
 * HAS-ONE
 * -------
 * Value must be an array of 1 element only
 */__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a.add_operation("has-one",function(value){if(!Array.isArray(value)){return true;}else{return value.length===1;}});/**
 * AT-LEAST-ONE
 * -------
 * Value must be an array with at least one element
 */__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a.add_operation("at-least-one",function(value){if(!Array.isArray(value)){return true;}else{return value.includes(true);}});/**
 * HAS-MANY
 * --------
 * Value must be an array of more then 1 element
 */__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a.add_operation("has-many",function(value){if(!Array.isArray(value)){return false;}else{return value.length>1;}});__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a.add_operation("=",function(values,comparator,parents){// Reducing value with parents
var reducedValues=reduceValues(values||[],parents,function(value,parent){return safeEqual(value,comparator)&&parent;});var filter=reducedValues.filter(function(_value){return _value===true;});return reducedValues.length===filter.length;});/**
 * CONTAINS
 * --------
 * Warning: The name is misleading
 * Value must be equal to the comparator
 * in case of an array, all of it's values must
 * be equal to the comparator
 */__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a.add_operation("contains",function(value,comparator){if(!Array.isArray(value)){return value===comparator;}else{var filter=value.filter(function(_value){return _value===comparator;});return value.length===filter.length;}});/**
 * DOES-NOT-CONTAIN
 * ----------------
 * Warning: The name is misleading
 * Value must not be equal to the comparator
 * in case of an array, all of it's values must
 * not be equal to the comparator
 */__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a.add_operation("does-not-contain",function(value,comparator){if(!Array.isArray(value)){return value!==comparator;}else{var filter=value.filter(function(_value){return _value!==comparator;});return value.length===filter.length;}});/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_json_logic_js___default.a);

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* globals define,module */
/*
Using a Universal Module Loader that should be browser, require, and AMD friendly
http://ricostacruz.com/cheatsheets/umdjs.html
*/
;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === "object") {
    module.exports = factory();
  } else {
    root.jsonLogic = factory();
  }
}(this, function() {
  "use strict";
  /* globals console:false */

  if ( ! Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    };
  }

  /**
   * Return an array that contains no duplicates (original not modified)
   * @param  {array} array   Original reference array
   * @return {array}         New array with no duplicates
   */
  function arrayUnique(array) {
    var a = [];
    for (var i=0, l=array.length; i<l; i++) {
      if (a.indexOf(array[i]) === -1) {
        a.push(array[i]);
      }
    }
    return a;
  }

  var jsonLogic = {};
  var operations = {
    "==": function(a, b) {
      return a == b;
    },
    "===": function(a, b) {
      return a === b;
    },
    "!=": function(a, b) {
      return a != b;
    },
    "!==": function(a, b) {
      return a !== b;
    },
    ">": function(a, b) {
      return a > b;
    },
    ">=": function(a, b) {
      return a >= b;
    },
    "<": function(a, b, c) {
      return (c === undefined) ? a < b : (a < b) && (b < c);
    },
    "<=": function(a, b, c) {
      return (c === undefined) ? a <= b : (a <= b) && (b <= c);
    },
    "!!": function(a) {
      return jsonLogic.truthy(a);
    },
    "!": function(a) {
      return !jsonLogic.truthy(a);
    },
    "%": function(a, b) {
      return a % b;
    },
    "log": function(a) {
      console.log(a); return a;
    },
    "in": function(a, b) {
      if(!b || typeof b.indexOf === "undefined") return false;
      return (b.indexOf(a) !== -1);
    },
    "cat": function() {
      return Array.prototype.join.call(arguments, "");
    },
    "substr":function(source, start, end) {
      if(end < 0){
        // JavaScript doesn't support negative end, this emulates PHP behavior
        var temp = String(source).substr(start);
        return temp.substr(0, temp.length + end);
      }
      return String(source).substr(start, end);
    },
    "+": function() {
      return Array.prototype.reduce.call(arguments, function(a, b) {
        return parseFloat(a, 10) + parseFloat(b, 10);
      }, 0);
    },
    "*": function() {
      return Array.prototype.reduce.call(arguments, function(a, b) {
        return parseFloat(a, 10) * parseFloat(b, 10);
      });
    },
    "-": function(a, b) {
      if(b === undefined) {
        return -a;
      }else{
        return a - b;
      }
    },
    "/": function(a, b) {
      return a / b;
    },
    "min": function() {
      return Math.min.apply(this, arguments);
    },
    "max": function() {
      return Math.max.apply(this, arguments);
    },
    "merge": function() {
      return Array.prototype.reduce.call(arguments, function(a, b) {
        return a.concat(b);
      }, []);
    },
    "var": function(a, b) {
      var not_found = (b === undefined) ? null : b;
      var data = this;
      if(typeof a === "undefined" || a==="" || a===null) {
        return data;
      }
      var sub_props = String(a).split(".");
      for(var i = 0; i < sub_props.length; i++) {
        if(data === null) {
          return not_found;
        }
        // Descending into data
        data = data[sub_props[i]];
        if(data === undefined) {
          return not_found;
        }
      }
      return data;
    },
    "missing": function() {
      /*
      Missing can receive many keys as many arguments, like {"missing:[1,2]}
      Missing can also receive *one* argument that is an array of keys,
      which typically happens if it's actually acting on the output of another command
      (like 'if' or 'merge')
      */

      var missing = [];
      var keys = Array.isArray(arguments[0]) ? arguments[0] : arguments;

      for(var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = jsonLogic.apply({"var": key}, this);
        if(value === null || value === "") {
          missing.push(key);
        }
      }

      return missing;
    },
    "missing_some": function(need_count, options) {
      // missing_some takes two arguments, how many (minimum) items must be present, and an array of keys (just like 'missing') to check for presence.
      var are_missing = jsonLogic.apply({"missing": options}, this);

      if(options.length - are_missing.length >= need_count) {
        return [];
      }else{
        return are_missing;
      }
    },
    "method": function(obj, method, args) {
      return obj[method].apply(obj, args);
    },

  };

  jsonLogic.is_logic = function(logic) {
    return (
      typeof logic === "object" && // An object
      logic !== null && // but not null
      ! Array.isArray(logic) && // and not an array
      Object.keys(logic).length === 1 // with exactly one key
    );
  };

  /*
  This helper will defer to the JsonLogic spec as a tie-breaker when different language interpreters define different behavior for the truthiness of primitives.  E.g., PHP considers empty arrays to be falsy, but Javascript considers them to be truthy. JsonLogic, as an ecosystem, needs one consistent answer.

  Spec and rationale here: http://jsonlogic.com/truthy
  */
  jsonLogic.truthy = function(value) {
    if(Array.isArray(value) && value.length === 0) {
      return false;
    }
    return !! value;
  };


  jsonLogic.get_operator = function(logic) {
    return Object.keys(logic)[0];
  };

  jsonLogic.get_values = function(logic) {
    return logic[jsonLogic.get_operator(logic)];
  };

  jsonLogic.apply = function(logic, data) {
    // Does this array contain logic? Only one way to find out.
    if(Array.isArray(logic)) {
      return logic.map(function(l) {
        return jsonLogic.apply(l, data);
      });
    }
    // You've recursed to a primitive, stop!
    if( ! jsonLogic.is_logic(logic) ) {
      return logic;
    }

    data = data || {};

    var op = jsonLogic.get_operator(logic);
    var values = logic[op];
    var i;
    var current;
    var scopedLogic, scopedData, filtered, initial;

    // easy syntax for unary operators, like {"var" : "x"} instead of strict {"var" : ["x"]}
    if( ! Array.isArray(values)) {
      values = [values];
    }

    // 'if', 'and', and 'or' violate the normal rule of depth-first calculating consequents, let each manage recursion as needed.
    if(op === "if" || op == "?:") {
      /* 'if' should be called with a odd number of parameters, 3 or greater
      This works on the pattern:
      if( 0 ){ 1 }else{ 2 };
      if( 0 ){ 1 }else if( 2 ){ 3 }else{ 4 };
      if( 0 ){ 1 }else if( 2 ){ 3 }else if( 4 ){ 5 }else{ 6 };

      The implementation is:
      For pairs of values (0,1 then 2,3 then 4,5 etc)
      If the first evaluates truthy, evaluate and return the second
      If the first evaluates falsy, jump to the next pair (e.g, 0,1 to 2,3)
      given one parameter, evaluate and return it. (it's an Else and all the If/ElseIf were false)
      given 0 parameters, return NULL (not great practice, but there was no Else)
      */
      for(i = 0; i < values.length - 1; i += 2) {
        if( jsonLogic.truthy( jsonLogic.apply(values[i], data) ) ) {
          return jsonLogic.apply(values[i+1], data);
        }
      }
      if(values.length === i+1) return jsonLogic.apply(values[i], data);
      return null;
    }else if(op === "and") { // Return first falsy, or last
      for(i=0; i < values.length; i+=1) {
        current = jsonLogic.apply(values[i], data);
        if( ! jsonLogic.truthy(current)) {
          return current;
        }
      }
      return current; // Last
    }else if(op === "or") {// Return first truthy, or last
      for(i=0; i < values.length; i+=1) {
        current = jsonLogic.apply(values[i], data);
        if( jsonLogic.truthy(current) ) {
          return current;
        }
      }
      return current; // Last




    }else if(op === 'filter'){
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];

      if ( ! Array.isArray(scopedData)) {
          return [];
      }
      // Return only the elements from the array in the first argument,
      // that return truthy when passed to the logic in the second argument.
      // For parity with JavaScript, reindex the returned array
      return scopedData.filter(function(datum){
          return jsonLogic.truthy( jsonLogic.apply(scopedLogic, datum));
      });
  }else if(op === 'map'){
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];

      if ( ! Array.isArray(scopedData)) {
          return [];
      }

      return scopedData.map(function(datum){
          return jsonLogic.apply(scopedLogic, datum);
      });

  }else if(op === 'reduce'){
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];
      initial = typeof values[2] !== 'undefined' ? values[2] : null;

      if ( ! Array.isArray(scopedData)) {
          return initial;
      }

      return scopedData.reduce(
          function(accumulator, current){
              return jsonLogic.apply(
                  scopedLogic,
                  {'current':current, 'accumulator':accumulator}
              );
          },
          initial
      );

    }else if(op === "all") {
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];
      // All of an empty set is false. Note, some and none have correct fallback after the for loop
      if( ! scopedData.length) {
        return false;
      }
      for(i=0; i < scopedData.length; i+=1) {
        if( ! jsonLogic.truthy( jsonLogic.apply(scopedLogic, scopedData[i]) )) {
          return false; // First falsy, short circuit
        }
      }
      return true; // All were truthy
    }else if(op === "none") {
      filtered = jsonLogic.apply({'filter' : values}, data);
      return filtered.length === 0;

    }else if(op === "some") {
      filtered = jsonLogic.apply({'filter' : values}, data);
      return filtered.length > 0;
    }

    // Everyone else gets immediate depth-first recursion
    values = values.map(function(val) {
      return jsonLogic.apply(val, data);
    });


    // The operation is called with "data" bound to its "this" and "values" passed as arguments.
    // Structured commands like % or > can name formal arguments while flexible commands (like missing or merge) can operate on the pseudo-array arguments
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments
    if(typeof operations[op] === "function") {
      return operations[op].apply(data, values);
    }else if(op.indexOf(".") > 0) { // Contains a dot, and not in the 0th position
      var sub_ops = String(op).split(".");
      var operation = operations;
      for(i = 0; i < sub_ops.length; i++) {
        // Descending into operations
        operation = operation[sub_ops[i]];
        if(operation === undefined) {
          throw new Error("Unrecognized operation " + op +
          " (failed at " + sub_ops.slice(0, i+1).join(".") + ")");
        }
      }

      return operation.apply(data, values);
    }

    throw new Error("Unrecognized operation " + op );
  };

  jsonLogic.uses_data = function(logic) {
    var collection = [];

    if( jsonLogic.is_logic(logic) ) {
      var op = jsonLogic.get_operator(logic);
      var values = logic[op];

      if( ! Array.isArray(values)) {
        values = [values];
      }

      if(op === "var") {
        // This doesn't cover the case where the arg to var is itself a rule.
        collection.push(values[0]);
      }else{
        // Recursion!
        values.map(function(val) {
          collection.push.apply(collection, jsonLogic.uses_data(val) );
        });
      }
    }

    return arrayUnique(collection);
  };

  jsonLogic.add_operation = function(name, code) {
    operations[name] = code;
  };

  jsonLogic.rm_operation = function(name) {
    delete operations[name];
  };

  jsonLogic.rule_like = function(rule, pattern) {
    // console.log("Is ". JSON.stringify(rule) . " like " . JSON.stringify(pattern) . "?");
    if(pattern === rule) {
      return true;
    } // TODO : Deep object equivalency?
    if(pattern === "@") {
      return true;
    } // Wildcard!
    if(pattern === "number") {
      return (typeof rule === "number");
    }
    if(pattern === "string") {
      return (typeof rule === "string");
    }
    if(pattern === "array") {
      // !logic test might be superfluous in JavaScript
      return Array.isArray(rule) && ! jsonLogic.is_logic(rule);
    }

    if(jsonLogic.is_logic(pattern)) {
      if(jsonLogic.is_logic(rule)) {
        var pattern_op = jsonLogic.get_operator(pattern);
        var rule_op = jsonLogic.get_operator(rule);

        if(pattern_op === "@" || pattern_op === rule_op) {
        // echo "\nOperators match, go deeper\n";
          return jsonLogic.rule_like(
            jsonLogic.get_values(rule, false),
            jsonLogic.get_values(pattern, false)
          );
        }
      }
      return false; // pattern is logic, rule isn't, can't be eq
    }

    if(Array.isArray(pattern)) {
      if(Array.isArray(rule)) {
        if(pattern.length !== rule.length) {
          return false;
        }
        /*
          Note, array order MATTERS, because we're using this array test logic to consider arguments, where order can matter. (e.g., + is commutative, but '-' or 'if' or 'var' are NOT)
        */
        for(var i = 0; i < pattern.length; i += 1) {
          // If any fail, we fail
          if( ! jsonLogic.rule_like(rule[i], pattern[i])) {
            return false;
          }
        }
        return true; // If they *all* passed, we pass
      }else{
        return false; // Pattern is array, rule isn't
      }
    }

    // Not logic, not array, not a === match for rule.
    return false;
  };

  return jsonLogic;
}));


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_condition_evo__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/variables.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpVariablesIndex=function(){function LpVariablesIndex(){_classCallCheck(this,LpVariablesIndex);this.variables={};}_createClass(LpVariablesIndex,[{key:'updateVariable',value:function updateVariable(var_){var i=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(var_){var changeStatus=false;if(this.variables[var_.id]&&this.variables[var_.id].value!==var_.value){changeStatus=true;}else if(!this.variables[var_.id])changeStatus=true;this.variables[var_.id]={value:var_.value,index:i};if(changeStatus===true)__WEBPACK_IMPORTED_MODULE_1__logic_condition_evo__["a" /* default */].execVariableHook(var_.id);}}},{key:'loadFromO',value:function loadFromO(){var _this=this;var os=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().loadedOvc.vF;if(os&&Object.keys(os).length>0)Object.keys(os).map(function(idx){return _this.updateVariable({id:idx,value:os[idx]});},this);}},{key:'delVariable',value:function delVariable(id){if(Object.prototype.hasOwnProperty.call(this.variables,id))delete this.variables[id];}},{key:'getVariable',value:function getVariable(id){if(this.variables[id])return this.variables[id];// let loaded_variable = getVariablePass(id)
// if(loaded_variable)
//     return {value: loaded_variable};
return{value:''};}}]);return LpVariablesIndex;}();/* harmony default export */ __webpack_exports__["a"] = (LpVariablesIndex);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/conditions_dependencies.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpConditionDependenciesIndex=function(){function LpConditionDependenciesIndex(){_classCallCheck(this,LpConditionDependenciesIndex);this.dependencies={};this.var_dependencies={};}_createClass(LpConditionDependenciesIndex,[{key:'buildDependencies',value:function buildDependencies(){var _this=this;var opts=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options;if(opts){var allKeys=Object.keys(opts);allKeys.forEach(function(idx){var now=opts[idx];if(now.meta.conditional){now.meta.conditions.forEach(function(jdx){if(idx.o!==false&&jdx.o){if(typeof _this.dependencies[jdx.o]==='undefined'){_this.dependencies[jdx.o]=[now.meta.id];}else{_this.dependencies[jdx.o].push(now.meta.id);}}else if(idx.o!==false&&jdx.v){if(typeof _this.var_dependencies[jdx.v]==='undefined'){_this.var_dependencies[jdx.v]=[now.meta.id];}else{_this.var_dependencies[jdx.v].push(now.meta.id);}}},_this);}},this);}}},{key:'getDependecies',value:function getDependecies(id){return this.dependencies[id];}},{key:'getVariableDependecies',value:function getVariableDependecies(id){return this.var_dependencies[id];}}]);return LpConditionDependenciesIndex;}();/* harmony default export */ __webpack_exports__["a"] = (LpConditionDependenciesIndex);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_condition_evo__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/conditions.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpConditionsIndex=function(){function LpConditionsIndex(){_classCallCheck(this,LpConditionsIndex);this.conditions={};}_createClass(LpConditionsIndex,[{key:'updateConditions',value:function updateConditions(){var _this=this;var keys=void 0;if(!__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.isLoaded())return;var la=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].action_tracker.last_action;if(la==='EDIT_OPTION_RADIO_'||la==='SET_SECTION_ID'||la==='EDIT_OPTION_VALUE_'){keys=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.dependencies.getDependecies(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].action_tracker.la_arg1));if(keys){keys.forEach(function(idx){var now=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[idx].meta;if(now.conditional&&now.compiledConditions.length>0){// let c = new ConditionRuntime(now.compiledConditions);
// c.compileDirect()
// // console.log(c)
// this.conditions[idx] = c.execute(true);
_this.conditions[idx]=__WEBPACK_IMPORTED_MODULE_2__logic_condition_evo__["a" /* default */].getCondition(idx);}});}}}},{key:'getCondition',value:function getCondition(cond){return this.conditions[cond];}},{key:'setCondition',value:function setCondition(cond,val){this.conditions[cond]=val;}},{key:'buildConditions',value:function buildConditions(tree){this.conditions=tree;}}]);return LpConditionsIndex;}();/* harmony default export */ __webpack_exports__["a"] = (LpConditionsIndex);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_thunk__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customTest__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__count_things__ = __webpack_require__(861);
/*
 * Project: LegalPlace assistant
 * File: src\middlewares\middlewares.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// in this phase we import other middleware (csutom)
// declare everything
// adding thunk middleware
var middlewares=[// trialMiddleware,
__WEBPACK_IMPORTED_MODULE_2__count_things__["a" /* countThings */],__WEBPACK_IMPORTED_MODULE_0_redux_thunk__["a" /* default */]];/* harmony default export */ __webpack_exports__["a"] = (middlewares);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export trialMiddleware */
/*
 * Project: LegalPlace assistant
 * File: src\middlewares\customTest.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var trialMiddleware=function trialMiddleware(store){return function(next){return function(action){next(action);};};};

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countThings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logic_action_counter__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_lp_app__ = __webpack_require__(2);
/*
* Project: LegalPlace assistant
* File: src/middlewares/count_things.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var countThings=function countThings(store){return function(next){return function(action){if(action.type=='EDIT_VARIABLE_VALUE_'&&__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].mutex.checkMutex('preview'))Object(__WEBPACK_IMPORTED_MODULE_0__logic_action_counter__["d" /* raiseVariable */])(action.id);// this one is the magic key.
if(__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].mutex.checkMutex('preview'))__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].action_tracker.trackAction(action.type,action.id);next(action);};};};

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contract__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__output__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__option_hover__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flat_ui__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_settings__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_state__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__input_context__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__toggle_preview__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__checkout_operations__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loading__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__document_state__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__load_ovc__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lperrors__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_load_ovc__ = __webpack_require__(236);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\root.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// import every single reducer, to manage the context
var lpReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({empty:__WEBPACK_IMPORTED_MODULE_1__global__["a" /* empty */],loading:__WEBPACK_IMPORTED_MODULE_1__global__["b" /* loading */],contract:__WEBPACK_IMPORTED_MODULE_2__contract__["a" /* ccontract */],output:__WEBPACK_IMPORTED_MODULE_3__output__["a" /* outputReducer */],error:__WEBPACK_IMPORTED_MODULE_4__error__["a" /* default */],optionHover:__WEBPACK_IMPORTED_MODULE_5__option_hover__["a" /* optionHoverReducer */],flat:__WEBPACK_IMPORTED_MODULE_6__flat_ui__["a" /* default */],account_settings:__WEBPACK_IMPORTED_MODULE_7__account_settings__["a" /* account_settings */],views:__WEBPACK_IMPORTED_MODULE_8__views__["a" /* default */],appstate:__WEBPACK_IMPORTED_MODULE_9__app_state__["a" /* appStateReducer */],input_context:__WEBPACK_IMPORTED_MODULE_10__input_context__["a" /* inputContext */],preview:__WEBPACK_IMPORTED_MODULE_11__toggle_preview__["b" /* togglePreviewReducer */],checkout_operations:__WEBPACK_IMPORTED_MODULE_12__checkout_operations__["a" /* default */],popover:__WEBPACK_IMPORTED_MODULE_11__toggle_preview__["a" /* popoverReducer */],loading_details:__WEBPACK_IMPORTED_MODULE_13__loading__["a" /* loadingDetails */],document_state:__WEBPACK_IMPORTED_MODULE_14__document_state__["a" /* documentStateReducer */],loadedOvc:__WEBPACK_IMPORTED_MODULE_15__load_ovc__["b" /* updateOVCReducer */],errors:__WEBPACK_IMPORTED_MODULE_16__lperrors__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (lpReducer);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = empty;
/* harmony export (immutable) */ __webpack_exports__["b"] = loading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_empty__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_loading__ = __webpack_require__(79);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\global.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */function empty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var action=arguments[1];if(action.type==__WEBPACK_IMPORTED_MODULE_0__actions_empty__["a" /* SET_EMPTY */])return true;if(action.type==__WEBPACK_IMPORTED_MODULE_0__actions_empty__["b" /* UNSET_EMPTY */]){return false;}return state;}function loading(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];if(action.type==__WEBPACK_IMPORTED_MODULE_1__actions_loading__["c" /* IS_LOADING */]){return true;}if(action.type==__WEBPACK_IMPORTED_MODULE_1__actions_loading__["d" /* NOT_LOADING */]){return false;}return state;}

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSET_EMPTY; });
/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\empty.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var SET_EMPTY='SET_EMPTY';var UNSET_EMPTY='NO_EMPTY';// TODO: optimize with inline
function setEmpty(is_empty){if(is_empty){return{type:SET_EMPTY};}return{type:UNSET_EMPTY};}/* unused harmony default export */ var _unused_webpack_default_export = (setEmpty);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_section__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_option__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__option__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_history__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\section.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// options
function rSection(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{label:'',option_ids:[],id:1,conditional:false,compiled_condition:[]};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_section__["a" /* ADD_SECTION */]:{var section=action.section;var sId=action.sId,isaNav=action.isaNav;var redirCondition=isaNav===undefined?true:isaNav;var result={label:section.label,option_ids:section.options,id:section.id};var options=result.option_ids.map(function(el){return Object(__WEBPACK_IMPORTED_MODULE_2__option__["a" /* default */])({},Object(__WEBPACK_IMPORTED_MODULE_1__actions_option__["c" /* addOption */])(el));});if(section.compiledConditions&&section.compiledConditions.length>0){result.conditional=true;result.compiled_condition=section.compiledConditions;}else{result.conditional=false;result.compiled_condition=null;}result.options_render=options;return result;}default:{return state;}}}

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optionReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_option__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variable__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_variable__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic_option_wrapper__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_lp_app__ = __webpack_require__(2);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\option.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// TODO: update the conditions after repeating every thing.
function optionReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_option__["a" /* ADD_OPTION */]:{var opt=new __WEBPACK_IMPORTED_MODULE_3__logic_option_wrapper__["a" /* OptionWrapper */](__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].references.getOption(action.id));// quick test if the father is good
var par=new __WEBPACK_IMPORTED_MODULE_3__logic_option_wrapper__["a" /* OptionWrapper */](__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].references.getOption(opt.parentId));var result={id:opt.id,type:opt.type,label:opt.label,options:opt.children,variables:opt.variables,multiple:opt.is_multiple,papa_multiple:opt.is_multiple&&!par.is_multiple};result.variable_renderer=result.variables.map(function(idx){return Object(__WEBPACK_IMPORTED_MODULE_1__variable__["a" /* default */])({},Object(__WEBPACK_IMPORTED_MODULE_2__actions_variable__["c" /* createVariable */])(idx));});result.option_renderer=result.options.map(function(idx){return optionReducer({},Object(__WEBPACK_IMPORTED_MODULE_0__actions_option__["c" /* addOption */])(idx));});return result;}case __WEBPACK_IMPORTED_MODULE_0__actions_option__["b" /* REMOVE_OPTION */]:return{};default:return state;}}

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = variableReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_variable__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_variable_wrapper__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\variable.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */function variableReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_variable__["a" /* ADD_VARIABLE */]:{var wrappedVariable=new __WEBPACK_IMPORTED_MODULE_1__logic_variable_wrapper__["a" /* VariableWrapper */](__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.getVariable(action.id));return Object.assign({},state,{id:wrappedVariable.id,type:wrappedVariable.type,helper:wrappedVariable.helper,label:wrappedVariable.label});}case __WEBPACK_IMPORTED_MODULE_0__actions_variable__["b" /* REMOVE_VARIABLE */]:return state;default:return state;}}

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_map_utils__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__section__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src\logic\json_to_contract.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// import './jsonTestModel';
// import { OptionWrapper } from './option_wrapper';
//These are names, don't worry about it
var Contract=function(){function Contract(obj){_classCallCheck(this,Contract);this.s={};this.name="";this.sections=new Object();this.variables={};this.options={};this.initial_options=[];this.total_sections=0;this.contract_version=0;this.s=obj;this.name=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].references.customs.get('title');this.options=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["j" /* OPTIONS */]];this.variables=obj[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["q" /* VARIABLES */]];this.contract_version=obj['version_id'];// 
this.loadSection();this.total_sections=this.getTotalSections();}// TODO: optimize the code by cloning the `variables` and `options`
_createClass(Contract,[{key:'getTotalSections',value:function getTotalSections(){return Object.keys(this.sections).length;}// TODO: check secitons if they exist
},{key:'getSections',value:function getSections(){if(__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["a" /* ARCHITECTURE */] in this.s)if(__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["n" /* SECTIONS */] in this.s[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["a" /* ARCHITECTURE */]])return this.s[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["a" /* ARCHITECTURE */]][__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["n" /* SECTIONS */]];return null;}// check if the section exists
},{key:'checkSection',value:function checkSection(s_id){// here we'll do a lazy search by ID 
// TODO: Accelerate the data retreiving by loading the sections in a sequential array
var tmp=this.s[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["a" /* ARCHITECTURE */]][__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["n" /* SECTIONS */]];for(var i in tmp){if(i==s_id)return i;}return false;}},{key:'loadSection',value:function loadSection(){var ss=this.s[__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["a" /* ARCHITECTURE */]][__WEBPACK_IMPORTED_MODULE_0__lp_map_utils__["n" /* SECTIONS */]];for(var i in ss){// 
this.sections[i]=new __WEBPACK_IMPORTED_MODULE_1__section__["a" /* Section */](ss[i]);// try the load fenyane for the sections
this.sections[i].loadFenyan(this.options,this.variables);}}}]);return Contract;}();/* harmony default export */ __webpack_exports__["a"] = (Contract);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Section; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__option_wrapper__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lp_map_utils__ = __webpack_require__(109);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src\logic\section.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// TODO: add more option names here
var Section=function(){function Section(obj){_classCallCheck(this,Section);this.id=0;this.label="";this.options=[];this.options_extracted=[];// TODO: Check if the thing is null or not
this.id=obj['id'];this.label=obj[__WEBPACK_IMPORTED_MODULE_1__lp_map_utils__["f" /* LABEL */]];this.options=obj[__WEBPACK_IMPORTED_MODULE_1__lp_map_utils__["k" /* OPTS */]];}// lazy loading for options
_createClass(Section,[{key:'loadFenyan',value:function loadFenyan(opts_ref,vars_ref){// Some optimization
var opts=this.options;// load
for(var i in opts){var tmp_opt_id=opts[i];var tmp_opt=new __WEBPACK_IMPORTED_MODULE_0__option_wrapper__["a" /* OptionWrapper */](opts_ref[tmp_opt_id]);tmp_opt.loadFenyanVariables(vars_ref);this.options_extracted[i]=tmp_opt;}}}]);return Section;}();

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(871);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 871 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeAutoSaveCookiesWP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return autosave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkAutosave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ovc_converter__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_lp_app__ = __webpack_require__(2);
/*
 * Project: LegalPlace assistant
 * File: src\logic\autosave.js
 * Author: Amine Azizi
 * Version: 1.0
 */var removeAutoSaveCookiesWP=function removeAutoSaveCookiesWP(){var cookies=new __WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */]();var hostname=window.location.hostname;var hostProd='legalplace.fr';var hostStaging='legalplace.eu';var hostLocal='localhost';var origin=hostname.indexOf(hostProd)>-1?'.'+hostProd:hostname.indexOf(hostStaging)>-1?'.'+hostStaging:hostLocal;cookies.remove('autoSave',{path:'/',domain:origin});};function autosave(){if(!__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].isPayed){if(typeof Storage!=='function')return false;// Document data
var data=Object(__WEBPACK_IMPORTED_MODULE_1__ovc_converter__["a" /* getAllOptions */])();var dataStringified=JSON.stringify(data);var checkout=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().appstate===2;var modelParams=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].references.customs.custom;// Contract's uniqid
var contractUniqid=false;if(typeof __WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractUniqid==='string'&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractUniqid.length>0){;contractUniqid=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractUniqid;}if(!contractUniqid&&typeof __WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().checkout_operations.contract_id==='string'&&__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().checkout_operations.contract_id.length>0)contractUniqid=__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().checkout_operations.contract_id;// Document info
var info={permalink:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].contractTitle,save_on:new Date().getTime(),title:__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.name,section:1+__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.currentSection,contract_id:contractUniqid,checkout:checkout};// Bar wording
if(typeof modelParams!=='undefined'&&typeof modelParams.reprise!=='undefined'){info.barWording=modelParams.reprise;}var infoStringified=JSON.stringify(info);// HERE DELETE COOKIES of autoSAve (SIV and others apps)
removeAutoSaveCookiesWP();// disable autosave
// window.localStorage.setItem('autosave_data', dataStringified);
// window.localStorage.setItem('autosave_info', infoStringified);
}}function checkAutosave(){if(typeof Storage!=='function')return false;var dataStringified=window.localStorage.getItem('autosave_data');var infoStringified=window.localStorage.getItem('autosave_info');if(dataStringified&&infoStringified){var data=JSON.parse(dataStringified);var info=JSON.parse(infoStringified);// Checking for title
if(info.title!==__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].getState().contract.name)return false;// Checking section
if(typeof info.section==='undefined')return false;// Tracking on lpevents
if(typeof __WEBPACK_IMPORTED_MODULE_2__tracking_lpevents__["a" /* default */]!=='undefined')__WEBPACK_IMPORTED_MODULE_2__tracking_lpevents__["a" /* default */].track('Continue on autosave');// Removing current info
window.localStorage.removeItem('autosave_data');window.localStorage.removeItem('autosave_info');return{data:data,info:info};}return false;}

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(876);


// We can't please Rollup and TypeScript at the same time
// Only way to make both of them work
var objectAssign = __webpack_require__(17);
var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* parseCookies */])(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* hasDocumentCookie */])();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = objectAssign({}, options, {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        }));
        this.cookies = objectAssign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ __webpack_exports__["a"] = (Cookies);


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasDocumentCookie;
/* unused harmony export cleanCookies */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseCookies;
/* unused harmony export isParsingCookie */
/* harmony export (immutable) */ __webpack_exports__["c"] = readCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatMobilePhone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_libphonenumber_js_mobile__ = __webpack_require__(878);
var formatMobilePhone=function formatMobilePhone(phoneNumber){var sanitizedNumber=Object(__WEBPACK_IMPORTED_MODULE_0_libphonenumber_js_mobile__["a" /* parsePhoneNumberFromString */])(phoneNumber,"FR");if(!sanitizedNumber||!sanitizedNumber.number||!sanitizedNumber.number.length)return'';// check if mobile
if(!['6','7'].includes(sanitizedNumber.nationalNumber.substr(0,1)))return'';return''+sanitizedNumber.countryCallingCode+sanitizedNumber.nationalNumber;};

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parsePhoneNumber */
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberFromString;
/* unused harmony export findNumbers */
/* unused harmony export searchNumbers */
/* unused harmony export findPhoneNumbersInText */
/* unused harmony export searchPhoneNumbersInText */
/* unused harmony export PhoneNumberMatcher */
/* unused harmony export AsYouType */
/* unused harmony export isSupportedCountry */
/* unused harmony export getCountries */
/* unused harmony export getCountryCallingCode */
/* unused harmony export getExtPrefix */
/* unused harmony export getExampleNumber */
/* unused harmony export formatIncompletePhoneNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_mobile_json_js__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_index__ = __webpack_require__(372);
/* unused harmony reexport ParseError */
/* unused harmony reexport parseIncompletePhoneNumber */
/* unused harmony reexport parsePhoneNumberCharacter */
/* unused harmony reexport parseDigits */
/* unused harmony reexport parseRFC3966 */
/* unused harmony reexport formatRFC3966 */
// Importing from `.json.js` a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239






function call(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(__WEBPACK_IMPORTED_MODULE_0__metadata_mobile_json_js__["a" /* default */])
	return func.apply(this, args)
}

function parsePhoneNumber() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["k" /* parsePhoneNumber */], arguments)
}

function parsePhoneNumberFromString() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["l" /* parsePhoneNumberFromString */], arguments)
}

function findNumbers() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["c" /* findNumbers */], arguments)
}

function searchNumbers() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["m" /* searchNumbers */], arguments)
}

function findPhoneNumbersInText() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["d" /* findPhoneNumbersInText */], arguments)
}

function searchPhoneNumbersInText() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["n" /* searchPhoneNumbersInText */], arguments)
}

function PhoneNumberMatcher(text, options) {
	return __WEBPACK_IMPORTED_MODULE_1__core_index__["b" /* PhoneNumberMatcher */].call(this, text, options, __WEBPACK_IMPORTED_MODULE_0__metadata_mobile_json_js__["a" /* default */])
}
PhoneNumberMatcher.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__core_index__["b" /* PhoneNumberMatcher */].prototype, {})
PhoneNumberMatcher.prototype.constructor = PhoneNumberMatcher

function AsYouType(country) {
	return __WEBPACK_IMPORTED_MODULE_1__core_index__["a" /* AsYouType */].call(this, country, __WEBPACK_IMPORTED_MODULE_0__metadata_mobile_json_js__["a" /* default */])
}
AsYouType.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__core_index__["a" /* AsYouType */].prototype, {})
AsYouType.prototype.constructor = AsYouType

function isSupportedCountry() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["j" /* isSupportedCountry */], arguments)
}

function getCountries() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["f" /* getCountries */], arguments)
}

function getCountryCallingCode() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["g" /* getCountryCallingCode */], arguments)
}

function getExtPrefix(country) {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["i" /* getExtPrefix */], arguments)
}

function getExampleNumber() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["h" /* getExampleNumber */], arguments)
}

function formatIncompletePhoneNumber() {
	return call(__WEBPACK_IMPORTED_MODULE_1__core_index__["e" /* formatIncompletePhoneNumber */], arguments)
}

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
/* harmony default export */ __webpack_exports__["a"] = ({"version":"1.7.54","country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6],0,0,0,0,0,0,0,[0,["4\\d{4}",[5]]]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["690\\d{6}|[356]\\d{5}",[6,9]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0",0,0,0,0,0,[0,["5[024-68]\\d{7}",[9]]]],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0",0,0,0,0,0,[0,["7\\d{8}"]]],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268",[["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"],["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"],0,0,["26840[69]\\d{4}"],["26848[01]\\d{4}"]]],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264",[["264(?:292|4(?:6[12]|9[78]))\\d{4}"],["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"],0,0,["264724\\d{4}"]]],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0",0,0,0,0,0,[0,["6(?:[78][2-9]|9\\d)\\d{6}",[9]]]],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"]]],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]],0,0,0,0,0,0,[0,["9[1-49]\\d{7}"]]],"AR":["54","00","11\\d{8}|(?:[2368]|9\\d)\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1",0,0,[0,["93888[013-9]\\d{5}|9(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-7]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"]]],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684",[["6846(?:22|33|44|55|77|88|9[19])\\d{4}"],["684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0",0,0,0,0,0,[0,["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",[7,8,9,10,11,12,13]]]],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]],0,0,0,0,0,0,[0,["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",[["18[1-8]\\d{3,6}",[6,7,8,9]],["(?:4[0-8]|50)\\d{4,8}",[6,7,8,9,10]],["800\\d{4,6}",[7,8,9]],["[67]00\\d{5,6}",[8,9]],0,0,["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]],"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365|46","1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:36554|99[2-9]\\d\\d)\\d{4}|(?:[16]0|4[04]|5[015]|7[07])\\d{7}"]]],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0",0,0,0,0,0,[0,["6040[0-4]\\d{4}|6(?:03|[1-356]|44|7\\d)\\d{6}"]]],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246",[["246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"],["246(?:2(?:[3568]\\d|4[0-57-9])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["(?:246976|900[2-9]\\d\\d)\\d{4}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"],0,["246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}"],0,["24631\\d{5}"]]],"BD":["880","00","1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0",0,0,0,0,0,[0,["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",[10]]]],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0",0,0,0,0,0,[0,["4[5-9]\\d{7}",[9]]]],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]],0,0,0,0,0,0,[0,["(?:0[127]|5[1-8]|[67]\\d)\\d{6}"]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0",0,0,0,0,0,[0,["43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}",[8,9]]]],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]],0,0,0,0,0,0,[0,["(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]],0,0,0,0,0,0,[0,["(?:29|31|6[1289]|7[125-9])\\d{6}"]]],"BJ":["229","00","(?:[2689]\\d|51)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25689]"]]],0,0,0,0,0,0,[0,["(?:51|6\\d|9[013-9])\\d{6}"]]],"BL":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441",[["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"],["441(?:[2378]\\d|5[0-39])\\d{5}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]],0,0,0,0,0,0,[0,["(?:22[89]|[78]\\d\\d)\\d{4}"]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?",0,0,0,[0,["[67]\\d{7}",[8]]]],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]",[["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"],["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2",0,0,[0,["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",[10,11]]]],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242",[["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"],["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"],["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"],0,["242225\\d{4}"]]],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],0,0,0,0,0,0,[0,["(?:1[67]|77)\\d{6}",[8]]]],"BW":["267","00","90\\d{5}|(?:[2-6]|7\\d)\\d{6}",[7,8],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7"]]],0,0,0,0,0,0,[0,["77200\\d{3}|7(?:[1-6]\\d|7[013-9])\\d{5}",[8]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,[0,["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",[9]]],"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]],0,0,0,0,0,0,[0,["6[0-35-7]\\d{5}",[7]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}",[10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"],["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"],0,0,0,["600[2-9]\\d{6}"]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,[0,["88\\d{5}|(?:8[0-2459]|9[017-9])\\d{7}"]]],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]],0,0,0,0,0,0,[0,["7[0257]\\d{6}"]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]],0,0,0,0,0,0,[0,["0[14-6]\\d{7}"]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0",0,0,0,0,0,[0,["7[35-9]\\d{7}"]]],"CI":["225","00","[02-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[02-9]"]]],0,0,0,0,0,0,[0,["(?:2[0-3]80|97[0-3]\\d)\\d{4}|(?:0[1-9]|[457]\\d|6[014-9]|8[4-9]|95)\\d{6}"]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]],0,0,0,0,0,0,[0,["[578]\\d{4}"]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],0,0,0,0,0,0,[0,["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:0\\d|1[0-35-9]|2[1-9]|3[0-2]|40)))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",[9]]]],"CM":["237","00","(?:[26]\\d\\d|88)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]],0,0,0,0,0,0,[0,["(?:24[23]|6[5-9]\\d)\\d{6}",[9]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,[0,["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}",[11]]],"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:1\\d|3)\\d{9}|[124-8]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1 $2",["[14][2-9]|[25-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?",0,0,0,[0,["3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|33(?:00|3[0-24-9])\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",[10]]]],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))",0,0,0,[0,["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",[8]]]],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0",0,0,0,0,0,[0,["5\\d{7}",[8]]]],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]],0,0,0,0,0,0,[0,["(?:[34][36]|5[1-389]|9\\d)\\d{5}"]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]",[["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"],["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"],0,0,0,0,0,["955\\d{5}",[8]],0,["60[0-2]\\d{4}",[7]]]],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]],0,0,0,0,0,0,[0,["9[4-79]\\d{6}"]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,[0,["(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[05]\\d{10}|[46][1-8]\\d{4,9})|49(?:[0-25]\\d|3[1-689]|7[1-7])\\d{4,8}|49(?:[0-2579]\\d|[34][1-9]|6[0-8])\\d{3}|49\\d{3,4}|(?:1|[368]\\d|4[0-8])\\d{3,13}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0",0,0,0,0,0,[0,["15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",[10,11]]]],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]],0,0,0,0,0,0,[0,["77\\d{6}"]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]],0,0,0,0,0,0,[0,["(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767",[["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"],["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-7]|70[1-6])\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8[024]9",[["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"],["8[024]9[2-9]\\d{6}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:5(?:4[0-29]|5\\d|6[01])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",[9]]]],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0",0,0,0,0,0,[0,["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",[9]]]],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["5(?:[0-35-9]\\d{6}|4(?:[0-57-9]\\d{5}|6(?:[0-24-9]\\d{4}|3(?:[0-35-9]\\d{3}|4000))))|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9]|8[2-4])\\d|7(?:[679]\\d|8[13-9]))\\d)|[349]\\d{4})\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",[7,8]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0",0,0,0,0,0,[0,["1[0-25]\\d{8}",[10]]]],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]",[["528[89]\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[016-8]|6[1267]|7[0-27]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:17[1-3]|7\\d\\d)\\d{4}"]]],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],0,0,0,0,0,0,[0,["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"]]],"ET":["251","00","(?:11|[2-59]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"],"0$1"]],"0",0,0,0,0,0,[0,["9\\d{8}"]]],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",[["(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",[5,6,7,8,9]],["(?:4[0-8]|50)\\d{4,8}",[6,7,8,9,10]],["800\\d{4,6}",[7,8,9]],["[67]00\\d{5,6}",[8,9]],0,0,["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]],"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,[0,["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",[7]]],"00"],"FK":["500","00","[2-7]\\d{4}",[5],0,0,0,0,0,0,0,[0,["[56]\\d{4}"]]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]],0,0,0,0,0,0,[0,["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]],"FO":["298","00","(?:[2-8]\\d|90)\\d{4}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))",0,0,0,[0,["(?:[27][1-9]|5\\d)\\d{4}"]]],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0",0,0,0,0,0,[0,["700\\d{6}|(?:6\\d|7[3-9])\\d{7}"]]],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],0,0,"0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})","$1",0,0,[0,["(?:0[2-7]|6[256]|7[47])\\d{6}|[2-7]\\d{6}"]]],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|(?:4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:0\\d|20)))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473",[["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"],["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0",0,0,0,0,0,[0,["5(?:0(?:0(?:0\\d|50)\\d|555[5-9])|(?:111\\d|8(?:58[89]|888))\\d|(?:2222|3333)[0-4]|52(?:00\\d|22[0-4])|75(?:00\\d|7(?:7[7-9]|8[01])))\\d{3}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}"]]],"GF":["594","00","(?:[56]94|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0",0,0,0,0,0,[0,["694(?:[0-249]\\d|3[0-48])\\d{4}"]]],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:2[0346-8]\\d|5(?:[0457]\\d|6[01]|9[1-6]))\\d{6}",[9]]]],"GI":["350","00","[256]\\d{7}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]],0,0,0,0,0,0,[0,["(?:5[146-8]\\d|6(?:06|29))\\d{5}"]]],"GL":["299","00","(?:19|[2-689]\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-689]"]]],0,0,0,0,0,0,[0,["[245]\\d{5}"]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],0,0,0,0,0,0,[0,["(?:[23679]\\d|5[0-389])\\d{5}"]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]],0,0,0,0,0,0,[0,["6[02356]\\d{7}",[9]]]],"GP":["590","00","(?:590|69\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]],0,0,0,0,0,0,[0,["(?:222|55[015])\\d{6}"]]],"GR":["30","00","5005000\\d{3}|(?:[2689]\\d|70)\\d{8}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]]],0,0,0,0,0,0,[0,["68[57-9]\\d{7}|(?:69|94)\\d{8}"]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,["[3-5]\\d{7}",[8]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671",[["671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"],["671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]],0,0,0,0,0,0,[0,["9(?:5\\d|6[569]|77)\\d{6}",[9]]]],"GY":["592","001","(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]],0,0,0,0,0,0,[0,["6\\d{6}"]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,[0,["(?:46(?:[01][0-6]|2[5-9]|4[0-57-9])|5730|626[01]|707[1-5]|848[015-9]|929[03-9])\\d{4}|(?:5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",[8]]],"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]],0,0,0,0,0,0,[0,["[37-9]\\d{7}",[8]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0",0,0,0,0,0,[0,["9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}",[8,9]]]],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]],0,0,0,0,0,0,[0,["[34]\\d{7}"]]],"HU":["36","00","[2357]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57-9]"],"06 $1"]],"06",0,0,0,0,0,[0,["(?:[257]0|3[01])\\d{7}",[9]]]],"ID":["62","00[189]","(?:(?:007803|8\\d{4})\\d|[1-36])\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0",0,0,0,0,0,[0,["8[1-35-9]\\d{7,10}",[9,10,11,12]]]],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[0,["8(?:22|[35-9]\\d)\\d{6}",[9]]]],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0",0,0,0,0,0,[0,["5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-8]|3[23]|44|5[05689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",[9]]]],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([5-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24",[["1624[5-8]\\d{5}"],["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"],["808162\\d{4}"],["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"],["70\\d{8}"],0,["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"],0,["56\\d{8}"]]],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0",0,0,0,0,0,[0,["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",[10]]]],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]],0,0,0,0,0,0,[0,["38\\d{5}"]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,[0,["7[3-9]\\d{8}",[10]]]],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0",0,0,0,0,0,[0,["9(?:(?:0(?:[1-35]\\d|44)|(?:[13]\\d|2[0-2])\\d)\\d|9(?:(?:[0-2]\\d|4[45])\\d|5[15]0|8(?:1\\d|88)|9(?:0[013]|1[0134]|21|77|9[6-9])))\\d{5}",[10]]]],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[0,["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[28]))\\d{4}"]],"00"],"IT":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1[4679]|[38]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876",[["(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:5(?:02|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"],["(?:658295|876(?:2(?:[14-9]\\d|2[013-9]|3[7-9])|[348]\\d\\d|5(?:0[13-9]|1[579]|[2-57-9]\\d|6[0-24-9])|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,[0,["7(?:[78][0-25-9]|9\\d)\\d{6}",[9]]]],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[279]|49|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3[3-8]|5[2-9])","[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3(?:[3-6][2-9]|7|8[2-5])|5[2-9])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]|80"],"0$1"]],"0",0,0,0,0,0,[0,["[7-9]0[1-9]\\d{7}",[10]]]],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:1(?:0[0-2]|1[0-5])|7\\d\\d)\\d{6}",[9]]]],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[0,["(?:312(?:58\\d|973)|8801\\d\\d)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|99[05-9])\\d{6}",[9]]]],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0",0,0,0,0,0,[0,["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",[8,9]]]],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0",0,0,0,0,0,[0,["(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}",[8]]]],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]],0,0,0,0,0,0,[0,["[34]\\d{6}"]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869",[["869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}"],["869(?:48[89]|5(?:5[6-8]|6[5-7])|66\\d|76[02-7])\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0",0,0,0,0,0,[0,["19[1-3]\\d{7}",[10]]]],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?",0,0,0,[0,["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",[9,10]]]],"KW":["965","00","(?:18|[2569]\\d\\d)\\d{5}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[25]"]]],0,0,0,0,0,0,[0,["(?:5(?:2(?:22|5[25])|88[58])|6(?:222|444|70[013-9]|888|93[039])|9(?:11[01]|333|500))\\d{4}|(?:5(?:[05]\\d|1[0-7]|6[56])|6(?:0[034679]|5[015-9]|6\\d|7[67]|9[069])|9(?:0[09]|22|[4679]\\d|55|8[057-9]))\\d{5}",[8]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345",[["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}"],["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["(?:345976|900[2-9]\\d\\d)\\d{4}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"],0,0,["345849\\d{4}"]]],"KZ":["7","810","33622\\d{5}|(?:7\\d|80)\\d{8}",[10],0,"8",0,0,0,0,"33|7",[["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}"],["7(?:0[0-25-8]|47|6[02-4]|7[15-8]|85)\\d{7}"],["800\\d{7}"],["809\\d{7}"],["808\\d{7}"],0,0,0,["751\\d{7}"]],"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:20(?:[239]\\d|5[24-9]|7[6-8])|302\\d)\\d{6}",[10]]]],"LB":["961","00","[7-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"]]],"0",0,0,0,0,0,[0,["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"]]],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758",[["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"],["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"LI":["423","00","90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)",0,0,0,[0,["(?:6(?:4(?:89|9\\d)|5[0-3]\\d|6(?:0[0-7]|10|2[06-9]|39))\\d|7(?:[37-9]\\d|42|56))\\d{4}"]]],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0",0,0,0,0,0,[0,["7[0-25-8]\\d{7}"]]],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",[7,9]]]],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]],0,0,0,0,0,0,[0,["[56]\\d{7}"]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]",0,0,0,[0,["6\\d{7}"]]],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",0,0,0,[0,["6(?:[269][18]|5[158]|7[189]|81)\\d{6}",[9]]]],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]],0,0,0,0,0,0,[0,["2\\d{7}"]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0",0,0,0,0,0,[0,["9[1-6]\\d{7}"]]],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]","5(?:29|38)[89]0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[016-8]|6[1267]|7[0-27]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","870\\d{5}|(?:[349]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0",0,0,0,0,0,[0,["4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"]]],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0",0,0,0,0,0,[0,["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"]]],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0",0,0,0,0,0,[0,["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",[8]]]],"MF":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1",0,0,[0,["3[2-49]\\d{7}"]]],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1",0,0,0,0,0,[0,["(?:(?:23|54)5|329|45[56])\\d{4}"]]],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0",0,0,0,0,0,[0,["7(?:4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[2-4]|42|9[23])\\d{5}"]]],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],0,0,0,0,0,0,[0,["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}"]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0",0,0,0,0,0,[0,["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",[7,8,9,10]]]],"MN":["976","001","[12]\\d{7,9}|[57-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}",[8]]]],"MO":["853","00","(?:28|[68]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[268]"]]],0,0,0,0,0,0,[0,["6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:[02][5-9]|[146-8]\\d|[35][0-4]))\\d{4}"]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670",[["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"],["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"MQ":["596","00","69\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0",0,0,0,0,0,[0,["69(?:6(?:[0-47-9]\\d|5[0-6]|6[0-4])|727)\\d{4}"]]],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]],0,0,0,0,0,0,[0,["[2-4][0-46-9]\\d{6}"]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664",[["6644(?:1[0-3]|91)\\d{4}"],["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]],0,0,0,0,0,0,[0,["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[2-468]|5\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]]],0,0,0,0,0,0,[0,["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[589]|4[3489]|7\\d|8[0-689]|9[0-8])\\d{5}",[8]]],"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,[0,["46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}",[7]]],"00"],"MW":["265","00","1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0",0,0,0,0,0,[0,["111\\d{6}|(?:31|77|88|99)\\d{7}",[9]]]],"MX":["52","0[09]","(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,[0,["(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}"]],"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9])|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0",0,0,0,0,0,[0,["1(?:4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[01]\\d|2[2-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}",[9,10]]]],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["8[2-79]\\d{7}",[9]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0",0,0,0,0,0,[0,["(?:60|8[1245])\\d{7}",[9]]]],"NC":["687","00","[2-57-9]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]],0,0,0,0,0,0,[0,["(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"]]],"NE":["227","00","[0289]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]"]]],0,0,0,0,0,0,[0,["(?:23|8[014589]|9\\d)\\d{6}"]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1",0,0,[0,["(?:14|3[58])\\d{4}"]]],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|90[1-9])\\d{7}",[10]]]],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]],0,0,0,0,0,0,[0,["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",[5,6,7,8,9,10],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],"0",0,0,0,0,0,[0,["6[1-58]\\d{7}",[9]]]],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|5[89]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]",[["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",[8]],["(?:4[015-8]|5[89]|9\\d)\\d{6}",[8]],["80[01]\\d{5}",[8]],["82[09]\\d{5}",[8]],["880\\d{5}",[8]],0,["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"],0,["85[0-5]\\d{5}",[8]],["810(?:0[0-6]|[2-8]\\d)\\d{3}",[8]]]],"NP":["977","00","9\\d{9}|[1-9]\\d{7}",[8,10],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["[1-8]|9(?:[1-579]|6[2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0",0,0,0,0,0,[0,["9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}",[10]]]],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]],0,0,0,0,0,0,[0,["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]],0,0,0,0,0,0,[0,["888[4-9]\\d{3}",[7]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["83"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[0367]|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,[0,["2[0-27-9]\\d{7,8}|21\\d{6}",[8,9,10]]],"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|8007\\d{4,5}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]],0,0,0,0,0,0,[0,["(?:1505|90[1-9]\\d)\\d{4}|(?:7[1289]|9[1-9])\\d{6}",[8]]]],"PA":["507","00","(?:[1-57-9]|6\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["6"]]],0,0,0,0,0,0,[0,["(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-6])\\d|8(?:1[01]|7[23]))\\d{4}"]]],"PE":["51","19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,[0,["9\\d{8}",[9]]],0," Anexo "],"PF":["689","00","[48]\\d{7}|4\\d{5}",[6,8],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[48]"]]],0,0,0,0,0,0,[0,["8[7-9]\\d{6}",[8]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,[0,["77(?:3[1-9]|[5-9]\\d)\\d{4}|(?:7[0-689]|81)\\d{6}",[8]]],"00"],"PH":["63","00","1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0",0,0,0,0,0,[0,["(?:81[37]|9(?:0[5-9]|1[0-24-9]|2[0-35-9]|[35]\\d|4[235-9]|6[0-35-8]|7[1-9]|8[189]|9[4-9]))\\d{7}",[10]]]],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0",0,0,0,0,0,[0,["3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}",[10]]]],"PL":["48","00","6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]],0,0,0,0,0,0,[0,["(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",[9]]]],"PM":["508","00","[45]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:4[02-4]|5[05])\\d{4}"]]],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939",[["(?:787|939)[2-9]\\d{6}"],["(?:787|939)[2-9]\\d{6}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0",0,0,0,0,0,[0,["5[69]\\d{7}",[9]]]],"PT":["351","00","(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"]]],0,0,0,0,0,0,[0,["6[356]9230\\d{3}|(?:6[036]93|9(?:[1-36]\\d\\d|480))\\d{5}"]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],0,0,0,0,0,0,[0,["(?:45[0-5]|6[2-4689]0|(?:77|88)\\d)\\d{4}"]]],"PY":["595","00","59\\d{4,6}|(?:[2-46-9]\\d|5[0-8])\\d{4,7}",[6,7,8,9],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"]],"0",0,0,0,0,0,[0,["9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",[9]]]],"QA":["974","00","[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]],0,0,0,0,0,0,[0,["(?:28|[35-7]\\d)\\d{6}",[8]]]],"RE":["262","00","9769\\d{5}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]",[["26(?:2\\d\\d|30[01])\\d{4}"],["(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[05]|6[0-36]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,0,["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,[0,["7[01]20\\d{5}|7(?:0[013-9]|1[01]|[2-7]\\d|8[03-8]|9[09])\\d{6}",[9]]],0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0",0,0,0,0,0,[0,["6(?:[0-689]|7\\d)\\d{6,7}",[8,9,10]]]],"RU":["7","810","[347-9]\\d{9}",[10],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"],"8 ($1)",1]],"8",0,0,0,0,"3[04-689]|[489]",[["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}"],["9\\d{9}"],["80[04]\\d{7}"],["80[39]\\d{7}"],["808\\d{7}"]],"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0",0,0,0,0,0,[0,["7[238]\\d{7}",[9]]]],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0",0,0,0,0,0,[0,["5(?:[013-689]\\d|7[0-36-8])\\d{6}",[9]]]],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],0,0,0,0,0,0,[0,["48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"]]],"SC":["248","010|0[0-2]","8000\\d{3}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,[0,["2[5-8]\\d{5}"]],"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:1[0-2]|9[0-3569])\\d{7}"]]],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0",0,0,0,0,0,[0,["7[02369]\\d{7}",[9]]]],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:01|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,["(?:8(?:01[0-7]|[1-8]\\d\\d|9(?:[014]\\d|2[1-9]|3[0-489]|5[0-2]))|9[0-8]\\d\\d)\\d{4}",[8]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]",[["2(?:[0-57-9]\\d|6[4-9])\\d\\d"],["[56]\\d{4}",[5]],0,0,0,0,0,0,["262\\d\\d",[5]]]],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,[0,["65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",[8]]],"00"],"SJ":["47","00","0\\d{4}|(?:[4589]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79",[["79\\d{6}",[8]],["(?:4[015-8]|5[89]|9\\d)\\d{6}",[8]],["80[01]\\d{5}",[8]],["82[09]\\d{5}",[8]],["880\\d{5}",[8]],0,["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"],0,["85[0-5]\\d{5}",[8]],["810(?:0[0-6]|[2-8]\\d)\\d{3}",[8]]]],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0",0,0,0,0,0,[0,["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",[9]]]],"SL":["232","00","(?:[2378]\\d|66|99)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0",0,0,0,0,0,[0,["(?:25|3[013-5]|66|7[4-9]|8[08]|99)\\d{6}"]]],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1",0,0,[0,["6[16]\\d{6}",[8]]]],"SN":["221","00","(?:[378]\\d{4}|93330)\\d{4}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]],0,0,0,0,0,0,[0,["7(?:[06-8]\\d|21|90)\\d{6}"]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[1-35-9]|9[2-9]"]]],"0",0,0,0,0,0,[0,["28\\d{5}|(?:6[1-9]|79)\\d{6,7}|(?:15|24|(?:3[59]|4[89]|8[08])\\d|60|7[1-8]|9(?:0\\d|[2-9]))\\d{6}",[7,8,9]]]],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]],0,0,0,0,0,0,[0,["(?:7[124-7]|8[124-9])\\d{5}",[7]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:12|9[12579])\\d{7}"]]],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]],0,0,0,0,0,0,[0,["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,[0,["66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}",[8]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721",[["7215(?:4[2-8]|8[239]|9[056])\\d{4}"],["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0",0,0,0,0,0,[0,["9(?:22|[3-589]\\d|6[02-9])\\d{6}",[9]]]],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]],0,0,0,0,0,0,[0,["7[6-9]\\d{6}",[8]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8",[["8\\d{3}"]]],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649",[["649(?:266|712|9(?:4\\d|50))\\d{4}"],["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"],0,0,0,["649(?:71[01]|966)\\d{4}"]]],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,[0,["(?:6[023568]|77|9\\d)\\d{6}"]],"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]],0,0,0,0,0,0,[0,["(?:7[09]|9[0-36-9])\\d{6}"]]],"TH":["66","00[1-9]","1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0",0,0,0,0,0,[0,["(?:14|6[1-6]|[89]\\d)\\d{7}",[9]]]],"TJ":["992","810","(?:00|11|[3-57-9]\\d)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"],0,1],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"],0,1],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3"],0,1],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0457-9]|11"],0,1]],"8",0,0,0,0,0,[0,["41[18]\\d{6}|(?:[04]0|11|5[05]|7[07]|88|9\\d)\\d{7}"]],"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7],0,0,0,0,0,0,0,[0,["7[2-4]\\d{2,5}"]]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]],0,0,0,0,0,0,[0,["7[2-8]\\d{6}",[8]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,[0,["6\\d{7}"]],"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]],0,0,0,0,0,0,[0,["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"]]],"TO":["676","00","(?:0800|[5-8]\\d{3})\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-8]"]]],0,0,0,0,0,0,[0,["6(?:3[02]|8[5-9])\\d{4}|(?:6[09]|7\\d|8[46-9])\\d{5}",[7]]]],"TR":["90","00","(?:4|8\\d{5})\\d{6}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[0589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6})","$1 $2 $3",["80"],"0$1",1]],"0",0,0,0,0,0,[0,["56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",[10]]]],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868",[["868(?:2(?:0[13]|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"],["868(?:2(?:6[3-9]|[7-9]\\d)|(?:3\\d|4[6-9])\\d|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]],0,0,0,0,0,0,[0,["(?:7[01]\\d|90)\\d{4}",[6,7]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,[0,["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",[9]]],0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0",0,0,0,0,0,[0,["77[2-9]\\d{6}|(?:6[2-9]|7[13-689])\\d{7}"]]],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]","4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["[3-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}",[9]]],"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0",0,0,0,0,0,[0,["7260\\d{5}|7(?:[0157-9]\\d|20|36|4[0-4])\\d{6}"]]],"US":["1","011","[2-9]\\d{9}",[10],[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","(?:[249]\\d\\d|80)\\d{5}|9\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[24]"]]],"0",0,0,0,0,0,[0,["9[1-9]\\d{6}",[8]]],"00"," int. "],"UZ":["998","810","55501\\d{4}|(?:[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"],"8 $1"]],"8",0,0,0,0,0,[0,["(?:55501|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))|(?:88|9[0-57-9])\\d{3})\\d{4}"]],"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698",[["06698\\d{1,6}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784",[["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"],["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0",0,0,0,0,0,[0,["4(?:1[24-8]|2[46])\\d{7}"]]],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284",[["284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"],["284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340",[["340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"],["340(?:2(?:0[12]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0",0,0,0,0,0,[0,["(?:52[238]|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",[9]]]],"VU":["678","00","(?:[23]\\d|[48]8)\\d{3}|(?:[57]\\d|90)\\d{5}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]],0,0,0,0,0,0,[0,["(?:5\\d|7[013-7])\\d{5}",[7]]]],"WF":["681","00","(?:[45]0|68|72|8\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[4-8]"]]],0,0,0,0,0,0,[0,["(?:50|68|72|8[23])\\d{4}"]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]],0,0,0,0,0,0,[0,["(?:7[235-7]|8(?:[3-7]|9\\d{3}))\\d{5}",[7,10]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0",0,0,0,0,0,[0,["4[3-9]\\d{6}",[8]]]],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,[0,["7[0137]\\d{7}",[9]]]],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63",[["269(?:0[67]|5[0-2]|6\\d|[78]0)\\d{4}"],["639(?:0[0-79]|1[019]|[267]\\d|3[09]|[45]0|9[04-79])\\d{4}"],["80\\d{7}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0",0,0,0,0,0,[0,["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",[5,6,7,8,9]]]],"ZM":["260","00","(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0",0,0,0,0,0,[0,["(?:7[679]|9[5-8])\\d{7}"]]],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0",0,0,0,0,0,[0,["7(?:[17]\\d|[38][1-9])\\d{6}",[9]]]]},"nonGeographic":{"800":["800",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,["[1-9]\\d{7}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"[35-7]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]\\d|7[6-8])\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|[19]\\d{7}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}",[7,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"51\\d{7}(?:\\d{3})?",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["510"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["5"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["51[013]0\\d{8}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
});
//# sourceMappingURL=semver-compare.js.map

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__metadata__["b"]; });
// Deprecated. Import from 'metadata.js' directly instead.

//# sourceMappingURL=getCountryCallingCode.js.map

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate___ = __webpack_require__(244);

/**
 * Checks if a given phone number is valid within a given region.
 * Is just an alias for `phoneNumber.isValid() && phoneNumber.country === country`.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 */

function isValidNumberForRegion(input, country, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  return input.country === country && Object(__WEBPACK_IMPORTED_MODULE_0__validate___["a" /* default */])(input, options, metadata);
}
//# sourceMappingURL=isValidNumberForRegion_.js.map

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsePhoneNumberFromString___ = __webpack_require__(884);


function parsePhoneNumberFromString() {
  var _normalizeArguments = Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber__["b" /* normalizeArguments */])(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return Object(__WEBPACK_IMPORTED_MODULE_1__parsePhoneNumberFromString___["a" /* default */])(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumberFromString.js.map

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumberFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber___ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ParseError__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(43);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function parsePhoneNumberFromString(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !Object(__WEBPACK_IMPORTED_MODULE_2__metadata__["d" /* isSupportedCountry */])(options.defaultCountry, metadata)) {
    options = _objectSpread({}, options, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return Object(__WEBPACK_IMPORTED_MODULE_0__parsePhoneNumber___["a" /* default */])(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof __WEBPACK_IMPORTED_MODULE_1__ParseError__["a" /* default */]) {//
    } else {
      throw error;
    }
  }
}
//# sourceMappingURL=parsePhoneNumberFromString_.js.map

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher__ = __webpack_require__(245);

function findNumbers(text, options, metadata) {
  var matcher = new __WEBPACK_IMPORTED_MODULE_0__PhoneNumberMatcher__["a" /* default */](text, options, metadata);
  var results = [];

  while (matcher.hasNext()) {
    results.push(matcher.next());
  }

  return results;
}
//# sourceMappingURL=findNumbers_.js.map

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegExpCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LRUCache__ = __webpack_require__(887);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

 // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
// countries being used for the same doc with ~10 patterns for each country. Some pages will have
// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
// that use-case won't have a lot of benefit.

var RegExpCache =
/*#__PURE__*/
function () {
  function RegExpCache(size) {
    _classCallCheck(this, RegExpCache);

    this.cache = new __WEBPACK_IMPORTED_MODULE_0__LRUCache__["a" /* default */](size);
  }

  _createClass(RegExpCache, [{
    key: "getPatternForRegExp",
    value: function getPatternForRegExp(pattern) {
      var regExp = this.cache.get(pattern);

      if (!regExp) {
        regExp = new RegExp('^' + pattern);
        this.cache.put(pattern, regExp);
      }

      return regExp;
    }
  }]);

  return RegExpCache;
}();


//# sourceMappingURL=RegExpCache.js.map

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LRUCache; });
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
var Node = function Node(key, value) {
  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  _classCallCheck(this, Node);

  this.key = key;
  this.value = value;
  this.next = next;
  this.prev = prev;
};

var LRUCache =
/*#__PURE__*/
function () {
  //set default limit of 10 if limit is not passed.
  function LRUCache() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    _classCallCheck(this, LRUCache);

    this.size = 0;
    this.limit = limit;
    this.head = null;
    this.tail = null;
    this.cache = {};
  } // Write Node to head of LinkedList
  // update cache with Node key and Node reference


  _createClass(LRUCache, [{
    key: "put",
    value: function put(key, value) {
      this.ensureLimit();

      if (!this.head) {
        this.head = this.tail = new Node(key, value);
      } else {
        var node = new Node(key, value, this.head);
        this.head.prev = node;
        this.head = node;
      } //Update the cache map


      this.cache[key] = this.head;
      this.size++;
    } // Read from cache map and make that node as new Head of LinkedList

  }, {
    key: "get",
    value: function get(key) {
      if (this.cache[key]) {
        var value = this.cache[key].value; // node removed from it's position and cache

        this.remove(key); // write node again to the head of LinkedList to make it most recently used

        this.put(key, value);
        return value;
      }

      console.log("Item not available in cache for key ".concat(key));
    }
  }, {
    key: "ensureLimit",
    value: function ensureLimit() {
      if (this.size === this.limit) {
        this.remove(this.tail.key);
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var node = this.cache[key];

      if (node.prev !== null) {
        node.prev.next = node.next;
      } else {
        this.head = node.next;
      }

      if (node.next !== null) {
        node.next.prev = node.prev;
      } else {
        this.tail = node.prev;
      }

      delete this.cache[key];
      this.size--;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = null;
      this.tail = null;
      this.size = 0;
      this.cache = {};
    } // // Invokes the callback function with every node of the chain and the index of the node.
    // forEach(fn) {
    //   let node = this.head;
    //   let counter = 0;
    //   while (node) {
    //     fn(node, counter);
    //     node = node.next;
    //     counter++;
    //   }
    // }
    // // To iterate over LRU with a 'for...of' loop
    // *[Symbol.iterator]() {
    //   let node = this.head;
    //   while (node) {
    //     yield node;
    //     node = node.next;
    //   }
    // }

  }]);

  return LRUCache;
}();


//# sourceMappingURL=LRUCache.js.map

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export containsMoreThanOneSlashInNationalNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate___ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parseDigits__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(165);



/**
 * Leniency when finding potential phone numbers in text segments
 * The levels here are ordered in increasing strictness.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Phone numbers accepted are "possible", but not necessarily "valid".
   */
  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
    return true;
  },

  /**
   * Phone numbers accepted are "possible" and "valid".
   * Numbers written in national format must have their national-prefix
   * present if it is usually written for a number of this type.
   */
  VALID: function VALID(number, candidate, metadata) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate___["a" /* default */])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidate.toString(), metadata)) {
      return false;
    } // Skipped for simplicity.
    // return isNationalPrefixPresentIfRequired(number, metadata)


    return true;
  },

  /**
   * Phone numbers accepted are "valid" and
   * are grouped in a possible way for this locale. For example, a US number written as
   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
   * "650 253 0000", "650 2530000" or "6502530000" are.
   * Numbers with more than one '/' symbol in the national significant number
   * are also dropped at this level.
   *
   * Warning: This level might result in lower coverage especially for regions outside of
   * country code "+1". If you are not sure about which level to use,
   * email the discussion group libphonenumber-discuss@googlegroups.com.
   */
  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate___["a" /* default */])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
  },

  /**
   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
   * are grouped in the same way that we would have formatted it, or as a single block. For
   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
   * "650 253 0000" or "6502530000" are.
   * Numbers with more than one '/' symbol are also dropped at this level.
   * <p>
   * Warning: This level might result in lower coverage especially for regions outside of country
   * code "+1". If you are not sure about which level to use, email the discussion group
   * libphonenumber-discuss@googlegroups.com.
   */
  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate___["a" /* default */])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
  }
});

function containsOnlyValidXChars(number, candidate, metadata) {
  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
  // national significant number or (2) an extension sign, in which case they always precede the
  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
  // or 'X'. We ignore the character if it appears as the last character of the string.
  for (var index = 0; index < candidate.length - 1; index++) {
    var charAtIndex = candidate.charAt(index);

    if (charAtIndex === 'x' || charAtIndex === 'X') {
      var charAtNextIndex = candidate.charAt(index + 1);

      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
        // This is the carrier code case, in which the 'X's always precede the national
        // significant number.
        index++;

        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
          return false;
        } // This is the extension sign case, in which the 'x' or 'X' should always precede the
        // extension number.

      } else if (Object(__WEBPACK_IMPORTED_MODULE_1__parseDigits__["a" /* default */])(candidate.substring(index)) !== number.ext) {
        return false;
      }
    }
  }

  return true;
}

function isNationalPrefixPresentIfRequired(number, _metadata) {
  // First, check how we deduced the country code. If it was written in international format, then
  // the national prefix is not required.
  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
    return true;
  }

  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());
  var metadata = util.getMetadataForRegion(phoneNumberRegion);

  if (metadata == null) {
    return true;
  } // Check if a national prefix should be present when formatting this number.


  var nationalNumber = util.getNationalSignificantNumber(number);
  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber); // To do this, we check that a national prefix formatting rule was present
  // and that it wasn't just the first-group symbol ($1) with punctuation.

  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
      // The national-prefix is optional in these cases, so we don't need to check if it was
      // present.
      return true;
    }

    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
      // National Prefix not needed for this number.
      return true;
    } // Normalize the remainder.


    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput()); // Check if we found a national prefix and/or carrier code at the start of the raw input, and
    // return the result.

    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
  }

  return true;
}

function containsMoreThanOneSlashInNationalNumber(number, candidate) {
  var firstSlashInBodyIndex = candidate.indexOf('/');

  if (firstSlashInBodyIndex < 0) {
    // No slashes, this is okay.
    return false;
  } // Now look for a second one.


  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);

  if (secondSlashInBodyIndex < 0) {
    // Only one slash, this is okay.
    return false;
  } // If the first slash is after the country calling code, this is permitted.


  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;

  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
    // Any more slashes and this is illegal.
    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
  }

  return true;
}

function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
  var normalizedCandidate = normalizeDigits(candidate, true
  /* keep non-digits */
  );
  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);

  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
    return true;
  } // If this didn't pass, see if there are any alternate formats that match, and try them instead.


  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
  var nationalSignificantNumber = util.getNationalSignificantNumber(number);

  if (alternateFormats) {
    for (var _iterator = alternateFormats.numberFormats(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var alternateFormat = _ref;

      if (alternateFormat.leadingDigitsPatterns().length > 0) {
        // There is only one leading digits pattern for alternate formats.
        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);

        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
          // Leading digits don't match; try another one.
          continue;
        }
      }

      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);

      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
        return true;
      }
    }
  }

  return false;
}
/**
 * Helper method to get the national-number part of a number, formatted without any national
 * prefix, and return it as a set of digit blocks that would be formatted together following
 * standard formatting rules.
 */


function getNationalNumberGroups(metadata, number, formattingPattern) {
  if (formattingPattern) {
    // We format the NSN only, and split that according to the separator.
    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
  } // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.


  var rfc3966Format = formatNumber(number, 'RFC3966', metadata); // We remove the extension part from the formatted string before splitting it into different
  // groups.

  var endIndex = rfc3966Format.indexOf(';');

  if (endIndex < 0) {
    endIndex = rfc3966Format.length;
  } // The country-code will have a '-' following it.


  var startIndex = rfc3966Format.indexOf('-') + 1;
  return rfc3966Format.slice(startIndex, endIndex).split('-');
}

function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN); // Set this to the last group, skipping it if the number has an extension.

  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1; // First we check if the national significant number is formatted as a block.
  // We use contains and not equals, since the national significant number may be present with
  // a prefix such as a national number prefix, or the country code itself.

  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
    return true;
  } // Starting from the end, go through in reverse, excluding the first group, and check the
  // candidate and number groups are the same.


  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;

  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
      return false;
    }

    formattedNumberGroupIndex--;
    candidateNumberGroupIndex--;
  } // Now check the first group. There may be a national prefix at the start, so we only check
  // that the candidate group ends with the formatted number group.


  return candidateNumberGroupIndex >= 0 && Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* endsWith */])(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
}

function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var fromIndex = 0;

  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    // First skip the country code if the normalized candidate contained it.
    var countryCode = String(number.getCountryCode());
    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
  } // Check each group of consecutive digits are not broken into separate groupings in the
  // {@code normalizedCandidate} string.


  for (var i = 0; i < formattedNumberGroups.length; i++) {
    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
    // doesn't contain the consecutive digits in formattedNumberGroups[i].
    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);

    if (fromIndex < 0) {
      return false;
    } // Moves {@code fromIndex} forward.


    fromIndex += formattedNumberGroups[i].length();

    if (i == 0 && fromIndex < normalizedCandidate.length()) {
      // We are at the position right after the NDC. We get the region used for formatting
      // information based on the country code in the phone number, rather than the number itself,
      // as we do not need to distinguish between different countries with the same country
      // calling code and this is faster.
      var region = util.getRegionCodeForCountryCode(number.getCountryCode());

      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
        // This means there is no formatting symbol after the NDC. In this case, we only
        // accept the number if there is no formatting symbol at all in the number, except
        // for extensions. This is only important for countries with national prefixes.
        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
        return Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* startsWith */])(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
      }
    }
  } // The check here makes sure that we haven't mistakenly already used the extension to
  // match the last group of the subscriber number. Note the extension cannot have
  // formatting in-between digits.


  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
}
//# sourceMappingURL=Leniency.js.map

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePreCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(165);
 // Regular expression of characters typically used to start a second phone number for the purposes
// of parsing. This allows us to strip off parts of the number that are actually the start of
// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
// extension so that the first number is parsed correctly.
//
// Matches a slash (\ or /) followed by a space followed by an `x`.
//

var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
function parsePreCandidate(candidate) {
  // Check for extra numbers at the end.
  // TODO: This is the place to start when trying to support extraction of multiple phone number
  // from split notations (+41 79 123 45 67 / 68).
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* trimAfterFirstMatch */])(SECOND_NUMBER_START_PATTERN, candidate);
}
//# sourceMappingURL=parsePreCandidate.js.map

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidPreCandidate;
// Matches strings that look like dates using "/" as a separator.
// Examples: 3/10/2011, 31/10/96 or 08/31/95.
var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/; // Matches timestamps.
// Examples: "2012-01-02 08:00".
// Note that the reg-ex does not include the
// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.

var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
function isValidPreCandidate(candidate, offset, text) {
  // Skip a match that is more likely to be a date.
  if (SLASH_SEPARATED_DATES.test(candidate)) {
    return false;
  } // Skip potential time-stamps.


  if (TIME_STAMPS.test(candidate)) {
    var followingText = text.slice(offset + candidate.length);

    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
      return false;
    }
  }

  return true;
}
//# sourceMappingURL=isValidPreCandidate.js.map

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEAD_CLASS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utf_8__ = __webpack_require__(379);
// Copy-pasted from `PhoneNumberMatcher.js`.



var OPENING_PARENS = "(\\[\uFF08\uFF3B";
var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PLUS_CHARS */], "]"); // Punctuation that may be at the start of a phone number - brackets and plus signs.

var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS); // Limit on the number of pairs of brackets in a phone number.

var BRACKET_PAIR_LIMIT = Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* limit */])(0, 3);
/**
 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
 * This also checks that there is something inside the brackets. Having no brackets at all is also
 * fine.
 *
 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
 * closing bracket first. We limit the sets of brackets in a phone number to four.
 */

var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
/**
 * Matches strings that look like publication pages. Example:
 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
 *
 * The string "211-227 (2003)" is not a telephone number.
 */

var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
function isValidCandidate(candidate, offset, text, leniency) {
  // Check the candidate doesn't contain any formatting
  // which would indicate that it really isn't a phone number.
  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
    return;
  } // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.


  if (leniency !== 'POSSIBLE') {
    // If the candidate is not at the start of the text,
    // and does not start with phone-number punctuation,
    // check the previous character.
    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
      var previousChar = text[offset - 1]; // We return null if it is a latin letter or an invalid punctuation symbol.

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["d" /* isInvalidPunctuationSymbol */])(previousChar) || Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["e" /* isLatinLetter */])(previousChar)) {
        return false;
      }
    }

    var lastCharIndex = offset + candidate.length;

    if (lastCharIndex < text.length) {
      var nextChar = text[lastCharIndex];

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["d" /* isInvalidPunctuationSymbol */])(nextChar) || Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["e" /* isLatinLetter */])(nextChar)) {
        return false;
      }
    }
  }

  return true;
}
//# sourceMappingURL=isValidCandidate.js.map

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchPhoneNumbersInText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__searchNumbers__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findPhoneNumbersInText__ = __webpack_require__(381);


function searchPhoneNumbersInText(text, defaultCountry, options, metadata) {
  var args = Object(__WEBPACK_IMPORTED_MODULE_1__findPhoneNumbersInText__["b" /* getArguments */])(defaultCountry, options, metadata);
  return Object(__WEBPACK_IMPORTED_MODULE_0__searchNumbers__["a" /* default */])(text, args.options, args.metadata);
}
//# sourceMappingURL=searchPhoneNumbersInText.js.map

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCountries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(43);

function getCountries(metadata) {
  return new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getExampleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__ = __webpack_require__(164);

function getExampleNumber(country, examples, metadata) {
  if (examples[country]) {
    return new __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__["a" /* default */](country, examples[country], metadata);
  }
}
//# sourceMappingURL=getExampleNumber.js.map

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatIncompletePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsYouType__ = __webpack_require__(382);

/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
 * @return {string} Formatted (possibly incomplete) phone number.
 */

function formatIncompletePhoneNumber(value, country, metadata) {
  if (!metadata) {
    metadata = country;
    country = undefined;
  }

  return new __WEBPACK_IMPORTED_MODULE_0__AsYouType__["a" /* default */](country, metadata).input(value);
}
//# sourceMappingURL=formatIncompletePhoneNumber.js.map

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(897);

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);
var bind = __webpack_require__(383);
var Axios = __webpack_require__(899);
var defaults = __webpack_require__(246);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(387);
axios.CancelToken = __webpack_require__(912);
axios.isCancel = __webpack_require__(386);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(913);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 898 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(246);
var utils = __webpack_require__(48);
var InterceptorManager = __webpack_require__(907);
var dispatchRequest = __webpack_require__(908);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(385);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);
var transformData = __webpack_require__(909);
var isCancel = __webpack_require__(386);
var defaults = __webpack_require__(246);
var isAbsoluteURL = __webpack_require__(910);
var combineURLs = __webpack_require__(911);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(48);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(387);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  decode: __webpack_require__(389),
  verify: __webpack_require__(1001),
  sign: __webpack_require__(1004),
  JsonWebTokenError: __webpack_require__(172),
  NotBeforeError: __webpack_require__(430),
  TokenExpiredError: __webpack_require__(431),
};


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

/*global module*/
var Buffer = __webpack_require__(5).Buffer;
var DataStream = __webpack_require__(391);
var jwa = __webpack_require__(396);
var Stream = __webpack_require__(111);
var toString = __webpack_require__(429);
var util = __webpack_require__(110);

function base64url(string, encoding) {
  return Buffer
    .from(string, encoding)
    .toString('base64')
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

function jwsSecuredInput(header, payload, encoding) {
  encoding = encoding || 'utf8';
  var encodedHeader = base64url(toString(header), 'binary');
  var encodedPayload = base64url(toString(payload), encoding);
  return util.format('%s.%s', encodedHeader, encodedPayload);
}

function jwsSign(opts) {
  var header = opts.header;
  var payload = opts.payload;
  var secretOrKey = opts.secret || opts.privateKey;
  var encoding = opts.encoding;
  var algo = jwa(header.alg);
  var securedInput = jwsSecuredInput(header, payload, encoding);
  var signature = algo.sign(securedInput, secretOrKey);
  return util.format('%s.%s', securedInput, signature);
}

function SignStream(opts) {
  var secret = opts.secret||opts.privateKey||opts.key;
  var secretStream = new DataStream(secret);
  this.readable = true;
  this.header = opts.header;
  this.encoding = opts.encoding;
  this.secret = this.privateKey = this.key = secretStream;
  this.payload = new DataStream(opts.payload);
  this.secret.once('close', function () {
    if (!this.payload.writable && this.readable)
      this.sign();
  }.bind(this));

  this.payload.once('close', function () {
    if (!this.secret.writable && this.readable)
      this.sign();
  }.bind(this));
}
util.inherits(SignStream, Stream);

SignStream.prototype.sign = function sign() {
  try {
    var signature = jwsSign({
      header: this.header,
      payload: this.payload.buffer,
      secret: this.secret.buffer,
      encoding: this.encoding
    });
    this.emit('done', signature);
    this.emit('data', signature);
    this.emit('end');
    this.readable = false;
    return signature;
  } catch (e) {
    this.readable = false;
    this.emit('error', e);
    this.emit('close');
  }
};

SignStream.sign = jwsSign;

module.exports = SignStream;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 917 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 918 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(5).Buffer;
var util = __webpack_require__(920);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(922);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(31)))

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(27)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(395);

/*<replacement>*/
var util = Object.create(__webpack_require__(130));
util.inherits = __webpack_require__(7);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(250);


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(98);


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(249).Transform


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(249).PassThrough


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*jshint node:true */

var Buffer = __webpack_require__(27).Buffer; // browserify
var SlowBuffer = __webpack_require__(27).SlowBuffer;

module.exports = bufferEq;

function bufferEq(a, b) {

  // shortcutting on type is necessary for correctness
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    return false;
  }

  // buffer sizes should be well-known information, so despite this
  // shortcutting, it doesn't leak any information about the *contents* of the
  // buffers.
  if (a.length !== b.length) {
    return false;
  }

  var c = 0;
  for (var i = 0; i < a.length; i++) {
    /*jshint bitwise:false */
    c |= a[i] ^ b[i]; // XOR
  }
  return c === 0;
}

bufferEq.install = function() {
  Buffer.prototype.equal = SlowBuffer.prototype.equal = function equal(that) {
    return bufferEq(this, that);
  };
};

var origBufEqual = Buffer.prototype.equal;
var origSlowBufEqual = SlowBuffer.prototype.equal;
bufferEq.restore = function() {
  Buffer.prototype.equal = origBufEqual;
  SlowBuffer.prototype.equal = origSlowBufEqual;
};


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(112)
exports.createHash = exports.Hash = __webpack_require__(131)
exports.createHmac = exports.Hmac = __webpack_require__(400)

var algos = __webpack_require__(937)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(403)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(939)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(954)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(959)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(993)

var publicEncrypt = __webpack_require__(994)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(997)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(113)
var Buffer = __webpack_require__(5).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(7)
var Hash = __webpack_require__(113)
var Buffer = __webpack_require__(5).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(7)
var Sha256 = __webpack_require__(398)
var Hash = __webpack_require__(113)
var Buffer = __webpack_require__(5).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7)
var SHA512 = __webpack_require__(399)
var Hash = __webpack_require__(113)
var Buffer = __webpack_require__(5).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(7)
var Buffer = __webpack_require__(5).Buffer

var Base = __webpack_require__(82)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(402)


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(404)
var defaultEncoding = __webpack_require__(405)
var sync = __webpack_require__(406)
var Buffer = __webpack_require__(5).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(31)))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(940)
var aes = __webpack_require__(256)
var aesModes = __webpack_require__(257)
var desModes = __webpack_require__(953)
var ebtk = __webpack_require__(169)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(82)
var des = __webpack_require__(941)
var inherits = __webpack_require__(7)
var Buffer = __webpack_require__(5).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(407);
exports.Cipher = __webpack_require__(255);
exports.DES = __webpack_require__(408);
exports.CBC = __webpack_require__(942);
exports.EDE = __webpack_require__(943);


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(49);
var inherits = __webpack_require__(7);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(49);
var inherits = __webpack_require__(7);

var Cipher = __webpack_require__(255);
var DES = __webpack_require__(408);

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(257)
var AuthCipher = __webpack_require__(412)
var Buffer = __webpack_require__(5).Buffer
var StreamCipher = __webpack_require__(413)
var Transform = __webpack_require__(82)
var aes = __webpack_require__(168)
var ebtk = __webpack_require__(169)
var inherits = __webpack_require__(7)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 945 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(132)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(5).Buffer
var xor = __webpack_require__(132)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(5).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(5).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(132)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(5).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(412)
var Buffer = __webpack_require__(5).Buffer
var MODES = __webpack_require__(257)
var StreamCipher = __webpack_require__(413)
var Transform = __webpack_require__(82)
var aes = __webpack_require__(168)
var ebtk = __webpack_require__(169)
var inherits = __webpack_require__(7)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 953 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(414)
var primes = __webpack_require__(957)

var DH = __webpack_require__(958)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 955 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 956 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(30);
var MillerRabin = __webpack_require__(415);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(414);
var randomBytes = __webpack_require__(112);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(131)
var stream = __webpack_require__(111)
var inherits = __webpack_require__(7)
var sign = __webpack_require__(960)
var verify = __webpack_require__(992)

var algorithms = __webpack_require__(402)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(400)
var crt = __webpack_require__(259)
var EC = __webpack_require__(260).ec
var BN = __webpack_require__(30)
var parseKeys = __webpack_require__(171)
var curves = __webpack_require__(425)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.2","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_from":"elliptic@6.5.2"}

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(50);
var BN = __webpack_require__(30);
var inherits = __webpack_require__(7);
var Base = __webpack_require__(170);

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(30);
var inherits = __webpack_require__(7);
var Base = __webpack_require__(170);

var utils = __webpack_require__(50);

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(50);
var BN = __webpack_require__(30);
var inherits = __webpack_require__(7);
var Base = __webpack_require__(170);

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(966);
exports.sha224 = __webpack_require__(967);
exports.sha256 = __webpack_require__(419);
exports.sha384 = __webpack_require__(968);
exports.sha512 = __webpack_require__(420);


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var common = __webpack_require__(133);
var shaCommon = __webpack_require__(418);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var SHA256 = __webpack_require__(419);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

var SHA512 = __webpack_require__(420);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var common = __webpack_require__(133);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var assert = __webpack_require__(49);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(30);
var HmacDRBG = __webpack_require__(973);
var utils = __webpack_require__(50);
var curves = __webpack_require__(261);
var rand = __webpack_require__(258);
var assert = utils.assert;

var KeyPair = __webpack_require__(974);
var Signature = __webpack_require__(975);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(262);
var utils = __webpack_require__(416);
var assert = __webpack_require__(49);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(30);
var utils = __webpack_require__(50);
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(30);

var utils = __webpack_require__(50);
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(262);
var curves = __webpack_require__(261);
var utils = __webpack_require__(50);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(977);
var Signature = __webpack_require__(978);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(50);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(30);
var utils = __webpack_require__(50);
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(134)

exports.certificate = __webpack_require__(989)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(134);
var inherits = __webpack_require__(7);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(981).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 981 */
/***/ (function(module, exports) {

var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(135).Reporter;
var EncoderBuffer = __webpack_require__(135).EncoderBuffer;
var DecoderBuffer = __webpack_require__(135).DecoderBuffer;
var assert = __webpack_require__(49);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(422);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(423);
decoders.pem = __webpack_require__(986);


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);
var Buffer = __webpack_require__(27).Buffer;

var DERDecoder = __webpack_require__(423);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(424);
encoders.pem = __webpack_require__(988);


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(7);

var DEREncoder = __webpack_require__(424);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(134)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(169)
var ciphers = __webpack_require__(256)
var Buffer = __webpack_require__(5).Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(30)
var EC = __webpack_require__(260).ec
var parseKeys = __webpack_require__(171)
var curves = __webpack_require__(425)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(260)
var BN = __webpack_require__(30)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(995)
exports.privateDecrypt = __webpack_require__(996)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(171)
var randomBytes = __webpack_require__(112)
var createHash = __webpack_require__(131)
var mgf = __webpack_require__(426)
var xor = __webpack_require__(427)
var BN = __webpack_require__(30)
var withPublic = __webpack_require__(428)
var crt = __webpack_require__(259)
var Buffer = __webpack_require__(5).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(171)
var mgf = __webpack_require__(426)
var xor = __webpack_require__(427)
var BN = __webpack_require__(30)
var crt = __webpack_require__(259)
var createHash = __webpack_require__(131)
var withPublic = __webpack_require__(428)
var Buffer = __webpack_require__(5).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(5)
var randombytes = __webpack_require__(112)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(31)))

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(5).Buffer;

var getParamBytesForAlg = __webpack_require__(999);

var MAX_OCTET = 0x80,
	CLASS_UNIVERSAL = 0,
	PRIMITIVE_BIT = 0x20,
	TAG_SEQ = 0x10,
	TAG_INT = 0x02,
	ENCODED_TAG_SEQ = (TAG_SEQ | PRIMITIVE_BIT) | (CLASS_UNIVERSAL << 6),
	ENCODED_TAG_INT = TAG_INT | (CLASS_UNIVERSAL << 6);

function base64Url(base64) {
	return base64
		.replace(/=/g, '')
		.replace(/\+/g, '-')
		.replace(/\//g, '_');
}

function signatureAsBuffer(signature) {
	if (Buffer.isBuffer(signature)) {
		return signature;
	} else if ('string' === typeof signature) {
		return Buffer.from(signature, 'base64');
	}

	throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}

function derToJose(signature, alg) {
	signature = signatureAsBuffer(signature);
	var paramBytes = getParamBytesForAlg(alg);

	// the DER encoded param should at most be the param size, plus a padding
	// zero, since due to being a signed integer
	var maxEncodedParamLength = paramBytes + 1;

	var inputLength = signature.length;

	var offset = 0;
	if (signature[offset++] !== ENCODED_TAG_SEQ) {
		throw new Error('Could not find expected "seq"');
	}

	var seqLength = signature[offset++];
	if (seqLength === (MAX_OCTET | 1)) {
		seqLength = signature[offset++];
	}

	if (inputLength - offset < seqLength) {
		throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
	}

	if (signature[offset++] !== ENCODED_TAG_INT) {
		throw new Error('Could not find expected "int" for "r"');
	}

	var rLength = signature[offset++];

	if (inputLength - offset - 2 < rLength) {
		throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
	}

	if (maxEncodedParamLength < rLength) {
		throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
	}

	var rOffset = offset;
	offset += rLength;

	if (signature[offset++] !== ENCODED_TAG_INT) {
		throw new Error('Could not find expected "int" for "s"');
	}

	var sLength = signature[offset++];

	if (inputLength - offset !== sLength) {
		throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
	}

	if (maxEncodedParamLength < sLength) {
		throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
	}

	var sOffset = offset;
	offset += sLength;

	if (offset !== inputLength) {
		throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
	}

	var rPadding = paramBytes - rLength,
		sPadding = paramBytes - sLength;

	var dst = Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);

	for (offset = 0; offset < rPadding; ++offset) {
		dst[offset] = 0;
	}
	signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);

	offset = paramBytes;

	for (var o = offset; offset < o + sPadding; ++offset) {
		dst[offset] = 0;
	}
	signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);

	dst = dst.toString('base64');
	dst = base64Url(dst);

	return dst;
}

function countPadding(buf, start, stop) {
	var padding = 0;
	while (start + padding < stop && buf[start + padding] === 0) {
		++padding;
	}

	var needsSign = buf[start + padding] >= MAX_OCTET;
	if (needsSign) {
		--padding;
	}

	return padding;
}

function joseToDer(signature, alg) {
	signature = signatureAsBuffer(signature);
	var paramBytes = getParamBytesForAlg(alg);

	var signatureBytes = signature.length;
	if (signatureBytes !== paramBytes * 2) {
		throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
	}

	var rPadding = countPadding(signature, 0, paramBytes);
	var sPadding = countPadding(signature, paramBytes, signature.length);
	var rLength = paramBytes - rPadding;
	var sLength = paramBytes - sPadding;

	var rsBytes = 1 + 1 + rLength + 1 + 1 + sLength;

	var shortLength = rsBytes < MAX_OCTET;

	var dst = Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);

	var offset = 0;
	dst[offset++] = ENCODED_TAG_SEQ;
	if (shortLength) {
		// Bit 8 has value "0"
		// bits 7-1 give the length.
		dst[offset++] = rsBytes;
	} else {
		// Bit 8 of first octet has value "1"
		// bits 7-1 give the number of additional length octets.
		dst[offset++] = MAX_OCTET	| 1;
		// length, base 256
		dst[offset++] = rsBytes & 0xff;
	}
	dst[offset++] = ENCODED_TAG_INT;
	dst[offset++] = rLength;
	if (rPadding < 0) {
		dst[offset++] = 0;
		offset += signature.copy(dst, offset, 0, paramBytes);
	} else {
		offset += signature.copy(dst, offset, rPadding, paramBytes);
	}
	dst[offset++] = ENCODED_TAG_INT;
	dst[offset++] = sLength;
	if (sPadding < 0) {
		dst[offset++] = 0;
		signature.copy(dst, offset, paramBytes);
	} else {
		signature.copy(dst, offset, paramBytes + sPadding);
	}

	return dst;
}

module.exports = {
	derToJose: derToJose,
	joseToDer: joseToDer
};


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getParamSize(keySize) {
	var result = ((keySize / 8) | 0) + (keySize % 8 === 0 ? 0 : 1);
	return result;
}

var paramBytesForAlg = {
	ES256: getParamSize(256),
	ES384: getParamSize(384),
	ES512: getParamSize(521)
};

function getParamBytesForAlg(alg) {
	var paramBytes = paramBytesForAlg[alg];
	if (paramBytes) {
		return paramBytes;
	}

	throw new Error('Unknown algorithm "' + alg + '"');
}

module.exports = getParamBytesForAlg;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

/*global module*/
var Buffer = __webpack_require__(5).Buffer;
var DataStream = __webpack_require__(391);
var jwa = __webpack_require__(396);
var Stream = __webpack_require__(111);
var toString = __webpack_require__(429);
var util = __webpack_require__(110);
var JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;

function isObject(thing) {
  return Object.prototype.toString.call(thing) === '[object Object]';
}

function safeJsonParse(thing) {
  if (isObject(thing))
    return thing;
  try { return JSON.parse(thing); }
  catch (e) { return undefined; }
}

function headerFromJWS(jwsSig) {
  var encodedHeader = jwsSig.split('.', 1)[0];
  return safeJsonParse(Buffer.from(encodedHeader, 'base64').toString('binary'));
}

function securedInputFromJWS(jwsSig) {
  return jwsSig.split('.', 2).join('.');
}

function signatureFromJWS(jwsSig) {
  return jwsSig.split('.')[2];
}

function payloadFromJWS(jwsSig, encoding) {
  encoding = encoding || 'utf8';
  var payload = jwsSig.split('.')[1];
  return Buffer.from(payload, 'base64').toString(encoding);
}

function isValidJws(string) {
  return JWS_REGEX.test(string) && !!headerFromJWS(string);
}

function jwsVerify(jwsSig, algorithm, secretOrKey) {
  if (!algorithm) {
    var err = new Error("Missing algorithm parameter for jws.verify");
    err.code = "MISSING_ALGORITHM";
    throw err;
  }
  jwsSig = toString(jwsSig);
  var signature = signatureFromJWS(jwsSig);
  var securedInput = securedInputFromJWS(jwsSig);
  var algo = jwa(algorithm);
  return algo.verify(securedInput, signature, secretOrKey);
}

function jwsDecode(jwsSig, opts) {
  opts = opts || {};
  jwsSig = toString(jwsSig);

  if (!isValidJws(jwsSig))
    return null;

  var header = headerFromJWS(jwsSig);

  if (!header)
    return null;

  var payload = payloadFromJWS(jwsSig);
  if (header.typ === 'JWT' || opts.json)
    payload = JSON.parse(payload, opts.encoding);

  return {
    header: header,
    payload: payload,
    signature: signatureFromJWS(jwsSig)
  };
}

function VerifyStream(opts) {
  opts = opts || {};
  var secretOrKey = opts.secret||opts.publicKey||opts.key;
  var secretStream = new DataStream(secretOrKey);
  this.readable = true;
  this.algorithm = opts.algorithm;
  this.encoding = opts.encoding;
  this.secret = this.publicKey = this.key = secretStream;
  this.signature = new DataStream(opts.signature);
  this.secret.once('close', function () {
    if (!this.signature.writable && this.readable)
      this.verify();
  }.bind(this));

  this.signature.once('close', function () {
    if (!this.secret.writable && this.readable)
      this.verify();
  }.bind(this));
}
util.inherits(VerifyStream, Stream);
VerifyStream.prototype.verify = function verify() {
  try {
    var valid = jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
    var obj = jwsDecode(this.signature.buffer, this.encoding);
    this.emit('done', valid, obj);
    this.emit('data', valid);
    this.emit('end');
    this.readable = false;
    return valid;
  } catch (e) {
    this.readable = false;
    this.emit('error', e);
    this.emit('close');
  }
};

VerifyStream.decode = jwsDecode;
VerifyStream.isValid = isValidJws;
VerifyStream.verify = jwsVerify;

module.exports = VerifyStream;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var JsonWebTokenError = __webpack_require__(172);
var NotBeforeError    = __webpack_require__(430);
var TokenExpiredError = __webpack_require__(431);
var decode            = __webpack_require__(389);
var timespan          = __webpack_require__(432);
var PS_SUPPORTED      = __webpack_require__(433);
var jws               = __webpack_require__(247);

var PUB_KEY_ALGS = ['RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512'];
var RSA_KEY_ALGS = ['RS256', 'RS384', 'RS512'];
var HS_ALGS = ['HS256', 'HS384', 'HS512'];

if (PS_SUPPORTED) {
  PUB_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
  RSA_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
}

module.exports = function (jwtString, secretOrPublicKey, options, callback) {
  if ((typeof options === 'function') && !callback) {
    callback = options;
    options = {};
  }

  if (!options) {
    options = {};
  }

  //clone this object since we are going to mutate it.
  options = Object.assign({}, options);

  var done;

  if (callback) {
    done = callback;
  } else {
    done = function(err, data) {
      if (err) throw err;
      return data;
    };
  }

  if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') {
    return done(new JsonWebTokenError('clockTimestamp must be a number'));
  }

  if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) {
    return done(new JsonWebTokenError('nonce must be a non-empty string'));
  }

  var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);

  if (!jwtString){
    return done(new JsonWebTokenError('jwt must be provided'));
  }

  if (typeof jwtString !== 'string') {
    return done(new JsonWebTokenError('jwt must be a string'));
  }

  var parts = jwtString.split('.');

  if (parts.length !== 3){
    return done(new JsonWebTokenError('jwt malformed'));
  }

  var decodedToken;

  try {
    decodedToken = decode(jwtString, { complete: true });
  } catch(err) {
    return done(err);
  }

  if (!decodedToken) {
    return done(new JsonWebTokenError('invalid token'));
  }

  var header = decodedToken.header;
  var getSecret;

  if(typeof secretOrPublicKey === 'function') {
    if(!callback) {
      return done(new JsonWebTokenError('verify must be called asynchronous if secret or public key is provided as a callback'));
    }

    getSecret = secretOrPublicKey;
  }
  else {
    getSecret = function(header, secretCallback) {
      return secretCallback(null, secretOrPublicKey);
    };
  }

  return getSecret(header, function(err, secretOrPublicKey) {
    if(err) {
      return done(new JsonWebTokenError('error in secret or public key callback: ' + err.message));
    }

    var hasSignature = parts[2].trim() !== '';

    if (!hasSignature && secretOrPublicKey){
      return done(new JsonWebTokenError('jwt signature is required'));
    }

    if (hasSignature && !secretOrPublicKey) {
      return done(new JsonWebTokenError('secret or public key must be provided'));
    }

    if (!hasSignature && !options.algorithms) {
      options.algorithms = ['none'];
    }

    if (!options.algorithms) {
      options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') ||
        ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ? PUB_KEY_ALGS :
        ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ? RSA_KEY_ALGS : HS_ALGS;

    }

    if (!~options.algorithms.indexOf(decodedToken.header.alg)) {
      return done(new JsonWebTokenError('invalid algorithm'));
    }

    var valid;

    try {
      valid = jws.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
    } catch (e) {
      return done(e);
    }

    if (!valid) {
      return done(new JsonWebTokenError('invalid signature'));
    }

    var payload = decodedToken.payload;

    if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
      if (typeof payload.nbf !== 'number') {
        return done(new JsonWebTokenError('invalid nbf value'));
      }
      if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) {
        return done(new NotBeforeError('jwt not active', new Date(payload.nbf * 1000)));
      }
    }

    if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
      if (typeof payload.exp !== 'number') {
        return done(new JsonWebTokenError('invalid exp value'));
      }
      if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) {
        return done(new TokenExpiredError('jwt expired', new Date(payload.exp * 1000)));
      }
    }

    if (options.audience) {
      var audiences = Array.isArray(options.audience) ? options.audience : [options.audience];
      var target = Array.isArray(payload.aud) ? payload.aud : [payload.aud];

      var match = target.some(function (targetAudience) {
        return audiences.some(function (audience) {
          return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
        });
      });

      if (!match) {
        return done(new JsonWebTokenError('jwt audience invalid. expected: ' + audiences.join(' or ')));
      }
    }

    if (options.issuer) {
      var invalid_issuer =
              (typeof options.issuer === 'string' && payload.iss !== options.issuer) ||
              (Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1);

      if (invalid_issuer) {
        return done(new JsonWebTokenError('jwt issuer invalid. expected: ' + options.issuer));
      }
    }

    if (options.subject) {
      if (payload.sub !== options.subject) {
        return done(new JsonWebTokenError('jwt subject invalid. expected: ' + options.subject));
      }
    }

    if (options.jwtid) {
      if (payload.jti !== options.jwtid) {
        return done(new JsonWebTokenError('jwt jwtid invalid. expected: ' + options.jwtid));
      }
    }

    if (options.nonce) {
      if (payload.nonce !== options.nonce) {
        return done(new JsonWebTokenError('jwt nonce invalid. expected: ' + options.nonce));
      }
    }

    if (options.maxAge) {
      if (typeof payload.iat !== 'number') {
        return done(new JsonWebTokenError('iat required when maxAge is specified'));
      }

      var maxAgeTimestamp = timespan(options.maxAge, payload.iat);
      if (typeof maxAgeTimestamp === 'undefined') {
        return done(new JsonWebTokenError('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
      }
      if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) {
        return done(new TokenExpiredError('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
      }
    }

    if (options.complete === true) {
      var signature = decodedToken.signature;

      return done(null, {
        header: header,
        payload: payload,
        signature: signature
      });
    }

    return done(null, payload);
  });
};


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer

var debug
/* istanbul ignore next */
if (typeof process === 'object' &&
    Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}) &&
    Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}).NODE_DEBUG &&
    /\bsemver\b/i.test(Object({"NODE_ENV":"production","BASE_LINK":undefined,"PUBLIC_URL":"https://d3as7bv2o8grkq.cloudfront.net","REACT_APP_STRIPE_KEY":"pk_test_pHVAlJpIbJfYc9EJp7zEYwcL","REACT_APP_API_URL":"https://api.legalplace.eu","REACT_APP_PAYPAL_CLIENT_ID":"AbjgtSBTENtMdpl-1i4LlKmY2N9HAJpiKO6JuAQ3OYrxcyS2gGJPWGl59_LzXu3-I1VLLPNTAigsAJdy","REACT_APP_BO_FORMALITES":"https://formalites.legalplace.eu","REACT_APP_COOKIES_ALL_SUBDOMAIN":".legalplace.eu","REACT_APP_REDIRECTED_URL":"https://www.legalplace.eu","REACT_APP_FRANFINANCE_MERCHANT_ID":"101040036520001"}).NODE_DEBUG)) {
  debug = function () {
    var args = Array.prototype.slice.call(arguments, 0)
    args.unshift('SEMVER')
    console.log.apply(console, args)
  }
} else {
  debug = function () {}
}

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0'

var MAX_LENGTH = 256
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
  /* istanbul ignore next */ 9007199254740991

// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16

// The actual regexps go on exports.re
var re = exports.re = []
var src = exports.src = []
var R = 0

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*'
var NUMERICIDENTIFIERLOOSE = R++
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+'

// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*'

// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')'

var MAINVERSIONLOOSE = R++
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')'

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')'

var PRERELEASEIDENTIFIERLOOSE = R++
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')'

// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))'

var PRERELEASELOOSE = R++
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))'

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+'

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))'

// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?'

src[FULL] = '^' + FULLPLAIN + '$'

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?'

var LOOSE = R++
src[LOOSE] = '^' + LOOSEPLAIN + '$'

var GTLT = R++
src[GTLT] = '((?:<|>)?=?)'

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*'
var XRANGEIDENTIFIER = R++
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*'

var XRANGEPLAIN = R++
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?'

var XRANGEPLAINLOOSE = R++
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?'

var XRANGE = R++
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$'
var XRANGELOOSE = R++
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$'

// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++
src[COERCE] = '(?:^|[^\\d])' +
              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
              '(?:$|[^\\d])'

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++
src[LONETILDE] = '(?:~>?)'

var TILDETRIM = R++
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+'
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g')
var tildeTrimReplace = '$1~'

var TILDE = R++
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$'
var TILDELOOSE = R++
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$'

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++
src[LONECARET] = '(?:\\^)'

var CARETTRIM = R++
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+'
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g')
var caretTrimReplace = '$1^'

var CARET = R++
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$'
var CARETLOOSE = R++
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$'

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$'
var COMPARATOR = R++
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$'

// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')'

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g')
var comparatorTrimReplace = '$1$2$3'

// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$'

var HYPHENRANGELOOSE = R++
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$'

// Star ranges basically just allow anything at all.
var STAR = R++
src[STAR] = '(<|>)?=?\\s*\\*'

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i])
  if (!re[i]) {
    re[i] = new RegExp(src[i])
  }
}

exports.parse = parse
function parse (version, options) {
  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }

  if (version instanceof SemVer) {
    return version
  }

  if (typeof version !== 'string') {
    return null
  }

  if (version.length > MAX_LENGTH) {
    return null
  }

  var r = options.loose ? re[LOOSE] : re[FULL]
  if (!r.test(version)) {
    return null
  }

  try {
    return new SemVer(version, options)
  } catch (er) {
    return null
  }
}

exports.valid = valid
function valid (version, options) {
  var v = parse(version, options)
  return v ? v.version : null
}

exports.clean = clean
function clean (version, options) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), options)
  return s ? s.version : null
}

exports.SemVer = SemVer

function SemVer (version, options) {
  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }
  if (version instanceof SemVer) {
    if (version.loose === options.loose) {
      return version
    } else {
      version = version.version
    }
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version)
  }

  if (version.length > MAX_LENGTH) {
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')
  }

  if (!(this instanceof SemVer)) {
    return new SemVer(version, options)
  }

  debug('SemVer', version, options)
  this.options = options
  this.loose = !!options.loose

  var m = version.trim().match(options.loose ? re[LOOSE] : re[FULL])

  if (!m) {
    throw new TypeError('Invalid Version: ' + version)
  }

  this.raw = version

  // these are actually numbers
  this.major = +m[1]
  this.minor = +m[2]
  this.patch = +m[3]

  if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
    throw new TypeError('Invalid major version')
  }

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
    throw new TypeError('Invalid minor version')
  }

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
    throw new TypeError('Invalid patch version')
  }

  // numberify any prerelease numeric ids
  if (!m[4]) {
    this.prerelease = []
  } else {
    this.prerelease = m[4].split('.').map(function (id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id
        if (num >= 0 && num < MAX_SAFE_INTEGER) {
          return num
        }
      }
      return id
    })
  }

  this.build = m[5] ? m[5].split('.') : []
  this.format()
}

SemVer.prototype.format = function () {
  this.version = this.major + '.' + this.minor + '.' + this.patch
  if (this.prerelease.length) {
    this.version += '-' + this.prerelease.join('.')
  }
  return this.version
}

SemVer.prototype.toString = function () {
  return this.version
}

SemVer.prototype.compare = function (other) {
  debug('SemVer.compare', this.version, this.options, other)
  if (!(other instanceof SemVer)) {
    other = new SemVer(other, this.options)
  }

  return this.compareMain(other) || this.comparePre(other)
}

SemVer.prototype.compareMain = function (other) {
  if (!(other instanceof SemVer)) {
    other = new SemVer(other, this.options)
  }

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch)
}

SemVer.prototype.comparePre = function (other) {
  if (!(other instanceof SemVer)) {
    other = new SemVer(other, this.options)
  }

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length) {
    return -1
  } else if (!this.prerelease.length && other.prerelease.length) {
    return 1
  } else if (!this.prerelease.length && !other.prerelease.length) {
    return 0
  }

  var i = 0
  do {
    var a = this.prerelease[i]
    var b = other.prerelease[i]
    debug('prerelease compare', i, a, b)
    if (a === undefined && b === undefined) {
      return 0
    } else if (b === undefined) {
      return 1
    } else if (a === undefined) {
      return -1
    } else if (a === b) {
      continue
    } else {
      return compareIdentifiers(a, b)
    }
  } while (++i)
}

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function (release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0
      this.patch = 0
      this.minor = 0
      this.major++
      this.inc('pre', identifier)
      break
    case 'preminor':
      this.prerelease.length = 0
      this.patch = 0
      this.minor++
      this.inc('pre', identifier)
      break
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0
      this.inc('patch', identifier)
      this.inc('pre', identifier)
      break
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0) {
        this.inc('patch', identifier)
      }
      this.inc('pre', identifier)
      break

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 ||
          this.patch !== 0 ||
          this.prerelease.length === 0) {
        this.major++
      }
      this.minor = 0
      this.patch = 0
      this.prerelease = []
      break
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0) {
        this.minor++
      }
      this.patch = 0
      this.prerelease = []
      break
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0) {
        this.patch++
      }
      this.prerelease = []
      break
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0) {
        this.prerelease = [0]
      } else {
        var i = this.prerelease.length
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++
            i = -2
          }
        }
        if (i === -1) {
          // didn't increment anything
          this.prerelease.push(0)
        }
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1])) {
            this.prerelease = [identifier, 0]
          }
        } else {
          this.prerelease = [identifier, 0]
        }
      }
      break

    default:
      throw new Error('invalid increment argument: ' + release)
  }
  this.format()
  this.raw = this.version
  return this
}

exports.inc = inc
function inc (version, release, loose, identifier) {
  if (typeof (loose) === 'string') {
    identifier = loose
    loose = undefined
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version
  } catch (er) {
    return null
  }
}

exports.diff = diff
function diff (version1, version2) {
  if (eq(version1, version2)) {
    return null
  } else {
    var v1 = parse(version1)
    var v2 = parse(version2)
    var prefix = ''
    if (v1.prerelease.length || v2.prerelease.length) {
      prefix = 'pre'
      var defaultResult = 'prerelease'
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return prefix + key
        }
      }
    }
    return defaultResult // may be undefined
  }
}

exports.compareIdentifiers = compareIdentifiers

var numeric = /^[0-9]+$/
function compareIdentifiers (a, b) {
  var anum = numeric.test(a)
  var bnum = numeric.test(b)

  if (anum && bnum) {
    a = +a
    b = +b
  }

  return a === b ? 0
    : (anum && !bnum) ? -1
    : (bnum && !anum) ? 1
    : a < b ? -1
    : 1
}

exports.rcompareIdentifiers = rcompareIdentifiers
function rcompareIdentifiers (a, b) {
  return compareIdentifiers(b, a)
}

exports.major = major
function major (a, loose) {
  return new SemVer(a, loose).major
}

exports.minor = minor
function minor (a, loose) {
  return new SemVer(a, loose).minor
}

exports.patch = patch
function patch (a, loose) {
  return new SemVer(a, loose).patch
}

exports.compare = compare
function compare (a, b, loose) {
  return new SemVer(a, loose).compare(new SemVer(b, loose))
}

exports.compareLoose = compareLoose
function compareLoose (a, b) {
  return compare(a, b, true)
}

exports.rcompare = rcompare
function rcompare (a, b, loose) {
  return compare(b, a, loose)
}

exports.sort = sort
function sort (list, loose) {
  return list.sort(function (a, b) {
    return exports.compare(a, b, loose)
  })
}

exports.rsort = rsort
function rsort (list, loose) {
  return list.sort(function (a, b) {
    return exports.rcompare(a, b, loose)
  })
}

exports.gt = gt
function gt (a, b, loose) {
  return compare(a, b, loose) > 0
}

exports.lt = lt
function lt (a, b, loose) {
  return compare(a, b, loose) < 0
}

exports.eq = eq
function eq (a, b, loose) {
  return compare(a, b, loose) === 0
}

exports.neq = neq
function neq (a, b, loose) {
  return compare(a, b, loose) !== 0
}

exports.gte = gte
function gte (a, b, loose) {
  return compare(a, b, loose) >= 0
}

exports.lte = lte
function lte (a, b, loose) {
  return compare(a, b, loose) <= 0
}

exports.cmp = cmp
function cmp (a, op, b, loose) {
  switch (op) {
    case '===':
      if (typeof a === 'object')
        a = a.version
      if (typeof b === 'object')
        b = b.version
      return a === b

    case '!==':
      if (typeof a === 'object')
        a = a.version
      if (typeof b === 'object')
        b = b.version
      return a !== b

    case '':
    case '=':
    case '==':
      return eq(a, b, loose)

    case '!=':
      return neq(a, b, loose)

    case '>':
      return gt(a, b, loose)

    case '>=':
      return gte(a, b, loose)

    case '<':
      return lt(a, b, loose)

    case '<=':
      return lte(a, b, loose)

    default:
      throw new TypeError('Invalid operator: ' + op)
  }
}

exports.Comparator = Comparator
function Comparator (comp, options) {
  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }

  if (comp instanceof Comparator) {
    if (comp.loose === !!options.loose) {
      return comp
    } else {
      comp = comp.value
    }
  }

  if (!(this instanceof Comparator)) {
    return new Comparator(comp, options)
  }

  debug('comparator', comp, options)
  this.options = options
  this.loose = !!options.loose
  this.parse(comp)

  if (this.semver === ANY) {
    this.value = ''
  } else {
    this.value = this.operator + this.semver.version
  }

  debug('comp', this)
}

var ANY = {}
Comparator.prototype.parse = function (comp) {
  var r = this.options.loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
  var m = comp.match(r)

  if (!m) {
    throw new TypeError('Invalid comparator: ' + comp)
  }

  this.operator = m[1]
  if (this.operator === '=') {
    this.operator = ''
  }

  // if it literally is just '>' or '' then allow anything.
  if (!m[2]) {
    this.semver = ANY
  } else {
    this.semver = new SemVer(m[2], this.options.loose)
  }
}

Comparator.prototype.toString = function () {
  return this.value
}

Comparator.prototype.test = function (version) {
  debug('Comparator.test', version, this.options.loose)

  if (this.semver === ANY) {
    return true
  }

  if (typeof version === 'string') {
    version = new SemVer(version, this.options)
  }

  return cmp(version, this.operator, this.semver, this.options)
}

Comparator.prototype.intersects = function (comp, options) {
  if (!(comp instanceof Comparator)) {
    throw new TypeError('a Comparator is required')
  }

  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }

  var rangeTmp

  if (this.operator === '') {
    rangeTmp = new Range(comp.value, options)
    return satisfies(this.value, rangeTmp, options)
  } else if (comp.operator === '') {
    rangeTmp = new Range(this.value, options)
    return satisfies(comp.semver, rangeTmp, options)
  }

  var sameDirectionIncreasing =
    (this.operator === '>=' || this.operator === '>') &&
    (comp.operator === '>=' || comp.operator === '>')
  var sameDirectionDecreasing =
    (this.operator === '<=' || this.operator === '<') &&
    (comp.operator === '<=' || comp.operator === '<')
  var sameSemVer = this.semver.version === comp.semver.version
  var differentDirectionsInclusive =
    (this.operator === '>=' || this.operator === '<=') &&
    (comp.operator === '>=' || comp.operator === '<=')
  var oppositeDirectionsLessThan =
    cmp(this.semver, '<', comp.semver, options) &&
    ((this.operator === '>=' || this.operator === '>') &&
    (comp.operator === '<=' || comp.operator === '<'))
  var oppositeDirectionsGreaterThan =
    cmp(this.semver, '>', comp.semver, options) &&
    ((this.operator === '<=' || this.operator === '<') &&
    (comp.operator === '>=' || comp.operator === '>'))

  return sameDirectionIncreasing || sameDirectionDecreasing ||
    (sameSemVer && differentDirectionsInclusive) ||
    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan
}

exports.Range = Range
function Range (range, options) {
  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }

  if (range instanceof Range) {
    if (range.loose === !!options.loose &&
        range.includePrerelease === !!options.includePrerelease) {
      return range
    } else {
      return new Range(range.raw, options)
    }
  }

  if (range instanceof Comparator) {
    return new Range(range.value, options)
  }

  if (!(this instanceof Range)) {
    return new Range(range, options)
  }

  this.options = options
  this.loose = !!options.loose
  this.includePrerelease = !!options.includePrerelease

  // First, split based on boolean or ||
  this.raw = range
  this.set = range.split(/\s*\|\|\s*/).map(function (range) {
    return this.parseRange(range.trim())
  }, this).filter(function (c) {
    // throw out any that are not relevant for whatever reason
    return c.length
  })

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range)
  }

  this.format()
}

Range.prototype.format = function () {
  this.range = this.set.map(function (comps) {
    return comps.join(' ').trim()
  }).join('||').trim()
  return this.range
}

Range.prototype.toString = function () {
  return this.range
}

Range.prototype.parseRange = function (range) {
  var loose = this.options.loose
  range = range.trim()
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE]
  range = range.replace(hr, hyphenReplace)
  debug('hyphen replace', range)
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace)
  debug('comparator trim', range, re[COMPARATORTRIM])

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace)

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace)

  // normalize spaces
  range = range.split(/\s+/).join(' ')

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
  var set = range.split(' ').map(function (comp) {
    return parseComparator(comp, this.options)
  }, this).join(' ').split(/\s+/)
  if (this.options.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function (comp) {
      return !!comp.match(compRe)
    })
  }
  set = set.map(function (comp) {
    return new Comparator(comp, this.options)
  }, this)

  return set
}

Range.prototype.intersects = function (range, options) {
  if (!(range instanceof Range)) {
    throw new TypeError('a Range is required')
  }

  return this.set.some(function (thisComparators) {
    return thisComparators.every(function (thisComparator) {
      return range.set.some(function (rangeComparators) {
        return rangeComparators.every(function (rangeComparator) {
          return thisComparator.intersects(rangeComparator, options)
        })
      })
    })
  })
}

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators
function toComparators (range, options) {
  return new Range(range, options).set.map(function (comp) {
    return comp.map(function (c) {
      return c.value
    }).join(' ').trim().split(' ')
  })
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator (comp, options) {
  debug('comp', comp, options)
  comp = replaceCarets(comp, options)
  debug('caret', comp)
  comp = replaceTildes(comp, options)
  debug('tildes', comp)
  comp = replaceXRanges(comp, options)
  debug('xrange', comp)
  comp = replaceStars(comp, options)
  debug('stars', comp)
  return comp
}

function isX (id) {
  return !id || id.toLowerCase() === 'x' || id === '*'
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes (comp, options) {
  return comp.trim().split(/\s+/).map(function (comp) {
    return replaceTilde(comp, options)
  }).join(' ')
}

function replaceTilde (comp, options) {
  var r = options.loose ? re[TILDELOOSE] : re[TILDE]
  return comp.replace(r, function (_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr)
    var ret

    if (isX(M)) {
      ret = ''
    } else if (isX(m)) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
    } else if (isX(p)) {
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
    } else if (pr) {
      debug('replaceTilde pr', pr)
      ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
            ' <' + M + '.' + (+m + 1) + '.0'
    } else {
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0'
    }

    debug('tilde return', ret)
    return ret
  })
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets (comp, options) {
  return comp.trim().split(/\s+/).map(function (comp) {
    return replaceCaret(comp, options)
  }).join(' ')
}

function replaceCaret (comp, options) {
  debug('caret', comp, options)
  var r = options.loose ? re[CARETLOOSE] : re[CARET]
  return comp.replace(r, function (_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr)
    var ret

    if (isX(M)) {
      ret = ''
    } else if (isX(m)) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
    } else if (isX(p)) {
      if (M === '0') {
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
      } else {
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0'
      }
    } else if (pr) {
      debug('replaceCaret pr', pr)
      if (M === '0') {
        if (m === '0') {
          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
                ' <' + M + '.' + m + '.' + (+p + 1)
        } else {
          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
                ' <' + M + '.' + (+m + 1) + '.0'
        }
      } else {
        ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
              ' <' + (+M + 1) + '.0.0'
      }
    } else {
      debug('no pr')
      if (M === '0') {
        if (m === '0') {
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1)
        } else {
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0'
        }
      } else {
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0'
      }
    }

    debug('caret return', ret)
    return ret
  })
}

function replaceXRanges (comp, options) {
  debug('replaceXRanges', comp, options)
  return comp.split(/\s+/).map(function (comp) {
    return replaceXRange(comp, options)
  }).join(' ')
}

function replaceXRange (comp, options) {
  comp = comp.trim()
  var r = options.loose ? re[XRANGELOOSE] : re[XRANGE]
  return comp.replace(r, function (ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr)
    var xM = isX(M)
    var xm = xM || isX(m)
    var xp = xm || isX(p)
    var anyX = xp

    if (gtlt === '=' && anyX) {
      gtlt = ''
    }

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0'
      } else {
        // nothing is forbidden
        ret = '*'
      }
    } else if (gtlt && anyX) {
      // we know patch is an x, because we have any x at all.
      // replace X with 0
      if (xm) {
        m = 0
      }
      p = 0

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>='
        if (xm) {
          M = +M + 1
          m = 0
          p = 0
        } else {
          m = +m + 1
          p = 0
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<'
        if (xm) {
          M = +M + 1
        } else {
          m = +m + 1
        }
      }

      ret = gtlt + M + '.' + m + '.' + p
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
    }

    debug('xRange return', ret)

    return ret
  })
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars (comp, options) {
  debug('replaceStars', comp, options)
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '')
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace ($0,
  from, fM, fm, fp, fpr, fb,
  to, tM, tm, tp, tpr, tb) {
  if (isX(fM)) {
    from = ''
  } else if (isX(fm)) {
    from = '>=' + fM + '.0.0'
  } else if (isX(fp)) {
    from = '>=' + fM + '.' + fm + '.0'
  } else {
    from = '>=' + from
  }

  if (isX(tM)) {
    to = ''
  } else if (isX(tm)) {
    to = '<' + (+tM + 1) + '.0.0'
  } else if (isX(tp)) {
    to = '<' + tM + '.' + (+tm + 1) + '.0'
  } else if (tpr) {
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr
  } else {
    to = '<=' + to
  }

  return (from + ' ' + to).trim()
}

// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function (version) {
  if (!version) {
    return false
  }

  if (typeof version === 'string') {
    version = new SemVer(version, this.options)
  }

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version, this.options)) {
      return true
    }
  }
  return false
}

function testSet (set, version, options) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version)) {
      return false
    }
  }

  if (version.prerelease.length && !options.includePrerelease) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (i = 0; i < set.length; i++) {
      debug(set[i].semver)
      if (set[i].semver === ANY) {
        continue
      }

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch) {
          return true
        }
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false
  }

  return true
}

exports.satisfies = satisfies
function satisfies (version, range, options) {
  try {
    range = new Range(range, options)
  } catch (er) {
    return false
  }
  return range.test(version)
}

exports.maxSatisfying = maxSatisfying
function maxSatisfying (versions, range, options) {
  var max = null
  var maxSV = null
  try {
    var rangeObj = new Range(range, options)
  } catch (er) {
    return null
  }
  versions.forEach(function (v) {
    if (rangeObj.test(v)) {
      // satisfies(v, range, options)
      if (!max || maxSV.compare(v) === -1) {
        // compare(max, v, true)
        max = v
        maxSV = new SemVer(max, options)
      }
    }
  })
  return max
}

exports.minSatisfying = minSatisfying
function minSatisfying (versions, range, options) {
  var min = null
  var minSV = null
  try {
    var rangeObj = new Range(range, options)
  } catch (er) {
    return null
  }
  versions.forEach(function (v) {
    if (rangeObj.test(v)) {
      // satisfies(v, range, options)
      if (!min || minSV.compare(v) === 1) {
        // compare(min, v, true)
        min = v
        minSV = new SemVer(min, options)
      }
    }
  })
  return min
}

exports.minVersion = minVersion
function minVersion (range, loose) {
  range = new Range(range, loose)

  var minver = new SemVer('0.0.0')
  if (range.test(minver)) {
    return minver
  }

  minver = new SemVer('0.0.0-0')
  if (range.test(minver)) {
    return minver
  }

  minver = null
  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i]

    comparators.forEach(function (comparator) {
      // Clone to avoid manipulating the comparator's semver object.
      var compver = new SemVer(comparator.semver.version)
      switch (comparator.operator) {
        case '>':
          if (compver.prerelease.length === 0) {
            compver.patch++
          } else {
            compver.prerelease.push(0)
          }
          compver.raw = compver.format()
          /* fallthrough */
        case '':
        case '>=':
          if (!minver || gt(minver, compver)) {
            minver = compver
          }
          break
        case '<':
        case '<=':
          /* Ignore maximum versions */
          break
        /* istanbul ignore next */
        default:
          throw new Error('Unexpected operation: ' + comparator.operator)
      }
    })
  }

  if (minver && range.test(minver)) {
    return minver
  }

  return null
}

exports.validRange = validRange
function validRange (range, options) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, options).range || '*'
  } catch (er) {
    return null
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr
function ltr (version, range, options) {
  return outside(version, range, '<', options)
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr
function gtr (version, range, options) {
  return outside(version, range, '>', options)
}

exports.outside = outside
function outside (version, range, hilo, options) {
  version = new SemVer(version, options)
  range = new Range(range, options)

  var gtfn, ltefn, ltfn, comp, ecomp
  switch (hilo) {
    case '>':
      gtfn = gt
      ltefn = lte
      ltfn = lt
      comp = '>'
      ecomp = '>='
      break
    case '<':
      gtfn = lt
      ltefn = gte
      ltfn = gt
      comp = '<'
      ecomp = '<='
      break
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"')
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, options)) {
    return false
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i]

    var high = null
    var low = null

    comparators.forEach(function (comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator
      low = low || comparator
      if (gtfn(comparator.semver, high.semver, options)) {
        high = comparator
      } else if (ltfn(comparator.semver, low.semver, options)) {
        low = comparator
      }
    })

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false
    }
  }
  return true
}

exports.prerelease = prerelease
function prerelease (version, options) {
  var parsed = parse(version, options)
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
}

exports.intersects = intersects
function intersects (r1, r2, options) {
  r1 = new Range(r1, options)
  r2 = new Range(r2, options)
  return r1.intersects(r2)
}

exports.coerce = coerce
function coerce (version) {
  if (version instanceof SemVer) {
    return version
  }

  if (typeof version !== 'string') {
    return null
  }

  var match = version.match(re[COERCE])

  if (match == null) {
    return null
  }

  return parse(match[1] +
    '.' + (match[2] || '0') +
    '.' + (match[3] || '0'))
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var timespan = __webpack_require__(432);
var PS_SUPPORTED = __webpack_require__(433);
var jws = __webpack_require__(247);
var includes = __webpack_require__(1005);
var isBoolean = __webpack_require__(1006);
var isInteger = __webpack_require__(1007);
var isNumber = __webpack_require__(1008);
var isPlainObject = __webpack_require__(1009);
var isString = __webpack_require__(1010);
var once = __webpack_require__(1011);

var SUPPORTED_ALGS = ['RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512', 'HS256', 'HS384', 'HS512', 'none']
if (PS_SUPPORTED) {
  SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
}

var sign_options_schema = {
  expiresIn: { isValid: function(value) { return isInteger(value) || (isString(value) && value); }, message: '"expiresIn" should be a number of seconds or string representing a timespan' },
  notBefore: { isValid: function(value) { return isInteger(value) || (isString(value) && value); }, message: '"notBefore" should be a number of seconds or string representing a timespan' },
  audience: { isValid: function(value) { return isString(value) || Array.isArray(value); }, message: '"audience" must be a string or array' },
  algorithm: { isValid: includes.bind(null, SUPPORTED_ALGS), message: '"algorithm" must be a valid string enum value' },
  header: { isValid: isPlainObject, message: '"header" must be an object' },
  encoding: { isValid: isString, message: '"encoding" must be a string' },
  issuer: { isValid: isString, message: '"issuer" must be a string' },
  subject: { isValid: isString, message: '"subject" must be a string' },
  jwtid: { isValid: isString, message: '"jwtid" must be a string' },
  noTimestamp: { isValid: isBoolean, message: '"noTimestamp" must be a boolean' },
  keyid: { isValid: isString, message: '"keyid" must be a string' },
  mutatePayload: { isValid: isBoolean, message: '"mutatePayload" must be a boolean' }
};

var registered_claims_schema = {
  iat: { isValid: isNumber, message: '"iat" should be a number of seconds' },
  exp: { isValid: isNumber, message: '"exp" should be a number of seconds' },
  nbf: { isValid: isNumber, message: '"nbf" should be a number of seconds' }
};

function validate(schema, allowUnknown, object, parameterName) {
  if (!isPlainObject(object)) {
    throw new Error('Expected "' + parameterName + '" to be a plain object.');
  }
  Object.keys(object)
    .forEach(function(key) {
      var validator = schema[key];
      if (!validator) {
        if (!allowUnknown) {
          throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
        }
        return;
      }
      if (!validator.isValid(object[key])) {
        throw new Error(validator.message);
      }
    });
}

function validateOptions(options) {
  return validate(sign_options_schema, false, options, 'options');
}

function validatePayload(payload) {
  return validate(registered_claims_schema, true, payload, 'payload');
}

var options_to_payload = {
  'audience': 'aud',
  'issuer': 'iss',
  'subject': 'sub',
  'jwtid': 'jti'
};

var options_for_objects = [
  'expiresIn',
  'notBefore',
  'noTimestamp',
  'audience',
  'issuer',
  'subject',
  'jwtid',
];

module.exports = function (payload, secretOrPrivateKey, options, callback) {
  if (typeof options === 'function') {
    callback = options;
    options = {};
  } else {
    options = options || {};
  }

  var isObjectPayload = typeof payload === 'object' &&
                        !Buffer.isBuffer(payload);

  var header = Object.assign({
    alg: options.algorithm || 'HS256',
    typ: isObjectPayload ? 'JWT' : undefined,
    kid: options.keyid
  }, options.header);

  function failure(err) {
    if (callback) {
      return callback(err);
    }
    throw err;
  }

  if (!secretOrPrivateKey && options.algorithm !== 'none') {
    return failure(new Error('secretOrPrivateKey must have a value'));
  }

  if (typeof payload === 'undefined') {
    return failure(new Error('payload is required'));
  } else if (isObjectPayload) {
    try {
      validatePayload(payload);
    }
    catch (error) {
      return failure(error);
    }
    if (!options.mutatePayload) {
      payload = Object.assign({},payload);
    }
  } else {
    var invalid_options = options_for_objects.filter(function (opt) {
      return typeof options[opt] !== 'undefined';
    });

    if (invalid_options.length > 0) {
      return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + (typeof payload ) + ' payload'));
    }
  }

  if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') {
    return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
  }

  if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') {
    return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
  }

  try {
    validateOptions(options);
  }
  catch (error) {
    return failure(error);
  }

  var timestamp = payload.iat || Math.floor(Date.now() / 1000);

  if (options.noTimestamp) {
    delete payload.iat;
  } else if (isObjectPayload) {
    payload.iat = timestamp;
  }

  if (typeof options.notBefore !== 'undefined') {
    try {
      payload.nbf = timespan(options.notBefore, timestamp);
    }
    catch (err) {
      return failure(err);
    }
    if (typeof payload.nbf === 'undefined') {
      return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
  }

  if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
    try {
      payload.exp = timespan(options.expiresIn, timestamp);
    }
    catch (err) {
      return failure(err);
    }
    if (typeof payload.exp === 'undefined') {
      return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
  }

  Object.keys(options_to_payload).forEach(function (key) {
    var claim = options_to_payload[key];
    if (typeof options[key] !== 'undefined') {
      if (typeof payload[claim] !== 'undefined') {
        return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
      }
      payload[claim] = options[key];
    }
  });

  var encoding = options.encoding || 'utf8';

  if (typeof callback === 'function') {
    callback = callback && once(callback);

    jws.createSign({
      header: header,
      privateKey: secretOrPrivateKey,
      payload: payload,
      encoding: encoding
    }).once('error', callback)
      .once('done', function (signature) {
        callback(null, signature);
      });
  } else {
    return jws.sign({header: header, payload: payload, secret: secretOrPrivateKey, encoding: encoding});
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27).Buffer))

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object ? baseValues(object, keys(object)) : [];
}

module.exports = includes;


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && objectToString.call(value) == boolTag);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isBoolean;


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = isInteger;


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && objectToString.call(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

module.exports = isPlainObject;


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = once;


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = outputReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\output.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// TODO: use the reduce+filter 
function variableReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_output__["e" /* INIT_OUTPUT_VARIABLE */]:// TODO: [OPT]
// console.log(action.id)
var value="";// console.log(store.getState().document_state.state)
if(__WEBPACK_IMPORTED_MODULE_3__globals__["b" /* store */].getState().document_state.state=='continue')value=Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["b" /* getVariablePass */])(action.id);else value=action.value;value=action.value;// console.log(value)
var _result_={id:action.id,value:action.value};return _result_;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["c" /* EDIT_VARIABLE_VALUE */]:var _result_={};//debugger;
if(action.id===state.id){_result_=Object.assign({},state,{value:action.value});return _result_;}else return state;return state;default:return state;}return state;}function optionReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_output__["d" /* INIT_OUTPUT_OPTION */]:var value="";if(__WEBPACK_IMPORTED_MODULE_3__globals__["b" /* store */].getState().document_state.state=='continue')value=__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.options.getOption(action.id).value;else value=false;value=action.value;var result_={id:action.id,value:value//-----------------------------------------------------
};__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.sections_cache.registerOption(action.id);//-----------------------------------------------------
return result_;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["b" /* EDIT_OPTION_VALUE */]:if(action.id==state.id){// debugger;
// console.log("jhh")
var c_id=Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["d" /* lpIdGetPure */])(action.id);return Object.assign({},state,{value:action.value});}return state;default:return state;}}function optionSReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["d" /* initializeOptions */])();switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_output__["d" /* INIT_OUTPUT_OPTION */]:var changed=false;state.map(function(idx,i){if(idx.id==action.id)changed=true;Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["k" /* reorderOption */])(idx,i);});if(!changed){var _result=state.map(function(idx){return idx;});var new_guy=optionReducer({},action);var length=_result.length;_result.push(new_guy);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["k" /* reorderOption */])(new_guy,length);return _result;}return state;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["b" /* EDIT_OPTION_VALUE */]:return state.map(function(idx,i){var opt_c=optionReducer(idx,action);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["k" /* reorderOption */])(opt_c,i);return opt_c;});case'FLUSH_AND_LOAD':var opts=__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.sections_cache.loadSectionOptions(action.id);var result=[];result=opts.map(function(idx){return{id:idx,value:__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.options.getOption(idx).value};});return result;break;default:return state;}}function variableSReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["e" /* initializeVariables */])();switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_output__["e" /* INIT_OUTPUT_VARIABLE */]:// TODO: [OPT]
// var result_ = state.map(idx => idx)
var changed_=false;var result_=state.map(function(idx,i){if(idx.id==action.id)changed_=true;Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["l" /* reorderVariable */])(idx,i);return idx;});if(!changed_){var var_c=variableReducer({},action);// Getting Value from index
// TODO SUPER DIRTY HACK MUST FIX
// INITIALIZATION MUST TAKE INTO CONSIDERATION
// CONTINUE CASES
var_c.value=__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.variables.getVariable(var_c.id).value;Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["l" /* reorderVariable */])(var_c,result_.length);result_.push(var_c);}return result_;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["c" /* EDIT_VARIABLE_VALUE */]:// if(lpIdGetPure(action.id) == 7)debugger;
// var n_action = {...action };
// if (typeof action.value == 'undefined')
//     n_action = {...n_action, value: "" }
// // update the state
// let state_ = [].concat(state);
var result=state.map(function(idx,i){Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["l" /* reorderVariable */])(idx,i);return idx;});var var_=Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["h" /* lpGetVariableById */])(action.id);if(typeof var_=='undefined')return result;result[var_.index].value=action.value;result[var_.index].key=action.key;__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.variables.updateVariable({id:action.id,value:action.value});// update the variable states
Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["i" /* lpSetVariableById */])(action.id,action.value);return result;default:return state;}return state;}function radiosReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];// uncheck all the radios
return state.map(function(idx){if(idx.key==action.key){return Object.assign({},idx,{value:action.value});}else return idx;});}function delOutputRed(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var index=arguments[1];var is_var=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var result=[];state.map(function(idx,i){if(typeof idx.id=='string'){var r=idx.id.split('_');if(r[1]!=undefined&&r[1]!=index){result.push(idx);if(!is_var)Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["k" /* reorderOption */])(idx,i);else Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["l" /* reorderVariable */])(idx,i);}else{if(!is_var){__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.options.delOption(idx.id);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["a" /* delReindexOption */])(idx.id);}else{__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.variables.delVariable(idx.id);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["b" /* delReindexVariable */])(idx.id);}}}else{result.push(idx);if(!is_var)Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["k" /* reorderOption */])(idx,i);else Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["l" /* reorderVariable */])(idx,i);}});return result;}function removeFirst(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var id=arguments[1];var copy_code=id;var opts_to_move=[];state.map(function(idx){if(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["c" /* lpIdGetCopy */])(idx.id)==copy_code){opts_to_move.push(idx);state[__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.options.getOption(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["d" /* lpIdGetPure */])(idx.id)).index].value=idx.value;}});var result=[];state.map(function(idx){if(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["c" /* lpIdGetCopy */])(idx.id)!=copy_code){return idx;}});return result;}function getAllChildren(id){var r=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var result=[];id=Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["d" /* lpIdGetPure */])(id);var now=__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].references.options[id].children;now.map(function(idx){r.push(idx);getAllChildren(idx,r);});return r;}function getAllVariableChildren(){var ids=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var result=[];ids.map(function(idx){__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].references.options[idx].variables.map(function(jdx){return result.push(jdx);});});return result;}window.check_=getAllChildren;function delFirst(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var f_c=arguments[1];var id=arguments[2];var result=[];var all_firsts=getAllChildren(id);state.map(function(idx,i){var c_id=idx.id;if(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["c" /* lpIdGetCopy */])(c_id)==f_c){result.push({id:parseInt(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["d" /* lpIdGetPure */])(c_id)),key:idx.key,value:idx.value});Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["k" /* reorderOption */])({id:parseInt(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["d" /* lpIdGetPure */])(c_id)),key:idx.key,value:idx.value},i);// Cleaning index
__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.options.delOption(c_id);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["a" /* delReindexOption */])(c_id);}else if(!all_firsts.includes(idx.id)){result.push(idx);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["k" /* reorderOption */])(idx,i);}});return result;}function delFirstV(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var f_c=arguments[1];var id=arguments[2];var result=[];var variables=getAllVariableChildren(getAllChildren(id,[]));state.map(function(idx,i){var c_id=idx.id;if(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["c" /* lpIdGetCopy */])(c_id)==f_c){result.push({id:parseInt(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["d" /* lpIdGetPure */])(c_id)),value:idx.value});Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["l" /* reorderVariable */])({id:parseInt(Object(__WEBPACK_IMPORTED_MODULE_2__logic_global_getter__["d" /* lpIdGetPure */])(c_id)),value:idx.value},i);// Cleaning index
__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.variables.delVariable(c_id);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["b" /* delReindexVariable */])(idx.id);}else{if(!variables.includes(idx.id)){result.push(idx);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["l" /* reorderVariable */])(idx,i);}else{// Cleaning index
__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].indexes.variables.delVariable(c_id);Object(__WEBPACK_IMPORTED_MODULE_1__logic_re_index__["b" /* delReindexVariable */])(idx.id);}}});// debugger;
return result;}function outputReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{o:[],v:[],c:[]};var action=arguments[1];// console.time('out_red');
var result=void 0;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_output__["d" /* INIT_OUTPUT_OPTION */]:result=Object.assign({},state,{o:optionSReducer(state.o,action)});break;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["e" /* INIT_OUTPUT_VARIABLE */]:result=Object.assign({},state,{v:variableSReducer(state.v,action)});break;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["b" /* EDIT_OPTION_VALUE */]:result=Object.assign({},state,{o:optionSReducer(state.o,action)});break;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["c" /* EDIT_VARIABLE_VALUE */]:result=Object.assign({},state,{v:variableSReducer(state.v,action)});break;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["a" /* EDIT_OPTION_RADIO */]:result=Object.assign({},state,{o:radiosReducer(state.o,action)});break;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["h" /* REM_OPTION_DUP */]:result=Object.assign({},state,{o:delOutputRed(state.o,action.id)});break;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["i" /* REM_VARIABLE_DUP */]:result=Object.assign({},state,{v:delOutputRed(state.v,action.id,true)});break;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["f" /* REMOVE_FIRST_OPTION */]:result=Object.assign({},state,{o:delFirst(state.o,action.first_copy,action.id)});break;case __WEBPACK_IMPORTED_MODULE_0__actions_output__["g" /* REMOVE_FIRST_VARIABLE */]:result=Object.assign({},state,{v:delFirstV(state.v,action.first_copy,action.id)});break;case'FLUSH_AND_LOAD':result=optionSReducer(state.o,action);break;default:result=Object.assign({},state);break;}// console.timeEnd('out_red')
return result;}

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_error__ = __webpack_require__(434);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\error.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */function errorReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{mail:false};var action=arguments[1];var result=Object.assign({},state);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_error__["a" /* MAIL_ERROR */]:result.mail=true;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_error__["b" /* MAIL_ERROR_NOT */]:result.mail=false;return result;default:return state;}}

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optionHoverReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_option_hover__ = __webpack_require__(1015);
function optionHoverReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{id:-102,parent:-102};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_option_hover__["a" /* HOVER_THIS */]:return Object.assign({},state,{id:action.id,parent:action.parent});case __WEBPACK_IMPORTED_MODULE_0__actions_option_hover__["b" /* UNHOVER_THIS */]:return{id:-102,parent:-102};}return state;}

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HOVER_THIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNHOVER_THIS; });
/* unused harmony export hoverThis */
/* unused harmony export unhoverThis */
var HOVER_THIS='HOVER_THIS_';var UNHOVER_THIS='UNHOVER_THIS';function hoverThis(id,parent){return{type:HOVER_THIS,id:id,parent:parent};}function unhoverThis(id){return{type:UNHOVER_THIS,id:id};}

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatUIReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_flat_ui__ = __webpack_require__(435);
/*
 * Project: LegalPlace assistant
 * File: src/redux/reducers/flat_ui.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// The control
function flatUIReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_flat_ui__["f" /* REMOVE_DUPLICATE */]:return[];case __WEBPACK_IMPORTED_MODULE_0__actions_flat_ui__["b" /* F_UI_CREATE */]:return state.slice();case __WEBPACK_IMPORTED_MODULE_0__actions_flat_ui__["e" /* F_UI_SET_ACTIVE */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actions_flat_ui__["c" /* F_UI_IS_MULTIPLE */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actions_flat_ui__["a" /* F_UI_COPY_NUMBER */]:return state;case __WEBPACK_IMPORTED_MODULE_0__actions_flat_ui__["d" /* F_UI_RADIO_ACTIVE */]:return state;default:return state;}}

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = account_settings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__ = __webpack_require__(23);
/*
 * Project: LegalPlace assistant
 * File: src/redux/reducers/account_settings.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */function account_settings(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{fb_id:'NONE',mail:'',exists:false,flatData:[],options:[],variables:[],multiples:[],currentSection:0,edited_doc:false,show_contact:false,card:true,x3:false,paypal:false,direct:false,is_crea_assist_sub:false,show_login_modal:false,show_singup_modal:false};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["n" /* UPDATE_MAIL_FROM_INPUT */]:return Object.assign({},state,{mail:action.value});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["c" /* LOAD_MAIL_FROM_FB */]:return Object.assign({},state,{mail:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["h" /* SET_EXISTANT_IN_FIREBASE */]:return Object.assign({},state,{exists:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["b" /* LOAD_FLAT_UI */]:return Object.assign({},state,{flatData:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["d" /* LOAD_OPTIONS */]:return Object.assign({},state,{options:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["a" /* EDITED_DOCUMENT */]:return Object.assign({},state,{edited_doc:action.edited});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["k" /* SHOW_CONTACT_US */]:return Object.assign({},state,{show_contact:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["e" /* SET_CARD_PAYMENT */]:return Object.assign({},state,{card:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["j" /* SET_X3_PAYMENT */]:return Object.assign({},state,{x3:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["i" /* SET_PAYPAL_PAYMENT */]:return Object.assign({},state,{paypal:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["g" /* SET_DIRECT_PAYMENT */]:return Object.assign({},state,{direct:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["f" /* SET_CREAT_ASSIST */]:return Object.assign({},state,{is_crea_assist_sub:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["l" /* SHOW_LOGIN_MODAL */]:return Object.assign({},state,{show_login_modal:action.val});case __WEBPACK_IMPORTED_MODULE_0__actions_account_settings__["m" /* SHOW_SINGUP_MODAL */]:return Object.assign({},state,{show_singup_modal:action.val});default:return state;}return state;}

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = viewsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_views__ = __webpack_require__(1019);
/*
* Project: LegalPlace assistant
* File: src/redux/reducers/views.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/function viewsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_views__["a" /* PREVIEW_INDEX */]){var updatedState=state;var indexes=Object.keys(action.val);indexes.forEach(function(idx){updatedState[idx]=action.val[idx];});return updatedState;}return state;}

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PREVIEW_INDEX; });
/* unused harmony export setPreviewIndex */
/*
* Project: LegalPlace assistant
* File: src/redux/actions/views.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var PREVIEW_INDEX='PREVIEW_INDEX_';function setPreviewIndex(val){return{type:PREVIEW_INDEX,val:val};}

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = appStateReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic_history__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_hardcoded_checkout__ = __webpack_require__(63);
/*
* Project: LegalPlace assistant
* File: src/redux/reducers/app_state.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/function appStateReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_1__actions_app_state__["e" /* LP_STATE_WIZARD */];var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_1__actions_app_state__["f" /* SET_STATE */]){// Check the change type, and then do something for it, (pass params if it's possible.)
if(state===__WEBPACK_IMPORTED_MODULE_1__actions_app_state__["e" /* LP_STATE_WIZARD */]){document.body.id='page-wizard';if(action.state===__WEBPACK_IMPORTED_MODULE_1__actions_app_state__["a" /* LP_STATE_CHECKOUT */]){// mail section
if(__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().account_settings.mail.length>0&&__WEBPACK_IMPORTED_MODULE_0_validator__["isEmail"](__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().account_settings.mail)){return __WEBPACK_IMPORTED_MODULE_1__actions_app_state__["b" /* LP_STATE_PAYMENT */];}}}var historyMutex=__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].mutex.checkMutex('history');switch(action.state){case __WEBPACK_IMPORTED_MODULE_1__actions_app_state__["a" /* LP_STATE_CHECKOUT */]:if(__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().document_state.state==='continue'){if(historyMutex)Object(__WEBPACK_IMPORTED_MODULE_3__logic_history__["a" /* default */])('normal',true,__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().contract.currentSection,__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().document_state.unique);else __WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].mutex.setMutex('history',true);// v(historyMutex)
}else if(historyMutex)Object(__WEBPACK_IMPORTED_MODULE_3__logic_history__["a" /* default */])('normal',false,__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().contract.currentSection+1,'');else __WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].mutex.setMutex('history',true);if(__WEBPACK_IMPORTED_MODULE_5__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].contractMetaId)>-1){document.body.id='ce_v3';}else{document.body.id='page-wizard';}break;case __WEBPACK_IMPORTED_MODULE_1__actions_app_state__["b" /* LP_STATE_PAYMENT */]:// window.history.pushState({state: store.getState()}, "Paiement", "/paiement");
if(__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().document_state.state==='continue'&&__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().contract.comeFrom!=='creer'){if(historyMutex){if(!action.ignoreHistory){Object(__WEBPACK_IMPORTED_MODULE_3__logic_history__["a" /* default */])('payment',true,0,__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().document_state.unique);}}else{__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].mutex.setMutex('history',true);}}else if(historyMutex){if(!action.ignoreHistory){Object(__WEBPACK_IMPORTED_MODULE_3__logic_history__["a" /* default */])('payment',false,0,__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* store */].getState().document_state.unique);}}else{__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].mutex.setMutex('history',true);}if(__WEBPACK_IMPORTED_MODULE_5__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].contractMetaId)>-1){document.body.id='ce_v3';}else{document.body.id='page-checkout';}break;case __WEBPACK_IMPORTED_MODULE_1__actions_app_state__["e" /* LP_STATE_WIZARD */]:{document.body.id='page-wizard';break;}default:case __WEBPACK_IMPORTED_MODULE_1__actions_app_state__["c" /* LP_STATE_PRE_WIZARD */]:break;}return action.state;}return state;}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toInt;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toInt(str, radix) {
  (0, _assertString2.default)(str);
  return parseInt(str, radix || 10);
}
module.exports = exports['default'];

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toBoolean;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toBoolean(str, strict) {
  (0, _assertString2.default)(str);
  if (strict) {
    return str === '1' || str === 'true';
  }
  return str !== '0' && str !== 'false' && str !== '';
}
module.exports = exports['default'];

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = equals;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function equals(str, comparison) {
  (0, _assertString2.default)(str);
  return str === comparison;
}
module.exports = exports['default'];

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contains;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _toString = __webpack_require__(264);

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function contains(str, elem) {
  (0, _assertString2.default)(str);
  return str.indexOf((0, _toString2.default)(elem)) >= 0;
}
module.exports = exports['default'];

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matches;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matches(str, pattern, modifiers) {
  (0, _assertString2.default)(str);
  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
    pattern = new RegExp(pattern, modifiers);
  }
  return pattern.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(114);

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__(438);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__(265);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _isFQDN = __webpack_require__(265);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

var _isIP = __webpack_require__(439);

var _isIP2 = _interopRequireDefault(_isIP);

var _merge = __webpack_require__(114);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};

var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];
    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }
  return false;
}

function isURL(url, options) {
  (0, _assertString2.default)(url);
  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }
  if (url.indexOf('mailto:') === 0) {
    return false;
  }
  options = (0, _merge2.default)(options, default_url_options);
  var protocol = void 0,
      auth = void 0,
      host = void 0,
      hostname = void 0,
      port = void 0,
      port_str = void 0,
      split = void 0,
      ipv6 = void 0;

  split = url.split('#');
  url = split.shift();

  split = url.split('?');
  url = split.shift();

  split = url.split('://');
  if (split.length > 1) {
    protocol = split.shift();
    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
    split[0] = url.substr(2);
  }
  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');
  if (split.length > 1) {
    auth = split.shift();
    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }
  hostname = split.join('@');

  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);
  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();
    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);
    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }
  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMACAddress;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;

function isMACAddress(str) {
  (0, _assertString2.default)(str);
  return macAddress.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBoolean;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBoolean(str) {
  (0, _assertString2.default)(str);
  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
}
module.exports = exports['default'];

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAlpha;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _alpha = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlpha(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';

  (0, _assertString2.default)(str);
  if (locale in _alpha.alpha) {
    return _alpha.alpha[locale].test(str);
  }
  throw new Error('Invalid locale \'' + locale + '\'');
}
module.exports = exports['default'];

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAlphanumeric;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _alpha = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlphanumeric(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';

  (0, _assertString2.default)(str);
  if (locale in _alpha.alphanumeric) {
    return _alpha.alphanumeric[locale].test(str);
  }
  throw new Error('Invalid locale \'' + locale + '\'');
}
module.exports = exports['default'];

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumeric;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numeric = /^[-+]?[0-9]+$/;

function isNumeric(str) {
  (0, _assertString2.default)(str);
  return numeric.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPort;

var _isInt = __webpack_require__(440);

var _isInt2 = _interopRequireDefault(_isInt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPort(str) {
  return (0, _isInt2.default)(str, { min: 0, max: 65535 });
}
module.exports = exports['default'];

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLowercase;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isLowercase(str) {
  (0, _assertString2.default)(str);
  return str === str.toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUppercase;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUppercase(str) {
  (0, _assertString2.default)(str);
  return str === str.toUpperCase();
}
module.exports = exports['default'];

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAscii;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */

function isAscii(str) {
  (0, _assertString2.default)(str);
  return ascii.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isVariableWidth;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _isFullWidth = __webpack_require__(441);

var _isHalfWidth = __webpack_require__(442);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isVariableWidth(str) {
  (0, _assertString2.default)(str);
  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMultibyte;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */

function isMultibyte(str) {
  (0, _assertString2.default)(str);
  return multibyte.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSurrogatePair;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;

function isSurrogatePair(str) {
  (0, _assertString2.default)(str);
  return surrogatePair.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFloat;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _alpha = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFloat(str, options) {
  (0, _assertString2.default)(str);
  options = options || {};
  var float = new RegExp('^(?:[-+])?(?:[0-9]+)?(?:\\' + (options.locale ? _alpha.decimal[options.locale] : '.') + '[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$');
  if (str === '' || str === '.' || str === '-' || str === '+') {
    return false;
  }
  return float.test(str) && (!options.hasOwnProperty('min') || str >= options.min) && (!options.hasOwnProperty('max') || str <= options.max) && (!options.hasOwnProperty('lt') || str < options.lt) && (!options.hasOwnProperty('gt') || str > options.gt);
}
module.exports = exports['default'];

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDecimal;

var _merge = __webpack_require__(114);

var _merge2 = _interopRequireDefault(_merge);

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _alpha = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function decimalRegExp(options) {
  var regExp = new RegExp('^[-+]?([0-9]+)?(\\' + _alpha.decimal[options.locale] + '[0-9]{' + options.decimal_digits + '})' + (options.force_decimal ? '' : '?') + '$');
  return regExp;
}

var default_decimal_options = {
  force_decimal: false,
  decimal_digits: '1,',
  locale: 'en-US'
};

var blacklist = ['', '-', '+'];

function isDecimal(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_decimal_options);
  if (options.locale in _alpha.decimal) {
    return !blacklist.includes(str.replace(/ /g, '')) && decimalRegExp(options).test(str);
  }
  throw new Error('Invalid locale \'' + options.locale + '\'');
}
module.exports = exports['default'];

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDivisibleBy;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _toFloat = __webpack_require__(437);

var _toFloat2 = _interopRequireDefault(_toFloat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDivisibleBy(str, num) {
  (0, _assertString2.default)(str);
  return (0, _toFloat2.default)(str) % parseInt(num, 10) === 0;
}
module.exports = exports['default'];

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHexColor;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;

function isHexColor(str) {
  (0, _assertString2.default)(str);
  return hexcolor.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISRC;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;

function isISRC(str) {
  (0, _assertString2.default)(str);
  return isrc.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMD5;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md5 = /^[a-f0-9]{32}$/;

function isMD5(str) {
  (0, _assertString2.default)(str);
  return md5.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHash;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lengths = {
  md5: 32,
  md4: 32,
  sha1: 40,
  sha256: 64,
  sha384: 96,
  sha512: 128,
  ripemd128: 32,
  ripemd160: 40,
  tiger128: 32,
  tiger160: 40,
  tiger192: 48,
  crc32: 8,
  crc32b: 8
};

function isHash(str, algorithm) {
  (0, _assertString2.default)(str);
  var hash = new RegExp('^[a-f0-9]{' + lengths[algorithm] + '}$');
  return hash.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isJSON;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isJSON(str) {
  (0, _assertString2.default)(str);
  try {
    var obj = JSON.parse(str);
    return !!obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  } catch (e) {/* ignore */}
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmpty;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEmpty(str) {
  (0, _assertString2.default)(str);
  return str.length === 0;
}
module.exports = exports['default'];

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isLength;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  var len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUUID;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuid = {
  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};

function isUUID(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

  (0, _assertString2.default)(str);
  var pattern = uuid[version];
  return pattern && pattern.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMongoId;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _isHexadecimal = __webpack_require__(443);

var _isHexadecimal2 = _interopRequireDefault(_isHexadecimal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMongoId(str) {
  (0, _assertString2.default)(str);
  return (0, _isHexadecimal2.default)(str) && str.length === 24;
}
module.exports = exports['default'];

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAfter;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _toDate = __webpack_require__(263);

var _toDate2 = _interopRequireDefault(_toDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAfter(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());

  (0, _assertString2.default)(str);
  var comparison = (0, _toDate2.default)(date);
  var original = (0, _toDate2.default)(str);
  return !!(original && comparison && original > comparison);
}
module.exports = exports['default'];

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBefore;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _toDate = __webpack_require__(263);

var _toDate2 = _interopRequireDefault(_toDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBefore(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());

  (0, _assertString2.default)(str);
  var comparison = (0, _toDate2.default)(date);
  var original = (0, _toDate2.default)(str);
  return !!(original && comparison && original < comparison);
}
module.exports = exports['default'];

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isIn;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _toString = __webpack_require__(264);

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isIn(str, options) {
  (0, _assertString2.default)(str);
  var i = void 0;
  if (Object.prototype.toString.call(options) === '[object Array]') {
    var array = [];
    for (i in options) {
      if ({}.hasOwnProperty.call(options, i)) {
        array[i] = (0, _toString2.default)(options[i]);
      }
    }
    return array.indexOf(str) >= 0;
  } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    return options.hasOwnProperty(str);
  } else if (options && typeof options.indexOf === 'function') {
    return options.indexOf(str) >= 0;
  }
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString2.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');
  if (!creditCard.test(sanitized)) {
    return false;
  }
  var sum = 0;
  var digit = void 0;
  var tmpNum = void 0;
  var shouldDouble = void 0;
  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);
    if (shouldDouble) {
      tmpNum *= 2;
      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }
    shouldDouble = !shouldDouble;
  }
  return !!(sum % 10 === 0 ? sanitized : false);
}
module.exports = exports['default'];

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISIN;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;

function isISIN(str) {
  (0, _assertString2.default)(str);
  if (!isin.test(str)) {
    return false;
  }

  var checksumStr = str.replace(/[A-Z]/g, function (character) {
    return parseInt(character, 36);
  });

  var sum = 0;
  var digit = void 0;
  var tmpNum = void 0;
  var shouldDouble = true;
  for (var i = checksumStr.length - 2; i >= 0; i--) {
    digit = checksumStr.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);
    if (shouldDouble) {
      tmpNum *= 2;
      if (tmpNum >= 10) {
        sum += tmpNum + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }
    shouldDouble = !shouldDouble;
  }

  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
}
module.exports = exports['default'];

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISBN;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
var isbn13Maybe = /^(?:[0-9]{13})$/;
var factor = [1, 3];

function isISBN(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  (0, _assertString2.default)(str);
  version = String(version);
  if (!version) {
    return isISBN(str, 10) || isISBN(str, 13);
  }
  var sanitized = str.replace(/[\s-]+/g, '');
  var checksum = 0;
  var i = void 0;
  if (version === '10') {
    if (!isbn10Maybe.test(sanitized)) {
      return false;
    }
    for (i = 0; i < 9; i++) {
      checksum += (i + 1) * sanitized.charAt(i);
    }
    if (sanitized.charAt(9) === 'X') {
      checksum += 10 * 10;
    } else {
      checksum += 10 * sanitized.charAt(9);
    }
    if (checksum % 11 === 0) {
      return !!sanitized;
    }
  } else if (version === '13') {
    if (!isbn13Maybe.test(sanitized)) {
      return false;
    }
    for (i = 0; i < 12; i++) {
      checksum += factor[i % 2] * sanitized.charAt(i);
    }
    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
      return !!sanitized;
    }
  }
  return false;
}
module.exports = exports['default'];

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISSN;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var issn = '^\\d{4}-?\\d{3}[\\dX]$';

function isISSN(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  (0, _assertString2.default)(str);
  var testIssn = issn;
  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
  if (!testIssn.test(str)) {
    return false;
  }
  var issnDigits = str.replace('-', '');
  var position = 8;
  var checksum = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = issnDigits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var digit = _step.value;

      var digitValue = digit.toUpperCase() === 'X' ? 10 : +digit;
      checksum += digitValue * position;
      --position;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return checksum % 11 === 0;
}
module.exports = exports['default'];

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMobilePhone;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var phones = {
  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-EG': /^((\+?20)|0)?1[012]\d{8}$/,
  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
  'el-GR': /^(\+?30|0)?(69\d{8})$/,
  'en-AU': /^(\+?61|0)4\d{8}$/,
  'en-GB': /^(\+?44|0)7\d{9}$/,
  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
  'en-KE': /^(\+?254|0)?[7]\d{8}$/,
  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
  'en-SG': /^(\+65)?[89]\d{7}$/,
  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
  'en-ZA': /^(\+?27|0)\d{9}$/,
  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}/,
  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
  'id-ID': /^(\+?62|0[1-9])[\s|\d]+$/,
  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'ja-JP': /^(\+?81|0)[789]0[ \-]?[1-9]\d{2}[ \-]?\d{5}$/,
  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  'lt-LT': /^(\+370|8)\d{8}$/,
  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'nb-NO': /^(\+?47)?[49]\d{7}$/,
  'nl-BE': /^(\+?32|0)4?\d{8}$/,
  'nn-NO': /^(\+?47)?[49]\d{7}$/,
  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  'th-TH': /^(\+66|66|0)\d{9}$/,
  'tr-TR': /^(\+?90|0)?5\d{9}$/,
  'uk-UA': /^(\+?38|8)?0\d{9}$/,
  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
  'zh-CN': /^(\+?0?86\-?)?1[3456789]\d{9}$/,
  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
};
/* eslint-enable max-len */

// aliases
phones['en-CA'] = phones['en-US'];
phones['fr-BE'] = phones['nl-BE'];
phones['zh-HK'] = phones['en-HK'];

function isMobilePhone(str, locale, options) {
  (0, _assertString2.default)(str);
  if (options && options.strictMode && !str.startsWith('+')) {
    return false;
  }
  if (locale in phones) {
    return phones[locale].test(str);
  } else if (locale === 'any') {
    for (var key in phones) {
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];
        if (phone.test(str)) {
          return true;
        }
      }
    }
    return false;
  }
  throw new Error('Invalid locale \'' + locale + '\'');
}
module.exports = exports['default'];

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCurrency;

var _merge = __webpack_require__(114);

var _merge2 = _interopRequireDefault(_merge);

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function currencyRegex(options) {
  var decimal_digits = '\\d{' + options.digits_after_decimal[0] + '}';
  options.digits_after_decimal.forEach(function (digit, index) {
    if (index !== 0) decimal_digits = decimal_digits + '|\\d{' + digit + '}';
  });
  var symbol = '(\\' + options.symbol.replace(/\./g, '\\.') + ')' + (options.require_symbol ? '' : '?'),
      negative = '-?',
      whole_dollar_amount_without_sep = '[1-9]\\d*',
      whole_dollar_amount_with_sep = '[1-9]\\d{0,2}(\\' + options.thousands_separator + '\\d{3})*',
      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
      whole_dollar_amount = '(' + valid_whole_dollar_amounts.join('|') + ')?',
      decimal_amount = '(\\' + options.decimal_separator + '(' + decimal_digits + '))' + (options.require_decimal ? '' : '?');
  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : '');

  // default is negative sign before symbol, but there are two other options (besides parens)
  if (options.allow_negatives && !options.parens_for_negatives) {
    if (options.negative_sign_after_digits) {
      pattern += negative;
    } else if (options.negative_sign_before_digits) {
      pattern = negative + pattern;
    }
  }

  // South African Rand, for example, uses R 123 (space) and R-123 (no space)
  if (options.allow_negative_sign_placeholder) {
    pattern = '( (?!\\-))?' + pattern;
  } else if (options.allow_space_after_symbol) {
    pattern = ' ?' + pattern;
  } else if (options.allow_space_after_digits) {
    pattern += '( (?!$))?';
  }

  if (options.symbol_after_digits) {
    pattern += symbol;
  } else {
    pattern = symbol + pattern;
  }

  if (options.allow_negatives) {
    if (options.parens_for_negatives) {
      pattern = '(\\(' + pattern + '\\)|' + pattern + ')';
    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
      pattern = negative + pattern;
    }
  }

  // ensure there's a dollar and/or decimal amount, and that
  // it doesn't start with a space or a negative sign followed by a space
  return new RegExp('^(?!-? )(?=.*\\d)' + pattern + '$');
}

var default_currency_options = {
  symbol: '$',
  require_symbol: false,
  allow_space_after_symbol: false,
  symbol_after_digits: false,
  allow_negatives: true,
  parens_for_negatives: false,
  negative_sign_before_digits: false,
  negative_sign_after_digits: false,
  allow_negative_sign_placeholder: false,
  thousands_separator: ',',
  decimal_separator: '.',
  allow_decimal: true,
  require_decimal: false,
  digits_after_decimal: [2],
  allow_space_after_digits: false
};

function isCurrency(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_currency_options);
  return currencyRegex(options).test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISO8601;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
// from http://goo.gl/0ejHHW
var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */

function isISO8601(str) {
  (0, _assertString2.default)(str);
  return iso8601.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISO31661Alpha2;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
var validISO31661Alpha2CountriesCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];

function isISO31661Alpha2(str) {
  (0, _assertString2.default)(str);
  return validISO31661Alpha2CountriesCodes.includes(str.toUpperCase());
}
module.exports = exports['default'];

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBase64;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notBase64 = /[^A-Z0-9+\/=]/i;

function isBase64(str) {
  (0, _assertString2.default)(str);
  var len = str.length;
  if (!len || len % 4 !== 0 || notBase64.test(str)) {
    return false;
  }
  var firstPaddingChar = str.indexOf('=');
  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
}
module.exports = exports['default'];

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDataURI;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;

var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;

var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;

function isDataURI(str) {
  (0, _assertString2.default)(str);
  var data = str.split(',');
  if (data.length < 2) {
    return false;
  }
  var attributes = data.shift().trim().split(';');
  var schemeAndMediaType = attributes.shift();
  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
    return false;
  }
  var mediaType = schemeAndMediaType.substr(5);
  if (mediaType !== '' && !validMediaType.test(mediaType)) {
    return false;
  }
  for (var i = 0; i < attributes.length; i++) {
    if (i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') {
      // ok
    } else if (!validAttribute.test(attributes[i])) {
      return false;
    }
  }
  for (var _i = 0; _i < data.length; _i++) {
    if (!validData.test(data[_i])) {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMimeType;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Checks if the provided string matches to a correct Media type format (MIME type)

  This function only checks is the string format follows the
  etablished rules by the according RFC specifications.
  This function supports 'charset' in textual media types
  (https://tools.ietf.org/html/rfc6657).

  This function does not check against all the media types listed
  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
  because of lightness purposes : it would require to include
  all these MIME types in this librairy, which would weigh it
  significantly. This kind of effort maybe is not worth for the use that
  this function has in this entire librairy.

  More informations in the RFC specifications :
  - https://tools.ietf.org/html/rfc2045
  - https://tools.ietf.org/html/rfc2046
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
*/

// Match simple MIME types
// NB :
//   Subtype length must not exceed 100 characters.
//   This rule does not comply to the RFC specs (what is the max length ?).
var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len

// Handle "charset" in "text/*"
var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len

// Handle "boundary" in "multipart/*"
var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len

function isMimeType(str) {
  (0, _assertString2.default)(str);
  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
}
module.exports = exports['default'];

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (str) {
  (0, _assertString2.default)(str);
  if (!str.includes(',')) return false;
  var pair = str.split(',');
  return lat.test(pair[0]) && long.test(pair[1]);
};

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;

module.exports = exports['default'];

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locales = undefined;

exports.default = function (str, locale) {
  (0, _assertString2.default)(str);
  if (locale in patterns) {
    return patterns[locale].test(str);
  } else if (locale === 'any') {
    for (var key in patterns) {
      if (patterns.hasOwnProperty(key)) {
        var pattern = patterns[key];
        if (pattern.test(str)) {
          return true;
        }
      }
    }
    return false;
  }
  throw new Error('Invalid locale \'' + locale + '\'');
};

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// common patterns
var threeDigit = /^\d{3}$/;
var fourDigit = /^\d{4}$/;
var fiveDigit = /^\d{5}$/;
var sixDigit = /^\d{6}$/;

var patterns = {
  AT: fourDigit,
  AU: fourDigit,
  BE: fourDigit,
  BG: fourDigit,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: fourDigit,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: fiveDigit,
  DK: fourDigit,
  DZ: fiveDigit,
  ES: fiveDigit,
  FI: fiveDigit,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  IL: fiveDigit,
  IN: sixDigit,
  IS: threeDigit,
  IT: fiveDigit,
  JP: /^\d{3}\-\d{4}$/,
  KE: fiveDigit,
  LI: /^(948[5-9]|949[0-7])$/,
  MX: fiveDigit,
  NL: /^\d{4}\s?[a-z]{2}$/i,
  NO: fourDigit,
  PL: /^\d{2}\-\d{3}$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: sixDigit,
  RU: sixDigit,
  SA: fiveDigit,
  SE: /^\d{3}\s?\d{2}$/,
  TW: /^\d{3}(\d{2})?$/,
  US: /^\d{5}(-\d{4})?$/,
  ZA: fourDigit,
  ZM: fiveDigit
};

var locales = exports.locales = Object.keys(patterns);

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;

var _rtrim = __webpack_require__(445);

var _rtrim2 = _interopRequireDefault(_rtrim);

var _ltrim = __webpack_require__(444);

var _ltrim2 = _interopRequireDefault(_ltrim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trim(str, chars) {
  return (0, _rtrim2.default)((0, _ltrim2.default)(str, chars), chars);
}
module.exports = exports['default'];

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = escape;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escape(str) {
  (0, _assertString2.default)(str);
  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
}
module.exports = exports['default'];

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unescape;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unescape(str) {
  (0, _assertString2.default)(str);
  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
}
module.exports = exports['default'];

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripLow;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

var _blacklist = __webpack_require__(446);

var _blacklist2 = _interopRequireDefault(_blacklist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stripLow(str, keep_new_lines) {
  (0, _assertString2.default)(str);
  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
  return (0, _blacklist2.default)(str, chars);
}
module.exports = exports['default'];

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = whitelist;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function whitelist(str, chars) {
  (0, _assertString2.default)(str);
  return str.replace(new RegExp('[^' + chars + ']+', 'g'), '');
}
module.exports = exports['default'];

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isWhitelisted;

var _assertString = __webpack_require__(4);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isWhitelisted(str, chars) {
  (0, _assertString2.default)(str);
  for (var i = str.length - 1; i >= 0; i--) {
    if (chars.indexOf(str[i]) === -1) {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeEmail;

var _merge = __webpack_require__(114);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_normalize_email_options = {
  // The following options apply to all email addresses
  // Lowercases the local part of the email address.
  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
  // The domain is always lowercased, as per RFC 1035
  all_lowercase: true,

  // The following conversions are specific to GMail
  // Lowercases the local part of the GMail address (known to be case-insensitive)
  gmail_lowercase: true,
  // Removes dots from the local part of the email address, as that's ignored by GMail
  gmail_remove_dots: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  gmail_remove_subaddress: true,
  // Conversts the googlemail.com domain to gmail.com
  gmail_convert_googlemaildotcom: true,

  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
  outlookdotcom_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  outlookdotcom_remove_subaddress: true,

  // The following conversions are specific to Yahoo
  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
  yahoo_lowercase: true,
  // Removes the subaddress (e.g. "-foo") from the email address
  yahoo_remove_subaddress: true,

  // The following conversions are specific to iCloud
  // Lowercases the local part of the iCloud address (known to be case-insensitive)
  icloud_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  icloud_remove_subaddress: true
};

// List of domains used by iCloud
var icloud_domains = ['icloud.com', 'me.com'];

// List of domains used by Outlook.com and its predecessors
// This list is likely incomplete.
// Partial reference:
// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com'];

// List of domains used by Yahoo Mail
// This list is likely incomplete
var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com'];

function normalizeEmail(email, options) {
  options = (0, _merge2.default)(options, default_normalize_email_options);

  var raw_parts = email.split('@');
  var domain = raw_parts.pop();
  var user = raw_parts.join('@');
  var parts = [user, domain];

  // The domain is always lowercased, as it's case-insensitive per RFC 1035
  parts[1] = parts[1].toLowerCase();

  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
    // Address is GMail
    if (options.gmail_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }
    if (options.gmail_remove_dots) {
      parts[0] = parts[0].replace(/\./g, '');
    }
    if (!parts[0].length) {
      return false;
    }
    if (options.all_lowercase || options.gmail_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
  } else if (~icloud_domains.indexOf(parts[1])) {
    // Address is iCloud
    if (options.icloud_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }
    if (!parts[0].length) {
      return false;
    }
    if (options.all_lowercase || options.icloud_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (~outlookdotcom_domains.indexOf(parts[1])) {
    // Address is Outlook.com
    if (options.outlookdotcom_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }
    if (!parts[0].length) {
      return false;
    }
    if (options.all_lowercase || options.outlookdotcom_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (~yahoo_domains.indexOf(parts[1])) {
    // Address is Yahoo
    if (options.yahoo_remove_subaddress) {
      var components = parts[0].split('-');
      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
    }
    if (!parts[0].length) {
      return false;
    }
    if (options.all_lowercase || options.yahoo_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (options.all_lowercase) {
    // Any other address
    parts[0] = parts[0].toLowerCase();
  }
  return parts.join('@');
}
module.exports = exports['default'];

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inputContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_input_context__ = __webpack_require__(72);
/*
* Project: LegalPlace assistant
* File: src/redux/reducers/input_context.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/function inputContext(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{variable:'',option:''};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_input_context__["a" /* IC_SET_OPTION */]:return Object.assign({},state,{option:action.optionid});case __WEBPACK_IMPORTED_MODULE_0__actions_input_context__["b" /* IC_SET_VARIABLE */]:return Object.assign({},state,{variable:action.varid});default:return state;}return state;}

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = togglePreviewReducer;
/* harmony export (immutable) */ __webpack_exports__["a"] = popoverReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_toggle_preview__ = __webpack_require__(115);
/*
* Project: LegalPlace assistant
* File: src/redux/reducers/toggle_preview.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/function togglePreviewReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_toggle_preview__["c" /* TOGGLE_PREVIEW */])return!state;return state;}function popoverReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_toggle_preview__["b" /* SHOW_POPOVER */])return true;if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_toggle_preview__["a" /* HIDE_POPOVER */])return false;return state;}

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkoutReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__ = __webpack_require__(22);
/*
* Project: LegalPlace assistant
* File: src/redux/reducers/checkout_operations.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// definition of some consts
function checkoutReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{user_id:'',contract_id:'',prices:{},admin_fees:{},pricing_type:'',dis_link:'',ml_link:'',csrf_key:'',csrf_value:'',c_codes:{},has_call:false,has_letter:false,promo_code:'',promo_percentage:0,promo_loading:false,letter:{number:1,name:'',address:'',city:'',zip:''},pack:1,payment_method:0,credit_card:{expiration:"",number:"",ccv:""},direct_name:"",direct_iban:"",confirm:false,show_payment_modal:false,togglepack:undefined,toggle_invoice:false,invoice:{organization:'',address:'',city:'',zip_code:'',nb_tva:''},packEntrepreneur:{backHeaderBtn:false,choosePack:undefined,upsellArray:[]}};var action=arguments[1];var result=Object.assign({},state);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["a" /* BUILD_CHECKOUT */]:result=Object.assign(result,{user_id:action.user_id,contract_id:action.contract_id,contract_meta_id:action.contract_meta_id,prices:action.prices,admin_fees:action.admin_fees,pricing_type:action.pricing_type,detailsCheckout:action.detailsCheckout,dis_link:action.desabonnement,ml_link:action.ml_link,c_codes:action.c_codes});return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["D" /* UPDATE_CSRF */]:result.csrf_key=action.csrf.tokenKey;result.csrf_value=action.csrf.token;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["r" /* CK_UPDATE_PROMOTION */]:result.promo_code=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["e" /* CK_SET_PACK */]:result.pack=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["f" /* CK_TOGGLE_CALL */]:result.has_call=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["g" /* CK_TOGGLE_LETTER */]:result.has_letter=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["o" /* CK_UPDATE_LETTER_NUMBER */]:result.letter.number=action.incr;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["p" /* CK_UPDATE_NAME */]:result.letter.name=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["i" /* CK_UPDATE_CITY */]:result.letter.city=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["h" /* CK_UPDATE_ADDRESS */]:result.letter.address=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["t" /* CK_UPDATE_ZIP */]:result.letter.zip=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["q" /* CK_UPDATE_PAYMENT_METHOD */]:result.payment_method=action.method;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["l" /* CK_UPDATE_C_NUMBER */]:result.credit_card.number=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["k" /* CK_UPDATE_C_EXPIRATION */]:result.credit_card.expiration=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["j" /* CK_UPDATE_C_CCV */]:result.credit_card.ccv=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["m" /* CK_UPDATE_DIRECT_NAME */]:result.direct_name=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["n" /* CK_UPDATE_IBAN */]:result.direct_iban=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["c" /* CK_CHECK */]:result.confirm=action.val;return result;case'UPDATE_C_CODES':result.c_codes=action.c_codes;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["s" /* CK_UPDATE_REDUCTION */]:result.promo_percentage=action.reduction;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["d" /* CK_LOADING_REDUCTION */]:result.promo_loading=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["b" /* CE_TOGGLE_PACK */]:result.togglepack=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["C" /* PACK_ENTREPRENEUR_HEADER_BTN */]:result.packEntrepreneur.backHeaderBtn=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["B" /* PACK_ENTREPRENEUR_CHOOSE_PACK */]:result.packEntrepreneur.choosePack=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["A" /* PACK_ENTREPRENEUR_ADD_UPSELL */]:result.packEntrepreneur.upsellArray=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["w" /* IU_NAME */]:result.invoice.organization=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["u" /* IU_ADDRESS */]:result.invoice.address=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["v" /* IU_CITY */]:result.invoice.city=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["z" /* IU_ZIP */]:result.invoice.zip_code=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["x" /* IU_TVA */]:result.invoice.nb_tva=action.val;return result;case __WEBPACK_IMPORTED_MODULE_0__actions_checkout_operations__["y" /* IU_VIS */]:result.toggle_invoice=!result.toggle_invoice;return result;default:return state;}}

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadingDetails;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_loading__ = __webpack_require__(79);
/*
* Project: LegalPlace assistant
* File: src/redux/reducers/loading.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/function loadingDetails(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{wizard:false,pricing:false,checking:false,checking_payment:false};var action=arguments[1];var result=Object.assign({},state);switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_loading__["g" /* WIZARD_LOAD */]:result.wizard=true;break;case __WEBPACK_IMPORTED_MODULE_0__actions_loading__["h" /* WIZARD_UNLOAD */]:result.wizard=false;break;case __WEBPACK_IMPORTED_MODULE_0__actions_loading__["e" /* PRICE_LOAD */]:result.pricing=true;break;case __WEBPACK_IMPORTED_MODULE_0__actions_loading__["f" /* PRICE_UNLOAD */]:result.pricing=false;break;case __WEBPACK_IMPORTED_MODULE_0__actions_loading__["a" /* IS_CHECKING */]:result.checking=action.is_checking;break;case __WEBPACK_IMPORTED_MODULE_0__actions_loading__["b" /* IS_CHECKING_PAYMENT */]:result.checking_payment=action.is_checking;break;default:break;}return result;}

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = documentStateReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_document_state__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_history__ = __webpack_require__(80);
/*
* Project: LegalPlace assistant
* File: src/redux/reducers/document_state.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// import { Map } from 'immutable';
function documentStateReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{state:'new',doc_name:'',unique:'',user_id:''};var action=arguments[1];var result=state;// cloning
switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_document_state__["b" /* NEW_DOCUMENT */]:result.state='new';break;case __WEBPACK_IMPORTED_MODULE_0__actions_document_state__["a" /* CONTINUE_DOCUMENT */]:result.state='continue';result.unique=action.id;// writeHistory(false, true, 0, action.id);
break;case __WEBPACK_IMPORTED_MODULE_0__actions_document_state__["c" /* SET_CONTRACT_NAME */]:result.doc_name=action.name;break;case __WEBPACK_IMPORTED_MODULE_0__actions_document_state__["e" /* SET_USER_ID */]:result.user_id=action.id;break;case __WEBPACK_IMPORTED_MODULE_0__actions_document_state__["d" /* SET_DOCUMENT_ID */]:result.state='continue';result.unique=action.doc;result.doc_name=__WEBPACK_IMPORTED_MODULE_1__app_lp_app__["a" /* default */].contractTitle;break;default:break;}return result;}

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lpErrorReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_lperrors__ = __webpack_require__(127);
/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\lperrors.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/function lpErrorReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{code:0,message:'',type:0,components:{}};var action=arguments[1];var result=state;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_lperrors__["a" /* LP_ERROR_SET */]:{var error=action.error;if(error.error_log_type===0){result.code=action.error.code;result.message=action.error.message;result.type=action.error.type;}else{result.components[error.component_type]={code:error.code,message:error.message,type:error.type};}break;}case __WEBPACK_IMPORTED_MODULE_0__actions_lperrors__["b" /* LP_ERROR_UNSET */]:if(action.component==='global'){result.code=0;result.message='';result.type=0;}else{result.components[action.component]=undefined;}break;default:return state;}return result;}

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/real_sections.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpRealSections=function(){function LpRealSections(){_classCallCheck(this,LpRealSections);this.sections={};this.output_sections={};}_createClass(LpRealSections,[{key:"updateRealSections",value:function updateRealSections(rC){this.sections=rC;}},{key:"updateOutputSections",value:function updateOutputSections(rC){this.output_sections=rC;}},{key:"getSection",value:function getSection(id){return this.sections[id];}},{key:"getOutputSection",value:function getOutputSection(id){return this.output_sections[id];}}]);return LpRealSections;}();/* harmony default export */ __webpack_exports__["a"] = (LpRealSections);

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/fatherhood.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpGrandpa=function(){function LpGrandpa(){_classCallCheck(this,LpGrandpa);}_createClass(LpGrandpa,[{key:"buildGrandpa",value:function buildGrandpa(tree){this.grandpa=tree;}},{key:"getFather",value:function getFather(id){return this.grandpa[id];}}]);return LpGrandpa;}();/* harmony default export */ __webpack_exports__["a"] = (LpGrandpa);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/fatherhood_variables.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpGrandpaVariables=function(){function LpGrandpaVariables(){_classCallCheck(this,LpGrandpaVariables);this.grandpa_vars={};}_createClass(LpGrandpaVariables,[{key:"buildGrandpaVariables",value:function buildGrandpaVariables(tree){this.grandpa_vars=tree;}},{key:"getVGrandpa",value:function getVGrandpa(id){return this.grandpa_vars[id];}}]);return LpGrandpaVariables;}();/* harmony default export */ __webpack_exports__["a"] = (LpGrandpaVariables);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logic_condition_evo__ = __webpack_require__(29);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/multiples.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpMultiples=function(){function LpMultiples(){_classCallCheck(this,LpMultiples);this.multiples={};}_createClass(LpMultiples,[{key:'addMultiple',value:function addMultiple(p,m){if((typeof m==='undefined'?'undefined':_typeof(m))==='object')__WEBPACK_IMPORTED_MODULE_0__logic_condition_evo__["a" /* default */].setupMultipleWatchers(m,p);__WEBPACK_IMPORTED_MODULE_0__logic_condition_evo__["a" /* default */].multipleChangeReduce(p,m);if(!m||m.length===0)delete this.multiples[p];else this.multiples[p]=m;}},{key:'exists',value:function exists(id){return!!this.multiples[id];}},{key:'getMultiple',value:function getMultiple(id){return this.multiples[id];}}]);return LpMultiples;}();/* harmony default export */ __webpack_exports__["a"] = (LpMultiples);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/views_by_variables.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpVarToView=function(){function LpVarToView(){_classCallCheck(this,LpVarToView);this.v_to_v={};}_createClass(LpVarToView,[{key:"buildVarToView",value:function buildVarToView(v2V){this.v_to_v=v2V;}},{key:"getViewByVar",value:function getViewByVar(id){return this.v_to_v[id];}}]);return LpVarToView;}();/* harmony default export */ __webpack_exports__["a"] = (LpVarToView);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/render.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpRenderContent=function(){function LpRenderContent(){_classCallCheck(this,LpRenderContent);this.content=[];this.length=0;}_createClass(LpRenderContent,[{key:"updateContent",value:function updateContent(cont){var len=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;this.content=cont;this.length=len;}},{key:"getContent",value:function getContent(){return this.content;}},{key:"getContentLength",value:function getContentLength(){return this.length;}}]);return LpRenderContent;}();/* harmony default export */ __webpack_exports__["a"] = (LpRenderContent);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/root_options.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpRootOptions=function(){function LpRootOptions(){_classCallCheck(this,LpRootOptions);this.roots={};}_createClass(LpRootOptions,[{key:"buildRootOptions",value:function buildRootOptions(){var _this=this;var sections=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];sections.forEach(function(idx){idx.options.forEach(function(jdx){_this.roots[jdx]=true;},_this);},this);}}]);return LpRootOptions;}();/* harmony default export */ __webpack_exports__["a"] = (LpRootOptions);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/by_section.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpBySectionIndex=function(){function LpBySectionIndex(){_classCallCheck(this,LpBySectionIndex);this.sections_options={};this.currentSection=0;}_createClass(LpBySectionIndex,[{key:'registerOption',value:function registerOption(opt){if(typeof this.sections_options[this.currentSection]==='undefined')this.sections_options[this.currentSection]={};this.sections_options[this.currentSection][opt]=true;}},{key:'loadSectionOptions',value:function loadSectionOptions(sec){this.currentSection=sec;if(this.sections_options[sec])return Object.keys(this.sections_options[sec]);return[];}}]);return LpBySectionIndex;}();/* harmony default export */ __webpack_exports__["a"] = (LpBySectionIndex);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/actions.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpActionsWindow=function(){function LpActionsWindow(){_classCallCheck(this,LpActionsWindow);this.last_action='NOTHING_BOX';this.la_arg1='';this.la_arg2='';}_createClass(LpActionsWindow,[{key:'trackAction',value:function trackAction(action){var arg1=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var arg2=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';this.last_action=action;this.la_arg1=arg1;this.la_arg2=arg2;}}]);return LpActionsWindow;}();/* harmony default export */ __webpack_exports__["a"] = (LpActionsWindow);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/mutex/mutex.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpMutex=function(){function LpMutex(){_classCallCheck(this,LpMutex);this.mutex={};}_createClass(LpMutex,[{key:"setMutex",value:function setMutex(mName,value){this.mutex[mName]=value;}},{key:"checkMutex",value:function checkMutex(mName){return this.mutex[mName];}}]);return LpMutex;}();/* harmony default export */ __webpack_exports__["a"] = (LpMutex);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__document__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ovc__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkout__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initialization__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__two_steps__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__slack_notifications__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mandatory__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__contacts__ = __webpack_require__(1101);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/ops.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpOperations=function LpOperations(){_classCallCheck(this,LpOperations);this.content=new __WEBPACK_IMPORTED_MODULE_0__output__["a" /* default */]();this.document=new __WEBPACK_IMPORTED_MODULE_1__document__["a" /* default */]();this.ovc=new __WEBPACK_IMPORTED_MODULE_2__ovc__["a" /* default */]();this.checkout=new __WEBPACK_IMPORTED_MODULE_3__checkout__["a" /* default */]();this.initialization=new __WEBPACK_IMPORTED_MODULE_4__initialization__["a" /* default */]();this.utils=new __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */]();this.two_steps=new __WEBPACK_IMPORTED_MODULE_6__two_steps__["a" /* default */]();this.slack=new __WEBPACK_IMPORTED_MODULE_7__slack_notifications__["a" /* default */]();this.mandatory=new __WEBPACK_IMPORTED_MODULE_8__mandatory__["a" /* default */]();this.contacts=new __WEBPACK_IMPORTED_MODULE_9__contacts__["a" /* default */]();};/* harmony default export */ __webpack_exports__["a"] = (LpOperations);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_load_contract__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic_utils_tree_operations__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_condition_evo__ = __webpack_require__(29);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/output.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpOpsOutput=function(){function LpOpsOutput(){_classCallCheck(this,LpOpsOutput);}_createClass(LpOpsOutput,[{key:'getOutput',value:function getOutput(){var optIds=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _this=this;var out=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var isInRepeated=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var store=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].store;optIds.map(function(idx){// if()
// test existance
// if(idx == 268)debugger;
var cId=idx;var mId=0;var amAMultiple=false;// check if the actual option is multiple
if(typeof idx==='string'){var _idx$split=idx.split('_');var _idx$split2=_slicedToArray(_idx$split,2);cId=_idx$split2[0];mId=_idx$split2[1];amAMultiple=true;}// check the conditions
if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.conditional&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.compiledConditions&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.compiledConditions.length>0){var idxCopy=false;if(amAMultiple){var _idx$split3=idx.split('_');var _idx$split4=_slicedToArray(_idx$split3,2);idxCopy=_idx$split4[1];}if(!__WEBPACK_IMPORTED_MODULE_5__logic_condition_evo__["a" /* default */].getCondition(idx))return;// if([262,266,278].includes(cId)) console.log(cId + ' : ' + cond.execute());
// Checking condition
}if(isInRepeated){// if(idx == 32)debugger;
// TODO: Test if there is something with children
// let v = lpApp.indexes.options.getOption(idx);
// if(v && v.value)
// console.log(idx, cId)
// if(lpIdGetPure(idx) == 266 || lpIdGetPure(idx) == 266)
// console.log([lpApp.references.getOption(lpIdGetPure(idx)).meta.outputRender, idx]);
// if(debug) console.log('>>>>> ' + idx)
out.push([__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).meta.outputRender,idx]);if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).children.length>0){var _lpApp$references$get=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId),children=_lpApp$references$get.children;if(amAMultiple)children=children.map(function(childrenIdx){return childrenIdx+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(childrenIdx);});_this.getOutput(children,out);}return;}// repeated case
// TODO: add the possibility that it is true (in all cases)
if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='repeated'){out.push([__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.outputRender,idx]);window.repeated=true;var repeatedChildren=LpOpsOutput.getChidlrenList(idx);// lpApp.references.getOption(lpIdGetPure(idx)).children;
// get the repeated one
var rAction=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.repeatOption;var rList=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.getMultiple(rAction):false;if(repeatedChildren.length>0){if(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)===574)_this.getOutput(repeatedChildren,out,true,true);else _this.getOutput(repeatedChildren,out,true);if(rList){rList.map(function(i){repeatedChildren=repeatedChildren.map(function(jdx){return Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(jdx)+'_'+i;});// recurse
if(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)===574)_this.getOutput(repeatedChildren,out,true,true);else _this.getOutput(repeatedChildren,out,true);// do the same
// console.log(repeatedChildren)
},_this);}}window.repeated=false;return;}var pa=Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_load_contract__["e" /* getMaa */])(idx);if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).meta.type==='radio'&&Object(__WEBPACK_IMPORTED_MODULE_3__logic_utils_tree_operations__["b" /* checkUnInitializedSiblings */])(idx)&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption&&pa&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(pa)&&idx===__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(pa).meta.default){out.push([__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).meta.outputRender,idx]);// Checking children
var referenceChildren=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).children;_this.getOutput(referenceChildren,out,false);return;}// if(idx == 30)debugger;
// the option is in the repeated case but it's a leaf
// if(isInRepeated){
//     // if(idx == 32)debugger;
//     out.push([lpApp.references.getOption(cId).meta.outputRender, idx]);
//     return
// }
// FIXME: initialization thing.
// test if it's nothing in the whole system.
// from here and till the end we just filter it
var opt=Object(__WEBPACK_IMPORTED_MODULE_4__logic_re_index__["g" /* lpGetOptionById */])(idx);// let opt = getOptionPass(idx)
// if(cId == 218)debugger;
if(typeof opt==='undefined'){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).meta.type==='radio'){// debugger;
// here we can do the initialization from the default
if(store.getState().loadedOvc&&store.getState().loadedOvc.oF){opt={value:store.getState().loadedOvc.oF[idx]};}else opt={value:false};}else if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).meta.type==='checkbox'){// debugger;
// if(cId == 41)debugger;
if(store.getState().loadedOvc&&store.getState().loadedOvc.cF){opt={value:store.getState().loadedOvc.cF[idx]};}else opt={value:false};}else{opt={value:true};}}console.assert(typeof opt!=='undefined','This '+idx+' is undefined');if(typeof opt==='number'||typeof opt==='boolean'){//
opt={value:opt};}// test conditions [am smart XD] // the leaf
// push it
// initialization options that are not (displayed) but it's the default shit
// number_of_all += 1;
// console.log(idx, "ssss")
if(opt.value||opt.value==='NONE'||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).meta.type==='hidden'||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).meta.type==='static'){// if(idx == 32)debugger;
// if
// console.log(idx, "lll")
out.push([__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId).meta.outputRender,idx]);// get children
var _lpApp$references$get2=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(cId),_children=_lpApp$references$get2.children;if(_children.length>0){if(amAMultiple){_children=_children.map(function(jdx){return jdx+'_'+mId;});}// recurse
// do the same
}_this.getOutput(_children,out,false);}// test multiplie
var multiples=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.getMultiple(idx):undefined;if(typeof multiples!=='undefined'){// build multiple options list
// debugger;
multiples=multiples.map(function(jdx){return idx+'_'+jdx;});_this.getOutput(multiples,out,false);}// recurse
});}},{key:'getOutputFroPreview',value:function getOutputFroPreview(varId){// extract the views,
var vDeps=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.var_to_view.getViewByVar(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(varId));var copyUnique=Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(varId);// Separate the thing
var viewsIdx=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.content.content.map(function(idx){return idx[0];});var optsIdx=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.content.content.map(function(idx){return idx[1];});var indexes=[];if(typeof vDeps==='undefined')return[];viewsIdx.map(function(idx,i){return vDeps.map(function(jdx){return jdx===idx?indexes.push(i):undefined;});});// do some search in of the copy
indexes=indexes.filter(function(idx){return Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(optsIdx[idx])===copyUnique;});var theIndex=indexes[0];var i1=theIndex-4<0?0:theIndex-4;var i2=theIndex+4>__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.content.content.length?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.content.content.length:theIndex+4;return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.content.content.slice(i1,i2);}}],[{key:'getChidlrenList',// get the children of an ID,
value:function getChidlrenList(id){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(id)).children;}}]);return LpOpsOutput;}();/* harmony default export */ __webpack_exports__["a"] = (LpOpsOutput);

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_condition_tree__ = __webpack_require__(161);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/document.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpOpsDocument=function(){function LpOpsDocument(){_classCallCheck(this,LpOpsDocument);}_createClass(LpOpsDocument,[{key:'checkWrappers',// check the documents' wrapper.
value:function checkWrappers(){var wrappers=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.docs_wrappers;var results={};if((typeof wrappers==='undefined'?'undefined':_typeof(wrappers))!=='object')return results;wrappers.forEach(function(idx,index){var id=idx.doc_name;var truth=true;if(_typeof(idx.conditions)==='object'&&_typeof(idx.conditions.compiledConditions)==='object'&&idx.conditions.compiledConditions.length>0){var conditions=idx.conditions;var cond=new __WEBPACK_IMPORTED_MODULE_1__logic_condition_tree__["a" /* ConditionRuntime */](conditions.compiledConditions);cond.compileDirect();truth=cond.execute(true);}results[index]={name:id,cond:truth};});return results;}}]);return LpOpsDocument;}();/* harmony default export */ __webpack_exports__["a"] = (LpOpsDocument);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/ovc.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpOpsOVC=function(){function LpOpsOVC(){_classCallCheck(this,LpOpsOVC);}_createClass(LpOpsOVC,[{key:'getIndexOfMultiple',value:function getIndexOfMultiple(multiple){var muls=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples;var index=-1;Object.keys(muls).forEach(function(idx){// console.log(muls[idx])
for(var i=0;i<muls[idx].length;i+=1){if(muls[idx][i]===multiple)index=i;}});return index+1;}/*  initParentingVars() {
      const varsParents = {};
      // extract the variable to option thing =
      Object.keys(lpApp.references.options).map((idx) => {
        lpApp.references.getOption(idx).variables.map((jdx) => {
          varsParents[jdx] = idx;
        });
      });
      return varsParents;
    } */// __ES_LINT_IVANN__ commented these two unused methods
/*  initParentingOpts() {
      const optsParents = {};
      // debugger;
      // extract the variable to option thing =
      Object.keys(lpApp.references.options).map((idx) => {
        lpApp.references.getOption(idx).children.map((jdx) => {
          optsParents[jdx] = idx;
        });
      });
      return optsParents;
    } *//*

    fromOVC() {
      // console.log(result);
      const on_opts = {};
      const result = {
        o: lpApp.getState().loadedOvc.o,
        v: lpApp.getState().loadedOvc.v,
        c: lpApp.getState().loadedOvc.c,
      };
      const ops_par = this.initParentingOpts();
      const var_par = this.initParentingVars();


      const options_flat = {};
      let opts = result.o;
      if ((typeof opts === 'undefined') || (opts.length)) opts = {};
      const opts_keys = Object.keys(opts);

      let i = 0;
      for (; i < opts_keys.length; i += 1) {
        const idx = opts_keys[i];
        const now_ = opts[idx];
        if ((typeof now_ === 'object') && (now_.length > 1)) {
          for (let j = 0; j < now_.length; j += 1) {
            const jdx = now_[j];
            if (jdx == '') {
              // console.log("faragh")
            } else if (j == 0) {
              // the first option
              options_flat[jdx] = true;
              options_flat[idx] = true;
            } else {
              let k = generateId1(4);
              if (lpApp.indexes.multiples.getMultiple(getOFirstMultipleParent(idx))) {
                const m_ = lpApp.indexes.multiples.getMultiple(getOFirstMultipleParent(idx));
                if ((i - 1) > m_.length) {
                  lpApp.indexes.multiples.getMultiple(getFirstMultipleParent(idx)).push(k);
                  options_flat[`${idx}_${k}`] = true;
                  options_flat[`${jdx}_${k}`] = true;
                } else {
                  k = m_[i - 1];
                  options_flat[`${idx}_${k}`] = true;
                  options_flat[`${jdx}_${k}`] = true;
                }
              } else {
                lpApp.indexes.multiples.addMultiple(idx, [k]);

                options_flat[`${idx}_${k}`] = true;
                options_flat[`${jdx}_${k}`] = true;
              }

              // window.lp_mult[idx] = true;
            }
          }
        } else if (now_ == '');
        // console.log("faragh");
        else options_flat[now_] = true;
      }

      // checkbox flat
      const checkbox_flat = {};
      let chk = result.c;
      if ((typeof chk === 'undefined') || (chk.length)) chk = {};
      const chk_keys = Object.keys(chk);
      i = 0;

      for (i = 0; i < chk_keys.length; i += 1) {
        const idx = chk_keys[i];
        const now_ = chk[idx].c ? chk[idx].c : chk[idx];
        let now_opts = chk[idx].v;

        if ((now_ != null) && now_ && (typeof now_ === 'object') && now_.length > 1) {
          for (let j = 0; j < now_.length; j += 1) {
            const jdx = now_[j];
            if (j == 0) {
              checkbox_flat[idx] = jdx;
            } else {
              const mk = getOFirstMultipleParent(idx);
              if (mk) {
                if (typeof lpApp.indexes.multiples.getMultiple(mk) !== 'undefined') {
                checkbox_flat[`${idx}_${lpApp.indexes.multiples.getMultiple(mk)[j - 1]}`] = jdx;
                }

                // debugger;
              }
            }
          }
        } else {
          checkbox_flat[idx] = typeof now_ === 'object' ? now_[0] : now_;
        }

        if ((typeof now_opts === 'object') && typeof now_opts.length === 'undefined') {
          const c_opts = now_opts;
          now_opts = [];
          for (const i in c_opts) {
            now_opts.push(c_opts[i]);
          }
        }
        if ((typeof now_opts === 'object') && (now_opts.length > 1)) {
          for (let j = 0; j < now_opts.length; j += 1) {
            const jdx = now_opts[j];
            // console.log(idx+ ' : '+jdx);
            if (jdx == '') {
              // console.log("faragh")
            } else if (j == 0) {
              // the first option
              options_flat[jdx] = true;
            } else {
              const k = generateId1(4);

              if (lpApp.indexes.multiples.getMultiple(idx)) {
                const tmp = lpApp.indexes.multiples.getMultiple(idx);
                tmp.push(k);
                lpApp.indexes.multiples.addMultiple(idx, tmp);
              } else lpApp.indexes.multiples.addMultiple(idx, [k]);
              options_flat[`${jdx}_${k}`] = true;
            }
          }
        } else if (now_opts == '');
        // console.log("faragh");
        else options_flat[now_opts] = true;
      }
      // console.log("hello")
      // extract informaion from V
      // don't waste variables xD hahahahha
      const vars_flat = {};
      i = 0;
      const v_keys = Object.keys(result.v);
      const v_ = result.v;
      for (i = 0; i < v_keys.length; i += 1) {
        const idx = v_keys[i];
        const now_ = v_[idx];
        if (typeof now_ === 'object' && now_.length > 1) {
          for (let j = 0; j < now_.length; j += 1) {
            const jdx = now_[j];
            if (j == 0) {
              vars_flat[idx] = jdx;
            } else {
              const mk = getFirstMultipleParent(idx);
              if (typeof mk !== 'undefined') {
                // debugger;
                if (typeof lpApp.indexes.multiples.getMultiple(mk) !== 'undefined') {
                vars_flat[`${idx}_${lpApp.indexes.multiples.getMultiple(mk)[j - 1]}`] = jdx;
                }
              }
            }
          }
        } else {
          vars_flat[idx] = typeof now_ === 'object' ? now_[0] : now_;
        }
      }
      return {
        o_c: options_flat,
        v_c: vars_flat,
        c_c: checkbox_flat,
      };
    }
  */},{key:'multipleFirst',value:function multipleFirst(id){// if(typeof id == 'undefined'){
//     console.trace("varioable undefined");
//     debugger;
// }
var now=id;// parseInt(id);
while(typeof now!=='undefined'){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(now).meta.multiple)return now;now=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa.getFather(now);}return false;}/*  getMultiplePosition(id) {
      const pureId = lpIdGetPure(id);
      const copy = lpIdGetCopy(id);
      const multiples = lpApp.indexes.multiples.getMultiple(this.multipleFirst(pureId));
      if (typeof multiples === 'undefined') return false;
      let idx = 1;
      const i = 0;
      while (multiples[i] !== copy) {
        idx += 1;
      }
      return idx;
    } *//*  toOVC() {
      const options = lpApp.getState().output.o;
      const variables = lpApp.getState().output.v;
      const options_pre = lpApp.getState().loadedOvc.oF;
      const checkbox_pre = lpApp.getState().loadedOvc.cF;
      const variables_pre = lpApp.getState().loadedOvc.vF;

      const o = {};
      const c = {};
      const v = {};

      // TODO: get the nearest grandpa multiple
      // initialization of options

      if (options_pre) {
        Object.keys(options_pre).map((idx) => {
          if (idx == true && lpApp.indexes.grandpa.getFather(lpIdGetPure(idx))) {
          // debugger
            if (lpIdGetCopy(idx) != -2) { // multiple thing
              const par = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx));
              o[par].push(lpIdGetPure(idx));
            } else if (
            lpApp.references.getOption(lpApp.indexes.grandpa.getFather(idx)).meta.multiple
            ) {
              o[lpApp.indexes.grandpa.getFather(idx)] = [idx];
            } else o[lpApp.indexes.grandpa.getFather(idx)] = idx;
          }
        });
      }


      // console.log(checkbox_pre)
      if (checkbox_pre) {
        Object.keys(checkbox_pre).map((idx) => {
        // console.log(idx)
          if (lpIdGetCopy(idx) == -2) { // multiple thing
            c[lpIdGetPure(idx)].push(checkbox_pre[idx]);
          } else if (lpApp.indexes.grandpa.getFather(idx) in lpApp.references.options
          && lpApp.references.getOption(lpApp.indexes.grandpa.getFather(idx)).meta.multiple
          ) {
            c[lpIdGetPure(idx)] = [checkbox_pre[lpIdGetPure(idx)]];
          } else c[lpIdGetPure(idx)] = checkbox_pre[lpIdGetPure(idx)];
        });
      }


      // initialization from checkboxes
      options.map((idx) => {
        if (lpApp.references.getOption(lpIdGetPure(idx.id)).meta.type == 'radio') {
          if (idx.value == true && lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id))) {
          // debugger
            if (lpIdGetCopy(idx.id) != -2) { // multiple thing
              const par = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id));
              if (typeof o[par] !== 'object') {
                o[par] = [];
                const max_ = this.getMultiplePosition(idx.id);
                for (let idx = 0; idx < max_; idx += 1) o[par].push('');
              }
              o[par].push(lpIdGetPure(idx.id));
            } else if (this.multipleFirst(lpIdGetPure(idx.id))) {
              o[lpApp.indexes.grandpa.getFather(idx.id)] = [idx.id];
            } else o[lpApp.indexes.grandpa.getFather(idx.id)] = idx.id;
          }
        }
        if (lpApp.references.getOption(lpIdGetPure(idx.id)).meta.type == 'checkbox') {
          // debugger
          if (lpIdGetCopy(idx.id) != -2) { // multiple thing
            const par = lpApp.indexes.grandpa.getFather(lpIdGetPure(idx.id));
            if (typeof c[lpIdGetPure(idx.id)] !== 'object') {
              c[lpIdGetPure(idx.id)] = [];
              const max_ = this.getMultiplePosition(idx.id);
              for (let i = 0; i < max_; i += 1) {
                c[lpIdGetPure(idx.id)].push('');
              }
            }
            c[lpIdGetPure(idx.id)].push(idx.value);
            // console.log(idx.id)
            // console.log(c[lpIdGetPure(idx.id)])
          } else if (this.multipleFirst(lpIdGetPure(idx.id))) {
            if (typeof c[lpIdGetPure(idx.id)] === 'object') c[lpIdGetPure(idx.id)][0] = idx.value;
            else c[lpIdGetPure(idx.id)] = [idx.value];
          } else c[lpIdGetPure(idx.id)] = idx.value;
        }
      });
      if (variables_pre) {
        Object.keys(variables_pre).map((idx) => {
          if (lpIdGetCopy(idx) == -2) { // multiple thing
            v[lpIdGetPure(idx)].push(variables_pre[idx]);
          } else if (
          this.multipleFirst((lpIdGetPure(lpApp.indexes.grandpa_vars.getVGrandpa(idx)))
          )) {
            v[lpIdGetPure(idx)] = [variables_pre[lpIdGetPure(idx)]];
          } else v[lpIdGetPure(idx)] = variables_pre[lpIdGetPure(idx)];
        });
      }

      variables.map((idx) => {
        // console.log(idx);
        if (lpIdGetCopy(idx.id) != -2) { // multiple thing
          const par = lpApp.indexes.grandpa_vars.getVGrandpa(lpIdGetPure(idx.id));
          v[lpIdGetPure(idx.id)].push(idx.value);
        } else if (
        this.multipleFirst(
        (lpIdGetPure(lpApp.indexes.grandpa_vars.getVGrandpa(lpIdGetPure(idx.id))))
        )) {
          v[lpIdGetPure(idx.id)] = [idx.value];
        } else v[lpIdGetPure(idx.id)] = idx.value;
      });


      return {
        o,
        v,
        c,
      };
    } */}]);return LpOpsOVC;}();/* harmony default export */ __webpack_exports__["a"] = (LpOpsOVC);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_condition_tree__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/checkout.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpOpsCheckout=function(){function LpOpsCheckout(){_classCallCheck(this,LpOpsCheckout);this.showCreditCardModal=function(){};}_createClass(LpOpsCheckout,[{key:'getPackId',/**
     * Gets the chosen pack for payment
     * @returns {number} 0 for the first selection and 1 for the sencod selection
     */value:function getPackId(){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.pack;}},{key:'getPackPrice',value:function getPackPrice(){return Object.values(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.prices)[this.getPackId()];}},{key:'getTTCPrice',value:function getTTCPrice(){var pro=LpOpsCheckout.isProInd();var lawyer=LpOpsCheckout.detectLawyer()?29.9:0;var letters=LpOpsCheckout.detectLetters();letters=letters?Math.abs(letters.number)*3.9:0;// devenir-coursier
if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractMetaId===302)return parseFloat(this.getPackPrice()*1.2).toFixed(2);return parseFloat((!pro?parseFloat(this.getPackPrice()):parseFloat(this.getPackPrice()*1.2))*LpOpsCheckout.getPromotionPercentage()+lawyer+letters).toFixed(2);}},{key:'getHTPrice',value:function getHTPrice(){var pro=LpOpsCheckout.isProInd();var lawyer=LpOpsCheckout.detectLawyer()?29.9:0;var letters=LpOpsCheckout.detectLetters();letters=letters?Math.abs(letters.number)*3.9:0;if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].contractMetaId===302)return parseFloat(this.getPackPrice()).toFixed(2);return parseFloat((!pro?parseFloat(this.getPackPrice())/1.2:parseFloat(this.getPackPrice()))*LpOpsCheckout.getPromotionPercentage()+lawyer+letters).toFixed(2);}},{key:'resetCreditCardInformation',value:function resetCreditCardInformation(){__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["M" /* ckCheckCondition */])(false));__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["J" /* ckCUpdateCardNumber */])(''));__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["I" /* ckCUpdateCardExpiration */])(''));__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["H" /* ckCUpdateCCV */])(''));}},{key:'resetCheckedCondition',value:function resetCheckedCondition(){__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["M" /* ckCheckCondition */])(false));}},{key:'setCheckoutCallback',value:function setCheckoutCallback(callback){this.showCreditCardModal=callback;}},{key:'isInvoiceActivated',value:function isInvoiceActivated(){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.toggle_invoice;}},{key:'getInvoice',value:function getInvoice(){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.invoice;}}],[{key:'isProInd',value:function isProInd(){var state=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState();var pro=true;var proTest=state.contract.client_type;// TODO: Check condition is not null
switch(proTest){case'COND':if(state.contract.pro_condition.length===0)pro=false;else{var proCond=new __WEBPACK_IMPORTED_MODULE_1__logic_condition_tree__["a" /* ConditionRuntime */](state.contract.pro_condition);proCond.compileDirect();pro=proCond.execute(true);}break;case'PRO':pro=true;break;default:break;}return pro;}},{key:'detectLetters',value:function detectLetters(){var letters=void 0;if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.has_letter){letters=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.letter;}else letters=false;return letters;}},{key:'detectLawyer',value:function detectLawyer(){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.has_call;}},{key:'getPromotionPercentage',value:function getPromotionPercentage(){if(Number.isNaN(parseFloat(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.promo_percentage))||typeof price==='string')return 1.0;return 1-__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().checkout_operations.promo_percentage;}}]);return LpOpsCheckout;}();/* harmony default export */ __webpack_exports__["a"] = (LpOpsCheckout);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_condition_evo__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/initialization.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */function filterRadios(){var siblings=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return siblings.filter(function(idx){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='radio';});}var LpOpsInitializations=function(){function LpOpsInitializations(){_classCallCheck(this,LpOpsInitializations);}_createClass(LpOpsInitializations,[{key:'initializeOptions',value:function initializeOptions(opts,dispatch,getState){var _this=this;opts.forEach(function(idx){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&idx in __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).meta&&(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).meta.type==='static'||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).meta.type==='hidden')||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).meta.type==='radio'){// radio_group.push(idx);
var dValue=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).meta.default;var _lpApp$references$get=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx),children=_lpApp$references$get.children;// test cnditions before doing any fuckedup move.
var pass=true;if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).meta.conditional){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.conditions){if(typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.getCondition(idx)==='undefined'&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).meta.compiledConditions.length>0){pass=__WEBPACK_IMPORTED_MODULE_5__logic_condition_evo__["a" /* default */].getCondition(idx);window.nbr_forced+=1;__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.setCondition(idx,pass);}else{pass=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.getCondition(idx);}}//
}// if(idx == 296)debugger;
if(pass&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&dValue in __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(dValue).meta&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(dValue).meta.type==='radio'){// get all radios
if(!LpOpsInitializations.isInitialized(children,getState().output.o)){// dispatch(checkRadio1(dValue, idx));
// rsRegisterAction(dValue, idx, false, -2);
}}if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).children.length>0){LpOpsInitializations.initializaChildren(children,dispatch);_this.initializeOptions(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(idx).children,dispatch,getState);}}});}},{key:'intiialize',value:function intiialize(opts){var _this2=this;var secondLevel=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var dispatch=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch,getState=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState;// console.time("init_opts");
if(!opts)return;opts.forEach(function(idx){var dValue=-1;var children=[];var pass=true;if(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx)===-2){;var _lpApp$references$get2=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx));children=_lpApp$references$get2.children;}else{children=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).children.map(function(i){return i+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx);});}if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)in __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta&&(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='static'||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='hidden')||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='radio'||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='checkbox'){// give em an initializer
dValue=LpOpsInitializations.initializeOneOption(idx);if(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx)!==-2&&dValue>-1)dValue=Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(dValue)+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx);// Making sure the option has no value
children.forEach(function(cdx){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(cdx).value)dValue=-1;});// console.log(dValue)
if(dValue>=0){// test cnditions before doing any fuckedup move.
if(typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.getCondition(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx))==='undefined'){pass=LpOpsInitializations.lpCheckCondition(idx);}else{pass=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.getCondition(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx));}// if(idx == 27)debugger;
if(pass&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)in __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='checkbox'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["k" /* editOption */])(idx,Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["a" /* getOptionPass */])(idx)));}if(pass&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(dValue)in __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(dValue)).meta&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(dValue)).meta.type==='radio'){// converting the lp_parenting into lp_grandpa
if(!LpOpsInitializations.isInitialized(filterRadios(children),getState().output.o)&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(dValue))){LpOpsInitializations.createMoreChildren(children,getState);}}else{// checkbox selection
if(pass&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)in __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='checkbox'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["k" /* editOption */])(idx,Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["a" /* getOptionPass */])(idx)));// console.log("initializing checkbox " + idx);
// console.log(" = " + idx + " third ")
}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["k" /* editOption */])(dValue,true));}// let s = getOFirstMultipleParent(lpIdGetPure(idx));
if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.multiple&&Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx)===-2){// test if it has really multiples
// debugger;
if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).children.length>0){_this2.intiialize(children,true);// console.log(" = " + idx + " deep one ")
}}}}if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.multiple&&Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx)===-2){// test if it has really multiples
// debugger;
if(typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples!=='undefined'&&Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)in __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples){var copies=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.getMultiple(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx));var pureCopies=copies.map(function(i){return Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)+'_'+i;});_this2.intiialize(pureCopies,true);// console.log(" = " + idx + " deep two ")
}}if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).children.length>0){// TODO: we have to check in this?.
LpOpsInitializations.createMoreChildren(children,getState);_this2.intiialize(children,true);// console.log(" = " + idx + " deep one ")
}}});this.initializeVariables(opts.filter(function(idx){return!__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(idx).value;}));if(!secondLevel){__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].mutex.setMutex('preview',true);}}},{key:'initializeVariables',value:function initializeVariables(opts){var _this3=this;var dispatch=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].dispatch;opts.forEach(function(idx){// if(typeof lpGetVariableById(idx) != 'undefined')return;
// initialize variables.
if(typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx))==='undefined')return;var _lpApp$references$get3=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)),variables=_lpApp$references$get3.variables;variables.forEach(function(l){// if(window.lp_vars[l]){
if(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx)===-2){var v=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(l);// let k = generateId1(4);
if(v){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["n" /* initOutputVariable */])(l,idx,v.value));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["l" /* editVariable */])(l,v.value));}}else{var _v=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(l+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx));// let k = generateId1(4);
if(_v){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["n" /* initOutputVariable */])(l+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx),idx,_v.value));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["l" /* editVariable */])(l+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx),_v.value));}}});var _lpApp$references$get4=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)),children=_lpApp$references$get4.children;// the children
var childrenChanged=void 0;if(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx)!==-2){// manage the muyltiples
childrenChanged=children.map(function(k){return k+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx);});}else{childrenChanged=children.map(function(k){return k;});}// TODO:
_this3.initializeVariables(childrenChanged.filter(function(jdx){return!__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(jdx).value;}));});}},{key:'raNextInit',value:function raNextInit(sectionNumber){return function(dispatch,getState){var theSection=getState().contract.sections[sectionNumber];if(theSection){__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].ops.initialization.initializeOptions(theSection.options,dispatch,getState);}};}}],[{key:'isInitialized',value:function isInitialized(){var rs=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var result=false;rs.forEach(function(idx){options.forEach(function(jdx){if(jdx.id===idx){if(jdx.value){result=true;}}});});return result;}},{key:'initializaChildren',value:function initializaChildren(opts,dispatch){// debugger;
opts.forEach(function(idx){if(typeof Object(__WEBPACK_IMPORTED_MODULE_2__logic_re_index__["g" /* lpGetOptionById */])(idx)==='undefined'){var uiid=Object(__WEBPACK_IMPORTED_MODULE_3__components_utils_misc__["b" /* generateId1 */])(1);var optType=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type;// Checking value
var _lpApp$indexes$option=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)),value=_lpApp$indexes$option.value;if(optType==='static'||optType==='hidden'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["m" /* initOutputOption */])(idx,uiid,true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["m" /* initOutputOption */])(idx,uiid,value));}}else{var s=Object(__WEBPACK_IMPORTED_MODULE_2__logic_re_index__["g" /* lpGetOptionById */])(idx);if(typeof s.value!=='undefined'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_output__["k" /* editOption */])(idx,s.value));}}});}},{key:'lpCheckCondition',value:function lpCheckCondition(idx){var pass=true;if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.conditional){if(typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.getCondition(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx))==='undefined'&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.compiledConditions.length>0){pass=__WEBPACK_IMPORTED_MODULE_5__logic_condition_evo__["a" /* default */].getCondition(idx);__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.setCondition(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx),pass);}else{pass=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.conditions.getCondition(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx));}//
}return pass;}},{key:'initializeOneOption',value:function initializeOneOption(idx){var dValue=-1;var here=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx));if(here.meta.default){dValue=here.meta.default;}__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).children.forEach(function(jdx){var now=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(jdx));//
if(now&&(now.meta.type==='radio'||now.meta.type==='checkbox')){// do the test if it's copy or not
var nowJdx=void 0;if(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx)===-2)nowJdx=jdx;else nowJdx=jdx+'_'+Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(idx);var s=Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["a" /* getOptionPass */])(nowJdx);if(typeof s!=='undefined'&&s){dValue=nowJdx;}}});// console.log(dValue)
if(dValue<0){// debugger;
var now=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx));if(now.meta.type==='radio'||now.meta.type==='checkbox'){var s=Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["a" /* getOptionPass */])(idx);//
if(typeof s!=='undefined'&&s){dValue=idx;}}}// if(typeof idx == 'string')debugger;
return dValue;}},{key:'createMoreChildren',value:function createMoreChildren(children,dispatch){LpOpsInitializations.initializaChildren(children,dispatch);}}]);return LpOpsInitializations;}();/* harmony default export */ __webpack_exports__["a"] = (LpOpsInitializations);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_global_getter__ = __webpack_require__(33);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/utils.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpUtils=function(){function LpUtils(){_classCallCheck(this,LpUtils);}_createClass(LpUtils,[{key:'addModalClassToBody',value:function addModalClassToBody(){document.body.classList.add('lp-mdl');// if(lpApp.env.is_mobile)
//     document.querySelector(".page-wrap").style.display = "none";
}},{key:'removeModalClassToBody',value:function removeModalClassToBody(){document.body.classList.remove('lp-mdl');// if(lpApp.env.is_mobile)
//     document.querySelector(".page-wrap").style.display = "";
}/**
     * flatten an object to a simple direct flat
     * @param {Object} dict
     * @param {Object} output
     * @param {String} prefix
     */},{key:'flattenDict',value:function flattenDict(){var dict=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _this=this;var output=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var prefix=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var flattenOutput=output;if((typeof dict==='undefined'?'undefined':_typeof(dict))!=='object')return flattenOutput;// the dict is an object
var keys=Object.keys(dict);keys.forEach(function(idx){if(_typeof(dict[idx])==='object'){_this.flattenDict(dict[idx],flattenOutput,prefix+idx+'__');}else{flattenOutput[prefix+idx]=dict[idx];}});return flattenOutput;}},{key:'getEditedVariables',value:function getEditedVariables(){var variableActions={};var keys=Object.keys(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.variables);keys.forEach(function(idx){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.variables[idx].value!=='')variableActions[idx]=true;});// updating if there is a variable or an option in there
var vF=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().loadedOvc.vF;var vFKeys=typeof vF==='undefined'?[]:Object.keys(vF);vFKeys.forEach(function(idx){if(vF[idx]!=='')variableActions[idx]=true;});if(typeof variableActions==='undefined')return 0;return Object.keys(variableActions).length;}},{key:'getEditedOptions',value:function getEditedOptions(){var OptionActions={};var _lpApp$getState$loade=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].getState().loadedOvc,oF=_lpApp$getState$loade.oF,cF=_lpApp$getState$loade.cF;var oFKeys=typeof oF==='undefined'?[]:Object.keys(oF);var cFKeys=typeof cF==='undefined'?[]:Object.keys(cF);var optionsKeys=Object.keys(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.options);optionsKeys.forEach(function(idx){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options[idx])OptionActions[idx]=true;});oFKeys.forEach(function(idx){if(oF[idx]&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx))&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='radio')OptionActions[idx]=true;});cFKeys.forEach(function(idx){if(cF[idx]&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.getOption(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)).meta.type==='checkbox')OptionActions[idx]=true;});if(typeof OptionActions==='undefined')return 0;return Object.keys(OptionActions).length;}},{key:'getAllChildren',value:function getAllChildren(id){var _this2=this;var r=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var pureId=Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(id);if(!__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[pureId]){return r;}var now=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[pureId].children;now.forEach(function(idx){r.push(idx);_this2.getAllChildren(idx,r);},this);return r;}},{key:'getAllVariableChildren',value:function getAllVariableChildren(){var ids=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var result=[];ids.forEach(function(idx){__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[idx].variables.map(function(jdx){return result.push(jdx);});});return result;}}]);return LpUtils;}();/* harmony default export */ __webpack_exports__["a"] = (LpUtils);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_global_getter__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/two_steps.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpTwoSteps=function(){function LpTwoSteps(){_classCallCheck(this,LpTwoSteps);}_createClass(LpTwoSteps,[{key:'checkOption',value:function checkOption(idx){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_options[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)]&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_options[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)].value&&!__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].isPayed;}},{key:'checkVariable',value:function checkVariable(idx){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_variables[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)]&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_variables[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)].value&&!__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].isPayed;}},{key:'checkSection',value:function checkSection(idx){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_sections[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)]&&__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_sections[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)].value&&!__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].isPayed;}},{key:'isDiscovered',value:function isDiscovered(idx){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'option';switch(type){case'option':if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_options[idx]){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_options[idx].isDiscovered();}return true;case'variable':if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_variables[idx]){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_variables[idx].isDiscovered();}return true;case'section':if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_sections[idx]){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.two_steps.ts_sections[idx].isDiscovered();}return true;default:return true;}}}]);return LpTwoSteps;}();/* harmony default export */ __webpack_exports__["a"] = (LpTwoSteps);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracking_lpevents__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/slack_notifications.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpSlackOps=function(){function LpSlackOps(){_classCallCheck(this,LpSlackOps);this.channel='';this.icon=':euro:';}_createClass(LpSlackOps,[{key:'sendContinueMessage',value:function sendContinueMessage(a){var quote=a==='Validate'?' a valider sa démarche : ':' a enregistrer sa démarche : ';var color=a==='Validate'?'#36A64F':'#669BCC';var json={username:'Suivi Création',icon_emoji:this.icon,channel:'#dossier-updated-crea',attachments:[{text:__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].getState().account_settings.mail+quote+__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].getState().contract.name+'\n<'+window.location.href+'|Questionnaire>'+(' - <https://www.legalplace.fr/telecharger/'+__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].continuity.continue+'|Documents>'),color:color}]};// Adding Environement to username when needed
if(typeof window.lp_env==='string'&&window.lp_env!=='prod'){json.username+=' - Environement:  '+window.lp_env;json.attachments[0].text=':warning: *CECI EST UN TEST -* '+json.attachments[0].text;}if(__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].isPayed){LpSlackOps.sendNotification(json);}}},{key:'sendCustomeSlack',value:function sendCustomeSlack(){var _this=this;var variablesExtraction=__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].references.slack_notification.saveSlack;/*
        let slackExtractions = {};
        for(var i = 0; i < variablesExtraction.length; i += 1){
          let current_slackExtraction = variablesExtraction[i].extractions.slack;

          if(current_slackExtraction.enabled === true){
            let current_value = variablesExtraction[i].value;
            if(!(current_slackExtraction.channel in slackExtractions)){
              slackExtractions[current_slackExtraction.channel] = [];
            }

            slackExtractions[current_slackExtraction.channel].push({
              title: current_slackExtraction.name,
              value: current_value,
              short: true
            });
          }
        }
*/variablesExtraction.forEach(function(idx){// Making sure variable is defined
if(typeof __WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].references.variables[idx.id]==='undefined')return;var json={username:idx.name,icon_emoji:_this.icon,channel:idx.channel,attachments:[{text:'eMail : '+__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].getState().account_settings.mail+' \n '+__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].references.variables[idx.id].label+' : '+(__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].indexes.variables.getVariable(idx.id)?__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].indexes.variables.getVariable(idx.id).value:' Not mentionned')}]};// Adding Environement to username when needed
if(typeof window.lp_env==='string'&&window.lp_env!=='prod'){json.username+=' - Environement:  '+window.lp_env;json.attachments[0].text=':warning: *CECI EST UN TEST -* '+json.attachments[0].text;}LpSlackOps.sendNotification(json);},this);}},{key:'generateMixpanel',value:function generateMixpanel(){var mx=__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].references.slack_notification.mixpanel;var evt={};mx.forEach(function(idx){evt[idx.name]=idx.type==='option'?LpSlackOps.extractOption(idx):LpSlackOps.extractVariable(idx);});}},{key:'generateSendinBlue',value:function generateSendinBlue(eventName){var sib=__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].references.slack_notification.sendinblue;var evt={};sib.forEach(function(idx){evt[idx.name]=idx.type==='option'?LpSlackOps.extractOption(idx):LpSlackOps.extractVariable(idx);});__WEBPACK_IMPORTED_MODULE_2__tracking_lpevents__["a" /* default */].trackSIB(eventName,evt);}},{key:'sendExtractionAttributesSBToDatalayer',value:function sendExtractionAttributesSBToDatalayer(){var sbDataIdentify=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var sib=__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].references.slack_notification.sendinblue;var evt=Object.assign({},sbDataIdentify);sib.forEach(function(idx){evt[idx.name]=idx.type==='option'?LpSlackOps.extractOption(idx):LpSlackOps.extractVariable(idx);});__WEBPACK_IMPORTED_MODULE_2__tracking_lpevents__["a" /* default */].trackDatalayerSendinBlue(evt);}}],[{key:'sendNotification',value:function sendNotification(){var _this2=this;var json=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;fetch('https://hooks.slack.com/services/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',{headers:{// "Accept": "application/json",
// "Content-Type": "application/json"
},body:JSON.stringify(json),method:'POST'}).then(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log(await resp.text())
if(callback)callback();case 1:case'end':return _context.stop();}}},_callee,_this2);}))).catch(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(err){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// console.log(await err.text())
if(callback)callback();case 1:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x4){return _ref2.apply(this,arguments);};}());}},{key:'extractVariable',value:function extractVariable(idx){return __WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].indexes.variables.getVariable(idx.id)?__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].indexes.variables.getVariable(idx.id).value:'No value';}},{key:'extractOption',value:function extractOption(idx){return __WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].indexes.options.getOption(idx.id)?__WEBPACK_IMPORTED_MODULE_1__lp_app__["a" /* default */].indexes.options.getOption(idx.id).value:'No value';}}]);return LpSlackOps;}();/* harmony default export */ __webpack_exports__["a"] = (LpSlackOps);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_condition_evo__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/mandatory.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpMandatory=function(){function LpMandatory(){_classCallCheck(this,LpMandatory);}_createClass(LpMandatory,[{key:'multipleOptionsCopies',value:function multipleOptionsCopies(sId){// Getting section multiple options
var mOptions=[];__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.sections[sId-1].options.forEach(function(idx){if(Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples,idx)){mOptions.push(idx);}});if(mOptions.length===0)return[];// Multiple variables
var mOps=[];// Reading section's mandatory variables to look for
// multiples
LpMandatory.filterStaticsAndCheckboxes(sId).forEach(function(idx){var op=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx));var tree=[idx];while(typeof op!=='undefined'){tree.push(op);op=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa.getFather(op);}tree.forEach(function(fId){if(mOptions.indexOf(fId)>-1){__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples[fId].forEach(function(copy){mOps.push(idx+'_'+copy);});}});});return mOps;}},{key:'checkMandatoryVariables',value:function checkMandatoryVariables(sId){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.mandatory_variables&&sId in __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.mandatory_variables){return!(typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.mandatory_variables[sId]==='undefined'?true:[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.mandatory_variables[sId]),_toConsumableArray(LpMandatory.multipleVariablesCopies(sId))).map(function(idx){return LpMandatory.checkVariable(idx);}).filter(function(idx){return!idx;}).length>0);}return true;}},{key:'checkMandatoryOptions',value:function checkMandatoryOptions(sId){if(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.mandatory_options){return typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.mandatory_options[sId]==='undefined'?true:[].concat(_toConsumableArray(LpMandatory.filterStaticsAndCheckboxes(sId)),_toConsumableArray(this.multipleOptionsCopies(sId))).map(function(idx){return LpMandatory.checkOption(idx);}).filter(function(idx){return!idx;}).length===0;}return true;}},{key:'globalCheckVariables',value:function globalCheckVariables(){return Object.keys(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.real_sections.sections).map(function(idx){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].ops.mandatory.checkMandatoryVariables(idx);}).filter(function(idx){return!idx;}).length===0;}},{key:'globalCheckOptions',value:function globalCheckOptions(){return Object.keys(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.real_sections.sections).map(function(idx){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].ops.mandatory.checkMandatoryOptions(idx);}).filter(function(idx){return!idx;}).length===0;}}],[{key:'isShown',value:function isShown(id){var amVar=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var op=amVar?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa_vars.getVGrandpa(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(id)):__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa.getFather(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(id));// get fatherZ
var fathers=[];while(typeof op!=='undefined'){fathers.push(op);op=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa.getFather(op);}// If it's a copy getting copy fathers
if(typeof id!=='number'){var copy=Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(id);fathers=fathers.map(function(idx){return idx+'_'+copy;});}// TODO : CHECK MULTIPLE CONDITIONS WITH NASRO
var fValues=fathers.map(function(idx){// check the conditionning
var condition=true;var opt=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)]?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx)].meta:{};if(opt.conditional&&opt.compiledConditions.length>0){// let cond_ = new ConditionRuntime(opt.compiledConditions);
// cond_.compileDirect();
// condition = cond_.execute(true);
condition=__WEBPACK_IMPORTED_MODULE_2__logic_condition_evo__["a" /* default */].getCondition(idx);}if(condition){var value=typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(idx)==='undefined'?Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["a" /* getOptionPass */])(idx):__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(idx).value;if(opt.type&&opt.type==='static')value=true;return value;}return false;});if(fValues.length===0)return true;return!(fValues.filter(function(idx){return idx!==true;}).length>0);}},{key:'filterStaticsAndCheckboxes',value:function filterStaticsAndCheckboxes(sId){var options=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.mandatory_options[sId];if(typeof options==='undefined')return[];var result=options.filter(function(idx){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[idx].meta.type==='static'||__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[idx].meta.type==='checkbox';});// console.log("Work ", sId, result);
// test if everyone is conditionned
var conds=result.map(function(idx){var opt=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[idx];if(opt.meta.conditional){// let cond = new ConditionRuntime(opt.meta.compiledConditions);
// // TODO: multiple check
// cond.compileDirect();
// return cond.execute(true);
return __WEBPACK_IMPORTED_MODULE_2__logic_condition_evo__["a" /* default */].getCondition(idx);}return true;});var r=[];result.forEach(function(idx,i){if(conds[i])r.push(idx);});return r;}},{key:'filterRadios',value:function filterRadios(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return arr.filter(function(idx){return __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[idx].meta.type==='radio';});}},{key:'checkOption',value:function checkOption(id){//
var opt=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.options[Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(id)];if(typeof opt==='undefined')return true;var children=opt.meta.type==='checkbox'?[opt.meta.id]:opt.children;children=LpMandatory.filterRadios(children);if(children.length===0)return true;var result=children.map(function(idx){var copyIdx=idx;var copy=Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["c" /* lpIdGetCopy */])(id);if(copy!==-2)copyIdx+='_'+copy;return typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(copyIdx)==='undefined'?Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["a" /* getOptionPass */])(copyIdx):__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.options.getOption(copyIdx).value;});result=result.filter(function(idx){return idx;});if(LpMandatory.isShown(id,false))return result.length>0;return true;}},{key:'checkVariable',value:function checkVariable(id){var pureId=Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(id);var variable=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.variables[pureId];var variableValue=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables?__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(id):'';var value=(typeof __WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(id)==='undefined'?Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["b" /* getVariablePass */])(id):__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.variables.getVariable(id).value)!=='';if(variable.type==='number')value=parseInt(variableValue?variableValue.value:0,10)>0;if(variable.type==='eval')value=true;if(LpMandatory.isShown(id)){return typeof value==='undefined'?false:value;}return true;}},{key:'multipleVariablesCopies',value:function multipleVariablesCopies(sId){// Getting section multiple options
var mOptions=[];__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.sections[sId-1].options.forEach(function(idx){if(Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples,idx)){mOptions.push(idx);}});if(mOptions.length===0)return[];// Multiple variables
var mVars=[];// Reading section's mandatory variables to look for
// multiples
__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].references.mandatory_variables[sId].forEach(function(idx){var op=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa_vars.getVGrandpa(Object(__WEBPACK_IMPORTED_MODULE_1__logic_global_getter__["d" /* lpIdGetPure */])(idx));var fathers=[];while(typeof op!=='undefined'){fathers.push(op);op=__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.grandpa.getFather(op);}fathers.forEach(function(fId){if(mOptions.indexOf(fId)>-1){__WEBPACK_IMPORTED_MODULE_0__lp_app__["a" /* default */].indexes.multiples.multiples[fId].forEach(function(copy){mVars.push(idx+'_'+copy);});}});});return mVars;}}]);return LpMandatory;}();/* harmony default export */ __webpack_exports__["a"] = (LpMandatory);

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/ops/contacts.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var HUB_TOKEN='86e28b6a-78e9-427f-8127-ce32b89b3397';// operations routes.
var H_GET_PROFILE_BY_MAIL='https://api.hubapi.com/contacts/v1/contact/email/';// + mail + /profile?hapikey= ......
var H_ADD_CONTACT='https://api.hubapi.com/contacts/v1/contact/';// + ?hapikey=....
var LpContactsOps=function(){function LpContactsOps(){_classCallCheck(this,LpContactsOps);this.name='';this.mail='';this.phone_number='';this.address='';}_createClass(LpContactsOps,[{key:'registerMail',value:function registerMail(mail){this.mail=mail;}/**
   *
   * @param {string} mail
   */},{key:'saveHubSpot',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// if(!this.__checkBasics())
//     return;
// TODO: this can be changable.
data={properties:[{property:'email',value:this.mail},{property:'firstname',value:this.name},{property:'phone',value:this.phone_number},{property:'website',value:window.location.href},{property:'address',value:this.address}]};_context.next=3;return this.checkContactExistance(this.mail);case 3:if(_context.sent){_context.next=5;break;}fetch(H_ADD_CONTACT+"?hapikey=86e28b6a-78e9-427f-8127-ce32b89b3397",{method:'POST',body:JSON.stringify(data)}).then(function(resp){if(resp.status===200)console.log("contact saved");}).catch(function(err){console.log(err);});case 5:case'end':return _context.stop();}}},_callee,this);}));function saveHubSpot(){return _ref.apply(this,arguments);}return saveHubSpot;}()}],[{key:'checkContactExistance',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(mail){var a,json;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(mail==='')){_context2.next=2;break;}return _context2.abrupt('return',false);case 2:_context2.next=4;return fetch(H_GET_PROFILE_BY_MAIL+mail+'/profile?hapikey='+HUB_TOKEN);case 4:a=_context2.sent;_context2.next=7;return a.json();case 7:json=_context2.sent;if(!(json.status==='error')){_context2.next=10;break;}return _context2.abrupt('return',false);case 10:return _context2.abrupt('return',json);case 11:case'end':return _context2.stop();}}},_callee2,this);}));function checkContactExistance(_x){return _ref2.apply(this,arguments);}return checkContactExistance;}()}]);return LpContactsOps;}();/* harmony default export */ __webpack_exports__["a"] = (LpContactsOps);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__log_entry__ = __webpack_require__(1103);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/log/log.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpLog=function(){function LpLog(){_classCallCheck(this,LpLog);this.logs=[];}_createClass(LpLog,[{key:'log',value:function log(type,message){this.logs.push(new __WEBPACK_IMPORTED_MODULE_0__log_entry__["a" /* default */](type,message));}}]);return LpLog;}();/* harmony default export */ __webpack_exports__["a"] = (LpLog);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Project: LegalPlace assistant
 * File: src/app/log/log_entry.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpLogEntry=function(){function LpLogEntry(type,message){_classCallCheck(this,LpLogEntry);this.create(type,message);}_createClass(LpLogEntry,[{key:'create',value:function create(type){var message=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';this.type=type;this.message=message;this.time=new Date();this.trace=new Error(message);}}]);return LpLogEntry;}();/* harmony default export */ __webpack_exports__["a"] = (LpLogEntry);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hrefTel */
/* unused harmony export tel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return displayHeaderPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayHeaderMobilePhone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_lpevents__ = __webpack_require__(15);
var hrefTel="tel:+330176350059";var tel="01 76 35 00 59";var trackTel="+330176350059";var clickTelButton=function clickTelButton(){__WEBPACK_IMPORTED_MODULE_0__tracking_lpevents__["a" /* default */].trackGTMGAEvent('Clic téléphone','Clic',trackTel);};var displayHeaderPhone=function displayHeaderPhone(){var headerPhone=document.createElement("span");headerPhone.innerHTML="<a href="+hrefTel+" class=\"support-cta\">\n          <span class=\"support-cta__icon icn-phone\"></span>\n          <span class=\"support-cta__txt\" id=\"phone-number\">"+tel+"</span>\n          </a>\n          ";document.getElementById("phone").appendChild(headerPhone);document.getElementById('phone').onclick=clickTelButton;};var displayHeaderMobilePhone=function displayHeaderMobilePhone(){var headerMobilePhone=document.createElement("span");headerMobilePhone.innerHTML="<a href="+hrefTel+" class=\"support-cta-outline navbar__support-cta\">\n    <span class=\"support-cta__icon icn-phone\"></span>\n     </a>";document.getElementById("phone-mobile").appendChild(headerMobilePhone);document.getElementById('phone-mobile').onclick=clickTelButton;};

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1106);
var objectAssign = __webpack_require__(17);
var decodeComponent = __webpack_require__(1107);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_animate_height__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_animate_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_animate_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_wording__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src\components\control_bar.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var _LpErrorBar=function(_Component){_inherits(_LpErrorBar,_Component);_createClass(_LpErrorBar,null,[{key:'hideError',value:function hideError(){Object(__WEBPACK_IMPORTED_MODULE_3__errors_error__["c" /* unraiseError */])('global');}}]);function _LpErrorBar(props){_classCallCheck(this,_LpErrorBar);var _this=_possibleConstructorReturn(this,(_LpErrorBar.__proto__||Object.getPrototypeOf(_LpErrorBar)).call(this,props));_this.in=false;return _this;}_createClass(_LpErrorBar,[{key:'componentDidMount',value:function componentDidMount(){if(this.refs.me)document.getElementById('errors-bar').appendChild(this.refs.me);}},{key:'render',value:function render(){var height=this.props.error_code>0?'auto':0;if(typeof height==='undefined')height=0;// console.log(height)
// <AnimateHeight height={height} duration={400}>
// </AnimateHeight>
// console.log(this.props.error_code)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'me'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_animate_height___default.a,{height:height,duration:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error notification-bar in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nb-container container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{ref:'text'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Erreur : ')+this.props.error_message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nb-x icn-x',onClick:_LpErrorBar.hideError})))));}}]);return _LpErrorBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{error_code:state.errors.code,error_message:state.errors.message};};var mapDispatchToProps=function mapDispatchToProps(){return{};};var LpErrorBar=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_LpErrorBar);/* harmony default export */ __webpack_exports__["a"] = (LpErrorBar);

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(35);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(447);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};

function omit(obj) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (!keys.length) {
    return obj;
  }

  var res = {};
  var objectKeys = Object.keys(obj);

  for (var i = 0; i < objectKeys.length; i++) {
    var key = objectKeys[i];

    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  }

  return res;
}

// Start animation helper using nested requestAnimationFrames
function startAnimationHelper(callback) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      callback();
    });
  });
}

var AnimateHeight = function (_React$Component) {
  _inherits(AnimateHeight, _React$Component);

  function AnimateHeight(props) {
    _classCallCheck(this, AnimateHeight);

    var _this = _possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));

    var height = 'auto';
    var overflow = 'visible';

    if (_this.isNumber(props.height)) {
      height = props.height < 0 ? 0 : props.height;
      overflow = 'hidden';
    } else if (
    // Percentage height
    typeof props.height === 'string' && props.height.search('%') === props.height.length - 1 && _this.isNumber(props.height.substr(0, props.height.length - 1))) {
      height = props.height;
      overflow = 'hidden';
    }

    _this.animationStateClasses = _extends({}, ANIMATION_STATE_CLASSES, props.animationStateClasses);

    var animationStateClasses = _this.getStaticStateClasses(height);

    _this.state = {
      animationStateClasses: animationStateClasses,
      height: height,
      overflow: overflow,
      shouldUseTransitions: false
    };
    return _this;
  }

  _createClass(AnimateHeight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var height = this.state.height;

      // Hide content if height is 0 (to prevent tabbing into it)
      // Check for contentElement is added cause this would fail in tests (react-test-renderer)
      // Read more here: https://github.com/Stanko/react-animate-height/issues/17

      if (this.contentElement && this.contentElement.style) {
        this.hideContent(height);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var height = this.props.height;

      // Check if 'height' prop has changed

      if (this.contentElement && nextProps.height !== height) {
        var _cx;

        // Remove display: none from the content div
        // if it was hidden to prevent tabbing into it
        this.showContent();

        // Cache content height
        this.contentElement.style.overflow = 'hidden';
        var contentHeight = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = '';

        var newHeight = null;
        var timeoutState = {
          height: null, // it will be always set to either 'auto' or specific number
          overflow: 'hidden'
        };
        var isCurrentHeightAuto = this.state.height === 'auto';

        if (this.isNumber(nextProps.height)) {
          // If new height is a number
          newHeight = nextProps.height < 0 ? 0 : nextProps.height;
          timeoutState.height = newHeight;
        } else if (
        // Percentage height
        typeof nextProps.height === 'string' && nextProps.height.search('%') === nextProps.height.length - 1 && this.isNumber(nextProps.height.substr(0, nextProps.height.length - 1))) {
          newHeight = nextProps.height;
          timeoutState.height = newHeight;
        } else {
          // If not, animate to content height
          // and then reset to auto
          newHeight = contentHeight;
          timeoutState.height = 'auto';
          timeoutState.overflow = null;
        }

        if (isCurrentHeightAuto) {
          // This is the height to be animated to
          timeoutState.height = newHeight;

          // If previous height was 'auto'
          // set starting height explicitly to be able to use transition
          newHeight = contentHeight;
        }

        // Animation classes
        var animationStateClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, height === 'auto' || nextProps.height < height), _defineProperty(_cx, this.animationStateClasses.animatingDown, nextProps.height === 'auto' || nextProps.height > height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));

        // Animation classes to be put after animation is complete
        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);

        // Set starting height and animating classes
        this.setState({
          animationStateClasses: animationStateClasses,
          height: newHeight,
          overflow: 'hidden',
          // When animating from 'auto' we first need to set fixed height
          // that change should be animated
          shouldUseTransitions: !isCurrentHeightAuto
        });

        // Clear timeouts
        clearTimeout(this.timeoutID);
        clearTimeout(this.animationClassesTimeoutID);

        if (isCurrentHeightAuto) {
          // When animating from 'auto' we use a short timeout to start animation
          // after setting fixed height above
          timeoutState.shouldUseTransitions = true;

          startAnimationHelper(function () {
            _this2.setState(timeoutState);

            // ANIMATION STARTS, run a callback if it exists
            _this2.runCallback(nextProps.onAnimationStart);
          });

          // Set static classes and remove transitions when animation ends
          this.animationClassesTimeoutID = setTimeout(function () {
            _this2.setState({
              animationStateClasses: timeoutAnimationStateClasses,
              shouldUseTransitions: false
            });

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(timeoutState.height);
            // Run a callback if it exists
            _this2.runCallback(nextProps.onAnimationEnd);
          }, nextProps.duration);
        } else {
          // ANIMATION STARTS, run a callback if it exists
          this.runCallback(nextProps.onAnimationStart);

          // Set end height, classes and remove transitions when animation is complete
          this.timeoutID = setTimeout(function () {
            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
            timeoutState.shouldUseTransitions = false;

            _this2.setState(timeoutState);

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(newHeight);
            // Run a callback if it exists
            _this2.runCallback(nextProps.onAnimationEnd);
          }, nextProps.duration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);
      this.timeoutID = null;
      this.animationClassesTimeoutID = null;
      this.animationStateClasses = null;
    }
  }, {
    key: 'isNumber',
    value: function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  }, {
    key: 'runCallback',
    value: function runCallback(callback) {
      if (callback && typeof callback === 'function') {
        callback();
      }
    }
  }, {
    key: 'showContent',
    value: function showContent() {
      if (this.state.height === 0) {
        this.contentElement.style.display = '';
      }
    }
  }, {
    key: 'hideContent',
    value: function hideContent(newHeight) {
      if (newHeight === 0) {
        this.contentElement.style.display = 'none';
      }
    }
  }, {
    key: 'getStaticStateClasses',
    value: function getStaticStateClasses(height) {
      var _cx2;

      return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses.static, true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _this3 = this;

      var _props = this.props,
          applyInlineTransitions = _props.applyInlineTransitions,
          children = _props.children,
          className = _props.className,
          contentClassName = _props.contentClassName,
          duration = _props.duration,
          easing = _props.easing,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          overflow = _state.overflow,
          animationStateClasses = _state.animationStateClasses,
          shouldUseTransitions = _state.shouldUseTransitions;

      // Include transition passed through styles

      var userTransition = style.transition ? style.transition + ',' : '';
      var transitionString = userTransition + ' height ' + duration + 'ms ' + easing + ' ';

      var componentStyle = _extends({}, style, {
        height: height,
        overflow: overflow || style.overflow
      });

      if (shouldUseTransitions && applyInlineTransitions) {
        componentStyle.WebkitTransition = transitionString;
        componentStyle.MozTransition = transitionString;
        componentStyle.OTransition = transitionString;
        componentStyle.msTransition = transitionString;
        componentStyle.transition = transitionString;
      }

      var componentClasses = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, className, className), _cx3));

      var propsToOmit = ['height', 'duration', 'easing', 'contentClassName', 'animationStateClasses', 'applyInlineTransitions'];

      return _react2.default.createElement(
        'div',
        _extends({}, omit.apply(undefined, [this.props].concat(propsToOmit)), {
          'aria-hidden': height === 0,
          className: componentClasses,
          style: componentStyle
        }),
        _react2.default.createElement(
          'div',
          {
            className: contentClassName,
            ref: function ref(el) {
              return _this3.contentElement = el;
            }
          },
          children
        )
      );
    }
  }]);

  return AnimateHeight;
}(_react2.default.Component);

AnimateHeight.propTypes = {
  animationStateClasses: _propTypes2.default.object,
  applyInlineTransitions: _propTypes2.default.bool,
  children: _propTypes2.default.any.isRequired,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  duration: _propTypes2.default.number.isRequired,
  easing: _propTypes2.default.string.isRequired,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onAnimationEnd: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  onAnimationStart: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  style: _propTypes2.default.object
};

AnimateHeight.defaultProps = {
  duration: 250,
  easing: 'ease',
  style: {},
  animationStateClasses: ANIMATION_STATE_CLASSES,
  applyInlineTransitions: true
};

exports.default = AnimateHeight;

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__title__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__preview__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__side_menu__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reprise_wizard__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_app_state__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import components.
var WizardContainer=function(_Component){_inherits(WizardContainer,_Component);function WizardContainer(props){_classCallCheck(this,WizardContainer);// TODO: recheck the aside class, when we have second step is always comes with creation product
var _this=_possibleConstructorReturn(this,(WizardContainer.__proto__||Object.getPrototypeOf(WizardContainer)).call(this,props));__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].callbacks.setupInitialCallbacks();__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].main(_this.props.match.params.name,_this.props.match.params.id?_this.props.match.params.id:'');return _this;}_createClass(WizardContainer,[{key:'componentWillMount',value:function componentWillMount(){if(__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].getState().contract.fullWidth){document.body.classList.add("full-wizard");}this.props.setWizardAppState();}},{key:'render',value:function render(){var _props=this.props,reprise_wizard=_props.reprise_wizard,contractName=_props.contractName,appState=_props.appState,fullWidth=_props.fullWidth;var reprise=reprise_wizard;var not_reprise=!reprise;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__title__["a" /* BigTitle */],{text:contractName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-container',id:'wizard-container'},reprise?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__reprise_wizard__["a" /* default */],null):"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-holder'},!reprise?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__main__["a" /* LpWizardMain */],{sectionId:parseInt(this.props.match.params.sectionId,10)})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),not_reprise&&!fullWidth&&(appState==0||appState==1||appState==3)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].isPayed?"forcing-aside":"aside"},__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].isPayed&&appState!=2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__side_menu__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].env.client_zone.width>=765&&(appState==0||appState==1||appState==3&&!this.props.wizard_loading)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__preview__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))));}}]);return WizardContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){return{reprise_wizard:state.contract.reprise_wizard,contractName:state.contract.name,appState:state.appstate,fullWidth:state.contract.fullWidth,wizard_loading:state.loading_details.wizard};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setWizardAppState:function setWizardAppState(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_9__redux_actions_app_state__["e" /* LP_STATE_WIZARD */]));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(WizardContainer)));

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _BigTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BigTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__save_button2__ = __webpack_require__(1112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\title.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var _BigTitle=function(_Component){_inherits(_BigTitle,_Component);function _BigTitle(props){_classCallCheck(this,_BigTitle);var _this=_possibleConstructorReturn(this,(_BigTitle.__proto__||Object.getPrototypeOf(_BigTitle)).call(this,props));if(typeof props.text==='undefined')props.text='';return _this;}_createClass(_BigTitle,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{ref:'title',className:'wizard-title',style:{display:this.props.app_state?'flex':'none',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.text),this.props.text!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__save_button2__["a" /* default */],null));}}]);return _BigTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{app_state:state.appstate===0||state.appstate===1||state.appstate===3||state.contract.reprise_wizard,reprise_wizard:state.contract.reprise_wizard};};var mapDispatchToProps=function mapDispatchToProps(){return{};};var BigTitle=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_BigTitle);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src/components/save_button2.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var _SaveButton=function(_Component){_inherits(_SaveButton,_Component);function _SaveButton(props){_classCallCheck(this,_SaveButton);var _this=_possibleConstructorReturn(this,(_SaveButton.__proto__||Object.getPrototypeOf(_SaveButton)).call(this,props));_this.saveButtonClicked=_this.saveButtonClicked.bind(_this);_this.closeButtonCallback=_this.closeButtonCallback.bind(_this);// here we launch the shit
// initFirebaseSystem(this.props.testAndLoadData)
_this.state={closed:false};return _this;}_createClass(_SaveButton,[{key:'closeButtonCallback',value:function closeButtonCallback(){this.setState({closed:!this.state.closed});}},{key:'saveButtonClicked',value:function saveButtonClicked(){if(this.props.contract_id===''){this.props.pass0(this.props.mail);}else{__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].ops.slack.sendContinueMessage('save update');this.props.pass0(this.props.mail,true);}}// we can make the input disabled in :
/**
     * = saved
     * = re-saved
     * = not-saved
     */},{key:'render',value:function render(){var stateDefault=this.props.contract_id==='';var stateSaved=!stateDefault&&!this.props.edited_doc;// and changed state
var stateError=typeof this.props.error!=='undefined';var height=this.state.closed?'auto':0;if(!this.props.is_mobile)height='auto';// console.log(this.props.is_checking)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:'pointer'},className:'doc-save btn-spinner'+(this.props.is_mobile?' wz-save-doc-mob visible-xs':' ')+(stateSaved?' done':'')+(stateError?' error':'')+(this.props.is_checking?' checking':''),onClick:stateSaved?function(){}:this.saveButtonClicked},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-save'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,stateDefault?Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Enregistrer et continuer plus tard'):stateSaved?__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('save_section_success_notif')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Votre document a été enregistré'):__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].references.customs.get('save_section_success_notif'):this.props.is_checking?Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Enregistrement en cours...'):Object(__WEBPACK_IMPORTED_MODULE_5__logic_wording__["a" /* _lp */])('Enregistrer et continuer plus tard')));}}]);return _SaveButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{mail:state.account_settings.mail,options:state.output.o,choices:state.output.c,variables:state.output.v,contractName:state.contract.name,currentSection:state.contract.currentSection,contract_id:state.document_state.unique,edited_doc:state.account_settings.edited_doc,error:state.errors.components['save-mail'],is_checking:state.loading_details.checking};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updateMail:function updateMail(mail){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["x" /* updateMailFromInput */])(mail));},pass0:function pass0(mail){var alreadySaved=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;// dispatch(buildQuery(mail, true))
if(alreadySaved){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["F" /* buildQuery */])(true));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_4__redux_actions_app_state__["d" /* LP_STATE_SAVE */]));}}};};var SaveButton=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_SaveButton);/* harmony default export */ __webpack_exports__["a"] = (SaveButton);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WizardMain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LpWizardMain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wizard_body__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_bar__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__option__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buy_mail_section__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions_contract__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logic_preview_render_condition_manager__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__buy_popover__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__misc_shimmer__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__save_component_section__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__logic_history__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__globals__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\main.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// initializing react env
// importing the whole components
// importing mthe creation of ne keys
//============================================================================
// import condition manager
// TODO: convert this into simple dumb component
/**
 * @description The main component, or the container of containers
 */var WizardMain=function(_Component){_inherits(WizardMain,_Component);_createClass(WizardMain,null,[{key:'hideMenu',value:function hideMenu(){// document.getElementsByClassName("wizard-dropdown")[0].classList.remove('active');
}}]);function WizardMain(props){_classCallCheck(this,WizardMain);var _this=_possibleConstructorReturn(this,(WizardMain.__proto__||Object.getPrototypeOf(WizardMain)).call(this,props));window.lp_o=_this.props.options;_this.shouldRedirect=false;_this.state={enters:false};return _this;}_createClass(WizardMain,[{key:'componentWillMount',value:function componentWillMount(){Object(__WEBPACK_IMPORTED_MODULE_11__logic_preview_render_condition_manager__["a" /* initializeEList */])();}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.options)__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].ops.initialization.initializeVariables(this.props.options);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){// console.log(nextProps.errors)
if(nextProps.full_preview!==this.props.full_preview){// remove unecessary rerender
return false;}return true;}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(!nextProps.wizard_loading){if(__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].fullWidth){document.body.classList.add('wizard-full');}}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.props.wizard_loading&&this.props.currentSection!==this.props.sectionId-1){if(this.props.sectionId&&this.props.sectionId>0&&this.props.sectionId<=this.props.max_sections){this.props.setSection(this.props.sectionId-1);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].fullWidth){document.body.classList.remove('wizard-full');}}// <LpPopOver />
},{key:'render',value:function render(){var sectionTitle=this.props.sectionTitle;// In case of Email section
if(this.props.app_state===1)sectionTitle=__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.get('email_section_title')=='NONE'?Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])(' Adresse e-mail où votre document doit être envoyé'):__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.get('email_section_title');// Save section
if(this.props.app_state===3)sectionTitle=__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.get('save_section_title')=='NONE'?Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])('Sauvegardez vos réponses'):__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.get('save_section_title');if(this.props.app_state===3&&this.props.document_id!=='')sectionTitle="Sauvegarde effectuée !";// The dispatch of information starts here
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__progress__["a" /* LpProgressBar */],{pp:''}),this.props.wizard_loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__misc_shimmer__["c" /* TitleShimmer */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'wz-menu',className:'wz-section-title',onMouseLeave:function onMouseLeave(){return WizardMain.hideMenu();}},this.props.app_state!==3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'wzd-count',style:{marginRight:'4px'}},this.props.app_state?Object(__WEBPACK_IMPORTED_MODULE_9__utils_misc__["d" /* localFormat */])(this.props.max_sections+1):Object(__WEBPACK_IMPORTED_MODULE_9__utils_misc__["d" /* localFormat */])(this.props.currentSection+1),'.'),sectionTitle))),this.props.app_state===1&&this.props.document_state===''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__buy_mail_section__["a" /* default */],null):this.props.app_state===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__save_component_section__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__wizard_body__["a" /* default */],{is_full:this.props.full_preview},this.props.wizard_loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__misc_shimmer__["b" /* ParagraphShimmer */],null):this.props.options?this.props.options.map(function(idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__option__["a" /* default */],{type:idx.type,label:idx.label,id:idx.id,key:Object(__WEBPACK_IMPORTED_MODULE_9__utils_misc__["b" /* generateId1 */])(4),lpKey:Object(__WEBPACK_IMPORTED_MODULE_9__utils_misc__["b" /* generateId1 */])(4),name:'',awlad:'option_renderer'in idx?idx.option_renderer:[],variables:idx.variable_renderer,ovc:'o',is_multiple:idx.multiple,isDuplicate:false,copy:-2,parent:-2});}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__control_bar__["a" /* default */],{is_full:this.props.full_preview})),__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].env.client_zone.width>=765?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modal__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),this.props.popover_state&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'real-popover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__buy_popover__["a" /* default */],null),' '));}}]);return WizardMain;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var sTitle='No section presented';var sSection=null;if('section'in state.contract){sTitle=state.contract.section.label;sSection=state.contract.section.options_render;}return{empty:state.empty,contractTitle:state.contract.name,sectionTitle:sTitle,options:sSection,actual_screen:state.appstate,currentSection:state.contract.currentSection,isFinished:state.contract.isFinished,full_preview:state.preview,app_state:state.appstate,popover_state:state.popover,wizard_loading:state.loading_details.wizard,max_sections:Object.keys(state.contract.sections).length,errors:state.errors,show_contact:state.account_settings.show_contact,document_state:state.document_state.unique,current_document_state:state.document_state.state,can_render:__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].mutex.checkMutex('preview'),sure:__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].action_tracker.last_action==='ADD_MULTIPLE',document_id:state.document_state.unique,show_login_modal:state.account_settings.show_login_modal,show_singup_modal:state.account_settings.show_singup_modal};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setSection:function setSection(id,isaNav){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__redux_actions_contract__["j" /* setSection */])(id,isaNav));// dispatch(redirectToSection(id));
},prepareData:function prepareData(id){dispatch(__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].ops.initialization.raNextInit(id));},redirectToSection:function redirectToSection(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__redux_actions_contract__["e" /* redirectToSection */])(id));}};};var LpWizardMain=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(WizardMain);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProgressBar */
/* unused harmony export TLpProgressBar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LpProgressBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\progress.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// this component shows the progression of filling the contract
// this one gets the level one object length
/**
 * Object a = {
 *  b: 1,
 *  c: 4
 * }
 * 
 * The length of first level is 2
 */// TODO: to refactor the component
var ProgressBar=function(_Component){_inherits(ProgressBar,_Component);function ProgressBar(props){_classCallCheck(this,ProgressBar);// set initial progress
var _this=_possibleConstructorReturn(this,(ProgressBar.__proto__||Object.getPrototypeOf(ProgressBar)).call(this,props));_this.params=new Object();_this.params=Object.assign({},props);if(typeof _this.params.progress=='undefined')_this.params.progress=0;// put the params
_this.params.progress*=100;// this one contains (progress, total) tuples
_this.changes_history=[];return _this;}// Progress UX operations
// checkProgressChange(new_sections){
//     return (new_sections == this.props.progress)
// }
// pushChange(a, p, t){
//     this.changes_history.push({
//         actual: a,
//         progress: p,
//         total: t
//     });
// }
// isEmptyHistory(){
//     return this.changes_history.length == 0;
// }
// popChange(){
//     return this.changes_history.pop();
// }
_createClass(ProgressBar,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].action_tracker.last_action=='SET_SECTION_ID')return true;return false;}// TODO: check if it's harmful to ommit the params variable, and ommit it
},{key:'componentWillMount',value:function componentWillMount(){this.params.progress=this.props.progress;this.params.progress_len=this.props.total_progress;}},{key:'componentDidMount',value:function componentDidMount(){this.params.progress=this.props.progress;this.params.progress_len=this.props.total_progress;}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){}},{key:'render',value:function render(){// TODO: move the calculation to pre-update phase
var s_=0;s_=this.props.progress/this.props.total_progress;s_*=100;// this.pushChange(s_, this.props.total_progress)
if(s_.toString()=="NaN")s_=0;var s={width:s_+'%'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"progress-bar in "+(s_>=10?" in":""),role:'progressbar','aria-valuenow':'60','aria-valuemin':'0','aria-valuemax':'100',style:s},Math.round(s_)+"%"));}}]);return ProgressBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var style_={marginLeft:"10px",marginRight:"10px"//     <div className="progress-index white-text text-lighten-1" > 
//     { Math.round( s_ ) } 
// </div> 
// FIXME: delete this component, it's useless
};var TLpProgressBar=function TLpProgressBar(props){var s_=props.progress/props.total_progress;s_*=100;var s={width:s_+'%'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"pink lighten-4 progress-bar"+s_<=10?" in":"",style:style_},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-full pink lighten-2',style:s},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-index white-text text-lighten-1'},Math.round(s_))));};// getting the progress information and put them into the component
var mapStateToProps=function mapStateToProps(state){window.tmp_0=state.contract.sections;var total_progress=Object.keys(__WEBPACK_IMPORTED_MODULE_3__app_lp_app__["a" /* default */].indexes.real_sections.sections).length;// let actual_change = state.contract.currentSection
return{progress:state.contract.currentSection,total_progress:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["e" /* objectLength */])(state.contract.sections),total_sections:total_progress};};// FIXME: rewrite the mapDispatchToProps
var LpProgressBar=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,function(dispatch){return{};})(ProgressBar);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\wizard_body.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var _WizardBody=function(_Component){_inherits(_WizardBody,_Component);function _WizardBody(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_WizardBody);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_WizardBody.__proto__||Object.getPrototypeOf(_WizardBody)).call.apply(_ref,[this].concat(args))),_this),_this.handleKeyPress=function(event){if(event.key==='Enter'){//Isolate the node that we're after
var currentNode=event.target;// If current focused element is a textarea we should ignore the enter event
if(currentNode.type==="textarea")return;event.preventDefault();var wizard_content=document.querySelector('.wizard-content');//find all tab-able elements
var allElements=wizard_content.querySelectorAll('.input-field .form-group input, .input-field .form-group select, .input-field .form-group textarea');//Find the current tab index.
var currentIndex=[].concat(_toConsumableArray(allElements)).findIndex(function(el){return currentNode.isEqualNode(el);});//focus the following element or click next if last
if(currentIndex+1<allElements.length){allElements[currentIndex+1].focus();}else{// should click next btn
}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_WizardBody,[{key:'componentDidMount',// WOW
// shouldComponentUpdate(newProps, newState){
//     if(newProps.currentSection != this.props.currentSection)
//         return true;
//     else
//         return false;
// }
value:function componentDidMount(){var wizardObserver=new MutationObserver(function(m){function getElHeight(el){if(el){var positionInfo=el.offsetHeight;return positionInfo;}return'0';}var wizard=document.querySelector('.wizard');var asideList=document.querySelector('.forcing-summary ul');if(asideList){asideList.style.height=(wizard?getElHeight(wizard):'0')+'px';}});wizardObserver.observe(document.querySelector('.wizard-content'),{childList:true,subtree:true});}},{key:'componentWillUpdate',value:function componentWillUpdate(){// console.log("%cstart section", "color: red");
// window.section_transition = true;
}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.props.mazel&&(this.props.doc_state==='continue'||window.autosave)){if(typeof window.lp[this.props.currentSection]!=='undefined'&&!window.lp[this.props.currentSection]&&(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].continuity&&__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].continuity.continue!=''||window.autosave)){// console.time("initialization");
// _initializeOptions1(this.props.options, false);
__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.initialization.intiialize(this.props.options,false);// console.timeEnd("initialization");
// this.props._initOne(this.props.currentSection-1);
window.lp[this.props.currentSection]=true;// console.log("inited")
}}// console.log("%cfinish section", "color: red")
// window.section_transition = false;
__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].mutex.setMutex('preview',true);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'wizard-content'+(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].isPayed&&!__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.two_steps.isDiscovered(this.props.currentSection,'section')?' highlight-second':''),onKeyPress:this.handleKeyPress},this.props.mandatory_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-output'},'Veuillez remplir tous les champs obligatoires'),this.props.children);}}]);return _WizardBody;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){if(state.loading_details.wizard){return{mazel:true};}return{mazel:false,currentSection:state.contract.currentSection,doc_state:state.document_state.state,options:state.contract.section.option_ids,mail:state.account_settings.mail,mandatory_error:state.errors.components.mandatory};};var WizardBody=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(_WizardBody);/* harmony default export */ __webpack_exports__["a"] = (WizardBody);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validator__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_contract__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_error__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logic_default_values__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logic_utils_history__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_hardcoded_checkout__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tracking_lpevents__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\control_bar.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// TODO: Add test if am on the first and last page.
var _ControlBar=function(_Component){_inherits(_ControlBar,_Component);function _ControlBar(props){_classCallCheck(this,_ControlBar);var _this=_possibleConstructorReturn(this,(_ControlBar.__proto__||Object.getPrototypeOf(_ControlBar)).call(this,props));_this.nextCallback=_this.nextCallback.bind(_this);_this.previousCallback=_this.previousCallback.bind(_this);_this.onHoverControlBarScrolling=_this.onHoverControlBarScrolling.bind(_this);_this.clickNumber=0;_this.state={isLoading:false};return _this;}_createClass(_ControlBar,[{key:'onHoverControlBarScrolling',value:function onHoverControlBarScrolling(){if(window.scrollingTracker){this.hoverTime=new Date().getTime();var wizardCoord=document.querySelector('.wizard-navbar').getBoundingClientRect();var controlBarCoord=document.querySelector('.wizard').getBoundingClientRect();var remainingSpace=200;this.remainingBottomSpace=controlBarCoord.bottom-wizardCoord.bottom-1;if(this.remainingBottomSpace>=remainingSpace){this.scrollAnimation=Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["g" /* scrollTo */])(document.documentElement,window.scrollY+remainingSpace,500);}else{this.scrollAnimation=Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["g" /* scrollTo */])(document.documentElement,window.scrollY+this.remainingBottomSpace,500);}}return null;}},{key:'nextCallback',value:function nextCallback(){this.clickTime=new Date().getTime();var remainingTime=this.clickTime-this.hoverTime;// Raising click number
this.clickNumber+=1;if(remainingTime<1000&&this.remainingBottomSpace>150&&this.clickNumber<3)return;// Setting default values for previous sections
__WEBPACK_IMPORTED_MODULE_11__logic_default_values__["a" /* default */].setDefaults();// Updating sections with default values
this.props.updateSections();// Stopping animation and reseting click number
if(this.scrollAnimation)this.scrollAnimation.stop();this.clickNumber=0;if(this.props.app_state_save){if(__WEBPACK_IMPORTED_MODULE_2_validator__["isEmail"](this.props.mail)||this.props.document_unique!==''){this.props.unreaiseError();// saveMail(this.props.mail);
this.props.pass0(this.props.mail,true);__WEBPACK_IMPORTED_MODULE_14__tracking_lpevents__["a" /* default */].trackGTMGAEvent('Contrat sauvegarde','Formulaire valide',this.props.contractTitle);}else{this.props.raiseError();}return;}// || this.props.currentSection == (this.props.max_sections - 1)
if(this.props.app_state_mail){// console.log("here is mail")
if(__WEBPACK_IMPORTED_MODULE_2_validator__["isEmail"](this.props.mail)||this.props.document_unique!==''){this.setState({isLoading:true});this.props.unreaiseError();// saveMail(this.props.mail);
this.props.pass0(this.props.mail);this.props.setIsFinished_(true);__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.contacts.registerMail(this.props.mail);__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.slack.sendCustomeSlack();__WEBPACK_IMPORTED_MODULE_14__tracking_lpevents__["a" /* default */].trackGTMGAEvent('Inscription email','Clic','Funnel Contrat standard');//lpApp.ops.contacts.saveHubSpot();
// debugger;
// this.props.goDownload();
}else{this.props.raiseError();}// TODO: raise the errors.
}else{if(this.props.document_unique!==''){if(this.props.currentSection===this.props.max_sections-1&&this.props.max_sections>1){// TODO: (Moncef) I added the "or true" condition
// in order to avoid the bugs caused in DEV-902 to block Mehdi from testing
// Please, fix asap
if(__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].isPayed){__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.slack.generateSendinBlue('Reached Post Payment');__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.slack.generateMixpanel('Reached Post Payment');}if(__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.mandatory.globalCheckOptions()&&__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.mandatory.globalCheckVariables()||!__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].isPayed||true){__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.slack.sendContinueMessage('Validate');__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.slack.sendCustomeSlack();this.props.pass0(this.props.mail,false);}return;}this.props.goForward();return;}if(this.props.currentSection===this.props.max_sections-1&&this.props.max_sections>1){__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.slack.sendContinueMessage();this.props.goCheckout();return;}this.props.goForward();}}},{key:'previousCallback',value:function previousCallback(){// Stopping animation and reseting click number
if(this.scrollAnimation){this.scrollAnimation.stop();}this.clickNumber=0;if(this.props.app_state_mail){if(__WEBPACK_IMPORTED_MODULE_2_validator__["isEmail"](this.props.mail)){this.props.resetMail();this.props.goWizard();}else{this.props.resetMail();this.props.goWizard();}}else if(this.props.currentSection>0){this.props.goBackward();}}},{key:'render',value:function render(){var _this2=this;var validate=__WEBPACK_IMPORTED_MODULE_13__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].contractMetaId)>-1?'validate':'email-download';var checkmark=__WEBPACK_IMPORTED_MODULE_13__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].contractMetaId)>-1?'checkmark':'file-download';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-navbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-navbar-inner'},!this.props.app_state_save?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-back new-btn-nav-wizard',style:!this.props.app_state_mail&&this.props.currentSection===0?{color:'grey',opacity:'0'}:{},onClick:this.previousCallback},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-arrow-left'}),Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('Précédent')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-back new-btn-nav-wizard',onClick:function onClick(){_this2.props.resetMail();_this2.props.goWizard();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-arrow-left'}),Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('Revenir '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hidden-xs'},Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('au questionnaire'))),!(this.props.app_state_save&&this.props.document_unique!=='')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:(this.props.app_state_mail||this.props.document_unique!==''&&this.props.currentSection>=this.props.max_sections-1?'btn btn-'+validate:'btn btn-next')+' on'+(this.props.pricing_loading||this.props.checkout_loading?' checking':''),onClick:this.nextCallback},this.props.app_state_mail||this.props.document_unique!==''&&this.props.currentSection>=this.props.max_sections-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.props.mail_icon?'material-icons':'icn-'+checkmark},this.props.mail_icon&&this.props.mail_icon!=='none'?this.props.mail_icon:''):this.props.app_state_save?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-save'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'loading-spin'}),this.props.app_state_mail||this.props.document_unique!==''&&this.props.currentSection>=this.props.max_sections-1?__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.customs.get('email_section_cta')==='NONE'?__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.customs.get('duplicate_cta_email')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('Télécharger'):__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.customs.get('duplicate_cta_email'):__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.customs.get('email_section_cta'):this.props.app_state_save?Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('Sauvegarder'):Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('Suivant'),this.props.app_state_mail||this.props.app_state_save||this.props.document_unique!==''&&this.props.currentSection>=this.props.max_sections-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-arrow-right'})),!this.props.app_state_mail&&!this.props.app_state_save&&(this.props.currentSection<this.props.max_sections-1||this.props.document_unique!==''&&this.props.currentSection<this.props.max_sections-1)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-skip hidden-xs new-btn-nav-wizard',onClick:this.nextCallback},Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])('Passer')))));}}]);return _ControlBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{mail_icon:__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].references.customs.custom.email_section_cta_icon,currentSection:state.contract.currentSection,total_sections:state.contract.total_sections,app_state_mail:state.appstate===1,app_state_save:state.appstate===3,mail:state.account_settings.mail,contractTitle:state.contract.name,max_sections:Object.keys(state.contract.sections).length,document_unique:state.document_state.unique,pricing_loading:state.loading_details.checking,checkout_loading:state.loading_details.pricing};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{dispatchGoDownload:function dispatchGoDownload(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__["b" /* LP_STATE_PAYMENT */]));},setIsFinished_:function setIsFinished_(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_contract__["g" /* setIsFinished */])(value));},dispatchGoWizard:function dispatchGoWizard(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__["e" /* LP_STATE_WIZARD */]));},dispatchGoForward:function dispatchGoForward(id){// check
__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].mutex.setMutex('preview',false);dispatch(__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.initialization.raNextInit(id-1));__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].mutex.setMutex('preview',true);dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_contract__["e" /* redirectToSection */])(id));//dispatch(setSection(id));
//------------------------------
// flush options
//------------------------------
},dispatchGoBackward:function dispatchGoBackward(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_contract__["e" /* redirectToSection */])(id));//dispatch(setSection(id));
//------------------------------
// flush options
//------------------------------
},dispatchGoCheckout:function dispatchGoCheckout(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_3__redux_actions_app_state__["a" /* LP_STATE_CHECKOUT */]));Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["f" /* scrollAndGoUp */])();},pass0:function pass0(mail){var save_=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_checkout_operations__["F" /* buildQuery */])(save_));Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["f" /* scrollAndGoUp */])();},dispatchRaiseError:function dispatchRaiseError(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_error__["c" /* raiseMailError */])());},dispatchUnraiseError:function dispatchUnraiseError(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_error__["d" /* unraiseMailErrors */])());},resetMail:function resetMail(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_account_settings__["x" /* updateMailFromInput */])(''));},autoSave:function autoSave(){// console.log("auto")
dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_actions_checkout_operations__["F" /* buildQuery */])(true,true));},dispatchUpdateSection:function dispatchUpdateSection(){dispatch({type:'UPDATE_SECTIONS_C'});}};};var mergeProps=function mergeProps(stateProps,dispatchProps){return{mail_icon:stateProps.mail_icon,document_unique:stateProps.document_unique,mail:stateProps.mail,app_state_mail:stateProps.app_state_mail,app_state_save:stateProps.app_state_save,contractTitle:stateProps.contractTitle,currentSection:stateProps.currentSection,max_sections:stateProps.max_sections,pricing_loading:stateProps.pricing_loading,checkout_loading:stateProps.checkout_loading,goForward:function goForward(){// console.log("I am in " + stateProps.currentSection);
if(stateProps.max_sections===stateProps.currentSection+1&&stateProps.max_sections>=1){dispatchProps.dispatchGoCheckout();Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["f" /* scrollAndGoUp */])();}else{dispatchProps.dispatchGoForward(stateProps.currentSection+1);}if(window.lpMax<=stateProps.currentSection+1){window.lpMax=stateProps.currentSection+1;}Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["f" /* scrollAndGoUp */])();},goBackward:function goBackward(){if(stateProps.currentSection!==0){dispatchProps.dispatchGoBackward(stateProps.currentSection-1);Object(__WEBPACK_IMPORTED_MODULE_4__utils_misc__["f" /* scrollAndGoUp */])();}},goDownload:dispatchProps.dispatchGoDownload,goWizard:dispatchProps.dispatchGoWizard,pass0:dispatchProps.pass0,setIsFinished_:dispatchProps.setIsFinished_,raiseError:dispatchProps.dispatchRaiseError,unreaiseError:dispatchProps.dispatchUnraiseError,updateSections:dispatchProps.dispatchUpdateSection,resetMail:dispatchProps.resetMail,goCheckout:dispatchProps.dispatchGoCheckout,autoSave:dispatchProps.autoSave};};var ControlBar=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(_ControlBar);/* harmony default export */ __webpack_exports__["a"] = (ControlBar);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _OptionContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptionContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__option__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__variable__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logic_utils_tree_operations__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src/components/option_container.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */// the flat import
var _OptionContainer=function(_Component){_inherits(_OptionContainer,_Component);function _OptionContainer(props){_classCallCheck(this,_OptionContainer);// initializing parameters
var _this=_possibleConstructorReturn(this,(_OptionContainer.__proto__||Object.getPrototypeOf(_OptionContainer)).call(this,props));_this.params=Object.assign({lpKey:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),// initialized by orgin
parent:'XXXX',variables:[],children:[],is_active:false},props);_this.params.children=Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["a" /* filterComponents */])(_this.params.id);// console.log(this.params.children)
// The creation must behere
// test if it's a multiple with is_copy
return _this;}_createClass(_OptionContainer,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.isDuplicate){this.props.initializeFlat(Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),this.props.parent,'oc',this.props.sectionId,-2,this.props.lpParent);}else this.props.initializeFlat(this.props.lpKey,this.props.parent,'oc',this.props.sectionId,-2,this.props.lpParent);}// PS. the option container contains his own lpKey, lpParent, id of the parent ,
},{key:'render',value:function render(){var _this2=this;// TODO: put the pre-render in their place
var emptyChildren=typeof this.params.children==='undefined'||this.params.children.length===0;// console.log(checkIfAllFalse(this.props.id.length ? this.props.id: []), this.props.id);
return!emptyChildren&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:this.params.id+'_',className:'wzog-vars wz-multiple'},typeof this.props.children!=='undefined'?this.params.children.map(function(idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__option__["a" /* default */],{key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),lpKey:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),lpParent:_this2.params.lpParent,id:idx.length?idx:__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.getOption(idx).meta.id,parent:_this2.props.id,type:idx.length?'RADIOS':__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.getOption(idx).meta.type,label:idx.length?'':__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.getOption(idx).meta.label,variables:idx.length?[]:__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.getOption(idx).variables.map(function(index){return __WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.getVariable(index);}),awlad:idx.length?[]:__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.getOption(idx).children.map(function(index){return __WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.getOption(index).meta;}),is_multiple:false,isDuplicate:_this2.props.isDuplicate,copy:_this2.props.copy});},this):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),this.props.visibility?this.params.variables.map(function(idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__variable__["a" /* default */],{lpKey:_this2.props.lpKey,lpParent:_this2.props.lpParent,id:idx.id,parent:_this2.props.id,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(2),label:idx.label,type:idx.type,is_multiple:_this2.props.is_multiple,isDuplicate:_this2.props.isDuplicate,copy:_this2.props.copy});},this):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));}}]);return _OptionContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// integrate onto the FLAT_UI system
var mapStateToProps=function mapStateToProps(state,ownProps){return{sectionId:state.contract.currentSection,push_left:Object(__WEBPACK_IMPORTED_MODULE_6__logic_utils_tree_operations__["a" /* checkIfAllFalse */])(ownProps.id.length?ownProps.id:[])};};var mapDispatchToProps=function mapDispatchToProps(){return{// eslint-disable-next-line
initializeFlat:function initializeFlat(uiid,id,genre,sectionId,parentId,parentLp){}};};var OptionContainer=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_OptionContainer);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initializeLogger */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firedFlat; });
/* unused harmony export firedOption */
/* unused harmony export firedVariable */
/*
* Project: LegalPlace assistant
* File: src/middlewares/logging.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/function initializeLogger(){window.lpFlat_loops=0;window.lpOption_loop=0;window.lpVariable_loop=0;}function firedFlat(){window.lpFlat_loops+=1;}function firedOption(){window.lpOption_loop+=1;}function firedVariable(){window.lpVariable_loop+=1;}

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__popup_preview__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_evaluate_operation__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\misc\text.js
 * Author: Azizi Amine
 * Version: 1.0
 */// init the react environment
// generate keys functions
// update the redux system
// turbo 0
// onfocus and onblur
// inputs: placeholder, id, label, helper (if it exists)
var EvalField=function(_Component){_inherits(EvalField,_Component);function EvalField(props){_classCallCheck(this,EvalField);// register the variable/option
// bind the events here
var _this=_possibleConstructorReturn(this,(EvalField.__proto__||Object.getPrototypeOf(EvalField)).call(this,props));_this.params=Object.assign({},props);_this.lpKey=Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4);_this.changeValue=_this.changeValue.bind(_this);_this.onValueChanged=_this.onValueChanged.bind(_this);_this.onFocus=_this.onFocus.bind(_this);_this.onBlur=_this.onBlur.bind(_this);if(props.isDuplicate){_this.params.id=_this.params.id+'_'+props.copy;}return _this;}// TODO: work on dispathcing things upside down, multiple, duplicate ....
// before putting the shit into the dom
_createClass(EvalField,[{key:'componentWillMount',value:function componentWillMount(){// console.time("text_" + this.props.id);
// TODO: check the duplication in the fucking existant UI component
if(!this.props.exists){this.props.initializeOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.lpKey,this.props.ovc,'');}else{this.params.label=__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getOption(this.props.id);}// console.timeEnd("text_" + this.props.id);
// console.log(this.props.result)
// FIXME:
__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].indexes.variables.variables[this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id].value=this.props.value;}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){// console.log(nextProps.value);
this.changeValue(nextProps.value);}},{key:'componentDidMount',value:function componentDidMount(){this.props.updateVariable();}},{key:'onValueChanged',value:function onValueChanged(){}},{key:'onFocus',value:function onFocus(){this.props.updateContext();}},{key:'onBlur',value:function onBlur(){this.props.unUpdateContext();}},{key:'changeValue',value:function changeValue(value){console.log('VALUE',value);this.props.changeValue(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,value);}},{key:'render',value:function render(){var opt=__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id);// console.log(this.props.result)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group','data-type':'text-input','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'text_'+this.props.lpKey},this.props.label,' ','helper'in opt&&__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper})),this.props.id in __WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.variables&&__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning,id:this.props.id,type:'v'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'g1',placeholder:__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id)&&__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).placeholder?__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(this.props.id).placeholder:'',id:'text_'+this.props.lpKey,value:this.props.result,onBlur:this.onBlur,onFocus:this.onFocus,className:'form-control',disabled:true})));}}]);return EvalField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){// test if exists
var exists=false;var existantKey='';var existantParent='';var realId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(realId).key;}}if(ownProps.ovc==='v'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(realId).key;}}var result=Object(__WEBPACK_IMPORTED_MODULE_7__logic_evaluate_operation__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(ownProps.id).evaluation,__WEBPACK_IMPORTED_MODULE_12__app_lp_app__["a" /* default */].references.getVariable(ownProps.id),realId);var value=''+result;return{sectionId:state.contract.currentSection,exists:exists,existantKey:existantKey,existantParent:existantParent,value:value,result:result};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// this case, parent = key
initializeOutput:function initializeOutput(id,parent,genre){var value=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(id,parent,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(id,parent,value));},editOutput:function editOutput(id,val){if(ownProps.ovc==='o'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["k" /* editOption */])(id,val));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["l" /* editVariable */])(id,val));}if(!Object(__WEBPACK_IMPORTED_MODULE_10__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["o" /* editedDocument */])(true));},changeValue:function changeValue(id,value){// let c_id = !isDuplicate ? id : id + '_' + copy;
// let c_pid = !isDuplicate ? parent : parent + '_' + copy;
dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["l" /* editVariable */])(id,value));if(!Object(__WEBPACK_IMPORTED_MODULE_10__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["o" /* editedDocument */])(true));},updateContext:function updateContext(){var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;var pId=ownProps.isDuplicate?ownProps.parent+'_'+ownProps.copy:ownProps.parent;if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(cId));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["d" /* icSetVariable */])(cId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(pId));}},unUpdateContext:function unUpdateContext(){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(''));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["d" /* icSetVariable */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(''));}}};};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){return Object.assign({sectionId:stateProps.sectionId,exists:stateProps.exists,existant_key:stateProps.existant_key,existant_parent:stateProps.existant_parent,value:stateProps.value,result:stateProps.result,initializeOutput:dispatchProps.initializeOutput,editOutput:dispatchProps.editOutput,changeValue:dispatchProps.changeValue,updateContext:dispatchProps.updateContext,unUpdateContext:dispatchProps.unUpdateContext,updateVariable:function updateVariable(){// console.log(stateProps.result)
dispatchProps.editOutput(ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id,stateProps.value);}},ownProps);};var LpEval=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(EvalField);/* harmony default export */ __webpack_exports__["a"] = (LpEval);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = evaluateOperation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_lp_app__ = __webpack_require__(2);
function evaluateOperation(operation,variable,id){var varREGEX=/\[var:([0-9]+)\]/gi;var getVarValue=function getVarValue(variableId){var value=0;var variableFromId=void 0;// If is multiple
if(/^([0-9]+)_(.*)$/.test(id)){var suffix=id.split('_')[1];if(__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.variables.variables.hasOwnProperty(variableId+'_'+suffix)){variableFromId=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.variables.getVariable(variableId+'_'+suffix);}else{variableFromId=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.variables.getVariable(variableId);}}else{variableFromId=__WEBPACK_IMPORTED_MODULE_0__app_lp_app__["a" /* default */].indexes.variables.getVariable(variableId);}if(variableFromId){value=variableFromId.value;if(typeof value==='string')value=value.replace(',','.');value=parseFloat(value);}return value;};var cleanedOperation=operation.replace(varREGEX,function(a,b){// var value = _this.variables_wrapper[b].value;
// Checking if B is a cibling
var value=getVarValue(b);return Number.isNaN(value)?0:value;});var result=0;try{result=eval(cleanedOperation);if(result===Infinity)result=0;}catch(exception_var_1){result=0;}if(Number.isNaN(result)){result=0;}// Decimal
var decimals=variable.eval_decimal?parseInt(variable.eval_decimal,10):2;var round=variable.round?parseInt(variable.round,10):0;var decma=1;for(var i=0;i<decimals;i+=1){decma*=10;}// Round
switch(round){case 0:result=Math.round(result*decma)/decma;break;case 1:result=Math.ceil(result*decma)/decma;break;case 2:result=Math.floor(result*decma)/decma;break;}// console.log("The result is:" + result);
return result;}

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__popup_preview__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src\components\misc\text.js
 * Author: Azizi Amine
 * Version: 1.0
 */// init the react environment
// generate keys functions
// update the redux system
//
// turbo 0
// onfocus and onblur
// inputs: placeholder, id, label, helper (if it exists)
var NumberField=function(_Component){_inherits(NumberField,_Component);function NumberField(props){_classCallCheck(this,NumberField);// register the variable/option
// bind the events here
var _this=_possibleConstructorReturn(this,(NumberField.__proto__||Object.getPrototypeOf(NumberField)).call(this,props));_this.params=Object.assign({},props);_this.lpKey=Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4);_this.onValueChanged=_this.onValueChanged.bind(_this);_this.onFocus=_this.onFocus.bind(_this);_this.onBlur=_this.onBlur.bind(_this);if(props.isDuplicate){_this.params.id=_this.params.id+'_'+props.copy;}return _this;}// TODO: work on dispathcing things upside down, multiple, duplicate ....
// before putting the shit into the dom
_createClass(NumberField,[{key:'componentWillMount',value:function componentWillMount(){// console.time("text_" + this.props.id);
// TODO: check the duplication in the fucking existant UI component
if(!this.props.exists){this.props.initializeOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.lpKey,this.props.ovc,__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].indexes.variables.getVariable(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id).value);}else{this.params.label=__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getOption(this.props.id);}// console.timeEnd("text_" + this.props.id);
}},{key:'componentDidUpdate',value:function componentDidUpdate(){}},{key:'onValueChanged',value:function onValueChanged(val){this.props.editOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.params.id,val);}},{key:'onFocus',value:function onFocus(){this.props.updateContext();}},{key:'onBlur',value:function onBlur(){this.props.unUpdateContext();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group','data-type':'text-input','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'text_'+this.props.lpKey},this.props.label,' ','helper'in __WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id)&&__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper})),this.props.id in __WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.variables&&__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning,id:this.props.id,type:'v'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',name:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(1),placeholder:__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id)&&__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).placeholder?__WEBPACK_IMPORTED_MODULE_11__app_lp_app__["a" /* default */].references.getVariable(this.props.id).placeholder:'',id:'text_'+this.props.lpKey,value:this.props.value,onChange:function onChange(evt){return _this2.onValueChanged(evt.target.value);},onBlur:this.onBlur,onFocus:this.onFocus,className:'form-control'})));}}]);return NumberField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){// test if exists
var exists=false;var existantKey='';var existantParent='';var value='';var realId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["g" /* lpGetOptionById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["g" /* lpGetOptionById */])(realId).key;var _lpGetOptionById=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["g" /* lpGetOptionById */])(realId);value=_lpGetOptionById.value;}}if(ownProps.ovc==='v'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(realId).key;var _lpGetVariableById=Object(__WEBPACK_IMPORTED_MODULE_7__logic_re_index__["h" /* lpGetVariableById */])(realId);value=_lpGetVariableById.value;}}return{sectionId:state.contract.currentSection,exists:exists,existantKey:existantKey,existantParent:existantParent,value:value};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// this case, parent = key
initializeOutput:function initializeOutput(id,parent,genre){var value=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["m" /* initOutputOption */])(id,parent,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["n" /* initOutputVariable */])(id,parent,value));},editOutput:function editOutput(id,val){if(ownProps.ovc==='o'){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["k" /* editOption */])(id,val));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_output__["l" /* editVariable */])(id,val));}if(!Object(__WEBPACK_IMPORTED_MODULE_9__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_account_settings__["o" /* editedDocument */])(true));},updateContext:function updateContext(){var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;var pId=ownProps.isDuplicate?ownProps.parent+'_'+ownProps.copy:ownProps.parent;if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(cId));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["d" /* icSetVariable */])(cId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(pId));}},unUpdateContext:function unUpdateContext(){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(''));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["d" /* icSetVariable */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_input_context__["c" /* icSetOption */])(''));}}};};var LpNumber=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(NumberField);/* harmony default export */ __webpack_exports__["a"] = (LpNumber);

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

/*
* Project: LegalPlace assistant
* File: src/components/utils/input_mask.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var ESCAPE_CHAR='\\';var DIGIT_RE=/^\d$/;var LETTER_RE=/^[A-Za-z]$/;var ALPHANNUMERIC_RE=/^[\dA-Za-z]$/;var DEFAULT_PLACEHOLDER_CHAR=' ';var DEFAULT_FORMAT_CHARACTERS={'*':{validate:function validate(char){return ALPHANNUMERIC_RE.test(char);}},'!':{validate:function validate(char){return DIGIT_RE.test(char);}},'?':{validate:function validate(char){return LETTER_RE.test(char);}},A:{validate:function validate(char){return LETTER_RE.test(char);},transform:function transform(char){return char.toUpperCase();}},'#':{validate:function validate(char){return ALPHANNUMERIC_RE.test(char);},transform:function transform(char){return char.toUpperCase();}}};function extend(dest,src){var extendedDest=dest;if(src){var props=Object.keys(src);for(var i=0,l=props.length;i<l;i+=1){extendedDest[props[i]]=src[props[i]];}}return extendedDest;}function copy(obj){return extend({},obj);}/**
 * Merge an object defining format characters into the defaults.
 * Passing null/undefined for en existing format character removes it.
 * Passing a definition for an existing format character overrides it.
 * @param {?Object} formatCharacters.
 */function mergeFormatCharacters(formatCharacters){var merged=copy(DEFAULT_FORMAT_CHARACTERS);if(formatCharacters){var chars=Object.keys(formatCharacters);for(var i=0,l=chars.length;i<l;i+=1){var char=chars[i];if(formatCharacters[char]===null){delete merged[char];}else{merged[char]=formatCharacters[char];}}}return merged;}/**
 * @param {string} source
 * @param {?Object} formatCharacters
 * @param placeholderChar
 * @param isRevealingMask
 * @returns {Pattern}
 * @constructor
 */function Pattern(source,formatCharacters,placeholderChar,isRevealingMask){if(!(this instanceof Pattern)){return new Pattern(source,formatCharacters,placeholderChar);}/** Placeholder character */this.placeholderChar=placeholderChar||DEFAULT_PLACEHOLDER_CHAR;/** Format character definitions. */this.formatCharacters=formatCharacters||DEFAULT_FORMAT_CHARACTERS;/** Pattern definition string with escape characters. */this.source=source;/** Pattern characters after escape characters have been processed. */this.pattern=[];/** Length of the pattern after escape characters have been processed. */this.length=0;/** Index of the first editable character. */this.firstEditableIndex=null;/** Index of the last editable character. */this.lastEditableIndex=null;/** Lookup for indices of editable characters in the pattern. */this.editableIndices={};/** If true, only the pattern before the last valid value character shows. */this.isRevealingMask=isRevealingMask||false;this.parse();}Pattern.prototype.parse=function parse(){var sourceChars=this.source.split('');var patternIndex=0;var pattern=[];for(var i=0,l=sourceChars.length;i<l;i+=1){var char=sourceChars[i];if(char===ESCAPE_CHAR){if(i===l-1){throw new Error('InputMask: pattern ends with a raw '+ESCAPE_CHAR);}var iOffset=i+1;char=sourceChars[iOffset];}else if(char in this.formatCharacters){if(this.firstEditableIndex===null){this.firstEditableIndex=patternIndex;}this.lastEditableIndex=patternIndex;this.editableIndices[patternIndex]=true;}pattern.push(char);patternIndex+=1;}if(this.firstEditableIndex===null){throw new Error('InputMask: pattern "'+this.source+'" does not contain any editable characters.');}this.pattern=pattern;this.length=pattern.length;};/**
 * @param {Array<string>} value
 * @return {Array<string>}
 */Pattern.prototype.formatValue=function format(value){var valueBuffer=new Array(this.length);var valueIndex=0;for(var i=0,l=this.length;i<l;i+=1){if(this.isEditableIndex(i)){if(this.isRevealingMask&&value.length<=valueIndex&&!this.isValidAtIndex(value[valueIndex],i)){break;}valueBuffer[i]=value.length>valueIndex&&this.isValidAtIndex(value[valueIndex],i)?this.transform(value[valueIndex],i):this.placeholderChar;valueIndex+=1;}else{valueBuffer[i]=this.pattern[i];// Also allow the value to contain static values from the pattern by
// advancing its index.
if(value.length>valueIndex&&value[valueIndex]===this.pattern[i]){valueIndex+=1;}}}return valueBuffer;};/**
 * @param {number} index
 * @return {boolean}
 */Pattern.prototype.isEditableIndex=function isEditableIndex(index){return!!this.editableIndices[index];};/**
 * @param {string} char
 * @param {number} index
 * @return {boolean}
 */Pattern.prototype.isValidAtIndex=function isValidAtIndex(char,index){return this.formatCharacters[this.pattern[index]].validate(char);};Pattern.prototype.transform=function transform(char,index){var format=this.formatCharacters[this.pattern[index]];return typeof format.transform==='function'?format.transform(char):char;};function InputMask(options){if(!(this instanceof InputMask)){return new InputMask(options);}var extendedOptions=extend({formatCharacters:null,pattern:null,isRevealingMask:false,placeholderChar:DEFAULT_PLACEHOLDER_CHAR,selection:{start:0,end:0},value:''},options);if(extendedOptions.pattern===null){throw new Error('InputMask: you must provide a pattern.');}if(typeof extendedOptions.placeholderChar!=='string'||extendedOptions.placeholderChar.length>1){throw new Error('InputMask: placeholderChar should be a single character or an empty string.');}this.placeholderChar=extendedOptions.placeholderChar;this.formatCharacters=mergeFormatCharacters(extendedOptions.formatCharacters);this.setPattern(extendedOptions.pattern,{value:extendedOptions.value,selection:extendedOptions.selection,isRevealingMask:extendedOptions.isRevealingMask});}// Editing
/**
 * Applies a single character of input based on the current selection.
 * @param {string} char
 * @return {boolean} true if a change has been made to value or selection as a
 *   result of the input, false otherwise.
 */InputMask.prototype.input=function input(char){// Ignore additional input if the cursor's at the end of the pattern
if(this.selection.start===this.selection.end&&this.selection.start===this.pattern.length){return false;}var selectionBefore=copy(this.selection);var valueBefore=this.getValue();var inputIndex=this.selection.start;// If the cursor or selection is prior to the first editable character, make
// sure any input given is applied to it.
if(inputIndex<this.pattern.firstEditableIndex){inputIndex=this.pattern.firstEditableIndex;}// Bail out or add the character to input
if(this.pattern.isEditableIndex(inputIndex)){if(!this.pattern.isValidAtIndex(char,inputIndex)){return false;}this.value[inputIndex]=this.pattern.transform(char,inputIndex);}// If multiple characters were selected, blank the remainder out based on the
// pattern.
var end=this.selection.end-1;while(end>inputIndex){if(this.pattern.isEditableIndex(end)){this.value[end]=this.placeholderChar;}end-=1;}// Advance the cursor to the next character
this.selection.start=inputIndex+1;this.selection.end=inputIndex+1;// Skip over any subsequent static characters
while(this.pattern.length>this.selection.start&&!this.pattern.isEditableIndex(this.selection.start)){this.selection.start+=1;this.selection.end+=1;}// History
if(this.historyIndex){// Took more input after undoing, so blow any subsequent history away
this.history.splice(this.historyIndex,this.history.length-this.historyIndex);this.historyIndex=null;}if(this.lastOp!=='input'||selectionBefore.start!==selectionBefore.end||this.lastSelection!==null&&selectionBefore.start!==this.lastSelection.start){this.history.push({value:valueBefore,selection:selectionBefore,lastOp:this.lastOp});}this.lastOp='input';this.lastSelection=copy(this.selection);return true;};/**
 * Attempts to delete from the value based on the current cursor position or
 * selection.
 * @return {boolean} true if the value or selection changed as the result of
 *   backspacing, false otherwise.
 */InputMask.prototype.backspace=function backspace(){// If the cursor is at the start there's nothing to do
if(this.selection.start===0&&this.selection.end===0){return false;}var selectionBefore=copy(this.selection);var valueBefore=this.getValue();// No range selected - work on the character preceding the cursor
if(this.selection.start===this.selection.end){if(this.pattern.isEditableIndex(this.selection.start-1)){this.value[this.selection.start-1]=this.placeholderChar;}this.selection.start-=1;this.selection.end-=1;}else{var end=this.selection.end-1;while(end>=this.selection.start){if(this.pattern.isEditableIndex(end)){this.value[end]=this.placeholderChar;}end-=1;}this.selection.end=this.selection.start;}// History
if(this.historyIndex){// Took more input after undoing, so blow any subsequent history away
this.history.splice(this.historyIndex,this.history.length-this.historyIndex);}if(this.lastOp!=='backspace'||selectionBefore.start!==selectionBefore.end||this.lastSelection!==null&&selectionBefore.start!==this.lastSelection.start){this.history.push({value:valueBefore,selection:selectionBefore,lastOp:this.lastOp});}this.lastOp='backspace';this.lastSelection=copy(this.selection);return true;};/**
 * Attempts to paste a string of input at the current cursor position or over
 * the top of the current selection.
 * Invalid content at any position will cause the paste to be rejected, and it
 * may contain static parts of the mask's pattern.
 * @param {string} input
 * @return {boolean} true if the paste was successful, false otherwise.
 */InputMask.prototype.paste=function paste(input){// This is necessary because we're just calling input() with each character
// and rolling back if any were invalid, rather than checking up-front.
var initialState={value:this.value.slice(),selection:copy(this.selection),lastOp:this.lastOp,history:this.history.slice(),historyIndex:this.historyIndex,lastSelection:copy(this.lastSelection)};var pastedInput=input;// If there are static characters at the start of the pattern and the cursor
// or selection is within them, the static characters must match for a valid
// paste.
if(this.selection.start<this.pattern.firstEditableIndex){for(var i=0,l=this.pattern.firstEditableIndex-this.selection.start;i<l;i+=1){if(pastedInput.charAt(i)!==this.pattern.pattern[i]){return false;}}// Continue as if the selection and pastedInput started from the editable part of
// the pattern.
pastedInput=pastedInput.substring(this.pattern.firstEditableIndex-this.selection.start);this.selection.start=this.pattern.firstEditableIndex;}for(var _i=0,_l=pastedInput.length;_i<_l&&this.selection.start<=this.pattern.lastEditableIndex;_i+=1){var valid=this.input(pastedInput.charAt(_i));// Allow static parts of the pattern to appear in pasted input - they will
// already have been stepped over by input(), so verify that the value
// deemed invalid by input() was the expected static character.
if(this.selection.start>0){// XXX This only allows for one static character to be skipped
var patternIndex=this.selection.start-1;if(!this.pattern.isEditableIndex(patternIndex)&&pastedInput.charAt(_i)===this.pattern.pattern[patternIndex]){valid=true;}}if(!valid){extend(this,initialState);return false;}}return true;};// History
InputMask.prototype.undo=function undo(){// If there is no history, or nothing more on the history stack, we can't undo
if(this.history.length===0||this.historyIndex===0){return false;}var historyItem=void 0;if(this.historyIndex){// Not currently undoing, set up the initial history index
this.historyIndex=this.history.length-1;historyItem=this.history[this.historyIndex];// Add a new history entry if anything has changed since the last one, so we
// can redo back to the initial state we started undoing from.
var value=this.getValue();if(historyItem.value!==value||historyItem.selection.start!==this.selection.start||historyItem.selection.end!==this.selection.end){this.history.push({value:value,selection:copy(this.selection),lastOp:this.lastOp,startUndo:true});}}else{var offsetIndex=this.historyIndex-1;historyItem=this.history[offsetIndex];}this.value=historyItem.value.split('');this.selection=historyItem.selection;this.lastOp=historyItem.lastOp;return true;};InputMask.prototype.redo=function redo(){if(this.history.length===0||this.historyIndex===null){return false;}var offsetIndex=this.historyIndex+1;var historyItem=this.history[offsetIndex];// If this is the last history item, we're done redoing
if(this.historyIndex===this.history.length-1){this.historyIndex=null;// If the last history item was only added to start undoing, remove it
if(historyItem.startUndo){this.history.pop();}}this.value=historyItem.value.split('');this.selection=historyItem.selection;this.lastOp=historyItem.lastOp;return true;};// Getters & setters
InputMask.prototype.setPattern=function setPattern(pattern,options){var extendedOptions=extend({selection:{start:0,end:0},value:''},options);this.pattern=new Pattern(pattern,this.formatCharacters,this.placeholderChar,extendedOptions.isRevealingMask);this.setValue(extendedOptions.value);this.emptyValue=this.pattern.formatValue([]).join('');this.selection=extendedOptions.selection;this.resetHistory();};InputMask.prototype.setSelection=function setSelection(selection){this.selection=copy(selection);if(this.selection.start===this.selection.end){if(this.selection.start<this.pattern.firstEditableIndex){this.selection.start=this.pattern.firstEditableIndex;this.selection.end=this.pattern.firstEditableIndex;return true;}// Set selection to the first editable, non-placeholder character before the selection
// OR to the beginning of the pattern
var index=this.selection.start;while(index>=this.pattern.firstEditableIndex){if(this.pattern.isEditableIndex(index-1)&&this.value[index-1]!==this.placeholderChar||index===this.pattern.firstEditableIndex){this.selection.start=index;this.selection.end=index;break;}index-=1;}return true;}return false;};InputMask.prototype.setValue=function setValue(value){var cleanedValue=value;if(typeof value!=='string'||!value){// console.log(value);
cleanedValue='';}this.value=this.pattern.formatValue(cleanedValue.split(''));};InputMask.prototype.getValue=function getValue(){return this.value.join('');};InputMask.prototype.getRawValue=function getRawValue(){var rawValue=[];for(var i=0;i<this.value.length;i+=1){if(this.pattern.editableIndices[i]===true){rawValue.push(this.value[i]);}}return rawValue.join('');};InputMask.prototype.resetHistory=function resetHistory(){this.history=[];this.historyIndex=null;this.lastOp=null;this.lastSelection=copy(this.selection);};InputMask.Pattern=Pattern;module.exports=InputMask;

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_input_mask__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_misc__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasicMask=function(_React$Component){_inherits(BasicMask,_React$Component);function BasicMask(props){_classCallCheck(this,BasicMask);var _this=_possibleConstructorReturn(this,(BasicMask.__proto__||Object.getPrototypeOf(BasicMask)).call(this,props));_this.params=Object.assign({},props);_this.lpKey=Object(__WEBPACK_IMPORTED_MODULE_11__utils_misc__["b" /* generateId1 */])(4);_this.onValueChanged=_this.onValueChanged.bind(_this);_this.onBlur=_this.onBlur.bind(_this);if(props.isDuplicate)_this.params.id=_this.params.id+'_'+props.copy;return _this;}_createClass(BasicMask,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.exists){this.props.initializeOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.lpKey,this.props.ovc,__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].indexes.variables.getVariable(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id).value);}else{this.params.label=__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getOption(this.props.id);}}},{key:'onValueChanged',value:function onValueChanged(val){this.props.editOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.params.id,val);}},{key:'onBlur',value:function onBlur(){this.props.unUpdateContext;}},{key:'render',value:function render(){var _this2=this;// Variable ref
var variable_ref=__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id);// Placeholder
var placeholder=variable_ref&&variable_ref.placeholder?variable_ref.placeholder:"";// Mask
var mask=variable_ref&&variable_ref.mask?variable_ref.mask:"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.props.lpKey},this.props.label,' ','helper'in __WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id)&&__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper})),this.props.id in __WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.variables&&__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning,id:this.props.id,type:'v'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_input_mask___default.a,_defineProperty({name:Object(__WEBPACK_IMPORTED_MODULE_11__utils_misc__["b" /* generateId1 */])(1),placeholder:placeholder,id:this.props.lpKey,value:this.props.value,autoComplete:this.props.autocomplete,onChange:function onChange(evt){return _this2.onValueChanged(evt.target.value);},onBlur:this.onBlur,className:'form-control',mask:mask},'placeholder',placeholder))));}}]);return BasicMask;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state,ownProps){// test if exists
var exists=false;var existantKey='';var existantParent='';var value='';var realId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(realId).key;var _lpGetOptionById=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(realId);value=_lpGetOptionById.value;}}if(ownProps.ovc==='v'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(realId).key;var _lpGetVariableById=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(realId);value=_lpGetVariableById.value;}}var isShown=false;if(state.input_context.variable!==''&&state.input_context.variable===ownProps.id){isShown=true;}var hw=__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].indexes.var_to_view.getViewByVar(ownProps.id);return{had_output:hw?hw.length>0:false,sectionId:state.contract.currentSection,exists:exists,existant_key:existantKey,existant_parent:existantParent,value:value,show_popup:isShown};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// this case, parent = key
initializeOutput:function initializeOutput(id,parent,genre){var value=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["m" /* initOutputOption */])(id,parent,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["n" /* initOutputVariable */])(id,parent,value));},editOutput:function editOutput(id,val){if(ownProps.ovc==='o'){dispatch(editOption(id,val));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["l" /* editVariable */])(id,val));}if(!Object(__WEBPACK_IMPORTED_MODULE_6__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_account_settings__["o" /* editedDocument */])(true));},updateContext:function updateContext(){var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;var pId=ownProps.isDuplicate?ownProps.parent+'_'+ownProps.copy:ownProps.parent;if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["c" /* icSetOption */])(cId));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["d" /* icSetVariable */])(cId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["c" /* icSetOption */])(pId));}},unUpdateContext:function unUpdateContext(){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["c" /* icSetOption */])(''));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["d" /* icSetVariable */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["c" /* icSetOption */])(''));}}};};var LpBasicMask=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(BasicMask);/* harmony default export */ __webpack_exports__["a"] = (LpBasicMask);

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(__webpack_require__(1)),reactDom=__webpack_require__(319);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r)}return e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else{var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select()}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else{var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length))}return{start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return{maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1)}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return-1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return!1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return!u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return!0;if(++s>=l.length)return!1}var t,n,a,i;return!isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return!1;var t,n;return(isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h)}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return"function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return(!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e)}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop)},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop()},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null)},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e)},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t)},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t)}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)})},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e)},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return{mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return!0}catch(r){}return!f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized(_assertThisInitialized(f)).beforePasteState,n=_assertThisInitialized(_assertThisInitialized(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end)},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else{var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end)}f.runSaveSelectionLoop()}isFunction(f.props.onFocus)&&f.props.onFocus(e)},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e)}isFunction(f.props.onBlur)&&f.props.onBlur(e)},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd()}};document.addEventListener("mouseup",r)}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e)},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""))},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e)};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value))},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p))}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end)}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate())},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop()},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1)}else t=React.createElement("input",_extends({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);module.exports=InputElement;


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_output__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__warning__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_input_mask__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_misc__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdvancedMask=function(_React$Component){_inherits(AdvancedMask,_React$Component);function AdvancedMask(props){_classCallCheck(this,AdvancedMask);var _this=_possibleConstructorReturn(this,(AdvancedMask.__proto__||Object.getPrototypeOf(AdvancedMask)).call(this,props));_this.params=Object.assign({},props);_this.lpKey=Object(__WEBPACK_IMPORTED_MODULE_11__utils_misc__["b" /* generateId1 */])(4);_this.onValueChanged=_this.onValueChanged.bind(_this);_this.onBlur=_this.onBlur.bind(_this);if(props.isDuplicate)_this.params.id=_this.params.id+'_'+props.copy;return _this;}_createClass(AdvancedMask,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.exists){this.props.initializeOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id,this.props.lpKey,this.props.ovc,__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].indexes.variables.getVariable(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.props.id).value);}else{this.params.label=__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getOption(this.props.id);}}},{key:'onValueChanged',value:function onValueChanged(val){this.props.editOutput(this.props.isDuplicate?this.props.id+'_'+this.props.copy:this.params.id,val);}},{key:'onBlur',value:function onBlur(){this.props.unUpdateContext;}},{key:'translateMask',value:function translateMask(mask){// Escaping special chars
mask=mask.replace(/(a|9|\*)/g,'\\$1');// Replacing mask chars
mask=mask.replace(/\?/g,'*');mask=mask.replace(/!/g,'9');mask=mask.replace(/@/g,'a');return mask;}},{key:'render',value:function render(){var _this2=this;// Variable ref
var variable_ref=__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id);// Placeholder
var placeholder=variable_ref&&variable_ref.placeholder?variable_ref.placeholder:"";// Mask
var mask=variable_ref&&variable_ref.advancedmask?this.translateMask(variable_ref.advancedmask):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.props.lpKey},this.props.label,' ','helper'in __WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id)&&__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id).helper})),this.props.id in __WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.variables&&__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__warning__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.getVariable(this.props.id).warning,id:this.props.id,type:'v'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_input_mask___default.a,_defineProperty({name:Object(__WEBPACK_IMPORTED_MODULE_11__utils_misc__["b" /* generateId1 */])(1),placeholder:placeholder,id:this.props.lpKey,value:this.props.value,autoComplete:this.props.autocomplete,onChange:function onChange(evt){return _this2.onValueChanged(evt.target.value);},onBlur:this.onBlur,className:'form-control',mask:mask},'placeholder',placeholder))));}}]);return AdvancedMask;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state,ownProps){// test if exists
var exists=false;var existantKey='';var existantParent='';var value='';var realId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;if(ownProps.ovc==='o'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(realId).key;var _lpGetOptionById=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["g" /* lpGetOptionById */])(realId);value=_lpGetOptionById.value;}}if(ownProps.ovc==='v'){if(typeof Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(realId)!=='undefined'){exists=true;existantKey=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(realId).key;var _lpGetVariableById=Object(__WEBPACK_IMPORTED_MODULE_8__logic_re_index__["h" /* lpGetVariableById */])(realId);value=_lpGetVariableById.value;}}var isShown=false;if(state.input_context.variable!==''&&state.input_context.variable===ownProps.id){isShown=true;}var hw=__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].indexes.var_to_view.getViewByVar(ownProps.id);return{had_output:hw?hw.length>0:false,sectionId:state.contract.currentSection,exists:exists,existant_key:existantKey,existant_parent:existantParent,value:value,show_popup:isShown};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{// this case, parent = key
initializeOutput:function initializeOutput(id,parent,genre){var value=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';if(genre==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["m" /* initOutputOption */])(id,parent,value));else if(genre==='v')dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["n" /* initOutputVariable */])(id,parent,value));},editOutput:function editOutput(id,val){if(ownProps.ovc==='o'){dispatch(editOption(id,val));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_output__["l" /* editVariable */])(id,val));}if(!Object(__WEBPACK_IMPORTED_MODULE_6__globals__["a" /* isDocumentEdited */])())dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_account_settings__["o" /* editedDocument */])(true));},updateContext:function updateContext(){var cId=ownProps.isDuplicate?ownProps.id+'_'+ownProps.copy:ownProps.id;var pId=ownProps.isDuplicate?ownProps.parent+'_'+ownProps.copy:ownProps.parent;if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["c" /* icSetOption */])(cId));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["d" /* icSetVariable */])(cId));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["c" /* icSetOption */])(pId));}},unUpdateContext:function unUpdateContext(){if(ownProps.ovc==='o')dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["c" /* icSetOption */])(''));else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["d" /* icSetVariable */])(''));dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_input_context__["c" /* icSetOption */])(''));}}};};var LpAdvancedMask=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AdvancedMask);/* harmony default export */ __webpack_exports__["a"] = (LpAdvancedMask);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _VariableContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VariableContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variable__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src/components/variable_container.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */var _VariableContainer=function(_Component){_inherits(_VariableContainer,_Component);function _VariableContainer(props){_classCallCheck(this,_VariableContainer);// maybe we don't get real values
var _this=_possibleConstructorReturn(this,(_VariableContainer.__proto__||Object.getPrototypeOf(_VariableContainer)).call(this,props));_this.params=Object.assign({},props,{lpKey:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),is_active:false});if(!_this.params.variables){_this.params.variables=[];}return _this;}_createClass(_VariableContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.initializeFlat(this.params.lpKey,this.params.parent,'vc',this.props.sectionId,-3,this.props.lpParent);// console.log("> " + this.params.lpKey + " > " + this.params.lpParent);
// FIXME: test if this exists in the flat before adding it.
this.state={shown:true};}},{key:'componentDidMount',value:function componentDidMount(){}// console.log(this.props)
// style={'show' in this.props &&
// this.props.show ? style_show : style_hide}
},{key:'render',value:function render(){var _this2=this;// console.log("jdjdjjd")
var isCopy='is_copy'in this.params&&this.params.is_copy;var isStatic=__WEBPACK_IMPORTED_MODULE_4__app_lp_app__["a" /* default */].references.getOption(this.props.id).meta.type==='static'&&this.props.variables&&this.props.variables.length>0;var hasVariables=this.props.variables&&this.props.variables.length>0;// <AnimateHeight height={height} duration={2000}>
// </AnimateHeight>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:!isStatic?'wzog-content'+(!hasVariables?' wz-empty':''):'wzog-wrapper',key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),'data-type':'variable-container','data-id':this.props.id,'data-is-duplicate':this.props.isDuplicate,'data-copy':this.props.copy},this.params.variables.map(function(idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__variable__["a" /* default */],{lpKey:_this2.props.lpKey,lpParent:_this2.props.lpParent,id:idx.id,parent:_this2.props.id,key:Object(__WEBPACK_IMPORTED_MODULE_2__utils_misc__["b" /* generateId1 */])(4),label:idx.label,type:idx.type,helper:idx.helper,autocomplete:idx.autocomplete?idx.autocomplete:'off',is_copy:isCopy,is_multiple:_this2.props.is_multiple,isDuplicate:_this2.props.isDuplicate,copy:_this2.props.copy});},this));}}]);return _VariableContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// we have to in the VC into the flatui
var mapStateToProps=function mapStateToProps(state){return{sectionId:state.contract.currentSection};};var mapDispatchToProps=function mapDispatchToProps(){return{initializeFlat:function initializeFlat(ui,id,genre,sectionId,parentId,parentui){}};};var VariableContainer=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_VariableContainer);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radio__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_re_index__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src/components/misc/radio_group.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var _RadioGroup=function(_Component){_inherits(_RadioGroup,_Component);function _RadioGroup(){_classCallCheck(this,_RadioGroup);return _possibleConstructorReturn(this,(_RadioGroup.__proto__||Object.getPrototypeOf(_RadioGroup)).apply(this,arguments));}_createClass(_RadioGroup,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){if(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].action_tracker.last_action==='EDIT_VARIABLE_VALUE_'||__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].action_tracker.last_action==='IC_SET_VARIABLE'||__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].action_tracker.last_action==='IC_SET_OPTION'){return false;}return true;}},{key:'render',value:function render(){var _this2=this;// console.log(filterSelected(this.props.id, this.props.value))
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:Object(__WEBPACK_IMPORTED_MODULE_3__utils_misc__["b" /* generateId1 */])(4)},this.props.id.map(function(idx,i){if(!__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].ops.two_steps.checkOption(idx)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__radio__["a" /* default */],{id:idx,parent:_this2.props.parent,group:_this2.props.parent,label:__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.getOption(idx).meta.label,ovc:'o',isDuplicate:_this2.props.isDuplicate,copy:_this2.props.copy,is_multiple:_this2.props.is_multiple,is_checked:_this2.props.value[i],key:idx});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:idx});}));}}]);return _RadioGroup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){var cId=ownProps.id;if(ownProps.isDuplicate)cId=cId.map(function(idx){return idx+'_'+ownProps.copy;});// console.log(cId)
return{value:cId.map(function(idx){return Object(__WEBPACK_IMPORTED_MODULE_4__logic_re_index__["g" /* lpGetOptionById */])(idx)?Object(__WEBPACK_IMPORTED_MODULE_4__logic_re_index__["g" /* lpGetOptionById */])(idx).value:false;})};};var mapDispatchToProps=function mapDispatchToProps(){return{};};var RadioGroup=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_RadioGroup);/* harmony default export */ __webpack_exports__["a"] = (RadioGroup);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_payment__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/mail_section.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// importing things
// the check of mail existance here
var _MailSection=function(_Component){_inherits(_MailSection,_Component);function _MailSection(props){_classCallCheck(this,_MailSection);var _this=_possibleConstructorReturn(this,(_MailSection.__proto__||Object.getPrototypeOf(_MailSection)).call(this,props));_this.updateMyMail=_this.updateMyMail.bind(_this);_this.toThePayment=_this.toThePayment.bind(_this);_this.has_error=false;// The initialization of payment system while the guy writes down the mail
if(typeof window.lp_payment==='undefined'){window.lp_payment=new __WEBPACK_IMPORTED_MODULE_4__logic_payment__["a" /* default */]();}return _this;}_createClass(_MailSection,[{key:'componentDidMount',value:function componentDidMount(){// this case may give us the false effect we are waiting for
__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].track('Reached email');__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackGTMCheckoutStep(2,'Votre adresse email',__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].getState().contract);/*
    * Adwords Conversion tracking
    */__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].adwordsConversion({google_conversion_value:0.01});}},{key:'updateMyMail',value:function updateMyMail(evt){// console.log(evt.target.value);
this.props.updateMail(evt.target.value);}},{key:'toThePayment',value:function toThePayment(){// saveMail(this.props.value);
// this.props.pass0(this.props.value);
this.props.goForward();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-content',style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'+(this.props.has_error?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.customs.get('email_section_label')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Adresse email'):__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.customs.get('email_section_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'mail',name:'email',onChange:function onChange(evt){return _this2.updateMyMail(evt);},value:this.props.value,className:'form-control',style:{marginTop:'10px',maxWidth:'360px',width:'100%'}}),this.props.has_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Veuillez saisir une adresse email valide.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'helper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-info-o'}),__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.customs.get('email_section_warning')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Nous ne partagerons vos informations avec personne'):__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].references.customs.get('email_section_warning')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Conformément à la Loi Informatique et Libertés et Règlement général sur la protection des données (RGPD), vous disposez d’un droit d’accès, de modification, de suppression et d’opposition au traitement de vos données à caractère personnel.')));}}]);return _MailSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{value:state.account_settings.mail,has_error:state.error.mail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{goForward:function goForward(){// check the existance here
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["b" /* LP_STATE_PAYMENT */]));},goBackward:function goBackward(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["e" /* LP_STATE_WIZARD */]));},updateMail:function updateMail(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_account_settings__["x" /* updateMailFromInput */])(val));},pass0:function pass0(){// dispatch(buildQuery(mail))
}};};var MailSection=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_MailSection);/* harmony default export */ __webpack_exports__["a"] = (MailSection);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENHANCED_CONVERSION_VALUE_BY_PERMALINK; });
var ENHANCED_CONVERSION_VALUE_BY_PERMALINK={'creation-sas':400,'creation-sasu':400,'creation-sarl':400,'creation-eurl':400,'creation-sci':300};

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_toggle_preview__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_wording__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/popover.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var _PopOver=function(_Component){_inherits(_PopOver,_Component);function _PopOver(props){_classCallCheck(this,_PopOver);var _this=_possibleConstructorReturn(this,(_PopOver.__proto__||Object.getPrototypeOf(_PopOver)).call(this,props));_this.goToDownload1=_this.goToDownload1.bind(_this);return _this;}_createClass(_PopOver,[{key:'componentDidMount',value:function componentDidMount(){document.getElementById('modal').appendChild(this.refs.modal_download);document.body.classList.add('overflow-hidden');document.getElementsByClassName('page-wrap')[0].classList.add('unfocus');}},{key:'componentDidUpdate',value:function componentDidUpdate(){document.getElementById('modal').appendChild(this.refs.modal_download);document.body.classList.add('overflow-hidden');document.getElementsByClassName('page-wrap')[0].classList.add('unfocus');}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.classList.remove('overflow-hidden');document.getElementsByClassName('page-wrap')[0].classList.remove('unfocus');document.getElementById('real-popover').appendChild(this.refs.modal_download);}},{key:'goToDownload1',value:function goToDownload1(){this.props.goBack();// saveMail(this.props.mail);
this.props.goToDownload();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-modal doc-download-modal',ref:'modal_download'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.props.goBack,className:'lpm-close icn-x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-modal-content col-md-6 col-md-offset-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-info-o'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ddm-notice'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])("Il est conseillé de remplir le document afin que vous puissiez l'adapter à votre situation")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Êtes-vous sûr de passer au téléchargement?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.goBack,href:'#',className:'btn btn-primary btn-lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-pen'}),Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('J’adapte mon document')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'lnk-white hover-pointer',onClick:this.goToDownload1},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Je passe au téléchargement')))));}}]);return _PopOver;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{mail:state.account_settings.mail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{bq:function bq(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["a" /* LP_STATE_CHECKOUT */]));},back:function back(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_toggle_preview__["d" /* hidePopover */])());}};};var mergeProps=function mergeProps(stateProps,dispatchProps){return{mail:stateProps.mail,goToDownload:function goToDownload(){dispatchProps.bq(stateProps.mail);},goBack:dispatchProps.back};};var LpPopOver=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(_PopOver);/* harmony default export */ __webpack_exports__["a"] = (LpPopOver);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logic_payment__ = __webpack_require__(268);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/save_component_section.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/// importing things
// import { saveMail } from '../logic/firebase/account';
// the check of mail existance here
var _SaveSection=function(_Component){_inherits(_SaveSection,_Component);function _SaveSection(props){_classCallCheck(this,_SaveSection);var _this=_possibleConstructorReturn(this,(_SaveSection.__proto__||Object.getPrototypeOf(_SaveSection)).call(this,props));_this.updateMyMail=_this.updateMyMail.bind(_this);_this.toThePayment=_this.toThePayment.bind(_this);_this.has_error=false;// The initialization of payment system while the guy writes down the mail
if(typeof window.lp_payment==='undefined'){window.lp_payment=new __WEBPACK_IMPORTED_MODULE_6__logic_payment__["a" /* default */]();}return _this;}_createClass(_SaveSection,[{key:'updateMyMail',value:function updateMyMail(evt){// console.log(evt.target.value);
this.props.updateMail(evt.target.value);}},{key:'toThePayment',value:function toThePayment(){// saveMail(this.props.value);
// this.props.pass0(this.props.value);
this.props.goForward();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-content',style:{}},this.props.document_id===''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{fontSize:'18px',fontWeight:"600",marginTop:'45px'}},__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.customs.get('save_section_text')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Renseignez votre adresse email afin de retrouver vos réponses lors de votre prochaine visite'):__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.customs.get('save_section_text')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wizard-email',style:{marginLeft:"15px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'+(this.props.has_error?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.customs.get('save_section_label')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Adresse email'):__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.customs.get('save_section_label')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'mail',name:'email',onChange:function onChange(evt){return _this2.updateMyMail(evt);},value:this.props.value,className:'form-control'}),this.props.has_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Veuillez saisir une adresse email valide.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'helper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-info-o'}),__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.customs.get('save_section_info')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Nous ne partagerons vos informations avec personne'):__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.customs.get('save_section_info')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{fontSize:'0.8em',marginTop:'75px'}},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Conformément à la Loi Informatique et Libertés et Règlement général sur la protection des données (RGPD), vous disposez d’un droit d’accès, de modification, de suppression et d’opposition au traitement de vos données à caractère personnel.'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'we-law',style:{fontSize:'18px',fontWeight:"600",marginTop:'45px'}},__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.customs.get('save_section_success_message')==='NONE'?Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Un email de confirmation vous a été envoyé contenant un lien pour reprendre votre questionnaire'):__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].references.customs.get('save_section_success_message')));}}]);return _SaveSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{value:state.account_settings.mail,has_error:state.error.mail,document_id:state.document_state.unique};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{goForward:function goForward(){// check the existance here
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["b" /* LP_STATE_PAYMENT */]));},goBackward:function goBackward(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_2__redux_actions_app_state__["e" /* LP_STATE_WIZARD */]));},updateMail:function updateMail(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_account_settings__["x" /* updateMailFromInput */])(val));},pass0:function pass0(){}};};var SaveSection=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_SaveSection);/* harmony default export */ __webpack_exports__["a"] = (SaveSection);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview_row__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions_toggle_preview__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_global_getter__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/preview.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var numberOfAll=0;// calculation of page numbers
var _Preview=function(_Component){_inherits(_Preview,_Component);function _Preview(props){_classCallCheck(this,_Preview);var _this=_possibleConstructorReturn(this,(_Preview.__proto__||Object.getPrototypeOf(_Preview)).call(this,props));_this.len=0;_this.updateNumbersTimer=null;_this.state={page_length:0};_this.child_render_state=0;_this.last_view=props.views.length-1;// console.log(props);
_this.goToPage=_this.goToPage.bind(_this);_this.addChildRender=_this.addChildRender.bind(_this);window.preview_loop=0;return _this;}_createClass(_Preview,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(nextProps.variable){return false;}if(nextProps.nah)return false;return true;}},{key:'componentWillUpdate',value:function componentWillUpdate(){window.preview_loop+=1;// Reseting children render counter to 0
this.child_render_state=0;}},{key:'componentDidUpdate',value:function componentDidUpdate(){// Updating auto numbers
this.updateNumbers();}},{key:'goToPage',value:function goToPage(id){if(id<=this.state.page_length||id>0){this.setState({});}}},{key:'addChildRender',value:function addChildRender(){this.child_render_state+=1;// If all views were updated, we update auto numbers (this fixes the DEV-1416 bug)
this.updateNumbers();}// eslint-disable-next-line
},{key:'updateNumbers',value:function updateNumbers(){var nbrSys={};// this one must change
var numbers=document.querySelectorAll('.aside .page [num-auto], .aside .page [num-auto-pre]');for(var i=0;i<numbers.length;i+=1){var v=numbers[i];if(v&&v.attributes&&v.attributes.getNamedItem('num-auto')){nbrSys[v.attributes.getNamedItem('num-auto').value]=0;}else{nbrSys[v.attributes.getNamedItem('num-auto-pre').value]=0;}}Object.keys(numbers).forEach(function(idx){var element=numbers[idx];if(element&&element.attributes&&element.attributes.getNamedItem('num-auto')){var counter=element.attributes.getNamedItem('num-auto').value;nbrSys[counter]+=1;element.innerHTML=nbrSys[counter];}else if(element&&element.attributes){var _counter=element.attributes.getNamedItem('num-auto-pre').value;element.innerHTML=nbrSys[_counter];}});}},{key:'render',value:function render(){var _this2=this;if(__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].isPrerender===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},this.props.views.map(function(idx,index){var last=_this2.props.views.length-1===index?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__preview_row__["a" /* default */],{key:Object(__WEBPACK_IMPORTED_MODULE_3__utils_misc__["b" /* generateId1 */])(4),idOut:idx[1],out:idx[0],lastView:last});}));}// console.time("render");
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-doc-live-preview hidden-xs',onClick:this.props.togglePreview},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_7__logic_wording__["a" /* _lp */])(this.props.title)),this.props.wizard_loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-spin'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icn-glass'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-doc-container lp-doc-sidebar',style:{overflow:'hidden'},key:Object(__WEBPACK_IMPORTED_MODULE_3__utils_misc__["b" /* generateId1 */])(3)},!this.props.wizard_loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-doc',ref:'page_margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},this.props.views.map(function(idx,index){var last=_this2.props.views.length-1===index?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__preview_row__["a" /* default */],{key:Object(__WEBPACK_IMPORTED_MODULE_3__utils_misc__["b" /* generateId1 */])(4),idOut:idx[1],out:idx[0],updateNumbers:_this2.updateNumbers,lastView:last});})))));// console.timeEnd('render');
}}]);return _Preview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){// check the updatable conditions.
numberOfAll=0;var outputs=[];// The algorithm of grabbing the
// get the section content
// prepare options
//    if(window.section_transition){
//        return {
//            in_transition: true
//        }
//    }
if(state.contract===undefined||state.contract===null){return{views:[]};}// if(!state.preview)return{
//     is_modal: state.preview,
//     preview: state.preview,
//     views: []
// }
var la=__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].action_tracker.last_action;if(la==='EDIT_VARIABLE_VALUE_'||!__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].mutex.checkMutex('preview')){// debugger;
return{variable:true,views:[],context_variable:state.input_context.variable===''?0:Object(__WEBPACK_IMPORTED_MODULE_5__logic_global_getter__["d" /* lpIdGetPure */])(state.input_context.variable)};}switch(la){case'EDIT_OPTION_RADIO_':case'CREATE_CONTRACT':case'SET_SECTION_ID':case'LOAD_OVC':case'EDIT_OPTION_VALUE_':case'SET_FULL_WIDTH':if(__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].mutex.checkMutex('preview')){Object.keys(__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].indexes.real_sections.output_sections).forEach(function(idx){__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].ops.content.getOutput(__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].indexes.real_sections.getOutputSection(idx).options,outputs);});}if(window.lml)window.lml+=1;else window.lml=1;break;default:outputs=__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].indexes.content.getContent();numberOfAll=__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].indexes.content.getContentLength();break;}// TODO: work on
__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].indexes.content.updateContent(outputs,numberOfAll);return{wizard_loading:state.loading_details.wizard,preview:state.preview,views:outputs,is_modal:state.preview,context_variable:state.input_context.variable===''?0:Object(__WEBPACK_IMPORTED_MODULE_5__logic_global_getter__["d" /* lpIdGetPure */])(state.input_context.variable),title:__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].references.customs.get('preview_title')==='NONE'?'Aperçu de votre document':__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].references.customs.get('preview_title')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{togglePreview:function togglePreview(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_actions_toggle_preview__["e" /* togglePreview */])());__WEBPACK_IMPORTED_MODULE_6__tracking_lpevents__["a" /* default */].trackGTMGAEvent('Contrat aperçu','Clic',__WEBPACK_IMPORTED_MODULE_8__app_lp_app__["a" /* default */].getState().contract.name);__WEBPACK_IMPORTED_MODULE_6__tracking_lpevents__["a" /* default */].track('Opened preview popup');}};};var Preview=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_Preview);/* harmony default export */ __webpack_exports__["a"] = (Preview);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_contract__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logic_default_values__ = __webpack_require__(448);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src/components/side_menu.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var _LpSideMenu=function(_Component){_inherits(_LpSideMenu,_Component);function _LpSideMenu(){_classCallCheck(this,_LpSideMenu);return _possibleConstructorReturn(this,(_LpSideMenu.__proto__||Object.getPrototypeOf(_LpSideMenu)).apply(this,arguments));}_createClass(_LpSideMenu,[{key:'componentDidMount',value:function componentDidMount(){var wizardObserver=new MutationObserver(function(){function getElHeight(el){if(el){return el.offsetHeight;}return'0';}var wizard=document.querySelector('.wizard');var asideList=document.querySelector('.forcing-summary ul');if(asideList){asideList.style.height=(wizard?getElHeight(wizard):'0')+'px';}});wizardObserver.observe(document.querySelector('.wizard-content'),{childList:true,subtree:true});if(document.body.offsetWidth<=1023){document.querySelector('#mysummary').style.display="none";}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var wizard=document.querySelector('.wizard');var asideList=document.querySelector('.forcing-summary ul');function getElHeight(el){return el.offsetHeight;}if(asideList){asideList.style.height=(wizard?getElHeight(wizard):'0')+'px';}_LpSideMenu.setActualSection(parseInt(this.props.actual_section,10));}// When changing the section the menu appears to be reselected.
},{key:'menuSelected',value:function menuSelected(element){var index=document.querySelector('#menu_s_'+element);if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].env.is_mobile||__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].env.client_zone.width<600){if(document.querySelector('#mysummary').classList.contains('closed')){document.querySelector('#mysummary').scrollTo(parseInt(document.querySelector('#innerSum').style.marginTop,10),0);document.querySelector('#innerSum').style.marginTop=0;document.querySelector('#mysummary').classList.remove('closed');document.querySelector('#mysummary').style.height='600px';return;}}document.querySelector('#mysummary').scrollTo(0,0);if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].env.is_mobile||__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].env.client_zone.width<600){var y=_LpSideMenu.getYOfMenu(element);if(index.offsetHeight>48){y-=index.offsetHeight-48;document.body.style.paddingTop=-(index.offsetHeight-48)+'px';}else{document.body.style.paddingTop='0px';}document.querySelector('#innerSum').style.marginTop='-'+y+'px';document.querySelector('#mysummary').style.height=index.offsetHeight+'px';document.querySelector('#mysummary').classList.add('closed');}console.log(element);this.props.setSectionRedux(element);// Setting default values
__WEBPACK_IMPORTED_MODULE_5__logic_default_values__["a" /* default */].setDefaults(element);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mysummary',className:'forcing-summary mysummary closed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fs-heading'},'Sommaire'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'innerSum'},Object.keys(this.props.sections).map(function(idx,i){var index=parseInt(idx,10)+1;var sectionId=_this2.props.sections[idx].id;var mandatoryVars=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.mandatory.checkMandatoryVariables(sectionId);var mandatoryOps=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.mandatory.checkMandatoryOptions(sectionId);var isMandatory=false;if(mandatoryOps===null&&mandatoryVars!==null)isMandatory=mandatoryVars;else if(mandatoryOps!==null&&mandatoryVars===null)isMandatory=mandatoryOps;else if(mandatoryOps!==null&&mandatoryVars!==null){isMandatory=mandatoryOps&&mandatoryVars;}else isMandatory=false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:' is-force'+(isMandatory?' is-ok':''),id:'menu_s_'+i,onClick:function onClick(){return _this2.menuSelected(i,sectionId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,index<10?''+0+index:index,' ','.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this2.props.sections[idx].label)));})));}}],[{key:'setActualSection',value:function setActualSection(element){var index=document.querySelector('#menu_s_'+element);if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].env.is_mobile||__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].env.client_zone.width<600){var y=_LpSideMenu.getYOfMenu(element);if(index.offsetHeight>48){y-=index.offsetHeight-48;document.body.style.paddingTop=-(index.offsetHeight-48)+'px';}else{document.body.style.paddingTop='0px';}document.querySelector('#innerSum').style.marginTop='-'+y+'px';document.querySelector('#mysummary').style.height=index.offsetHeight+'px';}var innerSumLi=[].slice.call(document.querySelectorAll('#innerSum>li'));innerSumLi.forEach(function(idx){return idx.classList.remove('active');});index.classList.toggle('active');}},{key:'getYOfMenu',value:function getYOfMenu(i){var result=0;for(var idx=1;idx<=i;idx+=1){result+=document.querySelector('#menu_s_'+idx).offsetHeight;}return result;}}]);return _LpSideMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){// TODO: some issues with the update of content, so we do it here,
var la=__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].action_tracker.last_action;switch(la){case'EDIT_OPTION_RADIO_':case'CREATE_CONTRACT':case'SET_SECTION_ID':case'LOAD_OVC':case'SET_FULL_WIDTH':case'EDIT_OPTION_VALUE_':case'ADD_MULTIPLE':case'INIT_OUTPUT_OPTION_':case'REMOVE_DUPLICATE':case'REM_OPTION_DUP':case'REM_VARIABLE_DUP':// case 'IC_SET_VARIABLE_':
if(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].mutex.checkMutex('preview')){var outputs=[];Object.keys(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.real_sections.output_sections).map(function(idx){__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.content.getOutput(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.real_sections.getOutputSection(idx).options,outputs);});__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.content.updateContent(outputs);}if(typeof window.p==='undefined')window.p=true;else{window.p=!window.p;}break;case'EDIT_VARIABLE_VALUE_':if(typeof window.p==='undefined')window.p=true;else{window.p=!window.p;}break;default:break;}return{actual_section:state.contract.currentSection,sections:__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].indexes.real_sections.output_sections,loading:state.loading_details.wizard,change:window.p};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setSectionRedux:function setSectionRedux(sId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_contract__["e" /* redirectToSection */])(sId));},doInits:function doInits(sId){__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].mutex.setMutex('preview',false);dispatch(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].ops.initialization.raNextInit(sId));}};};var mergeProps=function mergeProps(stateProps,dispatchProps){return{actual_section:stateProps.actual_section,sections:stateProps.sections,loading:stateProps.loading,setSectionRedux:function setSectionRedux(sId){Object(__WEBPACK_IMPORTED_MODULE_4__errors_error__["c" /* unraiseError */])('mandatory');dispatchProps.setSectionRedux(sId);dispatchProps.doInits(sId);},change:stateProps.change};};var LpSideMenu=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(_LpSideMenu);/* harmony default export */ __webpack_exports__["a"] = (LpSideMenu);

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_shimmer__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_history__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_hardcoded_checkout__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__header__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ce_checkout_step_two_next__ = __webpack_require__(1138);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckoutWrapper=function(_Component){_inherits(CheckoutWrapper,_Component);function CheckoutWrapper(props){_classCallCheck(this,CheckoutWrapper);var _this=_possibleConstructorReturn(this,(CheckoutWrapper.__proto__||Object.getPrototypeOf(CheckoutWrapper)).call(this,props));__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].mainCheckout(_this.props.match.params.name,_this.props.match.params.id?_this.props.match.params.id:'');return _this;}_createClass(CheckoutWrapper,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.togglepack||!(__WEBPACK_IMPORTED_MODULE_8__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].contractMetaId)>-1)){this.props.history.push('/contrats/'+this.props.match.params.name+'/'+this.props.match.params.id+'/paiement');}}},{key:'render',value:function render(){return this.props.togglepack?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-checkout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ce_checkout_step_two_next__["a" /* default */],null))):null;}}]);return CheckoutWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{togglepack:state.checkout_operations.togglepack};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{goBack:function goBack(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_5__redux_actions_app_state__["e" /* LP_STATE_WIZARD */]));// #event
lpevents.track('Modifier mon document',{});__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["p" /* lpPattern */].trackLastAction(__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["c" /* P_BACK */]);__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["p" /* lpPattern */].sendAndResetTracker();}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CheckoutWrapper)));

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = b64EncodeUnicode;
/* harmony export (immutable) */ __webpack_exports__["a"] = b64DecodeUnicode;
/*
 * Project: LegalPlace assistant
 * File: src\logic\utils\encoding.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */function b64EncodeUnicode(str){return btoa(encodeURIComponent(str).replace(new RegExp('%([0-9A-F]{2})','g'),function(match,p1){return String.fromCharCode(parseInt(p1,16));}));}function b64DecodeUnicode(str){return decodeURIComponent(Array.prototype.map.call(atob(str),function(c){return'%'+('00'+c.charCodeAt(0).toString(16)).slice(-2);}).join(''));}window.encode_=b64EncodeUnicode;window.decode_=b64DecodeUnicode;

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNSAxOEw5IDEyTDE1IDYiIHN0cm9rZT0iIzQ5NTA1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_modal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__card_modal_next__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_ops_sendinblue_notification__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_hardcoded_checkout__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__buy_upsell_pack_entrepreneur__ = __webpack_require__(1141);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/pack_choice.js
* Author: Amine Azizi
* Version: 1.0
*/// This one is special thing, we must change it to the CSS
var x3PaymentStyle={text:{color:'#3392FF',justifyContent:'center',textDecoration:'underline',cursor:'pointer'},container:{margin:'14px 0',textAlign:'center',alignItems:'center',cursor:'pointer'}};var starStyles={marginRight:'5px'};/**
 * @description The component that selects the packs of prices.
 */var _CePackChoiceTwoNext=function(_Component){_inherits(_CePackChoiceTwoNext,_Component);function _CePackChoiceTwoNext(props){_classCallCheck(this,_CePackChoiceTwoNext);var _this=_possibleConstructorReturn(this,(_CePackChoiceTwoNext.__proto__||Object.getPrototypeOf(_CePackChoiceTwoNext)).call(this,props));_initialiseProps.call(_this);_this.scrollEvent=_this.scrollEvent.bind(_this);_this.sendPromo=_this.sendPromo.bind(_this);_this.showCreditCardModal=_this.showCreditCardModal.bind(_this);_this.toggleAssistance=_this.toggleAssistance.bind(_this);__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.checkout.setCheckoutCallback(_this.showCreditCardModal);_this.checkoutsetPrices();_this.executeCouponOnce=0;var upsellArray=_this.pack&&_this.props.detailsCheckout[_this.pack]&&_this.props.detailsCheckout[_this.pack].upsell;var upsell=upsellArray&&upsellArray.length&&[].concat(_toConsumableArray(Array(upsellArray.length))).map(function(){return false;});// if comming from intermediate Checkout Upsell Page
if(props.upsellArrayChecked&&props.upsellArrayChecked.length)upsell=props.upsellArrayChecked;_this.state={show_modal:false,show_modal1:false,upsell:upsell,pack_data:_CePackChoiceTwoNext.getPackData(props)};return _this;}_createClass(_CePackChoiceTwoNext,[{key:'componentDidMount',value:function componentDidMount(){document.body.classList.add('ce_checkout_v3');document.body.classList.add('ce_payement_v3');document.body.classList.add('ce_checkout_sas');document.body.classList.add('cc-cart--fixed');Object(__WEBPACK_IMPORTED_MODULE_8__utils_misc__["f" /* scrollAndGoUp */])();var sdbNotif=new __WEBPACK_IMPORTED_MODULE_10__app_ops_sendinblue_notification__["a" /* default */]();sdbNotif.sendInBlueNotification(window.obj);var contractAssis=[175,197,124,176,198];if(contractAssis.indexOf(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId)!==-1&&(this.props.chosen_pack===0||this.props.chosen_pack===1)){this.refs.assistance.classList.remove('is-disabled');this.props.setCreatAssist(true);window.document.getElementById('check9').setAttribute('checked','checked');}var eventParams={};eventParams['Reache payment']='Reached PaymentPage';__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].track('Reache payment',eventParams);window.checkout_step='checkout';if(__WEBPACK_IMPORTED_MODULE_11__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId)>-1){__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackGTMCheckoutStep(3,'Récapitulatif de votre commande',__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].getState().contract,__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].getState().checkout_operations,__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId,this.state.pack_data.packs_names);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.classList.remove('ce_checkout_v3');document.body.classList.remove('ce_payement_v3');document.body.classList.remove('ce_checkout_sas');document.body.classList.remove('cc-cart--fixed');}},{key:'toggleAssistance',value:function toggleAssistance(evt){if(evt.target.checked){this.refs.assistance.classList.remove('is-disabled');this.props.setCreatAssist(true);}else{this.refs.assistance.classList.add('is-disabled');this.props.setCreatAssist(false);}}},{key:'showCreditCardModal',value:function showCreditCardModal(){var isX3=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(typeof isX3==='boolean'&&isX3){this.props.setCard(false);this.props.set3X(true);this.props.setPaypal(false);this.props.setDirect(false);this.props.updatePaymentMethod(0);__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.checkout.resetCheckedCondition();}else{this.props.setCard(true);this.props.set3X(false);this.props.setPaypal(false);this.props.setDirect(false);this.props.updatePaymentMethod(0);__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.checkout.resetCheckedCondition();}// Tracking opened payment popup
var eventParams={};eventParams['Chosen price']=parseFloat(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.checkout.getPackPrice());eventParams['Total price']=parseFloat(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice());eventParams['Chosen pack']=this.props.chosen_pack===2?'first_price':'second_price';if(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].subscription&&this.props.chosen_pack===1)eventParams['Chosen pack']='abonnement';__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackPopUpCheckout();__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].track('Opened Payment Popup',eventParams);if(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].subscription&&this.props.chosen_pack===1){this.setState({show_modal1:true});}else this.setState({show_modal:true});}/**
     * @description show and hide the payment button when the other shows up.
     */},{key:'scrollEvent',value:function scrollEvent(){var button=document.getElementById('payment_');if(button.getClientRects()[0].y<=__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].env.client_zone.height-35){this.refs.one.classList.add('animate-hide');}else{this.refs.one.classList.remove('animate-hide');}}},{key:'sendPromo',value:function sendPromo(){this.props.checkPromo(this.props.promo_code,this.props.contract_id);}},{key:'render',value:function render(){var _this2=this;var getContractName=function getContractName(contractMetaId){switch(contractMetaId){case 198:return'EURL';case 197:return'SARL';case 175:return'SAS';case 176:return'SASU';case 184:return"Rupture Conventionnelle";case 124:return'SCI';case 162:return'association';case 181:return'auto-Entrepreneur';case 219:return"Radiation d'Auto-Entreprise";case 229:return'';default:break;}};Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_4" /* isClientPro */])();var _getUpsellInfo=this.getUpsellInfo(),sumUpsellTva=_getUpsellInfo.sumUpsellTva,sumUpsell=_getUpsellInfo.sumUpsell,upsellWithTva=_getUpsellInfo.upsellWithTva,upsellWithoutTva=_getUpsellInfo.upsellWithoutTva;var prixHTLabel='Montant total HT';if(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId===181)prixHTLabel='Création Standard HT';/*
         * Pack name
         */var packName=this.state.pack_data.packs_names[this.props.chosen_pack];/*
         * Pack options
         */var packOptions=[];var li=void 0;this.state.pack_data.packs_contents.forEach(function(opt,i){if(opt.checks&&opt.checks[_this2.props.chosen_pack]===true||opt.display){if(opt.dynamic){if(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId!==124&&_this2.props.chosen_pack===2){li=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'pcnt-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pfi-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title,' ',getContractName(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId))),opt.helper?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},opt.helper):'');packOptions.push(li);li=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'pcnt-23'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pfi-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'M0')));packOptions.push(li);li=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'pcnt-24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pfi-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Documents annexes')));}else{li=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'pcnt-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pfi-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title,' ',getContractName(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId),' ','+ dossier complet')),opt.helper?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},opt.helper):'');}}else{li=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'pcnt-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pfi-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title)),opt.helper?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},opt.helper):'');}packOptions.push(li);}});// In case of reduction we show it
if(this.props.promo_percentage&&parseFloat(this.props.promo_percentage)>0&&this.executeCouponOnce<1){this.executeCouponOnce+=1;this.packPrice-=this.packPrice*this.props.promo_percentage;}// Calculating cart prices
var totalTVA=this.calculateTVA(sumUpsellTva);var totalFeesHT=parseFloat(this.getFeesHT());var totalHT=(+this.packPrice+totalFeesHT).toFixed(2);var totalTTC=(parseFloat(totalHT)+parseFloat(totalTVA)+parseFloat(sumUpsell)).toFixed(2);// 
// Admin fees details
var adminFeesDetails=[];if(this.state.pack_data.admin_fees_detail){this.state.pack_data.admin_fees_detail.forEach(function(fee,i){var adminLi=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'pcnt-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pfi-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,fee.title,' ','-',' ',parseFloat(fee.fee).toFixed(2).toString().replace('.',','),' ','\u20AC',fee.subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),fee.subtitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},fee.helper));adminFeesDetails.push(adminLi);});}else{adminFeesDetails=false;}// Label fees details
var labelFees="";if(this.state.pack_data.labelFees){labelFees=this.state.pack_data.labelFees;}var isECSelectedPack=__WEBPACK_IMPORTED_MODULE_11__constants_hardcoded_checkout__["c" /* HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId)>-1&&this.props.chosen_pack===3;var shouldDisplay3xPayment=!isECSelectedPack&&!this.state.pack_data.remove3xPayment&&totalTTC>100&&!(this.props.promo_percentage&&parseFloat(this.props.promo_percentage));var displayedPackPrice=parseFloat(this.packPrice).toFixed(2).toString().replace('.',',');var displayedPackName=isECSelectedPack?'Creation Express':packName;var shouldDisplayUpsell=this.state.pack_data.shouldDisplayUpsell&&this.state.pack_data.upsell&&this.state.pack_data.upsell.length&&this.props.detailsCheckout[this.pack].upsell&&this.props.detailsCheckout[this.pack].upsell.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'checkout-core'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cc-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cc-pack-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-features-extend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pf-recap'},'R\xE9capitulatif de votre commande'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pf-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pft-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,displayedPackName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pf-price pfp-primary'},this.packPrice===0?'Offert':displayedPackPrice+' \u20AC')),packOptions),this.feesPack>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pf-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pft-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Frais administratifs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pft-mention'},'(Obligatoire)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pf-price'},this.feesPack.toFixed(2).toString().replace('.',','),' ','\u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pft-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,labelFees)),adminFeesDetails),isECSelectedPack&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-features-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pf-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pft-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Expert Comptable'))),this.state.pack_data.Expert_comptable.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'expertComptableOption-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pfi-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.title,item.subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),item.subtitle))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},item.helper));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pack-features-info-text'},'Vous serez contact\xE9 apr\xE8s le paiement pour les modalit\xE9s de la solution comptable. Le prix est de 100\u20AC par mois si paiement mensuel ou 85\u20AC par mois si paiement annuel.')))),shouldDisplayUpsell&&this.state.pack_data.upsell.map(function(UpsellElt,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpsellElt,{index:index,checkedUpsell:_this2.state.upsell[index],upsellInfo:_this2.props.detailsCheckout[_this2.pack].upsell[index],toggleUpsell:_this2.toggleUpsell});}),!this.state.pack_data.shouldHidePhoneAssistance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'condition-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cbx-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ch-title'},'Assistance LegalPlace'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-chbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'check9',onClick:this.toggleAssistance}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'check9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chbx-txt'},'(Optionnel)')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cbx-content is-disabled',ref:'assistance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'cbx-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Appels illimit\xE9s avec des juristes experts pour r\xE9pondre \xE0 vos questions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Des juristes experts en droit fiscal, droit social, droit commercial, etc. sont \xE0 votre disposition par t\xE9l\xE9phone pour r\xE9pondre \xE0 vos questions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Acc\xE8s illimit\xE9 \xE0 nos mod\xE8les de documents juridiques personnalisables'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Notre assistant intelligent \xE9dite vos documents juridiques sur mesure : CDI, CDD, CGV, contrat de freelance, pacte d\'associ\xE9s, accord de confidentialit\xE9, etc.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cbx-footer'},'30 jours d\u2019essai gratuit puis 29,90\u20AC/mois. Offre sans engagement, r\xE9siliable \xE0 tout moment. Vous ne serez pas d\xE9bit\xE9 si vous r\xE9siliez avant la fin de la p\xE9riode d\u2019essai')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cc-sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'is-sticky'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cc-cart lpc-desktop cc-cart--fixed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'xcta cta-payement has-spinner',onClick:function onClick(){return _this2.showCreditCardModal(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-lock'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn-text'},'Payez en toute s\xE9curit\xE9'))),shouldDisplay3xPayment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:x3PaymentStyle.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:x3PaymentStyle.text,onClick:function onClick(){return _this2.showCreditCardModal(true);}},' ','ou payez en 3 fois : ',(totalTTC/3).toFixed(2).toString().replace('.',','),' ','\u20AC',' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpc-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-row is-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-item'},prixHTLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-price'},totalHT.toString().replace('.',','),' ','\u20AC')),upsellWithTva,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-item'},'TVA d\xE9ductible'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-price'},totalTVA.toString().replace('.',','),' ','\u20AC')),upsellWithoutTva,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-row is-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-item'},'TOTAL TTC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-price'},totalTTC.toString().replace('.',','),' ','\u20AC'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payement-methods-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img-responsive',width:'163',height:'25',src:'/wizard/img/cc.svg',onClick:function onClick(){return _this2.showCreditCardModal(false);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-coupon is-open cart-coupon-md\n                        '+(this.props.promo_code.length>0?' focus':'')+'\n                        '+(this.props.promo_loading?' is-checking':'')+'\n                        '+(Number.isNaN(parseFloat(this.props.promo_percentage))?' error':'')+'\n                        '+(!Number.isNaN(parseFloat(this.props.promo_percentage))&&parseFloat(this.props.promo_percentage)>0?' is-valid':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Reduction de ',' '+parseFloat(this.props.promo_percentage)*100,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Code de r\xE9duction',type:'text',className:'form-control',onChange:function onChange(evt){return _this2.props.updatePromo(evt.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn cc-btn',type:'button',onClick:this.sendPromo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lpc-txt'},'Valider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'loading-spin'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'help-block'},this.props.promo_percentage)))),!this.state.pack_data.shouldHideReassurance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ma-wrapp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marketing-args'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media checkout-assistance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-phone-b.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Assistance T\xE9l\xE9phonique'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-stitle'},'Pour tout renseignement'))),!this.state.pack_data.remove3xPayment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media x3-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-euro-b.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Payez en 3 fois'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-stitle'},'Sans frais suppl\xE9mentaires'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media wg-avis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-avis-b.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Satisfaction Garantie'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rb-stars'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:starStyles,className:'icn-star-half'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wa-avis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://fr.trustpilot.com/review/legalplace.fr'},'sur 451 avis')))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__card_modal_next__["a" /* default */],{packPriceWithReduction:this.packPrice,upsell:this.state.upsell,show:this.state.show_modal,fees:this.feesPack,totalTVA:totalTVA,totalTTC:totalTTC||null,allow3xPayment:shouldDisplay3xPayment,closeEvent:function closeEvent(){return _this2.setState({show_modal:false});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__payment_modal__["a" /* default */],{show:this.state.show_modal1,closeEvent:function closeEvent(){return _this2.setState({show_modal1:false});}}));}}],[{key:'getPackData',value:function getPackData(props){switch(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractMetaId){/*
             * Checkout SAS (175) & Checkout SASU (176)
             */case 198:case 197:case 175:case 176:return{admin_fees_detail:[{title:'Frais de greffe obligatoire',fee:66.21,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais d'annonce légale obligatoire",fee:195.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')}],packs_names:['Création Express','Création Standard','Statuts seuls','Creation Offerte'],packs_contents:[{title:'Statuts de',dynamic:true,checks:[true,true,true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Les statuts, le M0, les pi\xE8ces annexes obligatoires et le registre des b\xE9n\xE9ficiaires effectifs ')// eslint-disable-line
},{title:'Vérification du dossier',checks:[true,true,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos formalistes v\xE9rifient et valident votre dossier, ils prennent contact avec vous au besoin')// eslint-disable-line
},{title:'Immatriculation auprès du greffe',checks:[true,true,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cette formalit\xE9 est obligatoire')},{title:'Garantie anti-rejet',checks:[true,true,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Il arrive parfois que le greffe rejette des dossiers afin de demander des informations compl\xE9mentaires. Nos experts g\xE8rent tous les cas de rejet')// eslint-disable-line
},{title:"Publication de l'annonce légale",checks:[true,true,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cette formalit\xE9 est obligatoire')},{title:'Obtention du Kbis',checks:[true,true,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Vous obtiendrez votre Kbis apr\xE8s v\xE9rification de votre dossier dans un d\xE9lai de 10 jours en moyenne')// eslint-disable-line
},{title:'Traitement express (24h)',checks:[true,false,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous traiterons votre dossier sous 24h. L\'obtention de votre num\xE9ro SIREN peut cependant prendre 10 jours en moyenne')// eslint-disable-line
},{title:'Assistance téléphonique illimitée',checks:[true,false,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos experts sont disponibles pour vous aider')}],Expert_comptable:[{title:'Expert comptable dédié',checks:[false,false,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Votre expert comptable d\xE9di\xE9 vous accompagne et vous conseille en permanence Les services inclus le bilan comptable, la d\xE9claration de TVA, le suivi de tr\xE9sorerie, etc')},{title:'Logiciel comptable',checks:[false,false,false,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos solutions logiciels de derni\xE8re g\xE9n\xE9ration automatisent jusqu\u2019\xE0 100% de votre comptabilit\xE9. Fini les d\xE9placements et la \xAB paperasse \xBB. Vous gagnez du temps !')}]};// SCI
case 124:return{admin_fees_detail:[{title:'Frais de greffe obligatoire',fee:95.10,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais d'annonce légale obligatoire",fee:195.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')}],packs_names:['Création Express','Création Standard','Statuts seuls'],packs_contents:[{title:'Statuts de',dynamic:true,checks:[true,true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Les statuts, le M0, les pi\xE8ces annexes obligatoires et le registre des b\xE9n\xE9ficiaires effectifs ')// eslint-disable-line
},{title:'Vérification du dossier',checks:[true,true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos formalistes v\xE9rifient et valident votre dossier, ils prennent contact avec vous au besoin')// eslint-disable-line
},{title:'Immatriculation auprès du greffe',checks:[true,true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cette formalit\xE9 est obligatoire')},{title:'Garantie anti-rejet',checks:[true,true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Il arrive parfois que le greffe rejette des dossiers afin de demander des informations compl\xE9mentaires. Nos experts g\xE8rent tous les cas de rejet')// eslint-disable-line
},{title:"Publication de l'annonce légale",checks:[true,true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cette formalit\xE9 est obligatoire')},{title:'Obtention du Kbis',checks:[true,true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Vous obtiendrez votre Kbis apr\xE8s v\xE9rification de votre dossier dans un d\xE9lai de 10 jours en moyenne')// eslint-disable-line
},{title:'Traitement express (24h)',checks:[true,false,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous traiterons votre dossier sous 24h. L\'obtention de votre num\xE9ro SIREN peut cependant prendre 10 jours en moyenne')// eslint-disable-line
},{title:'Assistance téléphonique illimitée',checks:[true,false,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos experts sont disponibles pour vous aider')}]};// Rupture conventionnelle
case 184:return{admin_fees_detail:false,packs_names:['Pack sérénité','Pack confort','Pack expert'],packs_contents:[{title:"Dossier juridique complet",dynamic:false,checks:[true,true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Accord de rupture conventionnelle, Cerfa 14598 pr\xE9-rempli, Lettre de fixation de rendez-vous avec le salari\xE9 ')},{title:"Vérification de l'ensemble du dossier par un avocat",checks:[true,true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'L\'avocat v\xE9rifie la conformit\xE9 de votre dossier sur la base de vos pi\xE8ces (contrat de travail, derni\xE8res fiches de paie)')},{title:"Calculs des indemnités par un avocat",checks:[true,true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'L\'avocat v\xE9rifie les points sensibles pour \xE9viter un refus d\'homologation sur la base des informations que vous avez renseign\xE9es')},{title:"Accompagnement tout au long de la procédure",checks:[true,false,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'L\'avocat vous aide \xE0 d\xE9finir la strat\xE9gie de rupture et vous accompagne tout au long de la proc\xE9dure')},{title:"Dépot du dossier jusqu'à homologation",checks:[true,false,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'L\'avocat vous accompagne jusqu\'\xE0 la finalisation de la rupture et son homologation')},{title:"Signature d'un accord transactionnel (si besoin)",checks:[true,false,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'L\'accord transactionnel vous pr\xE9munit contre les \xE9ventuelles actions prud\'hommales du salari\xE9. Cette option est recommand\xE9e en cas de situation confilictuelle avec le salari\xE9.')}]};/*
           * Auto-Entrepreneur
           */case 181:return{admin_fees_detail:false,shouldHidePhoneAssistance:true,shouldDisplayUpsell:true,upsell:[__WEBPACK_IMPORTED_MODULE_12__buy_upsell_pack_entrepreneur__["a" /* default */]],packs_names:['Création express','Création Standard'],packs_contents:[{title:'Dossier juridique complet',checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Votre dossier comprend:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- votre formulaire P0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- les documents annexes requis (mal sp\xE9cifi\xE9 la premi\xE8re fois)')))},{title:'Gérer les formalités administratives',checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Revue et validation de votre dossier par un formaliste '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- D\xE9pot de votre dossier aupr\xE8s du greffe ou du CFE '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Gestion des \xE9changes avec le greffe ou le CFE ')))},{title:'Obtention du numéro SIRET',checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cette formalit\xE9 est obligatoire')},{title:'Assistance téléphonique illimitée',checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos experts sont disponibles pour vous aider')},{title:'Traitement express (24h)',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous traiterons votre dossier sous 24h. L\'obtention de votre num\xE9ro SIRET peut cependant prendre 10 \xE0 15 jours')// eslint-disable-line
},{title:'Obtention de l\'ACRE (ex ACCRE)',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous nous chargeons de compl\xE9ter pour vous votre formulaire ACRE afin de vous permettre de b\xE9n\xE9ficier des r\xE9ductions d\'imp\xF4ts d\xE9di\xE9es au cr\xE9ateur d\'entreprise')// eslint-disable-line
}]};/*
           * Changement de siège social
           */case 227:return{admin_fees_detail:[{title:'Frais de greffe obligatoire',fee:195.38,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais d'annonce légale obligatoire",fee:110.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais de greffe - Modification du registre des bénéficiaires effectifs",fee:46.51,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais de greffe - Modification du registre des b\xE9n\xE9ficiaires effectifs')}],packs_names:['Pack express','Pack Standard'],remove3xPayment:true,shouldHideReassurance:true,shouldHidePhoneAssistance:true,packs_contents:[{title:'Vérification de votre dossier par un expert LegalPlace',checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',checks:[true,true]},{title:'Kbis mis à jour',checks:[true,true]},{title:'Mise à jour de la déclaration des bénéficiaires effectifs',checks:[true,true]},{title:'Assistance téléphonique illimitée',checks:[true,true]},{title:'Traitement express (24h)',checks:[true,false]}]};/*
           * Radiation d'Auto-Entreprise
           */case 219:return{admin_fees_detail:false,packs_names:['Radiation express','Radiation standard'],packs_contents:[{title:"Dossier juridique complet",checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Le dossier comprend votre formulaire P2 - P4')},{title:"Revue et validation de votre dossier par un formaliste",checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos formalistes v\xE9rifient et valident votre dossier, ils prennent contact avec vous au besoin')},{title:"Dépot de votre dossier auprès du greffe ou du CFE",checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cette formalit\xE9 est obligatoire')},{title:"Gestion des échanges avec le greffe ou le CFE",checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Des allers-retours avec l\'administration sont parfois n\xE9cessaires et sont enti\xE8rement assur\xE9s par nos formalistes')},{title:"Assistance téléphonique illimitée",checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos formalistes sont joiniables pour r\xE9pondre \xE0 vos questions')},{title:"Gestion express (moins de 48h)",checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous traiterons votre dossier sous 48h.')}]};case 229:return{admin_fees_detail:false,packs_names:['Élection simplifiée'],shouldHideReassurance:true,shouldHidePhoneAssistance:true,remove3xPayment:true,packs_contents:[{title:"Retroplanning",checks:[true]},{title:"Tous vos documents légaux sur-mesure",checks:[true]},{title:"Suivi de votre procédure par un expert",checks:[true]},{title:"Assistance téléphonique",checks:[true]}]};case 230:return{admin_fees_detail:false,packs_names:['Élection classique','Élection digitalisée'],shouldHideReassurance:true,shouldHidePhoneAssistance:true,remove3xPayment:true,packs_contents:[{title:"Retroplanning",checks:[true,true]},{title:"Tous vos documents légaux sur-mesure",checks:[true,true]},{title:"Suivi de votre procédure par un expert",checks:[true,true]},{title:"Assistance téléphonique",checks:[true,true]},{title:'Prise en charge totale de vos élections par vote électronique',checks:[true,true]}]};case 231:return{admin_fees_detail:false,packs_names:['Élection classique','Élection digitalisée'],shouldHideReassurance:true,shouldHidePhoneAssistance:true,remove3xPayment:true,packs_contents:[{title:"Retroplanning",checks:[true,true]},{title:"Tous vos documents légaux sur-mesure",checks:[true,true]},{title:"Suivi de votre procédure par un expert",checks:[true,true]},{title:"Assistance téléphonique",checks:[true,true]},{title:'Guide complet sur la marche à suivre pour l\'organisation de vos éléctions',checks:[false,true]},{title:'Scrutin réalisé par vote électronique',checks:[true,false]}]};// ASSO
case 162:return{admin_fees_detail:false,packs_names:['Création express','Statuts seuls'],packs_contents:[{title:"Statuts d'association + Dossier complet",checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Les statuts '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- PV d\'assembl\xE9e g\xE9n\xE9rale constitutive '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Bulletin d\'adh\xE9sion (pour les nouveaux nembres) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Re\xE7u de cotisation d\'adh\xE9sion '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Re\xE7u fiscal de don (pour les d\xE9ductions d\'imp\xF4ts en cas de don) ')))},{title:"Enregistrement de l'association",checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Formalit\xE9 obligatoire. Frais de 44 \u20AC \xE0 payer vous-m\xEAme lorsque vous recevrez une facture de l\'Administration (pour la publication dans le Journal Officiel Association)')// eslint-disable-line
},{title:'Échanges avec la préfecture',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'En cas de rejet de votre dossier apr\xE8s instruction par les autorit\xE9s administratives, nous vous assistons dans la reprise de votre dossier pour effectuer un nouveau d\xE9p\xF4t')// eslint-disable-line
},{title:'Assistance obtention du SIRET',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous vous pr\xE9parons les pi\xE8ces n\xE9cessaires pour l\'obtention du num\xE9ro SIRET de votre association si vous envisagez d\'en solliciter un (n\xE9cessaire dans certains cas)')// eslint-disable-line
},{title:'Assistance téléphonique illimitée',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos experts sont disponibles pour vous aider')},{title:'Traitement express (24h)',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous traiterons votre dossier sous 24h. L\'obtention de votre num\xE9ro SIRET peut cependant prendre 10 \xE0 15 jours')// eslint-disable-line
}]};/*
           * changement-denomination-sociale
           */case 287:return{admin_fees_detail:[{title:'Frais de greffe obligatoire',fee:242.81,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais d'annonce légale obligatoire",fee:100.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')}],packs_names:['Pack Express','Pack Standard'],remove3xPayment:true,shouldHideReassurance:true,shouldHidePhoneAssistance:true,packs_contents:[{title:'Vérification de votre dossier par un expert LegalPlace',checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',checks:[true,true]},{title:'Kbis mis à jour',checks:[true,true]},{title:'Mise à jour de la déclaration des bénéficiaires effectifs',checks:[true,true]},{title:'Assistance téléphonique illimitée',checks:[true,true]},{title:'Traitement express (24h)',checks:[true,false]}]};/*
           * Changement d'objet de société
           */case 296:return{admin_fees_detail:[{title:'Frais de greffe obligatoire',fee:195.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais d'annonce légale obligatoire",fee:125.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')}],packs_names:['Pack express','Pack Standard'],remove3xPayment:true,shouldHideReassurance:true,shouldHidePhoneAssistance:true,packs_contents:[{title:'Vérification de votre dossier par un expert LegalPlace',checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',checks:[true,true]},{title:'Kbis mis à jour',checks:[true,true]},{title:'Assistance téléphonique illimitée',checks:[true,true]},{title:'Traitement express (24h)',checks:[true,false]}]};/*
           * modifier-date-cloture-ex-social
           */case 301:return{admin_fees_detail:[{title:'Frais de greffe obligatoire',fee:80.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')}],packs_names:['Pack express','Pack Standard'],remove3xPayment:true,shouldHideReassurance:true,shouldHidePhoneAssistance:true,packs_contents:[{title:'Vérification de votre dossier par un expert LegalPlace',checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',checks:[true,true]},{title:'Kbis mis à jour',checks:[true,true]},{title:'Assistance téléphonique illimitée',checks:[true,true]},{title:'Traitement express (24h)',checks:[true,false]}]};// Changement Siège Social EXT
case 616:return{admin_fees_detail:[{title:'Frais de greffe obligatoire',fee:251.05,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais d'annonce légale obligatoire",subtitle:"(ancien département)",fee:110.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais d'annonce légale obligatoire",subtitle:"(nouveau département)",fee:110.00,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais ind\xE9pendant de LegalPlace')},{title:"Frais de greffe - Modification du registre des bénéficiaires effectifs",fee:46.51,helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Frais de greffe - Modification du registre des b\xE9n\xE9ficiaires effectifs')}],packs_names:['Pack express','Pack Standard'],remove3xPayment:true,shouldHideReassurance:true,shouldHidePhoneAssistance:true,packs_contents:[{title:'Vérification de votre dossier par un expert LegalPlace',checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',checks:[true,true]},{title:'Kbis mis à jour',checks:[true,true]},{title:'Mise à jour de la déclaration des bénéficiaires effectifs',checks:[true,true]},{title:'Assistance téléphonique illimitée',checks:[true,true]},{title:'Traitement express (24h)',checks:[true,false]}]};// Devenir Artisan 
case 680:return{admin_fees_detail:false,labelFees:'Frais de traitement du dossier auprès de la CMA',shouldHidePhoneAssistance:true,remove3xPayment:true,shouldDisplayUpsell:true,upsell:[__WEBPACK_IMPORTED_MODULE_12__buy_upsell_pack_entrepreneur__["a" /* default */]],packs_names:['Création express','Création Standard'],packs_contents:[{title:'Dossier juridique complet Artisan',checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Votre dossier comprend:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- votre formulaire P0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- les documents annexes requis (mal sp\xE9cifi\xE9 la premi\xE8re fois)')))},{title:'Gérer les formalités administratives',checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Revue et validation de votre dossier par un formaliste '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- D\xE9pot de votre dossier aupr\xE8s du greffe ou du CFE '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Gestion des \xE9changes avec le greffe ou le CFE ')))},{title:'Obtention du numéro SIRET',checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Cette formalit\xE9 est obligatoire')},{title:'Assistance téléphonique illimitée',checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos experts sont disponibles pour vous aider')},{title:'Traitement express (24h)',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous traiterons votre dossier sous 24h. L\'obtention de votre num\xE9ro SIRET peut cependant prendre 10 \xE0 15 jours')// eslint-disable-line
},{title:'Obtention de l\'ACRE (ex ACCRE)',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous nous chargeons de compl\xE9ter pour vous votre formulaire ACRE afin de vous permettre de b\xE9n\xE9ficier des r\xE9ductions d\'imp\xF4ts d\xE9di\xE9es au cr\xE9ateur d\'entreprise')// eslint-disable-line
}]};default:return{admin_fees_detail:false,packs_names:['Création express','Statuts seuls'],remove3xPayment:true,packs_contents:[{title:"Statuts d'association + Dossier complet",checks:[true,true],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Les statuts '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- PV d\'assembl\xE9e g\xE9n\xE9rale constitutive '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Bulletin d\'adh\xE9sion (pour les nouveaux nembres) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Re\xE7u de cotisation d\'adh\xE9sion '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'- Re\xE7u fiscal de don (pour les d\xE9ductions d\'imp\xF4ts en cas de don) ')))},{title:"Enregistrement de l'association",checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Formalit\xE9 obligatoire. Frais de 44 \u20AC \xE0 payer vous-m\xEAme lorsque vous recevrez une facture de l\'Administration (pour la publication dans le Journal Officiel Association)')// eslint-disable-line
},{title:'Échanges avec la préfecture',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'En cas de rejet de votre dossier apr\xE8s instruction par les autorit\xE9s administratives, nous vous assistons dans la reprise de votre dossier pour effectuer un nouveau d\xE9p\xF4t')// eslint-disable-line
},{title:'Assistance obtention du SIRET',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous vous pr\xE9parons les pi\xE8ces n\xE9cessaires pour l\'obtention du num\xE9ro SIRET de votre association si vous envisagez d\'en solliciter un (n\xE9cessaire dans certains cas)')// eslint-disable-line
},{title:'Assistance téléphonique illimitée',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nos experts sont disponibles pour vous aider')},{title:'Traitement express (24h)',checks:[true,false],helper:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Nous traiterons votre dossier sous 24h. L\'obtention de votre num\xE9ro SIRET peut cependant prendre 10 \xE0 15 jours')// eslint-disable-line
}]};}}}]);return _CePackChoiceTwoNext;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.checkoutsetPrices=function(){switch(_this3.props.chosen_pack){case 0:_this3.packPrice=+_this3.props.first_price;_this3.feesPack=+_this3.props.first_fee;_this3.pack='first_price';break;case 1:_this3.packPrice=+_this3.props.second_price;_this3.feesPack=+_this3.props.second_fee;_this3.pack='second_price';break;case 3:_this3.packPrice=+_this3.props.fourth_price;_this3.feesPack=+_this3.props.fourth_fee;_this3.pack='fourth_price';break;default:_this3.packPrice=+_this3.props.third_price;_this3.feesPack=+_this3.props.third_fee;_this3.pack='third_price';break;}};this.upsellCart=function(label,price){var tva=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-item'},label||'',' ',label&&tva?'HT':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-price'},price?price.toString().replace('.',',')+' \u20AC':''));};this.getUpsellInfo=function(){//get upsell from  state
var upsell=_this3.state.upsell;// get upsell from store
var upsellArray=_this3.props.detailsCheckout[_this3.pack].upsell;// intialize variablse
var upsellWithTva=[];var upsellWithoutTva=[];var sumUpsellTva=0,sumUpsell=0;if(upsell&&upsellArray&&upsellArray.length){for(var i=0;i<upsellArray.length;i++){var _upsellArray$i=upsellArray[i],label=_upsellArray$i.label,price=_upsellArray$i.price,tva=_upsellArray$i.tva;if(upsell[i]){if(tva){sumUpsellTva+=+price*0.2;upsellWithTva.push(_this3.upsellCart(label,price.toFixed(2),tva));}else{upsellWithoutTva.push(_this3.upsellCart(label,price.toFixed(2)));}sumUpsell+=+price;}}}//sumUpsellTva will be added to tva
//sumUpsell will be added to ttc
//upsellWithTva display list before TVA
//upsellWithoutTval display list after TVA 
return{sumUpsellTva:sumUpsellTva,sumUpsell:sumUpsell,upsellWithTva:upsellWithTva,upsellWithoutTva:upsellWithoutTva};};this.calculateTVA=function(sumUpsellTva){var sumTva=0;if(typeof _this3.packPrice!=='undefined'&&typeof _this3.pack!=='undefined'&&_this3.props.detailsCheckout&&_this3.props.detailsCheckout[_this3.pack]){var feesArray=_this3.props.detailsCheckout[_this3.pack].fees;sumTva=+_this3.packPrice*0.2;if(feesArray&&feesArray.length){feesArray.forEach(function(feeItem){if(feeItem.tva){sumTva+=+feeItem.price*0.2;}});}}sumTva+=+sumUpsellTva;return sumTva.toFixed(2);};this.getFeesHT=function(){var sumFeesHT=0;if(typeof _this3.pack!=='undefined'&&_this3.props.detailsCheckout&&_this3.props.detailsCheckout[_this3.pack]){var feesArray=_this3.props.detailsCheckout[_this3.pack].fees;if(feesArray&&feesArray.length){feesArray.forEach(function(feeItem){sumFeesHT+=+feeItem.price;});}}return sumFeesHT.toFixed(2);};this.toggleUpsell=function(index){var upsellState=[].concat(_toConsumableArray(_this3.state.upsell));upsellState[index]=!upsellState[index];_this3.setState({upsell:upsellState});};};var mapStateToProps=function mapStateToProps(state){return{title:state.contract.name,first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price,third_price:state.checkout_operations.prices.third_price,fourth_price:state.checkout_operations.prices.fourth_price,first_fee:typeof state.checkout_operations.admin_fees!=='undefined'?state.checkout_operations.admin_fees.first_price:0,second_fee:typeof state.checkout_operations.admin_fees!=='undefined'?state.checkout_operations.admin_fees.second_price:0,third_fee:typeof state.checkout_operations.admin_fees!=='undefined'?state.checkout_operations.admin_fees.third_price:0,fourth_fee:typeof state.checkout_operations.admin_fees!=='undefined'?state.checkout_operations.admin_fees.fourth_price:0,detailsCheckout:state.checkout_operations.detailsCheckout,upsellArrayChecked:state.checkout_operations.packEntrepreneur.upsellArray,chosen_pack:state.checkout_operations.pack,pricing_loading:state.loading_details.pricing,has_call:state.checkout_operations.has_call,has_letter:state.checkout_operations.has_letter,letter_number:state.checkout_operations.letter.number,pack_price:state.checkout_operations.pack===0?state.checkout_operations.prices.first_price:state.checkout_operations.prices.second_price,promo_code:state.checkout_operations.promo_code,contract_id:state.checkout_operations.contract_id,promo_loading:state.checkout_operations.promo_loading,promo_percentage:state.checkout_operations.promo_percentage,price_loading:state.loading_details.pricing,client_email:state.account_settings.mail,card:state.account_settings.card,x3:state.account_settings.x3,paypal:state.account_settings.paypal,is_crea_assist_sub:state.account_settings.is_crea_assist_sub};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updatePaymentMethod:function updatePaymentMethod(meth){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["N" /* ckPaymentSelect */])(meth));},updatePromo:function updatePromo(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["W" /* ckUpdatePromoCode */])(val));},checkPromo:function checkPromo(coupon,contractId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["O" /* ckSendPromoCode */])(coupon,contractId));__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["f" /* P_CHECK_PROMO */]);},setCard:function setCard(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["p" /* setCardPayment */])(val));},set3X:function set3X(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["t" /* setX3Payment */])(val));},setPaypal:function setPaypal(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["s" /* setPaypalPayment */])(val));},setDirect:function setDirect(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["r" /* setDirectPayment */])(val));},setCreatAssist:function setCreatAssist(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__redux_actions_account_settings__["q" /* setCreatAssist */])(val));}};};var CePackChoiceTwoNext=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_CePackChoiceTwoNext);/* harmony default export */ __webpack_exports__["a"] = (CePackChoiceTwoNext);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_masked_input__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_actions_contract__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_stripe_element__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_hardcoded_checkout__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/card_modal.js
* Author: Amine Azizi
* Version: 1.0
*/// intiialization of errors payment errors
function initErrors(){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('credit-error');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('credit.number');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('card.exp');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('card.cvc');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('card.number');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('direct.name');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('direct.iban');Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["c" /* unraiseError */])('global');}var linkStyle={cursor:'pointer'};var divStyle={none:{display:'none'},block:{display:'block'}};var _CardModalNext=function(_Component){_inherits(_CardModalNext,_Component);function _CardModalNext(props){_classCallCheck(this,_CardModalNext);var _this=_possibleConstructorReturn(this,(_CardModalNext.__proto__||Object.getPrototypeOf(_CardModalNext)).call(this,props));_this.selectPrice=function(){var selectedPrice=void 0;switch(_this.props.selected_pack){case 0:selectedPrice='first_price';break;case 1:selectedPrice='second_price';break;case 3:selectedPrice='fourth_price';break;default:selectedPrice='third_price';break;}return selectedPrice;};_this.updateCardNumber=_this.updateCardNumber.bind(_this);_this.updateCardExpiration=_this.updateCardExpiration.bind(_this);_this.updateCardCCV=_this.updateCardCCV.bind(_this);_this.updateName=_this.updateName.bind(_this);// this.updateIban = this.updateIban.bind(this);
_this.initiatePayment=_this.initiatePayment.bind(_this);_this.updateCheckBox=_this.updateCheckBox.bind(_this);_this.totalPriceTTC=_this.totalPriceTTC.bind(_this);_this.choosePaymentMode=_this.choosePaymentMode.bind(_this);_this.iban=Object(__WEBPACK_IMPORTED_MODULE_13__utils_stripe_element__["b" /* stripeElement */])();// do the changes in the card type
_this.state={direct_name_error:''};return _this;}_createClass(_CardModalNext,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var that=this;var a=document.getElementById('checkout-modal');document.getElementById('checkout-modal').addEventListener('click',function(e){if(e.target===a||e.target===that.refs.close_btn){_this2.props.closeEvent();__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.checkout.resetCreditCardInformation();}__WEBPACK_IMPORTED_MODULE_8__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_8__tracking_pattern_detector__["g" /* P_CLOSE_PAIMENT */]);});// console.log("kkkk")
}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(document.getElementById('iban-element')){this.iban.mount('#iban-element');var errorMessage=document.getElementById('error-message');var bankName=document.getElementById('bank-name');this.iban.on('change',function(event){// Handle real-time validation errors from the iban Element.
if(event.error){errorMessage.textContent=event.error.message;errorMessage.classList.add('visible');}else{errorMessage.classList.remove('visible');}// Display bank name corresponding to IBAN, if available.
if(event.bankName){bankName.textContent=event.bankName;bankName.classList.add('visible');}else{bankName.classList.remove('visible');}});}if(!prevProps.show&&this.props.show){if(this.refs.credit_card_modal){document.getElementById('checkout-modal').appendChild(this.refs.credit_card_modal);document.getElementById('checkout-modal').classList.add('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='blur(5px)';document.body.style.overflow='hidden';__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.utils.addModalClassToBody();}}if(prevProps.show&&!this.props.show){document.getElementById('checkout-modal').classList.remove('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.utils.removeModalClassToBody();}if(paypal&&!document.querySelector('.paypal-buttons')&&document.querySelector('#paypal-container')){paypal.Buttons({style:{color:'blue',fundingicons:'false',layout:'horizontal',tagline:'false'},onClick:function onClick(data,actions){if(!_this3.props.confirmation){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',20,Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."));return actions.reject();}},createOrder:function createOrder(data,actions){return actions.order.create({purchase_units:[{amount:{currency_code:'EUR',value:_this3.totalPriceTTC().toFixed(2)}}]});},onApprove:function onApprove(data,actions){return actions.order.capture().then(function(response){_this3.initiatePayment(data.orderID,response.payer.email_address);});}}).render('#paypal-container');}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(document.getElementById('checkout-modal').firstChild)document.getElementById('checkout-modal').removeChild(document.getElementById('checkout-modal').firstChild);document.getElementById('checkout-modal').classList.remove('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.utils.removeModalClassToBody();}// TODO: better things.
},{key:'updateCardNumber',value:function updateCardNumber(evt){this.props.updateCardNumber(evt.target.value);}},{key:'updateCardExpiration',value:function updateCardExpiration(evt){this.props.dispatchUpdateCardExpiration(evt.target.value);}},{key:'updateCardCCV',value:function updateCardCCV(evt){this.props.dispatchUpdateCardCCV(evt.target.value);}},{key:'updateCheckBox',value:function updateCheckBox(evt){this.props.updateConfirmation(evt.target.checked);}},{key:'updateName',value:function updateName(evt){this.props.updateName_(evt.target.value);}// updateIban(evt){
//     this.props.updateIban_(evt.target.value);
// }
},{key:'choosePaymentMode',value:function choosePaymentMode(e){var chosenMode=e.currentTarget.attributes['data-mode'].value;if(chosenMode==='card'){this.props.setCard(true);this.props.set3X(false);this.props.setPaypal(false);this.props.setDirect(false);this.props.updatePaymentMethod(0);__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.checkout.resetCheckedCondition();}else if(chosenMode==='3x'){this.props.setCard(false);this.props.set3X(true);this.props.setPaypal(false);this.props.setDirect(false);this.props.updatePaymentMethod(0);__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.checkout.resetCheckedCondition();}else if(chosenMode=="direct"){this.props.setCard(false);this.props.set3X(false);this.props.setPaypal(false);this.props.setDirect(true);this.props.updatePaymentMethod(2);__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.checkout.resetCheckedCondition();}else{this.props.setCard(false);this.props.set3X(false);this.props.setPaypal(true);this.props.setDirect(false);this.props.updatePaymentMethod(1);__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].ops.checkout.resetCheckedCondition();}initErrors();}},{key:'initiatePayment',value:function initiatePayment(){var _this4=this;// if(this.props.confirmation){
this.props.loading();initErrors();// pattern.
__WEBPACK_IMPORTED_MODULE_8__tracking_pattern_detector__["p" /* lpPattern */].trackLastAction(__WEBPACK_IMPORTED_MODULE_8__tracking_pattern_detector__["i" /* P_PAY */]);__WEBPACK_IMPORTED_MODULE_8__tracking_pattern_detector__["p" /* lpPattern */].sendAndResetTracker();var selectedPrice=this.selectPrice();//---------------------============================= Credit Card
if(this.props.payment_method===0){// credit card
window.lp_payment.handleTransaction({type:'card',card:{number:this.props.card_number,cvc:!this.props.card_ccv.includes(' ')?this.props.card_ccv:this.props.card_ccv.slice(0,3),exp:this.props.card_expiration},contract_id:this.props.contract_id,pack:selectedPrice,invoice:{},coupon_code:this.props.promo_code,client_email:this.props.mail,pack_price:this.props.pack_price,document_name:__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].contractTitle,cgv:this.props.confirmation,is_installment:this.props.x3,is_crea_assist_sub:this.props.is_crea_assist_sub,price:this.totalPriceTTC(),paymentMethod:this.props.x3?'stripe_x3':'stripe',upsell:this.props.upsell,revenue:this.totalRevenue(),orderShipping:this.props.fees,packPriceWithReduction:this.props.packPriceWithReduction,orderTax:this.props.totalTVA,acteProduct:false}).then(function(response){if(response.STATUS==='SUCCESS'){window.localStorage.setItem('purchaseScore',response.purchaseScore);__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].setPayed(true);if(response.redirect!==undefined){window.onbeforeunload=null;_this4.props.setReprise(true);_this4.props.setRepriseLink(response.redirect);}_this4.props.closeEvent();}_this4.props.unloading();}).catch(function(error){try{var errorMessage=error&&error.length&&error[0].message;__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackErrorPaymentCheckout(errorMessage);}catch(er){console.log("error",er);}var err=void 0;if(error.gcv){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,error.gcv);err=error.ae;}else err=error;if(err.length&&err.length>0){err.forEach(function(idx){if(idx.hook==='global')Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',10,idx.message);else Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])(idx.hook,10,idx.message);});}// test if the thing is Error type
if(err instanceof Error){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,err.message);}_this4.props.unloading();});//-----------------============================= Direct Debit
}else if(this.props.payment_method===2){//Test the name form
if(this.props.direct_name.length==""){this.setState({direct_name_error:"Veuillez saisir votre nom"});this.props.unloading();return;}var valid_name=/^[a-zA-Z0-9_]{5,30}$/;if(valid_name.test(this.props.direct_name)){this.setState({direct_name_error:"Le format de votre nom semble incorrect"});this.props.unloading();return;}//Creat the token
var sourceData={type:'sepa_debit',currency:'eur',owner:{name:this.props.direct_name,email:this.props.mail},mandate:{// Automatically send a mandate notification email to your customer
// once the source is charged.
notification_method:'email'}};var that=this;__WEBPACK_IMPORTED_MODULE_13__utils_stripe_element__["a" /* stripe */].createSource(this.iban,sourceData).then(function(result){if(result.error){// Inform the customer that there was an error.
Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,result.error.message);_this4.props.unloading();}else{// Send the Source to your server to create a charge.
// stripeSourceHandler(result.source);
window.lp_payment.handleTransaction({type:'sepa_debit',iban_source:result.source,contract_id:that.props.contract_id,pack:selectedPrice,options:[],invoic:{},coupon:that.props.promo_code,price:that.totalPriceTTC(),locale:'fr_FR',client_email:that.props.mail,document_name:window.contractName,upsell:_this4.props.upsell,paymentMethod:'sepa_debit',revenue:_this4.totalRevenue(),orderShipping:_this4.props.fees,packPriceWithReduction:_this4.props.packPriceWithReduction,orderTax:_this4.props.totalTVA,acteProduct:false}).then(function(response){if(response.STATUS==='SUCCESS'){window.localStorage.setItem('purchaseScore',response.purchaseScore);__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].setPayed(true);if(response.redirect!==undefined){window.onbeforeunload=null;that.props.setReprise(true);that.props.setRepriseLink(response.redirect);}that.props.closeEvent();}that.props.unloading();}).catch(function(error){try{var errorMessage=error&&error.length&&error[0].message;__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackErrorPaymentCheckout(errorMessage);}catch(er){console.log("error",er);}var err=[];if(err.length&&err.length>0){err.forEach(function(idx){if(idx.hook==='global')Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',10,idx.message);else Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])(idx.hook,10,idx.message);});}// test if the thing is Error type
if(err instanceof Error){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,err.message);}that.props.unloading();});}});//send it to the backend
//-----------------============================= Paypal
}else{if(!this.props.confirmation){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',20,Object(__WEBPACK_IMPORTED_MODULE_9__logic_wording__["a" /* _lp */])("Vous devez lire et accepter nos conditions générales de vente et d'utilisation."));this.props.unloading();return;}var _pack=this.selectPrice();window.lp_payment.handleTransaction({type:'paypal',contract_id:this.props.contract_id,pack:_pack,options:[],invoice:{},pack_price:this.props.pack_price,coupon:this.props.promo_code,price:this.totalPriceTTC().toFixed(2),locale:'fr_FR',client_email:this.props.mail,document_name:window.contractName,cgv:this.props.confirmation,upsell:this.props.upsell,paymentMethod:'paypal',revenue:this.totalRevenue(),orderShipping:this.props.fees,packPriceWithReduction:this.props.packPriceWithReduction,orderTax:this.props.totalTVA,acteProduct:false}).then(function(response){if(response.STATUS==='SUCCESS'){__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].setPayed(true);window.localStorage.setItem('purchaseScore',response.purchaseScore);if(response.redirect!==undefined){window.onbeforeunload=null;_this4.props.setReprise(true);_this4.props.setRepriseLink(response.redirect);}_this4.props.closeEvent();}_this4.props.unloading();}).catch(function(error){try{var errorMessage=error&&error.length&&error[0].message;__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackErrorPaymentCheckout(errorMessage);}catch(er){console.log("error",er);}var err=void 0;if(error.gcv){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,error.gcv);err=error.ae;}else err=error;if(err.length&&err.length>0){err.forEach(function(idx){if(idx.hook==='global')Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',10,idx.message);else Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])(idx.hook,10,idx.message);});}// test if the thing is Error type
if(err instanceof Error){Object(__WEBPACK_IMPORTED_MODULE_6__errors_error__["b" /* raiseError */])('credit-error',12,err.message);}_this4.props.unloading();});}var pack=this.selectPrice();var eventParams={};eventParams['Chosen price']=this.props.price[pack];eventParams['Total price']=this.totalPriceTTC();eventParams['Chosen pack']=pack;eventParams['Payment method']=this.props.payment_method===0?'Stripe':'Paypal';__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].track('Asked Payment',eventParams);__WEBPACK_IMPORTED_MODULE_5__tracking_lpevents__["a" /* default */].trackClickPayment();}},{key:'totalPriceTTC',value:function totalPriceTTC(){if(this.props.totalTTC)return parseFloat(this.props.totalTTC);var thePrice=this.props.pack_price;// In case of reduction we show it
if(this.props.promo_percentage&&parseFloat(this.props.promo_percentage)>0){thePrice-=thePrice*this.props.promo_percentage;}// Calculating cart prices
var legalAnnonce=this.props.pack_fees>=195?195:0;var totalHT=thePrice+(this.props.pack_fees||0);var totalTVA=thePrice*1.2-thePrice+(legalAnnonce*1.2-legalAnnonce);window.xPcsiUD7J=parseFloat(totalHT)+parseFloat(totalTVA);return parseFloat(totalHT)+parseFloat(totalTVA);}},{key:'totalRevenue',value:function totalRevenue(){var thePrice=this.props.pack_price;// In case of reduction we show it
if(this.props.promo_percentage&&parseFloat(this.props.promo_percentage)>0){thePrice-=thePrice*this.props.promo_percentage;}// Calculating cart prices
var legalAnnonceRevenue=this.props.pack_fees>=195?75:0;return thePrice+legalAnnonceRevenue;}},{key:'render',value:function render(){var _this5=this;var cgvLink=Object.keys(__WEBPACK_IMPORTED_MODULE_14__constants_hardcoded_checkout__["a" /* CUSTOM_CGV_LINK_PER_META_IDS */]).indexOf(''+__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].contractMetaId)>-1?__WEBPACK_IMPORTED_MODULE_14__constants_hardcoded_checkout__["a" /* CUSTOM_CGV_LINK_PER_META_IDS */][__WEBPACK_IMPORTED_MODULE_10__app_lp_app__["a" /* default */].contractMetaId]:'https://www.legalplace.fr/conditions-generales/';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'credit_card_modal',className:'lpm-container'},this.props.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'close_btn',className:'lpm-close icn-x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkout-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'cp-title'},'Choisissez votre moyen de paiement'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-mode':'card',style:linkStyle,onClick:this.choosePaymentMode,className:'tn-btn'+(this.props.card?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pc-tab-radio'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tnb-text'},'\xA0 Carte bancaire')),this.props.allow3xPayment&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-mode':'3x',style:linkStyle,onClick:this.choosePaymentMode,className:'tn-btn'+(this.props.x3?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pc-tab-radio'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tnb-text'},'\xA0 CB en',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'3 fois'))),!this.props.is_crea_assist_sub?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-mode':'paypal',style:linkStyle,onClick:this.choosePaymentMode,className:'tn-btn'+(this.props.paypal?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pc-tab-radio'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tnb-text'},'\xA0',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'PayPal'))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-mode':'direct',style:linkStyle,onClick:this.choosePaymentMode,className:'tn-btn'+(this.props.direct?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pc-tab-radio'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tnb-text'},'\xA0',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Pr\xE9l\xE8vement')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.card?divStyle.block:divStyle.none,className:'tab-content cb-payement one-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-payement'},this.props.credit_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.props.credit_error.message,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group form-payement__card-number'+(this.props.error_card?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper','cypress-id':'cc-number-1time'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Num\xE9ro de la carte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!!! !!!! !!!! !!!!',type:'text',className:'form-control',autoComplete:'cc-number',value:this.props.card_number,onChange:this.updateCardNumber}),this.props.error_card&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},' ',this.props.error_card.message,' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6 form-payement__exp-date'+(this.props.error_exp?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date d\'expiration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!/!!',placeholder:'MM - AA',type:'text',className:'form-control',autoComplete:'cc-exp',value:this.props.card_expiration,onChange:this.updateCardExpiration}),this.props.error_exp&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},' ',this.props.error_exp.message,' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6 form-payement__cv'+(this.props.error_cvc?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Cryptogramme visuel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wzh-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'95',src:'/wizard/img/icn-crypto-w.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Les trois derniers chiffres imprim\xE9s au dos de votre carte de cr\xE9dit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!!!',type:'text',className:'form-control',autoComplete:'cc-csc',value:this.props.card_ccv,onChange:this.updateCardCCV}),this.props.error_cvc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},' ',this.props.error_cvc.message,' ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payement-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 cp-conditions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-chbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'check1',value:this.props.confirmation,onClick:this.updateCheckBox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'check1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chbx-txt'},'En cochant cette case, j\'accepte les',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:cgvLink},'conditions g\xE9n\xE9rales'),this.props.is_crea_assist_sub?' et les ':'',this.props.is_crea_assist_sub?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.legalplace.fr/conditions-generales-abonnement/'},'conditions g\xE9n\xE9rales d\'abonnement'):'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'xcta cta-payement has-spinner'+(this.props.loading_payment?' is-checking':''),href:'javascript:void(0)',onClick:this.props.loading_payment?function(){}:this.initiatePayment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn-text'},'Payer',' ',this.totalPriceTTC().toFixed(2).toString().replace('.',','),' ','\u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secure-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-lock'}),'Paiement s\xE9curis\xE9')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.x3?divStyle.block:divStyle.none,className:'tab-content cb-payement three-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-payement'},this.props.credit_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.props.credit_error.message,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group form-payement__card-number'+(this.props.error_card?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Num\xE9ro de la carte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!!! !!!! !!!! !!!!',type:'text',className:'form-control',autoComplete:'cc-number',value:this.props.card_number,onChange:this.updateCardNumber}),this.props.error_card&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},' ',this.props.error_card.message,' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6 form-payement__exp-date'+(this.props.error_exp?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Date d\'expiration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!/!!',placeholder:'MM - AA',type:'text',className:'form-control',autoComplete:'cc-exp',value:this.props.card_expiration,onChange:this.updateCardExpiration}),this.props.error_exp&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},' ',this.props.error_exp.message,' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6 form-payement__cv'+(this.props.error_cvc?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Cryptogramme visuel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wz-helper on-top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wzh-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'95',src:'/wizard/img/icn-crypto-w.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Les trois derniers chiffres imprim\xE9s au dos de votre carte de cr\xE9dit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__misc_masked_input__["a" /* default */],{mask:'!!!!',type:'text',className:'form-control',autoComplete:'cc-csc',value:this.props.card_ccv,onChange:this.updateCardCCV}),this.props.error_cvc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},' ',this.props.error_cvc.message,' ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payement-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 cp-conditions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-chbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'check3',value:this.props.confirmation,onClick:this.updateCheckBox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'check3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chbx-txt'},'En cochant cette case, j\'accepte les',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:cgvLink},'conditions g\xE9n\xE9rales'),this.props.is_crea_assist_sub?' et les ':'',this.props.is_crea_assist_sub?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.legalplace.fr/conditions-generales-abonnement/'},'conditions g\xE9n\xE9rales d\'abonnement'):'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'xcta cta-payement has-spinner'+(this.props.loading_payment?' is-checking':''),onClick:this.props.loading_payment&&this.state.payment_loading?function(){}:function(){return _this5.initiatePayment();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),this.props.loading_payment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'24',src:'/wizard/img/lp-spinner.svg'}):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn-text'},'Payer ',' ',(this.totalPriceTTC()/3).toFixed(2).toString().replace('.',','),' ','\u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secure-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-lock'}),'Paiement s\xE9curis\xE9'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cp-infos'},'Trois mensualit\xE9s de',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,(this.totalPriceTTC()/3).toFixed(2).toString().replace('.',','),' ','\u20AC'),', sans frais suppl\xE9mentaires.')))),!this.props.is_crea_assist_sub?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.paypal?divStyle.block:divStyle.none,className:'tab-content paypal-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-payement'},this.props.credit_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.props.credit_error.message,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payement-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-chbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'check2',value:this.props.confirmation,onClick:this.updateCheckBox}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'check2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chbx-txt'},'En cochant cette case, j\'accepte les',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:cgvLink},'conditions g\xE9n\xE9rales'),this.props.is_crea_assist_sub?' et les ':'',this.props.is_crea_assist_sub?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://www.legalplace.fr/conditions-generales-abonnement/'},'conditions g\xE9n\xE9rales d\'abonnement'):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'paypal-container',className:'paypal-crea-button'})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.direct==true?divStyle.block:divStyle.none,className:'tab-content prelevement-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-payement'},this.props.credit_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.props.credit_error.message,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group form-payement__name"'+(this.state.direct_name_error?' error':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Nom et pr\xE9nom'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',value:this.props.direct_name,onChange:this.updateName}),this.state.direct_name_error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},' ',this.state.direct_name_error,' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group form-payement__iban'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fg-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'IBAN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fc-wrapper',id:'iban-element'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'bank-name'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'error-message',role:'alert'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payement-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'--has-spinner cta-payement'+(this.props.loading_payment?' --is-checking':''),onClick:this.props.loading_payment?function(){}:this.initiatePayment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn-text'},'Payer',' ',this.totalPriceTTC().toFixed(2).toString().replace('.',','),' ','\u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'iban-text'},'En fournissant votre IBAN et en confirmant ce paiement, vous autorisez legalplace.fr et Stripe, notre prestataire de services de paiement, \xE0 envoyer des instructions \xE0 votre banque pour d\xE9biter votre compte conform\xE9ment \xE0 ces instructions. Vous avez droit \xE0 un remboursement de votre banque selon les termes et conditions de votre accord avec votre banque. Un remboursement doit \xEAtre r\xE9clam\xE9 dans un d\xE9lai de 8 semaines \xE0 compter de la date \xE0 laquelle votre compte a \xE9t\xE9 d\xE9bit\xE9.'))))))))));}}]);return _CardModalNext;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var packPrice=void 0;var packFees=void 0;switch(state.checkout_operations.pack){case 0:packPrice=state.checkout_operations.prices.first_price;packFees=state.checkout_operations.admin_fees.first_price;break;case 1:packPrice=state.checkout_operations.prices.second_price;packFees=state.checkout_operations.admin_fees.second_price;break;case 3:packPrice=state.checkout_operations.prices.fourth_price;packFees=state.checkout_operations.admin_fees.fourth_price;break;default:packPrice=state.checkout_operations.prices.third_price;packFees=state.checkout_operations.admin_fees.third_price;}return{payment_method:state.checkout_operations.payment_method,card_number:state.checkout_operations.credit_card.number,card_expiration:state.checkout_operations.credit_card.expiration,card_ccv:state.checkout_operations.credit_card.ccv,direct_name:state.checkout_operations.direct_name,direct_iban:state.checkout_operations.direct_iban,contract_id:state.checkout_operations.contract_id,selected_pack:state.checkout_operations.pack,price:state.checkout_operations.prices,call_chosen:state.checkout_operations.has_call,letter_chosen:state.checkout_operations.has_letter,// now with the letter informayion
letter_number:state.checkout_operations.letter.number,letter_zip:state.checkout_operations.letter.zip,letter_city:state.checkout_operations.letter.city,letter_address:state.checkout_operations.letter.address,letter_name:state.checkout_operations.letter.name,// coupone code
promo_code:state.checkout_operations.promo_code,confirmation:state.checkout_operations.confirm,promo_percentage:state.checkout_operations.promo_percentage,pack_price:packPrice,pack_fees:packFees,// the errors are here
credit_error:state.errors.components['credit-error'],error_card:state.errors.components['card.number'],error_exp:state.errors.components['card.exp'],error_cvc:state.errors.components['card.cvc'],error_direct_name:state.errors.components['direct.name'],error_direct_iban:state.errors.components['direct.iban'],// payment loading
loading_payment:state.loading_details.checking_payment,// For payment add
mail:state.account_settings.mail,card:state.account_settings.card,x3:state.account_settings.x3,paypal:state.account_settings.paypal,direct:state.account_settings.direct,is_crea_assist_sub:state.account_settings.is_crea_assist_sub};};var mapDispatchToProps=function mapDispatchToProps(dispatch){var l=__WEBPACK_IMPORTED_MODULE_4__globals__["b" /* store */].getState().document_state.state;if(l==='new'){// dispatch({type: SET_DOCUMENT_ID, doc: d})
}return{updatePaymentMethod:function updatePaymentMethod(meth){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["N" /* ckPaymentSelect */])(meth));},updateCardNumber:function updateCardNumber(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["J" /* ckCUpdateCardNumber */])(val));},dispatchUpdateCardExpiration:function dispatchUpdateCardExpiration(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["I" /* ckCUpdateCardExpiration */])(val));},dispatchUpdateCardCCV:function dispatchUpdateCardCCV(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["H" /* ckCUpdateCCV */])(val));},updateName_:function updateName_(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["K" /* ckCUpdateDirectName */])(val));},updateIban_:function updateIban_(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["L" /* ckCUpdateIban */])(val));},updateConfirmation:function updateConfirmation(val){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__redux_actions_checkout_operations__["c" /* CK_CHECK */],val:val});},loading:function loading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__["i" /* checkingPayment */])(true));},unloading:function unloading(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__redux_actions_loading__["i" /* checkingPayment */])(false));},setRepriseLink:function setRepriseLink(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__redux_actions_contract__["h" /* setRepriseLink */])(val));},setReprise:function setReprise(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__redux_actions_contract__["i" /* setRepriseWizard */])(val));},setCard:function setCard(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__redux_actions_account_settings__["p" /* setCardPayment */])(val));},set3X:function set3X(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__redux_actions_account_settings__["t" /* setX3Payment */])(val));},setPaypal:function setPaypal(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__redux_actions_account_settings__["s" /* setPaypalPayment */])(val));},setDirect:function setDirect(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__redux_actions_account_settings__["r" /* setDirectPayment */])(val));}};};var CardModalNext=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_CardModalNext);/* harmony default export */ __webpack_exports__["a"] = (CardModalNext);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stripeElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stripe; });
// Stripe keys
var pkKeys={s:'pk_live_22HdDuvIOJ715uUQ59wBCKAi'// Stripe LP
};// Setting test keys for non prod environements
if(typeof window.lp_env==='string'&&window.lp_env!=='prod'){pkKeys={s:'pk_test_pHVAlJpIbJfYc9EJp7zEYwcL'};}var stripe=Stripe(pkKeys.s);function stripeElement(){var style={base:{fontSize:'16px','::placeholder':{color:'#aab7c4'},':-webkit-autofill':{color:'#32325d'}},invalid:{color:'#fa755a',iconColor:'#fa755a',':-webkit-autofill':{color:'#fa755a'}}};var elements=stripe.elements();var iban=elements.create('iban',{style:style,supportedCountries:['SEPA']});return iban;}

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packEntrepreneur_css__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packEntrepreneur_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__packEntrepreneur_css__);
var PackEntrepreneur=function PackEntrepreneur(props){var _props$upsellInfo=props.upsellInfo,price=_props$upsellInfo.price,fakePrice=_props$upsellInfo.fakePrice,label=_props$upsellInfo.label;var checkedUpsell=props.checkedUpsell;price=price?price+'\u20AC':'32€';fakePrice=fakePrice?fakePrice+'\u20AC':'49€';label=label||'Pack Entrepreneur';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'condition-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cbx-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ch-title packTitle'},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'priceWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'check9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'priceCheckBox',type:'checkbox',onClick:function onClick(){return props.toggleUpsell(props.index);},checked:checkedUpsell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'packPrice'},'+'+price,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'chbx-txt oldPrice'},fakePrice,' ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'packContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Ce pack contient l\'ensemble des \xE9l\xE9ments utiles aux entrepreneurs afin qu\'ils puissent correctement exercer leur activit\xE9.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vous pouvez prendre ce pack plus tard mais le tarif r\xE9duit de ',price,' ne sera plus applicable. Le Pack Entrepreneur est valable 2 mois \xE0 partir de la date d\'achat.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'packOption'},'Assistance Entrepreneur'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Tr\xE8s rapidement, les entrepreneurs sont confront\xE9s \xE0 de nombreuses probl\xE9matiques. Gr\xE2ce \xE0 l\'assistance Entrepreneur, vous b\xE9n\xE9ficiez d\'un acc\xE8s privil\xE9gi\xE9 \xE0 notre expertise pour r\xE9pondre \xE0 toutes vos inqui\xE9tudes :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Comment g\xE9rer mon entreprise ?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Comment g\xE9rer ma comptabilit\xE9 ?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Comment facturer mes clients ?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Comment calculer mon tarif ?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Comment d\xE9clarer mes imp\xF4ts ?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Comment prospecter des clients ?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Quel compte bancaire choisir ?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'packOption'},'Contrats personnalis\xE9s'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Pendant 2 mois, vous avez un acc\xE8s illimit\xE9 \xE0 notre g\xE9n\xE9rateur de contrats personnalis\xE9s. C\'est un outil tr\xE8s puissant permettant d\'obtenir des contrats mis \xE0 jour. Il vous suffit simplement de r\xE9pondre \xE0 un questionnaire en ligne.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Exemples : contrats freelance, contrats de prestation de service, accord de confidentialit\xE9 (NDA), etc.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'packOption'},'Mod\xE8les de devis et factures'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Nous vous fournissons des templates de devis et de factures pr\xE9-remplis et aux normes.')));};/* harmony default export */ __webpack_exports__["a"] = (PackEntrepreneur);

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc_shimmer__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_app_state__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packs__ = __webpack_require__(1144);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PacksWrapper=function(_Component){_inherits(PacksWrapper,_Component);function PacksWrapper(props){_classCallCheck(this,PacksWrapper);var _this=_possibleConstructorReturn(this,(PacksWrapper.__proto__||Object.getPrototypeOf(PacksWrapper)).call(this,props));__WEBPACK_IMPORTED_MODULE_2__app_lp_app__["a" /* default */].mainCheckout(_this.props.match.params.name,_this.props.match.params.id?_this.props.match.params.id:'');return _this;}_createClass(PacksWrapper,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.pricing_loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__misc_shimmer__["b" /* ParagraphShimmer */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__packs__["a" /* default */],null));}}]);return PacksWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{pricing_loading:state.loading_details.pricing};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{goBack:function goBack(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_app_state__["g" /* setAppState */])(__WEBPACK_IMPORTED_MODULE_5__redux_actions_app_state__["e" /* LP_STATE_WIZARD */]));// #event
lpevents.track('Modifier mon document',{});__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["p" /* lpPattern */].trackLastAction(__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["c" /* P_BACK */]);__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["p" /* lpPattern */].sendAndResetTracker();}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PacksWrapper)));

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cart__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pack_choice__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ce_checkout_step_one__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__options__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_actions_toggle_preview__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logic_payment__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mobile_pay_bar__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_misc__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__invoice__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_hardcoded_checkout__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Checkout_CheckoutNew__ = __webpack_require__(1184);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/checkout.js
* Authors: Nasreddine DAIFALLAH, Moncef HAMMOU
* Version: 1.0
*/var _Packs=function(_Component){_inherits(_Packs,_Component);function _Packs(props){_classCallCheck(this,_Packs);var _this=_possibleConstructorReturn(this,(_Packs.__proto__||Object.getPrototypeOf(_Packs)).call(this,props));_this.toggleTheModel=_this.toggleTheModel.bind(_this);return _this;}_createClass(_Packs,[{key:'componentWillMount',value:function componentWillMount(){if(typeof window.lp_payment==='undefined'){window.lp_payment=new __WEBPACK_IMPORTED_MODULE_10__logic_payment__["a" /* default */]();}// create
//      this.sdbNotif.endInBlueNotification();
var wizardContainer=document.getElementById('wizard-container');if(wizardContainer){wizardContainer.classList.remove('wizard-container');}if(window.Intercom){window.Intercom('update');}}},{key:'componentDidMount',value:function componentDidMount(){if(__WEBPACK_IMPORTED_MODULE_17__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].contractMetaId)>-1){document.body.id='ce_v3';}else{document.body.id='page-checkout';}__WEBPACK_IMPORTED_MODULE_14__tracking_pattern_detector__["p" /* lpPattern */].init();Object(__WEBPACK_IMPORTED_MODULE_12__utils_misc__["f" /* scrollAndGoUp */])();if(__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].contractMetaId&&__WEBPACK_IMPORTED_MODULE_17__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].contractMetaId)===-1&&window.exectuteOnceCheckoutActe){if(window.exectuteOnceCheckoutActe===2)__WEBPACK_IMPORTED_MODULE_9__tracking_lpevents__["a" /* default */].trackGTMCheckoutStep(3,'Récapitulatif de votre commande',__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].getState().contract,__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].getState().checkout_operations,__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].contractMetaId,['Pack Basique','Pack Complet']);window.exectuteOnceCheckoutActe+=1;}// Hiding partners
// document.getElementsByClassName('partners-links')[0].style.display = 'none';
}},{key:'componentWillUpdate',value:function componentWillUpdate(){if(this.props.doc_state===''){this.props.setContinue(this.props.doc_state);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){// Hiding partners
// document.getElementsByClassName('partners-links')[0].style.display = 'block';
var wizardContainer=document.getElementById('wizard-container');if(wizardContainer){wizardContainer.classList.add('wizard-container');}}},{key:'toggleTheModel',value:function toggleTheModel(){this.props.showTheModal();__WEBPACK_IMPORTED_MODULE_9__tracking_lpevents__["a" /* default */].track('Preview checkout');__WEBPACK_IMPORTED_MODULE_14__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_14__tracking_pattern_detector__["e" /* P_CHECK_PREVIEW */]);}},{key:'render',value:function render(){var customCheckoutCta=__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom?__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.checkout_cta:'';// Define which checkout Coursier to display, depending if AB test is activated.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-checkout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_17__constants_hardcoded_checkout__["b" /* HARCODED_CHECKOUT_META_IDS */].indexOf(__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].contractMetaId)>-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ce_checkout_step_one__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container checkout-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cc-main'},__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].contractMetaId===302?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Checkout_CheckoutNew__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__pack_choice__["a" /* PackChoice */],null),this.props.disable_options&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__options__["a" /* default */],null),this.props.pack_content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'page-section hidden-xs',id:'checkout-recap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'section-title'},Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])("Votre commande contient")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'cr-pdf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onClick:this.toggleTheModel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-pdf ic-doc'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])("Version PDF"))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-glass'}))),this.props.price_pack===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'cr-word'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{title:'',href:'#',onClick:this.toggleTheModel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-word ic-doc'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])("Version Word"))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-glass'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'cr-annexes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])("Annexes"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])("Pourquoi nos documents sont-ils fiables ?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])("Ces documents sont "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])("à jour des dernières lois, rédigés par des avocats expérimentés")),Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])(" et adaptés à votre situation.")))))),this.props.disable_invoice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__invoice__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'page-section hidden-xs hidden-sm',id:'pack-checkout'},this.props.seconde_cta&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-block btn-primary cta-payement',href:'#',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].ops.checkout.showCreditCardModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'loading-spin'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-lock'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn-text'},typeof customCheckoutCta==="string"&&customCheckoutCta.trim().length>0?customCheckoutCta:Object(__WEBPACK_IMPORTED_MODULE_15__logic_wording__["a" /* _lp */])("Payer et Télécharger")))),__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].contractMetaId===302?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__mobile_pay_bar__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].contractMetaId===302?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__cart__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modal__["a" /* default */],null)));}}]);return _Packs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{doc_state:state.document_state.unique,mail:state.account_settings.mail,price_pack:state.checkout_operations.pack,title:state.contract.name,choosenPack:state.checkout_operations.pack,togglepack:state.checkout_operations.togglepack,seconde_cta:__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom&&__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.disablesecondpaymentcta?!__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.disablesecondpaymentcta:true,pack_content:__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom&&__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.disablepackcontent?!__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.disablepackcontent:true,disable_options:__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom&&__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.disableoptions?!__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.disableoptions:true,disable_invoice:__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom&&__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.disableinvoice?!__WEBPACK_IMPORTED_MODULE_16__app_lp_app__["a" /* default */].references.customs.custom.disableinvoice:true};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setContinue:function setContinue(){// dispatch({type: SET_DOCUMENT_ID, doc: d})
},showTheModal:function showTheModal(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__redux_actions_toggle_preview__["e" /* togglePreview */])());}};};var LpPacks=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_Packs);/* harmony default export */ __webpack_exports__["a"] = (LpPacks);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pack_choice__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payment_modal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__card_modal__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_default_checkout__ = __webpack_require__(1146);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/cart.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*//**
 * @description The cart class is meant to show the information of the purchase
 */var _Cart=function(_Component){_inherits(_Cart,_Component);function _Cart(props){_classCallCheck(this,_Cart);var _this=_possibleConstructorReturn(this,(_Cart.__proto__||Object.getPrototypeOf(_Cart)).call(this,props));_this.scrollEvent=_this.scrollEvent.bind(_this);_this.sendPromo=_this.sendPromo.bind(_this);_this.showCreditCardModal=_this.showCreditCardModal.bind(_this);_this.state={show_modal:false,show_modal1:false};__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].ops.checkout.setCheckoutCallback(_this.showCreditCardModal);return _this;}_createClass(_Cart,[{key:'componentWillUnmount',value:function componentWillUnmount(){window.onscroll=null;}},{key:'showCreditCardModal',value:function showCreditCardModal(){// Tracking opened payment popup
var eventParams={};eventParams['Chosen price']=parseFloat(__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].ops.checkout.getPackPrice());eventParams['Total price']=parseFloat(__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice());eventParams['Chosen pack']=this.props.choosenPack===0?'first_price':'second_price';if(__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].subscription&&this.props.choosenPack===1)eventParams['Chosen pack']='abonnement';__WEBPACK_IMPORTED_MODULE_6__tracking_lpevents__["a" /* default */].track('Opened Payment Popup',eventParams);__WEBPACK_IMPORTED_MODULE_6__tracking_lpevents__["a" /* default */].trackPopUpCheckout();if(__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].subscription&&this.props.choosenPack===1){this.setState({show_modal1:true});}else this.setState({show_modal:true});}/**
     * @description show and hide the payment button when the other shows up.
     */},{key:'scrollEvent',value:function scrollEvent(){var paymentButton=document.getElementById('payment_');if(paymentButton.getClientRects()[0].y<=__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].env.client_zone.height-35){this.refs.one.classList.add('animate-hide');}else{this.refs.one.classList.remove('animate-hide');}}},{key:'sendPromo',value:function sendPromo(){this.props.checkPromo(this.props.promo_code,__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].contractUniqid);}},{key:'render',value:function render(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_4" /* isClientPro */])();var customCheckoutCta=__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.customs.custom?__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].references.customs.custom.checkout_cta:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar lp-cart-ng',ref:'do_stuff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-cart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-block btn-primary cta-payement',ref:'one',onClick:this.showCreditCardModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-lock'}),typeof customCheckoutCta==='string'&&customCheckoutCta.trim().length>0?customCheckoutCta:this.props.pack_price===0&&__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].subscription?Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Tester gratuitement'):Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Payer et Télécharger')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'payement-methods-img hidden-xs',onClick:this.showCreditCardModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:'255',height:'26',src:'/wizard/img/checkout-methods.png',srcSet:'/wizard/img/checkout-methods@2x.png 2x'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ch-cart-section is-title chc-recap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-item'},Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Récapitulatif'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ch-cart-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-item'},this.props.choosenPack===0?Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Pack Basique'):this.props.pack_price===0&&__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].subscription?Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Abonnement Legalplace HT'):Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Pack Complet HT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-price'},parseFloat(__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].ops.checkout.getHTPrice()).toFixed(2),' ','\u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ch-cart-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-item'},Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('TVA à 20%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-price'},(__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice()-__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].ops.checkout.getHTPrice()).toFixed(2),' ','\u20AC')),this.props.has_call||this.props.has_letter,this.props.has_call&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ch-cart-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-item'},Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Question')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-price'},(29.90/1.2).toFixed(2),' ','\u20AC')),this.props.has_letter&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ch-cart-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-item'},Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Envoie par courrier')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-price'},(this.props.letter_number*3.90/1.2).toFixed(2),'\u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ch-cart-section is-bold chc-total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-item'},'Total TTC'),(!this.props.price_loading&&!Number.isNaN(parseFloat(this.props.second_price))&&!Number.isNaN(parseFloat(this.props.first_price))||!this.props.price_loading)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chc-price'},__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice(),' ','\u20AC'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-cart-coupon'+(this.props.promo_code.length>0?' focus':'')},(parseFloat(this.props.promo_percentage)===0||Number.isNaN(parseFloat(this.props.promo_percentage)))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{action:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',disabled:this.props.promo_loading,placeholder:'Code promotionnel',className:'form-control',onChange:function onChange(evt){return _this2.props.updatePromo(evt.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.props.promo_code.length<=0,className:'btn'+(this.props.promo_loading?' checking':''),type:'button',onClick:this.sendPromo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lpc-txt'},'Valider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'loading-spin'})),typeof this.props.promo_percentage==='string'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.promo_percentage)),parseFloat(this.props.promo_percentage)>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpcc-valid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_8__logic_wording__["a" /* _lp */])('Réduction de ')+parseFloat(this.props.promo_percentage)*100,' ','%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__card_modal__["a" /* default */],{show:this.state.show_modal,closeEvent:function closeEvent(){return _this2.setState({show_modal:false});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__payment_modal__["a" /* default */],{show:this.state.show_modal1,closeEvent:function closeEvent(){return _this2.setState({show_modal1:false});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lp-checkout-faq'},__WEBPACK_IMPORTED_MODULE_10__constants_default_checkout__["a" /* CONTRACTS_WITHOUT_CHECKOUT_META_ID */].indexOf(__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].contractMetaId)===-1&&__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].contractMetaId!==302&&__WEBPACK_IMPORTED_MODULE_10__constants_default_checkout__["b" /* DEFAULT_CHECKOUT_FAQ */].map(function(faqElement){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:faqElement.h3,className:'lp-checkout-faq__element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,faqElement.h3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,faqElement.p));})));}}]);return _Cart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{title:state.contract.name,first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price,choosenPack:state.checkout_operations.pack,has_call:state.checkout_operations.has_call,has_letter:state.checkout_operations.has_letter,letter_number:state.checkout_operations.letter.number,pack_price:state.checkout_operations.pack===0?state.checkout_operations.prices.first_price:state.checkout_operations.prices.second_price,promo_code:state.checkout_operations.promo_code,promo_loading:state.checkout_operations.promo_loading,promo_percentage:state.checkout_operations.promo_percentage,price_loading:state.loading_details.pricing,client_email:state.account_settings.mail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updatePromo:function updatePromo(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["W" /* ckUpdatePromoCode */])(val));},checkPromo:function checkPromo(val,contractId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["O" /* ckSendPromoCode */])(val,contractId));__WEBPACK_IMPORTED_MODULE_7__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_7__tracking_pattern_detector__["f" /* P_CHECK_PROMO */]);}};};var LpCart=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_Cart);/* harmony default export */ __webpack_exports__["a"] = (LpCart);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_CHECKOUT_FAQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTRACTS_WITHOUT_CHECKOUT_META_ID; });
var DEFAULT_CHECKOUT_FAQ=[{h3:'Pourquoi nos contrats sont-ils plus fiables que de simples modèles ?',p:'Tous nos documents juridiques sont rédigés par des avocats expérimentés. Plus de 100 00 clients ont téléchargé nos contrats qui sont constamment mis à jour des dernières lois'},{h3:'Après avoir effectué le paiement, puis-je modifier mon contrat ?',p:'Oui ! Vous pouvez modifier à tout moment votre contrat en revenant sur le questionnaire à tout moment. Attention toutefois à respecter la loi en vigueur si vous décidez de modifier vous-même votre contrat..'},{h3:'Et si j’ai un doute sur une disposition du contrat ?',p:'En cas de doute, vous pouvez faire appel à un avocat expérimenté. Lors de cet appel, vous pourrez poser toutes vos questions relatives à votre contrat. Il pourra également vous conseiller et vous assister dans vos démarches juridiques. L’appel dure 20 minutes et est facturé 29,90€'}];var CONTRACTS_WITHOUT_CHECKOUT_META_ID=[136];

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__table_checkouts_oneColumnPack_js__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__table_checkouts_threeColumnsPack__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__ = __webpack_require__(1159);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/pack_choice.js
* Author: Amine Azizi
* Version: 1.0
*//**
 * @description The component that selects the packs of prices.
 */var _CePackChoiceOne=function(_Component){_inherits(_CePackChoiceOne,_Component);function _CePackChoiceOne(props){_classCallCheck(this,_CePackChoiceOne);var _this=_possibleConstructorReturn(this,(_CePackChoiceOne.__proto__||Object.getPrototypeOf(_CePackChoiceOne)).call(this,props));_this.onChoose=_this.onChoose.bind(_this);return _this;}_createClass(_CePackChoiceOne,[{key:'componentWillMount',value:function componentWillMount(){document.body.classList.remove('ce-checkout');document.body.classList.remove('ce-checkout-s2');document.body.classList.remove('ce_payement_v3');document.body.classList.add('ce_checkout_v3');document.body.classList.add('ce_pricing_v3');document.body.classList.add('ce_checkout_sas');document.body.id='ce_v3';}},{key:'componentDidMount',value:function componentDidMount(){var eventParams={};eventParams['Reached Checkout']='Reached Checkout';eventParams['checkoutVersion']='legacy';if(!window.executeEventOnetime){__WEBPACK_IMPORTED_MODULE_4__tracking_lpevents__["a" /* default */].track('Reached Checkout',eventParams);// lpevents.trigger('heatmap_checkout');
window.executeEventOnetime=1;__WEBPACK_IMPORTED_MODULE_4__tracking_lpevents__["a" /* default */].adwordsConversion({google_conversion_value:0.01});}//hotjar trigger
// if (window.checkout_step !== 'paiement') {
// should it be here???
// writeHistory('payment', null, 'payment');
// }
window.checkout_step='paiement';}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.classList.remove('ce_checkout_v3');document.body.classList.remove('ce_pricing_v3');document.body.classList.remove('ce_checkout_sas');}},{key:'onChoose',value:function onChoose(e){var chosenPack=+e.target.attributes['data-pack'].value;if(chosenPack==='1')this.props.selectOne();else if(chosenPack==='2')this.props.selectTwo();else this.props.selectThree();this.props.togglePack(true);}},{key:'render',value:function render(){switch(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId){/*
             * Checkout SAS
             */case 175:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__["a" /* default */],null);/*
             * Checkout SASU
             */case 176:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__["a" /* default */],null);/*
             * Checkout SARL
             */case 197:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__["a" /* default */],null);/*
             * Checkout EURL
             */case 198:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__["a" /* default */],null);/*
             * Checkout SCI
             */case 124:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__["a" /* default */],null);/*
       * Checkout Rupture
       */case 184:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__table_checkouts_threeColumnsPack__["a" /* default */],null);/*
      * CSE moins de 20
      */case 229:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__table_checkouts_oneColumnPack_js__["a" /* default */],null);/*
      * CSE plus de 20
      */case 230:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],{removeReassurance:true,shouldNotHaveMostPopularPack:true});/*
      * CSE moins de 20 candidats
      */case 231:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],{removeReassurance:true,shouldNotHaveMostPopularPack:true});/*
       * Checkout Radiation AE
       */case 219:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],null);/*
       * Checkout Auto-Entrepreneur
       */case 181:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__["a" /* default */],null);/*
       * Checkout Auto-Entrepreneur Artisan
       */case 680:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__["a" /* default */],null);/**
      |--------------------------------------------------
      | Changement de siège social
      |--------------------------------------------------
      */case 227:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],{removeReassurance:true});/**
      |--------------------------------------------------
      | changement-denomination-sociale
      |--------------------------------------------------
      */case 287:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],{removeReassurance:true});/**
      |--------------------------------------------------
      | modifier-date-cloture-ex-social
      |--------------------------------------------------
      *//**
      |--------------------------------------------------
      | Changement de siège social
      |--------------------------------------------------
      */case 296:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],{removeReassurance:true});case 301:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],{removeReassurance:true});/**
      |--------------------------------------------------
      | Changement de siège social EXT
      |--------------------------------------------------
      */case 616:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],{removeReassurance:true});/*
             * Checkout Association
             */case 162:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__table_checkouts_PackSelectorPage__["a" /* default */],null);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__table_checkouts_twoColumnsPack__["a" /* default */],null);}}}]);return _CePackChoiceOne;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price,third_price:state.checkout_operations.prices.third_price,chosen_pack:state.checkout_operations.pack,pricing_loading:state.loading_details.pricing,promo_percentage:state.checkout_operations.promo_percentage,title:state.contract.name};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{togglePack:function togglePack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["G" /* ceTogglePack */])(val));},selectOne:function selectOne(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(0));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["l" /* P_SELECT_PACK_1 */]);},selectTwo:function selectTwo(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(1));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["m" /* P_SELECT_PACK_2 */]);},selectThree:function selectThree(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(2));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["n" /* P_SELECT_PACK_3 */]);}};};var CePackChoiceOne=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_CePackChoiceOne);/* harmony default export */ __webpack_exports__["a"] = (CePackChoiceOne);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__faq__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__upsell_pack_entrepreneurAB__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__upsell_pack_entrepreneurAB_Data__ = __webpack_require__(271);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _TwoColumnsPack=function(_Component){_inherits(_TwoColumnsPack,_Component);function _TwoColumnsPack(props){_classCallCheck(this,_TwoColumnsPack);var _this=_possibleConstructorReturn(this,(_TwoColumnsPack.__proto__||Object.getPrototypeOf(_TwoColumnsPack)).call(this,props));_this.chooseButtonToClick=function(e){if(Object.keys(__WEBPACK_IMPORTED_MODULE_7__upsell_pack_entrepreneurAB_Data__["a" /* packEntrepreneurData */]).indexOf(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId.toString())>-1){var index=+e.target.attributes['data-pack'].value;_this.props.onPackEntrepreneurChoosePack(index);}else{_this.onChoose(e);}};_this.onChooseNewAbTest=function(id){var chosenPack=id;if(chosenPack===1){_this.props.selectOne();}else _this.props.selectTwo();_this.props.togglePack(true);};_this.onChoose=_this.onChoose.bind(_this);_this.state={packs:_TwoColumnsPack.getPacksFeatures(),packNames:_this.getPackInfo()};return _this;}_createClass(_TwoColumnsPack,[{key:'onChoose',value:function onChoose(e){var chosenPack=+e.target.attributes['data-pack'].value;if(chosenPack===1){this.props.selectOne();}else this.props.selectTwo();this.props.togglePack(true);}},{key:'getPackInfo',value:function getPackInfo(){switch(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId){/*
             * Checkout Association
             */case 162:return[{title:'Statuts seuls',sub:'Vous créez seul',price:this.props.second_price+'\u20AC',fees:true},{title:'Création Express',sub:"On s'occupe de tout",price:this.props.first_price+'\u20AC',fees:true}];case 181:return[{title:'Création Standard',sub:"On s'occupe de tout",price:this.props.second_price+'\u20AC',fees:true},{title:'Création Express',sub:'Traité sous 24H',price:this.props.first_price+'\u20AC',fees:true}];// Changement de siège social
case 227:return[{title:'Pack Standard',price:this.props.second_price+'\u20AC',fees:'+ frais administratifs (352€)'},{title:'Pack Express',price:this.props.first_price+'\u20AC',fees:'+ frais administratifs (352€)'}];case 219:return[{title:"Radiation standard",sub:"",price:this.props.second_price+"€",fees:false},{title:"Radiation express",sub:"",price:this.props.first_price+"€",fees:false}];case 230:return[{title:'Moins de 50 salariés',sub:'',price:this.props.second_price+"€",fees:'Procédure complète avec vote 100% en ligne'},{title:'Plus de 50 salariés',sub:'',price:this.props.first_price+"€",fees:'Procédure complète avec vote 100% en ligne'}];case 231:return[{title:'Élection classique',sub:'',price:this.props.second_price+"€",fees:'Procédure complète avec vote sous enveloppes dans vos locaux'},{title:'Élection digitalisée',sub:'',price:this.props.first_price+"€",fees:'Procédure complète avec vote 100% en ligne\n\n'// Break line added to align with the other pack
}];// changement-denomination-sociale
case 287:return[{title:'Pack Standard',price:this.props.second_price+'\u20AC',fees:'+ frais administratifs (343€)'},{title:'Pack Express',price:this.props.first_price+'\u20AC',fees:'+ frais administratifs (343€)'}];// Changement d'objet de société
case 296:return[{title:'Pack Standard',price:this.props.second_price+'\u20AC',fees:'+ frais administratifs (320€)'},{title:'Pack Express',price:this.props.first_price+'\u20AC',fees:'+ frais administratifs (320€)'}];// modifier-date-cloture-ex-social
case 301:return[{title:'Pack Standard',price:this.props.second_price+'\u20AC',fees:'+ frais administratifs (80€)'},{title:'Pack Express',price:this.props.first_price+'\u20AC',fees:'+ frais administratifs (80€)'}];// Changement de siège social EXT
case 616:return[{title:'Pack Standard',price:this.props.second_price+'\u20AC',fees:'+ frais administratifs (517,56€)'},{title:'Pack Express',price:this.props.first_price+'\u20AC',fees:'+ frais administratifs (517,56€)'}];default:break;}}},{key:'render',value:function render(){var _this2=this;var getContractName=function getContractName(contractMetaId){switch(contractMetaId){case 162:return'association';case 181:return'auto entreprise';case 219:return"Radiation d'Auto-Entreprise";case 230:return'Élection du CSE';case 231:return'';default:break;}};var getContractTitle=function getContractTitle(contractMetaId){switch(contractMetaId){case 219:return{title:"Votre cessation d’activité est presque prête",subTitle:'Choisissez votre pack, nous gérons ensuite toutes les démarches'};case 230:return{title:'Élection du CSE',subTitle:'Choisissez votre pack en fonction de la taille de votre entreprise'};case 231:return{title:'Élection du CSE de votre société',subTitle:'Choisissez votre niveau d’accompagnement'};// Changement de siège social
case 227:return{title:'Votre changement de si\xE8ge social est pr\xEAt',subTitle:'Choisissez votre pack, nous gérons ensuite toutes les démarches'};// Changement de siège social EXT
case 616:return{title:'Votre changement de si\xE8ge social est pr\xEAt',subTitle:'Choisissez votre pack, nous gérons ensuite toutes les démarches'};// modifier-date-cloture-ex-social
case 301:return{title:'Votre modification de la date de cl\xF4ture \nde l\'exercice social est pr\xEAte',subTitle:'Choisissez votre pack, nous gérons ensuite toutes les démarches'};// changement-denomination-sociale
case 287:return{title:'Votre changement de d\xE9nomination sociale est pr\xEAt',subTitle:'Choisissez votre pack, nous gérons ensuite toutes les démarches'};// Changement d'objet de société
case 296:return{title:'Votre modification d\'objet social est pr\xEAte',subTitle:'Choisissez votre pack, nous gérons ensuite toutes les démarches'};default:return{title:'Votre '+getContractName(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId)+' est pr\xEAte \xE0 \xEAtre cr\xE9\xE9e',subTitle:'Choisissez votre pack, nous gérons ensuite toutes les démarches'};}};var getPackInfo=function getPackInfo(packIndex){var packList=[];_this2.state.packs.forEach(function(opt,i){if(opt.checks[packIndex]===true){var className='';if(opt.isTitle){className='is-title';}else if(opt.isSpacer){className='is-spacer';}var li=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'cemobpck-'+i,className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),opt.dynamic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title,' ',packIndex===0?'d\''+getContractName(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId):'',' ',packIndex===1?'+ dossier complet':'',' '):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title,' '));packList.push(li);}});return packList;};var packEntrepreneurPack=this.props.packEntrepreneurPack;if(typeof packEntrepreneurPack!=='undefined'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__upsell_pack_entrepreneurAB__["a" /* default */],{selectPack:this.onChooseNewAbTest,index:packEntrepreneurPack});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sc-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'sc-title'},getContractTitle(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId).title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sc-stitle'},getContractTitle(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId).subTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pricing-table-x5 pt-x5-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pt-pack'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'pack-title'},this.state.packNames[0].title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pack-stitle'},this.state.packNames[0].sub)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'px-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-current'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-value'},this.state.packNames[0].price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-tax'},'HT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pp-mention'},this.state.packNames[0].fees?this.state.packNames[0].fees:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xcta',href:'#','data-pack':'2',onClick:this.chooseButtonToClick},'Choisir ce pack'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},getPackInfo(0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pt-pack '+(this.props.shouldNotHaveMostPopularPack?'':'pt-premium')},!this.props.shouldNotHaveMostPopularPack&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-premium-mention'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Le  plus populaire')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'pack-title'},this.state.packNames[1].title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pack-stitle'},this.state.packNames[1].sub)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'px-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-current'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-value'},this.state.packNames[1].price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-tax'},'HT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pp-mention'},this.state.packNames[1].fees?this.state.packNames[1].fees:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xcta',href:'#','data-pack':'1',onClick:this.chooseButtonToClick},'Choisir ce pack'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},getPackInfo(1)))),!this.props.removeReassurance&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marketing-args'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media checkout-assistance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-phone.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Assistance T\xE9l\xE9phonique'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-stitle'},'Pour tout renseignement'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media x3-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-euro.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Payez en 3 fois'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-stitle'},'Sans frais supl\xE9mentaires'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media wg-avis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-avis.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Satisfaction Garantie'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rb-stars'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-half'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wa-avis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://fr.trustpilot.com/review/legalplace.fr'},'sur 451 avis'))))))))),[219,227,287,296,301,616].indexOf(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId)===-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__faq__["a" /* default */],null):"");}}],[{key:'getPacksFeatures',value:function getPacksFeatures(){switch(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId){/*
             *//* Checkout Association */case 162:return[{title:'Statuts ',dynamic:true,isTitle:true,isSpacer:false,checks:[true,true]},{title:"Enregistrement de l'association",isTitle:false,isSpacer:false,checks:[false,true]},{title:'Échanges avec la préfecture',isTitle:false,isSpacer:false,checks:[false,true]},{title:'Assistance obtention du SIRET',isTitle:false,isSpacer:false,checks:[false,true]},{title:'Assistance téléphonique illimitée',isTitle:false,isSpacer:false,checks:[false,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,true]}];case 181:return[{title:'Dossier juridique complet',dynamic:false,isTitle:true,isSpacer:false,checks:[true,true]},{title:'Gérer les formalités administratives',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Obtention du numéro SIRET',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Assistance téléphonique illimitée',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,true]},{title:'Obtention de l\'ACRE (ex ACCRE)',isTitle:false,isSpacer:false,checks:[false,true]}];// Changement de siège social
case 227:return[{title:'Vérification de votre dossier par un expert LegalPlace',dynamic:false,isTitle:true,isSpacer:false,checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Kbis mis à jour',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Mise à jour de la déclaration des bénéficiaires effectifs',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Assitance téléphonique illimitée',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,true]}];case 219:return[{title:"Dossier juridique complet",dynamic:false,isTitle:true,isSpacer:false,checks:[true,true]},{title:"Revue et validation de votre dossier par un formaliste",isTitle:false,isSpacer:false,checks:[true,true]},{title:"Dépot de votre dossier auprès du greffe ou du CFE",isTitle:false,isSpacer:false,checks:[true,true]},{title:"Gestion des échanges avec le greffe ou le CFE",isTitle:false,isSpacer:true,checks:[true,true]},{title:"Assistance téléphonique illimitée",isTitle:false,isSpacer:false,checks:[false,true]},{title:"Gestion express (moins de 48h)",isTitle:false,isSpacer:false,checks:[false,true]}];case 230:return[{title:'Rétroplanning',dynamic:false,isTitle:false,isSpacer:false,checks:[true,true]},{title:'Tous vos documents légaux sur-mesure',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Suivi de votre procédure par un expert',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Assistance téléphonique',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Prise en charge totale de vos élections par vote électronique',isTitle:false,isSpacer:false,checks:[true,true]}];case 231:return[{title:'Rétroplanning',dynamic:false,isTitle:false,isSpacer:false,checks:[true,true]},{title:'Tous vos documents légaux sur-mesure',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Suivi de votre procédure par un expert',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Assistance téléphonique',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Guide complet sur la marche à suivre pour l\'organisation de vos éléctions',isTitle:false,isSpacer:false,checks:[true,false]},{title:'Scrutin réalisé par vote électronique',isTitle:false,isSpacer:false,checks:[false,true]}];// changement-denomination-sociale
case 287:return[{title:'Vérification de votre dossier par un expert LegalPlace',dynamic:false,isTitle:true,isSpacer:false,checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Kbis mis à jour',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Mise à jour de la déclaration des bénéficiaires effectifs',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Assitance téléphonique illimitée',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,true]}];// Changement d'objet de société
case 296:return[{title:'Vérification de votre dossier par un expert LegalPlace',dynamic:false,isTitle:true,isSpacer:false,checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Kbis mis à jour',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Assitance téléphonique illimitée',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,true]}];// modifier-date-cloture-ex-social
case 301:return[{title:'Vérification de votre dossier par un expert LegalPlace',dynamic:false,isTitle:true,isSpacer:false,checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Kbis mis à jour',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Assitance téléphonique illimitée',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,true]}];// Changement de siège social EXT
case 616:return[{title:'Vérification de votre dossier par un expert LegalPlace',dynamic:false,isTitle:true,isSpacer:false,checks:[true,true]},{title:'Validation et transmission de votre dossier au greffe',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Kbis mis à jour',isTitle:false,isSpacer:false,checks:[true,true]},{title:'Mise à jour de la déclaration des bénéficiaires effectifs',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Assitance téléphonique illimitée',isTitle:false,isSpacer:true,checks:[true,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,true]}];default:return null;}}}]);return _TwoColumnsPack;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price,third_price:state.checkout_operations.prices.third_price,chosen_pack:state.checkout_operations.pack,pricing_loading:state.loading_details.pricing,promo_percentage:state.checkout_operations.promo_percentage,packEntrepreneurPack:state.checkout_operations.packEntrepreneur.choosePack,title:state.contract.name};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{togglePack:function togglePack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["G" /* ceTogglePack */])(val));},selectOne:function selectOne(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(0));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["l" /* P_SELECT_PACK_1 */]);},selectTwo:function selectTwo(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(1));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["m" /* P_SELECT_PACK_2 */]);},onPackEntrepreneurChoosePack:function onPackEntrepreneurChoosePack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_7" /* packEntrepreneurChoosePack */])(val));}};};var TwoColumnsPack=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_TwoColumnsPack);/* harmony default export */ __webpack_exports__["a"] = (TwoColumnsPack);

/***/ }),
/* 1149 */
/***/ (function(module, exports) {



/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PackEntrepreneurHeaderAB=function PackEntrepreneurHeaderAB(_ref){var header=_ref.header;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"headerTitle"},header.packTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"headerSubtitle"},header.packsubTitle));};/* harmony default export */ __webpack_exports__["a"] = (PackEntrepreneurHeaderAB);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PackEntrepreneurContentAB=function PackEntrepreneurContentAB(_ref){var picture=_ref.picture,optionTitle=_ref.optionTitle,optionText=_ref.optionText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"optionContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:picture}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"optionTitle"},optionTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"optionText"},optionText));};/* harmony default export */ __webpack_exports__["a"] = (PackEntrepreneurContentAB);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _PackEntrepreneurFooterAB=function(_Component){_inherits(_PackEntrepreneurFooterAB,_Component);function _PackEntrepreneurFooterAB(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_PackEntrepreneurFooterAB);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_PackEntrepreneurFooterAB.__proto__||Object.getPrototypeOf(_PackEntrepreneurFooterAB)).call.apply(_ref,[this].concat(args))),_this),_this.getPack=function(chosenPack){var pack=void 0;switch(chosenPack){case 0:pack='first_price';break;case 1:pack='second_price';break;default:pack='third_price';break;}return pack;},_this.goToNextStep=function(){var _this$props=_this.props,selectPack=_this$props.selectPack,index=_this$props.index;_this.props.entrepreneurPack(false);_this.props.addUpsellPackEntrepreneur([]);selectPack(index);},_this.goToNextStepWithUpsell=function(){var _this$props2=_this.props,selectPack=_this$props2.selectPack,index=_this$props2.index,detailsCheckout=_this$props2.detailsCheckout;_this.props.entrepreneurPack(false);var chosenPack=_this.getPack(index);var upsellArray=chosenPack&&detailsCheckout[chosenPack]&&detailsCheckout[chosenPack].upsell;var upsell=upsellArray&&upsellArray.length&&[].concat(_toConsumableArray(Array(upsellArray.length))).map(function(){return false;});// Only put the first upsell to true : to do the generic case after!!!
if(upsell&&upsell.length)upsell[0]=true;_this.props.addUpsellPackEntrepreneur(upsell);selectPack(index);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_PackEntrepreneurFooterAB,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__["a" /* default */].trackDatalayerMixpanel("Choisir ce pack","lp_ab_dedicatedupsellscreenme");this.props.addUpsellPackEntrepreneur([]);}},{key:"render",value:function render(){var footer=this.props.footer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"priceWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"crossedOutPrice"},footer.oldPrice,",",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"00"),"\u20AC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"newPrice"},footer.newPrice,",00\u20AC")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"addBtn",onClick:this.goToNextStepWithUpsell},footer.btnText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{type:"button",className:"skipBtn",onClick:this.goToNextStep},footer.skipBtnText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"footerText"},footer.footerText));}}]);return _PackEntrepreneurFooterAB;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{detailsCheckout:state.checkout_operations.detailsCheckout};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{entrepreneurPack:function entrepreneurPack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_5" /* packEntrepreneur */])(val));},addUpsellPackEntrepreneur:function addUpsellPackEntrepreneur(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_6" /* packEntrepreneurAddUpsell */])(val));}};};var PackEntrepreneurFooterAB=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_PackEntrepreneurFooterAB);/* harmony default export */ __webpack_exports__["a"] = (PackEntrepreneurFooterAB);

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__faq__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OneColumnPack=function(_Component){_inherits(OneColumnPack,_Component);function OneColumnPack(props){_classCallCheck(this,OneColumnPack);var _this=_possibleConstructorReturn(this,(OneColumnPack.__proto__||Object.getPrototypeOf(OneColumnPack)).call(this,props));console.log(props);_this.onChoose=_this.onChoose.bind(_this);_this.state={packs:OneColumnPack.getPacksFeatures(),packNames:_this.getPackInfo()};return _this;}_createClass(OneColumnPack,[{key:'componentDidUpdate',value:function componentDidUpdate(){console.log('UPDATE',this.state);}},{key:'onChoose',value:function onChoose(e){var chosenPack=+e.target.attributes['data-pack'].value;if(chosenPack===1){this.props.selectOne();}else this.props.selectTwo();this.props.togglePack(true);}},{key:'getPackInfo',value:function getPackInfo(){switch(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId){/*
        * Cse moins de 20 employés
        */case 229:return[{h1:'Élection du CSE de votre société',title:'Élection simplifiée',price:this.props.first_price+'\u20AC',fees:'Procédure pour confirmer l’absence de candidat aux élections'}];}}},{key:'render',value:function render(){var _this2=this;var getContractName=function getContractName(contractMetaId){switch(contractMetaId){case 230:return"Election du CSE de votre société";case 229:return"Election du CSE de votre société";default:break;}};var getPackInfo=function getPackInfo(packIndex){var packList=[];_this2.state.packs.forEach(function(opt,i){if(opt.checks[packIndex]===true){var className='';if(opt.isTitle){className='is-title';}else if(opt.isSpacer){className='is-spacer';}else if(opt.isWarning){className='is-warning';}var li=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'cemobpck-'+i,className:className},!opt.isWarning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),opt.dynamic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title,' ',packIndex===0?'d\''+getContractName(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId):'',' ',packIndex===1?'+ dossier complet':'',' '):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title,' '));packList.push(li);}});return packList;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sc-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'sc-title'},this.getPackInfo()[0].h1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pricing-table-x5 pt-x5-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pt-pack'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'pack-title'},this.getPackInfo()[0].title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pack-stitle'},this.getPackInfo()[0].sub)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'px-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-current'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-value'},this.getPackInfo()[0].price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-tax'},'HT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pp-mention'},this.getPackInfo()[0].fees?this.getPackInfo()[0].fees:'Sans frais administratifs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xcta',href:'#','data-pack':'1',onClick:this.onChoose},'Choisir ce pack'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},getPackInfo(0))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__faq__["a" /* default */],null));}}],[{key:'getPacksFeatures',value:function getPacksFeatures(){switch(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId){/* Cse plus de 20 */case 229:return[{title:'Retroplanning ',isTitle:false,isSpacer:false,checks:[true]},{title:"Tous vos documents légaux sur-mesure",isTitle:false,isSpacer:false,checks:[true]},{title:'Suivi de votre procédure par un expert',isTitle:false,isSpacer:false,checks:[true]},{title:'Assistance téléphonique',isTitle:false,isSpacer:false,checks:[true]},{title:'Attention : valable uniquement pour les entreprises de moins de 21 salariés et si aucun candidat ne se déclare sous 30 jours. Si un candidat se déclare, alors nous vous proposerons de souscrire à l\'une des deux autres offres (le prix déjà payé pour cette offre sera déduit)',isTitle:false,isSpacer:false,isWarning:true,checks:[true]}];default:return null;}}}]);return OneColumnPack;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){console.log('state lmerge to proips',state);return{first_price:state.checkout_operations.prices.first_price,chosen_pack:state.checkout_operations.pack,pricing_loading:state.loading_details.pricing,promo_percentage:state.checkout_operations.promo_percentage,title:state.contract.name};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{togglePack:function togglePack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["G" /* ceTogglePack */])(val));},selectOne:function selectOne(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(0));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["l" /* P_SELECT_PACK_1 */]);}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(OneColumnPack));

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__faq__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _threeColumnsPack=function(_Component){_inherits(_threeColumnsPack,_Component);function _threeColumnsPack(props){_classCallCheck(this,_threeColumnsPack);var _this=_possibleConstructorReturn(this,(_threeColumnsPack.__proto__||Object.getPrototypeOf(_threeColumnsPack)).call(this,props));_this.onChoose=_this.onChoose.bind(_this);_this.state={packs:_threeColumnsPack.getPacksFeatures(),packNames:_this.getPackInfo()};return _this;}_createClass(_threeColumnsPack,[{key:'onChoose',value:function onChoose(e){console.log("event",e,e.target.attributes['data-pack']);var chosenPack=+e.target.attributes['data-pack'].value;if(chosenPack===1)this.props.selectOne();else if(chosenPack===2)this.props.selectTwo();else this.props.selectThree();this.props.togglePack(true);}},{key:'getPackInfo',value:function getPackInfo(){switch(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId){/*
             * Checkout SAS & SASU & SARL & EURL
             */case 175:case 198:case 197:case 176:return[{title:'Statuts seuls',sub:'Vous créez seul',price:this.props.third_price+'\u20AC',fees:false},{title:'Création Standard',sub:"On s'occupe de tout",price:this.props.second_price+'\u20AC',fees:'+ frais administratifs (261,21€)'},{title:'Création Express',sub:'Traité sous 24H',price:this.props.first_price+'\u20AC',fees:'+ frais administratifs (261,21€)'}];case 124:return[{title:'Statuts seuls',sub:'Vous créez seul',price:this.props.third_price+'\u20AC',fees:false},{title:'Création Standard',sub:"On s'occupe de tout",price:this.props.second_price+'\u20AC',fees:'+ frais administratifs (290,10€)'},{title:'Création Express',sub:'Traité sous 24H',price:this.props.first_price+'\u20AC',fees:'+ frais administratifs (290,10€)'}];// ASSO
case 162:return[{title:'Statuts seuls',sub:'Vous créez seul',price:this.props.third_price+'\u20AC'},{title:'Création Standard',sub:"On s'occupe de tout",price:this.props.second_price+'\u20AC'},{title:'Création Express',sub:'Traité sous 24H',price:this.props.first_price+'\u20AC'}];case 184:return[{title:"Pack expert",sub:"Je me débrouille seul",price:this.props.third_price+"€",fees:false},{title:"Pack confort",sub:"Un avocat m'accompagne",price:this.props.second_price+"€",fees:false},{title:"Pack sérénité",sub:"Un avocat gère tout mon dossier",price:this.props.first_price+"€",fees:false}];default:break;}}},{key:'render',value:function render(){var _this2=this;var getContractName=function getContractName(contractMetaId){switch(contractMetaId){case 198:return'EURL';case 197:return'SARL';case 175:return'SAS';case 176:return'SASU';case 124:return'SCI';case 162:return'association';case 184:return"Rupture Conventionnelle";default:break;}};var getPackInfo=function getPackInfo(packIndex){var packList=[];_this2.state.packs.forEach(function(opt,i){if(opt.checks[packIndex]===true){var lineClassName='';if(opt.isTitle){lineClassName='is-title';}else if(opt.isSpacer){lineClassName='is-spacer';}// with space on Asso (162) product
var sperator=__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId===162?'':' ';var li=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'cemobpck-'+i,className:lineClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}),opt.dynamic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title,sperator,getContractName(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId),' ',(packIndex===1||packIndex===2)&&__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId!==162?'+ dossier complet':'',' '):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,opt.title,' '));packList.push(li);}});return packList;};// let getExpDate = () => {
//     let nomsDesMois = [
//         {month: "janvier", days: 31},
//         {month: "février", days: 30},
//         {month: "mars", days: 31},
//         {month: "avril", days: 30},
//         {month: "mai", days: 31},
//         {month: "juin", days: 30},
//         {month: "juillet", days: 31},
//         {month: "août", days: 31},
//         {month: "septembre", days: 30},
//         {month: "octobre", days: 31},
//         {month: "novembre", days: 30},
//         {month: "décembre", days: 31}
//     ];
//     let date = new Date();
//     let m = date.getMonth();
//     let y = date.getFullYear();
//     let d = nomsDesMois[m].days;
//     console.log(d);
//     return ("" + d + " " + nomsDesMois[m].month + " " + y);
// }
// let expDate = getExpDate();
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId===184?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sc-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'sc-title'},'Votre rupture conventionnelle est presque pr\xEAte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sc-stitle'},'Choisissez votre niveau d\'accompagnement')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sc-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'sc-title'},'Votre ',getContractName(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId),' est pr\xEAte \xE0 \xEAtre cr\xE9\xE9e'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'sc-stitle'},'Choisissez votre pack, nous g\xE9rons ensuite toutes les d\xE9marches')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pricing-table-x5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pt-pack'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'pack-title'},this.state.packNames[0].title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pack-stitle'},this.state.packNames[0].sub)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'px-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-current'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-value'},this.state.packNames[0].price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-tax'},'HT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pp-mention'},this.state.packNames[0].fees?this.state.packNames[0].fees:'Sans frais administratifs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xcta',href:'#','data-pack':'3',onClick:this.onChoose},'Choisir ce pack'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},getPackInfo(0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pt-pack'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'pack-title'},this.state.packNames[1].title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pack-stitle'},this.state.packNames[1].sub)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'px-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-current'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-value'},this.state.packNames[1].price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-tax'},'HT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pp-mention'},this.state.packNames[1].fees?this.state.packNames[1].fees:'Sans frais administratifs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xcta',href:'#','data-pack':'2',onClick:this.onChoose},'Choisir ce pack'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},getPackInfo(1))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'pt-pack pt-premium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-premium-mention'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Le  plus populaire')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'pack-title'},this.state.packNames[2].title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pack-stitle'},this.state.packNames[2].sub)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'px-pricing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-current'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-value'},this.state.packNames[2].price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pp-tax'},'HT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pp-mention'},this.state.packNames[2].fees?this.state.packNames[2].fees:'Sans frais administratifs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'xcta',href:'#','data-pack':'1',onClick:this.onChoose},'Choisir ce pack'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'pack-features'},getPackInfo(2)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marketing-args'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media checkout-assistance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-phone.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Assistance T\xE9l\xE9phonique'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-stitle'},'Pour tout renseignement'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media x3-payement'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-euro.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Payez en 3 fois'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-stitle'},'Sans frais suppl\xE9mentaires'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-media wg-avis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-obj'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/ma-avis.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-title'},'Satisfaction Garantie'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fm-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rb-stars'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-full'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-star-half'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wa-avis'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'https://fr.trustpilot.com/review/legalplace.fr'},'sur 451 avis'))))))))),__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId!==184?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__faq__["a" /* default */],null):"");}}],[{key:'getPacksFeatures',value:function getPacksFeatures(){switch(__WEBPACK_IMPORTED_MODULE_5__app_lp_app__["a" /* default */].contractMetaId){/*
             * Checkout SAS (175) & Checkout SASU (176) & EURL & SARL
             */case 198:case 197:case 175:case 176:return[{title:'Statuts de',dynamic:true,isTitle:true,isSpacer:false,checks:[true,true,true]},{title:'Vérification du dossier',isTitle:false,isSpacer:false,checks:[false,true,true]},{title:'Immatriculation auprès du greffe',isTitle:false,isSpacer:false,checks:[false,true,true]},{title:'Garantie anti-rejet',isTitle:false,isSpacer:false,checks:[false,true,true]},{title:"Publication de l'annonce légale",isTitle:false,isSpacer:false,checks:[false,true,true]},{title:'Obtention du Kbis',isTitle:false,isSpacer:true,checks:[false,true,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,false,true]},{title:'Assistance téléphonique illimitée',isTitle:false,isSpacer:false,checks:[false,false,true]}];case 124:return[{title:'Statuts de',dynamic:true,isTitle:true,isSpacer:false,checks:[true,true,true]},{title:'Vérification du dossier',isTitle:false,isSpacer:false,checks:[false,true,true]},{title:'Immatriculation auprès du greffe',isTitle:false,isSpacer:false,checks:[false,true,true]},{title:'Garantie anti-rejet',isTitle:false,isSpacer:false,checks:[false,true,true]},{title:"Publication de l'annonce légale",isTitle:false,isSpacer:false,checks:[false,true,true]},{title:'Obtention du Kbis',isTitle:false,isSpacer:true,checks:[false,true,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,false,true]},{title:'Assistance téléphonique illimitée',isTitle:false,isSpacer:false,checks:[false,false,true]}];// ASSO
case 162:return[{title:"Statuts d'",dynamic:true,isTitle:true,isSpacer:false,checks:[true,true,true]},{title:'Dossier Complet Création\n(Formulaires Cerfa, mandat,attestation de domiciliation, PV d\'assemblée générale)',isTitle:false,isSpacer:false,checks:[false,true,true]},{title:'Dossier Complet Vie de l\'Association\n(bulletin d\'adhésion, feuille de présence)',isTitle:false,isSpacer:false,checks:[false,false,true]},{title:'Enregistrement de l\'association',isTitle:false,isSpacer:false,checks:[false,true,true]},{title:'Échanges avec la Préfecture',isTitle:false,isSpacer:false,checks:[false,false,true]},{title:'Assistance obtention du SIRET',isTitle:false,isSpacer:false,checks:[false,false,true]},{title:'Assistance téléphonique illimitée',isTitle:false,isSpacer:false,checks:[false,false,true]},{title:'Traitement express (24h)',isTitle:false,isSpacer:false,checks:[false,false,true]},{title:'Garantie anti-rejet',isTitle:false,isSpacer:false,checks:[false,false,true]}];// rupture conventionnelle
case 184:return[{title:"Dossier juridique complet",dynamic:false,isTitle:true,isSpacer:false,checks:[true,true,true]},{title:"Vérification de l'ensemble du dossier par un avocat",isTitle:false,isSpacer:false,checks:[false,true,true]},{title:"Calculs des indemnités par un avocat",isTitle:false,isSpacer:true,checks:[false,true,true]},{title:"Accompagnement tout au long de la procédure ",isTitle:false,isSpacer:false,checks:[false,false,true]},{title:"Dépot du dossier jusqu'à homologation",isTitle:false,isSpacer:false,checks:[false,false,true]},{title:"Signature d'un accord transactionnel (si besoin)",isTitle:false,isSpacer:true,checks:[false,false,true]}];default:break;}}}]);return _threeColumnsPack;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price,third_price:state.checkout_operations.prices.third_price,chosen_pack:state.checkout_operations.pack,pricing_loading:state.loading_details.pricing,promo_percentage:state.checkout_operations.promo_percentage,title:state.contract.name};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{togglePack:function togglePack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["G" /* ceTogglePack */])(val));},selectOne:function selectOne(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(0));__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["l" /* P_SELECT_PACK_1 */]);},selectTwo:function selectTwo(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(1));__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["m" /* P_SELECT_PACK_2 */]);},selectThree:function selectThree(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(2));__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_4__tracking_pattern_detector__["n" /* P_SELECT_PACK_3 */]);}};};var ThreeColumnsPack=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_threeColumnsPack);/* harmony default export */ __webpack_exports__["a"] = (ThreeColumnsPack);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FAQ__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Phoneline__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Details__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_newCheckoutInfo__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ExtraPack_ExtraPack__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__upsell_pack_entrepreneurAB__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__upsell_pack_entrepreneurAB_Data__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_css__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tracking_lpevents__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PackSelector=function(_Component){_inherits(PackSelector,_Component);function PackSelector(props){_classCallCheck(this,PackSelector);var _this=_possibleConstructorReturn(this,(PackSelector.__proto__||Object.getPrototypeOf(PackSelector)).call(this,props));_this.goToNextStep=function(id,packName){//only for specefic product
if(Object.keys(__WEBPACK_IMPORTED_MODULE_12__upsell_pack_entrepreneurAB_Data__["a" /* packEntrepreneurData */]).indexOf(__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].contractMetaId.toString())>-1){_this.props.onPackEntrepreneurChoosePack(id);__WEBPACK_IMPORTED_MODULE_14__tracking_lpevents__["a" /* default */].trackDatalayerMixpanel('Pack Choice',''+packName);}else{_this.onSelectPack(id,packName);}};_this.onSelectPack=function(id,packName){var _this$props=_this.props,selectPack=_this$props.selectPack,togglePack=_this$props.togglePack;selectPack(id);togglePack(true,id);__WEBPACK_IMPORTED_MODULE_14__tracking_lpevents__["a" /* default */].trackDatalayerMixpanel('Pack Choice',''+packName);};_this.state={hasThreePack:false};return _this;}_createClass(PackSelector,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,first_price=_props.first_price,second_price=_props.second_price,third_price=_props.third_price,first_fee=_props.first_fee;var packHeaderDetails=Object(__WEBPACK_IMPORTED_MODULE_8__constants_newCheckoutInfo__["a" /* getGlobalData */])({first_price:first_price,second_price:second_price,third_price:third_price},first_fee)[__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].contractMetaId].packHeaderDetails;var appBody=document.getElementById('ce_v3');var appContainer=document.getElementById('app-container');if(appBody){appBody.classList.add('app-bg-blue');}if(appContainer){appContainer.classList.add('container-full-width');this.setState({hasThreePack:packHeaderDetails[2]&&Object.keys(packHeaderDetails[2]).length?true:false},function(){if(_this2.state.hasThreePack){appContainer.classList.add('container-threePacks');}});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var appContainer=document.getElementById('app-container');var appBody=document.getElementById('ce_v3');if(appBody){appBody.classList.remove('app-bg-blue');}if(appContainer){appContainer.classList.remove('container-full-width','container-threePacks');}}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,first_price=_props2.first_price,second_price=_props2.second_price,third_price=_props2.third_price,first_fee=_props2.first_fee,packEntrepreneurPack=_props2.packEntrepreneurPack;var _getGlobalData$lpApp$=Object(__WEBPACK_IMPORTED_MODULE_8__constants_newCheckoutInfo__["a" /* getGlobalData */])({first_price:first_price,second_price:second_price,third_price:third_price},first_fee)[__WEBPACK_IMPORTED_MODULE_9__app_lp_app__["a" /* default */].contractMetaId],headerTitle=_getGlobalData$lpApp$.headerTitle,packHeaderDetails=_getGlobalData$lpApp$.packHeaderDetails,contentInfoDetails=_getGlobalData$lpApp$.contentInfoDetails,faq=_getGlobalData$lpApp$.faq,extraPacksBottom=_getGlobalData$lpApp$.extraPacksBottom,extraPacksEC=_getGlobalData$lpApp$.extraPacksEC;if(typeof this.props.packEntrepreneurPack!=='undefined'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__upsell_pack_entrepreneurAB__["a" /* default */],{selectPack:this.onSelectPack,index:packEntrepreneurPack});}var hasThreePack=this.state.hasThreePack;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'packSelect-wrapper '+(hasThreePack?'threePacks':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Header__["a" /* default */],{title:headerTitle}),extraPacksEC&&extraPacksEC.length&&extraPacksEC.map(function(pack){return pack&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ExtraPack_ExtraPack__["a" /* default */],{hasThreePack:hasThreePack,pack:pack,selectPack:_this3.onSelectPack,isBottom:false,key:pack.id});}),packHeaderDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Details__["a" /* default */],{hasThreePack:hasThreePack,goToNextStep:this.goToNextStep,packHeaderDetails:packHeaderDetails,packFeatures:contentInfoDetails}),extraPacksBottom&&extraPacksBottom.length&&extraPacksBottom.map(function(pack){return pack&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ExtraPack_ExtraPack__["a" /* default */],{pack:pack,selectPack:function selectPack(){return _this3.onSelectPack(pack.id,pack.title);},isBottom:true,key:pack.id});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FAQ__["a" /* default */],{questions:faq}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Phoneline__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'footer-copyright'},'2020 \xA9 LegalPlace SAS'));}}]);return PackSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price,third_price:state.checkout_operations.prices.third_price,first_fee:typeof state.checkout_operations.admin_fees!=='undefined'?state.checkout_operations.admin_fees.first_price:0,chosen_pack:state.checkout_operations.pack,packEntrepreneurPack:state.checkout_operations.packEntrepreneur.choosePack,pricing_loading:state.loading_details.pricing,promo_percentage:state.checkout_operations.promo_percentage,title:state.contract.name};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{togglePack:function togglePack(val,id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["G" /* ceTogglePack */])(val,id));},onPackEntrepreneurChoosePack:function onPackEntrepreneurChoosePack(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_7" /* packEntrepreneurChoosePack */])(val));},selectPack:function selectPack(x){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["V" /* ckUpdatePack */])(x));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(x+1);}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PackSelector));

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__question__ = __webpack_require__(1162);
var FaqNew=function FaqNew(_ref){var questions=_ref.questions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'faq-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'faq-title'},'FAQ'),questions.map(function(question){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__question__["a" /* default */],{question:question,key:question.question});}));};/* harmony default export */ __webpack_exports__["a"] = (FaqNew);

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FaqQuestion=function(_Component){_inherits(FaqQuestion,_Component);function FaqQuestion(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FaqQuestion);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FaqQuestion.__proto__||Object.getPrototypeOf(FaqQuestion)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false},_this.toggleOpenQuestion=function(){var isOpen=_this.state.isOpen;_this.setState({isOpen:!isOpen});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FaqQuestion,[{key:"render",value:function render(){var _props$question=this.props.question,question=_props$question.question,answer=_props$question.answer;var isOpen=this.state.isOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faqQuestion-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faqQuestion-header",onClick:this.toggleOpenQuestion},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"faqQuestion-header-text"},question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faqQuestion-icon-container "+(isOpen?"isOpen":"isClosed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faqQuestion-icon "+(isOpen?"isOpen":"isClosed")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faqQuestion-icon vertical "+(isOpen?"isOpen":"isClosed")}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"faqQuestion-answer "+(isOpen?"isOpen":"isClosed")},answer));}}]);return FaqQuestion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FaqQuestion);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_phoneline_svg__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_phoneline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_phoneline_svg__);
var Phoneline=function Phoneline(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"phonelineContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside",{className:"phoneline"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_phoneline_svg___default.a,alt:"",className:"phoneline-icon"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"phoneline-subcontainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"phoneline-title"},"Pour toutes vos questions, appelez-nous au"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"tel:+33176350059",className:"phoneline-number"},"01 76 35 00 59"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"phoneline-subtext"},"Disponible du Lundi au Vendredi"))));};/* harmony default export */ __webpack_exports__["a"] = (Phoneline);

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMjVINkMzLjc5MDY3IDI1IDIgMjMuMjA5MyAyIDIxVjE3QzIgMTQuNzkwNyAzLjc5MDY3IDEzIDYgMTNIN0M3LjU1MiAxMyA4IDEzLjQ0OCA4IDE0VjI0QzggMjQuNTUyIDcuNTUyIDI1IDcgMjVaIiBzdHJva2U9IiMyMTI1MjkiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI4IDI1SDI3QzI2LjQ0OCAyNSAyNiAyNC41NTIgMjYgMjRWMTRDMjYgMTMuNDQ4IDI2LjQ0OCAxMyAyNyAxM0gyOEMzMC4yMDkzIDEzIDMyIDE0Ljc5MDcgMzIgMTdWMjFDMzIgMjMuMjA5MyAzMC4yMDkzIDI1IDI4IDI1WiIgc3Ryb2tlPSIjMjEyNTI5IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02IDEzQzYgNi45MjUzMyAxMC45MjUzIDIgMTcgMkMyMy4wNzQ3IDIgMjggNi45MjUzMyAyOCAxMyIgc3Ryb2tlPSIjMjEyNTI5IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMSAzMEgyNEMyNi4yMDkzIDMwIDI4IDI4LjIwOTMgMjggMjZWMjUiIHN0cm9rZT0iIzIxMjUyOSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkgMzJIMTdDMTUuODk2IDMyIDE1IDMxLjEwNCAxNSAzMEMxNSAyOC44OTYgMTUuODk2IDI4IDE3IDI4SDE5QzIwLjEwNCAyOCAyMSAyOC44OTYgMjEgMzBDMjEgMzEuMTA0IDIwLjEwNCAzMiAxOSAzMloiIHN0cm9rZT0iIzIxMjUyOSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMgMjEuNTg5NEMxNS4yNjY3IDIzLjY1NDcgMTguNzMzMyAyMy42NTQ3IDIxIDIxLjU4OTQiIHN0cm9rZT0iIzIxMjUyOSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMgMTQuMzEzMlYxNi4wNjI2IiBzdHJva2U9IiMyMTI1MjkiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIxIDE0LjMxMzJWMTYuMDYyNiIgc3Ryb2tlPSIjMjEyNTI5IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PackDetailsHeader__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableHeading__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TableRow__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PackDetailsFooter__ = __webpack_require__(1174);
var Details=function Details(_ref){var hasThreePack=_ref.hasThreePack,packHeaderDetails=_ref.packHeaderDetails,packFeatures=_ref.packFeatures,goToNextStep=_ref.goToNextStep;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main",{className:"packDetails-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PackDetailsHeader__["a" /* default */],{hasThreePack:hasThreePack,packHeaderDetails:packHeaderDetails,goToNextStep:goToNextStep}),packFeatures.map(function(feature){if(!feature)return null;var isHeading=feature.isHeading,title=feature.title,text=feature.text;if(isHeading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableHeading__["a" /* default */],{content:feature,key:text});}if(feature&&Object.keys(feature).length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TableRow__["a" /* default */],{hasThreePack:hasThreePack,content:feature,key:title});}return null;}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PackDetailsFooter__["a" /* default */],{hasThreePack:hasThreePack,packFooterDetails:packHeaderDetails,goToNextStep:goToNextStep}));};/* harmony default export */ __webpack_exports__["a"] = (Details);

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_headerImg1_svg__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_headerImg1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_headerImg1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_headerImg2_svg__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_headerImg2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_headerImg2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(272);
var PackDetailsHeader=function PackDetailsHeader(_ref){var hasThreePack=_ref.hasThreePack,packHeaderDetails=_ref.packHeaderDetails,goToNextStep=_ref.goToNextStep;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"header-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"headerImg-container "+(hasThreePack?"three-packs":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_headerImg1_svg___default.a,alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_headerImg2_svg___default.a,alt:""})),packHeaderDetails.map(function(pack){if(pack&&Object.keys(pack).length)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Card__["a" /* default */],{hasThreePack:hasThreePack,packDetails:pack,key:pack.id,goToNextStep:goToNextStep});return null;}));};/* harmony default export */ __webpack_exports__["a"] = (PackDetailsHeader);

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/headerImg1.9740f821.svg";

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PackBtn=function PackBtn(_ref){var goToNextStep=_ref.goToNextStep,isBottom=_ref.isBottom;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'card-btn '+(isBottom?'isBottom':''),onClick:goToNextStep},'Choisir ce pack');};/* harmony default export */ __webpack_exports__["a"] = (PackBtn);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon1_svg__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon1_svg__);
var TableHeading=function TableHeading(_ref){var content=_ref.content;var icon=content.icon,text=content.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tableHeading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"tableHeading-icon",src:icon,alt:"status"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"tableHeading-text"},text));};/* harmony default export */ __webpack_exports__["a"] = (TableHeading);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableIcon__ = __webpack_require__(1173);
var TableRow=function TableRow(_ref){var hasThreePack=_ref.hasThreePack,content=_ref.content;var title=content.title,text=content.content;var included=content.included;if(!hasThreePack){included=[included[0],included[1]];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tableRow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tableRow-content-container '+(hasThreePack?"three-packs":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'tableRow-content-title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'tableRow-content-text',dangerouslySetInnerHTML:{__html:text}})),included.map(function(option,index){// Get random Key for map
var key=Math.ceil(Math.random()*10);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableIcon__["a" /* default */],{hasThreePack:hasThreePack,isIncluded:option,key:index+'-'+key});}));};/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_included_icon_svg__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_included_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_included_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_not_included_icon_svg__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_not_included_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_not_included_icon_svg__);
var TableIcon=function TableIcon(_ref){var isIncluded=_ref.isIncluded,hasThreePack=_ref.hasThreePack;var icon=isIncluded?__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_included_icon_svg___default.a:__WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_not_included_icon_svg___default.a;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tableOption-container "+(hasThreePack?"three-packs":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:icon,alt:"ok"}));};/* harmony default export */ __webpack_exports__["a"] = (TableIcon);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__(272);
var PackDetailsFooter=function PackDetailsFooter(_ref){var hasThreePack=_ref.hasThreePack,packFooterDetails=_ref.packFooterDetails,goToNextStep=_ref.goToNextStep;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tableRow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tableRow-content-container "+(hasThreePack?"three-packs":"")}),packFooterDetails.map(function(pack){if(pack&&Object.keys(pack).length){var id=pack.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Card__["a" /* default */],{hasThreePack:hasThreePack,packDetails:pack,key:id,goToNextStep:goToNextStep});}return null;}));};/* harmony default export */ __webpack_exports__["a"] = (PackDetailsFooter);

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Header=function Header(_ref){var title=_ref.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"packSelect-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"packSelect-header-title"},title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,".")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"packSelect-header-subtitle"},"Choisissez votre pack, nous g\xE9rons ensuite toutes les d\xE9marches"));};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGlobalData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_img_NewPackSelector_table_heading_icon1_svg__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_img_NewPackSelector_table_heading_icon1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_img_NewPackSelector_table_heading_icon1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon2_svg__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon2_svg__);
var headerDetails=function headerDetails(first_price,second_price,feesPrice){var isAbTestProduct=[175,197,176,198].indexOf(lpApp.contractMetaId)>-1;return[{title:"Création Standard",subTitle:"On s'occupe de tout",price:second_price+"\u20AC",fees:true,id:1,info:feesPrice?displayFeesText(feesPrice):null},{title:"Création Express",subTitle:"Traité sous 24H",price:first_price+"\u20AC",fees:true,id:0,info:feesPrice?displayFeesText(feesPrice):null},Object.assign({},isAbTestProduct&&{title:"Création Offerte",subTitle:"Expert Comptable",price:'Offerte',id:3,info:feesPrice?displayFeesText(feesPrice):null})];};var faq=function faq(contractName){return[{question:"Pourquoi choisir LegalPlace ?",answer:"LegalPlace vous permet de créer votre société facilement, rapidement, et sans aucun risque de rejet par le greffe. Vos statuts sont parfaitement fiables juridiquement et adaptés à votre société. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et créent votre société en un temps record grâce à leur expérience et leur relations avec les greffes et autres administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre société, nous vous proposons de payer les frais de services et les frais administratifs en 3 fois sur 3 mois, sans aucun frais supplémentaire."},{question:"En combien de temps aurai-je mon K-bis?",answer:"Une fois votre dossier complet, nos experts lancent sous 24h* (formule express uniquement) toutes les démarches auprès du greffe et du journal d’annonce légale pour immatriculer votre société au plus vite. Vous recevrez alors votre Kbis en moyenne une semaine après (variable selon les départements)."},{question:"Que se passe-t-il après le paiement ?",answer:"Une fois le paiement effectu\xE9, vous serez redirig\xE9s vers un questionnaire avec des questions compl\xE9mentaires sur votre "+contractName+". Une fois le questionnaire compl\xE9t\xE9, vos statuts seront g\xE9n\xE9r\xE9s automatiquement et nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement). Vous recevrez alors vos statuts n\xE9cessaires \xE0 l\u2019ouverture de votre compte bancaire. Une fois votre compte bancaire ouvert, nos experts s\u2019occupent de tout jusqu\u2019\xE0 l\u2019obtention de votre Kbis."},{question:"Comment récupérer la TVA ?",answer:"Les frais de cr\xE9ation sont avanc\xE9s par un ou plusieurs associ\xE9s pour le compte de la soci\xE9t\xE9 en formation. Les associ\xE9s qui ont avanc\xE9 les co\xFBts de cr\xE9ation de "+contractName+" se remboursent une fois les fonds du compte bancaire de la soci\xE9t\xE9 d\xE9bloqu\xE9s \u2013 et \xE0 condition que la "+contractName+" dispose de la tr\xE9sorerie suffisante. La TVA aff\xE9rente aux frais de cr\xE9ation est d\xE9ductible dans le cadre des activit\xE9s de la soci\xE9t\xE9."}];};var displayFeesText=function displayFeesText(feesPrice){return"+ frais administratifs ("+feesPrice.toFixed(2).toString().replace('.',',')+"\u20AC)";};var getCompanyCreationDetails=function getCompanyCreationDetails(companyType){var isAbTestProduct=[175,197,176,198].indexOf(lpApp.contractMetaId)>-1;return[{text:"Statuts",isHeading:true,icon:__WEBPACK_IMPORTED_MODULE_0__styles_img_NewPackSelector_table_heading_icon1_svg___default.a},{title:"Statuts de "+companyType,included:[true,true,true],content:"Vous recevez vos statuts de "+companyType+" personnalis\xE9s gr\xE2ce aux r\xE9ponses renseign\xE9es dans le questionnaire. Vous recevrez \xE9galement le M0, les pi\xE8ces annexes obligatoires et le registre des b\xE9n\xE9ficiaires effectifs"},{title:"Vérification du dossier",included:[true,true,true],content:"Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin"},// Header 2
{text:"Nos experts juridiques prennent en charge votre dossier",isHeading:true,icon:__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon2_svg___default.a},// Content 2
{title:"Immatriculation auprès du greffe",included:[true,true,true],content:"Nous faisons les démarches nécessaire pour immatriculer votre société auprès du greffe"},{title:"Garantie anti-rejet",included:[true,true,true],content:"Il arrive parfois que le greffe rejette des dossiers afin de demander des informations complémentaires. Nos experts gèrent tous les cas de rejet"},{title:"Publication de l'annonce légale",included:[true,true,true],content:"Formalité obligatoire dans le cadre d'une constitution de société"},{title:"Obtention du kbis et du SIRET",included:[true,true,true],content:"Vous obtiendrez votre Kbis après vérification de votre dossier dans un délai de 8 jours en moyenne"},{title:"Traitement express (24h)",included:[false,true,true],content:"Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 8 à 12 jours"},{title:"Assistance téléphonique illimitée",included:[false,true,true],content:"Nos experts sont disponibles pour vous aider"},Object.assign({},isAbTestProduct?{title:"Solution complète d’expertise comptable",included:[false,false,true],content:"Vous bénificiez d’un expert comptable dédié ainsi que d’un logiciel de facturation"}:null)];};var todoOptions=["Préparer et vérifier le dossier complet","Demander l’immatriculation auprès du greffe","Gérer les échanges avec le greffe","Faire la publication de l'annonce légale"];var todoOptionsEC=['Vous payez uniquement les frais administratifs obligatoires','Après le paiement, un conseiller vous contacte pour vous présenter les modalités de la solution d’expertise comptable','Si vous souhaitez vous rétracter par la suite, nous vous remboursons à 100%'];var extraPackOptionsBottom=function extraPackOptionsBottom(companyType){return["Status de "+companyType];};var extraPackOptionsEC=['Tous les services du pack <br><b>Création Express</br>','Solution d’expertise <br>comptable'];var getGlobalData=function getGlobalData(_ref,feesPrice){var first_price=_ref.first_price,second_price=_ref.second_price,third_price=_ref.third_price;return{// creation-sci 3 packs
124:{headerTitle:"Votre SCI est prête à être créée",packHeaderDetails:headerDetails(first_price,second_price,feesPrice),faq:faq('SCI'),contentInfoDetails:getCompanyCreationDetails('SCI'),extraPacksBottom:[{title:"Statuts seuls",subTitle:"Vous créez seul",price:third_price+"\u20AC",options:extraPackOptionsBottom("SCI"),todoOptions:todoOptions,id:2,sectionTitles:['Ce pack contient','Ce qu’il vous reste à faire']}]},// Association: cr-ez-votre-association 162 
162:{headerTitle:"Votre association est prête à être créée",packHeaderDetails:[{title:"Statuts seuls",subTitle:"Vous créez seul",price:second_price+"\u20AC",fees:true,id:1},{title:"Création Express",subTitle:"On s'occupe de tout",price:first_price+"\u20AC",fees:true,id:0,info:"Possibilité de payer en 3 fois"}],faq:[{question:"Pourquoi choisir LegalPlace ?",answer:"LegalPlace vous permet de créer votre association facilement, rapidement, et sans aucun risque de rejet par la préfecture. Inutile de s’y connaître en droit ou en démarches administratives : nos experts s’occupent de tout. Vos statuts sont générés automatiquement grâce à vos réponses à notre questionnaire et sont parfaitement adaptés à votre association. Nos experts sont disponibles par email et téléphone pour répondre à vos questions et réalisent toutes les formalités administratives en un temps record grâce à leur expérience et leur relations avec les administrations. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre association, nous vous proposons de nous régler en 3 fois sur 3 mois, sans aucun frais supplémentaire."},{question:"En combien de temps mon association sera-t-elle créée ?",answer:"Une fois votre dossier complet, nos experts lancent sous 24h toutes les démarches pour créer votre association au plus vite. La création de votre association sera publiée au Journal Officiel des Association sous 7 à 10 jours et votre association sera alors officiellement créée !"},{question:"Que se passe-t-il après le paiement ?",answer:"Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires sur votre association. Une fois le questionnaire complété, vos statuts seront générés automatiquement. Nos experts traiterons alors votre dossier en moins de 24h* et vous contacterons en cas de besoin."},{question:"Comment personnaliser les statuts de mon association ?",answer:"Une fois le paiement effectué, vous serez redirigé vers un questionnaire qui vous demandera si vous souhaitez des statuts standards ou si vous souhaitez avoir un conseil d'administration, personnaliser les conditions d’adhésion, ajouter un président d’honneur, etc. Les statuts de votre association seront alors automatiquement modifiés en fonction de vos réponses."}],contentInfoDetails:[// Header 1
{text:"Statuts",isHeading:true,icon:__WEBPACK_IMPORTED_MODULE_0__styles_img_NewPackSelector_table_heading_icon1_svg___default.a},// Content 1
{title:"Statuts d'association",included:[true,true],content:"Vous recevez vos statuts d’association personnalisés grâce aux réponses renseignées dans le questionnaire"},{title:" Dossier complet",included:[true,true],content:"PV d'assemblée générale constitutive, Bulletin d'adhésion (pour les nouveaux nembres), Reçu de cotisation d'adhésion, Reçu fiscal de don(pour les déductions d'impôts en cas de don)"},// Header 2
{text:"Nos experts juridiques prennent en charge votre dossier",isHeading:true,icon:__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon2_svg___default.a},// Content 2
{title:"Enregistrement de l'association",included:[false,true],content:"Revue de votre dossier, échanges entre nos experts et vous en cas de besoin, puis dépôt de votre dossier à la préfecture"},{title:"Échanges avec la préfecture",included:[false,true],content:"En cas de rejet de votre dossier après instruction par les autorités administratives, nous vous assistons dans la reprise de votre dossier pour effectuer un nouveau dépôt"},{title:"Assistance obtention du SIRET",included:[false,true],content:"Nous vous préparons les pièces nécessaires pour l'obtention du numéro SIRET de votre association si vous envisagez d'en solliciter un (nécessaire dans certains cas)"},{title:"Traitement express (24h)",included:[false,true],content:"Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 10 à 15 jours"},{title:"Assistance téléphonique illimitée",included:[false,true],content:"Nos experts sont disponibles pour vous aider"}]},// Créez votre auto entreprise || creez-votre-micro-entreprise
181:{headerTitle:"Votre auto entreprise est prête à être créée",packHeaderDetails:headerDetails(first_price,second_price,feesPrice),faq:[{question:"Pourquoi choisir LegalPlace ?",answer:"LegalPlace vous permet de créer votre micro-entreprise en toute simplicité. Une fois vos réponses à notre questionnaire complétées, nos experts s’occupent de toutes les démarches administratives jusqu’à l’obtention de votre numéro SIREN. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre auto-entreprise, nous vous proposons de nous régler en 3 fois sur 3 mois, sans aucun frais supplémentaire."},{question:"En combien de temps mon auto-entreprise sera créée ?",answer:"Une fois votre dossier complet, nos experts lancent sous 24h (formule Express uniquement) toutes les démarches pour immatriculer votre auto-entreprise au plus vite. Vous obtiendrez alors votre numéro SIREN sous 10 à 30 jours en moyenne (variable selon les départements)."},{question:"Que se passe-t-il après le paiement ?",answer:"Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires. Une fois le questionnaire complété, nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement) et vous contacterons en cas de besoin."},{question:"Qu’est-ce que la demande d’ACCRE ?",answer:"L’ACCRE correspond à « Aide aux demandeurs d'emploi créant ou reprenant une entreprise ». Le dispositif consiste en une exonération de charges sociales pendant un an à partir du moment de l'immatriculation de la société ou au début de son activité. Si vous choisissez la formule Express, nos experts réalisent la demande d’Accre pour vous."}],contentInfoDetails:[// Header 1
{text:"Statuts",isHeading:true,icon:__WEBPACK_IMPORTED_MODULE_0__styles_img_NewPackSelector_table_heading_icon1_svg___default.a},// Content 1
{title:"Dossier juridique complet",included:[true,true],content:"Vous recevez le formulaire P0 complété ainsi que l'intégralité des documents juridiques nécessaires à la création de la micro-entreprise"},{title:"Vérification du dossier",included:[true,true],content:"Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin"},// Header 2
{text:"Nos experts juridiques prennent en charge votre dossier",isHeading:true,icon:__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon2_svg___default.a},// Content 2
{title:"Immatriculation auprès du greffe",included:[true,true],content:"Nous faisons les démarches nécessaire pour immatriculer votre société auprès du greffe"},{title:"Garantie anti-rejet",included:[true,true],content:"Il arrive parfois que le greffe rejette des dossiers afin de demander des informations complémentaires. Nos experts gèrent tous les cas de rejet"},{title:"Obtention du kbis et du SIRET",included:[true,true],content:"Vous obtiendrez votre Kbis après vérification de votre dossier dans un délai de 8 jours en moyenne"},{title:"Traitement express (24h)",included:[false,true],content:"Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 8 à 12 jours"},{title:"Assistance téléphonique illimitée",included:[false,true],content:"Nos experts sont disponibles pour vous aider"},{title:"Obtention de l'ACRE (ex ACCRE)",included:[false,true],content:"Nous nous chargeons de compléter pour vous votre formulaire ACRE afin de vous permettre de bénéficier des réductions d'impôts dédiées au créateur d'entreprise"}]},// Créez votre auto entreprise artisan || devenir-artisan
680:{headerTitle:"Votre auto entreprise est prête à être créée",packHeaderDetails:[{title:"Création Standard",subTitle:"On s'occupe de tout",price:second_price+"\u20AC",fees:true,id:1,info:Boolean(feesPrice)&&"+ "+feesPrice+"\u20AC de frais d\u2019inscription \xE0 la CMA"},{title:"Création Express",subTitle:"Traité sous 24H",price:first_price+"\u20AC",fees:true,id:0,info:Boolean(feesPrice)&&"+ "+feesPrice+"\u20AC de frais d\u2019inscription \xE0 la CMA"}],faq:[{question:"Pourquoi choisir LegalPlace ?",answer:"LegalPlace vous permet de créer votre micro-entreprise en toute simplicité. Une fois vos réponses à notre questionnaire complétées, nos experts s’occupent de toutes les démarches administratives jusqu’à l’obtention de votre numéro SIREN. De plus, comme nous souhaitons vous donner un coup de pouce pour la création de votre auto-entreprise, nous vous proposons de nous régler en 3 fois sur 3 mois, sans aucun frais supplémentaire."},{question:"En combien de temps mon auto-entreprise sera créée ?",answer:"Une fois votre dossier complet, nos experts lancent sous 24h (formule Express uniquement) toutes les démarches pour immatriculer votre auto-entreprise au plus vite. Vous obtiendrez alors votre numéro SIREN sous 10 à 30 jours en moyenne (variable selon les départements)."},{question:"Que se passe-t-il après le paiement ?",answer:"Une fois le paiement effectué, vous serez redirigés vers un questionnaire avec des questions complémentaires. Une fois le questionnaire complété, nos experts traiterons votre dossier en moins de 24h* (formule Express uniquement) et vous contacterons en cas de besoin."},{question:"Qu’est-ce que la demande d’ACCRE ?",answer:"L’ACCRE correspond à « Aide aux demandeurs d'emploi créant ou reprenant une entreprise ». Le dispositif consiste en une exonération de charges sociales pendant un an à partir du moment de l'immatriculation de la société ou au début de son activité. Si vous choisissez la formule Express, nos experts réalisent la demande d’Accre pour vous."}],contentInfoDetails:[// Header 1
{text:"Statuts",isHeading:true,icon:__WEBPACK_IMPORTED_MODULE_0__styles_img_NewPackSelector_table_heading_icon1_svg___default.a},// Content 1
{title:"Dossier juridique complet",included:[true,true],content:"Vous recevez le formulaire P0 complété ainsi que l'intégralité des documents juridiques nécessaires à la création de la micro-entreprise"},{title:"Vérification du dossier",included:[true,true],content:"Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin"},// Header 2
{text:"Nos experts juridiques prennent en charge votre dossier",isHeading:true,icon:__WEBPACK_IMPORTED_MODULE_1__styles_img_NewPackSelector_table_heading_icon2_svg___default.a},// Content 2
{title:"Immatriculation auprès du greffe",included:[true,true],content:"Nous faisons les démarches nécessaire pour immatriculer votre société auprès du greffe"},{title:"Garantie anti-rejet",included:[true,true],content:"Il arrive parfois que le greffe rejette des dossiers afin de demander des informations complémentaires. Nos experts gèrent tous les cas de rejet"},{title:"Obtention du kbis et du SIRET",included:[true,true],content:"Vous obtiendrez votre Kbis après vérification de votre dossier dans un délai de 8 jours en moyenne"},{title:"Traitement express (24h)",included:[false,true],content:"Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 8 à 12 jours"},{title:"Assistance téléphonique illimitée",included:[false,true],content:"Nos experts sont disponibles pour vous aider"},{title:"Obtention de l'ACRE (ex ACCRE)",included:[false,true],content:"Nous nous chargeons de compléter pour vous votre formulaire ACRE afin de vous permettre de bénéficier des réductions d'impôts dédiées au créateur d'entreprise"}]},///creation-sarl
197:{headerTitle:"Votre SARL est prête à être créée",packHeaderDetails:headerDetails(first_price,second_price,feesPrice),faq:faq('SARL'),contentInfoDetails:getCompanyCreationDetails('SARL'),extraPacksEC:[{title:"Création Offerte",subTitle:"Expert Comptable",price:'Offerte',options:extraPackOptionsEC,todoOptions:todoOptionsEC,info:feesPrice?displayFeesText(feesPrice):null,id:3,sectionTitles:['Ce pack contient','Comment cela fonctionne ?']}],extraPacksBottom:[{title:"Statuts seuls",subTitle:"Vous créez seul",price:third_price+"\u20AC",options:extraPackOptionsBottom("SARL"),todoOptions:todoOptions,id:2,sectionTitles:['Ce pack contient','Ce qu’il vous reste à faire']}]},// creation-eurl 3 packs
198:{headerTitle:"Votre EURL est prête à être créée",packHeaderDetails:headerDetails(first_price,second_price,feesPrice),faq:faq('EURL'),contentInfoDetails:getCompanyCreationDetails('EURL'),extraPacksEC:[{title:"Création Offerte",subTitle:"Expert Comptable",price:'Offerte',options:extraPackOptionsEC,todoOptions:todoOptionsEC,info:feesPrice?displayFeesText(feesPrice):null,id:3,sectionTitles:['Ce pack contient','Comment cela fonctionne ?']}],extraPacksBottom:[{title:"Statuts seuls",subTitle:"Vous créez seul",price:third_price+"\u20AC",options:extraPackOptionsBottom("EURL"),todoOptions:todoOptions,id:2,sectionTitles:['Ce pack contient','Ce qu’il vous reste à faire']}]},// creation-SAS 3 packs
175:{headerTitle:"Votre SAS est prête à être créée",packHeaderDetails:headerDetails(first_price,second_price,feesPrice),faq:faq('SAS'),contentInfoDetails:getCompanyCreationDetails('SAS'),extraPacksEC:[{title:"Création Offerte",subTitle:"Expert Comptable",price:'Offerte',options:extraPackOptionsEC,todoOptions:todoOptionsEC,info:feesPrice?displayFeesText(feesPrice):null,id:3,sectionTitles:['Ce pack contient','Comment cela fonctionne ?']}],extraPacksBottom:[{title:"Statuts seuls",subTitle:"Vous créez seul",price:third_price+"\u20AC",options:extraPackOptionsBottom("SAS"),todoOptions:todoOptions,id:2,sectionTitles:['Ce pack contient','Ce qu’il vous reste à faire']}]},// creation-SASU 3 packs
176:{headerTitle:"Votre SASU est prête à être créée",packHeaderDetails:headerDetails(first_price,second_price,feesPrice),faq:faq('SASU'),contentInfoDetails:getCompanyCreationDetails('SASU'),extraPacksEC:[{title:"Création Offerte",subTitle:"Expert Comptable",price:'Offerte',options:extraPackOptionsEC,todoOptions:todoOptionsEC,info:feesPrice?displayFeesText(feesPrice):null,id:3,sectionTitles:['Ce pack contient','Comment cela fonctionne ?']}],extraPacksBottom:[{title:"Statuts seuls",subTitle:"Vous créez seul",price:third_price+"\u20AC",options:extraPackOptionsBottom("SASU"),todoOptions:todoOptions,id:2,sectionTitles:['Ce pack contient','Ce qu’il vous reste à faire']}]}};};

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extraPack_css__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extraPack_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__extraPack_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_included_icon_svg__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_included_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_included_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_img_NewPackSelector_not_included_icon_svg__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_img_NewPackSelector_not_included_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_img_NewPackSelector_not_included_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Details_Card__ = __webpack_require__(272);
var ExtraPack=function ExtraPack(_ref){var pack=_ref.pack,selectPack=_ref.selectPack,isBottom=_ref.isBottom,hasThreePack=_ref.hasThreePack;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"extraPack-container "+(isBottom?'isBottom':'')+" "+(hasThreePack?'threePacks':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Details_Card__["a" /* default */],{packDetails:pack,goToNextStep:selectPack,isBottom:isBottom}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"extraPack-item-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"extraPack-item-title"},pack.sectionTitles[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"extraPack-item-list"},pack.options&&pack.options.length&&pack.options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"extraPack-item-listItem",key:"option_"+(index+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"includedIcon",src:__WEBPACK_IMPORTED_MODULE_2__styles_img_NewPackSelector_included_icon_svg___default.a,alt:"ok"}),isBottom?option:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:option}}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"extraPack-item-container todo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"extraPack-item-title"},pack.sectionTitles[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"extraPack-item-list"},pack.todoOptions&&pack.todoOptions.length&&pack.todoOptions.map(function(todo,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"extraPack-item-listItem",key:"todo_"+(index+1)},isBottom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"includedIcon",src:__WEBPACK_IMPORTED_MODULE_3__styles_img_NewPackSelector_not_included_icon_svg___default.a,alt:"ok"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"extrapack-item-listItem-number"},index+1),todo);}))));};/* harmony default export */ __webpack_exports__["a"] = (ExtraPack);

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logic_wording__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/options.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var _OptionsSelection=function(_Component){_inherits(_OptionsSelection,_Component);function _OptionsSelection(){_classCallCheck(this,_OptionsSelection);return _possibleConstructorReturn(this,(_OptionsSelection.__proto__||Object.getPrototypeOf(_OptionsSelection)).apply(this,arguments));}_createClass(_OptionsSelection,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'page-section hidden-xs',id:'pack-options'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'section-title'},'Options Compl\xE9mentaires'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media pack-option'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/icn-user.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'media-heading'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('20 minutes d\'appel avec un avocat expérimenté'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-right'},!this.props.call_state?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lp-cart-price'},'29.90 \u20AC'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'po-added'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-x-right'},!this.props.call_state?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn po-btn-add',onClick:this.props.addCall},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Ajouter')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn po-btn-delete',onClick:this.props.removeCall},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Enlever')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media pack-option'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/wizard/img/icn-letter.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'media-heading'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Recevoir mon document par courrier'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-right'},!this.props.letter_state?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'lp-cart-price'},'3.90 \u20AC'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'po-added'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-checkmark'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-x-right'},!this.props.letter_state?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn po-btn-add',onClick:this.props.addLetter},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Ajouter')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn po-btn-delete',onClick:this.props.removeLetter},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Enlever'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline pack-qte'+(this.props.letter_state?'':' hidden')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'qte'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])("Nombre d'exemplaires")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',id:'qte',min:'1',value:this.props.letter_nbr,onChange:function onChange(evt){return _this2.props.updateNumber(evt.target.value);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pack-address-receive'+(this.props.letter_state?'':' hidden')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'d1'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Nom et prénoms ou nom de la société')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',id:'d1',value:this.props.letter_name,onChange:function onChange(val){return _this2.props.updateName(val.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'d1'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Adresse complète')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',id:'d1',value:this.props.letter_address,onChange:function onChange(e){return _this2.props.updateAddress(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'d1'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Ville')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',id:'d1',value:this.props.letter_city,onChange:function onChange(e){return _this2.props.updateCity(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'d1'},Object(__WEBPACK_IMPORTED_MODULE_4__logic_wording__["a" /* _lp */])('Code postal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',id:'d1',value:this.props.letter_zip,onChange:function onChange(e){return _this2.props.updateZip(e.target.value);}}))))));}}]);return _OptionsSelection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{call_state:state.checkout_operations.has_call,letter_state:state.checkout_operations.has_letter,letter_nbr:state.checkout_operations.letter.number,letter_name:state.checkout_operations.letter.name,letter_address:state.checkout_operations.letter.address,letter_city:state.checkout_operations.letter.city,letter_zip:state.checkout_operations.letter.zip};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{addCall:function addCall(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["P" /* ckSetCall */])(true));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["a" /* P_ADD_CALL */]);},removeCall:function removeCall(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["P" /* ckSetCall */])(false));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["j" /* P_REMOVE_CALL */]);},addLetter:function addLetter(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["Q" /* ckSetSending */])(true));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["b" /* P_ADD_LETTER */]);},removeLetter:function removeLetter(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["Q" /* ckSetSending */])(false));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["k" /* P_REMOVE_LETTER */]);},updateNumber:function updateNumber(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["T" /* ckUpdateLettersNbr */])(val));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["d" /* P_CHANGE_LETTER */]);},updateName:function updateName(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["U" /* ckUpdateName */])(val));},updateAddress:function updateAddress(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["R" /* ckUpdateAddress */])(val));__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_3__tracking_pattern_detector__["o" /* P_UPDATE_ADDRESS */]);},updateCity:function updateCity(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["S" /* ckUpdateCity */])(val));},updateZip:function updateZip(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["X" /* ckUpdateZip */])(val));}};};var OptionsSelection=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_OptionsSelection);/* harmony default export */ __webpack_exports__["a"] = (OptionsSelection);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__card_modal__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__payment_modal__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_lp_app__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/buy/mobile_pay_bar.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var _MobilePayBar=function(_Component){_inherits(_MobilePayBar,_Component);function _MobilePayBar(props){_classCallCheck(this,_MobilePayBar);var _this=_possibleConstructorReturn(this,(_MobilePayBar.__proto__||Object.getPrototypeOf(_MobilePayBar)).call(this,props));_this.showCreditCardModal=_this.showCreditCardModal.bind(_this);_this.state={show_modal:false,show_modal1:false};return _this;}_createClass(_MobilePayBar,[{key:'showCreditCardModal',value:function showCreditCardModal(){// Tracking opened payment popup
var eventParams={};eventParams['Chosen price']=parseFloat(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].ops.checkout.getPackPrice());eventParams['Total price']=parseFloat(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice());eventParams['Chosen pack']=this.props.choosenPack===0?'first_price':'second_price';if(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].subscription&&this.props.choosenPack===1)eventParams['Chosen pack']='abonnement';__WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__["a" /* default */].track('Opened Payment Popup',eventParams);__WEBPACK_IMPORTED_MODULE_3__tracking_lpevents__["a" /* default */].trackPopUpCheckout();if(__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].subscription&&this.props.choosenPack===1){this.setState({show_modal1:true});}else this.setState({show_modal:true});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-bar visible-xs visible-sm',ref:'_one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bb-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cbb-price'},Object(__WEBPACK_IMPORTED_MODULE_2__logic_wording__["a" /* _lp */])('Prix TTC : ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cbb-price is-bold'},__WEBPACK_IMPORTED_MODULE_6__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice(),' ','\u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn btn-primary cta-payement',onClick:this.showCreditCardModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-lock'}),Object(__WEBPACK_IMPORTED_MODULE_2__logic_wording__["a" /* _lp */])('Acheter')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:this.state.show_modal||this.state.show_modal1?'':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__card_modal__["a" /* default */],{show:this.state.show_modal,closeEvent:function closeEvent(){return _this2.setState({show_modal:false});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__payment_modal__["a" /* default */],{show:this.state.show_modal1,closeEvent:function closeEvent(){return _this2.setState({show_modal1:false});}}))));}}]);return _MobilePayBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{promo_code:state.checkout_operations.promo_code,confirmation:state.checkout_operations.confirm,promo_percentage:state.checkout_operations.promo_percentage,pack_price:state.checkout_operations.pack===0?state.checkout_operations.prices.first_price:state.checkout_operations.prices.second_price,call_chosen:state.checkout_operations.has_call,letter_chosen:state.checkout_operations.has_letter,// now with the letter informayion
letter_number:state.checkout_operations.letter.number,client_email:state.account_settings.mail,choosenPack:state.checkout_operations.pack,title:state.contract.name,first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price};};var mapDispatchToProps=function mapDispatchToProps(){return{};};var LpMobilePayBar=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_MobilePayBar);/* harmony default export */ __webpack_exports__["a"] = (LpMobilePayBar);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Project: LegalPlace assistant
 * File: src/components/buy/invoice.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/var LpInvoice=function(_Component){_inherits(LpInvoice,_Component);function LpInvoice(props){_classCallCheck(this,LpInvoice);var _this=_possibleConstructorReturn(this,(LpInvoice.__proto__||Object.getPrototypeOf(LpInvoice)).call(this,props));_this.visiblityCallback=_this.visiblityCallback.bind(_this);_this.nameCallback=_this.nameCallback.bind(_this);_this.addressCallback=_this.addressCallback.bind(_this);_this.cityCallback=_this.cityCallback.bind(_this);_this.zipCallback=_this.zipCallback.bind(_this);_this.tvaCallback=_this.tvaCallback.bind(_this);return _this;}_createClass(LpInvoice,[{key:'visiblityCallback',value:function visiblityCallback(){this.props.toggleInvoice();}},{key:'nameCallback',value:function nameCallback(evt){this.props.updateName(evt.target.value);}},{key:'addressCallback',value:function addressCallback(evt){this.props.updateAddress(evt.target.value);}},{key:'cityCallback',value:function cityCallback(evt){this.props.updateCity(evt.target.value);}},{key:'zipCallback',value:function zipCallback(evt){this.props.updateZIP(evt.target.value);}},{key:'tvaCallback',value:function tvaCallback(evt){this.props.updateTVA(evt.target.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'hidden-xs page-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cb-title form-group lp-chbx'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',id:'facture',name:'facture',className:'',onChange:this.visiblityCallback,style:{marginRight:'10px'},value:this.props.visible}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'facture'},'Je souhaiterais recevoir une facture (optionnel)')),this.props.visible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vars ng-scope'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'section-title'},'Veuillez renseigner ces informations, si vous souhaitez recevoir une facture.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cr-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Nom et Pr\xE9noms ou Nom de la Soci\xE9t\xE9:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'organization',className:'form-control',onChange:this.nameCallback})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Adresse compl\xE8te :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'address',className:'form-control',onChange:this.addressCallback})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-7 form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Ville :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'city',className:'form-control',onChange:this.cityCallback})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5 form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Code postal :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'zip_code',className:'form-control',onChange:this.zipCallback}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Num\xE9ro de TVA (si applicable) :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'nb_tva',className:'form-control',onChange:this.tvaCallback})))));}}]);return LpInvoice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{visible:state.checkout_operations.toggle_invoice};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleInvoice:function toggleInvoice(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_2" /* invoiceUpdateVisibility */])());},updateName:function updateName(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_0" /* invoiceUpdateName */])(val));},updateCity:function updateCity(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["Z" /* invoiceUpdateCity */])(val));},updateAddress:function updateAddress(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["Y" /* invoiceUpdateAddress */])(val));},updateTVA:function updateTVA(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_1" /* invoiceUpdateTVA */])(val));},updateZIP:function updateZIP(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_checkout_operations__["_3" /* invoiceUpdateZip */])(val));}};};/* harmony default export */ __webpack_exports__["a"] = (LpInvoice=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(LpInvoice));

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LearnMore__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Slider__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_checkoutData__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckoutHeader__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CheckoutStepsList__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Cart_CartNew__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__card_modal__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckoutUpsell__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__logic_utils_experimentsDataHelpers__ = __webpack_require__(463);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckoutNew=function(_Component){_inherits(CheckoutNew,_Component);function CheckoutNew(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CheckoutNew);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CheckoutNew.__proto__||Object.getPrototypeOf(CheckoutNew)).call.apply(_ref,[this].concat(args))),_this),_this.checkoutCoursierData=__WEBPACK_IMPORTED_MODULE_5__constants_checkoutData__["a" /* checkoutData */][302],_this.state={showPaymentModal:false,upsellItems:_this.checkoutCoursierData.upsellData},_this.toggleUpsellPrice=function(){var updatedUpsellItems=_this.state.upsellItems.map(function(item){return item=Object.assign({},item,{isSelected:!item.isSelected});});_this.setState({upsellItems:updatedUpsellItems});},_this.showPaymentModal=function(){// Tracking opened payment popup
var eventParams={};lpevents.trackPopUpCheckout();lpevents.track("Opened Payment Popup",eventParams);_this.setState({showPaymentModal:true});},_this.closePaymentModal=function(){return _this.setState({showPaymentModal:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CheckoutNew,[{key:"componentDidMount",value:function componentDidMount(){var appBody=document.getElementById("page-checkout");if(appBody){appBody.classList.add("app-bg-lightgrey");}}},{key:"render",value:function render(){var _this2=this;var _props$customerFirstN=this.props.customerFirstName,customerFirstName=_props$customerFirstN===undefined?null:_props$customerFirstN;var _state=this.state,showPaymentModal=_state.showPaymentModal,upsellItems=_state.upsellItems;var _checkoutCoursierData=this.checkoutCoursierData,steps=_checkoutCoursierData.steps,contractType=_checkoutCoursierData.contractType,checkoutHeaderImg=_checkoutCoursierData.checkoutHeaderImg,upsellData=_checkoutCoursierData.upsellData;var firstName=customerFirstName?" "+customerFirstName:"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkoutNew-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkoutNew-recap-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CheckoutHeader__["a" /* default */],{checkoutHeaderImg:checkoutHeaderImg,customerFirstName:firstName,contractType:contractType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CheckoutStepsList__["a" /* default */],{checkoutSteps:steps})),upsellData.map(function(upsell,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CheckoutUpsell__["a" /* default */],{addUpsellPrice:_this2.toggleUpsellPrice,upsellData:upsell,key:"upsell_"+(index+1)});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Cart_CartNew__["a" /* default */],{upsellItems:upsellItems}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LearnMore__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Slider__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Nous nous occupons de toutes les d\xE9marches administratives pour vous permettre de devenir micro-entrepreneur et commencer votre activit\xE9 de coursier \xE0 v\xE9lo."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Notre expertise permet de garantir que vous obtiendrez votre Kbis dans les meilleurs d\xE9lais et que votre dossier est garanti valide et conforme.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__card_modal__["a" /* default */],{show:showPaymentModal,closeEvent:this.closePaymentModal}));}}]);return CheckoutNew;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{customerFirstName:state.loadedOvc.v["30"]};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(CheckoutNew));

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__learnmore_css__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__learnmore_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__learnmore_css__);
var learnMoreData=[{statNumber:297,contentText:"coursiers à vélo ont démarré leur activité grâce à LegalPlace"},{statNumber:"97%",contentText:"de satisfaction clients"}];var LearnMoreItem=function LearnMoreItem(_ref){var statNumber=_ref.statNumber,contentText=_ref.contentText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"learnmore_card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"learnmore_card_title"},statNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"learnmore_card_text"},contentText));};var LearnMore=function LearnMore(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"learnmore_wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"learnmore_title"},"En savoir plus sur Legalplace"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"learnmore_cards_wrapper"},learnMoreData.map(function(blocElement,index){var statNumber=blocElement.statNumber,contentText=blocElement.contentText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LearnMoreItem,{statNumber:statNumber,contentText:contentText,key:"learnMoreItem_"+(index+1)});})));};/* harmony default export */ __webpack_exports__["a"] = (LearnMore);

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_star_svg__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_star_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slider_css__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__slider_css__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var reviewSlidesData=[{slideClass:"slide_1",rating:5,heading:"Avis clients",reviewText:"Accompagnement tout au long de ma procédure, professionalisme et efficacité",customerName:"Bilal — devenu coursier en Février 2020"},{slideClass:"slide_2",rating:5,heading:"Avis clients",reviewText:"Démarche rapide et 100% digitalisée! j'ai gagné beaucoup de temps!",customerName:"Flora — devenue coursière en Février 2020"},{slideClass:"slide_3",rating:5,heading:"Avis clients",reviewText:"Avec LegalPlace j'ai pu finir ma démarche vite fait! Je recommande vivement!!!",customerName:"Lucas — devenu coursier en Janvier 2020"}];var Rating=function Rating(_ref){var rating=_ref.rating;var index=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,[].concat(_toConsumableArray(Array(rating))).map(function(){index++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"star",src:__WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_star_svg___default.a,key:"star_"+index});}));};var Slide=function Slide(_ref2){var slideClass=_ref2.slideClass,rating=_ref2.rating,heading=_ref2.heading,reviewText=_ref2.reviewText,customerName=_ref2.customerName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slide "+slideClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slide-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Rating,{rating:rating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"slide-text-header"},heading)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"slide-body"},reviewText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"slide-footer"},customerName));};var Slider=function Slider(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slideshow-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"slide-container"},reviewSlidesData.map(function(slideElement,index){var slideClass=slideElement.slideClass,rating=slideElement.rating,heading=slideElement.heading,reviewText=slideElement.reviewText,customerName=slideElement.customerName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Slide,{key:"reviewSlide_"+(index+1),slideClass:slideClass,rating:rating,heading:heading,reviewText:reviewText,customerName:customerName});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"loading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,".")));};/* harmony default export */ __webpack_exports__["a"] = (Slider);

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDBMMTIuMzYwNyA3LjYzOTMySDIwTDEzLjgxOTcgMTIuMzYwN0wxNi4xODAzIDIwTDEwIDE1LjI3ODZMMy44MTk2NiAyMEw2LjE4MDM0IDEyLjM2MDdMMCA3LjYzOTMySDcuNjM5MzJMMTAgMFoiIGZpbGw9IiNGRjk4MDAiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkoutData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_img_newCheckout_checkoutHeader_svg__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_img_newCheckout_checkoutHeader_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_img_newCheckout_checkoutHeader_svg__);
var checkoutData={302:{checkoutHeaderImg:__WEBPACK_IMPORTED_MODULE_0__styles_img_newCheckout_checkoutHeader_svg___default.a,contractType:'statut de micro-entrepreneur',steps:[{id:1,status:'first',content:'Vous complétez le questionnaire d’informations'},{id:2,status:'next',content:'Nous préparons votre dossier pour qu’il soit conforme'},{id:3,status:'upcoming',content:'Nous déposons votre dossier auprès du greffe'},{id:4,status:'upcoming',content:'Nous assurons la gestion des échanges avec le greffe'},{id:5,status:'beforeLast',content:'Nous vous obtenons le Kbis'},{id:6,status:'last',content:'Vous pouvez démarrer votre activité !'}],upsellData:[{name:'Assistance inscription Uber',priceHT:12.5,priceTTC:15,oldPrice:null,isSelected:false,description:['En optant pour l’assistance inscription, nous vous aidons à terminer les démarches d’inscription sur le site d’Uber Eats.'],includedOptions:[{heading:'Guide étape par étape',text:'Nous vous fournissons un guide étape par étape pour effectuer votre inscription sur le site d’Uber Eats.'},{heading:'Assistance téléphonique',text:' Si vous rencontrez des soucis durant votre inscription, un conseiller vous guide et répond à vos questions en direct.'}]}]}};

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checkoutHeader.12df0e33.svg";

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CheckoutHeader=function CheckoutHeader(_ref){var checkoutHeaderImg=_ref.checkoutHeaderImg,customerFirstName=_ref.customerFirstName,contractType=_ref.contractType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkoutNew-recap-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"checkoutNew-recap-header-img",src:checkoutHeaderImg,alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"checkoutNew-recap-header-title"},"Merci"+customerFirstName+", vous avez presque termin\xE9 !"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"checkoutNew-recap-header-subtitle"},"Une fois que vous aurez termin\xE9 ce questionnaire, nous allons entamer les d\xE9marches pour cr\xE9er votre "+contractType));};/* harmony default export */ __webpack_exports__["a"] = (CheckoutHeader);

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckoutStep__ = __webpack_require__(1195);
var CheckoutStepsList=function CheckoutStepsList(_ref){var checkoutSteps=_ref.checkoutSteps;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'checkoutCoursier-recap-stepsList'},checkoutSteps.map(function(step,index){var status=step.status,content=step.content,id=step.id;var isLastStep=index===checkoutSteps.length-1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CheckoutStep__["a" /* default */],{statusClass:status,content:content,key:id,isLastStep:isLastStep});}));};/* harmony default export */ __webpack_exports__["a"] = (CheckoutStepsList);

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_checkoutStep_emoji_svg__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_checkoutStep_emoji_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_checkoutStep_emoji_svg__);
var CheckoutStep=function CheckoutStep(_ref){var statusClass=_ref.statusClass,content=_ref.content,isLastStep=_ref.isLastStep;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"checkoutNew-recap-checkoutStep"},isLastStep?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"checkoutNew-recap-checkoutStep-emoji",src:__WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_checkoutStep_emoji_svg___default.a}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkoutNew-recap-checkoutStep-status "+statusClass}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"checkoutNew-recap-checkoutStep-text "+statusClass},content));};/* harmony default export */ __webpack_exports__["a"] = (CheckoutStep);

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CartCta__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__card_modal__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions_checkout_operations__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_lp_app__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CartPromoCodeBtn__ = __webpack_require__(1201);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartNew=function(_Component){_inherits(CartNew,_Component);function CartNew(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CartNew);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CartNew.__proto__||Object.getPrototypeOf(CartNew)).call.apply(_ref,[this].concat(args))),_this),_this.state={showPromoCodeInput:false,showPaymentModal:false},_this.showPaymentModal=function(){// Tracking opened payment popup
var eventParams={};eventParams["Chosen price"]=parseFloat(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.checkout.getPackPrice());eventParams["Total price"]=parseFloat(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].ops.checkout.getTTCPrice());eventParams["Chosen pack"]="first_price";if(__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].subscription&&_this.props.chosenPack===1){eventParams["Chosen pack"]="abonnement";}lpevents.trackPopUpCheckout();lpevents.track("",eventParams);_this.setState({showPaymentModal:true});},_this.closePaymentModal=function(){return _this.setState({showPaymentModal:false});},_this.showPromoCodeInput=function(){return _this.setState({showPromoCodeInput:true});},_this.sendPromo=function(){_this.props.checkPromo(_this.props.promo_code,__WEBPACK_IMPORTED_MODULE_7__app_lp_app__["a" /* default */].contractUniqid);_this.setState({showPromoCodeInput:false});},_this.updatePromoCode=function(event){_this.props.updatePromo(event.target.value);},_this.getCartWidth=function(){var windowWidth=window.innerWidth;if(windowWidth<=990){_this.setState({windowWidth:windowWidth});}},_this.getTotalWithPromoCode=function(total,hasValidPromoCode,PromoPercentage){return hasValidPromoCode&&total*(1-PromoPercentage)||total;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CartNew,[{key:'render',value:function render(){var _state=this.state,showPaymentModal=_state.showPaymentModal,showPromoCodeInput=_state.showPromoCodeInput,windowWidth=_state.windowWidth;var _props=this.props,promo_code=_props.promo_code,promo_loading=_props.promo_loading,promo_percentage=_props.promo_percentage,upsellItems=_props.upsellItems,pack_priceHT=_props.pack_priceHT;var hasPromoCode=promo_code.length>0;var selectedUpsellItems=upsellItems.filter(function(item){return item.isSelected;});var upsellPaymentData=upsellItems.map(function(item){return item.isSelected;});var isValidPromoCode=hasPromoCode&&typeof promo_percentage!=="string"&&promo_percentage!==0;var isInvalidPromoCode=typeof promo_percentage==='string';var promoDiscountRate=parseFloat(promo_percentage)*100;var packPriceWithCode=pack_priceHT&&this.getTotalWithPromoCode(pack_priceHT,isValidPromoCode,promo_percentage);var totalTTC=packPriceWithCode*1.2;var tvaPrice=totalTTC/120*20;if(selectedUpsellItems.length>0){selectedUpsellItems.forEach(function(upsellItem){var priceHT=upsellItem.priceHT;var newPrice=packPriceWithCode+priceHT;totalTTC=newPrice*1.2;tvaPrice=totalTTC/6;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-display-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-content-container',style:{width:windowWidth+'px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotalContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},'Tarif HT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},(pack_priceHT&&pack_priceHT.toFixed(2))+' \u20AC')),isValidPromoCode&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotalContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},'Code de r\xE9duction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},'- '+promoDiscountRate+' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotalContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},'Sous-total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},packPriceWithCode.toFixed(2)+' \u20AC'))),selectedUpsellItems.length>0&&selectedUpsellItems.map(function(upsellItem,index){var name=upsellItem.name,priceHT=upsellItem.priceHT;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotalContainer',key:'upsellItem_'+(index+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},priceHT.toFixed(2)+' \u20AC'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-subtotalContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},'TVA \xE0 20%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-subtotalContainer-text'},tvaPrice.toFixed(2)+' \u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-totalContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-totalContainer-text'},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cart-totalContainer-text'},totalTTC.toFixed(2)+' \u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CartCta__["a" /* default */],{ctaHandler:this.showPaymentModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CartPromoCodeBtn__["a" /* default */],{showInput:this.showPromoCodeInput,shouldShowPromoCodeInput:showPromoCodeInput,isLoadingPromoCode:promo_loading,validateCode:this.sendPromo,updatePromoCode:this.updatePromoCode,isValidPromoCode:isValidPromoCode,isInvalidPromoCode:isInvalidPromoCode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__card_modal__["a" /* default */],{show:showPaymentModal,closeEvent:this.closePaymentModal,totalTTC:totalTTC,upsell:upsellPaymentData})));}}]);return CartNew;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;var mapStateToProps=function mapStateToProps(state){return{title:state.contract.name,first_price:state.checkout_operations.prices.first_price,second_price:state.checkout_operations.prices.second_price,chosenPack:state.checkout_operations.pack,has_call:state.checkout_operations.has_call,has_letter:state.checkout_operations.has_letter,letter_number:state.checkout_operations.letter.number,pack_priceHT:state.checkout_operations.contract_meta_id===302?state.checkout_operations.prices.first_price:state.checkout_operations.prices.second_price,promo_code:state.checkout_operations.promo_code,promo_loading:state.checkout_operations.promo_loading,promo_percentage:state.checkout_operations.promo_percentage,price_loading:state.loading_details.pricing,client_email:state.account_settings.mail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updatePromo:function updatePromo(val){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_checkout_operations__["W" /* ckUpdatePromoCode */])(val));},checkPromo:function checkPromo(val,contractId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_actions_checkout_operations__["O" /* ckSendPromoCode */])(val,contractId));__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["p" /* lpPattern */].trackInPayment(__WEBPACK_IMPORTED_MODULE_6__tracking_pattern_detector__["f" /* P_CHECK_PROMO */]);}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CartNew));

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_right_chevron_white_svg__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_right_chevron_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_right_chevron_white_svg__);
var CartCTA=function CartCTA(_ref){var ctaHandler=_ref.ctaHandler;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"cart-cta",type:"button",onClick:ctaHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Valider et Continuer"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_1__styles_img_newCheckout_right_chevron_white_svg___default.a,alt:""}));};/* harmony default export */ __webpack_exports__["a"] = (CartCTA);

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDkgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjk5OTk5OSAxTDcgN0wxIDEzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CartPromoCode=function CartPromoCode(_ref){var showInput=_ref.showInput,shouldShowPromoCodeInput=_ref.shouldShowPromoCodeInput,validateCode=_ref.validateCode,isLoadingPromoCode=_ref.isLoadingPromoCode,updatePromoCode=_ref.updatePromoCode,isValidPromoCode=_ref.isValidPromoCode,isInvalidPromoCode=_ref.isInvalidPromoCode;if(isValidPromoCode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cart-promoCode-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"cart-promoCode-response valid"},"Votre Code est appliqu\xE9 !"));}else if(isInvalidPromoCode&&!shouldShowPromoCodeInput){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cart-promoCode-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"cart-promoCode-response invalid"},"Votre code est erron\xE9 ! -",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"cart-promoCode-btn",onClick:showInput,type:"button"},"R\xE9essayer")));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cart-promoCode-container"},shouldShowPromoCodeInput?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cart-promoCode-subContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{action:"",onSubmit:function onSubmit(event){return event.preventDefault();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"cart-promoCode-input",type:"text",placeholder:"Code Promo",disabled:isLoadingPromoCode,onChange:updatePromoCode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"cart-promoCode-input-validate-btn "+(isLoadingPromoCode?"checking":""),type:"button",onClick:validateCode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"lpc-txt"},"Valider"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"loading-spin"})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"cart-promoCode-btn",onClick:showInput,type:"button"},"Code Promo ?"));};/* harmony default export */ __webpack_exports__["a"] = (CartPromoCode);

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkoutUpsell_css__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkoutUpsell_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__checkoutUpsell_css__);
var CheckoutUpsell=function CheckoutUpsell(_ref){var addUpsellPrice=_ref.addUpsellPrice,upsellData=_ref.upsellData;var name=upsellData.name,priceTTC=upsellData.priceTTC,description=upsellData.description,includedOptions=upsellData.includedOptions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkoutUpsell-condition-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkoutUpsell-cbx-head'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'checkoutUpsell-title'},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'check9',className:'checkoutUpsell-priceWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'checkoutUpsell-priceCheckBox',type:'checkbox',onClick:addUpsellPrice}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkoutUpsell-price'},'+'+priceTTC+'\u20AC'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'packContent'},description.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:'description_part_'+(index+1)},item);}),includedOptions.map(function(option,index){var heading=option.heading,text=option.text,list=option.list;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'included_option_'+(index+1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'checkoutUpsell-option'},heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,text),list&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,list.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'list_item_'+(index+1)},item);})));})));};/* harmony default export */ __webpack_exports__["a"] = (CheckoutUpsell);

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _ContactUs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LpContactUs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseLink__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_error__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logic_wording__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Project: LegalPlace assistant
* File: src/components/contact_us.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/var _ContactUs=function(_Component){_inherits(_ContactUs,_Component);_createClass(_ContactUs,null,[{key:'closeModal',value:function closeModal(){__WEBPACK_IMPORTED_MODULE_3__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["u" /* showContactUs */])(false));}}]);function _ContactUs(props){_classCallCheck(this,_ContactUs);var _this=_possibleConstructorReturn(this,(_ContactUs.__proto__||Object.getPrototypeOf(_ContactUs)).call(this,props));_this.state={name:'',mail:'',subject:'',message:'',sent:false};// init context for callbacks
_this.updateName=_this.updateName.bind(_this);_this.updateMail=_this.updateMail.bind(_this);_this.updateSubject=_this.updateSubject.bind(_this);_this.updateMessage=_this.updateMessage.bind(_this);_this.sendContact=_this.sendContact.bind(_this);return _this;}_createClass(_ContactUs,[{key:'componentDidMount',value:function componentDidMount(){if(this.refs.contactus){document.getElementById('contact-form').appendChild(this.refs.contactus);if(this.props.show_contact){document.getElementById('contact-form').classList.add('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='blur(5px)';document.body.style.overflow='hidden';}else{document.getElementById('contact-form').classList.remove('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';}}// console.log("dddd " + this.props.show_contact)
var a=document.getElementById('contact-form');document.getElementById('contact-form').addEventListener('click',function(e){if(e.target===a)_ContactUs.closeModal();});}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(nextProps.show_contact&&!this.props.show_contact){if(this.state.sent){this.state.sent=false;this.state.mail='';this.state.name='';this.state.subject='';this.state.message='';}}}},{key:'componentDidUpdate',value:function componentDidUpdate(){// console.log(this.refs.contactus)
if(this.refs.contactus){// document.getElementById('contact-form').appendChild(this.refs.contactus);
if(this.props.show_contact){// console.log(this.refs.contactus)
document.getElementById('contact-form').classList.add('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='blur(5px)';document.body.style.overflow='hidden';}else{document.getElementById('contact-form').classList.remove('lp-modal');document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';}}// console.log("dddd " + this.props.show_contact)
}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.getElementsByClassName('page-wrap')[0].style.filter='none';document.body.style.overflow='auto';document.getElementById('contact-form').classList.remove('lp-modal');}},{key:'updateName',value:function updateName(val){this.setState({name:val.target.value});}},{key:'updateMail',value:function updateMail(val){this.setState({mail:val.target.value});}},{key:'updateSubject',value:function updateSubject(val){this.setState({subject:val.target.value});}},{key:'updateMessage',value:function updateMessage(val){this.setState({message:val.target.value});}},{key:'sendContact',value:function sendContact(e){e.preventDefault();var information={name:this.state.name,email:this.state.mail,subject:this.state.subject,message:this.state.message};var init={method:'POST',body:JSON.stringify(information)};var that=this;// managing errors
var err0=void 0;var err1=void 0;var err2=void 0;err0=false;err1=false;err2=false;if(this.state.name===''){Object(__WEBPACK_IMPORTED_MODULE_5__errors_error__["b" /* raiseError */])('contact-name',9,Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Veuillez saisir votre nom complet'));err0=true;}else{Object(__WEBPACK_IMPORTED_MODULE_5__errors_error__["c" /* unraiseError */])('contact-name');}if(this.state.subject.length<5){Object(__WEBPACK_IMPORTED_MODULE_5__errors_error__["b" /* raiseError */])('contact-subject',9,Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Votre sujet dois contenir au moins 5 caractères'));err1=true;}else Object(__WEBPACK_IMPORTED_MODULE_5__errors_error__["c" /* unraiseError */])('contact-subject');if(this.state.message.length<10){Object(__WEBPACK_IMPORTED_MODULE_5__errors_error__["b" /* raiseError */])('contact-message',9,Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Votre message dois contenir au moins 10 caractères.'));err2=true;}else Object(__WEBPACK_IMPORTED_MODULE_5__errors_error__["c" /* unraiseError */])('contact-message');if(!err0&&!err1&&!err2){fetch(__WEBPACK_IMPORTED_MODULE_4__baseLink__["a" /* default */]+'/data/contracts/contact_support',init).then(function(response){response.json().then(function(){that.setState({sent:true});}).catch(function(jsonError){Object(__WEBPACK_IMPORTED_MODULE_5__errors_error__["b" /* raiseError */])('global',2,Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Erreur de connexion serveur'));});}).catch(function(error){Object(__WEBPACK_IMPORTED_MODULE_5__errors_error__["b" /* raiseError */])('global',2,Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('On pourait pas connecter au serveur'));});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'contactus',className:'lpm-container'},this.props.show_contact&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-close icn-x',onClick:_ContactUs.closeModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-title'},Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])("Besoin d'aide? Nous sommes là pour vous")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lpm-content'},!this.state.sent&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{acceptCharset:'utf-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 form-group'+(typeof this.props.error_name==='undefined'?'':' error')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'d1'},Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Votre nom')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Nom complet'),className:'form-control',id:'cf-name',onChange:this.updateName,value:this.state.name}),typeof this.props.error_name!=='undefined'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])(this.props.error_name.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'d1'},Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Adresse email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',placeholder:Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Adresse email'),className:'form-control',id:'cf-email',onChange:this.updateMail,value:this.state.mail}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-xs-12'+(typeof this.props.error_subject==='undefined'?'':' error')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'d1'},'Sujet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Sujet'),className:'form-control',id:'cf-subject',onChange:this.updateSubject,value:this.state.subject}),typeof this.props.error_subject!=='undefined'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.error_subject.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-xs-12'+(typeof this.props.error_message==='undefined'?'':' error')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'d1'},Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Votre message')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control',rows:'3',id:'cf-message',onChange:this.updateMessage,value:this.state.message}),typeof this.props.error_message!=='undefined'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'help-block'},this.props.error_message.message))),!this.state.sent&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.sendContact,className:'btn btn-primary pull-right'},Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Envoyer'))))))),this.state.sent&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cf-success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icn-checkmark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_6__logic_wording__["a" /* _lp */])('Votre message a bien été envoyé'))))));}}]);return _ContactUs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{show_contact:state.account_settings.show_contact,error_name:state.errors.components['contact-name'],error_subject:state.errors.components['contact-subject'],error_message:state.errors.components['contact-message']};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{closeContact:function closeContact(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["u" /* showContactUs */])(false));}};};var LpContactUs=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_ContactUs);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SingupModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseLink__ = __webpack_require__(108);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _SingupModal=function(_Component){_inherits(_SingupModal,_Component);_createClass(_SingupModal,null,[{key:"closeModal",value:function closeModal(){__WEBPACK_IMPORTED_MODULE_4__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["w" /* showSingupModal */])(false));}}]);function _SingupModal(props){_classCallCheck(this,_SingupModal);var _this=_possibleConstructorReturn(this,(_SingupModal.__proto__||Object.getPrototypeOf(_SingupModal)).call(this,props));_this.updateMail=function(val){_this.setState({mail:val.target.value});};_this.updatePassword1=function(val){_this.setState({password1:val.target.value});var strength=0;var password=val.target.value;if(password.match(/[A-Z]/))strength+=20;// Making sure it container lowercase letters
if(password.match(/[a-z]/))strength+=20;// Checking for number
if(password.match(/[0-9]/))strength+=20;// Checking for special chars
if(password.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/))strength+=20;// Checking for length
if(password.length>7)strength+=20;var background='';var text='';if(strength<21){background='#b80b0b';text='Très faible';}else if(strength<41){background='#b8480b';text='Faible';}else if(strength<61){background='#f08b08';text='Moyen';}else if(strength<81){background='#c7c90f';text='Fort';}else{background='#32c90f';text='Très fort';}_this.setState({width:strength+'%',background:background,text:text});};_this.updatePassword2=function(val){_this.setState({password2:val.target.value});// Check if both passwords match
var password1=_this.state.password1;var password2=val.target.value;if(password1!==password2){raiseError("password2",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Les deux mots de passe sont différents"));}else{unraiseError("password2");}};_this.updateCgu=function(val){_this.setState({cgu:val.target.checked});};_this.signup=function(e){e.preventDefault();unraiseError("form");var information={email:_this.state.mail,password:_this.state.password1,password_repeat:_this.state.password2};var init={method:"POST",body:JSON.stringify(information)};var that=_this;// managing errors
var err0=false;var err1=false;var err2=false;var err3=false;if(_this.state.mail!==""){// Checking email
var re=/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g;if(!re.test(_this.state.mail)){raiseError("mail",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Veuillez saisir une adresse email correcte"));err2=true;}else{unraiseError("mail");}}else{raiseError("mail",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Veuillez saisir votre adresse mail"));err0=true;}if(_this.state.password1===""){raiseError("password1",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Veuillez saisir votre mot de passe"));err1=true;}else unraiseError("password1");if(_this.state.password1!==_this.state.password2){raiseError("password2",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Les deux mots de passe sont différents"));err2=true;}else unraiseError("password2");if(!_this.state.cgu){raiseError("cgu",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Veuillez accepter les conditions d'utilisation"));err3=true;}else unraiseError("cgu");if(!err0&&!err1&&!err2&&!err3){fetch(__WEBPACK_IMPORTED_MODULE_5__baseLink__["a" /* default */]+"/data/contracts/signup",init).then(function(response){response.json().then(function(j_response){if(j_response.status==="success"){that.setState({singedUp:true});_SingupModal.closeModal();var cnx=document.getElementById('connexion');cnx.innerText=j_response.data.userEmail;cnx.setAttribute('href',__WEBPACK_IMPORTED_MODULE_5__baseLink__["a" /* default */]+"/compte");cnx.setAttribute('target','_blank');}else{raiseError("form",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(j_response.data.errors[0]));}}).catch(function(jsonError){raiseError("global",2,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Erreur de connexion au serveur"));});}).catch(function(error){raiseError("global",2,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Erreur de connexion au serveur"));});}};_this.state={mail:"",password1:"",password2:"",cgu:false,singedUp:false,formErrors:[],background:'#fff',width:'0',text:''};return _this;}_createClass(_SingupModal,[{key:"componentDidMount",value:function componentDidMount(){if(this.refs.singupmodal){if(this.props.show_singup_modal){document.getElementById("singup-modal").appendChild(this.refs.singupmodal);document.body.classList.add("modal-open");}else{document.body.classList.remove("modal-open");}}// const a = document.getElementById("singup-modal");
// document.getElementById("singup-modal").addEventListener("click", e => {
//   if (e.target !== a) _SingupModal.closeModal();
// });
}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(this.refs.singupmodal&&!this.props.show_login_modal){if(this.props.show_singup_modal){document.body.classList.add("modal-open");}else{document.body.classList.remove("modal-open");}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.body.classList.remove("modal-open");}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:"singupmodal"},this.props.show_singup_modal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm user-modal signup-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"lpm__title"},"Inscrivez vous \xE0 LegalPlace"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__close icn-x",onClick:_SingupModal.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-form__body"},this.props.error_form&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"alert error"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help-block"},Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(this.props.error_form.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group "+(typeof this.props.error_mail==="undefined"?"":" error")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"lf-email"},"Adresse email"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"email",className:"form-control",id:"lf-email",onChange:this.updateMail}),typeof this.props.error_mail!=="undefined"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help-block"},Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(this.props.error_mail.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group "+(typeof this.props.error_password1==="undefined"?"":" error")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"lf-pass"},"Mot de passe"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"password",className:"form-control",id:"lf-pass",onChange:this.updatePassword1}),typeof this.props.error_password1!=="undefined"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help-block"},Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(this.props.error_password1.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"password-strength form-group",style:{display:'block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Niveau de s\xE9curit\xE9 de votre mot de passe"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"strength"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bar",style:{width:this.state.width,background:this.state.background},"data-strength":this.state.width})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"strength-txt"},this.state.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group "+(typeof this.props.error_password2==="undefined"?"":" error")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"lf-pass2"},"Confirmez votre mot de passe"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"password",className:"form-control",id:"lf-pass2",onChange:this.updatePassword2}),typeof this.props.error_password2!=="undefined"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help-block"},Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(this.props.error_password2.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-form__actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group lp-chbx "+(typeof this.props.error_cgu==="undefined"?"":" error")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"cgv",className:"lpcbx",onChange:this.updateCgu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"cgv"},"J'ai lu et j'accepte les"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/conditions-generales/",target:"_blank"},"conditions g\xE9n\xE9rales d'utilisation")),typeof this.props.error_cgu!=="undefined"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help-block"},Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(this.props.error_cgu.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:this.signup,className:"btn btn-primary user-cta"}," Continuer"))))))),this.state.singedUp&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cf-success"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"success"},"Vous \xEAtes maintenant connect\xE9")));}}]);return _SingupModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{show_singup_modal:state.account_settings.show_singup_modal,show_login_modal:state.account_settings.show_login_modal,error_mail:state.errors.components["mail"],error_password1:state.errors.components["password1"],error_password2:state.errors.components["password2"],error_cgu:state.errors.components["cgu"],error_form:state.errors.components["form"]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{closeContact:function closeContact(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["w" /* showSingupModal */])(false));}};};var SingupModal=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_SingupModal);

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic_wording__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globals__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseLink__ = __webpack_require__(108);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _LoginModal=function(_Component){_inherits(_LoginModal,_Component);_createClass(_LoginModal,null,[{key:"closeModal",value:function closeModal(){__WEBPACK_IMPORTED_MODULE_4__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["v" /* showLoginModal */])(false));}},{key:"singup",value:function singup(){__WEBPACK_IMPORTED_MODULE_4__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["v" /* showLoginModal */])(false));__WEBPACK_IMPORTED_MODULE_4__globals__["b" /* store */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["w" /* showSingupModal */])(true));}}]);function _LoginModal(props){_classCallCheck(this,_LoginModal);var _this=_possibleConstructorReturn(this,(_LoginModal.__proto__||Object.getPrototypeOf(_LoginModal)).call(this,props));_this.updateMail=function(val){_this.setState({mail:val.target.value});};_this.updatePassword=function(val){_this.setState({password:val.target.value});};_this.updateRemember=function(val){_this.setState({remember:val.target.checked});};_this.login=function(e){e.preventDefault();unraiseError("form");var information={email:_this.state.mail,password:_this.state.password,remember:_this.state.remember};var init={method:"POST",body:JSON.stringify(information)};var that=_this;// managing errors
var err0=false;var err1=false;var err2=false;if(_this.state.mail!==""){// Checking email
var re=/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g;if(!re.test(_this.state.mail)){raiseError("mail",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Veuillez saisir une adresse email correcte"));err2=true;}else{unraiseError("mail");}}else{raiseError("mail",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Veuillez saisir votre adresse mail"));err0=true;}if(_this.state.password===""){raiseError("password",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Veuillez saisir votre mot de passe"));err1=true;}else unraiseError("password");if(!err0&&!err1&&!err2){fetch(__WEBPACK_IMPORTED_MODULE_5__baseLink__["a" /* default */]+"/data/contracts/login",init).then(function(response){response.json().then(function(j_response){if(j_response.status==="success"){that.setState({loggedIn:true});_LoginModal.closeModal();var cnx=document.getElementById('connexion');cnx.innerText=j_response.data.userEmail;cnx.setAttribute('href',__WEBPACK_IMPORTED_MODULE_5__baseLink__["a" /* default */]+"/compte");cnx.setAttribute('target','_blank');}else{raiseError("form",9,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(j_response.data.errors[0]));}}).catch(function(jsonError){raiseError("global",2,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Erreur de connexion au serveur"));});}).catch(function(error){raiseError("global",2,Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])("Erreur de connexion au serveur"));});}};_this.state={mail:"",password:"",remember:false,loggedIn:false,formErrors:[]};return _this;}_createClass(_LoginModal,[{key:"componentDidMount",value:function componentDidMount(){if(this.refs.loginmodal){if(this.props.show_login_modal){document.getElementById("login-modal").appendChild(this.refs.loginmodal);document.body.classList.add("modal-open");}else{document.body.classList.remove("modal-open");}}// const a = document.getElementById("login-modal");
// document.getElementById("login-modal").addEventListener("click", e => {
//   if (e.target !== a) _LoginModal.closeModal();
// });
}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(this.refs.loginmodal&&!this.props.show_singup_modal){if(this.props.show_login_modal){document.body.classList.add("modal-open");}else{document.body.classList.remove("modal-open");}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.body.classList.remove("modal-open");}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:"loginmodal"},this.props.show_login_modal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm user-modal signin-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"lpm__title"},"Connexion \xE0 votre compte"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__close icn-x",onClick:_LoginModal.closeModal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-form"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-form__body"},this.props.error_form&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"alert error"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help-block"},Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(this.props.error_form.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group "+(typeof this.props.error_mail==="undefined"?"":" error")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"lf-email"},"Adresse email"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"email",className:"form-control",id:"lf-email",onChange:this.updateMail}),typeof this.props.error_mail!=="undefined"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help-block"},Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(this.props.error_mail.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group "+(typeof this.props.error_password==="undefined"?"":" error")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"lf-pass"},"Mot de passe"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"password",className:"form-control",id:"lf-pass",onChange:this.updatePassword}),typeof this.props.error_password!=="undefined"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"help-block"},Object(__WEBPACK_IMPORTED_MODULE_1__logic_wording__["a" /* _lp */])(this.props.error_password.message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-form__actions"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"form-group lp-chbx"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"remember-me",className:"lpcbx",onChange:this.updateRemember}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"remember-me"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"chbx-txt"},"Se souvenir de moi"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:this.login,className:"btn btn-primary user-cta"},"Continuer"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"lpm__footer user-form__footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{id:"singup",onClick:_LoginModal.singup,href:"#"},"Inscription"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/compte/recuperer-mdp",target:"_blank"},"Mot de passe oubli\xE9 ?")))),this.state.loggedIn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cf-success"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"success"},"Vous \xEAtes maintenant connect\xE9")));}}]);return _LoginModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{show_login_modal:state.account_settings.show_login_modal,show_singup_modal:state.account_settings.show_singup_modal,error_mail:state.errors.components["mail"],error_password:state.errors.components["password"],error_form:state.errors.components["form"]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{closeContact:function closeContact(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_actions_account_settings__["v" /* showLoginModal */])(false));}};};var LoginModal=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_LoginModal);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_onboardingData__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_img_onboarding_chevron_forward_svg__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_img_onboarding_chevron_forward_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_img_onboarding_chevron_forward_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_img_onboarding_chevron_back_svg__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_img_onboarding_chevron_back_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_img_onboarding_chevron_back_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OnboardingModal=function(_Component){_inherits(OnboardingModal,_Component);function OnboardingModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OnboardingModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OnboardingModal.__proto__||Object.getPrototypeOf(OnboardingModal)).call.apply(_ref,[this].concat(args))),_this),_this.contractOnboardingData=__WEBPACK_IMPORTED_MODULE_2__constants_onboardingData__["a" /* onboardingData */][_this.props.contractMetaId],_this.localStepNumber=JSON.parse(localStorage.getItem("onboardingCoursierStep"))||null,_this.state={stepNumber:_this.localStepNumber||1},_this.goToNextStep=function(){var stepNumber=_this.state.stepNumber;_this.setState({stepNumber:stepNumber+1},function(){return localStorage.setItem("onboardingCoursierStep",_this.state.stepNumber);});},_this.goToPreviousStep=function(){var stepNumber=_this.state.stepNumber;_this.setState({stepNumber:stepNumber-1},function(){return localStorage.setItem("onboardingCoursierStep",_this.state.stepNumber);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OnboardingModal,[{key:'componentDidMount',value:function componentDidMount(){var stepNumber=this.state.stepNumber;var title=this.contractOnboardingData['step_'+stepNumber].title;__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].trackMix("coursierOnboardingNav",{onboardingScreen:title});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var stepNumber=this.state.stepNumber;var title=this.contractOnboardingData['step_'+stepNumber].title;if(prevState.stepNumber!==stepNumber){__WEBPACK_IMPORTED_MODULE_1__tracking_lpevents__["a" /* default */].trackMix("coursierOnboardingNav",{onboardingScreen:title});}}},{key:'render',value:function render(){var stepNumber=this.state.stepNumber;var _contractOnboardingDa=this.contractOnboardingData['step_'+stepNumber],htmlTitle=_contractOnboardingDa.htmlTitle,content=_contractOnboardingDa.content,img=_contractOnboardingDa.img;var totalSteps=this.contractOnboardingData.totalSteps;var closeOnboardingModal=this.props.closeOnboardingModal;var isFirstStep=stepNumber===1;var isLastStep=stepNumber===totalSteps;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'onboardingModal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'onboardingModal-content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'onboardingModal-img',src:img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'onboardingModal-content-title',dangerouslySetInnerHTML:{__html:htmlTitle}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'onboardingModal-content-text'},content),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'onboardingModal-pagination-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'onboardingModal-pagination-item '+(stepNumber===1?"isCurrentPage":"")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'onboardingModal-pagination-item '+(stepNumber===2?"isCurrentPage":"")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'onboardingModal-pagination-item '+(stepNumber===3?"isCurrentPage":"")})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'onboardingModal-btn-container'},isLastStep?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'onboardingModal-btn onboardingModal-btn_primary',onClick:closeOnboardingModal},'C\'est parti !'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'onboardingModal-btn onboardingModal-btn_primary',onClick:this.goToNextStep},'Suivant',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'onboardingModal-btn-icon',src:__WEBPACK_IMPORTED_MODULE_3__styles_img_onboarding_chevron_forward_svg___default.a,alt:''})),!isFirstStep&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'onboardingModal-btn',onClick:this.goToPreviousStep},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'onboardingModal-btn-icon',src:__WEBPACK_IMPORTED_MODULE_4__styles_img_onboarding_chevron_back_svg___default.a,alt:''}),'Pr\xE9c\xE9dent'))));}}]);return OnboardingModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (OnboardingModal);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onboardingData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contractsData__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_onboarding_onboarding_coursier_step1_svg__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_onboarding_onboarding_coursier_step1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_onboarding_onboarding_coursier_step1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_onboarding_onboarding_coursier_step2_svg__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_onboarding_onboarding_coursier_step2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_img_onboarding_onboarding_coursier_step2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_img_onboarding_onboarding_coursier_step3_svg__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_img_onboarding_onboarding_coursier_step3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_img_onboarding_onboarding_coursier_step3_svg__);
var onboardingData={// Devenir Coursier
302:{name:__WEBPACK_IMPORTED_MODULE_0__contractsData__["a" /* DEVENIR_COURSIER */],totalSteps:3,step_1:{title:"Créer une micro-entreprise",htmlTitle:"Créer une <span class='onboardingModal-content-title_highlightedText'><span>micro-entreprise</span><div/></span>",content:"En tant que coursier à vélo, vous n'êtes pas salarié. Vous devez donc créer une micro-entreprise pour pouvoir facturer et être payé.",img:__WEBPACK_IMPORTED_MODULE_1__styles_img_onboarding_onboarding_coursier_step1_svg___default.a},step_2:{title:"Obtenir un extrait Kbis",htmlTitle:"Obtenir un extrait <span class='onboardingModal-content-title_highlightedText'><span>Kbis</span><div/></span>",content:"Un extrait KBIS est en quelque sorte la carte d’identité d’une entreprise, il permet de confirmer que vous avez bien votre propre entreprise. Ce document est obligatoire pour devenir coursier.",img:__WEBPACK_IMPORTED_MODULE_2__styles_img_onboarding_onboarding_coursier_step2_svg___default.a},step_3:{title:"Démarrer votre activité",htmlTitle:"Démarrer votre <span class='onboardingModal-content-title_highlightedText'><span>activité</span><div/></span>",content:"Une fois que avez obtenu votre extrait Kbis, vous pouvez vous inscrire sur la plateforme de votre choix (ex: Uber Eats, Deliveroo, etc).",img:__WEBPACK_IMPORTED_MODULE_3__styles_img_onboarding_onboarding_coursier_step3_svg___default.a}}};

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEVENIR_COURSIER; });
var DEVENIR_COURSIER='devenir-coursier';

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/onboarding_coursier_step2.5cfb352b.svg";

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/onboarding_coursier_step3.e251846d.svg";

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDggMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjk5OTk5OSAxTDcgN0wxIDEzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDkgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjUgMTNMMS41IDdMNy41IDEiIHN0cm9rZT0iIzZCNzU3RiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setCookieIfAlias; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__(97);
var cookies=new __WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */]();var setCookieIfAlias=function setCookieIfAlias(){var originPathParams=window.location.href.split('/');var referrerPathParams=window.document.referrer.split('/');if(originPathParams.indexOf('contrats')>1&&referrerPathParams.indexOf('contrats')>1){var originPermalink=originPathParams[originPathParams.indexOf('contrats')+1];var referrerPermalink=referrerPathParams[referrerPathParams.indexOf('contrats')+1];if(originPermalink!==referrerPermalink){cookies.set('origin-'+originPermalink,referrerPermalink,{path:'/',domain:".legalplace.eu"});}else{// In case the previous page is a landing page and is not the alias landing
if(originPathParams.length===6&&referrerPathParams.length===6&&originPathParams[5]==='creer'&&referrerPathParams[5]===''){if(cookies.get('origin-'+originPermalink)){cookies.remove('origin-'+originPermalink,{path:'/',domain:".legalplace.eu"});}}}}};

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generation_loader_css__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generation_loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__generation_loader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_bar__ = __webpack_require__(1217);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GenerationLoader=function(_Component){_inherits(GenerationLoader,_Component);function GenerationLoader(props){_classCallCheck(this,GenerationLoader);var _this=_possibleConstructorReturn(this,(GenerationLoader.__proto__||Object.getPrototypeOf(GenerationLoader)).call(this,props));_this.state={};return _this;}_createClass(GenerationLoader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Vos documents sont en cours de g\xE9n\xE9ration...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__progress_bar__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'generationLoader-image',src:'/wizard/img/mes-locaux.svg',alt:'description'}));}}]);return GenerationLoader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GenerationLoader);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generation_loader_css__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generation_loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__generation_loader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__manager_apiManager__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Progressbar=function(_React$Component){_inherits(Progressbar,_React$Component);function Progressbar(props){_classCallCheck(this,Progressbar);var _this=_possibleConstructorReturn(this,(Progressbar.__proto__||Object.getPrototypeOf(Progressbar)).call(this,props));var _this$props$match$par=_this.props.match.params,id=_this$props$match$par.id,name=_this$props$match$par.name;_this.uniqid=id;_this.state={progress:0,speed:1,step:0,color:"#3392FF"};_this.downloadUrl="https://www.legalplace.eu"+'/contrats/'+name+'/'+_this.uniqid+'/telechargement';_this.time=150;//  = 15s
return _this;}_createClass(Progressbar,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.interval=setInterval(function(){return _this2.frame();},this.time);var pullResults=setInterval(function(){Object(__WEBPACK_IMPORTED_MODULE_2__manager_apiManager__["a" /* checkGeneratedFiles */])(_this2.uniqid).then(function(res){if(res.status===204){window.location.href=_this2.downloadUrl;}});},2000);}},{key:'frame',value:function frame(){var _this3=this;if(this.state.progress<100){this.setState(function(prevState){return{progress:prevState.progress+_this3.state.speed<100?prevState.progress+_this3.state.speed:100};});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.interval);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this4=this;// console.log(prevState)
if(prevState.progress+this.state.speed===100){// Call to backend api
Object(__WEBPACK_IMPORTED_MODULE_2__manager_apiManager__["a" /* checkGeneratedFiles */])(this.uniqid).then(function(res){if(res.status===204){window.location.href=_this4.downloadUrl;}else{_this4.setState({progress:0});}}).catch(function(){_this4.setState({progress:0});});this.setState(function(prevState){return{step:prevState.step+1};},function(){if(_this4.state.step===5)window.location.href=_this4.downloadUrl;});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'myBar',style:{width:this.state.progress+"%",backgroundColor:this.state.color}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'progressText'},this.state.progress,'%')));}}]);return Progressbar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* withRouter */])(Progressbar));

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wizardxAbOptions; });
// Ab test wizardx, handled by lambda edge
var wizardxAbOptions={testName:"wizardx",testVarOld:"legacy",testVarNew:"legacy-redirect",testShareOld:100,testShareNew:0};

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Data__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__upsell_Ec_Header__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__upsell_Ec_Content__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__upsell_Ec_Footer__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpsellEcComponent=function(_Component){_inherits(UpsellEcComponent,_Component);function UpsellEcComponent(){_classCallCheck(this,UpsellEcComponent);return _possibleConstructorReturn(this,(UpsellEcComponent.__proto__||Object.getPrototypeOf(UpsellEcComponent)).apply(this,arguments));}_createClass(UpsellEcComponent,[{key:"componentDidMount",value:function componentDidMount(){window.scrollTo(0,0);}},{key:"componentWillMount",value:function componentWillMount(){if(typeof this.props.togglePack==='undefined')this.props.history.push("/contrats/"+this.props.match.params.name+"/"+this.props.match.params.id+"/paiement");document.getElementById("app-container").classList.add("fullWidth");document.getElementById("main-nav").classList.add("delete-margin");}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.getElementById("app-container").classList.remove('fullWidth');document.getElementById("main-nav").classList.remove('delete-margin');}},{key:"render",value:function render(){var header=__WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Data__["a" /* upsellEcData */].header,content=__WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Data__["a" /* upsellEcData */].content,footer=__WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Data__["a" /* upsellEcData */].footer,card=__WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Data__["a" /* upsellEcData */].card;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main",{className:"upsellEcWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__upsell_Ec_Header__["a" /* default */],{header:header,card:card}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__upsell_Ec_Content__["a" /* default */],{content:content}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__upsell_Ec_Footer__["a" /* default */],{footer:footer,card:card}));}}]);return UpsellEcComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{togglePack:state.checkout_operations.togglepack};};var UpsellEc=Object(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,null)(UpsellEcComponent));/* harmony default export */ __webpack_exports__["a"] = (UpsellEc);

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return upsellEcData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_img_upsellEc_infography_img_png__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_img_upsellEc_infography_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_img_upsellEc_infography_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_horse_icon_svg__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_horse_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_horse_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_upsellEc_software_icon_svg__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_img_upsellEc_software_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_img_upsellEc_software_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_img_upsellEc_user_icon_svg__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_img_upsellEc_user_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_img_upsellEc_user_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_img_upsellEc_ec_photo_png__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_img_upsellEc_ec_photo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_img_upsellEc_ec_photo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_img_upsellEc_ruler_icon_svg__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_img_upsellEc_ruler_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_img_upsellEc_ruler_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_img_upsellEc_phone_icon_svg__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_img_upsellEc_phone_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_img_upsellEc_phone_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_img_upsellEc_calculator_icon_svg__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_img_upsellEc_calculator_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__styles_img_upsellEc_calculator_icon_svg__);
var upsellEcData={card:{monthSubscription:"100€ par mois / Mensuel",yearSubscription:"85€ par mois / Annuel",textBtn:"Ça m'intéresse",textLink:"Je m'occupe seul de la comptabilité"},header:{headerTitle:"Lancez-vous simplement, on s'occupe de votre compta",headerImage:__WEBPACK_IMPORTED_MODULE_0__styles_img_upsellEc_infography_img_png___default.a,headerText:"Votre expert comptable disponible, réactif avec un logiciel de suivi simple et efficace pour être enfin serein sur sa compta"},content:{includedOptions:[{icon:__WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_horse_icon_svg___default.a,optionTitle:"Expert comptable dédié",optionText:"Votre expert comptable dédié vous accompagne et vous conseille en permanence Les services inclus le bilan comptable, la déclaration de TVA, le suivi de trésorerie, etc"},{icon:__WEBPACK_IMPORTED_MODULE_2__styles_img_upsellEc_software_icon_svg___default.a,optionTitle:"Logiciel de comptabilité",optionText:"Nos solutions logiciels de dernière génération automatisent jusqu’à 100% de votre comptabilité. Fini les déplacements et la « paperasse ». Vous gagnez du temps !"},{icon:__WEBPACK_IMPORTED_MODULE_3__styles_img_upsellEc_user_icon_svg___default.a,optionTitle:"Hyper disponibilité",optionText:"Votre expert comptable est disponible et réactif pour vous aider et répondre à toutes vos questions d’ordre fiscales, sociales, gestion et juridique."}],expertComptable:{title:"Vous êtes suivi par un véritable expert comptable",picture:__WEBPACK_IMPORTED_MODULE_4__styles_img_upsellEc_ec_photo_png___default.a,name:"Jean Luc Javelaud",description:["Expert-comptable et commissaire aux comptes, inscrit à l’Ordre des experts comptables de Marseille depuis 1997, entouré d’une équipe de 20 collaborateurs expérimentés, ayant pour objectif d’accompagner nos clients dans la réussite de leur entreprise, de sa création à sa cession.","L’équipe de Jean Luc Javelaud possède plus de 20 ans d’expertise en fiscalité, en paie, et en gestion de patrimoine pour prendre les bonnes options fiscales et sociales."]},optionsContent:[{icon:__WEBPACK_IMPORTED_MODULE_5__styles_img_upsellEc_ruler_icon_svg___default.a,optionTitle:"Solution sur mesure",optionText:"Socic gère tous types d’entreprises : TPE, PME, Professions libérales, Holdings, … quel que soit le régime fiscal et social (SARL, SAS, EURL, SASU, …)."},{icon:__WEBPACK_IMPORTED_MODULE_6__styles_img_upsellEc_phone_icon_svg___default.a,optionTitle:"Assistance et conseil",optionText:"Vous bénéficiez des conseils de nos experts spécialisés en fiscalité, en paies, et en gestion de patrimoine pour prendre les bonnes options fiscales et sociales."},{icon:__WEBPACK_IMPORTED_MODULE_7__styles_img_upsellEc_calculator_icon_svg___default.a,optionTitle:"Comptabilité",optionText:"Vous bénéficiez des tous les services comptable : Déclaration de TVA, Suivi de trésorerie, Bilan comptable, financier et déclarations fiscales incluses, Liasse fiscale, Impôt société, TVA, Prélèvements sur dividendes, TVS, DSI etc."}]},footer:{footerTitle:"Fonctionnlaités du logiciel de comptabilité",listItems:["Comptabilité automatisée","Tableaux de bord","Application mobile","Gestion de la TVA","Gestion des justificatifs","Gestion commerciale"]}};

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/infography-img.151e40d2.png";

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjUgNDYuNDU4QzI2LjYzMiA0Ni40NTggMjIuNSA0My44MjYgMjIuNSAzOC45NThWMzEuNDU4SDQwLjVWMzguOTU4QzQwLjUgNDAuNTM0IDM5LjI4NiA0Ni40NTggMzEuNSA0Ni40NThaIiBzdHJva2U9IiM0NUNBQ0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNi41IDI1LjQ1OEwxMy41IDMxLjQ1OCIgc3Ryb2tlPSIjNDVDQUNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjIuNSAyNS40NThINC41QzMuNzA0MzUgMjUuNDU4IDIuOTQxMjkgMjUuMTQxOSAyLjM3ODY4IDI0LjU3OTNDMS44MTYwNyAyNC4wMTY3IDEuNSAyMy4yNTM2IDEuNSAyMi40NThWNC40NThDMS41IDMuNjYyMzUgMS44MTYwNyAyLjg5OTI5IDIuMzc4NjggMi4zMzY2OEMyLjk0MTI5IDEuNzc0MDcgMy43MDQzNSAxLjQ1OCA0LjUgMS40NThIMzZDMzYuNzk1NiAxLjQ1OCAzNy41NTg3IDEuNzc0MDcgMzguMTIxMyAyLjMzNjY4QzM4LjY4MzkgMi44OTkyOSAzOSAzLjY2MjM1IDM5IDQuNDU4VjEzLjQ1OCIgc3Ryb2tlPSIjNDVDQUNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuNSAzMS40NThIMTYuNSIgc3Ryb2tlPSIjNDVDQUNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy41IDE5LjQ1OEgyMi41IiBzdHJva2U9IiM0NUNBQ0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC41IDE5LjQ1OFYxNC45NTgiIHN0cm9rZT0iIzQ1Q0FDRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2LjUgMTkuNDU4VjExLjk1OCIgc3Ryb2tlPSIjNDVDQUNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjIuNSAxOS40NThWNy40NTgwMSIgc3Ryb2tlPSIjNDVDQUNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjguNTU0IDIwLjM2OEMyNi4zNTQgMjIuNTY4IDMwLjczMiAyMy4zMSAyOC41ODQgMjUuNDU4IiBzdHJva2U9IiM0NUNBQ0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zNC44ODIgMTYuNTM4QzMxLjA1OCAyMC4zNiAzOC42ODIgMjEuNjYgMzQuOTM0IDI1LjQwMiIgc3Ryb2tlPSIjNDVDQUNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNDAuNSAzMi45NThINDJDNDMuMTkzNSAzMi45NTggNDQuMzM4MSAzMy40MzIxIDQ1LjE4MiAzNC4yNzZDNDYuMDI1OSAzNS4xMTk5IDQ2LjUgMzYuMjY0NSA0Ni41IDM3LjQ1OEM0Ni41IDM4LjY1MTUgNDYuMDI1OSAzOS43OTYxIDQ1LjE4MiA0MC42NEM0NC4zMzgxIDQxLjQ4MzkgNDMuMTkzNSA0MS45NTggNDIgNDEuOTU4SDM5LjczNCIgc3Ryb2tlPSIjNDVDQUNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI4LjUgMzEuNVYzOUwzNy41IDMxLjVINDMuNUM0NC4yOTU2IDMxLjUgNDUuMDU4NyAzMS4xODM5IDQ1LjYyMTMgMzAuNjIxM0M0Ni4xODM5IDMwLjA1ODcgNDYuNSAyOS4yOTU2IDQ2LjUgMjguNVY0LjVDNDYuNSAzLjcwNDM1IDQ2LjE4MzkgMi45NDEyOSA0NS42MjEzIDIuMzc4NjhDNDUuMDU4NyAxLjgxNjA3IDQ0LjI5NTYgMS41IDQzLjUgMS41SDE5LjVDMTguNzA0NCAxLjUgMTcuOTQxMyAxLjgxNjA3IDE3LjM3ODcgMi4zNzg2OEMxNi44MTYxIDIuOTQxMjkgMTYuNSAzLjcwNDM1IDE2LjUgNC41IiBzdHJva2U9IiM0NUNBQ0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xLjUgMjRDMS41IDI2Ljc4NDggMi42MDYyNSAyOS40NTU1IDQuNTc1MzggMzEuNDI0NkM2LjU0NDUxIDMzLjM5MzggOS4yMTUyMyAzNC41IDEyIDM0LjVDMTQuNzg0OCAzNC41IDE3LjQ1NTUgMzMuMzkzOCAxOS40MjQ2IDMxLjQyNDZDMjEuMzkzOCAyOS40NTU1IDIyLjUgMjYuNzg0OCAyMi41IDI0QzIyLjUgMjEuMjE1MiAyMS4zOTM4IDE4LjU0NDUgMTkuNDI0NiAxNi41NzU0QzE3LjQ1NTUgMTQuNjA2MiAxNC43ODQ4IDEzLjUgMTIgMTMuNUM5LjIxNTIzIDEzLjUgNi41NDQ1MSAxNC42MDYyIDQuNTc1MzggMTYuNTc1NEMyLjYwNjI1IDE4LjU0NDUgMS41IDIxLjIxNTIgMS41IDI0VjI0WiIgc3Ryb2tlPSIjNDVDQUNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjcuMzUgNDYuNUMyNC4zNjk1IDQyLjY3MDggMjAuMDY0OCA0MC4wOTQ2IDE1LjI4MTYgMzkuMjc3NEMxMC40OTg1IDM4LjQ2MDMgNS41ODI2OCAzOS40NjE0IDEuNSA0Mi4wODQiIHN0cm9rZT0iIzQ1Q0FDRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ec-photo.52ad82e2.png";

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDciIHZpZXdCb3g9IjAgMCA0NyA0NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMjI0NTggMzcuMjkyMUwzMy4wNDQ0IDUuNDcyMzFMNDEuNTI5NyAxMy45NTc2TDkuNzA5ODYgNDUuNzc3NEwxLjIyNDU4IDM3LjI5MjFaIiBzdHJva2U9IiMzMzkyRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMS44IDYuOTg3OTRMMTYuOTcyIDEuNTU3OTRDMTYuNzAzNSAxLjQ1OTQ1IDE2LjQxMjQgMS40Mzk4OCAxNi4xMzMyIDEuNTAxNTVDMTUuODUzOSAxLjU2MzIxIDE1LjU5ODEgMS43MDM1NCAxNS4zOTYgMS45MDU5NEwxMi44OSA0LjQwOTk0QzEyLjYwOTUgNC42OTE3OSAxMi40NTIgNS4wNzMyNyAxMi40NTIgNS40NzA5NEMxMi40NTIgNS44Njg2MSAxMi42MDk1IDYuMjUwMDkgMTIuODkgNi41MzE5NEwyMi40MzYgMTYuMDc3OSIgc3Ryb2tlPSIjMzM5MkZGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNDAuMDE2IDE1LjJMNDUuNDQyIDMwLjAyMzlDNDUuNTQwNSAzMC4yOTI1IDQ1LjU2MDEgMzAuNTgzNSA0NS40OTg0IDMwLjg2MjhDNDUuNDM2NyAzMS4xNDIxIDQ1LjI5NjQgMzEuMzk3OSA0NS4wOTQgMzEuNTk5OUw0Mi42IDM0LjEwOTlDNDIuMzE4MiAzNC4zOTA1IDQxLjkzNjcgMzQuNTQ4IDQxLjUzOSAzNC41NDhDNDEuMTQxMyAzNC41NDggNDAuNzU5OSAzNC4zOTA1IDQwLjQ3OCAzNC4xMDk5TDMwLjkzMiAyNC41NjM5IiBzdHJva2U9IiMzMzkyRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOS43MTYgMzUuNzY3OUwxNi4yMjQgMzIuMjc1OSIgc3Ryb2tlPSIjMzM5MkZGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjcuMjE2IDI4LjI2NzlMMjMuNzI0IDI0Ljc3NTkiIHN0cm9rZT0iIzMzOTJGRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM0LjcxNiAyMC43Njc5TDMxLjIyNCAxNy4yNzU5IiBzdHJva2U9IiMzMzkyRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Card__ = __webpack_require__(474);
var UpsellEcHeader=function UpsellEcHeader(props){var header=props.header,card=props.card,history=props.history;var goBack=function goBack(){history.push('paiement');};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'upsellEc-headingSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'upsellEc-headingSection-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'goBackLink-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'goBackLink',style:{cursor:"pointer"},onClick:goBack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icn-arrow-left'}),'Retour')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'upsellEc-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'upsellEc-headerTitle'},header.headerTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'',className:'upsellEc-headerImage',src:header.headerImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'upsellEc-headerText'},header.headerText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Card__["a" /* default */],{card:card})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* withRouter */])(UpsellEcHeader));

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var UpsellEcContent=function UpsellEcContent(_ref){var content=_ref.content;var includedOptions=content.includedOptions,card=content.card,expertComptable=content.expertComptable,optionsContent=content.optionsContent;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"upsellEc-contentSection"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"upsellEc-content-rapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"upsellEc-content-options"},includedOptions&&includedOptions.length&&includedOptions.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i,className:"upsellEc-optionContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"",src:option.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"upsellEc-optionTitle"},option.optionTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"upsellEc-optionText"},option.optionText));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"upsellEc-content-profile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"upsellEc-content-profileTitle"},expertComptable.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"upsellEc-content-profilePhoto",alt:"",src:expertComptable.picture}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"upsellEc-content-profileName"},expertComptable.name),expertComptable.description&&expertComptable.description&&expertComptable.description.map(function(text,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{key:i,className:"upsellEc-content-profileText"},text);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"upsellEc-content-options"},optionsContent&&optionsContent.length&&optionsContent.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i,className:"upsellEc-optionContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"",src:option.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"upsellEc-optionTitle"},option.optionTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"upsellEc-optionText profileOptionText"},option.optionText));}))));};/* harmony default export */ __webpack_exports__["a"] = (UpsellEcContent);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_checked_icon_svg__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_checked_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_checked_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Card__ = __webpack_require__(474);
var UpsellEcFooter=function UpsellEcFooter(_ref){var footer=_ref.footer,card=_ref.card;var list=footer.listItems;var semiLength=list.length/2;var leftList=list.slice(0,semiLength);var rightList=list.slice(semiLength);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'upsellEc-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'upsellEc-footer-title'},footer.footerTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'upsellEc-features'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'upsellEc-features-list'},leftList&&leftList.length&&leftList.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'upsellEc-features-listItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'upsellEc-features-checkedIcon',alt:'',src:__WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_checked_icon_svg___default.a}),item);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'upsellEc-features-list'},rightList&&rightList.length&&rightList.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'upsellEc-features-listItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'upsellEc-features-checkedIcon',alt:'',src:__WEBPACK_IMPORTED_MODULE_1__styles_img_upsellEc_checked_icon_svg___default.a}),item);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__upsell_Ec_Card__["a" /* default */],{card:card}));};/* harmony default export */ __webpack_exports__["a"] = (UpsellEcFooter);

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDZMOSAxN0w0IDEyIiBzdHJva2U9IiMxNENGOTYiIHN0cm9rZS13aWR0aD0iNCIvPgo8L3N2Zz4K"

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export abTestArtisanPricingName */
/* unused harmony export abTestArtisanPricingOldVar */
/* unused harmony export abTestArtisanPricingNewdVar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAbTestArtisanPricing; });
/* unused harmony export getAbtestArtisanPricing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_abTest__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_universal_cookie__ = __webpack_require__(97);
var cookies=new __WEBPACK_IMPORTED_MODULE_1_universal_cookie__["a" /* default */]();var abTestArtisanPricingName='lp_ab_artisanPricingPageFees';var abTestArtisanPricingOldVar='withoutFees';var abTestArtisanPricingNewdVar='withFees';var setCookies=function setCookies(){if(!cookies.get(abTestArtisanPricingName)){cookies.set(abTestArtisanPricingName,Math.random()>0.5?abTestArtisanPricingOldVar:abTestArtisanPricingNewdVar,{path:'/',domain:".legalplace.eu"});}};var setAbTestArtisanPricing=function setAbTestArtisanPricing(){var nameAbTest=arguments.length>0&&arguments[0]!==undefined?arguments[0]:abTestArtisanPricingName;setCookies();if(typeof window[nameAbTest]==='undefined'){var abTestArtisanPricing=new __WEBPACK_IMPORTED_MODULE_0__tracking_abTest__["a" /* default */]();if(typeof abTestArtisanPricing!=='undefined'){// Enregistrement du test
abTestArtisanPricing.registerFromCookie(nameAbTest,abTestArtisanPricingNewdVar);}}};var getAbtestArtisanPricing=function getAbtestArtisanPricing(){var nameAbTest=arguments.length>0&&arguments[0]!==undefined?arguments[0]:abTestArtisanPricingName;return window[nameAbTest];};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.2623973c.js